import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  LocalDate: { input: string; output: string; }
  Time: { input: string; output: string; }
};

export type Absence = Commentable & WithExtraFields & {
  readonly __typename?: 'Absence';
  readonly ContentDocumentLinks__r: Maybe<ReadonlyArray<ContentDocumentLink>>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly absenceDays: ReadonlyArray<AbsenceDay>;
  /** @deprecated employeeAbsenceCategory.currentYearSummary instead */
  readonly allowanceWithdrawalDays: Maybe<ReadonlyArray<AllowanceWithdrawalDay>>;
  readonly approvalRequests: Maybe<ReadonlyArray<ApprovalRequest>>;
  readonly category: AbsenceCategory;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Colleague;
  readonly employeeAbsenceCategory: Maybe<EmployeeAbsenceCategory>;
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Approval_Status__c: AbsenceApprovalStatus;
  readonly flair__Category_Icon__c: Scalars['String']['output'];
  readonly flair__Category_Id__c: Scalars['String']['output'];
  readonly flair__Category_Name__c: Scalars['String']['output'];
  readonly flair__Category_Restrict_Absence_Deletion__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Category_Time_Tracking_Restricted__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Category_Unlimited__c: Scalars['Boolean']['output'];
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Days_Times__c: Maybe<Scalars['String']['output']>;
  readonly flair__EmployeeId__c: Scalars['String']['output'];
  readonly flair__Employee_Absence_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date_Half_Day__c: Scalars['Boolean']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__End_Time__c: Scalars['Time']['output'];
  readonly flair__LocationId__c: Scalars['String']['output'];
  readonly flair__Loom_Video__c: Maybe<Scalars['String']['output']>;
  readonly flair__Paid__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Requires_Approval__c: Scalars['Boolean']['output'];
  readonly flair__Start_Date_Half_Day__c: Scalars['Boolean']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Start_Time__c: Scalars['Time']['output'];
  readonly flair__Type__c: AbsenceType;
  readonly flair__Visibility__c: Maybe<Scalars['String']['output']>;
  readonly flair__Withdrawal_Amount__c: Scalars['Float']['output'];
  readonly flair__Working_Amount__c: Scalars['Float']['output'];
  readonly loomVideo: Maybe<LoomVideo>;
  readonly overlappingAbsences: ReadonlyArray<Absence>;
  readonly recordType: RecordType;
};

export type AbsenceAllowance = {
  readonly __typename?: 'AbsenceAllowance';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employeeAbsenceCategory: EmployeeAbsenceCategory;
  readonly flair__Accrual_Policy_Period_Start_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Available_Amount__c: Scalars['Float']['output'];
  readonly flair__Carried_Over_Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Employee_Absence_Category__c: Scalars['String']['output'];
  readonly flair__Expiration_Date__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Expired_Amount__c: Scalars['Float']['output'];
  readonly flair__Period_End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Period_Start_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Used_Amount__c: Scalars['Float']['output'];
  readonly pastYearAbsenceAllowance: Maybe<PastYearAllowanceSummary>;
};


export type AbsenceAllowancePastYearAbsenceAllowanceArgs = {
  startOfYearDate: Scalars['LocalDate']['input'];
};

export type AbsenceAllowanceFilter = {
  readonly startOfYearDate: InputMaybe<Scalars['LocalDate']['input']>;
};

export type AbsenceAllowancesSummary = {
  readonly __typename?: 'AbsenceAllowancesSummary';
  readonly availableAmount: Scalars['Float']['output'];
  readonly gainedThisYear: Scalars['Float']['output'];
  readonly usedAmount: Scalars['Float']['output'];
};

export type AbsenceApprovalRequestNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo';
  readonly approvalRequest: Maybe<ApprovalRequest>;
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export type AbsenceApprovalRequestToMe = {
  readonly __typename?: 'AbsenceApprovalRequestToMe';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly absence: Absence;
  readonly approver: Colleague;
  readonly flair__Absence__c: Scalars['String']['output'];
  readonly flair__Approval_Status__c: Scalars['String']['output'];
  readonly flair__Approver_Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Approver__c: Scalars['String']['output'];
  readonly flair__Employee_Id__c: Scalars['String']['output'];
  /** @deprecated use absence */
  readonly requestedAbsence: RequestedAbsence;
};

export type AbsenceApprovalRequestToMePagination = {
  readonly __typename?: 'AbsenceApprovalRequestToMePagination';
  readonly items: ReadonlyArray<AbsenceApprovalRequestToMe>;
  readonly paginationInfo: PaginationInfo;
};

export type AbsenceApprovalRequestToMePayload = {
  readonly __typename?: 'AbsenceApprovalRequestToMePayload';
  readonly query: Query;
  readonly record: Maybe<ApprovalRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export enum AbsenceApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export type AbsenceApproveRejectError = {
  readonly __typename?: 'AbsenceApproveRejectError';
  readonly errorCode: AbsenceApproveRejectErrorCode;
  readonly message: Maybe<Scalars['String']['output']>;
};

export enum AbsenceApproveRejectErrorCode {
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  NotInPendingState = 'NOT_IN_PENDING_STATE',
  NoAccess = 'NO_ACCESS'
}

export type AbsenceApproveRejectRequestPayload = {
  readonly __typename?: 'AbsenceApproveRejectRequestPayload';
  readonly error: Maybe<AbsenceApproveRejectError>;
  readonly recordIds: ReadonlyArray<Scalars['String']['output']>;
  readonly records: ReadonlyArray<ApprovalRequest>;
};

export type AbsenceCategoriesGroup = {
  readonly __typename?: 'AbsenceCategoriesGroup';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly categories: ReadonlyArray<AbsenceCategory>;
  readonly flair__Order__c: Scalars['Float']['output'];
};

export type AbsenceCategory = {
  readonly __typename?: 'AbsenceCategory';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Absence_Categories_Group__c: Maybe<Scalars['String']['output']>;
  readonly flair__Archived_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Compensatory_Time__c: Scalars['Boolean']['output'];
  readonly flair__Icon__c: Maybe<Scalars['String']['output']>;
  readonly flair__Order__c: Scalars['Float']['output'];
  readonly flair__Paid__c: Scalars['Boolean']['output'];
  readonly flair__Public__c: Scalars['Boolean']['output'];
  readonly flair__Special_Rules__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type__c: AbsenceType;
  readonly flair__Unlimited__c: Scalars['Boolean']['output'];
  readonly flair__Without_Balance__c: Scalars['Boolean']['output'];
  readonly group: Maybe<AbsenceCategoriesGroup>;
};

export type AbsenceDay = {
  readonly __typename?: 'AbsenceDay';
  readonly Id: Scalars['String']['output'];
  readonly flair__Absence__c: Scalars['String']['output'];
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Day__c: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Time__c: Scalars['Time']['output'];
  readonly flair__Start_Time__c: Scalars['Time']['output'];
};

export type AbsenceFilterInput = {
  readonly excludeRejected: InputMaybe<Scalars['Boolean']['input']>;
  readonly from: InputMaybe<Scalars['LocalDate']['input']>;
  readonly intersectionMode: InputMaybe<IntersectionMode>;
  readonly onlyWithTimeTrackingRestrictedCategory: InputMaybe<Scalars['Boolean']['input']>;
  readonly to: InputMaybe<Scalars['LocalDate']['input']>;
};

export type AbsenceMutations = {
  readonly __typename?: 'AbsenceMutations';
  readonly approve: AbsenceApproveRejectRequestPayload;
  readonly approveAbsenceRequest: AbsenceApprovalRequestToMePayload;
  readonly reject: AbsenceApproveRejectRequestPayload;
  readonly rejectAbsenceRequest: AbsenceApprovalRequestToMePayload;
  readonly upsertAbsence: Absence;
  readonly validateAbsenceRequest: ValidateAbsenceRequestResponse;
};


export type AbsenceMutationsApproveArgs = {
  ids: ReadonlyArray<Scalars['String']['input']>;
};


export type AbsenceMutationsApproveAbsenceRequestArgs = {
  id: Scalars['String']['input'];
};


export type AbsenceMutationsRejectArgs = {
  inputs: ReadonlyArray<AbsenceRequestRejectInput>;
};


export type AbsenceMutationsRejectAbsenceRequestArgs = {
  comment: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type AbsenceMutationsUpsertAbsenceArgs = {
  input: UpsertAbsenceInput;
};


export type AbsenceMutationsValidateAbsenceRequestArgs = {
  input: RequestAbsenceInput;
};

export type AbsenceNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'AbsenceNotificationRenderInfo';
  readonly absence: Maybe<Absence>;
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export type AbsencePagination = {
  readonly __typename?: 'AbsencePagination';
  readonly items: ReadonlyArray<Absence>;
  readonly paginationInfo: PaginationInfo;
};

export type AbsenceRateFilter = {
  readonly endDate: Scalars['LocalDate']['input'];
  readonly startDate: Scalars['LocalDate']['input'];
};

export type AbsenceRateReportMonth = {
  readonly __typename?: 'AbsenceRateReportMonth';
  readonly absenceRate: Scalars['Float']['output'];
  readonly monthDate: Scalars['DateTime']['output'];
};

export type AbsenceRateReportPayload = {
  readonly __typename?: 'AbsenceRateReportPayload';
  readonly months: ReadonlyArray<AbsenceRateReportMonth>;
  readonly overallAbsenceRate: Maybe<Scalars['Float']['output']>;
};

export type AbsenceRequestFilterInput = {
  readonly approvalStatuses: InputMaybe<ReadonlyArray<AbsenceApprovalStatus>>;
  readonly categoryIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly employeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly managerReportsType: ManagerReportsType;
  readonly startDateFrom: InputMaybe<Scalars['DateTime']['input']>;
  readonly startDateTo: InputMaybe<Scalars['DateTime']['input']>;
};

export type AbsenceRequestPolicy = {
  readonly __typename?: 'AbsenceRequestPolicy';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Document_Upload__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Max_Absence_Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Max_Used_Amount_Period__c: Maybe<AbsenceRequestPolicyUsedAmountPeriod>;
  readonly flair__Max_Used_Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Min_Absence_Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Min_Amount_For_Document_Upload__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Min_Notice_Period_Unit__c: Maybe<AbsenceRequestPolicyNoticeRequiredUnit>;
  readonly flair__Min_Notice_Required__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Note_Placeholder__c: Maybe<Scalars['String']['output']>;
  readonly flair__Require_Note__c: Maybe<Scalars['Boolean']['output']>;
};

export enum AbsenceRequestPolicyNoticeRequiredUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Months = 'MONTHS',
  Unknown = 'UNKNOWN',
  Weeks = 'WEEKS'
}

export enum AbsenceRequestPolicyUsedAmountPeriod {
  Monthly = 'MONTHLY',
  Unknown = 'UNKNOWN',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type AbsenceRequestRejectInput = {
  readonly comment: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export enum AbsenceRequestSortFieldEnum {
  ApprovalStatus = 'APPROVAL_STATUS',
  CalendarTime = 'CALENDAR_TIME',
  CategoryName = 'CATEGORY_NAME',
  CreatedDate = 'CREATED_DATE',
  EmployeeName = 'EMPLOYEE_NAME',
  StartDate = 'START_DATE',
  WorkingTime = 'WORKING_TIME'
}

export type AbsenceRequestSortInput = {
  readonly field: AbsenceRequestSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export enum AbsenceType {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Unknown = 'UNKNOWN'
}

export type AbsenceYearlySummary = {
  readonly __typename?: 'AbsenceYearlySummary';
  readonly currentPeriod: AbsenceYearlySummaryCurrent;
  /** @deprecated use period.startDate instead */
  readonly customYearStartDay: Maybe<Scalars['LocalDate']['output']>;
  readonly employeeAbsenceCategoryId: Scalars['String']['output'];
  readonly hasYearlyBasedAccrualPolicy: Scalars['Boolean']['output'];
  readonly isUnlimited: Scalars['Boolean']['output'];
  readonly nextPeriod: AbsenceYearlySummaryNext;
  readonly previousPeriod: AbsenceYearlySummaryPrevious;
  /** @deprecated not required */
  readonly year: Scalars['Int']['output'];
};

export type AbsenceYearlySummaryAllowance = {
  readonly __typename?: 'AbsenceYearlySummaryAllowance';
  readonly absenceAllowanceId: Maybe<Scalars['String']['output']>;
  readonly accrualPolicyId: Maybe<Scalars['String']['output']>;
  readonly accrued: Scalars['Float']['output'];
  readonly expired: Scalars['Float']['output'];
  readonly lost: Scalars['Float']['output'];
  readonly title: Scalars['String']['output'];
  readonly used: Scalars['Float']['output'];
};

export type AbsenceYearlySummaryCarriedOver = {
  readonly __typename?: 'AbsenceYearlySummaryCarriedOver';
  readonly amount: Scalars['Float']['output'];
  readonly expireOn: Maybe<Scalars['LocalDate']['output']>;
  readonly expired: Scalars['Float']['output'];
  readonly lost: Scalars['Float']['output'];
  readonly used: Scalars['Float']['output'];
};

export type AbsenceYearlySummaryCurrent = {
  readonly __typename?: 'AbsenceYearlySummaryCurrent';
  readonly accrued: Maybe<Scalars['Float']['output']>;
  readonly allowances: Maybe<ReadonlyArray<AbsenceYearlySummaryAllowance>>;
  readonly available: Maybe<Scalars['Float']['output']>;
  readonly carriedOverFromPrevYear: ReadonlyArray<AbsenceYearlySummaryCarriedOver>;
  readonly endDate: Scalars['LocalDate']['output'];
  readonly planned: Scalars['Float']['output'];
  readonly plannedAbsences: ReadonlyArray<Absence>;
  readonly plannedAbsencesIds: ReadonlyArray<Scalars['String']['output']>;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly taken: Scalars['Float']['output'];
  readonly takenAbsences: ReadonlyArray<Absence>;
  readonly takenAbsencesIds: ReadonlyArray<Scalars['String']['output']>;
};

export type AbsenceYearlySummaryNext = {
  readonly __typename?: 'AbsenceYearlySummaryNext';
  readonly allowances: Maybe<ReadonlyArray<AbsenceYearlySummaryAllowance>>;
  readonly endDate: Scalars['LocalDate']['output'];
  readonly planned: Scalars['Float']['output'];
  readonly plannedAbsences: ReadonlyArray<Absence>;
  readonly plannedAbsencesIds: ReadonlyArray<Scalars['String']['output']>;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly willAccrue: Maybe<Scalars['Float']['output']>;
};

export type AbsenceYearlySummaryPrevious = {
  readonly __typename?: 'AbsenceYearlySummaryPrevious';
  readonly accrued: Maybe<Scalars['Float']['output']>;
  readonly allowances: Maybe<ReadonlyArray<AbsenceYearlySummaryAllowance>>;
  readonly endDate: Scalars['LocalDate']['output'];
  readonly startDate: Scalars['LocalDate']['output'];
  readonly taken: Scalars['Float']['output'];
  readonly takenAbsences: ReadonlyArray<Absence>;
  readonly takenAbsencesIds: ReadonlyArray<Scalars['String']['output']>;
  readonly used: Maybe<Scalars['Float']['output']>;
};

export type AcceptEmployeeFeedbackOutcomeObjectivesInput = {
  readonly employeeFeedbackOutcomeId: Scalars['String']['input'];
};

export type AccrualPolicy = {
  readonly __typename?: 'AccrualPolicy';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Interval__c: AccrualPolicyInterval;
};

export enum AccrualPolicyInterval {
  Anniversary = 'ANNIVERSARY',
  Monthly = 'MONTHLY',
  Unknown = 'UNKNOWN',
  Yearly = 'YEARLY'
}

export type ActiveEmployeesFilter = {
  readonly departments: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly employeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly locations: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly searchTerm: InputMaybe<Scalars['String']['input']>;
  readonly teams: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type AddInventoryInput = {
  readonly Name: Scalars['String']['input'];
  readonly flair__Manufacturer__c: Scalars['String']['input'];
  readonly flair__Model__c: Scalars['String']['input'];
  readonly flair__Support_Advisor__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Support_Instruction__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Support_Video__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Type__c: InputMaybe<Scalars['String']['input']>;
};

export type AddInventoryItemInput = {
  readonly flair__App_Cat_Download_Or_Connect_Link__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__App_Cat_Editor__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__App_Cat_Version__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Electronics_Cat_Operating_System__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Employee__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Inventory__c: Scalars['String']['input'];
  readonly flair__Location__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Net_Purchase_Price__c: InputMaybe<Scalars['Float']['input']>;
  readonly flair__Notes__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Purchase_Date__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Serial_Number__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Supplier__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Uniform_Cat_Size_System__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Uniform_Cat_Size__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Uniform_Cat_Type__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Vehicle_Cat_Fuel_Type__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Vehicle_Cat_Identification_Number_VIN__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Vehicle_Cat_Insurance_Company_Contact__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Vehicle_Cat_Insurance_Company__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Vehicle_Cat_Insurance_policy_number__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Vehicle_Cat_Model_Year__c: InputMaybe<Scalars['Int']['input']>;
  readonly flair__Vehicle_Cat_Serial_Plate_Number__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Warranty_Date__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Warranty_Information__c: InputMaybe<Scalars['String']['input']>;
};

export type AddInventoryItemPayload = {
  readonly __typename?: 'AddInventoryItemPayload';
  readonly record: InventoryItem;
  readonly recordId: Scalars['String']['output'];
};

export type AddInventoryPayload = {
  readonly __typename?: 'AddInventoryPayload';
  readonly record: Inventory;
  readonly recordId: Scalars['String']['output'];
};

export type AddSkillToEmployeeInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly rate: InputMaybe<Scalars['Int']['input']>;
  readonly skillId: Scalars['String']['input'];
};

export type AdditionalManager = {
  readonly __typename?: 'AdditionalManager';
  readonly flair__Employee__c: Scalars['String']['output'];
};

export enum AiProcessingState {
  Done = 'DONE',
  Error = 'ERROR',
  NotStarted = 'NOT_STARTED',
  Processing = 'PROCESSING',
  Unknown = 'UNKNOWN'
}

export type AllNotificationsActionPayload = {
  readonly __typename?: 'AllNotificationsActionPayload';
  readonly recordIds: ReadonlyArray<Scalars['String']['output']>;
};

export type AllowanceWithdrawalDay = {
  readonly __typename?: 'AllowanceWithdrawalDay';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly absence: Maybe<Absence>;
  readonly flair__Absence_Allowance__c: Scalars['String']['output'];
  readonly flair__Absence__c: Maybe<Scalars['String']['output']>;
  readonly flair__Allowance_Period_End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Allowance_Period_Start_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Day__c: Scalars['String']['output'];
};

export type AnniversariesFilter = {
  readonly filterBy: EmployeeScopeFilter;
  readonly limit: InputMaybe<Scalars['Int']['input']>;
};

export type Announcement = Commentable & {
  readonly __typename?: 'Announcement';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly emojis: ReadonlyArray<AnnouncementEmoji>;
  readonly employee: Maybe<Colleague>;
  readonly flair__Announcement_Text__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Published_Date__c: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementEmoji = {
  readonly __typename?: 'AnnouncementEmoji';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly announcement: Announcement;
  readonly employee: Colleague;
  readonly flair__Company_Announcement__c: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
};

export type AnnouncementEmojiPayload = {
  readonly __typename?: 'AnnouncementEmojiPayload';
  readonly announcement: Announcement;
  readonly announcementId: Scalars['String']['output'];
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<AnnouncementEmoji>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type AnnouncementMutations = {
  readonly __typename?: 'AnnouncementMutations';
  readonly create: AnnouncementEmojiPayload;
  readonly delete: AnnouncementEmojiPayload;
};


export type AnnouncementMutationsCreateArgs = {
  input: CreateEmojiInput;
};


export type AnnouncementMutationsDeleteArgs = {
  input: DeleteEmojiInput;
};

export type AnswerCheckinsSurveyCycleInput = {
  readonly comment: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly score: Scalars['Int']['input'];
  readonly surveyCycleId: Scalars['String']['input'];
  readonly surveyId: Scalars['String']['input'];
};

export type AnswerEnpsSurveyCycleInput = {
  readonly comment: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly score: Scalars['Int']['input'];
  readonly surveyCycleId: Scalars['String']['input'];
  readonly surveyId: Scalars['String']['input'];
};

export type AnyObject = {
  readonly Id: Scalars['String']['output'];
};

export type ApprovalRequest = {
  readonly __typename?: 'ApprovalRequest';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly absence: Maybe<Absence>;
  readonly approver: Maybe<Colleague>;
  readonly flair__Action_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Approval_Assignment__c: Scalars['String']['output'];
  readonly flair__Approval_Policy_Step_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Approval_Policy__c: Maybe<Scalars['String']['output']>;
  readonly flair__Approval_Status__c: ApprovalRequestStatus;
  readonly flair__Approver_Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Approver__c: Scalars['String']['output'];
  readonly flair__Employee_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Record_Employee__c: Scalars['String']['output'];
  readonly flair__Related_Id__c: Scalars['String']['output'];
  readonly flair__Related_Object_Name__c: Scalars['String']['output'];
  readonly flair__Request_Errors__c: Maybe<Scalars['String']['output']>;
  readonly flair__Requested_At__c: Scalars['DateTime']['output'];
  readonly recordEmployee: Maybe<Colleague>;
  readonly relatedRecordName: Scalars['String']['output'];
  readonly relatedRecordObjectName: Scalars['String']['output'];
};

export type ApprovalRequestMutations = {
  readonly __typename?: 'ApprovalRequestMutations';
  readonly updateApprovalRequestStatus: UpdateApprovalRequestStatusPayload;
};


export type ApprovalRequestMutationsUpdateApprovalRequestStatusArgs = {
  input: UpdateApprovalRequestStatusInput;
};

export enum ApprovalRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export enum ApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type ApproveTimeEntryChangeRequestInput = {
  readonly ids: ReadonlyArray<Scalars['String']['input']>;
};

export enum ApproveTimeSheetAction {
  ApproveAllChangeRequests = 'APPROVE_ALL_CHANGE_REQUESTS',
  RejectAllChangeRequests = 'REJECT_ALL_CHANGE_REQUESTS'
}

export type ApproveTimeSheetError = {
  readonly __typename?: 'ApproveTimeSheetError';
  readonly errorCode: ApproveTimeSheetErrorCode;
  readonly message: Maybe<Scalars['String']['output']>;
};

export enum ApproveTimeSheetErrorCode {
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  NotInPendingState = 'NOT_IN_PENDING_STATE',
  NoAccess = 'NO_ACCESS'
}

export type ApproveTimeSheetsPayload = {
  readonly __typename?: 'ApproveTimeSheetsPayload';
  readonly error: Maybe<ApproveTimeSheetError>;
  readonly recordIds: ReadonlyArray<Scalars['String']['output']>;
  readonly records: ReadonlyArray<TimeSheet>;
};

export type ArchiveNotificationFilterInput = {
  readonly searchText: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveNotificationInput = {
  readonly id: Scalars['String']['input'];
};

export enum AscDescEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AvailableEvaluationTemplatesInput = {
  readonly candidateId: Scalars['String']['input'];
  readonly employeeId: Scalars['String']['input'];
};

export type BirthdaysFilter = {
  readonly filterBy: EmployeeScopeFilter;
  readonly limit: InputMaybe<Scalars['Int']['input']>;
  readonly startDate: Scalars['String']['input'];
};

export type BreakLegislationRule = {
  readonly __typename?: 'BreakLegislationRule';
  readonly Id: Scalars['String']['output'];
  readonly flair__Break__c: Scalars['Int']['output'];
  readonly flair__Time_Framework__c: Scalars['String']['output'];
  readonly flair__Work_More_Than_Hour__c: Scalars['Int']['output'];
  readonly flair__Work_More_Than_Minute__c: Scalars['Int']['output'];
  readonly timeFramework: TimeFramework;
};

export type BreakScheduled = {
  readonly __typename?: 'BreakScheduled';
  readonly endTime: Scalars['Time']['output'];
  readonly id: Scalars['String']['output'];
  readonly startTime: Scalars['Time']['output'];
};

export type CalculateAbsenceWorkingAmountAllowanceResponse = {
  readonly __typename?: 'CalculateAbsenceWorkingAmountAllowanceResponse';
  readonly amountLeft: Scalars['Float']['output'];
  readonly id: Scalars['String']['output'];
  readonly isSystem: Scalars['Boolean']['output'];
  readonly periodEndDate: Maybe<Scalars['String']['output']>;
  readonly periodStartDate: Maybe<Scalars['String']['output']>;
  readonly withdrawalAmount: Scalars['Float']['output'];
};

export type CalculateAbsenceWorkingAmountInput = {
  readonly employeeAbsenceCategoryId: Scalars['String']['input'];
  readonly endDate: Scalars['String']['input'];
  readonly endTime: Scalars['Time']['input'];
  readonly startDate: Scalars['String']['input'];
  readonly startTime: Scalars['Time']['input'];
};

export type CalculateAbsenceWorkingAmountResponse = {
  readonly __typename?: 'CalculateAbsenceWorkingAmountResponse';
  readonly allowances: ReadonlyArray<CalculateAbsenceWorkingAmountAllowanceResponse>;
  readonly hasCredits: Scalars['Boolean']['output'];
  readonly workingAmount: Scalars['Float']['output'];
};

export type CalendarPeriod = {
  readonly __typename?: 'CalendarPeriod';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Calendar__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__Official__c: Scalars['Boolean']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Type__c: HolidayType;
};

export type CancelShiftChangeRequestInput = {
  readonly id: Scalars['String']['input'];
};

export type CancelShiftChangeRequestPayload = {
  readonly __typename?: 'CancelShiftChangeRequestPayload';
  readonly query: Query;
  readonly record: Maybe<ShiftChangeRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CandidateEvaluation = Commentable & {
  readonly __typename?: 'CandidateEvaluation';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly answers: Maybe<ReadonlyArray<EvaluationAnswer>>;
  readonly candidate: JobCandidate;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Colleague;
  readonly evaluationTemplate: Maybe<EvaluationTemplate>;
  readonly flair__Candidate__c: Scalars['String']['output'];
  readonly flair__Due_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Evaluated__c: Scalars['Boolean']['output'];
  readonly flair__Evaluation_Template__c: Scalars['String']['output'];
  readonly flair__Final_Score__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Overall_Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Skipped_At__c: Maybe<Scalars['DateTime']['output']>;
};

export type CandidateEvaluationNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'CandidateEvaluationNotificationRenderInfo';
  readonly candidateEvaluation: Maybe<CandidateEvaluation>;
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export type CandidateFilterInput = {
  readonly searchTerm: InputMaybe<Scalars['String']['input']>;
  readonly source: InputMaybe<Scalars['String']['input']>;
  readonly stages: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type CandidateListFilterOptions = {
  readonly __typename?: 'CandidateListFilterOptions';
  readonly sources: ReadonlyArray<PickListEntry>;
  readonly stages: ReadonlyArray<PickListEntry>;
};

export type Celebration = Commentable & WithReactions & {
  readonly __typename?: 'Celebration';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly flair__Loom_Video__c: Maybe<Scalars['String']['output']>;
  readonly flair__Message__c: Scalars['String']['output'];
  readonly flair__Predefined_Image__c: Maybe<Scalars['String']['output']>;
  readonly flair__Public__c: Scalars['Boolean']['output'];
  readonly flair__Sender__c: Scalars['String']['output'];
  readonly flair__Type__c: Maybe<Scalars['String']['output']>;
  readonly loomVideo: Maybe<LoomVideo>;
  readonly myEmployeeRecipient: Maybe<CelebrationEmployeeRecipient>;
  readonly reactions: ReadonlyArray<Reaction>;
  readonly recipients: ReadonlyArray<CelebrationRecipient>;
  readonly sender: Colleague;
};

export type CelebrationEmployeeRecipient = {
  readonly __typename?: 'CelebrationEmployeeRecipient';
  readonly Id: Scalars['String']['output'];
  readonly celebration: Celebration;
  readonly employee: Colleague;
  readonly flair__Celebration__c: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Read_Date__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Upserting_Key__c: Scalars['String']['output'];
};

export enum CelebrationFeed {
  Public = 'Public',
  Received = 'Received',
  Sent = 'Sent'
}

export type CelebrationFilterInput = {
  readonly feed: CelebrationFeed;
};

export type CelebrationMutations = {
  readonly __typename?: 'CelebrationMutations';
  readonly createCelebration: CelebrationPayload;
  readonly deleteCelebration: CelebrationPayload;
  readonly makeCelebrationPublic: CelebrationPayload;
  readonly markAsRead: MarkCelebrationAsReadPayload;
  readonly updateCelebration: CelebrationPayload;
};


export type CelebrationMutationsCreateCelebrationArgs = {
  input: CreateCelebrationInput;
};


export type CelebrationMutationsDeleteCelebrationArgs = {
  input: DeleteCelebrationInput;
};


export type CelebrationMutationsMakeCelebrationPublicArgs = {
  input: MakeCelebrationPublicInput;
};


export type CelebrationMutationsMarkAsReadArgs = {
  input: MarkCelebrationsAsReadInput;
};


export type CelebrationMutationsUpdateCelebrationArgs = {
  input: UpdateCelebrationInput;
};

export type CelebrationNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'CelebrationNotificationRenderInfo';
  readonly celebration: Maybe<Celebration>;
  readonly celebrationEmployeeRecipient: Maybe<CelebrationEmployeeRecipient>;
  readonly employee: Maybe<Colleague>;
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export type CelebrationPagination = {
  readonly __typename?: 'CelebrationPagination';
  readonly items: ReadonlyArray<Celebration>;
  readonly paginationInfo: PaginationInfo;
};

export type CelebrationPayload = {
  readonly __typename?: 'CelebrationPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<Celebration>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CelebrationRecipient = {
  readonly __typename?: 'CelebrationRecipient';
  readonly Id: Scalars['String']['output'];
  readonly celebration: Celebration;
  readonly employee: Maybe<Colleague>;
  readonly flair__Celebration__c: Scalars['String']['output'];
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Order__c: Scalars['Int']['output'];
  readonly flair__Recipient_Type__c: CelebrationRecipientType;
  readonly flair__Team__c: Maybe<Scalars['String']['output']>;
  readonly team: Maybe<Team>;
};

export type CelebrationRecipientInput = {
  readonly id: Scalars['String']['input'];
  readonly type: CelebrationRecipientType;
};

export enum CelebrationRecipientType {
  Employee = 'EMPLOYEE',
  Team = 'TEAM'
}

export type Certificate = {
  readonly __typename?: 'Certificate';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type CertificateMutations = {
  readonly __typename?: 'CertificateMutations';
  readonly createEmployeeCertificate: EmployeeCertificatePayload;
  readonly deleteEmployeeCertificate: EmployeeCertificatePayload;
  readonly updateEmployeeCertificate: EmployeeCertificatePayload;
};


export type CertificateMutationsCreateEmployeeCertificateArgs = {
  input: CreateEmployeeCertificateInput;
};


export type CertificateMutationsDeleteEmployeeCertificateArgs = {
  id: Scalars['String']['input'];
};


export type CertificateMutationsUpdateEmployeeCertificateArgs = {
  input: UpdateEmployeeCertificateInput;
};

export enum ChangeEvent {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

export type ChangeReviewerInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly participantId: Scalars['String']['input'];
  readonly reviewerId: Scalars['String']['input'];
};

export type ChangeReviewerPayload = {
  readonly __typename?: 'ChangeReviewerPayload';
  readonly recordId: Scalars['String']['output'];
};

export type CheckinsSurvey = {
  readonly __typename?: 'CheckinsSurvey';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly cycles: ReadonlyArray<CheckinsSurveyCycle>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Allow_comments__c: Scalars['Boolean']['output'];
  readonly flair__Compulsory__c: Scalars['Boolean']['output'];
  readonly flair__Default_Language__c: Scalars['String']['output'];
  readonly flair__Question_Text__c: Scalars['String']['output'];
};

export type CheckinsSurveyAnswer = {
  readonly __typename?: 'CheckinsSurveyAnswer';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Checkins_Survey_Cycle__c: Scalars['String']['output'];
  readonly flair__Checkins_Survey__c: Scalars['String']['output'];
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Dismissed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Score__c: Maybe<Scalars['Int']['output']>;
};

export type CheckinsSurveyCycle = {
  readonly __typename?: 'CheckinsSurveyCycle';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Checkins_Survey__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Start_Date__c: Scalars['LocalDate']['output'];
};

export type CheckinsSurveyCycleDto = {
  readonly __typename?: 'CheckinsSurveyCycleDto';
  readonly endDate: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['String']['output'];
  readonly startDate: Scalars['LocalDate']['output'];
};

export type CheckinsSurveyDto = {
  readonly __typename?: 'CheckinsSurveyDto';
  readonly active: Scalars['Boolean']['output'];
  readonly allowComments: Scalars['Boolean']['output'];
  readonly compulsory: Scalars['Boolean']['output'];
  readonly createdOn: Scalars['DateTime']['output'];
  readonly cycles: ReadonlyArray<CheckinsSurveyCycleDto>;
  readonly defaultLanguage: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly questionText: Scalars['String']['output'];
};

export type CheckinsSurveyMutations = {
  readonly __typename?: 'CheckinsSurveyMutations';
  readonly answerCheckinsSurveyCycle: CheckinsSurveyPayload;
  readonly dismissCheckinsSurveyCycle: CheckinsSurveyPayload;
};


export type CheckinsSurveyMutationsAnswerCheckinsSurveyCycleArgs = {
  input: AnswerCheckinsSurveyCycleInput;
};


export type CheckinsSurveyMutationsDismissCheckinsSurveyCycleArgs = {
  input: DismissCheckinsSurveyCycleInput;
};

export type CheckinsSurveyPayload = {
  readonly __typename?: 'CheckinsSurveyPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CloneEmployeeObjectiveInput = {
  readonly employeeIds: ReadonlyArray<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type CloneEmployeeObjectivePayload = {
  readonly __typename?: 'CloneEmployeeObjectivePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly recordIds: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type CloseTicketInput = {
  readonly reason: InputMaybe<Scalars['String']['input']>;
  readonly ticketId: Scalars['String']['input'];
};

export type CloseTicketPayload = {
  readonly __typename?: 'CloseTicketPayload';
  readonly record: Maybe<Ticket>;
  readonly recordId: Scalars['String']['output'];
};

export type Colleague = AnyObject & WithExtraFields & {
  readonly __typename?: 'Colleague';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly absenceCategories: ReadonlyArray<EmployeeAbsenceCategory>;
  readonly absences2: ReadonlyArray<Absence>;
  readonly avatar: Maybe<EmployeeAvatar>;
  readonly department: Maybe<Department>;
  readonly employeeSkills: ReadonlyArray<EmployeeSkillAssociation>;
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly flair__Birthday_this_year__c: Maybe<Scalars['String']['output']>;
  readonly flair__Company_Email__c: Maybe<Scalars['String']['output']>;
  readonly flair__Company_Phone_Number__c: Maybe<Scalars['String']['output']>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__End_Of_Probation_Period__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__First_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Hide_My_Birthday__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Last_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Manager__c: Maybe<Scalars['String']['output']>;
  readonly flair__Position__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Upcoming_Anniversary__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Upcoming_Birthday__c: Maybe<Scalars['String']['output']>;
  readonly holidays: ReadonlyArray<Holiday>;
  readonly location: Maybe<Location>;
  readonly manager: Maybe<Colleague>;
  readonly recordType: RecordType;
  readonly shifts: ReadonlyArray<EmployeeShift>;
  readonly teams: ReadonlyArray<Team>;
  readonly workloads: ReadonlyArray<EmployeeWorkload>;
};


export type ColleagueAbsences2Args = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type ColleagueHolidaysArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type ColleagueShiftsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type ColleagueWorkloadsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type Comment = WithReactions & {
  readonly __typename?: 'Comment';
  readonly ContentDocumentLinks: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employee: Colleague;
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Object_Name__c: Scalars['String']['output'];
  readonly mentions: ReadonlyArray<MentionedEmployee>;
  readonly reactions: ReadonlyArray<Reaction>;
  readonly related: Maybe<Commentable>;
};

export type CommentAbsenceExtraData = CommentExtraDataInterface & {
  readonly __typename?: 'CommentAbsenceExtraData';
  readonly absenceRequest: Maybe<Scalars['String']['output']>;
  readonly extraDataType: CommentExtraDataType;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CommentExtraDataInterface = {
  readonly extraDataType: CommentExtraDataType;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export enum CommentExtraDataType {
  CommentAbsenceExtraData = 'CommentAbsenceExtraData'
}

export type CommentFileInput = {
  readonly fileContentBase64: Scalars['String']['input'];
  readonly fileName: Scalars['String']['input'];
};

export type CommentMutations = {
  readonly __typename?: 'CommentMutations';
  readonly createComment: CommentPayload;
  readonly deleteComment: CommentPayload;
  readonly updateComment: UpdatedCommentPayload;
};


export type CommentMutationsCreateCommentArgs = {
  input: CreateCommentInput;
};


export type CommentMutationsDeleteCommentArgs = {
  id: Scalars['String']['input'];
};


export type CommentMutationsUpdateCommentArgs = {
  input: UpdateCommentInput;
};

export type CommentNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'CommentNotificationRenderInfo';
  readonly comment: Maybe<Comment>;
  readonly employee: Maybe<Colleague>;
  /** @deprecated We don't need extraData anymore. Comments support deep links now. */
  readonly extraData: Maybe<CommentExtraDataInterface>;
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export type CommentPayload = {
  readonly __typename?: 'CommentPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Object_Name__c: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<Comment>;
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly related: Maybe<Commentable>;
};

export type Commentable = {
  readonly Id: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
};

export type CommentableIdInput = {
  readonly objectName: Scalars['String']['input'];
  readonly recordId: Scalars['String']['input'];
};

export type CompanyDocument = {
  readonly __typename?: 'CompanyDocument';
  readonly ContentDocumentLinks: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
};

export type CompanyObjective = Objective & {
  readonly __typename?: 'CompanyObjective';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly allHistoryItems: ReadonlyArray<ObjectiveHistoryItemCommon>;
  readonly allParents: ReadonlyArray<Objective>;
  readonly category: Maybe<ObjectiveCategory>;
  readonly childrenObjectives: ReadonlyArray<TeamOrEmployeeObjective>;
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Current_Status__c: ObjectiveCurrentStatusType;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Due_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Expected_Progress__c: Scalars['Float']['output'];
  readonly flair__Is_Draft__c: Scalars['Boolean']['output'];
  readonly flair__Nested_Goals_Allowed__c: Scalars['Boolean']['output'];
  readonly flair__Objective_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__Objective_Time_Period__c: Maybe<Scalars['String']['output']>;
  readonly flair__On_Track__c: Scalars['Boolean']['output'];
  readonly flair__Owner__c: Maybe<Scalars['String']['output']>;
  readonly flair__Progress__c: Scalars['Float']['output'];
  readonly flair__Start_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Status_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: ObjectiveStatusType;
  readonly flair__Visibility__c: ObjectiveVisibility;
  /** @deprecated use allHistoryItems */
  readonly historyItems: ReadonlyArray<ObjectiveHistoryItem>;
  readonly owner: Maybe<Colleague>;
  readonly period: Maybe<ObjectiveTimePeriod>;
  readonly sharedWith: ReadonlyArray<Colleague>;
  readonly statusChangedBy: Maybe<Colleague>;
  readonly tags: ReadonlyArray<Tag>;
};

export type ContentDocument = {
  readonly __typename?: 'ContentDocument';
  readonly ContentSize: Scalars['Int']['output'];
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly FileExtension: Maybe<Scalars['String']['output']>;
  readonly FileType: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LatestPublishedVersionId: Scalars['String']['output'];
  readonly Title: Scalars['String']['output'];
  readonly downloadUrl: Scalars['String']['output'];
  readonly previewUrl: Scalars['String']['output'];
  readonly viewUrl: Scalars['String']['output'];
};


export type ContentDocumentPreviewUrlArgs = {
  size: InputMaybe<Scalars['Int']['input']>;
};

export type ContentDocumentLink = {
  readonly __typename?: 'ContentDocumentLink';
  readonly ContentDocument: ContentDocument;
  readonly ContentDocumentId: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LinkedEntityId: Scalars['String']['output'];
  /** @deprecated Use downloadUrl instead */
  readonly PublicLink: Maybe<ContentPublicLink>;
  readonly downloadUrl: Scalars['String']['output'];
  readonly viewUrl: Scalars['String']['output'];
};

export type ContentPublicLink = {
  readonly __typename?: 'ContentPublicLink';
  readonly contentDocumentId: Scalars['String']['output'];
  /** @deprecated Use downloadUrl instead */
  readonly downloadLink: Scalars['String']['output'];
  /** @deprecated Use viewUrl instead */
  readonly viewLink: Scalars['String']['output'];
};

export type CostCenter = {
  readonly __typename?: 'CostCenter';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Code__c: Scalars['String']['output'];
};

export type Course = {
  readonly __typename?: 'Course';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
};

export type CoursesMutations = {
  readonly __typename?: 'CoursesMutations';
  readonly gotoCourseUrl: Scalars['String']['output'];
};


export type CoursesMutationsGotoCourseUrlArgs = {
  employeeCourseId: Scalars['String']['input'];
};

export type CreateCandidateEvaluationInput = {
  readonly candidateId: Scalars['String']['input'];
  readonly employeeId: Scalars['String']['input'];
  readonly templateId: Scalars['String']['input'];
};

export type CreateCelebrationInput = {
  readonly loomVideo: InputMaybe<CreateLoomVideoInput>;
  readonly message: Scalars['String']['input'];
  readonly predefinedImage: InputMaybe<Scalars['String']['input']>;
  readonly public: Scalars['Boolean']['input'];
  readonly recipients: ReadonlyArray<CelebrationRecipientInput>;
  readonly type: Scalars['String']['input'];
};

export type CreateCommentInput = {
  readonly comment: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly files: InputMaybe<ReadonlyArray<CommentFileInput>>;
  readonly relatedId: Scalars['String']['input'];
  readonly relatedObjectName: Scalars['String']['input'];
};

export type CreateDataChangeRequestInput = {
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly initiatorEmployeeId: Scalars['String']['input'];
  readonly payload: DataChangePayloadInput;
  readonly requestFormId: Scalars['String']['input'];
};

export type CreateDataChangeRequestPayload = {
  readonly __typename?: 'CreateDataChangeRequestPayload';
  readonly query: Query;
  readonly record: Maybe<EmployeeDataChangeRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CreateDraftExpenseInput = {
  readonly dateFrom: Scalars['LocalDate']['input'];
  readonly expenseGroupId: InputMaybe<Scalars['String']['input']>;
  readonly expenseItems: InputMaybe<ReadonlyArray<DraftExpenseItemInput>>;
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly files: InputMaybe<ReadonlyArray<FileInput>>;
  readonly recordTypeId: Scalars['String']['input'];
};

export type CreateEmojiInput = {
  readonly announcementId: Scalars['String']['input'];
  readonly employeeId: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type CreateEmployeeCertificateInput = {
  readonly certificateId: InputMaybe<Scalars['String']['input']>;
  readonly certificateName: Scalars['String']['input'];
  readonly certificateUrl: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly expirationDate: InputMaybe<Scalars['LocalDate']['input']>;
  readonly files: InputMaybe<ReadonlyArray<EmployeeCertificateFileInput>>;
  readonly issueDate: InputMaybe<Scalars['LocalDate']['input']>;
  readonly issuedBy: Scalars['String']['input'];
  readonly plannedDate: InputMaybe<Scalars['LocalDate']['input']>;
};

export type CreateEmployeeNoteInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly polarity: ManagerEmployeeNotePolarity;
  readonly text: Scalars['String']['input'];
};

export type CreateEmployeeNotesPayload = {
  readonly __typename?: 'CreateEmployeeNotesPayload';
  readonly record: ManagerEmployeeNote;
  readonly recordId: Scalars['String']['output'];
};

export type CreateEmployeeObjectiveInput = {
  readonly cancelReason: InputMaybe<Scalars['String']['input']>;
  readonly categoryId: InputMaybe<Scalars['String']['input']>;
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly dueDate: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly keyResults: ReadonlyArray<CreateObjectiveKeyResultInput>;
  readonly manualProgress: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly parentObjectiveId: InputMaybe<ObjectiveIdInput>;
  readonly rate: EmployeeObjectiveRateType;
  readonly sharedWithEmployeeIds: ReadonlyArray<Scalars['String']['input']>;
  readonly startDate: InputMaybe<Scalars['String']['input']>;
  readonly status: ObjectiveCurrentStatusType;
  readonly tagIds: ReadonlyArray<Scalars['String']['input']>;
  readonly timePeriodId: InputMaybe<Scalars['String']['input']>;
  readonly visibility: ObjectiveVisibility;
};

export type CreateEmployeeObjectivePayload = {
  readonly __typename?: 'CreateEmployeeObjectivePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly record: Maybe<EmployeeObjective>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CreateExpenseGroupInput = {
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly tripLocation: InputMaybe<Scalars['String']['input']>;
  readonly type: ExpenseGroupType;
};

export type CreateExpenseInput = {
  readonly amount: InputMaybe<Scalars['Float']['input']>;
  readonly category: Scalars['String']['input'];
  readonly dateFrom: InputMaybe<Scalars['LocalDate']['input']>;
  readonly dateTo: InputMaybe<Scalars['LocalDate']['input']>;
  readonly description: Scalars['String']['input'];
  readonly expenseDate: Scalars['LocalDate']['input'];
  readonly expenseGroupId: InputMaybe<Scalars['String']['input']>;
  readonly expenseItems: InputMaybe<ReadonlyArray<ExpenseItemInput>>;
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly files: InputMaybe<ReadonlyArray<FileInput>>;
  readonly project: InputMaybe<Scalars['String']['input']>;
  readonly recordTypeId: InputMaybe<Scalars['String']['input']>;
  readonly timeFrom: InputMaybe<Scalars['String']['input']>;
  readonly timeTo: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpenseItemInput = {
  readonly expenseId: Scalars['String']['input'];
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly files: InputMaybe<ReadonlyArray<FileInput>>;
  readonly flair__Address_From__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Address_To__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Manual_Amount__c: InputMaybe<Scalars['Float']['input']>;
  readonly flair__Means_Of_Transport__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Note__c: InputMaybe<Scalars['String']['input']>;
  readonly merchantId: InputMaybe<Scalars['String']['input']>;
  readonly merchantName: InputMaybe<Scalars['String']['input']>;
  readonly recordTypeId: Scalars['String']['input'];
};

export type CreateLoomVideoInput = {
  readonly embedUrl: Scalars['String']['input'];
  readonly height: Scalars['Int']['input'];
  readonly loomId: Scalars['String']['input'];
  readonly loomPublicAppId: Scalars['String']['input'];
  readonly sharedUrl: Scalars['String']['input'];
  readonly width: Scalars['Int']['input'];
};

export type CreateLoomVideoPayload = {
  readonly __typename?: 'CreateLoomVideoPayload';
  readonly flair__Related_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Object_Name__c: Maybe<Scalars['String']['output']>;
  readonly record: Maybe<LoomVideo>;
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly related: Maybe<WithLoomVideo>;
};

export type CreateMerchantInput = {
  readonly name: Scalars['String']['input'];
};

export type CreateMyTimeEntryInput = {
  readonly macAddress: Scalars['String']['input'];
  readonly origin: InputMaybe<TimeEntryOrigin>;
};

export type CreateMyTimeEntryPayload = {
  readonly __typename?: 'CreateMyTimeEntryPayload';
  /** @deprecated use errors2 instead */
  readonly errors: ReadonlyArray<TimeTrackingErrorV2>;
  readonly errors2: ReadonlyArray<TimeTrackingErrorBase>;
  readonly me: Maybe<Me>;
  readonly record: Maybe<MyTimeEntry>;
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly warnings: ReadonlyArray<TimeTrackingWarning>;
};

export type CreateObjectiveKeyResultInput = {
  readonly currentValue: Scalars['Float']['input'];
  readonly initialValue: Scalars['Float']['input'];
  readonly name: Scalars['String']['input'];
  readonly targetValue: Scalars['Float']['input'];
  readonly type: ObjectiveKeyResultType;
};

export type CreateOpenShiftAssignmentRequestInput = {
  readonly openShiftId: Scalars['String']['input'];
};

export type CreatePeerReviewerInput = {
  readonly currentFeedbackRequestId: Scalars['String']['input'];
  readonly outcomeId: Scalars['String']['input'];
  readonly peerReviewerIds: ReadonlyArray<Scalars['String']['input']>;
};

export type CreateReactionInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly relatedId: Scalars['String']['input'];
  readonly relatedObjectName: Scalars['String']['input'];
  readonly text: Scalars['String']['input'];
};

export type CreateShiftChangeRequestInput = {
  readonly changeReason: InputMaybe<Scalars['String']['input']>;
  readonly proposedResourceEmployeeId: Scalars['String']['input'];
  readonly shiftId: Scalars['String']['input'];
};

export type CreateShiftChangeRequestPayload = {
  readonly __typename?: 'CreateShiftChangeRequestPayload';
  readonly query: Query;
  readonly record: Maybe<ShiftChangeRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CreateSkillInput = {
  readonly createdBy: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly rateable: Scalars['Boolean']['input'];
};

export type CreateTeamObjectiveInput = {
  readonly cancelReason: InputMaybe<Scalars['String']['input']>;
  readonly categoryId: InputMaybe<Scalars['String']['input']>;
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly dueDate: InputMaybe<Scalars['String']['input']>;
  readonly keyResults: ReadonlyArray<CreateObjectiveKeyResultInput>;
  readonly manualProgress: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly parentObjectiveId: InputMaybe<ObjectiveIdInput>;
  readonly rate: EmployeeObjectiveRateType;
  readonly sharedWithEmployeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly startDate: InputMaybe<Scalars['String']['input']>;
  readonly status: ObjectiveCurrentStatusType;
  readonly tagIds: ReadonlyArray<Scalars['String']['input']>;
  readonly teamId: Scalars['String']['input'];
  readonly timePeriodId: InputMaybe<Scalars['String']['input']>;
  readonly visibility: ObjectiveVisibility;
};

export type CreateTeamObjectivePayload = {
  readonly __typename?: 'CreateTeamObjectivePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly record: Maybe<TeamObjective>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type CreateTicketInput = {
  readonly flair__Anonymous__c: Scalars['Boolean']['input'];
  readonly flair__Category__c: Scalars['String']['input'];
  readonly flair__Details__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Employee__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Subject__c: Scalars['String']['input'];
  readonly flair__Visibility__c: TicketVisibility;
};

export type CreateTicketPayload = {
  readonly __typename?: 'CreateTicketPayload';
  readonly record: Ticket;
  readonly recordId: Scalars['String']['output'];
};

export type CreateTimeEntryBreakChangeRequestInput = {
  readonly changeRequestId: Scalars['String']['input'];
  readonly endDatetime: Scalars['DateTime']['input'];
  readonly startDatetime: Scalars['DateTime']['input'];
};

export type CreateTimeEntryBreakInput = {
  readonly end: InputMaybe<Scalars['DateTime']['input']>;
  readonly start: Scalars['DateTime']['input'];
  readonly timeEntryId: Scalars['String']['input'];
};

export type CreateTimeEntryChangeRequestBreakInput = {
  readonly breakId: InputMaybe<Scalars['String']['input']>;
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly startDatetime: Scalars['DateTime']['input'];
};

export type CreateTimeEntryChangeRequestInput = {
  readonly breaks: ReadonlyArray<CreateTimeEntryChangeRequestBreakInput>;
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly startDatetime: Scalars['DateTime']['input'];
  readonly timeEntryId: InputMaybe<Scalars['String']['input']>;
};

export type CreateTimeEntryInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly end: InputMaybe<Scalars['DateTime']['input']>;
  readonly start: Scalars['DateTime']['input'];
};

export type CustomerSupport = {
  readonly __typename?: 'CustomerSupport';
  readonly supportAccess: Scalars['Boolean']['output'];
};

export type CustomerSupportInput = {
  readonly supportAccess: Scalars['Boolean']['input'];
};

export type DataChangePayloadInput = {
  readonly changeReason: Scalars['String']['input'];
  readonly files: ReadonlyArray<FileInput>;
  readonly objectsFieldsChanges: InputMaybe<ReadonlyArray<ObjectFieldChangesInput>>;
};

export type DateTimeRangeInput = {
  readonly from: InputMaybe<Scalars['DateTime']['input']>;
  readonly to: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeWithOrigin = {
  readonly __typename?: 'DateTimeWithOrigin';
  readonly changeRequestId: Maybe<Scalars['String']['output']>;
  readonly timeEntryId: Maybe<Scalars['String']['output']>;
  readonly value: Maybe<Scalars['DateTime']['output']>;
};

export type DayTimeInput = {
  readonly currentDate: Scalars['String']['input'];
  readonly endTime: Scalars['Time']['input'];
  readonly startTime: Scalars['Time']['input'];
};

export type DeleteCelebrationInput = {
  readonly id: Scalars['String']['input'];
};

export type DeleteEmojiInput = {
  readonly id: Scalars['String']['input'];
};

export type DeleteEmployeeNotesPayload = {
  readonly __typename?: 'DeleteEmployeeNotesPayload';
  readonly recordId: Scalars['String']['output'];
};

export type DeleteEmployeeObjectiveInput = {
  readonly id: Scalars['String']['input'];
};

export type DeleteEvaluationAnswerPayload = {
  readonly __typename?: 'DeleteEvaluationAnswerPayload';
  readonly recordId: Scalars['String']['output'];
};

export type DeleteExpensePayload = {
  readonly id: Scalars['String']['input'];
};

export type DeleteLoomVideoInput = {
  readonly id: Scalars['String']['input'];
  readonly relatedId: Scalars['String']['input'];
  readonly relatedObjectName: Scalars['String']['input'];
};

export type DeleteLoomVideoPayload = {
  readonly __typename?: 'DeleteLoomVideoPayload';
  readonly flair__Related_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Object_Name__c: Maybe<Scalars['String']['output']>;
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly related: Maybe<WithLoomVideo>;
};

export type DeleteObjectivePayload = {
  readonly __typename?: 'DeleteObjectivePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly objectiveType: ObjectiveType;
  readonly recordId: Scalars['String']['output'];
};

export type DeletePeerReviewerInput = {
  readonly currentFeedbackRequestId: Scalars['String']['input'];
  readonly feedbackRequestIds: ReadonlyArray<Scalars['String']['input']>;
};

export type DeleteSkillInput = {
  readonly id: Scalars['String']['input'];
};

export type DeleteTimeEntryChangeRequestPayload = {
  readonly __typename?: 'DeleteTimeEntryChangeRequestPayload';
  readonly recordId: Scalars['String']['output'];
};

export type DeleteTimeEntryPayload = {
  readonly __typename?: 'DeleteTimeEntryPayload';
  readonly recordId: Scalars['String']['output'];
  readonly timeSheet: Maybe<TimeSheet>;
  readonly timeSheetId: Maybe<Scalars['String']['output']>;
};

export type DeleteWorkflowItemLoomVideoInput = {
  readonly id: Scalars['String']['input'];
  readonly loomId: Scalars['String']['input'];
};

export type Department = {
  readonly __typename?: 'Department';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type DevTools = {
  readonly __typename?: 'DevTools';
  readonly performanceDebug: Maybe<Scalars['String']['output']>;
  readonly throwError: Maybe<Scalars['String']['output']>;
};


export type DevToolsThrowErrorArgs = {
  message: InputMaybe<Scalars['String']['input']>;
};

export type DevelopmentFramework = {
  readonly __typename?: 'DevelopmentFramework';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly categories: ReadonlyArray<ObjectiveCategory>;
};

export type DictionaryItem = {
  readonly __typename?: 'DictionaryItem';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Active__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Dictionary__c: Maybe<Scalars['String']['output']>;
  readonly flair__English__c: Maybe<Scalars['String']['output']>;
  readonly flair__French__c: Maybe<Scalars['String']['output']>;
  readonly flair__German__c: Maybe<Scalars['String']['output']>;
  readonly flair__Italian__c: Maybe<Scalars['String']['output']>;
  readonly flair__Key__c: Scalars['String']['output'];
  readonly flair__Norwegian__c: Maybe<Scalars['String']['output']>;
  readonly flair__Russian__c: Maybe<Scalars['String']['output']>;
  readonly flair__Spanish__c: Maybe<Scalars['String']['output']>;
  readonly label: Maybe<Scalars['String']['output']>;
};


export type DictionaryItemLabelArgs = {
  lang: InputMaybe<SupportedLocal>;
};

export enum DictionaryItemType {
  Manufacturer = 'MANUFACTURER',
  OperatingSystem = 'OPERATING_SYSTEM',
  TicketCategory = 'TICKET_CATEGORY',
  TicketSubject = 'TICKET_SUBJECT'
}

export type DismissCheckinsSurveyCycleInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly surveyCycleId: Scalars['String']['input'];
  readonly surveyId: Scalars['String']['input'];
};

export type DismissEnpsSurveyCycleInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly surveyCycleId: Scalars['String']['input'];
  readonly surveyId: Scalars['String']['input'];
};

export type DocumentCategory = {
  readonly __typename?: 'DocumentCategory';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type DocumentMutations = {
  readonly __typename?: 'DocumentMutations';
  readonly createFolder: EmployeeDocumentFolderCreatePayload;
  readonly delete: NavigatablesDeletePayload;
  readonly move: NavigatablesMovePayload;
  readonly rename: NavigatableRenamePayload;
  readonly updateEmployeeDocument: EmployeeDocumentUpdatePayload;
  readonly updateStatus: NavigatableUpdateStatusPayload;
  readonly uploadDocument: UploadDocumentPayload;
  readonly uploadEmployeeDocument: Scalars['String']['output'];
};


export type DocumentMutationsCreateFolderArgs = {
  employeeId: Scalars['String']['input'];
  input: EmployeeDocumentFolderCreateInput;
};


export type DocumentMutationsDeleteArgs = {
  employeeId: Scalars['String']['input'];
  navigatableIds: ReadonlyArray<NavigatableIdInput>;
  recursive: InputMaybe<Scalars['Boolean']['input']>;
};


export type DocumentMutationsMoveArgs = {
  employeeId: Scalars['String']['input'];
  moveTo: MoveToFolderInput;
  navigatableIds: ReadonlyArray<NavigatableIdInput>;
};


export type DocumentMutationsRenameArgs = {
  employeeId: Scalars['String']['input'];
  input: NavigatableRenameInput;
};


export type DocumentMutationsUpdateEmployeeDocumentArgs = {
  employeeId: Scalars['String']['input'];
  input: EmployeeDocumentUpdateInput;
};


export type DocumentMutationsUpdateStatusArgs = {
  employeeId: Scalars['String']['input'];
  input: NavigatableUpdateStatusInput;
};


export type DocumentMutationsUploadDocumentArgs = {
  employeeId: Scalars['String']['input'];
  input: UploadEmployeeDocumentInput;
};


export type DocumentMutationsUploadEmployeeDocumentArgs = {
  input: UploadEmployeeDocumentInput;
};

export enum DocumentStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type DocumentTemplate = {
  readonly __typename?: 'DocumentTemplate';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type DocumentTemplateMutations = {
  readonly __typename?: 'DocumentTemplateMutations';
  readonly getDownloadLink: Scalars['String']['output'];
};


export type DocumentTemplateMutationsGetDownloadLinkArgs = {
  recordId: Scalars['String']['input'];
  requesterType: RequesterType;
  templateId: Scalars['String']['input'];
};

export type DocumentTemplates = {
  readonly __typename?: 'DocumentTemplates';
  readonly documentTemplatesForPR: ReadonlyArray<DocumentTemplate>;
};


export type DocumentTemplatesDocumentTemplatesForPrArgs = {
  feedbackOutcomeId: Scalars['String']['input'];
};

export enum DocumentVisiblity {
  Hr = 'HR',
  HrEmployee = 'HR_EMPLOYEE',
  HrManager = 'HR_MANAGER',
  HrManagerEmployee = 'HR_MANAGER_EMPLOYEE'
}

export type DocumentsFilter = {
  readonly fromDate: Scalars['DateTime']['input'];
  readonly toDate: Scalars['DateTime']['input'];
};

export type DownloadPdfAnalyticInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly outcomeId: Scalars['String']['input'];
  readonly platform: Scalars['String']['input'];
  readonly templateId: Scalars['String']['input'];
  readonly userRole: UserRole;
};

export type DraftExpenseItemInput = {
  readonly flair__Means_Of_Transport__c: InputMaybe<Scalars['String']['input']>;
  readonly recordTypeId: Scalars['String']['input'];
};

export type DurationWithOrigin = {
  readonly __typename?: 'DurationWithOrigin';
  readonly changeRequestIds: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly minutes: Maybe<Scalars['Float']['output']>;
  readonly timeEntryIds: ReadonlyArray<Scalars['String']['output']>;
};

export type Employee = {
  readonly __typename?: 'Employee';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly absenceCategories: ReadonlyArray<EmployeeAbsenceCategory>;
  readonly absences: ReadonlyArray<Absence>;
  readonly additionalCompensations: ReadonlyArray<EmployeeAdditionalCompensation>;
  readonly avatar: Maybe<EmployeeAvatar>;
  readonly currentTimeSheet: Maybe<TimeSheet>;
  readonly currentWorkloads: ReadonlyArray<EmployeeWorkload>;
  readonly data: EmployeeData;
  readonly department: Maybe<Department>;
  readonly employeeCertificates: ReadonlyArray<EmployeeCertificate>;
  readonly employeeHistory: ReadonlyArray<Maybe<EmployeeHistory>>;
  readonly employeeSkills: ReadonlyArray<EmployeeSkillAssociation>;
  readonly feedback: EmployeeFeedback;
  readonly feedbacks: ReadonlyArray<EmployeeFeedback>;
  readonly flair__Active__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Company_Email__c: Maybe<Scalars['String']['output']>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Language__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Of_Probation_Period__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Entity__c: Maybe<Scalars['String']['output']>;
  readonly flair__First_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Hide_My_Birthday__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Last_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Position__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Upcoming_Anniversary__c: Maybe<Scalars['LocalDate']['output']>;
  readonly holidays: ReadonlyArray<Holiday>;
  readonly location: Maybe<Location>;
  readonly managerRolesForEmployee: ReadonlyArray<ManagerRole>;
  readonly oneTimeCompensations: ReadonlyArray<EmployeeOneTimeCompensation>;
  readonly salaries: ReadonlyArray<EmployeeSalary>;
  readonly timeSheets: ReadonlyArray<EmployeeTimeSheet>;
  readonly workloads: ReadonlyArray<EmployeeWorkload>;
};


export type EmployeeAbsencesArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type EmployeeDataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeFeedbackArgs = {
  id: Scalars['String']['input'];
};


export type EmployeeHolidaysArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type EmployeeTimeSheetsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type EmployeeWorkloadsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type EmployeeAbsenceCategory = {
  readonly __typename?: 'EmployeeAbsenceCategory';
  readonly Id: Scalars['String']['output'];
  readonly absenceRequestPolicies: ReadonlyArray<EmployeeAbsenceRequestPolicy>;
  readonly accrualPolicies: ReadonlyArray<EmployeeAccrualPolicy>;
  /** @deprecated use allowances with filter instead */
  readonly allowanceByYear: Maybe<AbsenceAllowance>;
  readonly allowances: ReadonlyArray<AbsenceAllowance>;
  /** @deprecated use yearlySummary or currentYearSummary instead */
  readonly allowancesSummary: AbsenceAllowancesSummary;
  readonly category: AbsenceCategory;
  readonly currentYearSummary: AbsenceYearlySummary;
  readonly flair__Absence_Category__c: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Unlimited__c: Scalars['Boolean']['output'];
  readonly flair__Visibility__c: Scalars['String']['output'];
  readonly yearlySummary: AbsenceYearlySummary;
};


export type EmployeeAbsenceCategoryAllowanceByYearArgs = {
  startOfYearDate: Scalars['LocalDate']['input'];
};


export type EmployeeAbsenceCategoryAllowancesArgs = {
  filter: InputMaybe<AbsenceAllowanceFilter>;
};


export type EmployeeAbsenceCategoryYearlySummaryArgs = {
  today: Scalars['LocalDate']['input'];
  year: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeAbsenceRequestPolicy = {
  readonly __typename?: 'EmployeeAbsenceRequestPolicy';
  readonly Id: Scalars['String']['output'];
  readonly absenceRequestPolicy: AbsenceRequestPolicy;
  readonly flair__Absence_Request_Policy__c: Scalars['String']['output'];
  readonly flair__Employee_Absence_Category__c: Scalars['String']['output'];
};

export type EmployeeAccrualPolicy = {
  readonly __typename?: 'EmployeeAccrualPolicy';
  readonly Id: Scalars['String']['output'];
  readonly accrualPolicy: AccrualPolicy;
  readonly flair__Accrual_Policy__c: Scalars['String']['output'];
  readonly flair__Employee_Absence_Category__c: Scalars['String']['output'];
};

export type EmployeeAdditionalCompensation = {
  readonly __typename?: 'EmployeeAdditionalCompensation';
  readonly CurrencyIsoCode: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Compensation_Type__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Recurring_Period_in_Months__c: Scalars['Int']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
};

export type EmployeeAvatar = {
  readonly __typename?: 'EmployeeAvatar';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly url: Maybe<Scalars['String']['output']>;
  readonly urlLarge: Maybe<Scalars['String']['output']>;
};

export type EmployeeCertificate = Commentable & {
  readonly __typename?: 'EmployeeCertificate';
  readonly ContentDocumentLinks: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly certificate: Maybe<Certificate>;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Maybe<Colleague>;
  readonly flair__Certificate_Link__c: Maybe<Scalars['String']['output']>;
  readonly flair__Certificate__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Expiration_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Issue_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Issued_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Planned_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Status__c: Scalars['String']['output'];
};

export type EmployeeCertificateFileInput = {
  readonly fileContentBase64: Scalars['String']['input'];
  readonly fileName: Scalars['String']['input'];
};

export type EmployeeCertificatePayload = {
  readonly __typename?: 'EmployeeCertificatePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<EmployeeCertificate>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type EmployeeCourse = {
  readonly __typename?: 'EmployeeCourse';
  readonly Id: Scalars['String']['output'];
  readonly course: Maybe<Course>;
  readonly employee: Maybe<Colleague>;
  readonly flair__Complete_Progress__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Completed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Course__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Enrolled_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Total_Seconds__c: Maybe<Scalars['Int']['output']>;
};

export type EmployeeCoursesFilterInput = {
  readonly managerReportsType: ManagerReportsType;
};

export type EmployeeData = {
  readonly __typename?: 'EmployeeData';
  readonly employeeId: Scalars['String']['output'];
  readonly relatedLists: ReadonlyArray<EmployeeDataRelatedList>;
  readonly sections: ReadonlyArray<EmployeeDataSection>;
};

export type EmployeeDataChangeRequest = Commentable & {
  readonly __typename?: 'EmployeeDataChangeRequest';
  readonly ContentDocumentLinks__r: Maybe<ReadonlyArray<ContentDocumentLink>>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Maybe<Colleague>;
  readonly flair__Change_Request_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Changes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Initiated_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Is_Initiated_By_Other_Employee__c: Scalars['Boolean']['output'];
  readonly flair__Object_Action__c: Maybe<EmployeeDataChangeRequestObjectAction>;
  readonly flair__Old_Values__c: Maybe<Scalars['String']['output']>;
  readonly flair__Request_Form__c: Maybe<Scalars['String']['output']>;
  readonly flair__Requested_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Status__c: EmployeeDataChangeRequestStatus;
  readonly initiatedBy: Maybe<Colleague>;
  readonly objectChanges: ObjectChanges;
  readonly requestForm: Maybe<RequestForm>;
};

export type EmployeeDataChangeRequestFilter = {
  readonly status: InputMaybe<EmployeeDataChangeRequestStatus>;
};

export type EmployeeDataChangeRequestManagerFilterInput = {
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<EmployeeDataChangeRequestStatus>;
};

export type EmployeeDataChangeRequestMutations = {
  readonly __typename?: 'EmployeeDataChangeRequestMutations';
  readonly removeRequest: Scalars['Boolean']['output'];
};


export type EmployeeDataChangeRequestMutationsRemoveRequestArgs = {
  id: Scalars['String']['input'];
};

export enum EmployeeDataChangeRequestObjectAction {
  None = 'NONE',
  ObjectCreate = 'OBJECT_CREATE',
  ObjectUpdate = 'OBJECT_UPDATE'
}

export enum EmployeeDataChangeRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type EmployeeDataField = {
  readonly __typename?: 'EmployeeDataField';
  readonly employeeId: Scalars['String']['output'];
  readonly fieldInfo: FieldInfo;
  /** @deprecated Use `fieldInfo.*`. */
  readonly label: Scalars['String']['output'];
  /** @deprecated Use `fieldInfo.*`. */
  readonly locale: Scalars['String']['output'];
  /** @deprecated Use `fieldInfo.*`. */
  readonly name: Scalars['String']['output'];
  readonly oldValue: Maybe<Scalars['String']['output']>;
  readonly parentId: Scalars['String']['output'];
  readonly pendingApproval: Scalars['Boolean']['output'];
  /** @deprecated Use `fieldInfo.*`. */
  readonly picklistValues: ReadonlyArray<EmployeeDataPickListEntry>;
  readonly state: EmployeeDataFieldState;
  /** @deprecated Use `fieldInfo.*`. */
  readonly type: EmployeeDataFieldType;
  readonly value: Maybe<Scalars['String']['output']>;
};

export enum EmployeeDataFieldState {
  Edit = 'EDIT',
  Readonly = 'READONLY',
  Required = 'REQUIRED'
}

export enum EmployeeDataFieldType {
  Address = 'ADDRESS',
  Anytype = 'ANYTYPE',
  Base64 = 'BASE64',
  Boolean = 'BOOLEAN',
  Combobox = 'COMBOBOX',
  Currency = 'CURRENCY',
  Datacategorygroupreference = 'DATACATEGORYGROUPREFERENCE',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Double = 'DOUBLE',
  Email = 'EMAIL',
  Encryptedstring = 'ENCRYPTEDSTRING',
  Id = 'ID',
  Integer = 'INTEGER',
  Long = 'LONG',
  Multipicklist = 'MULTIPICKLIST',
  Percent = 'PERCENT',
  Phone = 'PHONE',
  Picklist = 'PICKLIST',
  Reference = 'REFERENCE',
  String = 'STRING',
  Textarea = 'TEXTAREA',
  Time = 'TIME',
  Url = 'URL'
}

export type EmployeeDataMutations = {
  readonly __typename?: 'EmployeeDataMutations';
  readonly createEmployeeNote: CreateEmployeeNotesPayload;
  readonly deleteEmployeeNote: DeleteEmployeeNotesPayload;
  readonly removeMyAvatar: UpdateMyAvatarPayload;
  readonly updateMyAvatar: UpdateMyAvatarPayload;
  readonly updateMyBirthday: UpdateMyBirthdayPayload;
  readonly updateMyFields: UpdateMyEmployeeDataPayload;
  readonly updateMyLanguage: UpdateMyLanguagePayload;
};


export type EmployeeDataMutationsCreateEmployeeNoteArgs = {
  input: CreateEmployeeNoteInput;
};


export type EmployeeDataMutationsDeleteEmployeeNoteArgs = {
  id: Scalars['String']['input'];
};


export type EmployeeDataMutationsUpdateMyAvatarArgs = {
  input: InputMaybe<UpdateMyAvatarInput>;
};


export type EmployeeDataMutationsUpdateMyBirthdayArgs = {
  hideMyBirthday: Scalars['Boolean']['input'];
};


export type EmployeeDataMutationsUpdateMyFieldsArgs = {
  input: UpdateFieldsInput;
  locale: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeDataMutationsUpdateMyLanguageArgs = {
  language: Scalars['String']['input'];
};

export type EmployeeDataPickListEntry = {
  readonly __typename?: 'EmployeeDataPickListEntry';
  readonly label: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type EmployeeDataRelatedList = {
  readonly __typename?: 'EmployeeDataRelatedList';
  readonly label: Scalars['String']['output'];
  readonly objectType: Scalars['String']['output'];
  readonly records: ReadonlyArray<EmployeeDataRelatedListRecord>;
};

export type EmployeeDataRelatedListRecord = {
  readonly __typename?: 'EmployeeDataRelatedListRecord';
  readonly fields: ReadonlyArray<EmployeeDataField>;
  readonly id: Scalars['String']['output'];
};

export type EmployeeDataSection = {
  readonly __typename?: 'EmployeeDataSection';
  readonly employeeId: Scalars['String']['output'];
  readonly fields: ReadonlyArray<EmployeeDataField>;
  readonly label: Scalars['String']['output'];
};

export type EmployeeDocument = Commentable & Navigatable & {
  readonly __typename?: 'EmployeeDocument';
  readonly ContentDocumentLinks__r: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly approvalRequest: ReadonlyArray<ApprovalRequest>;
  readonly canDelete: Scalars['Boolean']['output'];
  readonly children: ReadonlyArray<Navigatable>;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly createdBy: Maybe<Colleague>;
  readonly documentCategory: DocumentCategory;
  readonly flair__Approval_Status__c: Maybe<Scalars['String']['output']>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Document_Category__c: Scalars['String']['output'];
  readonly flair__Employee1__c: Scalars['String']['output'];
  readonly flair__Employee_Document_Folder__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Note__c: Maybe<Scalars['String']['output']>;
  readonly flair__Self_Uploaded__c: Scalars['Boolean']['output'];
  readonly flair__Visibility__c: DocumentVisiblity;
  readonly fullPath: Scalars['String']['output'];
  readonly navigatableType: NavigatableType;
  readonly parentFolder: Maybe<EmployeeDocumentFolder>;
  readonly parentFolderId: Maybe<Scalars['String']['output']>;
  readonly parents: Maybe<ReadonlyArray<Navigatable>>;
};

export type EmployeeDocumentFolder = Navigatable & {
  readonly __typename?: 'EmployeeDocumentFolder';
  readonly CreatedById: Scalars['String']['output'];
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly children: ReadonlyArray<Navigatable>;
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Parent_Folder__c: Maybe<Scalars['String']['output']>;
  readonly fullPath: Scalars['String']['output'];
  readonly navigatableType: NavigatableType;
  readonly parentFolder: Maybe<EmployeeDocumentFolder>;
  readonly parentFolderId: Maybe<Scalars['String']['output']>;
  readonly parents: Maybe<ReadonlyArray<Navigatable>>;
};

export type EmployeeDocumentFolderCreateInput = {
  readonly name: Scalars['String']['input'];
  readonly parentFolderId: Scalars['String']['input'];
};

export type EmployeeDocumentFolderCreatePayload = {
  readonly __typename?: 'EmployeeDocumentFolderCreatePayload';
  readonly errorCode: Maybe<NavigatableErrorCode>;
  readonly record: Maybe<EmployeeDocumentFolder>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type EmployeeDocumentUpdateInput = {
  readonly category: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly note: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeDocumentUpdatePayload = {
  readonly __typename?: 'EmployeeDocumentUpdatePayload';
  readonly record: EmployeeDocument;
  readonly recordId: Scalars['String']['output'];
};

export type EmployeeDocumentsFilter = {
  readonly created: InputMaybe<DateTimeRangeInput>;
  readonly folderId: InputMaybe<Scalars['String']['input']>;
  readonly searchTerm: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeEvaluation = {
  readonly __typename?: 'EmployeeEvaluation';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly answers: Maybe<ReadonlyArray<EvaluationAnswer>>;
  readonly employee: Colleague;
  readonly evaluationTemplate: Maybe<EvaluationTemplate>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Evaluated__c: Scalars['Boolean']['output'];
  readonly flair__Evaluation_Template__c: Scalars['String']['output'];
  readonly flair__Evaluator__c: Scalars['String']['output'];
  readonly flair__Final_Score__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Overall_Comment__c: Maybe<Scalars['String']['output']>;
  readonly workflowItem: Maybe<WorkflowItem>;
};

export type EmployeeFeedback = {
  readonly __typename?: 'EmployeeFeedback';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly answers: ReadonlyArray<EmployeeFeedbackAnswer>;
  readonly employeeFeedback: Maybe<EmployeeFeedback>;
  readonly feedbackCycle: FeedbackCycle;
  readonly flair__Deadline__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Feedback_Cycle__c: Scalars['String']['output'];
  readonly flair__Employee_Feedback_Outcome__c: Scalars['String']['output'];
  readonly flair__Feedback_About__c: Scalars['String']['output'];
  readonly flair__Feedback_From__c: Scalars['String']['output'];
  readonly flair__Is_Peer_Reviewer__c: Scalars['Boolean']['output'];
  readonly flair__Progress__c: Scalars['Int']['output'];
  readonly flair__Self_Evaluation__c: Scalars['Boolean']['output'];
  readonly flair__State__c: EmployeeFeedbackState;
  readonly flair__Submitted_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly hasFilledAnswers: Scalars['Boolean']['output'];
  readonly managerFeedback: Maybe<EmployeeFeedback>;
  readonly outcome: EmployeeFeedbackOutcome;
  readonly peerFeedbacks: ReadonlyArray<EmployeeFeedback>;
  readonly reviewee: EmployeeFeedbackParticipant;
  readonly reviewer: EmployeeFeedbackParticipant;
};

export type EmployeeFeedbackAnswer = {
  readonly __typename?: 'EmployeeFeedbackAnswer';
  readonly Id: Scalars['String']['output'];
  readonly feedbackAnswer: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Feedback_Question__c: Scalars['String']['output'];
  readonly flair__Employee_Feedback_Request__c: Scalars['String']['output'];
  readonly flair__Feedback__c: Maybe<Scalars['String']['output']>;
  readonly flair__Note__c: Maybe<Scalars['String']['output']>;
  readonly question: FeedbackQuestion;
};

export type EmployeeFeedbackMutations = {
  readonly __typename?: 'EmployeeFeedbackMutations';
  readonly createPeerReviewers: PeerReviewerPayload;
  readonly deletePeerReviewers: PeerReviewerPayload;
};


export type EmployeeFeedbackMutationsCreatePeerReviewersArgs = {
  input: CreatePeerReviewerInput;
};


export type EmployeeFeedbackMutationsDeletePeerReviewersArgs = {
  input: DeletePeerReviewerInput;
};

export type EmployeeFeedbackOutcome = {
  readonly __typename?: 'EmployeeFeedbackOutcome';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  /** @deprecated goals now on sidebar */
  readonly finishedObjectives: ReadonlyArray<EmployeeObjective>;
  readonly flair__Accepted_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Completed__c: Scalars['Boolean']['output'];
  readonly flair__Employee_1_On_1_Meeting__c: Scalars['String']['output'];
  readonly flair__Employee_Feedback_Participant__c: Scalars['String']['output'];
  readonly flair__Ended_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Feedback_About__c: Maybe<Scalars['String']['output']>;
  readonly flair__Feedback_Cycle__c: Scalars['String']['output'];
  readonly flair__Feedback_From__c: Scalars['String']['output'];
  readonly meeting: Maybe<EmployeeMeeting>;
  /** @deprecated goals now on sidebar */
  readonly objectives: ReadonlyArray<EmployeeObjective>;
  /** @deprecated goals now on sidebar */
  readonly openObjectives: ReadonlyArray<EmployeeObjective>;
  readonly resolutions: ReadonlyArray<EmployeeFeedbackResolution>;
  readonly reviewer: Employee;
};

export type EmployeeFeedbackParticipant = {
  readonly __typename?: 'EmployeeFeedbackParticipant';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly avatar: Maybe<EmployeeAvatar>;
  readonly department: Maybe<Department>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Position__c: Maybe<Scalars['String']['output']>;
};

export type EmployeeFeedbackResolution = {
  readonly __typename?: 'EmployeeFeedbackResolution';
  readonly Id: Scalars['String']['output'];
  readonly flair__Employee_Feedback_Question__c: Scalars['String']['output'];
  readonly flair__Resolution__c: Maybe<Scalars['String']['output']>;
  readonly question: FeedbackQuestion;
};

export enum EmployeeFeedbackState {
  Draft = 'Draft',
  Submitted = 'Submitted',
  Unknown = 'Unknown'
}

export type EmployeeFilterInput = {
  readonly managerReportsType: ManagerReportsType;
};

export type EmployeeHistory = {
  readonly __typename?: 'EmployeeHistory';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__New_Value__c: Maybe<Scalars['String']['output']>;
  readonly flair__Old_Value__c: Maybe<Scalars['String']['output']>;
};

export type EmployeeHubFeature = {
  readonly __typename?: 'EmployeeHubFeature';
  readonly Id: Scalars['String']['output'];
  readonly flair__Customise_Dashboard_Main_Slider__c: Maybe<Scalars['String']['output']>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Entity__c: Maybe<Scalars['String']['output']>;
  readonly flair__Hide_Absences__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Anniversaries__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Announcements__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Assessments__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Certificates__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Cheers__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Corporate_Documents__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Directory__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Employee_Bank_Details__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Employee_Salaries__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Employee_Workload_Details__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Expenses__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Goals__c: Scalars['Boolean']['output'];
  readonly flair__Hide_HR_HelpDesk__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Home_Absent_Today__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Home_Birthdays_Card__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Home_New_Hires_Card__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Inventory__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Org_Chart__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Personal_Data__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Personal_Documents__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Private_Notes__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Projects__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Public_Holidays__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Recruiting__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Shift_Planner__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Skills__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Surveys__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Time_Tracking__c: Scalars['Boolean']['output'];
  readonly flair__Hide_Workflows__c: Scalars['Boolean']['output'];
  readonly flair__IsGlobal__c: Scalars['Boolean']['output'];
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
};

export type EmployeeHubFeatureMutations = {
  readonly __typename?: 'EmployeeHubFeatureMutations';
  readonly updateSliderSettings: SliderSettingsPayload;
};


export type EmployeeHubFeatureMutationsUpdateSliderSettingsArgs = {
  input: UpdateSliderSettingsInput;
};

export type EmployeeMeeting = {
  readonly __typename?: 'EmployeeMeeting';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Start_Datetime__c: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeNotificationSetting = {
  readonly __typename?: 'EmployeeNotificationSetting';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__ApprovedAbsence_Email__c: Scalars['Boolean']['output'];
  readonly flair__ApprovedAbsence_Push__c: Scalars['Boolean']['output'];
  readonly flair__ApprovedAbsence_Slack__c: Scalars['Boolean']['output'];
  readonly flair__CandidateEvaluated_Email__c: Scalars['Boolean']['output'];
  readonly flair__CandidateEvaluation_Email__c: Scalars['Boolean']['output'];
  readonly flair__CelebrationReceived_Email__c: Scalars['Boolean']['output'];
  readonly flair__CelebrationReceived_Slack__c: Scalars['Boolean']['output'];
  readonly flair__CommentCreated_Email__c: Scalars['Boolean']['output'];
  readonly flair__CommentCreated_Slack__c: Scalars['Boolean']['output'];
  readonly flair__DeletedAbsence_Email__c: Scalars['Boolean']['output'];
  readonly flair__DeletedAbsence_Push__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeDataChanges_Email__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeDataChanges_Push__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeFeedbackNotification_Email__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeFeedbackNotification_Push__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeShiftsPublished_Email__c: Scalars['Boolean']['output'];
  /** @deprecated flair__TimesheetOverview_Email__c is not used anymore */
  readonly flair__EmployeeShiftsPublished_Push__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeUpload_Email__c: Scalars['Boolean']['output'];
  readonly flair__EmployeeUpload_Push__c: Scalars['Boolean']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__ExpiringWorkflowItems_Email__c: Scalars['Boolean']['output'];
  readonly flair__ExpiringWorkflowItems_Slack__c: Scalars['Boolean']['output'];
  readonly flair__FC_EmployeeReviewSubmitted_Email__c: Scalars['Boolean']['output'];
  readonly flair__FC_ReviewerReviewSubmitted_Email__c: Scalars['Boolean']['output'];
  readonly flair__InformHiringManager_Email__c: Scalars['Boolean']['output'];
  readonly flair__NewAbsenceApprovalRequest_Email__c: Scalars['Boolean']['output'];
  readonly flair__NewAbsenceApprovalRequest_Push__c: Scalars['Boolean']['output'];
  readonly flair__NewAbsenceApprovalRequest_Slack__c: Scalars['Boolean']['output'];
  readonly flair__NewAbsence_Email__c: Scalars['Boolean']['output'];
  readonly flair__NewEmployeeDocument_Email__c: Scalars['Boolean']['output'];
  readonly flair__NewEmployeeDocument_Push__c: Scalars['Boolean']['output'];
  readonly flair__NewTimeEntryChangeRequest_Email__c: Scalars['Boolean']['output'];
  readonly flair__OpenShiftRequestCreated_Email__c: Scalars['Boolean']['output'];
  readonly flair__OpenShiftRequestCreated_Push__c: Scalars['Boolean']['output'];
  readonly flair__OpenShiftRequest_Email__c: Scalars['Boolean']['output'];
  readonly flair__OpenShiftRequest_Push__c: Scalars['Boolean']['output'];
  readonly flair__OpenShiftsPublished_Email__c: Scalars['Boolean']['output'];
  readonly flair__OpenShiftsPublished_Push__c: Scalars['Boolean']['output'];
  readonly flair__PendingWorkflowItems_Email__c: Scalars['Boolean']['output'];
  readonly flair__PendingWorkflowItems_Slack__c: Scalars['Boolean']['output'];
  readonly flair__PfReviewMeetingAttendee_Email__c: Scalars['Boolean']['output'];
  readonly flair__PfReviewMeetingOrganizer_Email__c: Scalars['Boolean']['output'];
  readonly flair__RejectedAbsence_Email__c: Scalars['Boolean']['output'];
  readonly flair__RejectedAbsence_Push__c: Scalars['Boolean']['output'];
  readonly flair__RejectedAbsence_Slack__c: Scalars['Boolean']['output'];
  readonly flair__TicketAssigned_Email__c: Scalars['Boolean']['output'];
  readonly flair__TicketClosed_Email__c: Scalars['Boolean']['output'];
  readonly flair__TicketShared_Email__c: Scalars['Boolean']['output'];
  readonly flair__TicketStatusChanged_Email__c: Scalars['Boolean']['output'];
  readonly flair__TicketSubmitted_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimeBalanceWithdrawalCreated_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimeEntryAdded_Slack__c: Scalars['Boolean']['output'];
  readonly flair__TimeEntryChangesApproved_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimeEntryChangesApproved_Slack__c: Scalars['Boolean']['output'];
  readonly flair__TimeEntryChangesRejected_Slack__c: Scalars['Boolean']['output'];
  readonly flair__TimeEntryDeleted_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimeEntryDeleted_Slack__c: Scalars['Boolean']['output'];
  readonly flair__TimeTrackingAutoClockOutManager_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimeTrackingAutoClockOut_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimesheetApproved_Slack__c: Scalars['Boolean']['output'];
  readonly flair__TimesheetOverview_Email__c: Scalars['Boolean']['output'];
  readonly flair__TimesheetPendingWeekly_Slack__c: Scalars['Boolean']['output'];
};

export type EmployeeNotificationSettingsInput = {
  readonly Id: Scalars['String']['input'];
  readonly flair__ApprovedAbsence_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__ApprovedAbsence_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__ApprovedAbsence_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__CandidateEvaluated_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__CandidateEvaluation_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__CelebrationReceived_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__CelebrationReceived_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__CommentCreated_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__CommentCreated_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__DeletedAbsence_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__DeletedAbsence_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeDataChanges_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeDataChanges_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeFeedbackNotification_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeFeedbackNotification_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeShiftsPublished_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeShiftsPublished_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeUpload_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__EmployeeUpload_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__ExpiringWorkflowItems_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__ExpiringWorkflowItems_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__FC_EmployeeReviewSubmitted_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__FC_ReviewerReviewSubmitted_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__InformHiringManager_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewAbsenceApprovalRequest_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewAbsenceApprovalRequest_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewAbsenceApprovalRequest_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewAbsence_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewEmployeeDocument_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewEmployeeDocument_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__NewTimeEntryChangeRequest_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__OpenShiftRequestCreated_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__OpenShiftRequestCreated_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__OpenShiftRequest_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__OpenShiftRequest_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__OpenShiftsPublished_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__OpenShiftsPublished_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__PendingWorkflowItems_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__PendingWorkflowItems_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__PfReviewMeetingAttendee_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__PfReviewMeetingOrganizer_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__RejectedAbsence_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__RejectedAbsence_Push__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__RejectedAbsence_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TicketAssigned_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TicketClosed_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TicketShared_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TicketStatusChanged_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TicketSubmitted_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeBalanceWithdrawalCreated_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeEntryAdded_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeEntryChangesApproved_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeEntryChangesApproved_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeEntryChangesRejected_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeEntryDeleted_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeEntryDeleted_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeTrackingAutoClockOutManager_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimeTrackingAutoClockOut_Email__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimesheetApproved_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__TimesheetPendingWeekly_Slack__c: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeObjective = Objective & {
  readonly __typename?: 'EmployeeObjective';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly allHistoryItems: ReadonlyArray<ObjectiveHistoryItemCommon>;
  readonly allParents: ReadonlyArray<Objective>;
  readonly category: Maybe<ObjectiveCategory>;
  readonly childrenObjectives: ReadonlyArray<EmployeeObjective>;
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Change_Requested_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Company_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Current_Status__c: ObjectiveCurrentStatusType;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Due_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Employee_Feedback_Outcome__c: Maybe<Scalars['String']['output']>;
  readonly flair__Expected_Progress__c: Scalars['Float']['output'];
  readonly flair__Finished_Feedback_Outcome__c: Maybe<Scalars['String']['output']>;
  readonly flair__Is_Draft__c: Scalars['Boolean']['output'];
  readonly flair__Manual_Progress__c: Scalars['Boolean']['output'];
  readonly flair__Objective_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__Objective_Time_Period__c: Maybe<Scalars['String']['output']>;
  readonly flair__On_Track__c: Scalars['Boolean']['output'];
  readonly flair__Owner__c: Maybe<Scalars['String']['output']>;
  readonly flair__Parent__c: Maybe<Scalars['String']['output']>;
  readonly flair__Progress__c: Scalars['Float']['output'];
  readonly flair__RateAt__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__RateBy__c: Maybe<Scalars['String']['output']>;
  readonly flair__Rate_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Rate__c: Maybe<EmployeeObjectiveRateType>;
  readonly flair__Responsible__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Status_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: ObjectiveStatusType;
  readonly flair__Team_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Visibility__c: ObjectiveVisibility;
  /** @deprecated use allHistoryItems */
  readonly historyItems: ReadonlyArray<ObjectiveHistoryItem>;
  readonly keyResultUpdates: ReadonlyArray<ObjectiveKeyResultUpdate>;
  readonly keyResults: ReadonlyArray<ObjectiveKeyResult>;
  readonly owner: Maybe<Colleague>;
  /** @deprecated use parentObjective */
  readonly parent: Maybe<EmployeeObjective>;
  readonly parentObjective: Maybe<Objective>;
  readonly period: Maybe<ObjectiveTimePeriod>;
  readonly rateBy: Maybe<Colleague>;
  readonly responsible: Maybe<Colleague>;
  readonly sharedWith: ReadonlyArray<Colleague>;
  readonly statusChangedBy: Maybe<Colleague>;
  readonly tags: ReadonlyArray<Tag>;
};

export enum EmployeeObjectiveRateType {
  Exceeded = 'EXCEEDED',
  Fulfilled = 'FULFILLED',
  NotFulfilled = 'NOT_FULFILLED',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type EmployeeOneTimeCompensation = {
  readonly __typename?: 'EmployeeOneTimeCompensation';
  readonly CurrencyIsoCode: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Compensation_Date__c: Scalars['String']['output'];
  readonly flair__Compensation_Type__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: Scalars['String']['output'];
};

export type EmployeeOvertimeReport = {
  readonly __typename?: 'EmployeeOvertimeReport';
  readonly employeeId: Scalars['String']['output'];
  readonly employeeName: Scalars['String']['output'];
  readonly totalOvertime: Scalars['Float']['output'];
};

export type EmployeeSalary = {
  readonly __typename?: 'EmployeeSalary';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly CurrencyIsoCode: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Employee1__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Formula_Status__c: Scalars['String']['output'];
  readonly flair__Salary_Type__c: SalaryType;
  readonly flair__Start_Date__c: Scalars['String']['output'];
};

export enum EmployeeScopeFilter {
  AllCompany = 'ALL_COMPANY',
  MyTeam = 'MY_TEAM'
}

export type EmployeeSegment = {
  readonly __typename?: 'EmployeeSegment';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Record_Id__c: Scalars['String']['output'];
};

export type EmployeeShift = {
  readonly __typename?: 'EmployeeShift';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly breaks: ReadonlyArray<ShiftBreak>;
  readonly employee: Employee;
  readonly flair__Employee_Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Location__c: Scalars['String']['output'];
  readonly flair__Open_Shift__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Total_Break_Period_in_Minutes__c: Scalars['Int']['output'];
  readonly location: Maybe<Location>;
  readonly shiftLabels: ReadonlyArray<ShiftLabel>;
};

export type EmployeeShiftLabelAssociation = {
  readonly __typename?: 'EmployeeShiftLabelAssociation';
  readonly Id: Scalars['String']['output'];
  readonly flair__Employee_Shift__c: Scalars['String']['output'];
  readonly flair__Shift_Label__c: Scalars['String']['output'];
};

export type EmployeeSkillAssociation = {
  readonly __typename?: 'EmployeeSkillAssociation';
  readonly Id: Scalars['String']['output'];
  readonly employee: Colleague;
  readonly flair__Change_Requested_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Rate__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Skill__c: Scalars['String']['output'];
  readonly flair__Top__c: Scalars['Boolean']['output'];
  readonly skill: Skill;
};

export type EmployeeSkillMutations = {
  readonly __typename?: 'EmployeeSkillMutations';
  readonly addSkill: UpdateEmployeeSkillPayload;
  readonly removeSkill: UpdateEmployeeSkillPayload;
  readonly updateSkillRate: UpdateEmployeeSkillPayload;
  readonly updateSkillTop: UpdateEmployeeSkillPayload;
};


export type EmployeeSkillMutationsAddSkillArgs = {
  input: AddSkillToEmployeeInput;
};


export type EmployeeSkillMutationsRemoveSkillArgs = {
  input: RemoveSkillFromEmployeeInput;
};


export type EmployeeSkillMutationsUpdateSkillRateArgs = {
  input: UpdateSkillRateInput;
};


export type EmployeeSkillMutationsUpdateSkillTopArgs = {
  input: UpdateSkillTopInput;
};

export type EmployeeSlackConnection = {
  readonly __typename?: 'EmployeeSlackConnection';
  readonly employeeId: Scalars['String']['output'];
  readonly slackStatusAutoUpdate: Scalars['Boolean']['output'];
  readonly slackUserId: Scalars['String']['output'];
  readonly userScopes: ReadonlyArray<Scalars['String']['output']>;
};

export type EmployeeTimeSheet = {
  readonly __typename?: 'EmployeeTimeSheet';
  readonly Id: Scalars['String']['output'];
  readonly flair__Absence_Hours__c: Scalars['Float']['output'];
  readonly flair__Approval_Status__c: TimeSheetStatus;
  readonly flair__Current_Compensatory_Time_Level_1__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Current_Compensatory_Time_Level_2__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__Given_Compensatory_Time_Level_1__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Given_Compensatory_Time_Level_2__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Holiday_Hours__c: Scalars['Float']['output'];
  readonly flair__Non_Deductible_Absence_Hours__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Project_Time_Entries_Minutes__c: Scalars['Float']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Target_Hours__c: Scalars['Float']['output'];
  readonly flair__Time_Entry_Hours__c: Scalars['Float']['output'];
  readonly timeEntries: ReadonlyArray<TimeEntry>;
  readonly trackedTime: TimesheetTrackedTime;
  readonly workloads: ReadonlyArray<EmployeeWorkload>;
};

export type EmployeeTimeSheetFilterInput = {
  readonly month: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<TimeSheetStatus>;
  readonly year: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeTokenResponse = {
  readonly __typename?: 'EmployeeTokenResponse';
  readonly authorizationCode: Maybe<Scalars['String']['output']>;
  readonly error: Maybe<EmployeeTokenResponseErrorCode>;
};

export enum EmployeeTokenResponseErrorCode {
  AccessDenied = 'AccessDenied',
  EmployeeDoNotAllowSupportAccess = 'EmployeeDoNotAllowSupportAccess',
  EmployeeNotFound = 'EmployeeNotFound'
}

export type EmployeeTurnoverRateFilter = {
  readonly endDate: Scalars['LocalDate']['input'];
  readonly startDate: Scalars['LocalDate']['input'];
};

export type EmployeeTurnoverRateReportMonth = {
  readonly __typename?: 'EmployeeTurnoverRateReportMonth';
  readonly monthDate: Scalars['DateTime']['output'];
  readonly turnoverRate: Scalars['Float']['output'];
};

export type EmployeeTurnoverRateReportPayload = {
  readonly __typename?: 'EmployeeTurnoverRateReportPayload';
  readonly monthlyResults: ReadonlyArray<EmployeeTurnoverRateReportMonth>;
  readonly overallTurnoverRate: Scalars['Float']['output'];
};

export type EmployeeWorkload = {
  readonly __typename?: 'EmployeeWorkload';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Hours_Per_Day__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Hours__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Public_Holiday__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Time_Framework__c: Maybe<Scalars['String']['output']>;
  readonly flair__Time_Tracking_Type__c: WorkloadTrackingType;
  readonly flair__Type__c: WorkloadType;
  readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>;
  readonly flair__Workload_Model__c: WorkloadModel;
  readonly timeFramework: Maybe<TimeFramework>;
  readonly workloadWeeks: ReadonlyArray<WorkloadWeek>;
};

export type Employment = {
  readonly __typename?: 'Employment';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employee: Employee;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Is_Future_Employment__c: Scalars['Boolean']['output'];
  readonly flair__Main__c: Scalars['Boolean']['output'];
  readonly flair__Position__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly position: Maybe<Position>;
};

export type EngagementSurvey = {
  readonly __typename?: 'EngagementSurvey';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly deadlineOver: Scalars['Boolean']['output'];
  readonly flair__Deadline__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Is_Anonymous__c: Scalars['Boolean']['output'];
  readonly flair__Is_Compulsory__c: Scalars['Boolean']['output'];
  readonly flair__Long_Introduction__c: Maybe<Scalars['String']['output']>;
  readonly flair__Rating_Max__c: Scalars['Int']['output'];
  readonly flair__Rating_Min__c: Scalars['Int']['output'];
  readonly flair__State__c: EngagementSurveyState;
  readonly questions: ReadonlyArray<EngagementSurveyQuestion>;
  readonly responses: ReadonlyArray<EngagementSurveyEmployeeResponse>;
  readonly sections: ReadonlyArray<EngagementSurveySection>;
};

export type EngagementSurveyAnswerOption = {
  readonly __typename?: 'EngagementSurveyAnswerOption';
  readonly Id: Scalars['String']['output'];
  readonly answer: EngagementSurveyQuestionAnswer;
  readonly flair__Engagement_Survey_Employee_Response__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey_Question_Answer__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey_Question_Option__c: Scalars['String']['output'];
  readonly flair__Value__c: Maybe<Scalars['Int']['output']>;
  readonly option: EngagementSurveyQuestionOption;
  readonly response: EngagementSurveyEmployeeResponse;
};

export type EngagementSurveyDto = {
  readonly __typename?: 'EngagementSurveyDto';
  readonly compulsory: Scalars['Boolean']['output'];
  readonly createdOn: Scalars['DateTime']['output'];
  readonly deadline: Maybe<Scalars['LocalDate']['output']>;
  readonly dismissedAt: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly submittedAt: Maybe<Scalars['DateTime']['output']>;
};

export type EngagementSurveyEmployeeResponse = {
  readonly __typename?: 'EngagementSurveyEmployeeResponse';
  readonly Id: Scalars['String']['output'];
  readonly engagementSurvey: EngagementSurvey;
  readonly flair__Dismissed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey__c: Scalars['String']['output'];
  readonly flair__Submitted_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly questionsAnswers: ReadonlyArray<EngagementSurveyQuestionAnswer>;
};

export type EngagementSurveyEmployeeResponsePayload = {
  readonly __typename?: 'EngagementSurveyEmployeeResponsePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<EngagementSurveyEmployeeResponse>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type EngagementSurveyQuestion = {
  readonly __typename?: 'EngagementSurveyQuestion';
  readonly Id: Scalars['String']['output'];
  readonly flair__Can_comment__c: Scalars['Boolean']['output'];
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Engagement_Survey_Section__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey__c: Scalars['String']['output'];
  readonly flair__Hint__c: Maybe<Scalars['String']['output']>;
  readonly flair__Is_Optional__c: Scalars['Boolean']['output'];
  readonly flair__Order__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Question_Text__c: Scalars['String']['output'];
  readonly flair__Type__c: QuestionnaireType;
  readonly options: ReadonlyArray<EngagementSurveyQuestionOption>;
};

export type EngagementSurveyQuestionAnswer = {
  readonly __typename?: 'EngagementSurveyQuestionAnswer';
  readonly Id: Scalars['String']['output'];
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey_Employee_Response__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey_Question__c: Scalars['String']['output'];
  readonly flair__Engagement_Survey__c: Scalars['String']['output'];
  readonly flair__Free_Text__c: Maybe<Scalars['String']['output']>;
  readonly flair__Score__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Upserting_Key__c: Scalars['String']['output'];
  readonly question: EngagementSurveyQuestion;
  readonly response: EngagementSurveyEmployeeResponse;
  readonly selectedOptions: ReadonlyArray<EngagementSurveyAnswerOption>;
};

export type EngagementSurveyQuestionAnswerPayload = {
  readonly __typename?: 'EngagementSurveyQuestionAnswerPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<EngagementSurveyQuestionAnswer>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type EngagementSurveyQuestionOption = {
  readonly __typename?: 'EngagementSurveyQuestionOption';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Engagement_Survey_Question__c: Scalars['String']['output'];
  readonly flair__Order__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Required__c: Scalars['Boolean']['output'];
};

export type EngagementSurveySection = {
  readonly __typename?: 'EngagementSurveySection';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Engagement_Survey__c: Scalars['String']['output'];
  readonly questions: ReadonlyArray<EngagementSurveyQuestion>;
};

export enum EngagementSurveyState {
  Closed = 'CLOSED',
  Paused = 'PAUSED',
  Setup = 'SETUP',
  Started = 'STARTED',
  Unknown = 'UNKNOWN'
}

export type EngagementSurveysMutations = {
  readonly __typename?: 'EngagementSurveysMutations';
  readonly answerEngagementSurveyQuestion: EngagementSurveyQuestionAnswerPayload;
  readonly dismissEngagementSurveyEmployeeResponse: EngagementSurveyEmployeeResponsePayload;
  readonly submitEngagementSurveyEmployeeResponse: EngagementSurveyEmployeeResponsePayload;
};


export type EngagementSurveysMutationsAnswerEngagementSurveyQuestionArgs = {
  input: UpdateEngagementSurveyAnswerInput;
};


export type EngagementSurveysMutationsDismissEngagementSurveyEmployeeResponseArgs = {
  input: SubmitEngagementSurveyInput;
};


export type EngagementSurveysMutationsSubmitEngagementSurveyEmployeeResponseArgs = {
  input: SubmitEngagementSurveyInput;
};

export type EnpsSurvey = {
  readonly __typename?: 'EnpsSurvey';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly cycles: ReadonlyArray<EnpsSurveyCycle>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Allow_comments__c: Scalars['Boolean']['output'];
  readonly flair__Compulsory__c: Scalars['Boolean']['output'];
  readonly flair__Default_Language__c: Scalars['String']['output'];
  readonly flair__Message_Body__c: Scalars['String']['output'];
  readonly flair__Question_Text__c: Scalars['String']['output'];
};

export type EnpsSurveyAnswer = {
  readonly __typename?: 'EnpsSurveyAnswer';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Dismissed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Score__c: Maybe<Scalars['Int']['output']>;
  readonly flair__eNPS_Survey_Cycle__c: Scalars['String']['output'];
  readonly flair__eNPS_Survey__c: Scalars['String']['output'];
};

export type EnpsSurveyCycle = {
  readonly __typename?: 'EnpsSurveyCycle';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__End_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Start_Date__c: Scalars['LocalDate']['output'];
  readonly flair__eNPS_Survey__c: Scalars['String']['output'];
};

export type EnpsSurveyCycleDto = {
  readonly __typename?: 'EnpsSurveyCycleDto';
  readonly endDate: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['String']['output'];
  readonly startDate: Scalars['LocalDate']['output'];
};

export type EnpsSurveyDto = {
  readonly __typename?: 'EnpsSurveyDto';
  readonly active: Scalars['Boolean']['output'];
  readonly allowComments: Scalars['Boolean']['output'];
  readonly compulsory: Scalars['Boolean']['output'];
  readonly createdOn: Scalars['DateTime']['output'];
  readonly cycles: ReadonlyArray<EnpsSurveyCycleDto>;
  readonly defaultLanguage: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly messageBodyText: Scalars['String']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly questionText: Scalars['String']['output'];
};

export type EnpsSurveyMutations = {
  readonly __typename?: 'EnpsSurveyMutations';
  readonly answerEnpsSurveyCycle: EnpsSurveyPayload;
  readonly dismissEnpsSurveyCycle: EnpsSurveyPayload;
};


export type EnpsSurveyMutationsAnswerEnpsSurveyCycleArgs = {
  input: AnswerEnpsSurveyCycleInput;
};


export type EnpsSurveyMutationsDismissEnpsSurveyCycleArgs = {
  input: DismissEnpsSurveyCycleInput;
};

export type EnpsSurveyPayload = {
  readonly __typename?: 'EnpsSurveyPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type EvaluationAnswer = {
  readonly __typename?: 'EvaluationAnswer';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Answer__c: Maybe<Scalars['String']['output']>;
  readonly flair__Candidate_Evaluation__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Evaluation__c: Maybe<Scalars['String']['output']>;
  readonly flair__Evaluation_Template_Option__c: Maybe<Scalars['String']['output']>;
  readonly flair__Evaluation_Template_Question__c: Maybe<Scalars['String']['output']>;
  readonly flair__Question_Type__c: EvaluationTemplateQuestionType;
  readonly flair__Score__c: Maybe<Scalars['Int']['output']>;
};

export type EvaluationMutations = {
  readonly __typename?: 'EvaluationMutations';
  readonly createCandidateEvaluation: UpdateCandidateEvaluationPayload;
  readonly deleteEvaluationAnswer: Maybe<ReadonlyArray<DeleteEvaluationAnswerPayload>>;
  readonly saveCandidateEvaluation: UpdateCandidateEvaluationPayload;
  readonly saveEmployeeEvaluation: UpdateEmployeeEvaluationPayload;
  readonly saveEvaluationAnswer: SaveEvaluationAnswerPayload;
  readonly skipEmployeeEvaluation: UpdateCandidateEvaluationPayload;
};


export type EvaluationMutationsCreateCandidateEvaluationArgs = {
  input: CreateCandidateEvaluationInput;
};


export type EvaluationMutationsDeleteEvaluationAnswerArgs = {
  ids: ReadonlyArray<Scalars['String']['input']>;
};


export type EvaluationMutationsSaveCandidateEvaluationArgs = {
  input: SaveCandidateEvaluationInput;
};


export type EvaluationMutationsSaveEmployeeEvaluationArgs = {
  input: SaveEmployeeEvaluationInput;
};


export type EvaluationMutationsSaveEvaluationAnswerArgs = {
  input: SaveEvaluationAnswerInput;
};


export type EvaluationMutationsSkipEmployeeEvaluationArgs = {
  evaluationId: Scalars['String']['input'];
};

export type EvaluationTemplate = {
  readonly __typename?: 'EvaluationTemplate';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Rating_Max__c: Scalars['Int']['output'];
  readonly flair__Rating_Min__c: Scalars['Int']['output'];
  readonly questions: ReadonlyArray<EvaluationTemplateQuestion>;
};

export type EvaluationTemplateAnswer = {
  readonly __typename?: 'EvaluationTemplateAnswer';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Answer__c: Maybe<Scalars['String']['output']>;
  readonly flair__Candidate_Evaluation__c: Maybe<Scalars['String']['output']>;
  readonly flair__Evaluation_Template_Option__c: Maybe<Scalars['String']['output']>;
  readonly flair__Evaluation_Template_Question__c: Scalars['String']['output'];
  readonly flair__Question_Type__c: EvaluationTemplateQuestionType;
  readonly flair__Score__c: Maybe<Scalars['Int']['output']>;
};

export type EvaluationTemplateOption = {
  readonly __typename?: 'EvaluationTemplateOption';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Hint__c: Maybe<Scalars['String']['output']>;
  readonly flair__Required__c: Scalars['Boolean']['output'];
};

export type EvaluationTemplateQuestion = {
  readonly __typename?: 'EvaluationTemplateQuestion';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Hint__c: Maybe<Scalars['String']['output']>;
  readonly flair__Name__c: Scalars['String']['output'];
  readonly flair__Question_Type__c: EvaluationTemplateQuestionType;
  readonly flair__Required__c: Scalars['Boolean']['output'];
  readonly flair__Sequence__c: Scalars['Int']['output'];
  readonly options: ReadonlyArray<EvaluationTemplateOption>;
};

export enum EvaluationTemplateQuestionType {
  FreeSlider = 'FREE_SLIDER',
  FreeText = 'FREE_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Rating = 'RATING',
  Scorecard = 'SCORECARD',
  SingleChoice = 'SINGLE_CHOICE',
  Unknown = 'UNKNOWN'
}

export type EvaluationsFilter = {
  readonly evaluatorId: InputMaybe<Scalars['String']['input']>;
  readonly jobId: InputMaybe<Scalars['String']['input']>;
  readonly managerId: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type Expense = Commentable & WithExtraFields & {
  readonly __typename?: 'Expense';
  readonly ContentDocumentLinks: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly CurrencyIsoCode: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Colleague;
  readonly expenseCategory: Maybe<ExpenseCategory>;
  readonly expenseGroup: Maybe<ExpenseGroup>;
  readonly expenseItems: ReadonlyArray<ExpenseItem>;
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Date_From__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Date_To__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Decline_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Description__c: Scalars['String']['output'];
  /** @deprecated use flair__Submitted_By__c instead */
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Expense_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__Expense_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Expense_Group__c: Maybe<Scalars['String']['output']>;
  readonly flair__Final_Amount__c: Scalars['Float']['output'];
  readonly flair__Is_Draft__c: Scalars['Boolean']['output'];
  readonly flair__Merchant__c: Maybe<Scalars['String']['output']>;
  readonly flair__OCR_Completed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__OCR__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Project__c: Maybe<Scalars['String']['output']>;
  readonly flair__Reimbursed__c: Scalars['Boolean']['output'];
  readonly flair__Status__c: ExpenseStatus;
  readonly flair__Submitted_By__c: Scalars['String']['output'];
  readonly flair__Time_From__c: Maybe<Scalars['String']['output']>;
  readonly flair__Time_To__c: Maybe<Scalars['String']['output']>;
  readonly merchant: Maybe<Merchant>;
  readonly project: Maybe<Project>;
  readonly recordType: RecordType;
};

export type ExpenseCategory = {
  readonly __typename?: 'ExpenseCategory';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type ExpenseFilterInput = {
  readonly category: InputMaybe<Scalars['String']['input']>;
  readonly managerReportsType: ManagerReportsType;
  readonly status: InputMaybe<ExpenseStatus>;
  readonly type: InputMaybe<ExpenseTypeFilter>;
  readonly year: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseGroup = Commentable & {
  readonly __typename?: 'ExpenseGroup';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly CurrencyIsoCode: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Colleague;
  readonly endDate: Maybe<Scalars['LocalDate']['output']>;
  readonly expenses: ReadonlyArray<Expense>;
  readonly flair__Decline_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Reimbursed__c: Scalars['Boolean']['output'];
  readonly flair__Status__c: ExpenseStatus;
  readonly flair__Trip_Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type__c: ExpenseGroupType;
  readonly isGroup: Scalars['Boolean']['output'];
  readonly startDate: Maybe<Scalars['LocalDate']['output']>;
  readonly totalAmount: Scalars['Float']['output'];
};

export type ExpenseGroupFilterInput = {
  readonly expenseGroupIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly managerReportsType: ManagerReportsType;
};

export type ExpenseGroupMutations = {
  readonly __typename?: 'ExpenseGroupMutations';
  readonly createExpenseGroup: ExpenseGroupPayload;
  readonly deleteExpenseGroup: ExpenseGroupPayload;
  readonly updateExpenseGroupStatus: ExpenseGroupPayload;
};


export type ExpenseGroupMutationsCreateExpenseGroupArgs = {
  input: CreateExpenseGroupInput;
};


export type ExpenseGroupMutationsDeleteExpenseGroupArgs = {
  id: Scalars['String']['input'];
};


export type ExpenseGroupMutationsUpdateExpenseGroupStatusArgs = {
  input: UpdateExpenseGroupStatusInput;
};

export type ExpenseGroupPayload = {
  readonly __typename?: 'ExpenseGroupPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<ExpenseGroup>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export enum ExpenseGroupSortFieldEnum {
  CreatedDate = 'CREATED_DATE'
}

export type ExpenseGroupSortInput = {
  readonly field: ExpenseGroupSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export enum ExpenseGroupType {
  Group = 'GROUP',
  Trip = 'TRIP'
}

export type ExpenseItem = WithExtraFields & {
  readonly __typename?: 'ExpenseItem';
  readonly ContentDocumentLinks: ReadonlyArray<ContentDocumentLink>;
  readonly Id: Scalars['String']['output'];
  readonly Name: Maybe<Scalars['String']['output']>;
  readonly RecordTypeId: Maybe<Scalars['String']['output']>;
  readonly expense: Maybe<Expense>;
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly flair__Address_From__c: Maybe<Scalars['String']['output']>;
  readonly flair__Address_To__c: Maybe<Scalars['String']['output']>;
  readonly flair__Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Breakfast_Provided__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Dinner_Provided__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Distance_Sync_In_Progress__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Expense__c: Scalars['String']['output'];
  readonly flair__Km_Distance__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Lunch_Provided__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Manual_Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Means_Of_Transport__c: Maybe<Scalars['String']['output']>;
  readonly flair__Merchant__c: Maybe<Scalars['String']['output']>;
  readonly flair__Note__c: Maybe<Scalars['String']['output']>;
  readonly flair__Tax__c: Maybe<Scalars['String']['output']>;
  readonly merchant: Maybe<Merchant>;
  readonly recordType: RecordType;
  readonly tax: Maybe<Tax>;
};

export type ExpenseItemInput = {
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly files: InputMaybe<ReadonlyArray<FileInput>>;
  readonly manualAmount: InputMaybe<Scalars['Float']['input']>;
  readonly merchantId: InputMaybe<Scalars['String']['input']>;
  readonly merchantName: Scalars['String']['input'];
  readonly recordTypeId: Scalars['String']['input'];
};

export type ExpenseItemPayload = {
  readonly __typename?: 'ExpenseItemPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<ExpenseItem>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type ExpenseMutations = {
  readonly __typename?: 'ExpenseMutations';
  readonly createDraftExpense: ExpensePayload;
  readonly createExpenseItem: ExpenseItemPayload;
  readonly createMerchant: MerchantPayload;
  readonly deleteExpense: ExpensePayload;
  readonly deleteExpenseItem: ExpenseItemPayload;
  readonly updateExpense: ExpensePayload;
  readonly updateExpenseItem: ExpenseItemPayload;
  readonly updateExpenseStatus: ExpensePayload;
};


export type ExpenseMutationsCreateDraftExpenseArgs = {
  input: CreateDraftExpenseInput;
};


export type ExpenseMutationsCreateExpenseItemArgs = {
  input: CreateExpenseItemInput;
};


export type ExpenseMutationsCreateMerchantArgs = {
  input: CreateMerchantInput;
};


export type ExpenseMutationsDeleteExpenseArgs = {
  id: Scalars['String']['input'];
};


export type ExpenseMutationsDeleteExpenseItemArgs = {
  id: Scalars['String']['input'];
};


export type ExpenseMutationsUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type ExpenseMutationsUpdateExpenseItemArgs = {
  input: UpdateExpenseItemInput;
};


export type ExpenseMutationsUpdateExpenseStatusArgs = {
  input: UpdateExpenseStatusInput;
};

export type ExpensePagination = {
  readonly __typename?: 'ExpensePagination';
  readonly items: ReadonlyArray<Expense>;
  readonly paginationInfo: PaginationInfo;
};

export type ExpensePayload = {
  readonly __typename?: 'ExpensePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<Expense>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type ExpenseRule = {
  readonly __typename?: 'ExpenseRule';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Amount_Per__c: Maybe<Scalars['String']['output']>;
  readonly flair__Compensation_Amount__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Condition_Field__c: Maybe<Scalars['String']['output']>;
  readonly flair__Condition_Operator__c: Maybe<ExpenseRuleConditionOperator>;
  readonly flair__Condition_Value__c: Maybe<Scalars['String']['output']>;
  readonly flair__Expense_Rules_Template__c: Scalars['String']['output'];
  readonly flair__Percentage_Addition__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Valid_For_Record_Types__c: Maybe<Scalars['String']['output']>;
};

export enum ExpenseRuleConditionOperator {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export enum ExpenseSortFieldEnum {
  CreatedDate = 'CREATED_DATE',
  ExpenseDate = 'EXPENSE_DATE'
}

export type ExpenseSortInput = {
  readonly field: ExpenseSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export enum ExpenseStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Reimbursed = 'REIMBURSED',
  Unknown = 'UNKNOWN'
}

export enum ExpenseTypeFilter {
  Groups = 'GROUPS',
  Individual = 'INDIVIDUAL',
  Trips = 'TRIPS'
}

export type ExternalLocation = {
  readonly __typename?: 'ExternalLocation';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type ExtraFieldContextParamInput = {
  readonly name: Scalars['String']['input'];
  readonly type: FieldType;
  readonly value: Scalars['String']['input'];
};

export type ExtraFieldFormInfo = {
  readonly __typename?: 'ExtraFieldFormInfo';
  readonly fieldApiName: Scalars['String']['output'];
  readonly fieldInfo: ExtraFieldInfo;
  readonly formId: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly required: Scalars['Boolean']['output'];
  readonly visibilityCondition: Maybe<Scalars['String']['output']>;
  readonly visibleLines: Maybe<Scalars['Int']['output']>;
};

export type ExtraFieldInfo = {
  readonly __typename?: 'ExtraFieldInfo';
  readonly decimalPlaces: Maybe<Scalars['Int']['output']>;
  readonly inlineHelpText: Maybe<Scalars['String']['output']>;
  readonly isRichTextArea: Scalars['Boolean']['output'];
  readonly label: Scalars['String']['output'];
  readonly picklistValues: Maybe<ReadonlyArray<PickListEntry>>;
  readonly referenceObjectApiName: Maybe<Scalars['String']['output']>;
  readonly type: FieldType;
};

export type ExtraFieldInput = {
  readonly fieldApiName: Scalars['String']['input'];
  readonly jsonValue: InputMaybe<Scalars['String']['input']>;
  readonly type: FieldType;
  readonly valueJson: InputMaybe<Scalars['String']['input']>;
};

export type ExtraFieldLookupOption = {
  readonly __typename?: 'ExtraFieldLookupOption';
  readonly id: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
};

export type ExtraFieldTableInfo = {
  readonly __typename?: 'ExtraFieldTableInfo';
  readonly columnTitle: Maybe<Scalars['String']['output']>;
  readonly customFieldName: Maybe<Scalars['String']['output']>;
  readonly fieldApiName: Scalars['String']['output'];
  readonly fieldInfo: Maybe<ExtraFieldInfo>;
  readonly id: Scalars['String']['output'];
  readonly tableId: Maybe<Scalars['String']['output']>;
};

export type ExtraFieldValue = {
  readonly __typename?: 'ExtraFieldValue';
  readonly displayValue: Maybe<Scalars['String']['output']>;
  readonly extraFieldInfoId: Scalars['String']['output'];
  readonly fieldApiName: Scalars['String']['output'];
  readonly fieldInfo: ExtraFieldInfo;
  readonly forms: ReadonlyArray<ExtraFieldFormInfo>;
  readonly jsonValue: Maybe<Scalars['String']['output']>;
  readonly objectApiName: Scalars['String']['output'];
  readonly recordId: Scalars['String']['output'];
  readonly referenceTo: Maybe<AnyObject>;
  readonly referenceToId: Maybe<Scalars['String']['output']>;
  readonly referenceToObjectApiName: Maybe<Scalars['String']['output']>;
  readonly tables: ReadonlyArray<ExtraFieldTableInfo>;
  readonly type: FieldType;
};

export type ExtraFields = {
  readonly __typename?: 'ExtraFields';
  readonly extraFieldLookupOptions: ReadonlyArray<ExtraFieldLookupOption>;
  readonly objectExtraFields: ObjectExtraFields;
  readonly objectsExtraFields: ReadonlyArray<ObjectExtraFields>;
  readonly withExtraFields: WithExtraFields;
};


export type ExtraFieldsExtraFieldLookupOptionsArgs = {
  contextParams: InputMaybe<ReadonlyArray<ExtraFieldContextParamInput>>;
  extraFieldsConfigReference: InputMaybe<ExtraFieldsConfigReferenceInput>;
  id: Scalars['String']['input'];
};


export type ExtraFieldsObjectExtraFieldsArgs = {
  objectApiName: Scalars['String']['input'];
};


export type ExtraFieldsObjectsExtraFieldsArgs = {
  objectApiNames: ReadonlyArray<Scalars['String']['input']>;
};


export type ExtraFieldsWithExtraFieldsArgs = {
  objectApiName: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};

export enum ExtraFieldsConfigLocation {
  RequestForm = 'RequestForm'
}

export type ExtraFieldsConfigReferenceInput = {
  readonly location: ExtraFieldsConfigLocation;
  readonly recordId: InputMaybe<Scalars['String']['input']>;
};

export enum FeedbackAnswerVisibility {
  SemiHidden = 'SEMI_HIDDEN',
  Unknown = 'UNKNOWN',
  Visible = 'VISIBLE'
}

export type FeedbackCycle = {
  readonly __typename?: 'FeedbackCycle';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Deadline__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Deadline__c: Maybe<Scalars['String']['output']>;
  readonly flair__Introduction_Text__c: Maybe<Scalars['String']['output']>;
  readonly flair__Manage_Goals__c: Scalars['Boolean']['output'];
  readonly flair__Manager_Deadline__c: Maybe<Scalars['String']['output']>;
  readonly flair__Meeting_Required__c: Scalars['Boolean']['output'];
  readonly flair__Number_of_Peers__c: Scalars['Int']['output'];
  readonly flair__Rating_Max__c: Scalars['Int']['output'];
  readonly flair__Rating_Min__c: Scalars['Int']['output'];
  readonly flair__See_All_Questions__c: Scalars['Boolean']['output'];
  readonly flair__Signature_required__c: Scalars['Boolean']['output'];
  readonly flair__State__c: FeedbackCycleState;
  readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes;
  readonly flair__With_Peers__c: Scalars['Boolean']['output'];
  readonly flair__Without_Reviewer__c: Scalars['Boolean']['output'];
  readonly questions: ReadonlyArray<FeedbackQuestion>;
};

export enum FeedbackCycleState {
  Finished = 'Finished',
  InProgress = 'InProgress',
  Publishing = 'Publishing',
  Setup = 'Setup',
  Unknown = 'Unknown'
}

export enum FeedbackCycleTimelineTypes {
  Sequential = 'SEQUENTIAL',
  Simultaneous = 'SIMULTANEOUS'
}

export type FeedbackQuestion = {
  readonly __typename?: 'FeedbackQuestion';
  readonly Id: Scalars['String']['output'];
  readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility;
  readonly flair__Choices__c: ReadonlyArray<Scalars['String']['output']>;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Feedback_Question_Section__c: Maybe<Scalars['String']['output']>;
  readonly flair__Feedback_Question_Type__c: FeedbackQuestionType;
  readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility;
  readonly flair__Hint__c: Maybe<Scalars['String']['output']>;
  readonly flair__Is_Satisfaction_Section__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Optional_Comment__c: Scalars['Boolean']['output'];
  readonly flair__Optional__c: Scalars['Boolean']['output'];
  readonly flair__Position__c: Scalars['Int']['output'];
  /** @deprecated use flair__Feedback_Question_Type__c instead */
  readonly flair__Question_Type__c: FeedbackQuestionType;
  readonly flair__Question__c: Maybe<Scalars['String']['output']>;
  readonly flair__Required_Choice__c: ReadonlyArray<Scalars['String']['output']>;
  readonly flair__Section_Name__c: Maybe<Scalars['String']['output']>;
};

export enum FeedbackQuestionType {
  Dropdown = 'DROPDOWN',
  FreeSlider = 'FREE_SLIDER',
  FreeText = 'FREE_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Rating = 'RATING',
  Scorecard = 'SCORECARD',
  SingleChoice = 'SINGLE_CHOICE',
  Unknown = 'UNKNOWN',
  YesNo = 'YES_NO'
}

export enum FeedbackQuestionVisibility {
  Employee = 'EMPLOYEE',
  EmployeePeers = 'EMPLOYEE_PEERS',
  Manager = 'MANAGER',
  ManagerEmployee = 'MANAGER_EMPLOYEE',
  ManagerEmployeePeers = 'MANAGER_EMPLOYEE_PEERS',
  ManagerPeers = 'MANAGER_PEERS',
  Peers = 'PEERS',
  Unknown = 'UNKNOWN'
}

export type FieldChangeInput = {
  readonly fieldName: Scalars['String']['input'];
  readonly fieldType: Scalars['String']['input'];
  readonly newValue: Scalars['String']['input'];
};

export type FieldInfo = {
  readonly __typename?: 'FieldInfo';
  readonly label: Scalars['String']['output'];
  readonly locale: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly objectType: Scalars['String']['output'];
  readonly picklistValues: ReadonlyArray<PickListEntry>;
  readonly recordTypeId: Maybe<Scalars['String']['output']>;
  readonly type: FieldType;
};

export enum FieldType {
  Address = 'ADDRESS',
  Anytype = 'ANYTYPE',
  Base64 = 'BASE64',
  Boolean = 'BOOLEAN',
  Combobox = 'COMBOBOX',
  Currency = 'CURRENCY',
  Datacategorygroupreference = 'DATACATEGORYGROUPREFERENCE',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Double = 'DOUBLE',
  Email = 'EMAIL',
  Encryptedstring = 'ENCRYPTEDSTRING',
  Id = 'ID',
  Integer = 'INTEGER',
  Long = 'LONG',
  Multipicklist = 'MULTIPICKLIST',
  Percent = 'PERCENT',
  Phone = 'PHONE',
  Picklist = 'PICKLIST',
  Reference = 'REFERENCE',
  String = 'STRING',
  Textarea = 'TEXTAREA',
  Time = 'TIME',
  Url = 'URL'
}

export type FileInput = {
  readonly fileContentBase64: Scalars['String']['input'];
  readonly fileName: Scalars['String']['input'];
};

export type FinishEmployeeFeedbackOutcomeInput = {
  readonly goals: InputMaybe<ReadonlyArray<UpdateCycleEmployeeObjectiveInput>>;
  readonly id: Scalars['String']['input'];
  readonly onlyUpdateResolutions: InputMaybe<Scalars['Boolean']['input']>;
  readonly resolutions: InputMaybe<ReadonlyArray<UpdateEmployeeFeedbackResolution>>;
};

export type GeolocationCoordinatesInput = {
  readonly accuracy: InputMaybe<Scalars['Float']['input']>;
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
};

export enum GoalType {
  Company = 'company',
  Employee = 'employee',
  Team = 'team'
}

export type HiringManager = {
  readonly __typename?: 'HiringManager';
  readonly Id: Scalars['String']['output'];
  readonly job: Maybe<Job>;
  readonly jobs: ReadonlyArray<Job>;
};


export type HiringManagerJobArgs = {
  id: Scalars['String']['input'];
};

export type Holiday = {
  readonly __typename?: 'Holiday';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly endDate: Scalars['String']['output'];
  readonly flair__Day__c: Scalars['String']['output'];
  readonly flair__Official__c: Scalars['Boolean']['output'];
  readonly flair__Type__c: HolidayType;
  readonly startDate: Scalars['String']['output'];
};

export enum HolidayType {
  Afternoon = 'AFTERNOON',
  FullDay = 'FULL_DAY',
  Morning = 'MORNING'
}

export type Hub = {
  readonly __typename?: 'Hub';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Company_Logo_Url__c: Maybe<Scalars['String']['output']>;
  readonly flair__Cover_Url__c: Maybe<Scalars['String']['output']>;
  readonly flair__Inactivity_Timeout__c: Maybe<Scalars['Float']['output']>;
};

export type IdentifyInput = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly locale: Scalars['String']['input'];
  readonly manager: Scalars['Boolean']['input'];
  readonly organization: Scalars['String']['input'];
};

export enum IntersectionMode {
  Intersection = 'INTERSECTION',
  Within = 'WITHIN',
  WithinExcluded = 'WITHIN_EXCLUDED'
}

export type Inventory = {
  readonly __typename?: 'Inventory';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Manufacturer__c: Maybe<Scalars['String']['output']>;
  readonly flair__Model__c: Maybe<Scalars['String']['output']>;
  readonly flair__Support_Advisor__c: Maybe<Scalars['String']['output']>;
  readonly flair__Support_Instruction__c: Maybe<Scalars['String']['output']>;
  readonly flair__Support_Video__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type__c: Maybe<Scalars['String']['output']>;
  readonly manufacturer: Maybe<DictionaryItem>;
  readonly supportAdvisor: Maybe<Colleague>;
};

export type InventoryItem = Commentable & {
  readonly __typename?: 'InventoryItem';
  readonly ContentDocumentLinks: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedById: Maybe<Scalars['String']['output']>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly CurrencyIsoCode: Maybe<Scalars['String']['output']>;
  readonly Id: Scalars['String']['output'];
  readonly Name: Maybe<Scalars['String']['output']>;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly createdBy: Maybe<Colleague>;
  readonly electronicsCatOperatingSystem: Maybe<DictionaryItem>;
  readonly employee: Maybe<Colleague>;
  readonly flair__App_Cat_Download_Or_Connect_Link__c: Maybe<Scalars['String']['output']>;
  readonly flair__App_Cat_Editor__c: Maybe<Scalars['String']['output']>;
  readonly flair__App_Cat_Version__c: Maybe<Scalars['String']['output']>;
  readonly flair__Approval_Status__c: Maybe<Scalars['String']['output']>;
  readonly flair__Electronics_Cat_Operating_System__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Inventory__c: Scalars['String']['output'];
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Net_Purchase_Price__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Purchase_Date__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Serial_Number__c: Maybe<Scalars['String']['output']>;
  readonly flair__Supplier__c: Maybe<Scalars['String']['output']>;
  readonly flair__Uniform_Cat_Size_System__c: Maybe<Scalars['String']['output']>;
  readonly flair__Uniform_Cat_Size__c: Maybe<Scalars['String']['output']>;
  readonly flair__Uniform_Cat_Type__c: Maybe<Scalars['String']['output']>;
  readonly flair__Vehicle_Cat_Fuel_Type__c: Maybe<Scalars['String']['output']>;
  readonly flair__Vehicle_Cat_Identification_Number_VIN__c: Maybe<Scalars['String']['output']>;
  readonly flair__Vehicle_Cat_Insurance_Company_Contact__c: Maybe<Scalars['String']['output']>;
  readonly flair__Vehicle_Cat_Insurance_Company__c: Maybe<Scalars['String']['output']>;
  readonly flair__Vehicle_Cat_Insurance_policy_number__c: Maybe<Scalars['String']['output']>;
  readonly flair__Vehicle_Cat_Model_Year__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Vehicle_Cat_Serial_Plate_Number__c: Maybe<Scalars['String']['output']>;
  readonly flair__Warranty_Date__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Warranty_Information__c: Maybe<Scalars['String']['output']>;
  readonly inventory: Inventory;
  readonly location: Maybe<Location>;
  readonly supplier: Maybe<Merchant>;
  readonly uniformCatSizeSystem: Maybe<DictionaryItem>;
  readonly uniformCatType: Maybe<DictionaryItem>;
  readonly vehicleCatFuelType: Maybe<DictionaryItem>;
};

export type InventoryItemFilterInput = {
  readonly categoryName: InputMaybe<Scalars['String']['input']>;
  readonly locationId: InputMaybe<Scalars['String']['input']>;
  readonly month: InputMaybe<Scalars['LocalDate']['input']>;
  readonly searchTerm: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<Scalars['String']['input']>;
  readonly year: InputMaybe<Scalars['LocalDate']['input']>;
};

export enum InventoryItemSortFieldEnum {
  Category = 'CATEGORY',
  CreatedDate = 'CREATED_DATE',
  InventoryItem = 'INVENTORY_ITEM',
  Location = 'LOCATION',
  Status = 'STATUS'
}

export type InventoryItemSortInput = {
  readonly field: InventoryItemSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export enum InventoryItemStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type InventoryItemsPagination = {
  readonly __typename?: 'InventoryItemsPagination';
  readonly items: ReadonlyArray<InventoryItem>;
  readonly paginationInfo: PaginationInfo;
};

export type InventoryMutations = {
  readonly __typename?: 'InventoryMutations';
  readonly addInventory: Maybe<AddInventoryPayload>;
  readonly addInventoryItem: Maybe<AddInventoryItemPayload>;
  readonly updateInventoryItemStatus: Maybe<UpdateInventoryItemStatusPayload>;
};


export type InventoryMutationsAddInventoryArgs = {
  input: AddInventoryInput;
};


export type InventoryMutationsAddInventoryItemArgs = {
  input: AddInventoryItemInput;
};


export type InventoryMutationsUpdateInventoryItemStatusArgs = {
  input: UpdateInventoryItemStatusInput;
};

export type InventoryTemplate = {
  readonly __typename?: 'InventoryTemplate';
  readonly Id: Scalars['String']['output'];
  readonly Name: Maybe<Scalars['String']['output']>;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
};

export type InvitedColleague = {
  readonly __typename?: 'InvitedColleague';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly absences2: ReadonlyArray<Absence>;
  readonly employeeSkills: ReadonlyArray<EmployeeSkillAssociation>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Position__c: Maybe<Scalars['String']['output']>;
  readonly location: Maybe<ExternalLocation>;
  readonly shifts: ReadonlyArray<EmployeeShift>;
};


export type InvitedColleagueAbsences2Args = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type InvitedColleagueShiftsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type Job = {
  readonly __typename?: 'Job';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly candidates: JobCandidatesWithPagination;
  readonly candidatesCount: Scalars['Int']['output'];
  readonly department: Maybe<Department>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Display_in_Hub__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__FlairAI_Key_Requirements_JSON__c: Maybe<Scalars['String']['output']>;
  readonly flair__Job_Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Job_Requirements__c: Maybe<Scalars['String']['output']>;
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Published_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Responsibilities__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: Maybe<JobStatus>;
  readonly flair__Time_Commitment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type_of_Employment__c: Maybe<Scalars['String']['output']>;
  readonly jobLink: Scalars['String']['output'];
  readonly jobSkills: ReadonlyArray<JobSkillAssociation>;
  readonly location: Maybe<Location>;
};


export type JobCandidatesArgs = {
  filter: InputMaybe<CandidateFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<SortInput>;
};


export type JobJobLinkArgs = {
  careerPortalId: InputMaybe<Scalars['String']['input']>;
  refererId: InputMaybe<Scalars['String']['input']>;
};

export type JobCandidate = Commentable & {
  readonly __typename?: 'JobCandidate';
  readonly ContentDocumentLinks__r: Maybe<ReadonlyArray<ContentDocumentLink>>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly candidateEvaluations: ReadonlyArray<CandidateEvaluation>;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly flair__Anonymized__c: Scalars['Boolean']['output'];
  readonly flair__Application_Source__c: Maybe<Scalars['String']['output']>;
  readonly flair__Cover_Letter__c: Maybe<Scalars['String']['output']>;
  readonly flair__Email__c: Maybe<Scalars['String']['output']>;
  readonly flair__Final_Score__c: Maybe<Scalars['Float']['output']>;
  readonly flair__FlairAI_KR_Matching_Info_JSON__c: Maybe<Scalars['String']['output']>;
  readonly flair__FlairAI_KR_Matching_Status__c: AiProcessingState;
  readonly flair__FlairAI_Total_KR_Matching_Score__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Full_Name__c: Scalars['String']['output'];
  readonly flair__Funnel_Stage__c: Maybe<Scalars['String']['output']>;
  readonly flair__How_did_you_hear_about_us__c: Maybe<Scalars['String']['output']>;
  readonly flair__Job__c: Maybe<Scalars['String']['output']>;
  readonly flair__LinkedIn__c: Maybe<Scalars['String']['output']>;
  readonly flair__Overall_Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Phone__c: Maybe<Scalars['String']['output']>;
  readonly job: Maybe<Job>;
  readonly recruitingDocuments: ReadonlyArray<RecruitingDocument>;
};

export type JobCandidatesWithPagination = {
  readonly __typename?: 'JobCandidatesWithPagination';
  readonly items: ReadonlyArray<JobCandidate>;
  readonly paginationInfo: PaginationInfo;
};

export type JobHiringManager = {
  readonly __typename?: 'JobHiringManager';
  readonly Id: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Job__c: Scalars['String']['output'];
};

export type JobSkillAssociation = {
  readonly __typename?: 'JobSkillAssociation';
  readonly Id: Scalars['String']['output'];
  readonly flair__Job__c: Scalars['String']['output'];
  readonly flair__Skill_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Skill__c: Scalars['String']['output'];
  readonly skill: Skill;
};

export enum JobStatus {
  CandidatesRejection = 'CANDIDATES_REJECTION',
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type LastUpdateEntityId = {
  readonly __typename?: 'LastUpdateEntityId';
  readonly id: Scalars['String']['output'];
  readonly objectType: Scalars['String']['output'];
};

export type LastUpdateFilter = {
  readonly filterByCategory: ReadonlyArray<LastUpdateFilterByCategory>;
  readonly filterByTeam: LastUpdateFilterByTeam;
};

export enum LastUpdateFilterByCategory {
  All = 'ALL',
  Announcements = 'ANNOUNCEMENTS',
  Cheers = 'CHEERS',
  NewJoiners = 'NEW_JOINERS'
}

export enum LastUpdateFilterByTeam {
  AllCompany = 'ALL_COMPANY',
  MyTeam = 'MY_TEAM'
}

export type LastUpdateOffset = {
  readonly __typename?: 'LastUpdateOffset';
  readonly announcementOffset: Scalars['Int']['output'];
  readonly celebrationOffset: Scalars['Int']['output'];
  readonly newHiresOffset: Scalars['Int']['output'];
};

export type LastUpdateOffsetInput = {
  readonly announcementOffset: Scalars['Int']['input'];
  readonly celebrationOffset: Scalars['Int']['input'];
  readonly newHiresOffset: Scalars['Int']['input'];
};

export type LastUpdatePaginationInfo = {
  readonly limit: Scalars['Int']['input'];
  readonly offset: LastUpdateOffsetInput;
};

export type LastUpdateResponse = {
  readonly __typename?: 'LastUpdateResponse';
  readonly data: ReadonlyArray<LastUpdates>;
  readonly entities: ReadonlyArray<LastUpdateEntityId>;
  readonly offset: LastUpdateOffset;
};

export type LastUpdates = Announcement | Celebration | Colleague;

export type Location = {
  readonly __typename?: 'Location';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type LocationHoliday = {
  readonly __typename?: 'LocationHoliday';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly endDate: Scalars['String']['output'];
  readonly flair__Day__c: Scalars['String']['output'];
  readonly flair__Official__c: Scalars['Boolean']['output'];
  readonly flair__Type__c: HolidayType;
  readonly startDate: Scalars['String']['output'];
};

export type LoomVideo = {
  readonly __typename?: 'LoomVideo';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Embed_Url__c: Scalars['String']['output'];
  readonly flair__Height__c: Scalars['Int']['output'];
  readonly flair__Loom_Id__c: Scalars['String']['output'];
  readonly flair__Loom_Public_App_Id__c: Scalars['String']['output'];
  readonly flair__Shared_Url__c: Scalars['String']['output'];
  readonly flair__Width__c: Scalars['Int']['output'];
};

export type LoomVideoInput = {
  readonly loomVideo: CreateLoomVideoInput;
  readonly relatedId: Scalars['String']['input'];
  readonly relatedObjectName: Scalars['String']['input'];
};

export type LoomVideoMutations = {
  readonly __typename?: 'LoomVideoMutations';
  readonly createLoomVideo: CreateLoomVideoPayload;
  readonly deleteLoomVideo: DeleteLoomVideoPayload;
};


export type LoomVideoMutationsCreateLoomVideoArgs = {
  input: LoomVideoInput;
};


export type LoomVideoMutationsDeleteLoomVideoArgs = {
  input: DeleteLoomVideoInput;
};

export type MakeCelebrationPublicInput = {
  readonly id: Scalars['String']['input'];
};

export type Manager = {
  readonly __typename?: 'Manager';
  readonly Id: Scalars['String']['output'];
  readonly absencesForManager: AbsencePagination;
  /** @deprecated use query.employeeDataChangeRequests instead */
  readonly changeRequests: ReadonlyArray<EmployeeDataChangeRequest>;
  readonly currentTimeSheets: ReadonlyArray<TimeSheet>;
  readonly employee: Maybe<Employee>;
  readonly employeeCourses: ReadonlyArray<EmployeeCourse>;
  readonly employeeNotes: ReadonlyArray<ManagerEmployeeNote>;
  readonly employees: ReadonlyArray<Employee>;
  readonly employeesObjectives: ReadonlyArray<TeamOrEmployeeObjective>;
  readonly expenseGroups: ReadonlyArray<ExpenseGroup>;
  readonly expenses: ExpensePagination;
  readonly pendingEmployeeFeedbacks: ReadonlyArray<EmployeeFeedback>;
  readonly pendingExpenses: ReadonlyArray<Expense>;
  readonly pendingTimeEntryChangeRequests: ReadonlyArray<TimeEntryChangeRequest>;
  readonly pendingTimeSheets: ReadonlyArray<TimeSheet>;
  readonly performanceReviews: ReadonlyArray<EmployeeFeedback>;
  /** @deprecated use query.requestForms instead */
  readonly requestForms: ReadonlyArray<RequestForm>;
  readonly tickets: TicketPagination;
  readonly timeFrameworks: ReadonlyArray<TimeFramework>;
  /** @deprecated use query.timeSheet */
  readonly timeSheet: TimeSheet;
  /** @deprecated use query.timeSheets */
  readonly timeSheets: ReadonlyArray<TimeSheet>;
  readonly timeSheetsPagination: TimeSheetPagination;
};


export type ManagerAbsencesForManagerArgs = {
  filter: AbsenceRequestFilterInput;
  pagination: PaginationInput;
  sort: AbsenceRequestSortInput;
};


export type ManagerChangeRequestsArgs = {
  filter: EmployeeDataChangeRequestManagerFilterInput;
};


export type ManagerCurrentTimeSheetsArgs = {
  filter: InputMaybe<TimeSheetFilterInput>;
};


export type ManagerEmployeeArgs = {
  id: Scalars['String']['input'];
};


export type ManagerEmployeeCoursesArgs = {
  filter: EmployeeCoursesFilterInput;
};


export type ManagerEmployeeNotesArgs = {
  employeeId: Scalars['String']['input'];
};


export type ManagerEmployeesArgs = {
  filter: InputMaybe<EmployeeFilterInput>;
};


export type ManagerEmployeesObjectivesArgs = {
  filter: InputMaybe<ObjectiveFilterManager>;
};


export type ManagerExpenseGroupsArgs = {
  filter: InputMaybe<ExpenseGroupFilterInput>;
};


export type ManagerExpensesArgs = {
  filter: InputMaybe<ExpenseFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<ReadonlyArray<ExpenseSortInput>>;
};


export type ManagerPendingExpensesArgs = {
  filter: InputMaybe<ExpenseFilterInput>;
};


export type ManagerPendingTimeEntryChangeRequestsArgs = {
  filter: InputMaybe<PendingTimeEntryChangeFilterInput>;
};


export type ManagerPendingTimeSheetsArgs = {
  filter: InputMaybe<TimeSheetFilterInput>;
};


export type ManagerRequestFormsArgs = {
  filter: RequestFormFilterInput;
  sortBy: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTicketsArgs = {
  employeeId: Scalars['String']['input'];
  filter: InputMaybe<TicketFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<TicketSortInput>;
};


export type ManagerTimeSheetArgs = {
  id: Scalars['String']['input'];
};


export type ManagerTimeSheetsArgs = {
  ids: ReadonlyArray<Scalars['String']['input']>;
};


export type ManagerTimeSheetsPaginationArgs = {
  filter: InputMaybe<TimeSheetFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<ReadonlyArray<TimeSheetSortInput>>;
};

export type ManagerEmployeeNote = {
  readonly __typename?: 'ManagerEmployeeNote';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Encrypted_Text__c: Scalars['String']['output'];
  readonly flair__Manager__c: Scalars['String']['output'];
  readonly flair__Polarity__c: ManagerEmployeeNotePolarity;
  readonly manager: Manager;
  readonly text: Scalars['String']['output'];
};

export enum ManagerEmployeeNotePolarity {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE',
  Unknown = 'UNKNOWN'
}

export enum ManagerReportsType {
  All = 'ALL',
  Direct = 'DIRECT'
}

export enum ManagerRole {
  AbsenceApprover = 'ABSENCE_APPROVER',
  Compensation = 'COMPENSATION',
  DirectManager = 'DIRECT_MANAGER',
  ExpenseApprover = 'EXPENSE_APPROVER',
  FeedbackManager = 'FEEDBACK_MANAGER',
  HelpDeskManager = 'HELP_DESK_MANAGER',
  HrManager = 'HR_MANAGER',
  Manager = 'MANAGER',
  SeeEmployeeData = 'SEE_EMPLOYEE_DATA',
  ShiftApprover = 'SHIFT_APPROVER',
  TimeEntryApprover = 'TIME_ENTRY_APPROVER'
}

export type MarkCelebrationAsReadPayload = {
  readonly __typename?: 'MarkCelebrationAsReadPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly recordIds: ReadonlyArray<Scalars['String']['output']>;
  readonly records: ReadonlyArray<Celebration>;
};

export type MarkCelebrationsAsReadInput = {
  readonly ids: ReadonlyArray<Scalars['String']['input']>;
};

export type Me = {
  readonly __typename?: 'Me';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly Organization: Scalars['String']['output'];
  readonly absenceCategories: ReadonlyArray<EmployeeAbsenceCategory>;
  /** @deprecated Query.employeeAbsences */
  readonly absences: ReadonlyArray<Absence>;
  readonly absencesByYear: ReadonlyArray<Absence>;
  readonly absencesCurrentYear: ReadonlyArray<Absence>;
  readonly activeColleagues: ReadonlyArray<Colleague>;
  readonly allColleagues: ReadonlyArray<Colleague>;
  readonly approvalRequests: ReadonlyArray<ApprovalRequest>;
  readonly archivedNotifications: NotificationPagination;
  readonly avatar: Maybe<EmployeeAvatar>;
  readonly birthdaysColleagues: ReadonlyArray<Colleague>;
  readonly calendarToken: Maybe<Scalars['String']['output']>;
  readonly certificates: ReadonlyArray<EmployeeCertificate>;
  readonly checkinsSurveys: ReadonlyArray<CheckinsSurveyDto>;
  readonly colleaguesObjectives: ReadonlyArray<TeamOrEmployeeObjective>;
  /** @deprecated absenceCategories */
  readonly compensatoryTimeCategory: Maybe<EmployeeAbsenceCategory>;
  readonly courses: ReadonlyArray<EmployeeCourse>;
  readonly coverUrl: Maybe<Scalars['String']['output']>;
  readonly currentTimeEntry: Maybe<MyTimeEntry>;
  readonly customerSupport: CustomerSupport;
  readonly data: EmployeeData;
  readonly department: Maybe<Department>;
  readonly employeeDataChangeRequests: ReadonlyArray<EmployeeDataChangeRequest>;
  readonly employeeDocumentFolders: ReadonlyArray<EmployeeDocumentFolder>;
  readonly employeeDocuments: ReadonlyArray<EmployeeDocument>;
  readonly employeeSkills: ReadonlyArray<EmployeeSkillAssociation>;
  readonly engagementSurveys: ReadonlyArray<EngagementSurveyDto>;
  readonly enpsSurveys: ReadonlyArray<EnpsSurveyDto>;
  readonly feedback: EmployeeFeedback;
  readonly feedbacks: ReadonlyArray<EmployeeFeedback>;
  readonly feedbacksAsReviewer: ReadonlyArray<EmployeeFeedback>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Can_Change_Own_Time_Entries__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Company_Email__c: Maybe<Scalars['String']['output']>;
  readonly flair__Country__c: Maybe<Scalars['String']['output']>;
  readonly flair__Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Language__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__First_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Garden_Leave__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Hide_My_Birthday__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Last_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  /** @deprecated use location instead */
  readonly flair__Location__r: Maybe<MyLocation>;
  readonly flair__Manager__c: Maybe<Scalars['String']['output']>;
  readonly flair__Position__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date__c: Maybe<Scalars['String']['output']>;
  readonly hasSlackUser: Scalars['Boolean']['output'];
  readonly holidays: ReadonlyArray<Holiday>;
  readonly hubAccessRestricted: Scalars['Boolean']['output'];
  readonly inboxNotifications: NotificationPagination;
  readonly invitedColleagues: ReadonlyArray<InvitedColleague>;
  readonly location: Maybe<Location>;
  readonly logoUrl: Maybe<Scalars['String']['output']>;
  readonly manager: Maybe<Colleague>;
  readonly managerRoles: ReadonlyArray<ManagerRole>;
  readonly myExpenseGroups: ReadonlyArray<ExpenseGroup>;
  readonly myExpenses: ReadonlyArray<Expense>;
  readonly myObjectives: ReadonlyArray<TeamOrEmployeeObjective>;
  readonly myUnreadCelebrations: ReadonlyArray<Celebration>;
  readonly notCompletedWorkflowItems: ReadonlyArray<WorkflowItem>;
  readonly notificationSettings: EmployeeNotificationSetting;
  readonly objectives: ReadonlyArray<EmployeeObjective>;
  readonly onboardingWorkflow: Maybe<Workflow>;
  readonly ongoingAbsences: ReadonlyArray<Absence>;
  readonly openShifts: ReadonlyArray<OpenShift>;
  /** @deprecated Use me.hasSlackUser */
  readonly orgHasSlackEnabled: Scalars['Boolean']['output'];
  readonly pastAbsences: ReadonlyArray<Absence>;
  readonly shiftChangeRequestsFromMe: ReadonlyArray<ShiftChangeRequest>;
  readonly shiftChangeRequestsToMe: ReadonlyArray<ShiftChangeRequest>;
  readonly shifts: ReadonlyArray<EmployeeShift>;
  readonly snoozedNotifications: NotificationPagination;
  readonly taskNotifications: NotificationPagination;
  readonly teamColleagues: ReadonlyArray<Colleague>;
  readonly teams: ReadonlyArray<Team>;
  readonly timeSheetsPagination: TimeSheetPagination;
  readonly upcomingAbsences: ReadonlyArray<Absence>;
  readonly upcomingCalendarPeriods: ReadonlyArray<CalendarPeriod>;
  readonly upcomingHolidays: ReadonlyArray<LocationHoliday>;
  readonly workloads: ReadonlyArray<MyWorkload>;
};


export type MeAbsencesArgs = {
  excludeRejected: InputMaybe<Scalars['Boolean']['input']>;
  from: InputMaybe<Scalars['DateTime']['input']>;
  intersectionMode: InputMaybe<IntersectionMode>;
  sort: InputMaybe<AscDescEnum>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


export type MeAbsencesByYearArgs = {
  includePrevYearCrossedAbsences: InputMaybe<Scalars['Boolean']['input']>;
  startOfYearDate: Scalars['LocalDate']['input'];
};


export type MeActiveColleaguesArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type MeApprovalRequestsArgs = {
  filter: InputMaybe<MyApprovalRequestFilterInput>;
};


export type MeArchivedNotificationsArgs = {
  filter: ArchiveNotificationFilterInput;
  pagination: InputMaybe<PaginationInput>;
};


export type MeBirthdaysColleaguesArgs = {
  filter: BirthdaysFilter;
};


export type MeColleaguesObjectivesArgs = {
  filter: InputMaybe<ObjectiveFilter>;
};


export type MeDataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


export type MeEmployeeDataChangeRequestsArgs = {
  filter: InputMaybe<EmployeeDataChangeRequestFilter>;
};


export type MeEmployeeDocumentsArgs = {
  filter: InputMaybe<EmployeeDocumentsFilter>;
};


export type MeFeedbackArgs = {
  id: Scalars['String']['input'];
};


export type MeFeedbacksArgs = {
  filter: InputMaybe<MyFeedbacksFilter>;
};


export type MeHolidaysArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type MeInboxNotificationsArgs = {
  pagination: InputMaybe<PaginationInput>;
};


export type MeInvitedColleaguesArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type MeMyExpensesArgs = {
  sort: InputMaybe<ReadonlyArray<ExpenseSortInput>>;
};


export type MeMyObjectivesArgs = {
  filter: InputMaybe<ObjectiveFilter>;
};


export type MeOpenShiftsArgs = {
  from: Scalars['DateTime']['input'];
  locationId: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type MeShiftChangeRequestsFromMeArgs = {
  filter: InputMaybe<MyShiftChangeRequestFilterInput>;
};


export type MeShiftChangeRequestsToMeArgs = {
  filter: InputMaybe<MyShiftChangeRequestFilterInput>;
};


export type MeShiftsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type MeSnoozedNotificationsArgs = {
  pagination: InputMaybe<PaginationInput>;
};


export type MeTaskNotificationsArgs = {
  pagination: InputMaybe<PaginationInput>;
};


export type MeTeamColleaguesArgs = {
  departments: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  locations: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  teams: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  to: Scalars['DateTime']['input'];
};


export type MeTimeSheetsPaginationArgs = {
  filter: InputMaybe<EmployeeTimeSheetFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<ReadonlyArray<TimeSheetSortInput>>;
};


export type MeUpcomingAbsencesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
};


export type MeWorkloadsArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};

export type MentionedEmployee = {
  readonly __typename?: 'MentionedEmployee';
  readonly employee: Colleague;
  readonly hasAccess: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
};

export type Merchant = {
  readonly __typename?: 'Merchant';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type MerchantPayload = {
  readonly __typename?: 'MerchantPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly merchant: Maybe<Merchant>;
};

export type MoveToFolderInput = {
  readonly folderId: Scalars['String']['input'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly absence: AbsenceMutations;
  readonly acceptEmployeeFeedbackOutcomeObjectives: Scalars['String']['output'];
  readonly announcements: AnnouncementMutations;
  readonly approvalRequest: ApprovalRequestMutations;
  readonly celebrations: CelebrationMutations;
  readonly certificates: CertificateMutations;
  readonly checkinsSurveys: CheckinsSurveyMutations;
  readonly comment: CommentMutations;
  readonly courses: CoursesMutations;
  /** @deprecated Use timeTrackingMutations.* instead */
  readonly createMyTimeEntry: Scalars['String']['output'];
  readonly createOpenShiftAssignmentRequest: Scalars['String']['output'];
  readonly deleteEmployeeObjective: Scalars['String']['output'];
  readonly deleteOpenShiftAssignmentRequest: Scalars['String']['output'];
  readonly deleteUpcomingAbsence: Scalars['String']['output'];
  readonly document: DocumentMutations;
  readonly documentTemplate: DocumentTemplateMutations;
  readonly employeeData: EmployeeDataMutations;
  readonly employeeDataChangeRequest: EmployeeDataChangeRequestMutations;
  readonly employeeFeedback: EmployeeFeedbackMutations;
  readonly employeeHubFeatures: EmployeeHubFeatureMutations;
  readonly employeeSkills: EmployeeSkillMutations;
  readonly engagementSurveys: EngagementSurveysMutations;
  readonly enpsSurveys: EnpsSurveyMutations;
  readonly evaluation: EvaluationMutations;
  readonly expenseGroups: ExpenseGroupMutations;
  readonly expenses: ExpenseMutations;
  readonly finishEmployeeFeedbackOutcome: Scalars['String']['output'];
  /** @deprecated Old analytics was deprecated */
  readonly identify: Scalars['String']['output'];
  readonly inventory: InventoryMutations;
  readonly loomVideo: LoomVideoMutations;
  readonly notifications: NotificationMutations;
  readonly objectives: ObjectiveMutations;
  /** @deprecated Use timeTrackingMutations.* instead */
  readonly pauseMyTimeEntry: Scalars['String']['output'];
  readonly performanceReview: PerformanceReviewMutations;
  readonly project: ProjectMutations;
  readonly reaction: ReactionMutations;
  readonly recruiting: RecruitingMutations;
  readonly requestAbsence: Scalars['String']['output'];
  readonly requestForm: RequestFormMutations;
  /** @deprecated Use timeTrackingMutations.* instead */
  readonly resumeMyTimeEntry: Scalars['String']['output'];
  readonly sendFeedback: SendFeedbackPayload;
  readonly shiftChangeRequest: ShiftChangeRequestMutations;
  readonly skills: SkillMutations;
  readonly slack: SlackMutations;
  /** @deprecated Use timeTrackingMutations.* instead */
  readonly stopMyTimeEntry: Scalars['String']['output'];
  readonly submitEmployeeFeedback: Scalars['String']['output'];
  readonly ticket: TicketMutations;
  readonly timeSheet: TimeSheetMutations;
  readonly timeTracking: TimeTrackingMutations;
  readonly updateCustomerSupport: UpdateCustomerSupportPayload;
  readonly updateEmployeeFeedbackAnswer: Maybe<EmployeeFeedbackAnswer>;
  readonly updateEmployeeFeedbackResolution: Scalars['String']['output'];
  readonly updateEmployeeMeeting: Scalars['String']['output'];
  readonly updateEmployeeNotificationSettings: Scalars['String']['output'];
  readonly updateMyTimeEntryNotes: MyTimeEntry;
  readonly upsertEmployeeObjective: Scalars['String']['output'];
  readonly workflow: WorkflowMutations;
};


export type MutationAcceptEmployeeFeedbackOutcomeObjectivesArgs = {
  input: AcceptEmployeeFeedbackOutcomeObjectivesInput;
};


export type MutationCreateMyTimeEntryArgs = {
  input: InputMaybe<CreateMyTimeEntryInput>;
};


export type MutationCreateOpenShiftAssignmentRequestArgs = {
  input: CreateOpenShiftAssignmentRequestInput;
};


export type MutationDeleteEmployeeObjectiveArgs = {
  input: DeleteEmployeeObjectiveInput;
};


export type MutationDeleteOpenShiftAssignmentRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUpcomingAbsenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationFinishEmployeeFeedbackOutcomeArgs = {
  input: FinishEmployeeFeedbackOutcomeInput;
};


export type MutationIdentifyArgs = {
  input: IdentifyInput;
};


export type MutationPauseMyTimeEntryArgs = {
  id: Scalars['String']['input'];
  origin: InputMaybe<TimeEntryOrigin>;
};


export type MutationRequestAbsenceArgs = {
  input: RequestAbsenceInput;
};


export type MutationResumeMyTimeEntryArgs = {
  id: Scalars['String']['input'];
  origin: InputMaybe<TimeEntryOrigin>;
};


export type MutationSendFeedbackArgs = {
  input: SendFeedbackInput;
};


export type MutationStopMyTimeEntryArgs = {
  id: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
  origin: InputMaybe<TimeEntryOrigin>;
};


export type MutationSubmitEmployeeFeedbackArgs = {
  input: SubmitEmployeeFeedbackInput;
};


export type MutationUpdateCustomerSupportArgs = {
  input: CustomerSupportInput;
};


export type MutationUpdateEmployeeFeedbackAnswerArgs = {
  input: UpdateEmployeeFeedbackAnswerInput;
};


export type MutationUpdateEmployeeFeedbackResolutionArgs = {
  input: UpdateEmployeeFeedbackResolution;
};


export type MutationUpdateEmployeeMeetingArgs = {
  input: UpdateEmployeeMeetingInput;
};


export type MutationUpdateEmployeeNotificationSettingsArgs = {
  input: EmployeeNotificationSettingsInput;
};


export type MutationUpdateMyTimeEntryNotesArgs = {
  input: UpdateMyTimeEntryNotesInput;
};


export type MutationUpsertEmployeeObjectiveArgs = {
  input: UpsertEmployeeObjectiveInput;
};

export type MyApprovalRequestFilterInput = {
  readonly categoryIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly employeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly managerReportsType: InputMaybe<ManagerReportsType>;
  readonly relatedObjectName: InputMaybe<Scalars['String']['input']>;
  readonly startDateFrom: InputMaybe<Scalars['DateTime']['input']>;
  readonly startDateTo: InputMaybe<Scalars['DateTime']['input']>;
  readonly statuses: InputMaybe<ReadonlyArray<ApprovalRequestStatus>>;
};

export type MyFeedbacksFilter = {
  readonly state: InputMaybe<EmployeeFeedbackState>;
};

export type MyLocation = {
  readonly __typename?: 'MyLocation';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export type MyShiftChangeRequestFilterInput = {
  readonly approvalStatus: InputMaybe<ShiftChangeRequestApprovalStatus>;
  readonly colleagueApprovalStatus: InputMaybe<ShiftChangeRequestColleagueApprovalStatus>;
  readonly detailedStatus: InputMaybe<ShiftChangeRequestDetailedStatus>;
};

export type MyTimeEntry = {
  readonly __typename?: 'MyTimeEntry';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly breaks: ReadonlyArray<MyTimeEntryBreak>;
  readonly changeRequest: Maybe<TimeEntryChangeRequest>;
  readonly flair__Approval_Status__c: TimeEntryApprovalStatus;
  readonly flair__Cost_Center__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Is_Locked__c: Scalars['Boolean']['output'];
  readonly flair__Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Non_compliant__c: Scalars['Boolean']['output'];
  readonly flair__Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Payroll_Completed__c: Scalars['Boolean']['output'];
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Total_Break_Period_In_Hours__c: Scalars['Float']['output'];
  readonly flair__Total_Period_In_Hours__c: Scalars['Float']['output'];
  readonly flair__Working_Period_In_Hours__c: Scalars['Float']['output'];
  readonly location: Maybe<MyLocation>;
  readonly timeSheetId: Maybe<Scalars['String']['output']>;
};

export type MyTimeEntryBreak = {
  readonly __typename?: 'MyTimeEntryBreak';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly flair__Auto_adjusted_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__End_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Total_Break_Period_in_Hours__c: Scalars['Float']['output'];
  readonly flair__Total_Break_Period_in_Minutes__c: Scalars['Float']['output'];
};

export type MyTimeSheet = {
  readonly __typename?: 'MyTimeSheet';
  readonly Id: Scalars['String']['output'];
  readonly absences: ReadonlyArray<Absence>;
  readonly calendarPeriods: ReadonlyArray<CalendarPeriod>;
  readonly flair__Approval_Status__c: TimeSheetStatus;
  readonly flair__Current_Compensatory_Time_Level_1__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Current_Compensatory_Time_Level_2__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__Given_Compensatory_Time_Level_1__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Given_Compensatory_Time_Level_2__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Non_Deductible_Absence_Hours__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Target_Hours__c: Scalars['Float']['output'];
  readonly flair__Type__c: WorkloadType;
  readonly holidays: ReadonlyArray<LocationHoliday>;
  readonly paidAbsences: ReadonlyArray<Absence>;
  readonly projectTimeEntries: ReadonlyArray<ProjectTimeEntry>;
  readonly timeEntries: ReadonlyArray<MyTimeEntry>;
  readonly timeEntryChangeRequests: ReadonlyArray<TimeEntryChangeRequest>;
  readonly timeSheetDays: ReadonlyArray<TimeSheetDay>;
  readonly trackedTime: TimesheetTrackedTime;
  readonly workloads: ReadonlyArray<MyWorkload>;
};

export type MyWorkload = {
  readonly __typename?: 'MyWorkload';
  readonly Id: Scalars['String']['output'];
  readonly flair__End_Date__c: Maybe<Scalars['String']['output']>;
  readonly flair__Hours_Per_Day__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Public_Holiday__c: Maybe<Scalars['String']['output']>;
  /** @deprecated use flair__Time_Tracking_Type__c = 'NO_TRACKING' instead */
  readonly flair__Skip_Time_Tracking__c: Scalars['Boolean']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Time_Framework__c: Maybe<Scalars['String']['output']>;
  readonly flair__Time_Tracking_Type__c: WorkloadTrackingType;
  readonly flair__Type__c: WorkloadType;
  readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>;
  readonly flair__Workload_Model__c: WorkloadModel;
  readonly timeFramework: Maybe<TimeFramework>;
  readonly workloadWeeks: ReadonlyArray<WorkloadWeek>;
};

export type Navigatable = {
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly children: ReadonlyArray<Navigatable>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly fullPath: Scalars['String']['output'];
  readonly navigatableType: NavigatableType;
  readonly parentFolder: Maybe<EmployeeDocumentFolder>;
  readonly parentFolderId: Maybe<Scalars['String']['output']>;
  readonly parents: Maybe<ReadonlyArray<Navigatable>>;
};

export enum NavigatableErrorCode {
  DeleteNonEmptyFolderWithoutRecursion = 'DELETE_NON_EMPTY_FOLDER_WITHOUT_RECURSION',
  DocumentsUploadedByHrNonDeletable = 'DOCUMENTS_UPLOADED_BY_HR_NON_DELETABLE',
  FolderContainsNonDeletableItems = 'FOLDER_CONTAINS_NON_DELETABLE_ITEMS',
  NameAlreadyExists = 'NAME_ALREADY_EXISTS'
}

export type NavigatableIdInput = {
  readonly id: Scalars['String']['input'];
  readonly type: NavigatableType;
};

export type NavigatableIdPayload = {
  readonly __typename?: 'NavigatableIdPayload';
  readonly id: Scalars['String']['output'];
  readonly type: NavigatableType;
};

export type NavigatableRenameInput = {
  readonly name: Scalars['String']['input'];
  readonly navigatableId: NavigatableIdInput;
};

export type NavigatableRenamePayload = {
  readonly __typename?: 'NavigatableRenamePayload';
  readonly errorCode: Maybe<NavigatableErrorCode>;
  readonly record: Navigatable;
  readonly recordId: NavigatableIdPayload;
};

export enum NavigatableType {
  EmployeeDocument = 'EMPLOYEE_DOCUMENT',
  EmployeeDocumentFolder = 'EMPLOYEE_DOCUMENT_FOLDER'
}

export type NavigatableUpdateStatusInput = {
  readonly navigatableId: NavigatableIdInput;
  readonly status: Scalars['String']['input'];
};

export type NavigatableUpdateStatusPayload = {
  readonly __typename?: 'NavigatableUpdateStatusPayload';
  readonly record: EmployeeDocument;
  readonly recordId: NavigatableIdPayload;
};

export type NavigatablesDeletePayload = {
  readonly __typename?: 'NavigatablesDeletePayload';
  readonly employeeId: Scalars['String']['output'];
  readonly errorCode: Maybe<NavigatableErrorCode>;
  readonly parentFolder: EmployeeDocumentFolder;
  readonly parentFolderId: Scalars['String']['output'];
  readonly recordIds: ReadonlyArray<NavigatableIdPayload>;
  readonly records: ReadonlyArray<Navigatable>;
};

export type NavigatablesMovePayload = {
  readonly __typename?: 'NavigatablesMovePayload';
  readonly employeeId: Scalars['String']['output'];
  readonly errorCode: Maybe<NavigatableErrorCode>;
  readonly recordIds: ReadonlyArray<NavigatableIdPayload>;
  readonly records: ReadonlyArray<Navigatable>;
  readonly sourceFolderIds: ReadonlyArray<Scalars['String']['output']>;
  readonly sourceFolders: ReadonlyArray<EmployeeDocumentFolder>;
  readonly targetFolder: EmployeeDocumentFolder;
  readonly targetFolderId: Scalars['String']['output'];
};

export type Notification = {
  readonly __typename?: 'Notification';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly flair__Body__c: Maybe<Scalars['String']['output']>;
  readonly flair__Button_Link__c: Maybe<Scalars['String']['output']>;
  readonly flair__Button_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Is_Archived__c: Scalars['Boolean']['output'];
  readonly flair__Is_Read__c: Scalars['Boolean']['output'];
  readonly flair__Is_Snoozed__c: Scalars['Boolean']['output'];
  readonly flair__Is_Task__c: Scalars['Boolean']['output'];
  readonly flair__Object_Type__c: Maybe<Scalars['String']['output']>;
  readonly flair__Read_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Record_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Snoozed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Title__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type__c: Scalars['String']['output'];
  readonly flair__Unsnooze_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly renderInfo: NotificationRenderInfo;
};

export type NotificationFilterInput = {
  readonly archived: Scalars['Boolean']['input'];
  readonly onlyUnread: Scalars['Boolean']['input'];
  readonly snoozed: Scalars['Boolean']['input'];
};

export type NotificationMutations = {
  readonly __typename?: 'NotificationMutations';
  readonly archiveAllInboxNotifications: AllNotificationsActionPayload;
  readonly archiveNotification: NotificationPayload;
  readonly markAllInboxNotificationsAsRead: AllNotificationsActionPayload;
  readonly markAllTaskNotificationsAsRead: AllNotificationsActionPayload;
  readonly snoozeNotification: NotificationPayload;
  readonly unarchiveNotification: NotificationPayload;
  readonly unsnoozeNotification: NotificationPayload;
};


export type NotificationMutationsArchiveNotificationArgs = {
  input: ArchiveNotificationInput;
};


export type NotificationMutationsSnoozeNotificationArgs = {
  input: SnoozeNotificationInput;
};


export type NotificationMutationsUnarchiveNotificationArgs = {
  input: ArchiveNotificationInput;
};


export type NotificationMutationsUnsnoozeNotificationArgs = {
  input: UnsnoozeNotificationInput;
};

export type NotificationPagination = {
  readonly __typename?: 'NotificationPagination';
  readonly items: ReadonlyArray<Notification>;
  readonly paginationInfo: PaginationInfo;
  readonly unreadCount: Scalars['Int']['output'];
};

export type NotificationPayload = {
  readonly __typename?: 'NotificationPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<Notification>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type NotificationRenderInfo = {
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export enum NotificationType {
  None = 'NONE',
  NotPaid = 'NOT_PAID'
}

export type ObjectChanges = {
  readonly __typename?: 'ObjectChanges';
  readonly fields: ReadonlyArray<ObjectFieldChange>;
  readonly objectApiName: Scalars['String']['output'];
  readonly objectLabel: Scalars['String']['output'];
};

export type ObjectExtraFields = {
  readonly __typename?: 'ObjectExtraFields';
  readonly availableRecordTypes: ReadonlyArray<RecordType>;
  readonly form: ReadonlyArray<ExtraFieldFormInfo>;
  readonly objectApiName: Scalars['String']['output'];
  readonly recordTypes: ReadonlyArray<RecordType>;
  readonly table: ReadonlyArray<ExtraFieldTableInfo>;
};


export type ObjectExtraFieldsFormArgs = {
  name: InputMaybe<Scalars['String']['input']>;
};


export type ObjectExtraFieldsTableArgs = {
  name: InputMaybe<Scalars['String']['input']>;
};

export type ObjectFieldChange = {
  readonly __typename?: 'ObjectFieldChange';
  readonly fieldApiName: Scalars['String']['output'];
  readonly fieldLabel: Scalars['String']['output'];
  readonly fieldType: FieldType;
  readonly isRichTextArea: Maybe<Scalars['Boolean']['output']>;
  readonly newDisplayName: Maybe<Scalars['String']['output']>;
  readonly newValue: Maybe<Scalars['String']['output']>;
  readonly oldDisplayName: Maybe<Scalars['String']['output']>;
  readonly oldValue: Maybe<Scalars['String']['output']>;
};

export type ObjectFieldChangesInput = {
  readonly fieldChanges: ReadonlyArray<FieldChangeInput>;
  readonly objectName: Scalars['String']['input'];
  readonly positionChange: InputMaybe<PositionChangeInput>;
  readonly recordId: InputMaybe<Scalars['String']['input']>;
  readonly salaryChange: InputMaybe<SalaryChangeInput>;
};

export type ObjectFieldValue = {
  readonly __typename?: 'ObjectFieldValue';
  readonly fieldInfo: FieldInfo;
  readonly value: Maybe<Scalars['String']['output']>;
};

export type ObjectRecordType = {
  readonly __typename?: 'ObjectRecordType';
  readonly objectApiName: Scalars['String']['output'];
  readonly recordTypes: ReadonlyArray<RecordType>;
};

export type Objective = {
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly allHistoryItems: ReadonlyArray<ObjectiveHistoryItemCommon>;
  readonly allParents: ReadonlyArray<Objective>;
  readonly category: Maybe<ObjectiveCategory>;
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Current_Status__c: ObjectiveCurrentStatusType;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Due_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Expected_Progress__c: Scalars['Float']['output'];
  readonly flair__Is_Draft__c: Scalars['Boolean']['output'];
  readonly flair__Objective_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__Objective_Time_Period__c: Maybe<Scalars['String']['output']>;
  readonly flair__On_Track__c: Scalars['Boolean']['output'];
  readonly flair__Owner__c: Maybe<Scalars['String']['output']>;
  readonly flair__Progress__c: Scalars['Float']['output'];
  readonly flair__Start_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Status_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: ObjectiveStatusType;
  readonly flair__Visibility__c: ObjectiveVisibility;
  /** @deprecated use allHistoryItems */
  readonly historyItems: ReadonlyArray<ObjectiveHistoryItem>;
  readonly owner: Maybe<Colleague>;
  readonly period: Maybe<ObjectiveTimePeriod>;
  readonly sharedWith: ReadonlyArray<Colleague>;
  readonly statusChangedBy: Maybe<Colleague>;
  readonly tags: ReadonlyArray<Tag>;
};

export type ObjectiveCategory = {
  readonly __typename?: 'ObjectiveCategory';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
};

export enum ObjectiveCurrentStatusType {
  Behind = 'BEHIND',
  Canceled = 'CANCELED',
  Done = 'DONE',
  Draft = 'DRAFT',
  OnTrack = 'ON_TRACK',
  Unknown = 'UNKNOWN'
}

export type ObjectiveFilter = {
  readonly categoryId: InputMaybe<StringUpdateInput>;
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly goalType: InputMaybe<GoalType>;
  readonly periodId: InputMaybe<Scalars['String']['input']>;
  readonly tagId: InputMaybe<Scalars['String']['input']>;
};

export type ObjectiveFilterManager = {
  readonly categoryId: InputMaybe<StringUpdateInput>;
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly goalType: InputMaybe<GoalType>;
  readonly locationId: InputMaybe<Scalars['String']['input']>;
  readonly periodId: InputMaybe<Scalars['String']['input']>;
  readonly tagId: InputMaybe<Scalars['String']['input']>;
};

export type ObjectiveHistoryItem = ObjectiveHistoryItemCommon & {
  readonly __typename?: 'ObjectiveHistoryItem';
  readonly changedBy: Maybe<Colleague>;
  readonly changedById: Maybe<Scalars['String']['output']>;
  readonly date: Scalars['DateTime']['output'];
  readonly fieldApiName: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly newValue: Maybe<Scalars['String']['output']>;
  readonly objective: Maybe<Objective>;
  readonly objectiveId: Scalars['String']['output'];
  readonly objectiveType: ObjectiveType;
  readonly oldValue: Maybe<Scalars['String']['output']>;
  readonly requestId: Scalars['String']['output'];
};

export type ObjectiveHistoryItemCommon = {
  readonly changedBy: Maybe<Colleague>;
  readonly changedById: Maybe<Scalars['String']['output']>;
  readonly date: Scalars['DateTime']['output'];
  readonly id: Scalars['String']['output'];
  readonly objective: Maybe<Objective>;
  readonly objectiveId: Scalars['String']['output'];
  readonly objectiveType: ObjectiveType;
  readonly requestId: Scalars['String']['output'];
};

export type ObjectiveHistoryItemReference = {
  readonly __typename?: 'ObjectiveHistoryItemReference';
  readonly itemId: Maybe<Scalars['String']['output']>;
  readonly name: Maybe<Scalars['String']['output']>;
  readonly type: ObjectiveReferenceType;
};

export type ObjectiveIdInput = {
  readonly id: Scalars['String']['input'];
  readonly type: ObjectiveType;
};

export type ObjectiveIdUpdateInput = {
  readonly objectiveId: InputMaybe<ObjectiveIdInput>;
};

export type ObjectiveKeyResult = {
  readonly __typename?: 'ObjectiveKeyResult';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Change_Requested_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Completed__c: Scalars['Boolean']['output'];
  readonly flair__Current_Value__c: Scalars['Float']['output'];
  readonly flair__Employee_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Initial_Value__c: Scalars['Float']['output'];
  readonly flair__Progress__c: Scalars['Float']['output'];
  readonly flair__Target_Value__c: Scalars['Float']['output'];
  readonly flair__Team_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type__c: ObjectiveKeyResultType;
  readonly keyResultUpdates: ReadonlyArray<ObjectiveKeyResultUpdate>;
  readonly objective: TeamOrEmployeeObjective;
};

export enum ObjectiveKeyResultType {
  Boolean = 'BOOLEAN',
  Numeric = 'NUMERIC',
  Percentage = 'PERCENTAGE',
  Unknown = 'UNKNOWN'
}

export type ObjectiveKeyResultUpdate = {
  readonly __typename?: 'ObjectiveKeyResultUpdate';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Objective_Key_Result__c: Scalars['String']['output'];
  readonly flair__Previous_Value__c: Maybe<Scalars['String']['output']>;
  readonly flair__Value__c: Maybe<Scalars['String']['output']>;
  readonly keyResult: ObjectiveKeyResult;
};

export type ObjectiveMutations = {
  readonly __typename?: 'ObjectiveMutations';
  readonly cloneEmployeeObjective: CloneEmployeeObjectivePayload;
  readonly createEmployeeObjective: CreateEmployeeObjectivePayload;
  readonly createTeamObjective: CreateTeamObjectivePayload;
  readonly deleteObjective: DeleteObjectivePayload;
  readonly updateEmployeeObjectiveFields: UpdateObjectivePayload;
  readonly updateKeyResultValue: UpdateObjectiveKeyResultPayload;
  readonly updateObjectiveStatus: UpdateObjectivePayload;
  readonly updateTeamObjectiveFields: UpdateObjectivePayload;
};


export type ObjectiveMutationsCloneEmployeeObjectiveArgs = {
  input: CloneEmployeeObjectiveInput;
};


export type ObjectiveMutationsCreateEmployeeObjectiveArgs = {
  input: CreateEmployeeObjectiveInput;
};


export type ObjectiveMutationsCreateTeamObjectiveArgs = {
  input: CreateTeamObjectiveInput;
};


export type ObjectiveMutationsDeleteObjectiveArgs = {
  objectiveId: ObjectiveIdInput;
};


export type ObjectiveMutationsUpdateEmployeeObjectiveFieldsArgs = {
  input: UpdateEmployeeObjectiveFieldsInput;
};


export type ObjectiveMutationsUpdateKeyResultValueArgs = {
  input: UpdateObjectiveKeyResultValueInput;
  objective: ObjectiveIdInput;
};


export type ObjectiveMutationsUpdateObjectiveStatusArgs = {
  input: UpdateObjectiveStatusInput;
};


export type ObjectiveMutationsUpdateTeamObjectiveFieldsArgs = {
  input: UpdateTeamObjectiveFieldsInput;
};

export enum ObjectivePhaseActionType {
  Allow = 'ALLOW',
  Deny = 'DENY',
  RequireApproval = 'REQUIRE_APPROVAL'
}

export enum ObjectiveReferenceChangeEvent {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

export type ObjectiveReferenceHistoryItem = ObjectiveHistoryItemCommon & {
  readonly __typename?: 'ObjectiveReferenceHistoryItem';
  readonly changeEvent: ObjectiveReferenceChangeEvent;
  readonly changedBy: Maybe<Colleague>;
  readonly changedById: Maybe<Scalars['String']['output']>;
  readonly date: Scalars['DateTime']['output'];
  readonly id: Scalars['String']['output'];
  readonly objective: Maybe<Objective>;
  readonly objectiveId: Scalars['String']['output'];
  readonly objectiveType: ObjectiveType;
  readonly reference: ObjectiveHistoryItemReference;
  readonly requestId: Scalars['String']['output'];
};

export enum ObjectiveReferenceType {
  KeyResult = 'KEY_RESULT',
  Share = 'SHARE',
  Tag = 'TAG'
}

export type ObjectiveShare = {
  readonly __typename?: 'ObjectiveShare';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Company_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Team_Objective__c: Maybe<Scalars['String']['output']>;
};

export enum ObjectiveStatusType {
  Behind = 'BEHIND',
  Canceled = 'CANCELED',
  Done = 'DONE',
  OnTrack = 'ON_TRACK',
  Unknown = 'UNKNOWN'
}

export type ObjectiveTag = {
  readonly __typename?: 'ObjectiveTag';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Company_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Tag__c: Scalars['String']['output'];
  readonly flair__Team_Objective__c: Maybe<Scalars['String']['output']>;
};

export type ObjectiveTimePeriod = {
  readonly __typename?: 'ObjectiveTimePeriod';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly currentPhase: Maybe<ObjectiveTimePeriodPhase>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Current_Phase__c: Maybe<Scalars['String']['output']>;
  readonly flair__Development_Framework__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date__c: Scalars['LocalDate']['output'];
  readonly flair__Start_Date__c: Scalars['LocalDate']['output'];
  readonly framework: Maybe<DevelopmentFramework>;
};

export type ObjectiveTimePeriodPhase = {
  readonly __typename?: 'ObjectiveTimePeriodPhase';
  readonly createGoals: ObjectivePhaseActionType;
  readonly deleteGoals: ObjectivePhaseActionType;
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly updateGoals: ObjectivePhaseActionType;
  readonly updateProgress: ObjectivePhaseActionType;
  readonly updateWeight: ObjectivePhaseActionType;
};

export enum ObjectiveType {
  Company = 'COMPANY',
  Employee = 'EMPLOYEE',
  Team = 'TEAM'
}

export enum ObjectiveVisibility {
  AllTheCompany = 'ALL_THE_COMPANY',
  ManagementAndHr = 'MANAGEMENT_AND_HR',
  ProtectedItem = 'PROTECTED_ITEM',
  Unknown = 'UNKNOWN'
}

export type OpenShift = {
  readonly __typename?: 'OpenShift';
  readonly AssignmentRequests: ReadonlyArray<OpenShiftAssignmentRequest>;
  readonly Breaks: ReadonlyArray<ShiftBreak>;
  readonly EmployeeShifts: ReadonlyArray<EmployeeShift>;
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly Skills: ReadonlyArray<Skill>;
  readonly flair__Employees_Count__c: Scalars['Int']['output'];
  readonly flair__End_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Location__c: Scalars['String']['output'];
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Total_Break_Period_in_Minutes__c: Scalars['Int']['output'];
};

export type OpenShiftAssignmentRequest = {
  readonly __typename?: 'OpenShiftAssignmentRequest';
  readonly Id: Scalars['String']['output'];
  readonly employee: Employee;
  readonly flair__Confirmed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Open_Shift__c: Scalars['String']['output'];
};

export type OpenShiftSkillAssociation = {
  readonly __typename?: 'OpenShiftSkillAssociation';
  readonly flair__Open_Shift__c: Scalars['String']['output'];
  readonly flair__Skill__c: Scalars['String']['output'];
};

export type OrganizationFeature = {
  readonly __typename?: 'OrganizationFeature';
  readonly Id: Scalars['String']['output'];
};

export type OrganizationInfo = {
  readonly __typename?: 'OrganizationInfo';
  readonly features: Maybe<ReadonlyArray<OrganizationFeature>>;
  readonly flairHubPermissionSet: Scalars['Boolean']['output'];
  readonly salesforceUserId: Maybe<Scalars['String']['output']>;
  readonly subscriptionInfo: SubscriptionInfo;
};

export type OverlappingAbsence = {
  readonly __typename?: 'OverlappingAbsence';
  readonly Id: Scalars['String']['output'];
  readonly flair__Category_Name__c: Scalars['String']['output'];
  readonly flair__EmployeeId__c: Scalars['String']['output'];
  readonly flair__End_Date_Half_Day__c: Scalars['Boolean']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__End_Time__c: Scalars['String']['output'];
  readonly flair__Start_Date_Half_Day__c: Scalars['Boolean']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Start_Time__c: Scalars['String']['output'];
  readonly flair__Type__c: AbsenceType;
  readonly flair__Working_Amount__c: Scalars['Float']['output'];
  readonly requester: Colleague;
};

export type OvertimeFilter = {
  readonly endDate: Scalars['LocalDate']['input'];
  readonly startDate: Scalars['LocalDate']['input'];
};

export type OvertimeReportPayload = {
  readonly __typename?: 'OvertimeReportPayload';
  readonly employeeResults: ReadonlyArray<EmployeeOvertimeReport>;
  readonly overallOvertime: Maybe<Scalars['Float']['output']>;
};

export type PaginationInfo = {
  readonly __typename?: 'PaginationInfo';
  readonly totalCount: Scalars['Int']['output'];
};

export type PaginationInput = {
  readonly limit: Scalars['Int']['input'];
  readonly offset: Scalars['Int']['input'];
};

export type PastYearAllowanceSummary = {
  readonly __typename?: 'PastYearAllowanceSummary';
  readonly availableAmount: Scalars['Float']['output'];
  readonly carriedOverAmount: Scalars['Float']['output'];
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  readonly expiredAmount: Scalars['Float']['output'];
  readonly taken: Scalars['Float']['output'];
};

export type PeerReviewerPayload = {
  readonly __typename?: 'PeerReviewerPayload';
  readonly currentFeedbackRequest: Maybe<EmployeeFeedback>;
  readonly currentFeedbackRequestId: Scalars['String']['output'];
};

export type PendingTimeEntryChangeFilterInput = {
  readonly managerReportsType: ManagerReportsType;
};

export type PerformanceReviewMutations = {
  readonly __typename?: 'PerformanceReviewMutations';
  readonly changeReviewer: ChangeReviewerPayload;
  readonly trackDownloadPDFEvent: Scalars['Boolean']['output'];
};


export type PerformanceReviewMutationsChangeReviewerArgs = {
  input: ChangeReviewerInput;
};


export type PerformanceReviewMutationsTrackDownloadPdfEventArgs = {
  input: DownloadPdfAnalyticInput;
};

export type PickListEntry = {
  readonly __typename?: 'PickListEntry';
  readonly label: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type PicklistEntry = {
  readonly __typename?: 'PicklistEntry';
  readonly label: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type Position = {
  readonly __typename?: 'Position';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly childPositions: Maybe<ReadonlyArray<Maybe<Position>>>;
  readonly employment: Maybe<Employment>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Parent_Position__c: Maybe<Scalars['String']['output']>;
  readonly flair__Staffed__c: Scalars['Boolean']['output'];
  readonly flair__Title__c: Scalars['String']['output'];
  readonly parentPosition: Maybe<Position>;
};

export type PositionChangeInput = {
  readonly currentPositionId: InputMaybe<Scalars['String']['input']>;
  readonly effectiveDate: Scalars['String']['input'];
  readonly endDate: InputMaybe<Scalars['String']['input']>;
  readonly newPositionId: Scalars['String']['input'];
};

export type PositionFilterInput = {
  readonly activeOnly: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PricingPlan {
  Free = 'FREE',
  Paid = 'PAID',
  Trial = 'TRIAL'
}

export type ProbationsFilter = {
  readonly limit: InputMaybe<Scalars['Int']['input']>;
  readonly startDate: InputMaybe<Scalars['String']['input']>;
};

export type ProcessTimeEntryChangeRequestsPayload = {
  readonly __typename?: 'ProcessTimeEntryChangeRequestsPayload';
  readonly recordIds: ReadonlyArray<Scalars['String']['output']>;
  readonly records: ReadonlyArray<TimeEntryChangeRequest>;
};

export type Project = AnyObject & WithExtraFields & {
  readonly __typename?: 'Project';
  readonly Id: Scalars['String']['output'];
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly flair__Billable__c: Scalars['Boolean']['output'];
  readonly flair__Change_Requested_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Estimation__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Name__c: Scalars['String']['output'];
  readonly flair__Start_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly historyItems: ReadonlyArray<ProjectHistoryItem>;
  readonly recordType: RecordType;
  readonly timeTracked: Scalars['Float']['output'];
};

export type ProjectHistoryItem = {
  readonly __typename?: 'ProjectHistoryItem';
  readonly changeEvent: ChangeEvent;
  readonly changedBy: Maybe<Colleague>;
  readonly changedById: Maybe<Scalars['String']['output']>;
  readonly date: Scalars['DateTime']['output'];
  readonly fieldApiName: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly newValue: Maybe<Scalars['String']['output']>;
  readonly oldValue: Maybe<Scalars['String']['output']>;
  readonly projectId: Scalars['String']['output'];
  readonly requestId: Scalars['String']['output'];
};

export type ProjectMutations = {
  readonly __typename?: 'ProjectMutations';
  readonly saveProjectTimeEntriesByDays: SaveProjectTimeEntriesPayload;
  readonly saveProjectTimeEntriesByProjects: SaveProjectTimeEntriesPayload;
  readonly updateProject: UpdateProjectPayload;
};


export type ProjectMutationsSaveProjectTimeEntriesByDaysArgs = {
  input: SaveProjectTimeEntriesByDaysInput;
};


export type ProjectMutationsSaveProjectTimeEntriesByProjectsArgs = {
  input: SaveProjectTimeEntriesByProjectsInput;
};


export type ProjectMutationsUpdateProjectArgs = {
  input: UpdateProjectInput;
};

export type ProjectTimeEntriesFilterInput = {
  readonly projectsIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type ProjectTimeEntriesInput = {
  readonly costCenterId: InputMaybe<Scalars['String']['input']>;
  readonly date: Scalars['String']['input'];
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly minutes: InputMaybe<Scalars['Int']['input']>;
  readonly notes: InputMaybe<Scalars['String']['input']>;
  readonly projectId: Scalars['String']['input'];
  readonly timeEntryId: InputMaybe<Scalars['String']['input']>;
};

export type ProjectTimeEntry = WithExtraFields & {
  readonly __typename?: 'ProjectTimeEntry';
  readonly Id: Scalars['String']['output'];
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly flair__Cost_Center__c: Maybe<Scalars['String']['output']>;
  readonly flair__Date__c: Scalars['LocalDate']['output'];
  readonly flair__Employee_Timesheet__c: Scalars['String']['output'];
  readonly flair__Minutes__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Project__c: Maybe<Scalars['String']['output']>;
  readonly flair__Time_Entry__c: Maybe<Scalars['String']['output']>;
  readonly project: Maybe<Project>;
  readonly recordType: RecordType;
  readonly timeSheet: TimeSheet;
  readonly timeSheetDayProjectTimeEntry: Maybe<TimeSheetDayProjectTimeEntry>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly absence: Absence;
  readonly absencesCategories: ReadonlyArray<AbsenceCategory>;
  readonly activeEmployees: ReadonlyArray<Colleague>;
  readonly activeObjectivePeriods: ReadonlyArray<ObjectiveTimePeriod>;
  readonly allAbsences: ReadonlyArray<Absence>;
  readonly allCertificates: ReadonlyArray<Certificate>;
  readonly allObjectives: ReadonlyArray<Objective>;
  readonly anniversaries: ReadonlyArray<Colleague>;
  readonly announcements: ReadonlyArray<Announcement>;
  readonly anyObject: Maybe<AnyObject>;
  readonly approvalRequest: ApprovalRequest;
  readonly approvalRequests: ReadonlyArray<ApprovalRequest>;
  readonly availableEvaluationTemplates: ReadonlyArray<EvaluationTemplate>;
  readonly calculateAbsenceWorkingAmount: CalculateAbsenceWorkingAmountResponse;
  readonly candidate: JobCandidate;
  readonly candidateEvaluationById: CandidateEvaluation;
  readonly candidateListFilterOptions: CandidateListFilterOptions;
  readonly celebrationsPagination: CelebrationPagination;
  readonly comment: Maybe<Comment>;
  readonly commentable: Commentable;
  /** @deprecated Use commentable */
  readonly comments: ReadonlyArray<Comment>;
  readonly companyDocuments: ReadonlyArray<CompanyDocument>;
  readonly costCenters: ReadonlyArray<CostCenter>;
  readonly departments: ReadonlyArray<Department>;
  readonly devTools: DevTools;
  readonly dictionaryById: DictionaryItem;
  readonly dictionaryItemsByParent: ReadonlyArray<DictionaryItem>;
  readonly dictionaryItemsByType: ReadonlyArray<DictionaryItem>;
  readonly documentCategories: ReadonlyArray<DocumentCategory>;
  readonly documentTemplates: DocumentTemplates;
  readonly employee: Maybe<Colleague>;
  readonly employeeAbsenceCategoryById: Maybe<EmployeeAbsenceCategory>;
  readonly employeeAbsences: ReadonlyArray<Absence>;
  readonly employeeCourses: ReadonlyArray<EmployeeCourse>;
  readonly employeeDataChangeRequest: Maybe<EmployeeDataChangeRequest>;
  readonly employeeDataChangeRequests: ReadonlyArray<EmployeeDataChangeRequest>;
  readonly employeeEvaluationById: EmployeeEvaluation;
  readonly employeeFeedback: EmployeeFeedback;
  readonly employeeHubFeatures: Maybe<EmployeeHubFeature>;
  readonly employeeToken: Maybe<EmployeeTokenResponse>;
  readonly engagementSurveyEmployeeResponse: EngagementSurveyEmployeeResponse;
  readonly engagementSurveyEmployeeResponseBySurveyAndEmployee: Maybe<EngagementSurveyEmployeeResponse>;
  readonly evaluations: ReadonlyArray<CandidateEvaluation>;
  readonly expense: Maybe<Expense>;
  readonly expenseCategories: ReadonlyArray<ExpenseCategory>;
  readonly expenseGroup: Maybe<ExpenseGroup>;
  readonly expenseRules: Maybe<ReadonlyArray<ExpenseRule>>;
  readonly extraFields: ExtraFields;
  readonly hiringManager: HiringManager;
  readonly hub: Maybe<Hub>;
  readonly inventories: ReadonlyArray<Inventory>;
  readonly inventoryCategories: ReadonlyArray<RecordType>;
  readonly inventoryItemById: Maybe<InventoryItem>;
  readonly inventoryItemsPagination: InventoryItemsPagination;
  readonly job: Maybe<Job>;
  readonly jobs: ReadonlyArray<Job>;
  readonly lastUpdates: LastUpdateResponse;
  readonly locations: ReadonlyArray<Location>;
  readonly manager: Manager;
  readonly me: Me;
  readonly merchants: ReadonlyArray<Merchant>;
  readonly myAbsenceCategoryById: Maybe<EmployeeAbsenceCategory>;
  readonly myTimeSheets: ReadonlyArray<MyTimeSheet>;
  readonly navigatable: Maybe<Navigatable>;
  readonly newHires: ReadonlyArray<Colleague>;
  readonly objectRecordTypes: ReadonlyArray<ObjectRecordType>;
  readonly objective: Maybe<Objective>;
  readonly objectivePeriods: ReadonlyArray<ObjectiveTimePeriod>;
  readonly orgChartEmployees: ReadonlyArray<Colleague>;
  readonly organizationInfo: OrganizationInfo;
  readonly positions: ReadonlyArray<Position>;
  readonly probations: ReadonlyArray<Colleague>;
  readonly projects: ReadonlyArray<Project>;
  readonly recordFields: ReadonlyArray<ObjectFieldValue>;
  readonly recordTypes: ReadonlyArray<RecordType>;
  readonly reports: Reports;
  readonly requestForms: ReadonlyArray<RequestForm>;
  /** @deprecated Use absence */
  readonly requestedAbsence: RequestedAbsence;
  readonly schedulerShift: Maybe<Shift>;
  readonly schedulerShifts: ReadonlyArray<Shift>;
  readonly searchEmployeesForMention: ReadonlyArray<SearchMentionEmployeePayload>;
  readonly shiftChangeRequest: Maybe<ShiftChangeRequest>;
  readonly shiftChangeRequests: ReadonlyArray<ShiftChangeRequest>;
  readonly skills: ReadonlyArray<Skill>;
  readonly slack: SlackInfo;
  readonly tags: ReadonlyArray<Tag>;
  readonly teams: ReadonlyArray<Team>;
  readonly ticketById: Ticket;
  readonly ticketPagination: TicketPagination;
  readonly ticketPolicy: TicketPolicy;
  readonly timeSheet: TimeSheet;
  readonly timeSheetDay: Maybe<TimeSheetDay>;
  readonly timeSheetDays: ReadonlyArray<TimeSheetDay>;
  readonly timeSheets: ReadonlyArray<TimeSheet>;
  readonly workflow: Workflow;
  readonly workflowItems: WorkflowItemsPagination;
  readonly workflowItemsFilterOptions: WorkflowItemsFilterOptions;
  readonly workflows: WorkflowPagination;
  readonly workflowsFilterOptions: WorkflowsFilterOptions;
  readonly workloads: ReadonlyArray<EmployeeWorkload>;
};


export type QueryAbsenceArgs = {
  id: Scalars['String']['input'];
};


export type QueryActiveEmployeesArgs = {
  filter: InputMaybe<ActiveEmployeesFilter>;
  pagination: InputMaybe<PaginationInput>;
};


export type QueryAllAbsencesArgs = {
  filterBy: InputMaybe<EmployeeScopeFilter>;
  from: Scalars['DateTime']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryAllObjectivesArgs = {
  filter: InputMaybe<ObjectiveFilterManager>;
};


export type QueryAnniversariesArgs = {
  filter: InputMaybe<AnniversariesFilter>;
};


export type QueryAnyObjectArgs = {
  id: Scalars['String']['input'];
  objectApiName: Scalars['String']['input'];
};


export type QueryApprovalRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryApprovalRequestsArgs = {
  relatedRecordId: Scalars['String']['input'];
};


export type QueryAvailableEvaluationTemplatesArgs = {
  input: AvailableEvaluationTemplatesInput;
};


export type QueryCalculateAbsenceWorkingAmountArgs = {
  input: CalculateAbsenceWorkingAmountInput;
};


export type QueryCandidateArgs = {
  id: Scalars['String']['input'];
};


export type QueryCandidateEvaluationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCelebrationsPaginationArgs = {
  filter: CelebrationFilterInput;
  pagination: InputMaybe<PaginationInput>;
};


export type QueryCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type QueryCommentableArgs = {
  commentableId: CommentableIdInput;
};


export type QueryCommentsArgs = {
  recordId: Scalars['String']['input'];
};


export type QueryCompanyDocumentsArgs = {
  filter: InputMaybe<DocumentsFilter>;
};


export type QueryDictionaryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryDictionaryItemsByParentArgs = {
  id: Scalars['String']['input'];
};


export type QueryDictionaryItemsByTypeArgs = {
  type: DictionaryItemType;
};


export type QueryEmployeeArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeeAbsenceCategoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeeAbsencesArgs = {
  employeeId: Scalars['String']['input'];
  filter: InputMaybe<AbsenceFilterInput>;
  sort: InputMaybe<AscDescEnum>;
};


export type QueryEmployeeCoursesArgs = {
  employeeId: Scalars['String']['input'];
};


export type QueryEmployeeDataChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeeDataChangeRequestsArgs = {
  filter: InputMaybe<EmployeeDataChangeRequestFilter>;
};


export type QueryEmployeeEvaluationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeeFeedbackArgs = {
  feedbackId: Scalars['String']['input'];
};


export type QueryEmployeeTokenArgs = {
  email: Scalars['String']['input'];
};


export type QueryEngagementSurveyEmployeeResponseArgs = {
  id: Scalars['String']['input'];
};


export type QueryEngagementSurveyEmployeeResponseBySurveyAndEmployeeArgs = {
  employeeId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};


export type QueryEvaluationsArgs = {
  filter: InputMaybe<EvaluationsFilter>;
};


export type QueryExpenseArgs = {
  id: Scalars['String']['input'];
};


export type QueryExpenseGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryInventoryItemByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryInventoryItemsPaginationArgs = {
  employeeId: Scalars['String']['input'];
  filter: InputMaybe<InventoryItemFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<InventoryItemSortInput>;
};


export type QueryJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryLastUpdatesArgs = {
  filter: LastUpdateFilter;
  paginationInfo: LastUpdatePaginationInfo;
};


export type QueryMyAbsenceCategoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyTimeSheetsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryNavigatableArgs = {
  employeeId: Scalars['String']['input'];
  navigatableId: NavigatableIdInput;
};


export type QueryObjectRecordTypesArgs = {
  objectApiNames: ReadonlyArray<Scalars['String']['input']>;
};


export type QueryObjectiveArgs = {
  objectiveId: ObjectiveIdInput;
};


export type QueryPositionsArgs = {
  filter: InputMaybe<PositionFilterInput>;
};


export type QueryProbationsArgs = {
  filter: InputMaybe<ProbationsFilter>;
};


export type QueryRecordFieldsArgs = {
  fields: ReadonlyArray<Scalars['String']['input']>;
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};


export type QueryRecordTypesArgs = {
  objectApiName: Scalars['String']['input'];
};


export type QueryRequestFormsArgs = {
  filter: InputMaybe<RequestFormFilterInput>;
  sortBy: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestedAbsenceArgs = {
  absenceId: Scalars['String']['input'];
};


export type QuerySchedulerShiftArgs = {
  id: Scalars['String']['input'];
};


export type QuerySchedulerShiftsArgs = {
  filter: ShiftFilterInput;
};


export type QuerySearchEmployeesForMentionArgs = {
  filter: SearchEmployeesForMention;
};


export type QueryShiftChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryShiftChangeRequestsArgs = {
  filter: InputMaybe<ShiftChangeRequestFilterInput>;
};


export type QueryTeamsArgs = {
  filter: InputMaybe<TeamFilter>;
  pagination: InputMaybe<PaginationInput>;
};


export type QueryTicketByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryTicketPaginationArgs = {
  anonymousTicketIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  employeeId: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<TicketFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<TicketSortInput>;
};


export type QueryTimeSheetArgs = {
  id: Scalars['String']['input'];
};


export type QueryTimeSheetDayArgs = {
  day: Scalars['LocalDate']['input'];
  employeeId: Scalars['String']['input'];
};


export type QueryTimeSheetDaysArgs = {
  request: TimeSheetDaysRequestInput;
};


export type QueryTimeSheetsArgs = {
  ids: ReadonlyArray<Scalars['String']['input']>;
};


export type QueryWorkflowArgs = {
  workflowId: Scalars['String']['input'];
};


export type QueryWorkflowItemsArgs = {
  filter: InputMaybe<WorkflowItemsFilterInput2>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<WorkflowsItemsListSortInput>;
  workflowContext: WorkflowContext;
};


export type QueryWorkflowItemsFilterOptionsArgs = {
  workflowContext: WorkflowContext;
  workflowId: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkflowsArgs = {
  filter: InputMaybe<WorkflowsFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  sort: InputMaybe<WorkflowListSortInput>;
  workflowContext: WorkflowContext;
};


export type QueryWorkflowsFilterOptionsArgs = {
  workflowContext: WorkflowContext;
};


export type QueryWorkloadsArgs = {
  employeeId: Scalars['String']['input'];
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};

export enum QuestionnaireType {
  Dropdown = 'DROPDOWN',
  FreeSlider = 'FREE_SLIDER',
  FreeText = 'FREE_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Rating = 'RATING',
  Scorecard = 'SCORECARD',
  SingleChoice = 'SINGLE_CHOICE',
  Unknown = 'UNKNOWN',
  YesNo = 'YES_NO'
}

export type Reaction = {
  readonly __typename?: 'Reaction';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employee: Employee;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Related_Id__c: Scalars['String']['output'];
  readonly flair__Related_Object_Name__c: Scalars['String']['output'];
  readonly flair__Text__c: Scalars['String']['output'];
};

export type ReactionMutations = {
  readonly __typename?: 'ReactionMutations';
  readonly createReaction: ReactionPayload;
  readonly deleteReaction: ReactionPayload;
};


export type ReactionMutationsCreateReactionArgs = {
  input: CreateReactionInput;
};


export type ReactionMutationsDeleteReactionArgs = {
  id: Scalars['String']['input'];
};

export type ReactionPayload = {
  readonly __typename?: 'ReactionPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Id__c: Maybe<Scalars['String']['output']>;
  readonly flair__Related_Object_Name__c: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<Reaction>;
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly related: Maybe<WithReactions>;
};

export type RecordType = {
  readonly __typename?: 'RecordType';
  readonly DeveloperName: Scalars['String']['output'];
  readonly Id: Scalars['String']['output'];
  readonly IsAvailable: Scalars['Boolean']['output'];
  readonly IsDefault: Scalars['Boolean']['output'];
  readonly IsMaster: Scalars['Boolean']['output'];
  /** @deprecated Record Types use Name field as label */
  readonly Label: Maybe<Scalars['String']['output']>;
  readonly Name: Scalars['String']['output'];
  readonly SobjectType: Maybe<Scalars['String']['output']>;
};

export type RecruitingDocument = {
  readonly __typename?: 'RecruitingDocument';
  readonly ContentDocumentLinks__r: Maybe<ReadonlyArray<ContentDocumentLink>>;
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Title__c: Scalars['String']['output'];
};

export enum RecruitingDocumentVisiblity {
  HiringManager = 'HIRING_MANAGER',
  HiringManagerAndEvaluator = 'HIRING_MANAGER_AND_EVALUATOR'
}

export type RecruitingMutations = {
  readonly __typename?: 'RecruitingMutations';
  readonly meRefererId: Scalars['String']['output'];
  readonly meReferrerLink: Maybe<Scalars['String']['output']>;
};

export type RejectTimeEntryChangeRequestInput = {
  readonly ids: ReadonlyArray<Scalars['String']['input']>;
};

export type RemoveSkillFromEmployeeInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
};

export enum RenderInfoType {
  AbsenceApprovalRequestNotificationRenderInfo = 'AbsenceApprovalRequestNotificationRenderInfo',
  AbsenceNotificationRenderInfo = 'AbsenceNotificationRenderInfo',
  CandidateEvaluationNotificationRenderInfo = 'CandidateEvaluationNotificationRenderInfo',
  CelebrationNotificationRenderInfo = 'CelebrationNotificationRenderInfo',
  CommentNotificationRenderInfo = 'CommentNotificationRenderInfo',
  SimpleNotificationRenderInfo = 'SimpleNotificationRenderInfo',
  TicketClosedNotificationRenderInfo = 'TicketClosedNotificationRenderInfo',
  TicketManagerClosedNotificationRenderInfo = 'TicketManagerClosedNotificationRenderInfo',
  TicketManagerStatusChangedNotificationRenderInfo = 'TicketManagerStatusChangedNotificationRenderInfo',
  TicketSharedNotificationRenderInfo = 'TicketSharedNotificationRenderInfo',
  TicketStatusChangedNotificationRenderInfo = 'TicketStatusChangedNotificationRenderInfo',
  TicketSubmittedNotificationRenderInfo = 'TicketSubmittedNotificationRenderInfo',
  TimeBalanceWithdrawalNotificationRenderInfo = 'TimeBalanceWithdrawalNotificationRenderInfo',
  TimeEntryChangeRequestNotificationRenderInfo = 'TimeEntryChangeRequestNotificationRenderInfo',
  TimeEntryNotificationRenderInfo = 'TimeEntryNotificationRenderInfo',
  TimeLimitTimeEntryNotificationRenderInfo = 'TimeLimitTimeEntryNotificationRenderInfo',
  WorkflowItemNotificationRenderInfo = 'WorkflowItemNotificationRenderInfo'
}

export type Reports = {
  readonly __typename?: 'Reports';
  readonly absenceRate: Maybe<AbsenceRateReportPayload>;
  readonly employeeOvertime: Maybe<OvertimeReportPayload>;
  readonly turnoverRate: Maybe<EmployeeTurnoverRateReportPayload>;
};


export type ReportsAbsenceRateArgs = {
  filter: AbsenceRateFilter;
};


export type ReportsEmployeeOvertimeArgs = {
  filter: OvertimeFilter;
};


export type ReportsTurnoverRateArgs = {
  filter: EmployeeTurnoverRateFilter;
};

export type RequestAbsenceInput = {
  readonly attachedFile: InputMaybe<FileInput>;
  readonly daysTimes: InputMaybe<ReadonlyArray<DayTimeInput>>;
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly flair__Comment__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Employee_Absence_Category__c: Scalars['String']['input'];
  readonly flair__Employee_Absence_Request_Policy__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__End_Date__c: Scalars['String']['input'];
  readonly flair__End_Time__c: InputMaybe<Scalars['Time']['input']>;
  readonly flair__Start_Date__c: Scalars['String']['input'];
  readonly flair__Start_Time__c: InputMaybe<Scalars['Time']['input']>;
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly loomVideo: InputMaybe<CreateLoomVideoInput>;
};

export type RequestForm = {
  readonly __typename?: 'RequestForm';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly extraFieldInfos: Maybe<ReadonlyArray<ExtraFieldFormInfo>>;
  readonly flair__Active__c: Scalars['Boolean']['output'];
  readonly flair__Data_Change_Object_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Data_Change_Objects_Fields__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Field_Api_Name__c: Maybe<Scalars['String']['output']>;
  readonly flair__Extra_Fields_Config__c: Maybe<Scalars['String']['output']>;
  readonly flair__Information__c: Maybe<Scalars['String']['output']>;
  readonly flair__Mandatory_Reason__c: Scalars['Boolean']['output'];
  readonly flair__Position_Change_Enabled__c: Scalars['Boolean']['output'];
  readonly flair__Request_Type__c: RequestFormType;
  readonly flair__Require_Approval__c: Scalars['Boolean']['output'];
  readonly flair__Salary_Change_Enabled__c: Scalars['Boolean']['output'];
  readonly flair__Visibility__c: RequestFormVisibility;
  readonly objectsFields: ReadonlyArray<RequestFormObjectFields>;
  readonly recordTypes: ReadonlyArray<RecordType>;
};

export type RequestFormFilterInput = {
  readonly formId: InputMaybe<Scalars['String']['input']>;
  readonly objectName: InputMaybe<Scalars['String']['input']>;
  readonly type: InputMaybe<RequestFormType>;
};

export type RequestFormMutations = {
  readonly __typename?: 'RequestFormMutations';
  readonly createDataChangeRequest: CreateDataChangeRequestPayload;
  readonly validateCreateDataChangeRequest: ValidateDataChangeRequestPayload;
};


export type RequestFormMutationsCreateDataChangeRequestArgs = {
  input: CreateDataChangeRequestInput;
};


export type RequestFormMutationsValidateCreateDataChangeRequestArgs = {
  input: CreateDataChangeRequestInput;
};

export type RequestFormObjectFields = {
  readonly __typename?: 'RequestFormObjectFields';
  readonly fields: ReadonlyArray<Scalars['String']['output']>;
  readonly objectName: Scalars['String']['output'];
};

export enum RequestFormType {
  NoObject = 'NO_OBJECT',
  ObjectCreate = 'OBJECT_CREATE',
  ObjectDataChange = 'OBJECT_DATA_CHANGE'
}

export enum RequestFormVisibility {
  Hr = 'HR',
  HrEmployee = 'HR_EMPLOYEE',
  HrManager = 'HR_MANAGER',
  HrManagerEmployee = 'HR_MANAGER_EMPLOYEE'
}

export type RequestedAbsence = {
  readonly __typename?: 'RequestedAbsence';
  readonly ContentDocumentLinks__r: ReadonlyArray<ContentDocumentLink>;
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly approvalRequests: ReadonlyArray<ApprovalRequest>;
  readonly category: EmployeeAbsenceCategory;
  readonly flair__Amount__c: Scalars['Float']['output'];
  readonly flair__Approval_Status__c: AbsenceApprovalStatus;
  readonly flair__Category_Icon__c: Scalars['String']['output'];
  readonly flair__Category_Name__c: Scalars['String']['output'];
  readonly flair__Comment__c: Maybe<Scalars['String']['output']>;
  readonly flair__EmployeeId__c: Scalars['String']['output'];
  readonly flair__Employee_Absence_Category__c: Scalars['String']['output'];
  readonly flair__End_Date_Half_Day__c: Scalars['Boolean']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__End_Time__c: Scalars['Time']['output'];
  readonly flair__LocationId__c: Scalars['String']['output'];
  readonly flair__Loom_Video__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Date_Half_Day__c: Scalars['Boolean']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Start_Time__c: Scalars['Time']['output'];
  readonly flair__Type__c: AbsenceType;
  readonly flair__Working_Amount__c: Scalars['Float']['output'];
  readonly loomVideo: Maybe<LoomVideo>;
  readonly overlappingAbsences: ReadonlyArray<OverlappingAbsence>;
  readonly requester: Colleague;
};

export enum RequesterType {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type RespondToShiftChangeRequestInput = {
  readonly colleagueApprovalStatus: ShiftChangeRequestColleagueApprovalStatus;
  readonly id: Scalars['String']['input'];
};

export type RespondToShiftChangeRequestPayload = {
  readonly __typename?: 'RespondToShiftChangeRequestPayload';
  readonly query: Query;
  readonly record: Maybe<ShiftChangeRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type SalaryChangeInput = {
  readonly currentSalaryId: InputMaybe<Scalars['String']['input']>;
  readonly effectiveDate: Scalars['String']['input'];
  readonly endDate: InputMaybe<Scalars['String']['input']>;
  readonly isQuickUpdate: Scalars['Boolean']['input'];
  readonly newFrequency: InputMaybe<Scalars['String']['input']>;
  readonly newValue: Scalars['Float']['input'];
  readonly notes: InputMaybe<Scalars['String']['input']>;
};

export enum SalaryType {
  BiWeekly = 'BiWeekly',
  Hourly = 'Hourly',
  Monthly = 'Monthly',
  Unknown = 'Unknown',
  Weekly = 'Weekly'
}

export type SaveCandiateEvaluationInput = {
  readonly candidateEvaluationId: Scalars['String']['input'];
  readonly evaluated: Scalars['Boolean']['input'];
  readonly finalComment: InputMaybe<Scalars['String']['input']>;
  readonly finalScore: InputMaybe<Scalars['Int']['input']>;
};

export type SaveCandidateEvaluationInput = {
  readonly candidateEvaluationId: Scalars['String']['input'];
  readonly evaluated: Scalars['Boolean']['input'];
  readonly finalComment: InputMaybe<Scalars['String']['input']>;
  readonly finalScore: InputMaybe<Scalars['Int']['input']>;
};

export type SaveEmployeeEvaluationInput = {
  readonly employeeEvaluationId: Scalars['String']['input'];
  readonly evaluated: Scalars['Boolean']['input'];
  readonly finalComment: InputMaybe<Scalars['String']['input']>;
  readonly finalScore: InputMaybe<Scalars['Int']['input']>;
};

export type SaveEvaluationAnswerInput = {
  readonly candidateEvaluationId: InputMaybe<Scalars['String']['input']>;
  readonly employeeEvaluationId: InputMaybe<Scalars['String']['input']>;
  readonly evaluationTemplateOption: InputMaybe<Scalars['String']['input']>;
  readonly evaluationTemplateQuestion: Scalars['String']['input'];
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly message: InputMaybe<Scalars['String']['input']>;
  readonly questionType: EvaluationTemplateQuestionType;
  readonly score: InputMaybe<Scalars['Int']['input']>;
};

export type SaveEvaluationAnswerPayload = {
  readonly __typename?: 'SaveEvaluationAnswerPayload';
  readonly record: Maybe<EvaluationAnswer>;
  readonly recordId: Scalars['String']['output'];
};

export type SaveEvaluationTemplateAnswerInput = {
  readonly candidateEvaluationId: InputMaybe<Scalars['String']['input']>;
  readonly employeeEvaluationId: InputMaybe<Scalars['String']['input']>;
  readonly evaluationTemplateOption: InputMaybe<Scalars['String']['input']>;
  readonly evaluationTemplateQuestion: Scalars['String']['input'];
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly message: InputMaybe<Scalars['String']['input']>;
  readonly score: InputMaybe<Scalars['Int']['input']>;
  readonly type: EvaluationTemplateQuestionType;
};

export type SaveProjectTimeEntriesByDaysInput = {
  readonly date: Scalars['String']['input'];
  readonly timeEntries: ReadonlyArray<ProjectTimeEntriesInput>;
  readonly timesheetId: Scalars['String']['input'];
};

export type SaveProjectTimeEntriesByProjectsInput = {
  readonly timeEntries: ReadonlyArray<ProjectTimeEntriesInput>;
  readonly timesheetId: Scalars['String']['input'];
};

export type SaveProjectTimeEntriesPayload = {
  readonly __typename?: 'SaveProjectTimeEntriesPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly recordIds: ReadonlyArray<Scalars['String']['output']>;
  readonly records: ReadonlyArray<ProjectTimeEntry>;
};

export type SearchEmployeesForMention = {
  readonly recordId: Scalars['String']['input'];
  readonly searchTerm: Scalars['String']['input'];
};

export type SearchMentionEmployeePayload = {
  readonly __typename?: 'SearchMentionEmployeePayload';
  readonly avatarUrl: Maybe<Scalars['String']['output']>;
  readonly hasAccess: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly position: Maybe<Scalars['String']['output']>;
};

export type SendFeedbackInput = {
  readonly text: Scalars['String']['input'];
};

export type SendFeedbackPayload = {
  readonly __typename?: 'SendFeedbackPayload';
  readonly id: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

export type SettingItem = {
  readonly id: Scalars['String']['input'];
  readonly order: Scalars['Float']['input'];
  readonly visible: Scalars['Boolean']['input'];
};

export type Shift = {
  readonly __typename?: 'Shift';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly breaks: ReadonlyArray<ShiftBreak>;
  readonly department: Maybe<Department>;
  readonly employee: Maybe<Employee>;
  readonly flair__Allow_Shift_Transfer__c: Maybe<Scalars['Boolean']['output']>;
  readonly flair__Employee_Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Linked_Resource_Id__c: Scalars['String']['output'];
  readonly flair__Linked_Resource_Object__c: Scalars['String']['output'];
  readonly flair__Linked_Target_Id__c: Scalars['String']['output'];
  readonly flair__Linked_Target_Object__c: Scalars['String']['output'];
  readonly flair__Min_Days_Before_Shift_Transfer__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Paid_Preparation_Time_After__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Paid_Preparation_Time_Before__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Paid_Time_In_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Pending_Change_Requests_Count__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Resource_Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Shift_Color__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Target_Department__c: Maybe<Scalars['String']['output']>;
  readonly flair__Target_Location__c: Maybe<Scalars['String']['output']>;
  readonly flair__Title__c: Maybe<Scalars['String']['output']>;
  readonly flair__Total_Break_Period_in_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Total_Time_In_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Working_Time_In_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly location: Maybe<Location>;
  readonly shiftChangeRequests: ReadonlyArray<ShiftChangeRequest>;
  readonly shiftLabels: ReadonlyArray<ShiftLabel>;
};

export type ShiftBreak = {
  readonly __typename?: 'ShiftBreak';
  readonly Id: Scalars['String']['output'];
  readonly flair__End_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
};

export type ShiftChangeRequest = {
  readonly __typename?: 'ShiftChangeRequest';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Approval_Status_Changed_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus;
  readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus;
  readonly flair__Change_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Colleague_Approval_Status__c: Maybe<ShiftChangeRequestColleagueApprovalStatus>;
  readonly flair__Colleague_Responded_At__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Proposed_Resource_Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Request_Type__c: ShiftChangeRequestType;
  readonly flair__Requested_At__c: Scalars['DateTime']['output'];
  readonly flair__Requested_By_Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Shift__c: Scalars['String']['output'];
  readonly proposedResourceEmployee: Maybe<Employee>;
  readonly requestedByEmployee: Maybe<Employee>;
  readonly shift: Shift;
};

export enum ShiftChangeRequestApprovalStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum ShiftChangeRequestColleagueApprovalStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export enum ShiftChangeRequestDetailedStatus {
  Approved = 'APPROVED',
  CancelledByRequester = 'CANCELLED_BY_REQUESTER',
  PendingColleagueApproval = 'PENDING_COLLEAGUE_APPROVAL',
  PendingManagersApproval = 'PENDING_MANAGERS_APPROVAL',
  RejectedByColleague = 'REJECTED_BY_COLLEAGUE',
  RejectedByManagers = 'REJECTED_BY_MANAGERS',
  Unknown = 'UNKNOWN'
}

export type ShiftChangeRequestFilterInput = {
  readonly approvalStatus: InputMaybe<ShiftChangeRequestApprovalStatus>;
  readonly proposedResourceEmployeeId: InputMaybe<Scalars['String']['input']>;
  readonly requestedByEmployeeId: InputMaybe<Scalars['String']['input']>;
  readonly shiftId: InputMaybe<Scalars['String']['input']>;
};

export type ShiftChangeRequestMutations = {
  readonly __typename?: 'ShiftChangeRequestMutations';
  readonly cancelShiftChangeRequest: CancelShiftChangeRequestPayload;
  readonly createShiftChangeRequest: CreateShiftChangeRequestPayload;
  readonly respondToShiftChangeRequest: RespondToShiftChangeRequestPayload;
};


export type ShiftChangeRequestMutationsCancelShiftChangeRequestArgs = {
  input: CancelShiftChangeRequestInput;
};


export type ShiftChangeRequestMutationsCreateShiftChangeRequestArgs = {
  input: CreateShiftChangeRequestInput;
};


export type ShiftChangeRequestMutationsRespondToShiftChangeRequestArgs = {
  input: RespondToShiftChangeRequestInput;
};

export enum ShiftChangeRequestType {
  ShiftTransfer = 'SHIFT_TRANSFER'
}

export type ShiftFilterInput = {
  readonly employeesIds: ReadonlyArray<Scalars['String']['input']>;
  readonly endDate: Scalars['DateTime']['input'];
  readonly startDate: Scalars['DateTime']['input'];
};

export type ShiftLabel = {
  readonly __typename?: 'ShiftLabel';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Tag_Name__c: Scalars['String']['output'];
};

export type ShiftLabelAssociation = {
  readonly __typename?: 'ShiftLabelAssociation';
  readonly Id: Scalars['String']['output'];
  readonly flair__Shift_Label__c: Scalars['String']['output'];
  readonly flair__Shift__c: Scalars['String']['output'];
};

export type SignRequestSigner = {
  readonly __typename?: 'SignRequestSigner';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__External_Signature_Link__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: SignRequestSignerStatus;
};

export enum SignRequestSignerStatus {
  Draft = 'DRAFT',
  Notified = 'NOTIFIED',
  Prepared = 'PREPARED',
  Signed = 'SIGNED',
  Unknown = 'UNKNOWN'
}

export type SimpleNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'SimpleNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
};

export type Skill = {
  readonly __typename?: 'Skill';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly createdBy: Maybe<Colleague>;
  readonly employeeSkills: ReadonlyArray<EmployeeSkillAssociation>;
  readonly flair__Color__c: Maybe<Scalars['String']['output']>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Rateable__c: Scalars['Boolean']['output'];
  readonly flair__Short_Name__c: Maybe<Scalars['String']['output']>;
};

export type SkillMutations = {
  readonly __typename?: 'SkillMutations';
  readonly createSkill: SkillPayload;
  readonly deleteSkill: SkillPayload;
  readonly updateSkill: SkillPayload;
};


export type SkillMutationsCreateSkillArgs = {
  input: CreateSkillInput;
};


export type SkillMutationsDeleteSkillArgs = {
  input: DeleteSkillInput;
};


export type SkillMutationsUpdateSkillArgs = {
  input: UpdateSkillInput;
};

export type SkillPayload = {
  readonly __typename?: 'SkillPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<Skill>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type SlackInfo = {
  readonly __typename?: 'SlackInfo';
  readonly employeeSlackConnection: Maybe<EmployeeSlackConnection>;
  readonly orgHasSlackEnabled: Scalars['Boolean']['output'];
};

export type SlackInstallationResponse = {
  readonly __typename?: 'SlackInstallationResponse';
  readonly installationUri: Scalars['String']['output'];
};

export type SlackMutations = {
  readonly __typename?: 'SlackMutations';
  readonly connectToSlackUser: UpdateSlackUserPayload;
  readonly employeeAuthorizeUrl: SlackInstallationResponse;
  readonly setSlackStatusAutoUpdate: SlackStatusAutoUpdatePayload;
  readonly setUserStatusForDebugOnly: Scalars['String']['output'];
  readonly slackAppAuthorizeUrl: SlackInstallationResponse;
};


export type SlackMutationsConnectToSlackUserArgs = {
  input: UpdateSlackUserInput;
};


export type SlackMutationsEmployeeAuthorizeUrlArgs = {
  successRedirectUrl: InputMaybe<Scalars['String']['input']>;
  userScopes: ReadonlyArray<Scalars['String']['input']>;
};


export type SlackMutationsSetSlackStatusAutoUpdateArgs = {
  input: SlackStatusAutoUpdateInput;
};


export type SlackMutationsSetUserStatusForDebugOnlyArgs = {
  statusEmojii: InputMaybe<Scalars['String']['input']>;
  statusText: Scalars['String']['input'];
};

export type SlackStatusAutoUpdateInput = {
  readonly slackStatusAutoUpdate: Scalars['Boolean']['input'];
};

export type SlackStatusAutoUpdatePayload = {
  readonly __typename?: 'SlackStatusAutoUpdatePayload';
  readonly query: Maybe<Query>;
};

export type SliderSettingsPayload = {
  readonly __typename?: 'SliderSettingsPayload';
  readonly query: Query;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type SnoozeNotificationInput = {
  readonly id: Scalars['String']['input'];
  readonly unsnoozeAt: Scalars['DateTime']['input'];
};

export type SortInput = {
  readonly field: Scalars['String']['input'];
  readonly order: InputMaybe<AscDescEnum>;
};

export type StartMyTimeEntryInput = {
  readonly geolocation: InputMaybe<GeolocationCoordinatesInput>;
  readonly kioskId: InputMaybe<Scalars['String']['input']>;
};

export type StopMyTimeEntryInput = {
  readonly Id: Scalars['String']['input'];
  readonly geolocation: InputMaybe<GeolocationCoordinatesInput>;
  readonly kioskId: InputMaybe<Scalars['String']['input']>;
  readonly notes: InputMaybe<Scalars['String']['input']>;
  readonly updateBreaks: InputMaybe<ReadonlyArray<TimeEntryBreakInput>>;
};

export type StringUpdateInput = {
  readonly value: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployeeFeedbackInput = {
  readonly answers: InputMaybe<ReadonlyArray<UpdateEmployeeFeedbackAnswerInput>>;
  readonly id: Scalars['String']['input'];
  readonly onlyUpdateAnswers: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitEngagementSurveyInput = {
  readonly responseId: Scalars['String']['input'];
};

export type SubmitTimeEntryChangeRequestInput = {
  readonly breaks: ReadonlyArray<TimeEntryBreakChangeRequestInput>;
  readonly changeRequestId: InputMaybe<Scalars['String']['input']>;
  readonly costCenterId: InputMaybe<Scalars['String']['input']>;
  readonly creationNotes: InputMaybe<Scalars['String']['input']>;
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly notes: InputMaybe<Scalars['String']['input']>;
  readonly projectEntries: InputMaybe<SaveProjectTimeEntriesByDaysInput>;
  readonly startDatetime: Scalars['DateTime']['input'];
  readonly timeEntryId: InputMaybe<Scalars['String']['input']>;
};

export type SubmitTimeEntryChangeRequestPayload = {
  readonly __typename?: 'SubmitTimeEntryChangeRequestPayload';
  /** @deprecated use errors2 instead */
  readonly errors: ReadonlyArray<TimeTrackingErrorV2>;
  readonly errors2: ReadonlyArray<TimeTrackingErrorBase>;
  readonly projectTimeEntries: ReadonlyArray<ProjectTimeEntry>;
  readonly record: Maybe<TimeEntryChangeRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type SubmitTimeEntryInput = {
  readonly breaks: ReadonlyArray<TimeEntryBreakInput>;
  readonly costCenterId: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly notes: InputMaybe<Scalars['String']['input']>;
  readonly projectEntries: InputMaybe<SaveProjectTimeEntriesByDaysInput>;
  readonly startDatetime: Scalars['DateTime']['input'];
  readonly timeEntryId: InputMaybe<Scalars['String']['input']>;
};

export type SubmitTimeEntryPayload = {
  readonly __typename?: 'SubmitTimeEntryPayload';
  /** @deprecated use errors2 instead */
  readonly errors: ReadonlyArray<TimeTrackingErrorV2>;
  readonly errors2: ReadonlyArray<TimeTrackingErrorBase>;
  readonly projectTimeEntries: ReadonlyArray<ProjectTimeEntry>;
  readonly record: Maybe<TimeEntry>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type SubscriptionInfo = {
  readonly __typename?: 'SubscriptionInfo';
  readonly activeDocgenTemplates: Scalars['Int']['output'];
  readonly activeEmployeeNumber: Scalars['Int']['output'];
  readonly ai: Scalars['Boolean']['output'];
  readonly bringYourContractJobPosting: Scalars['Boolean']['output'];
  readonly cvParsing: Scalars['Boolean']['output'];
  readonly docgen: Scalars['Boolean']['output'];
  readonly docgenTemplates: Scalars['Int']['output'];
  readonly esign: Scalars['Boolean']['output'];
  readonly exceededLicensesAlert: Scalars['Boolean']['output'];
  readonly flairScheduler: Scalars['Boolean']['output'];
  readonly notPaidAlert: Scalars['Boolean']['output'];
  readonly notification: NotificationType;
  readonly organicJobPosting: Scalars['Boolean']['output'];
  readonly paidJobPosting: Scalars['Boolean']['output'];
  readonly plan: PricingPlan;
  readonly platformEmployees: Scalars['Int']['output'];
  readonly recruitingCommunication: Scalars['Boolean']['output'];
};

export enum SupportedLocal {
  De = 'de',
  DeCh = 'de_ch',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  No = 'no',
  Pt = 'pt',
  Ru = 'ru'
}

export type SyncObjectiveKeyResultInput = {
  readonly createKeyResult: InputMaybe<CreateObjectiveKeyResultInput>;
  readonly keepKeyResultId: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  readonly __typename?: 'Tag';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Active__c: Scalars['Boolean']['output'];
};

export type Tax = {
  readonly __typename?: 'Tax';
  readonly Id: Scalars['String']['output'];
  readonly Name: Maybe<Scalars['String']['output']>;
  readonly flair__Percentage__c: Maybe<Scalars['Float']['output']>;
};

export type Team = {
  readonly __typename?: 'Team';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employees: ReadonlyArray<Colleague>;
};

export type TeamFilter = {
  readonly searchTerm: InputMaybe<Scalars['String']['input']>;
  readonly teamIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type TeamObjective = Objective & {
  readonly __typename?: 'TeamObjective';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly allHistoryItems: ReadonlyArray<ObjectiveHistoryItemCommon>;
  readonly allParents: ReadonlyArray<Objective>;
  readonly category: Maybe<ObjectiveCategory>;
  readonly childrenObjectives: ReadonlyArray<TeamOrEmployeeObjective>;
  readonly createdBy: Maybe<Colleague>;
  readonly flair__Company_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Created_By__c: Maybe<Scalars['String']['output']>;
  readonly flair__Current_Status__c: ObjectiveCurrentStatusType;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Due_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Expected_Progress__c: Scalars['Float']['output'];
  readonly flair__Is_Draft__c: Scalars['Boolean']['output'];
  readonly flair__Manual_Progress__c: Scalars['Boolean']['output'];
  readonly flair__Objective_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__Objective_Time_Period__c: Maybe<Scalars['String']['output']>;
  readonly flair__On_Track__c: Scalars['Boolean']['output'];
  readonly flair__Owner__c: Maybe<Scalars['String']['output']>;
  readonly flair__Parent_Team_Objective__c: Maybe<Scalars['String']['output']>;
  readonly flair__Progress__c: Scalars['Float']['output'];
  readonly flair__RateAt__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__RateBy__c: Maybe<Scalars['String']['output']>;
  readonly flair__Rate__c: Maybe<EmployeeObjectiveRateType>;
  readonly flair__Start_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Status_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: ObjectiveStatusType;
  readonly flair__Team__c: Scalars['String']['output'];
  readonly flair__Visibility__c: ObjectiveVisibility;
  /** @deprecated use allHistoryItems */
  readonly historyItems: ReadonlyArray<ObjectiveHistoryItem>;
  readonly keyResultUpdates: ReadonlyArray<ObjectiveKeyResultUpdate>;
  readonly keyResults: ReadonlyArray<ObjectiveKeyResult>;
  readonly owner: Maybe<Colleague>;
  readonly parentObjective: Maybe<TeamOrCompanyObjective>;
  readonly period: Maybe<ObjectiveTimePeriod>;
  readonly rateBy: Maybe<Colleague>;
  readonly sharedWith: ReadonlyArray<Colleague>;
  readonly statusChangedBy: Maybe<Colleague>;
  readonly tags: ReadonlyArray<Tag>;
  readonly team: Team;
};

export type TeamOrCompanyObjective = CompanyObjective | TeamObjective;

export type TeamOrEmployeeObjective = EmployeeObjective | TeamObjective;

export type Ticket = Commentable & {
  readonly __typename?: 'Ticket';
  readonly CreatedById: Scalars['String']['output'];
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Scalars['String']['output'];
  readonly assignee: Maybe<Colleague>;
  readonly category: DictionaryItem;
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly createdBy: Maybe<Colleague>;
  readonly employee: Maybe<Colleague>;
  readonly flair__Anonymous__c: Scalars['Boolean']['output'];
  readonly flair__Assignee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Category__c: Scalars['String']['output'];
  readonly flair__Closing_Reason__c: Maybe<Scalars['String']['output']>;
  readonly flair__Details__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Priority__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: Scalars['String']['output'];
  readonly flair__Subject__c: Maybe<Scalars['String']['output']>;
  readonly flair__Ticket_Number__c: Scalars['Int']['output'];
  readonly flair__Visibility__c: TicketVisibility;
  readonly subject: Maybe<DictionaryItem>;
};

export type TicketClosedNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TicketClosedNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly ticket: Maybe<Ticket>;
};

export type TicketFilterInput = {
  readonly assigneeId: InputMaybe<Scalars['String']['input']>;
  readonly categoryId: InputMaybe<Scalars['String']['input']>;
  readonly month: InputMaybe<Scalars['LocalDate']['input']>;
  readonly searchTerm: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<ReadonlyArray<TicketStatus>>;
  readonly year: InputMaybe<Scalars['LocalDate']['input']>;
};

export type TicketManagerClosedNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TicketManagerClosedNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly ticket: Maybe<Ticket>;
};

export type TicketManagerStatusChangedNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly ticket: Maybe<Ticket>;
};

export type TicketMutations = {
  readonly __typename?: 'TicketMutations';
  readonly closeTicket: Maybe<CloseTicketPayload>;
  readonly createTicket: Maybe<CreateTicketPayload>;
};


export type TicketMutationsCloseTicketArgs = {
  input: CloseTicketInput;
};


export type TicketMutationsCreateTicketArgs = {
  input: CreateTicketInput;
};

export type TicketPagination = {
  readonly __typename?: 'TicketPagination';
  readonly items: ReadonlyArray<Ticket>;
  readonly paginationInfo: PaginationInfo;
};

export type TicketPolicy = {
  readonly __typename?: 'TicketPolicy';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Category_Key__c: Maybe<Scalars['String']['output']>;
  readonly flair__Ticket_Visibility__c: Scalars['String']['output'];
  readonly flair__Whistleblower_Active__c: Scalars['Boolean']['output'];
};

export type TicketSharedNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TicketSharedNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly ticket: Maybe<Ticket>;
};

export enum TicketSortFieldEnum {
  Assignee = 'ASSIGNEE',
  Category = 'CATEGORY',
  LastUpdate = 'LAST_UPDATE',
  Requested = 'REQUESTED',
  Status = 'STATUS',
  Subject = 'SUBJECT',
  TicketNumber = 'TICKET_NUMBER'
}

export type TicketSortInput = {
  readonly field: TicketSortFieldEnum;
  readonly ticket: InputMaybe<AscDescEnum>;
};

export enum TicketStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export type TicketStatusChangedNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TicketStatusChangedNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly ticket: Maybe<Ticket>;
};

export type TicketSubmittedNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TicketSubmittedNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly ticket: Maybe<Ticket>;
};

export enum TicketVisibility {
  HrEmployee = 'HR_EMPLOYEE',
  HrManagerEmployee = 'HR_MANAGER_EMPLOYEE'
}

export enum TimeBalanceAutoResetMode {
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum TimeBalanceCalculationMode {
  AfterSpecificTime = 'AFTER_SPECIFIC_TIME',
  BasedOnDayTargetTime = 'BASED_ON_DAY_TARGET_TIME',
  NotTrack = 'NOT_TRACK'
}

export type TimeBalanceSettings = {
  readonly __typename?: 'TimeBalanceSettings';
  readonly Id: Scalars['String']['output'];
  readonly flair__Auto_Reset_Mode__c: Maybe<TimeBalanceAutoResetMode>;
  readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode;
  readonly flair__Daily_Threshold_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Maximum_Daily_Working_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Negative_Capacity_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Not_Deduct_Deficit__c: Scalars['Boolean']['output'];
  readonly flair__Positive_Capacity_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Premium_Level_1_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Premium_Level_1_Multiplier__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Premium_Level_2_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Premium_Level_2_Multiplier__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Start_Calculate_After_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Threshold_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Update_Mode__c: TimeBalanceUpdateMode;
};

export enum TimeBalanceUpdateMode {
  Immediate = 'IMMEDIATE',
  TimeSheetApproved = 'TIME_SHEET_APPROVED'
}

export type TimeBalanceWithdrawal = {
  readonly __typename?: 'TimeBalanceWithdrawal';
  readonly Id: Scalars['String']['output'];
  /** @deprecated use  absenceAllowances */
  readonly absenceAllowance: Maybe<AbsenceAllowance>;
  readonly absenceAllowances: Maybe<ReadonlyArray<AbsenceAllowance>>;
  readonly employee: Maybe<Colleague>;
  /** @deprecated use absenceAllowances */
  readonly flair__Absence_Allowance__c: Maybe<Scalars['String']['output']>;
  readonly flair__Amount__c: Scalars['Int']['output'];
  readonly flair__Day__c: Scalars['String']['output'];
  readonly flair__Employee_One_Time_Compensation__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType;
};

export type TimeBalanceWithdrawalNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly withdrawal: Maybe<TimeBalanceWithdrawal>;
};

export enum TimeBalanceWithdrawalType {
  AdjustTimeBalanceTo = 'ADJUST_TIME_BALANCE_TO',
  ToAbsenceAllowance = 'TO_ABSENCE_ALLOWANCE',
  ToNull = 'TO_NULL',
  ToOneTimeCompensation = 'TO_ONE_TIME_COMPENSATION'
}

export type TimeEntry = {
  readonly __typename?: 'TimeEntry';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly Name: Maybe<Scalars['String']['output']>;
  readonly breaks: ReadonlyArray<TimeEntryBreak>;
  readonly employee: Maybe<Colleague>;
  readonly flair__Cost_Center__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__End_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Is_Locked__c: Scalars['Boolean']['output'];
  readonly flair__Non_compliant__c: Scalars['Boolean']['output'];
  readonly flair__Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Payroll_Completed__c: Scalars['Boolean']['output'];
  readonly flair__Reference_ID__c: Maybe<Scalars['String']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Total_Break_Period_In_Hours__c: Scalars['Float']['output'];
  readonly flair__Total_Period_In_Hours__c: Scalars['Float']['output'];
  readonly flair__Working_Period_In_Hours__c: Scalars['Float']['output'];
  readonly timeSheet: Maybe<TimeSheet>;
};

export enum TimeEntryApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type TimeEntryBreak = {
  readonly __typename?: 'TimeEntryBreak';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly flair__Auto_adjusted_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__End_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Total_Break_Period_in_Hours__c: Scalars['Float']['output'];
};

export type TimeEntryBreakChangeRequest = {
  readonly __typename?: 'TimeEntryBreakChangeRequest';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly flair__End_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Time_Entry_Break__c: Maybe<Scalars['String']['output']>;
  readonly flair__Time_Entry_Change_Request__c: Scalars['String']['output'];
  readonly timeEntryBreak: Maybe<TimeEntryBreak>;
};

export type TimeEntryBreakChangeRequestInput = {
  readonly breakChangeRequestId: InputMaybe<Scalars['String']['input']>;
  readonly breakId: InputMaybe<Scalars['String']['input']>;
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly startDatetime: Scalars['DateTime']['input'];
};

export type TimeEntryBreakInput = {
  readonly breakId: InputMaybe<Scalars['String']['input']>;
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly startDatetime: Scalars['DateTime']['input'];
};

export type TimeEntryChangeRequest = {
  readonly __typename?: 'TimeEntryChangeRequest';
  readonly Id: Scalars['String']['output'];
  readonly LastModifiedDate: Scalars['DateTime']['output'];
  readonly affectedTimeEntry: Maybe<TimeEntry>;
  readonly breaks: ReadonlyArray<TimeEntryBreakChangeRequest>;
  readonly employee: Employee;
  readonly flair__Cost_Center__c: Maybe<Scalars['String']['output']>;
  readonly flair__Creation_Time_Entry_Notes__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Datetime__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Start_Datetime__c: Scalars['DateTime']['output'];
  readonly flair__Status__c: ApprovalStatus;
  readonly flair__Time_Entry__c: Maybe<Scalars['String']['output']>;
  readonly flair__Total_Break_Period_In_Hours__c: Scalars['Float']['output'];
  readonly flair__Total_Period_In_Hours__c: Scalars['Float']['output'];
  readonly flair__Working_Period_In_Hours__c: Scalars['Float']['output'];
  readonly timeEntry: Maybe<TimeEntry>;
};

export type TimeEntryChangeRequestNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly timeEntryChangeRequest: Maybe<TimeEntryChangeRequest>;
};

export type TimeEntryNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TimeEntryNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly timeEntry: Maybe<TimeEntry>;
};

export enum TimeEntryOrigin {
  EmployeeHub = 'employee-hub',
  EmployeeHubMobile = 'employee-hub-mobile',
  Kiosk = 'kiosk',
  Slack = 'slack'
}

export type TimeFramework = {
  readonly __typename?: 'TimeFramework';
  readonly Id: Scalars['String']['output'];
  readonly breakLegislationRules: ReadonlyArray<BreakLegislationRule>;
  readonly flair__Automatically_Deduct_Unused_Break__c: Scalars['Boolean']['output'];
  readonly flair__Block_Ending_Breaks__c: Scalars['Boolean']['output'];
  readonly flair__Is_Restrict_Future_Entries_Enabled__c: Scalars['Boolean']['output'];
  readonly flair__Minimal_Break_Length__c: Scalars['Int']['output'];
  readonly flair__Notify_Employee_For_Break_Time__c: Scalars['Boolean']['output'];
  readonly flair__Overtime_Policy__c: Maybe<Scalars['String']['output']>;
  readonly flair__Suggest_Adding_Break__c: Scalars['Boolean']['output'];
  readonly flair__Time_Balance_Settings__c: Maybe<Scalars['String']['output']>;
  readonly flair__Time_Limit_Settings__c: Maybe<Scalars['String']['output']>;
  /** @deprecated use TimeLimitSettings.flair__Is_Restrict_Future_Entries_Enabled__c instead */
  readonly flair__Track_Geolocation__c: Scalars['Boolean']['output'];
  readonly timeBalanceSettings: Maybe<TimeBalanceSettings>;
  readonly timeLimitSettings: Maybe<TimeLimitSettings>;
};

export type TimeLimitErrorMaxDailyLimitExceeded = TimeTrackingErrorBase & {
  readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded';
  readonly allowedTimeInMin: Scalars['Int']['output'];
  readonly errorCode: TimeTrackingErrorCode;
  readonly message: Scalars['String']['output'];
  readonly type: TimeTrackingErrorType;
};

export enum TimeLimitMaxDailyRestrictionAction {
  ClockOutAndNotify = 'CLOCK_OUT_AND_NOTIFY',
  OnlyNotify = 'ONLY_NOTIFY'
}

export enum TimeLimitMaxDailyRestrictionType {
  BasedOnWorkload = 'BASED_ON_WORKLOAD',
  CustomMinutesDuration = 'CUSTOM_MINUTES_DURATION',
  NoRestriction = 'NO_RESTRICTION'
}

export type TimeLimitSettings = {
  readonly __typename?: 'TimeLimitSettings';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly flair__Is_Restrict_Future_Entries_Enabled__c: Scalars['Boolean']['output'];
  readonly flair__Maximum_Daily_Restriction_Action__c: Maybe<TimeLimitMaxDailyRestrictionAction>;
  readonly flair__Maximum_Daily_Restriction_Custom_Minutes__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Maximum_Daily_Restriction_Notify_HR__c: Scalars['Boolean']['output'];
  readonly flair__Maximum_Daily_Restriction_Type__c: TimeLimitMaxDailyRestrictionType;
  readonly flair__Restrict_Tracking_On_Non_Working_Days__c: Scalars['Boolean']['output'];
};

export type TimeLimitTimeEntryNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly timeEntry: Maybe<TimeEntry>;
};

export type TimeLimitWarningMaxDailyLimit = {
  readonly __typename?: 'TimeLimitWarningMaxDailyLimit';
  readonly allowedTimeInMin: Scalars['Int']['output'];
  readonly alreadyTrackedInMin: Scalars['Int']['output'];
  readonly autoClockOut: Scalars['Boolean']['output'];
  readonly leftToTrackInMin: Scalars['Int']['output'];
  readonly warningCode: TimeTrackingWarningCode;
};

export type TimeSheet = {
  readonly __typename?: 'TimeSheet';
  readonly Id: Scalars['String']['output'];
  readonly absences: ReadonlyArray<Absence>;
  readonly calendarPeriods: ReadonlyArray<CalendarPeriod>;
  readonly employee: Employee;
  readonly flair__Absence_Hours__c: Scalars['Float']['output'];
  readonly flair__Approval_Status__c: TimeSheetStatus;
  readonly flair__Current_Compensatory_Time_Level_1__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Current_Compensatory_Time_Level_2__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__End_Date__c: Scalars['String']['output'];
  readonly flair__Given_Compensatory_Time_Level_1__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Given_Compensatory_Time_Level_2__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Holiday_Hours__c: Scalars['Float']['output'];
  readonly flair__Non_Deductible_Absence_Hours__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Project_Time_Entries_Minutes__c: Scalars['Float']['output'];
  readonly flair__Start_Date__c: Scalars['String']['output'];
  readonly flair__Target_Hours__c: Scalars['Float']['output'];
  readonly flair__Time_Entries_Hours_Diff__c: Scalars['Float']['output'];
  readonly flair__Time_Entry_Hours__c: Scalars['Float']['output'];
  readonly flair__Type__c: WorkloadType;
  readonly holidays: ReadonlyArray<LocationHoliday>;
  readonly nextTimeSheet: Maybe<TimeSheet>;
  readonly nextTimeSheetStartDay: Scalars['LocalDate']['output'];
  readonly paidAbsences: ReadonlyArray<Absence>;
  readonly previousTimeSheet: Maybe<TimeSheet>;
  readonly previousTimeSheetStartDay: Scalars['LocalDate']['output'];
  readonly projectsTimeEntries: ReadonlyArray<ProjectTimeEntry>;
  readonly timeEntries: ReadonlyArray<TimeEntry>;
  readonly timeEntryChangeRequests: ReadonlyArray<TimeEntryChangeRequest>;
  readonly timeSheetDays: ReadonlyArray<TimeSheetDay>;
  readonly trackedTime: TimesheetTrackedTime;
  readonly warnings: ReadonlyArray<TimeSheetWarning>;
  readonly workedHours: Scalars['Float']['output'];
  readonly workloads: ReadonlyArray<EmployeeWorkload>;
};


export type TimeSheetProjectsTimeEntriesArgs = {
  filter: InputMaybe<ProjectTimeEntriesFilterInput>;
};

export type TimeSheetDay = Commentable & WithLoomVideo & {
  readonly __typename?: 'TimeSheetDay';
  readonly Id: Scalars['String']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly employee: Maybe<Employee>;
  readonly flair__Day__c: Scalars['LocalDate']['output'];
  readonly flair__Employee__c: Maybe<Scalars['String']['output']>;
  readonly flair__Holiday_Minutes__c: Scalars['Float']['output'];
  readonly flair__Loom_Video__c: Maybe<Scalars['String']['output']>;
  readonly flair__Project_Time_Entries_Minutes__c: Scalars['Float']['output'];
  readonly flair__Target_Minutes__c: Scalars['Float']['output'];
  readonly flair__Time_Balance_Minutes__c: Scalars['Float']['output'];
  readonly flair__Time_Entries_Minutes__c: Scalars['Float']['output'];
  readonly flair__Timesheet__c: Scalars['String']['output'];
  readonly flair__Workload_Minutes__c: Scalars['Float']['output'];
  readonly loomVideo: Maybe<LoomVideo>;
  readonly timeBalanceAccumulated: Maybe<Scalars['Int']['output']>;
  readonly timeBalanceWithdrawals: ReadonlyArray<TimeBalanceWithdrawal>;
  readonly timeSheet: TimeSheet;
  readonly timeSheetDayProjectTimeEntries: ReadonlyArray<TimeSheetDayProjectTimeEntry>;
};

export type TimeSheetDayProjectTimeEntry = {
  readonly __typename?: 'TimeSheetDayProjectTimeEntry';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employee: Employee;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__Minutes__c: Maybe<Scalars['Float']['output']>;
  readonly flair__Project_Time_Entry__c: Scalars['String']['output'];
  readonly flair__Timesheet_Day__c: Scalars['String']['output'];
  readonly projectTimeEntry: ProjectTimeEntry;
  readonly timesheetDay: TimeSheetDay;
};

export type TimeSheetDaysRequestInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly endDay: Scalars['LocalDate']['input'];
  readonly startDay: Scalars['LocalDate']['input'];
};

export type TimeSheetFilterInput = {
  readonly employeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly employeeName: InputMaybe<Scalars['String']['input']>;
  readonly managerReportsType: ManagerReportsType;
  readonly month: InputMaybe<Scalars['String']['input']>;
  readonly projectTimeEntriesFilter: InputMaybe<ProjectTimeEntriesFilterInput>;
  readonly status: InputMaybe<TimeSheetStatus>;
  readonly withWarnings: InputMaybe<Scalars['Boolean']['input']>;
  readonly year: InputMaybe<Scalars['String']['input']>;
};

export type TimeSheetMutations = {
  readonly __typename?: 'TimeSheetMutations';
  readonly approveTimeSheets: ApproveTimeSheetsPayload;
};


export type TimeSheetMutationsApproveTimeSheetsArgs = {
  ids: ReadonlyArray<Scalars['String']['input']>;
  timeEntryChangeRequestApproveAction: InputMaybe<ApproveTimeSheetAction>;
};

export type TimeSheetPagination = {
  readonly __typename?: 'TimeSheetPagination';
  readonly items: ReadonlyArray<TimeSheet>;
  readonly paginationInfo: PaginationInfo;
};

export enum TimeSheetSortFieldEnum {
  EmployeeName = 'EMPLOYEE_NAME',
  StartDate = 'START_DATE'
}

export type TimeSheetSortInput = {
  readonly field: TimeSheetSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export enum TimeSheetStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export type TimeSheetWarning = {
  readonly __typename?: 'TimeSheetWarning';
  readonly id: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
};

export type TimeTrackingError = TimeTrackingErrorBase & {
  readonly __typename?: 'TimeTrackingError';
  readonly errorCode: TimeTrackingErrorCode;
  readonly message: Scalars['String']['output'];
  readonly type: TimeTrackingErrorType;
};

export type TimeTrackingErrorBase = {
  readonly errorCode: TimeTrackingErrorCode;
  readonly message: Scalars['String']['output'];
  readonly type: TimeTrackingErrorType;
};

export enum TimeTrackingErrorCode {
  DisabledInWorkload = 'DISABLED_IN_WORKLOAD',
  InvalidDto = 'INVALID_DTO',
  MaxDailyLimitExceeded = 'MAX_DAILY_LIMIT_EXCEEDED',
  NotInsideEmploymentTermRange = 'NOT_INSIDE_EMPLOYMENT_TERM_RANGE',
  NotInsideWorkloadRange = 'NOT_INSIDE_WORKLOAD_RANGE',
  NoTimeEntry = 'NO_TIME_ENTRY',
  TimeEntryFinished = 'TIME_ENTRY_FINISHED',
  TimeEntryValidation = 'TIME_ENTRY_VALIDATION'
}

export enum TimeTrackingErrorType {
  TimeLimitErrorMaxDailyLimitExceeded = 'TimeLimitErrorMaxDailyLimitExceeded',
  TimeTrackingError = 'TimeTrackingError'
}

export type TimeTrackingErrorV2 = TimeLimitErrorMaxDailyLimitExceeded | TimeTrackingError | UnknownTimeTrackingError;

export type TimeTrackingMutations = {
  readonly __typename?: 'TimeTrackingMutations';
  readonly approveTimeEntryChangeRequests: ProcessTimeEntryChangeRequestsPayload;
  readonly createMyTimeEntry: CreateMyTimeEntryPayload;
  readonly deleteTimeEntry: DeleteTimeEntryPayload;
  readonly deleteTimeEntryChangeRequest: DeleteTimeEntryChangeRequestPayload;
  readonly pauseMyTimeEntry: UpdateMyTimeEntryPayload;
  readonly rejectTimeEntryChangeRequests: ProcessTimeEntryChangeRequestsPayload;
  readonly resumeMyTimeEntry: UpdateMyTimeEntryPayload;
  readonly stopMyTimeEntry: UpdateMyTimeEntryPayload;
  readonly submitTimeEntry: SubmitTimeEntryPayload;
  readonly submitTimeEntryChangeRequest: SubmitTimeEntryChangeRequestPayload;
  readonly updateTimeEntryNotes: UpdateNotesPayload;
};


export type TimeTrackingMutationsApproveTimeEntryChangeRequestsArgs = {
  input: ApproveTimeEntryChangeRequestInput;
};


export type TimeTrackingMutationsCreateMyTimeEntryArgs = {
  input: InputMaybe<StartMyTimeEntryInput>;
};


export type TimeTrackingMutationsDeleteTimeEntryArgs = {
  id: Scalars['String']['input'];
};


export type TimeTrackingMutationsDeleteTimeEntryChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type TimeTrackingMutationsPauseMyTimeEntryArgs = {
  input: UpdateMyTimeEntryInput;
};


export type TimeTrackingMutationsRejectTimeEntryChangeRequestsArgs = {
  input: RejectTimeEntryChangeRequestInput;
};


export type TimeTrackingMutationsResumeMyTimeEntryArgs = {
  input: UpdateMyTimeEntryInput;
};


export type TimeTrackingMutationsStopMyTimeEntryArgs = {
  input: StopMyTimeEntryInput;
};


export type TimeTrackingMutationsSubmitTimeEntryArgs = {
  input: SubmitTimeEntryInput;
};


export type TimeTrackingMutationsSubmitTimeEntryChangeRequestArgs = {
  input: SubmitTimeEntryChangeRequestInput;
};


export type TimeTrackingMutationsUpdateTimeEntryNotesArgs = {
  input: UpdateTimeEntryNotesInput;
};

export type TimeTrackingWarning = TimeLimitWarningMaxDailyLimit;

export enum TimeTrackingWarningCode {
  MaxDailyLimitWarning = 'MAX_DAILY_LIMIT_WARNING',
  Unknown = 'UNKNOWN'
}

export type TimesheetDayChanges = {
  readonly __typename?: 'TimesheetDayChanges';
  readonly breaksDuration: DurationWithOrigin;
  readonly changeRequestIds: ReadonlyArray<Scalars['String']['output']>;
  readonly changeRequests: ReadonlyArray<TimeEntryChangeRequest>;
  readonly trackedDuration: DurationWithOrigin;
  readonly trackedTimeEnd: DateTimeWithOrigin;
  readonly trackedTimeStart: DateTimeWithOrigin;
  readonly workedMinutes: Maybe<Scalars['Float']['output']>;
};

export type TimesheetDayTrackedTime = {
  readonly __typename?: 'TimesheetDayTrackedTime';
  readonly absenceMinutes: Scalars['Float']['output'];
  readonly allAbsences: ReadonlyArray<Absence>;
  readonly allAbsencesIds: ReadonlyArray<Scalars['String']['output']>;
  readonly breaksDuration: DurationWithOrigin;
  readonly breaksMinutes: Scalars['Float']['output'];
  readonly day: Scalars['LocalDate']['output'];
  readonly dayChanges: Maybe<TimesheetDayChanges>;
  readonly dayStartDateTime: Scalars['DateTime']['output'];
  readonly deficitMinutes: Scalars['Float']['output'];
  readonly endOfTrackedTime: Maybe<Scalars['DateTime']['output']>;
  readonly holidayMinutes: Scalars['Float']['output'];
  readonly holidays: ReadonlyArray<LocationHoliday>;
  readonly holidaysIds: ReadonlyArray<Scalars['String']['output']>;
  /** @deprecated Please use workedMinutes */
  readonly nonDeductibleMinutes: Scalars['Float']['output'];
  readonly overtimeMinutes: Scalars['Float']['output'];
  readonly startOfTrackedTime: Maybe<Scalars['DateTime']['output']>;
  readonly targetMinutes: Scalars['Float']['output'];
  readonly timeEntries: ReadonlyArray<TimeEntry>;
  readonly timeEntriesIds: ReadonlyArray<Scalars['String']['output']>;
  readonly timesheetId: Scalars['String']['output'];
  readonly trackedDuration: DurationWithOrigin;
  readonly trackedMinutes: Scalars['Float']['output'];
  readonly trackedTimeEnd: DateTimeWithOrigin;
  readonly trackedTimeStart: DateTimeWithOrigin;
  readonly workedMinutes: Scalars['Float']['output'];
};

export type TimesheetTrackedTime = {
  readonly __typename?: 'TimesheetTrackedTime';
  readonly days: ReadonlyArray<TimesheetDayTrackedTime>;
  readonly timesheetId: Scalars['String']['output'];
  readonly totalDaysTracked: Scalars['Int']['output'];
  /** @deprecated Please use totalWorkedMinutes */
  readonly totalNonDeductibleMinutes: Scalars['Float']['output'];
  readonly totalTrackedMinutes: Scalars['Float']['output'];
  readonly totalWorkedMinutes: Scalars['Float']['output'];
};

export type UnknownTimeTrackingError = {
  readonly __typename?: 'UnknownTimeTrackingError';
  readonly errorCode: TimeTrackingErrorCode;
};

export type UnsnoozeNotificationInput = {
  readonly id: Scalars['String']['input'];
};

export type UpdateApprovalRequestStatusInput = {
  readonly comment: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly status: ApprovalRequestStatus;
};

export type UpdateApprovalRequestStatusPayload = {
  readonly __typename?: 'UpdateApprovalRequestStatusPayload';
  readonly query: Query;
  readonly record: Maybe<ApprovalRequest>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type UpdateCandidateEvaluationPayload = {
  readonly __typename?: 'UpdateCandidateEvaluationPayload';
  readonly record: Maybe<CandidateEvaluation>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateCelebrationInput = {
  readonly id: Scalars['String']['input'];
  readonly loomVideo: InputMaybe<CreateLoomVideoInput>;
  readonly message: Scalars['String']['input'];
  readonly predefinedImage: InputMaybe<Scalars['String']['input']>;
  readonly public: Scalars['Boolean']['input'];
  readonly recipients: ReadonlyArray<CelebrationRecipientInput>;
  readonly type: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  readonly id: Scalars['String']['input'];
  readonly text: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerSupportPayload = {
  readonly __typename?: 'UpdateCustomerSupportPayload';
  readonly query: Query;
};

export type UpdateCycleEmployeeObjectiveInput = {
  readonly id: Scalars['String']['input'];
  readonly outcomeId: Scalars['String']['input'];
};

export type UpdateEmployeeCertificateInput = {
  readonly certificateId: InputMaybe<Scalars['String']['input']>;
  readonly certificateName: Scalars['String']['input'];
  readonly certificateUrl: InputMaybe<Scalars['String']['input']>;
  readonly deleteFileId: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly expirationDate: InputMaybe<Scalars['LocalDate']['input']>;
  readonly files: InputMaybe<ReadonlyArray<EmployeeCertificateFileInput>>;
  readonly id: Scalars['String']['input'];
  readonly issueDate: InputMaybe<Scalars['LocalDate']['input']>;
  readonly issuedBy: Scalars['String']['input'];
  readonly plannedDate: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpdateEmployeeEvaluationPayload = {
  readonly __typename?: 'UpdateEmployeeEvaluationPayload';
  readonly record: Maybe<EmployeeEvaluation>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateEmployeeFeedbackAnswerInput = {
  readonly answer: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly notes: Scalars['String']['input'];
};

export type UpdateEmployeeFeedbackResolution = {
  readonly resolutionId: Scalars['String']['input'];
  readonly value: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeMeetingInput = {
  readonly id: Scalars['String']['input'];
  readonly startDatetime: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEmployeeObjectiveFieldsInput = {
  readonly categoryId: InputMaybe<StringUpdateInput>;
  readonly description: InputMaybe<StringUpdateInput>;
  readonly dueDate: InputMaybe<StringUpdateInput>;
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly keyResults: InputMaybe<ReadonlyArray<SyncObjectiveKeyResultInput>>;
  readonly manualProgress: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: InputMaybe<Scalars['String']['input']>;
  readonly parentObjectiveId: InputMaybe<ObjectiveIdUpdateInput>;
  readonly sharedWithEmployeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly startDate: InputMaybe<StringUpdateInput>;
  readonly tagIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly timePeriodId: InputMaybe<Scalars['String']['input']>;
  readonly visibility: InputMaybe<ObjectiveVisibility>;
};

export type UpdateEmployeeSkillPayload = {
  readonly __typename?: 'UpdateEmployeeSkillPayload';
  readonly colleague: Maybe<Colleague>;
  readonly employee: Maybe<Employee>;
  readonly employeeId: Maybe<Scalars['String']['output']>;
  readonly error: Maybe<Scalars['String']['output']>;
  readonly query: Query;
  readonly record: Maybe<EmployeeSkillAssociation>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type UpdateEngagementSurveyAnswerInput = {
  readonly answer: InputMaybe<Scalars['String']['input']>;
  readonly employeeId: Scalars['String']['input'];
  readonly notes: InputMaybe<Scalars['String']['input']>;
  readonly questionId: Scalars['String']['input'];
  readonly responseId: Scalars['String']['input'];
};

export type UpdateExpenseGroupStatusInput = {
  readonly declineReason: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly reimbursed: InputMaybe<Scalars['Boolean']['input']>;
  readonly status: ExpenseStatus;
};

export type UpdateExpenseInput = {
  readonly category: InputMaybe<Scalars['String']['input']>;
  readonly dateFrom: InputMaybe<Scalars['LocalDate']['input']>;
  readonly dateTo: InputMaybe<Scalars['LocalDate']['input']>;
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly expenseGroupId: InputMaybe<Scalars['String']['input']>;
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly files: InputMaybe<ReadonlyArray<FileInput>>;
  readonly id: Scalars['String']['input'];
  readonly merchantId: InputMaybe<Scalars['String']['input']>;
  readonly project: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<ExpenseStatus>;
  readonly timeFrom: InputMaybe<Scalars['String']['input']>;
  readonly timeTo: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpenseItemInput = {
  readonly RecordTypeId: InputMaybe<Scalars['String']['input']>;
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly flair__Address_From__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Address_To__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Breakfast_Provided__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__Dinner_Provided__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__Lunch_Provided__c: InputMaybe<Scalars['Boolean']['input']>;
  readonly flair__Manual_Amount__c: InputMaybe<Scalars['Float']['input']>;
  readonly flair__Note__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Tax__c: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type UpdateExpenseStatusInput = {
  readonly declineReason: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly status: ExpenseStatus;
};

export type UpdateFieldInput = {
  readonly name: Scalars['String']['input'];
  readonly type: FieldType;
  readonly value: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFieldsInput = {
  readonly fields: ReadonlyArray<UpdateFieldInput>;
};

export type UpdateInventoryItemStatusInput = {
  readonly inventoryItemId: Scalars['String']['input'];
  readonly status: Scalars['String']['input'];
};

export type UpdateInventoryItemStatusPayload = {
  readonly __typename?: 'UpdateInventoryItemStatusPayload';
  readonly record: InventoryItem;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateMyAvatarInput = {
  readonly fileContentBase64: Scalars['String']['input'];
  readonly fileName: Scalars['String']['input'];
};

export type UpdateMyAvatarPayload = {
  readonly __typename?: 'UpdateMyAvatarPayload';
  readonly query: Query;
  readonly record: Maybe<EmployeeAvatar>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type UpdateMyBirthdayPayload = {
  readonly __typename?: 'UpdateMyBirthdayPayload';
  readonly query: Query;
  readonly record: Maybe<Employee>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateMyDataInput = {
  readonly fields: ReadonlyArray<UpdateMyDataInputField>;
};

export type UpdateMyDataInputField = {
  readonly name: Scalars['String']['input'];
  readonly type: EmployeeDataFieldType;
  readonly value: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyEmployeeDataPayload = {
  readonly __typename?: 'UpdateMyEmployeeDataPayload';
  readonly record: Maybe<EmployeeData>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateMyLanguagePayload = {
  readonly __typename?: 'UpdateMyLanguagePayload';
  readonly query: Query;
  readonly record: Maybe<Employee>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateMyTimeEntryInput = {
  readonly Id: Scalars['String']['input'];
  readonly geolocation: InputMaybe<GeolocationCoordinatesInput>;
  readonly kioskId: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyTimeEntryNotesInput = {
  readonly id: Scalars['String']['input'];
  readonly notes: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyTimeEntryPayload = {
  readonly __typename?: 'UpdateMyTimeEntryPayload';
  /** @deprecated Use `errors2` instead */
  readonly error: Maybe<TimeTrackingError>;
  /** @deprecated use errors2 instead */
  readonly errors: ReadonlyArray<TimeTrackingErrorV2>;
  readonly errors2: ReadonlyArray<TimeTrackingErrorBase>;
  readonly me: Maybe<Me>;
  readonly record: Maybe<MyTimeEntry>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateNotesPayload = {
  readonly __typename?: 'UpdateNotesPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly timeEntry: Maybe<TimeEntry>;
  readonly timeEntryChangeRequest: Maybe<TimeEntryChangeRequest>;
  readonly timeEntryChangeRequestId: Maybe<Scalars['String']['output']>;
  readonly timeEntryId: Maybe<Scalars['String']['output']>;
};

export type UpdateObjectiveKeyResultPayload = {
  readonly __typename?: 'UpdateObjectiveKeyResultPayload';
  readonly record: Maybe<ObjectiveKeyResult>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateObjectiveKeyResultValueInput = {
  readonly comment: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly value: Scalars['Float']['input'];
};

export type UpdateObjectivePayload = {
  readonly __typename?: 'UpdateObjectivePayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly objectiveType: ObjectiveType;
  readonly record: Maybe<Objective>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateObjectiveStatusInput = {
  readonly cancelReason: InputMaybe<Scalars['String']['input']>;
  readonly objectiveId: ObjectiveIdInput;
  readonly rate: EmployeeObjectiveRateType;
  readonly status: ObjectiveCurrentStatusType;
};

export type UpdateProjectInput = {
  readonly billable: Scalars['Boolean']['input'];
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly endDate: InputMaybe<Scalars['LocalDate']['input']>;
  readonly estimation: InputMaybe<Scalars['Int']['input']>;
  readonly id: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly startDate: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpdateProjectPayload = {
  readonly __typename?: 'UpdateProjectPayload';
  readonly record: Maybe<Project>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateSkillInput = {
  readonly id: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type UpdateSkillRateInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly rate: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSkillTopInput = {
  readonly employeeId: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly top: Scalars['Boolean']['input'];
};

export type UpdateSlackUserInput = {
  readonly slackUser: Scalars['String']['input'];
};

export type UpdateSlackUserPayload = {
  readonly __typename?: 'UpdateSlackUserPayload';
  readonly result: UpdateSlackUserResult;
};

export enum UpdateSlackUserResult {
  SlackIsNotEnabledForOrganization = 'SlackIsNotEnabledForOrganization',
  Success = 'Success'
}

export type UpdateSliderSettingsInput = {
  readonly settings: ReadonlyArray<SettingItem>;
};

export type UpdateTeamObjectiveFieldsInput = {
  readonly categoryId: InputMaybe<StringUpdateInput>;
  readonly description: InputMaybe<StringUpdateInput>;
  readonly dueDate: InputMaybe<StringUpdateInput>;
  readonly id: Scalars['String']['input'];
  readonly keyResults: InputMaybe<ReadonlyArray<SyncObjectiveKeyResultInput>>;
  readonly manualProgress: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: InputMaybe<Scalars['String']['input']>;
  readonly parentObjectiveId: InputMaybe<ObjectiveIdUpdateInput>;
  readonly sharedWithEmployeeIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly startDate: InputMaybe<StringUpdateInput>;
  readonly tagIds: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly teamId: InputMaybe<Scalars['String']['input']>;
  readonly timePeriodId: InputMaybe<Scalars['String']['input']>;
  readonly visibility: InputMaybe<ObjectiveVisibility>;
};

export type UpdateTimeEntryBreakChangeRequestInput = {
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly id: Scalars['String']['input'];
  readonly startDatetime: Scalars['DateTime']['input'];
};

export type UpdateTimeEntryBreakInput = {
  readonly end: InputMaybe<Scalars['DateTime']['input']>;
  readonly id: Scalars['String']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type UpdateTimeEntryChangeRequestInput = {
  readonly endDatetime: InputMaybe<Scalars['DateTime']['input']>;
  readonly id: Scalars['String']['input'];
  readonly startDatetime: Scalars['DateTime']['input'];
};

export type UpdateTimeEntryInput = {
  readonly end: InputMaybe<Scalars['DateTime']['input']>;
  readonly id: Scalars['String']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type UpdateTimeEntryNotesInput = {
  readonly changeRequestId: InputMaybe<Scalars['String']['input']>;
  readonly notes: Scalars['String']['input'];
  readonly timeEntryId: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkflowFirstOpenedDateInput = {
  readonly id: Scalars['String']['input'];
};

export type UpdateWorkflowFirstOpenedDatePayload = {
  readonly __typename?: 'UpdateWorkflowFirstOpenedDatePayload';
  readonly record: Maybe<Workflow>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateWorkflowItemDataRequestInput = {
  readonly dataFields: ReadonlyArray<UpdateFieldInput>;
  readonly id: Scalars['String']['input'];
  readonly status: WorkflowItemStatus;
};

export type UpdateWorkflowItemDataRequestPayload = {
  readonly __typename?: 'UpdateWorkflowItemDataRequestPayload';
  readonly employeeId: Scalars['String']['output'];
  readonly record: Maybe<WorkflowItem>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateWorkflowItemFileRequestInput = {
  readonly deleteFileId: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly status: InputMaybe<WorkflowItemStatus>;
  readonly uploadFile: InputMaybe<FileInput>;
  readonly uploadedFileVisibility: InputMaybe<DocumentVisiblity>;
};

export type UpdateWorkflowItemPayload = {
  readonly __typename?: 'UpdateWorkflowItemPayload';
  readonly record: Maybe<WorkflowItem>;
  readonly recordId: Scalars['String']['output'];
};

export type UpdateWorkflowItemRegularInput = {
  readonly id: Scalars['String']['input'];
  readonly status: WorkflowItemStatus;
};

export type UpdateWorkflowItemStatusInput = {
  readonly id: Scalars['String']['input'];
  readonly status: WorkflowItemStatus;
};

export type UpdateWorkflowItemSubTasksInput = {
  readonly id: Scalars['String']['input'];
  readonly status: WorkflowItemStatus;
  readonly subTasks: ReadonlyArray<WorkflowTaskInput>;
};

export type UpdateWorkflowItemVideoRequestInput = {
  readonly id: Scalars['String']['input'];
  readonly loomVideo: InputMaybe<CreateLoomVideoInput>;
  readonly status: InputMaybe<WorkflowItemStatus>;
};

export type UpdatedCommentPayload = {
  readonly __typename?: 'UpdatedCommentPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly record: Maybe<Comment>;
  readonly recordId: Maybe<Scalars['String']['output']>;
};

export type UploadDocumentPayload = {
  readonly __typename?: 'UploadDocumentPayload';
  readonly record: EmployeeDocument;
  readonly recordId: Scalars['String']['output'];
};

export type UploadEmployeeDocumentInput = {
  readonly category: Scalars['String']['input'];
  readonly documentName: Scalars['String']['input'];
  readonly fileContentBase64: Scalars['String']['input'];
  readonly fileName: Scalars['String']['input'];
  readonly folderId: InputMaybe<Scalars['String']['input']>;
  readonly visibility: InputMaybe<DocumentVisiblity>;
};

export type UpsertAbsenceInput = {
  readonly attachedFile: InputMaybe<FileInput>;
  readonly daysTimes: InputMaybe<ReadonlyArray<DayTimeInput>>;
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly extraFields: InputMaybe<ReadonlyArray<ExtraFieldInput>>;
  readonly flair__Comment__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__Employee_Absence_Category__c: Scalars['String']['input'];
  readonly flair__Employee_Absence_Request_Policy__c: InputMaybe<Scalars['String']['input']>;
  readonly flair__End_Date__c: Scalars['String']['input'];
  readonly flair__End_Time__c: InputMaybe<Scalars['Time']['input']>;
  readonly flair__Start_Date__c: Scalars['String']['input'];
  readonly flair__Start_Time__c: InputMaybe<Scalars['Time']['input']>;
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly loomVideo: InputMaybe<CreateLoomVideoInput>;
};

export type UpsertEmployeeObjectiveInput = {
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly dueDate: InputMaybe<Scalars['String']['input']>;
  readonly employeeFeedbackOutcomeId: InputMaybe<Scalars['String']['input']>;
  readonly finishedFeedbackOutcomeId: InputMaybe<Scalars['String']['input']>;
  readonly id: InputMaybe<Scalars['String']['input']>;
  readonly parent: InputMaybe<Scalars['String']['input']>;
  readonly rate: InputMaybe<Scalars['String']['input']>;
  readonly rateReason: InputMaybe<Scalars['String']['input']>;
  readonly responsible: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export enum UserRole {
  Employee = 'EMPLOYEE',
  Reviewer = 'REVIEWER'
}

export type ValidateAbsenceRequestAboveMaxAmountError = {
  readonly __typename?: 'ValidateAbsenceRequestAboveMaxAmountError';
  readonly maxAmount: Scalars['Float']['output'];
  readonly reason: ValidateAbsenceRequestErrorReason;
  readonly requestedAmount: Scalars['Float']['output'];
};

export type ValidateAbsenceRequestAboveMaxUsedAmountError = {
  readonly __typename?: 'ValidateAbsenceRequestAboveMaxUsedAmountError';
  readonly maxUsedAmount: Scalars['Float']['output'];
  readonly maxUsedAmountPeriod: ValidateAbsenceRequestAboveMaxUsedAmountPeriod;
  readonly reason: ValidateAbsenceRequestErrorReason;
  readonly requestedAmount: Scalars['Float']['output'];
  readonly usedAmount: Scalars['Float']['output'];
};

export type ValidateAbsenceRequestAboveMaxUsedAmountPeriod = {
  readonly __typename?: 'ValidateAbsenceRequestAboveMaxUsedAmountPeriod';
  readonly endDate: Scalars['LocalDate']['output'];
  readonly startDate: Scalars['LocalDate']['output'];
};

export type ValidateAbsenceRequestAllowance = {
  readonly __typename?: 'ValidateAbsenceRequestAllowance';
  readonly amountLeft: Scalars['Float']['output'];
  readonly id: Scalars['String']['output'];
  readonly isSystem: Scalars['Boolean']['output'];
  readonly periodEndDate: Maybe<Scalars['LocalDate']['output']>;
  readonly periodStartDate: Maybe<Scalars['LocalDate']['output']>;
  readonly withdrawalAmount: Scalars['Float']['output'];
};

export type ValidateAbsenceRequestBelowMinAmountError = {
  readonly __typename?: 'ValidateAbsenceRequestBelowMinAmountError';
  readonly minAmount: Scalars['Float']['output'];
  readonly reason: ValidateAbsenceRequestErrorReason;
  readonly requestedAmount: Scalars['Float']['output'];
};

export type ValidateAbsenceRequestError = ValidateAbsenceRequestAboveMaxAmountError | ValidateAbsenceRequestAboveMaxUsedAmountError | ValidateAbsenceRequestBelowMinAmountError | ValidateAbsenceRequestInsufficientCreditsError | ValidateAbsenceRequestInsufficientNoticePeriodError | ValidateAbsenceRequestInvalidDaysTimesError | ValidateAbsenceRequestOverlappingAbsencesError | ValidateAbsenceRequestStartTimeGreaterThanEndTimeError;

export enum ValidateAbsenceRequestErrorReason {
  AboveMaxAmount = 'ABOVE_MAX_AMOUNT',
  AboveMaxUsedAmount = 'ABOVE_MAX_USED_AMOUNT',
  BelowMinAmount = 'BELOW_MIN_AMOUNT',
  InsufficientCredits = 'INSUFFICIENT_CREDITS',
  InsufficientNoticePeriod = 'INSUFFICIENT_NOTICE_PERIOD',
  InvalidDaysTimes = 'INVALID_DAYS_TIMES',
  OverlappingAbsences = 'OVERLAPPING_ABSENCES',
  StartTimeGreaterThanEndTime = 'START_TIME_GREATER_THAN_END_TIME'
}

export type ValidateAbsenceRequestInsufficientCreditsError = {
  readonly __typename?: 'ValidateAbsenceRequestInsufficientCreditsError';
  readonly reason: ValidateAbsenceRequestErrorReason;
  readonly requestedAmount: Scalars['Float']['output'];
};

export type ValidateAbsenceRequestInsufficientNoticePeriodError = {
  readonly __typename?: 'ValidateAbsenceRequestInsufficientNoticePeriodError';
  readonly noticePeriodAmount: Scalars['Float']['output'];
  readonly noticePeriodUnit: AbsenceRequestPolicyNoticeRequiredUnit;
  readonly reason: ValidateAbsenceRequestErrorReason;
  readonly requestedAmount: Scalars['Float']['output'];
};

export type ValidateAbsenceRequestInvalidDaysTimesError = {
  readonly __typename?: 'ValidateAbsenceRequestInvalidDaysTimesError';
  readonly reason: ValidateAbsenceRequestErrorReason;
};

export type ValidateAbsenceRequestOverlappingAbsencesError = {
  readonly __typename?: 'ValidateAbsenceRequestOverlappingAbsencesError';
  readonly overlappingAbsences: ReadonlyArray<Absence>;
  readonly reason: ValidateAbsenceRequestErrorReason;
};

export type ValidateAbsenceRequestResponse = {
  readonly __typename?: 'ValidateAbsenceRequestResponse';
  readonly allowances: ReadonlyArray<ValidateAbsenceRequestAllowance>;
  readonly employeeAbsenceCategory: EmployeeAbsenceCategory;
  readonly employeeAbsenceCategoryId: Scalars['String']['output'];
  readonly error: Maybe<ValidateAbsenceRequestError>;
  readonly requestedAmount: Maybe<Scalars['Float']['output']>;
};

export type ValidateAbsenceRequestStartTimeGreaterThanEndTimeError = {
  readonly __typename?: 'ValidateAbsenceRequestStartTimeGreaterThanEndTimeError';
  readonly reason: ValidateAbsenceRequestErrorReason;
};

export type ValidateDataChangeRequestPayload = {
  readonly __typename?: 'ValidateDataChangeRequestPayload';
  readonly error: Maybe<Scalars['String']['output']>;
  readonly isValid: Scalars['Boolean']['output'];
};

export type WithExtraFields = {
  readonly Id: Scalars['String']['output'];
  readonly extraFields: ReadonlyArray<ExtraFieldValue>;
  readonly recordType: RecordType;
};

export type WithLoomVideo = {
  readonly Id: Scalars['String']['output'];
  readonly flair__Loom_Video__c: Maybe<Scalars['String']['output']>;
  readonly loomVideo: Maybe<LoomVideo>;
};

export type WithReactions = {
  readonly Id: Scalars['String']['output'];
  readonly reactions: ReadonlyArray<Reaction>;
};

export type Workflow = {
  readonly __typename?: 'Workflow';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly employee: Colleague;
  readonly flair__Closest_Item_Due_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Complete_Progress__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  readonly flair__First_Opened__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Show_Onboarding_Widget__c: Scalars['Boolean']['output'];
  readonly flair__Status__c: WorkflowStatus;
  readonly flair__Type__c: WorkflowType;
  readonly flair__Workflow_Template__c: Maybe<Scalars['String']['output']>;
  readonly item: Maybe<WorkflowItem>;
  readonly items: ReadonlyArray<WorkflowItem>;
  readonly steps: ReadonlyArray<WorkflowStep>;
};


export type WorkflowItemArgs = {
  id: Scalars['String']['input'];
};

export enum WorkflowContext {
  All = 'ALL',
  My = 'MY',
  Other = 'OTHER'
}

export type WorkflowItem = Commentable & {
  readonly __typename?: 'WorkflowItem';
  readonly CreatedDate: Scalars['DateTime']['output'];
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
  readonly attachments: ReadonlyArray<ContentDocumentLink>;
  readonly canUpdate: Scalars['Boolean']['output'];
  readonly comments: ReadonlyArray<Comment>;
  readonly commentsCount: Scalars['Int']['output'];
  readonly dataFields: Maybe<ReadonlyArray<WorkflowItemDataField>>;
  readonly documentCategory: Maybe<DocumentCategory>;
  readonly flair__Data_Fields__c: Maybe<Scalars['String']['output']>;
  readonly flair__Description__c: Maybe<Scalars['String']['output']>;
  readonly flair__Document_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__Due_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Employee_Evaluation__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee_Feedback_Participant__c: Maybe<Scalars['String']['output']>;
  readonly flair__Employee__c: Scalars['String']['output'];
  /** @deprecated use flair__Document_Category__c and documentCategory instead */
  readonly flair__File_Category__c: Maybe<Scalars['String']['output']>;
  readonly flair__File_Format__c: Maybe<WorkflowItemFileFormat>;
  readonly flair__Hide_From_Assignee__c: Scalars['Boolean']['output'];
  readonly flair__Instructions_Loom_Url__c: Maybe<Scalars['String']['output']>;
  readonly flair__Is_Mandatory__c: Scalars['Boolean']['output'];
  readonly flair__Last_Status_Change_Date__c: Maybe<Scalars['DateTime']['output']>;
  readonly flair__Loom_Video__c: Maybe<Scalars['String']['output']>;
  readonly flair__Order__c: Maybe<Scalars['Int']['output']>;
  readonly flair__Responsible_Team__c: Maybe<Scalars['String']['output']>;
  readonly flair__Responsible_Type2__c: Maybe<WorkflowItemResponsibleType>;
  readonly flair__Responsible__c: Maybe<Scalars['String']['output']>;
  readonly flair__Sign_Request_Signer__c: Maybe<Scalars['String']['output']>;
  readonly flair__Status__c: WorkflowItemStatus;
  readonly flair__Sub_Tasks_Json__c: Maybe<Scalars['String']['output']>;
  readonly flair__Type__c: WorkflowItemType;
  readonly flair__Workflow_Step__c: Scalars['String']['output'];
  readonly flair__Workflow_Template_Item__c: Maybe<Scalars['String']['output']>;
  readonly flair__Workflow__c: Scalars['String']['output'];
  readonly loomVideo: Maybe<LoomVideo>;
  readonly responsible: Maybe<Colleague>;
  readonly responsibleTeam: Maybe<Team>;
  readonly signRequestSigner: Maybe<SignRequestSigner>;
  readonly subTasks: ReadonlyArray<WorkflowSubTask>;
  readonly uploadedFile: Maybe<ContentDocument>;
  readonly uploadedFileVisibility: Maybe<DocumentVisiblity>;
  readonly workflow: Workflow;
  readonly workflowStep: WorkflowStep;
};


export type WorkflowItemDataFieldsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowItemDataField = {
  readonly __typename?: 'WorkflowItemDataField';
  readonly fieldInfo: FieldInfo;
  readonly value: Maybe<Scalars['String']['output']>;
};

export enum WorkflowItemFileFormat {
  Any = 'ANY',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Unknown = 'UNKNOWN',
  Zip = 'ZIP'
}

export type WorkflowItemNotificationRenderInfo = NotificationRenderInfo & {
  readonly __typename?: 'WorkflowItemNotificationRenderInfo';
  readonly notificationId: Scalars['String']['output'];
  readonly recordId: Maybe<Scalars['String']['output']>;
  readonly renderInfoType: RenderInfoType;
  readonly workflow: Maybe<Workflow>;
};

export enum WorkflowItemResponsibleType {
  Assignee = 'ASSIGNEE',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  PerformanceManager = 'PERFORMANCE_MANAGER',
  Team = 'TEAM',
  Unknown = 'UNKNOWN'
}

export enum WorkflowItemStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type WorkflowItemTemplate = {
  readonly __typename?: 'WorkflowItemTemplate';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export enum WorkflowItemType {
  AccountCreation = 'ACCOUNT_CREATION',
  CycleAssignment = 'CYCLE_ASSIGNMENT',
  DataRequest = 'DATA_REQUEST',
  EvaluationRequest = 'EVALUATION_REQUEST',
  FileRequest = 'FILE_REQUEST',
  Regular = 'REGULAR',
  Signature = 'SIGNATURE',
  Unknown = 'UNKNOWN',
  VideoRequest = 'VIDEO_REQUEST'
}

export type WorkflowItemsFilterInput2 = {
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly myTasks: InputMaybe<Scalars['Boolean']['input']>;
  readonly responsibleId: InputMaybe<Scalars['String']['input']>;
  readonly status: InputMaybe<WorkflowItemStatus>;
  readonly workflowId: InputMaybe<Scalars['String']['input']>;
  readonly workflowItemTemplateId: InputMaybe<Scalars['String']['input']>;
  readonly workflowTemplateId: InputMaybe<Scalars['String']['input']>;
  readonly workflowType: InputMaybe<WorkflowType>;
  readonly year: InputMaybe<Scalars['LocalDate']['input']>;
};

export type WorkflowItemsFilterOptions = {
  readonly __typename?: 'WorkflowItemsFilterOptions';
  readonly employeeIds: ReadonlyArray<Scalars['String']['output']>;
  readonly employees: ReadonlyArray<Colleague>;
  readonly responsibleEmployeeIds: ReadonlyArray<Scalars['String']['output']>;
  readonly responsibleEmployees: ReadonlyArray<Colleague>;
  readonly responsibleTeamIds: ReadonlyArray<Scalars['String']['output']>;
  readonly responsibleTeams: ReadonlyArray<Team>;
  readonly workflowItemTemplateIds: ReadonlyArray<Scalars['String']['output']>;
  readonly workflowItemTemplates: ReadonlyArray<WorkflowItemTemplate>;
  readonly workflowTemplateIds: ReadonlyArray<Scalars['String']['output']>;
  readonly workflowTemplates: ReadonlyArray<WorkflowTemplate>;
};

export enum WorkflowItemsFilterType {
  ForAll = 'FOR_ALL',
  ForMe = 'FOR_ME',
  ForOthers = 'FOR_OTHERS'
}

export type WorkflowItemsPagination = {
  readonly __typename?: 'WorkflowItemsPagination';
  readonly items: ReadonlyArray<WorkflowItem>;
  readonly paginationInfo: PaginationInfo;
};

export enum WorkflowListSortFieldEnum {
  DueDate = 'DUE_DATE',
  EmployeeName = 'EMPLOYEE_NAME',
  Workflow = 'WORKFLOW',
  WorkflowStatus = 'WORKFLOW_STATUS',
  WorkflowType = 'WORKFLOW_TYPE'
}

export type WorkflowListSortInput = {
  readonly field: WorkflowListSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export type WorkflowMutations = {
  readonly __typename?: 'WorkflowMutations';
  readonly deleteWorkflowItemLoomVideo: UpdateWorkflowItemPayload;
  readonly updateWorkflowFirstOpenedDate: UpdateWorkflowFirstOpenedDatePayload;
  readonly updateWorkflowItemDataRequest: UpdateWorkflowItemDataRequestPayload;
  readonly updateWorkflowItemFileRequest: UpdateWorkflowItemPayload;
  readonly updateWorkflowItemRegular: UpdateWorkflowItemPayload;
  readonly updateWorkflowItemStatus: UpdateWorkflowItemPayload;
  readonly updateWorkflowItemSubTasks: UpdateWorkflowItemPayload;
  readonly updateWorkflowItemVideoRequest: UpdateWorkflowItemPayload;
};


export type WorkflowMutationsDeleteWorkflowItemLoomVideoArgs = {
  input: DeleteWorkflowItemLoomVideoInput;
};


export type WorkflowMutationsUpdateWorkflowFirstOpenedDateArgs = {
  input: UpdateWorkflowFirstOpenedDateInput;
};


export type WorkflowMutationsUpdateWorkflowItemDataRequestArgs = {
  input: UpdateWorkflowItemDataRequestInput;
};


export type WorkflowMutationsUpdateWorkflowItemFileRequestArgs = {
  input: UpdateWorkflowItemFileRequestInput;
};


export type WorkflowMutationsUpdateWorkflowItemRegularArgs = {
  input: UpdateWorkflowItemRegularInput;
};


export type WorkflowMutationsUpdateWorkflowItemStatusArgs = {
  input: UpdateWorkflowItemStatusInput;
};


export type WorkflowMutationsUpdateWorkflowItemSubTasksArgs = {
  input: UpdateWorkflowItemSubTasksInput;
};


export type WorkflowMutationsUpdateWorkflowItemVideoRequestArgs = {
  input: UpdateWorkflowItemVideoRequestInput;
};

export type WorkflowPagination = {
  readonly __typename?: 'WorkflowPagination';
  readonly items: ReadonlyArray<Workflow>;
  readonly paginationInfo: PaginationInfo;
};

export enum WorkflowStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Unknown = 'UNKNOWN'
}

export type WorkflowStep = {
  readonly __typename?: 'WorkflowStep';
  readonly Id: Scalars['String']['output'];
  readonly flair__Activating_Trigger__c: WorkflowStepActivatingTrigger;
  readonly flair__Activation_Date__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Is_Active__c: Scalars['Boolean']['output'];
  readonly flair__Mandatory_Items_Completed_At__c: Maybe<Scalars['LocalDate']['output']>;
  readonly flair__Order__c: Scalars['Int']['output'];
  readonly flair__Previous_Workflow_Step__c: Maybe<Scalars['String']['output']>;
  readonly flair__Step_Name__c: Scalars['String']['output'];
  readonly flair__Workflow__c: Scalars['String']['output'];
  readonly previousWorkflowStep: Maybe<WorkflowStep>;
  readonly workflow: Workflow;
};

export enum WorkflowStepActivatingTrigger {
  AfterFinishingMandatoryTasks = 'AFTER_FINISHING_MANDATORY_TASKS',
  SpecificDate = 'SPECIFIC_DATE',
  Unknown = 'UNKNOWN'
}

export type WorkflowSubTask = {
  readonly __typename?: 'WorkflowSubTask';
  readonly checked: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
  readonly text: Scalars['String']['output'];
};

export type WorkflowTaskInput = {
  readonly checked: Scalars['Boolean']['input'];
  readonly id: Scalars['String']['input'];
  readonly text: Scalars['String']['input'];
};

export type WorkflowTemplate = {
  readonly __typename?: 'WorkflowTemplate';
  readonly Id: Scalars['String']['output'];
  readonly Name: Scalars['String']['output'];
};

export enum WorkflowType {
  Employee = 'EMPLOYEE',
  EmployeeEquipmentRequest = 'EMPLOYEE_EQUIPMENT_REQUEST',
  ExpenseReport = 'EXPENSE_REPORT',
  Offboarding = 'OFFBOARDING',
  Onboarding = 'ONBOARDING',
  Other = 'OTHER'
}

export type WorkflowsFilterInput = {
  readonly employeeId: InputMaybe<Scalars['String']['input']>;
  readonly workflowStatus: InputMaybe<WorkflowStatus>;
  readonly workflowStatuses: InputMaybe<ReadonlyArray<WorkflowStatus>>;
  readonly workflowTemplateId: InputMaybe<Scalars['String']['input']>;
  readonly workflowType: InputMaybe<WorkflowType>;
  readonly year: InputMaybe<Scalars['LocalDate']['input']>;
};

export type WorkflowsFilterOptions = {
  readonly __typename?: 'WorkflowsFilterOptions';
  readonly employeeIds: ReadonlyArray<Scalars['String']['output']>;
  readonly employees: ReadonlyArray<Colleague>;
  readonly workflowTemplateIds: ReadonlyArray<Scalars['String']['output']>;
  readonly workflowTemplates: ReadonlyArray<WorkflowTemplate>;
};

export enum WorkflowsItemsListSortFieldEnum {
  DueDate = 'DUE_DATE',
  EmployeeName = 'EMPLOYEE_NAME',
  Responsible = 'RESPONSIBLE',
  Task = 'TASK',
  Workflow = 'WORKFLOW',
  WorkflowStatus = 'WORKFLOW_STATUS',
  WorkflowType = 'WORKFLOW_TYPE'
}

export type WorkflowsItemsListSortInput = {
  readonly field: WorkflowsItemsListSortFieldEnum;
  readonly order: InputMaybe<AscDescEnum>;
};

export enum WorkingDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type WorkloadDay = {
  readonly __typename?: 'WorkloadDay';
  readonly breakMinutes: Maybe<Scalars['Int']['output']>;
  readonly breaksScheduled: Maybe<ReadonlyArray<BreakScheduled>>;
  readonly dayOfWeek: Scalars['String']['output'];
  readonly endTime: Maybe<Scalars['Time']['output']>;
  readonly startTime: Maybe<Scalars['Time']['output']>;
  readonly workingMinutes: Scalars['Int']['output'];
  readonly workloadId: Scalars['String']['output'];
  readonly workloadWeekId: Scalars['String']['output'];
};

export enum WorkloadModel {
  Fixed = 'FIXED',
  Flexible = 'FLEXIBLE',
  HourlyBased = 'HOURLY_BASED',
  Unknown = 'UNKNOWN'
}

export enum WorkloadTrackingType {
  NoTracking = 'NO_TRACKING',
  ProjectTracking = 'PROJECT_TRACKING',
  TimeTracking = 'TIME_TRACKING',
  TimeTrackingAndProjectTracking = 'TIME_TRACKING_AND_PROJECT_TRACKING',
  TimeTrackingWithProjects = 'TIME_TRACKING_WITH_PROJECTS'
}

export enum WorkloadType {
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type WorkloadWeek = {
  readonly __typename?: 'WorkloadWeek';
  readonly Id: Scalars['String']['output'];
  readonly friday: WorkloadDay;
  readonly monday: WorkloadDay;
  readonly saturday: WorkloadDay;
  readonly sunday: WorkloadDay;
  readonly thursday: WorkloadDay;
  readonly tuesday: WorkloadDay;
  readonly wednesday: WorkloadDay;
  readonly workload: MyWorkload;
  readonly workloadId: Scalars['String']['output'];
};

export type WorkloadWeekSf = {
  readonly __typename?: 'WorkloadWeekSf';
  readonly Id: Scalars['String']['output'];
  readonly flair__Employee_Workload__c: Scalars['String']['output'];
  readonly flair__Friday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Friday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Friday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Friday_Working_Minutes__c: Scalars['Float']['output'];
  readonly flair__Monday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Monday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Monday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Monday_Working_Minutes__c: Scalars['Float']['output'];
  readonly flair__Saturday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Saturday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Saturday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Saturday_Working_Minutes__c: Scalars['Float']['output'];
  readonly flair__Sunday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Sunday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Sunday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Sunday_Working_Minutes__c: Scalars['Float']['output'];
  readonly flair__Thursday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Thursday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Thursday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Thursday_Working_Minutes__c: Scalars['Float']['output'];
  readonly flair__Tuesday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Tuesday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Tuesday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Tuesday_Working_Minutes__c: Scalars['Float']['output'];
  readonly flair__Wednesday_Break_Minutes__c: Scalars['Float']['output'];
  readonly flair__Wednesday_End_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Wednesday_Start_Time__c: Maybe<Scalars['Time']['output']>;
  readonly flair__Wednesday_Working_Minutes__c: Scalars['Float']['output'];
};

export type AbsencePopoverFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType };

export type AbsencePopoverOverlappingFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType };

export type AbsencePopoverHolidayFragment = { readonly __typename?: 'Holiday', readonly Id: string, readonly Name: string, readonly flair__Type__c: HolidayType };

export type TimeSheetWorkloadWithTimeFrameworkFragment = { readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null };

export type CalendarPeriodPopoverFragment = { readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string };

export type SearchEmployeesForMentionQueryVariables = Exact<{
  filter: SearchEmployeesForMention;
}>;


export type SearchEmployeesForMentionQuery = { readonly __typename?: 'Query', readonly searchEmployeesForMention: ReadonlyArray<{ readonly __typename?: 'SearchMentionEmployeePayload', readonly id: string, readonly name: string, readonly avatarUrl: string | null, readonly position: string | null, readonly hasAccess: boolean }> };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { readonly __typename?: 'Mutation', readonly comment: { readonly __typename?: 'CommentMutations', readonly createComment: { readonly __typename?: 'CommentPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> } | null, readonly related: { readonly __typename?: 'Absence', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Announcement', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'CandidateEvaluation', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Celebration', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeCertificate', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeDocument', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Expense', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'ExpenseGroup', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'InventoryItem', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'JobCandidate', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Ticket', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'WorkflowItem', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | null } } };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { readonly __typename?: 'Mutation', readonly comment: { readonly __typename?: 'CommentMutations', readonly deleteComment: { readonly __typename?: 'CommentPayload', readonly recordId: string | null, readonly error: string | null, readonly related: { readonly __typename?: 'Absence', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Announcement', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'CandidateEvaluation', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Celebration', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeCertificate', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeDocument', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Expense', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'ExpenseGroup', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'InventoryItem', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'JobCandidate', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Ticket', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'WorkflowItem', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | null } } };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { readonly __typename?: 'Mutation', readonly comment: { readonly __typename?: 'CommentMutations', readonly updateComment: { readonly __typename?: 'UpdatedCommentPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> } | null } } };

export type CommentsQueryVariables = Exact<{
  commentableId: CommentableIdInput;
}>;


export type CommentsQuery = { readonly __typename?: 'Query', readonly commentable: { readonly __typename?: 'Absence', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Announcement', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'CandidateEvaluation', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Celebration', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeCertificate', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'EmployeeDocument', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Expense', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'ExpenseGroup', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'InventoryItem', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'JobCandidate', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'Ticket', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } | { readonly __typename?: 'WorkflowItem', readonly commentsCount: number, readonly Id: string, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> }> } };

export type EmployeeWithAvatarAndPopup_ColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type UpdateMyAvatarMutationVariables = Exact<{
  input: InputMaybe<UpdateMyAvatarInput>;
}>;


export type UpdateMyAvatarMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly updateMyAvatar: { readonly __typename?: 'UpdateMyAvatarPayload', readonly recordId: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null, readonly urlLarge: string | null } | null } } } } };

export type RemoveMyAvatarMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveMyAvatarMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly removeMyAvatar: { readonly __typename?: 'UpdateMyAvatarPayload', readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null, readonly urlLarge: string | null } | null } } } } };

export type EmployeeByTeamSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeByTeamSelectQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> }, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }> }> };

export type PeformanceReviewPageQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
  feedbackId: Scalars['String']['input'];
}>;


export type PeformanceReviewPageQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly feedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null }>, readonly objectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null }> }, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Request__c: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Feedback__c: string | null, readonly flair__Note__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null } }> } | null, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Request__c: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Feedback__c: string | null, readonly flair__Note__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility } }> } } | null } };

export type UpdateEmployeeFeedbackAnswerMutationVariables = Exact<{
  input: UpdateEmployeeFeedbackAnswerInput;
}>;


export type UpdateEmployeeFeedbackAnswerMutation = { readonly __typename?: 'Mutation', readonly updateEmployeeFeedbackAnswer: { readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string } | null };

export type UpsertEmployeeObjectiveMutationVariables = Exact<{
  input: UpsertEmployeeObjectiveInput;
}>;


export type UpsertEmployeeObjectiveMutation = { readonly __typename?: 'Mutation', readonly upsertEmployeeObjective: string };

export type ExtraFieldLookupOptionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  contextParams: ReadonlyArray<ExtraFieldContextParamInput> | ExtraFieldContextParamInput;
  extraFieldsConfigReference: InputMaybe<ExtraFieldsConfigReferenceInput>;
}>;


export type ExtraFieldLookupOptionsQuery = { readonly __typename?: 'Query', readonly extraFields: { readonly __typename?: 'ExtraFields', readonly extraFieldLookupOptions: ReadonlyArray<{ readonly __typename?: 'ExtraFieldLookupOption', readonly id: string, readonly label: string }> } };

type ExtraFieldsTable_WithExtraFields_Absence_Fragment = { readonly __typename?: 'Absence', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

type ExtraFieldsTable_WithExtraFields_Colleague_Fragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

type ExtraFieldsTable_WithExtraFields_Expense_Fragment = { readonly __typename?: 'Expense', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

type ExtraFieldsTable_WithExtraFields_ExpenseItem_Fragment = { readonly __typename?: 'ExpenseItem', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

type ExtraFieldsTable_WithExtraFields_Project_Fragment = { readonly __typename?: 'Project', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

type ExtraFieldsTable_WithExtraFields_ProjectTimeEntry_Fragment = { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

export type ExtraFieldsTable_WithExtraFieldsFragment = ExtraFieldsTable_WithExtraFields_Absence_Fragment | ExtraFieldsTable_WithExtraFields_Colleague_Fragment | ExtraFieldsTable_WithExtraFields_Expense_Fragment | ExtraFieldsTable_WithExtraFields_ExpenseItem_Fragment | ExtraFieldsTable_WithExtraFields_Project_Fragment | ExtraFieldsTable_WithExtraFields_ProjectTimeEntry_Fragment;

export type ExtraFieldsTable_ExtraFieldValueFragment = { readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null };

export type ExtraFieldsTable_ProjectFragment = { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string };

export type ExtraFieldsTable_ColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type ObjectExtraFieldsFragment = { readonly __typename?: 'ObjectExtraFields', readonly objectApiName: string, readonly recordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean }>, readonly availableRecordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean }>, readonly form: ReadonlyArray<{ readonly __typename?: 'ExtraFieldFormInfo', readonly id: string, readonly fieldApiName: string, readonly required: boolean, readonly formId: string | null, readonly visibilityCondition: string | null, readonly visibleLines: number | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } }>, readonly table: ReadonlyArray<{ readonly __typename?: 'ExtraFieldTableInfo', readonly id: string, readonly fieldApiName: string, readonly tableId: string | null, readonly customFieldName: string | null, readonly columnTitle: string | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } | null }> };

export type AvailableRecordTypeFragment = { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean };

export type ExtraFieldFormInfoFragment = { readonly __typename?: 'ExtraFieldFormInfo', readonly id: string, readonly fieldApiName: string, readonly required: boolean, readonly formId: string | null, readonly visibilityCondition: string | null, readonly visibleLines: number | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } };

export type ExtraFieldTableInfoFragment = { readonly __typename?: 'ExtraFieldTableInfo', readonly id: string, readonly fieldApiName: string, readonly tableId: string | null, readonly customFieldName: string | null, readonly columnTitle: string | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } | null };

export type ExtraFieldInfoFragment = { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null };

export type AllObjectsExtraFieldsQueryVariables = Exact<{
  objectApiNames: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AllObjectsExtraFieldsQuery = { readonly __typename?: 'Query', readonly extraFields: { readonly __typename?: 'ExtraFields', readonly objectsExtraFields: ReadonlyArray<{ readonly __typename?: 'ObjectExtraFields', readonly objectApiName: string, readonly recordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean }>, readonly availableRecordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean }>, readonly form: ReadonlyArray<{ readonly __typename?: 'ExtraFieldFormInfo', readonly id: string, readonly fieldApiName: string, readonly required: boolean, readonly formId: string | null, readonly visibilityCondition: string | null, readonly visibleLines: number | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } }>, readonly table: ReadonlyArray<{ readonly __typename?: 'ExtraFieldTableInfo', readonly id: string, readonly fieldApiName: string, readonly tableId: string | null, readonly customFieldName: string | null, readonly columnTitle: string | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } | null }> }> } };

export type WithExtraFieldsQueryVariables = Exact<{
  recordId: Scalars['String']['input'];
  objectApiName: Scalars['String']['input'];
}>;


export type WithExtraFieldsQuery = { readonly __typename?: 'Query', readonly extraFields: { readonly __typename?: 'ExtraFields', readonly withExtraFields: { readonly __typename?: 'Absence', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } | { readonly __typename?: 'Colleague', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } | { readonly __typename?: 'Expense', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } | { readonly __typename?: 'ExpenseItem', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } | { readonly __typename?: 'Project', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } | { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } } };

export type ExtraFieldValueFragment = { readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType };

export type ExtraFieldValueShortFragment = { readonly __typename?: 'ExtraFieldValue', readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType };

export type RecordTypeFragment = { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean };

export type SendFeedbackMutationVariables = Exact<{
  input: SendFeedbackInput;
}>;


export type SendFeedbackMutation = { readonly __typename?: 'Mutation', readonly sendFeedback: { readonly __typename?: 'SendFeedbackPayload', readonly id: string, readonly title: string } };

export type HolidayPopoverFragment = { readonly __typename?: 'Holiday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string };

export type LoomVideoFragment = { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string };

export type AddLoomVideoMutationVariables = Exact<{
  input: LoomVideoInput;
}>;


export type AddLoomVideoMutation = { readonly __typename?: 'Mutation', readonly loomVideo: { readonly __typename?: 'LoomVideoMutations', readonly createLoomVideo: { readonly __typename?: 'CreateLoomVideoPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly related: { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null } | null } } };

export type RemoveLoomVideoMutationVariables = Exact<{
  input: DeleteLoomVideoInput;
}>;


export type RemoveLoomVideoMutation = { readonly __typename?: 'Mutation', readonly loomVideo: { readonly __typename?: 'LoomVideoMutations', readonly deleteLoomVideo: { readonly __typename?: 'DeleteLoomVideoPayload', readonly recordId: string | null, readonly related: { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null } | null } } };

export type MyAllApprovalRequestsLightQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAllApprovalRequestsLightQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Related_Object_Name__c: string, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null }> } };

export type AbsenceApprovalRequestNotificationFieldsFragment = { readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | null };

export type AbsenceNotificationFieldsFragment = { readonly __typename?: 'AbsenceNotificationRenderInfo', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null };

export type CandidateEvaluationNotificationFieldsFragment = { readonly __typename?: 'CandidateEvaluationNotificationRenderInfo', readonly candidateEvaluation: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } } | null };

export type CelebrationNotificationFieldsFragment = { readonly __typename?: 'CelebrationNotificationRenderInfo', readonly celebrationEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly celebration: { readonly __typename?: 'Celebration', readonly Id: string, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } } } | null };

export type NotificationFieldsFragment = { readonly __typename?: 'Notification', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Is_Read__c: boolean, readonly flair__Is_Snoozed__c: boolean, readonly flair__Read_At__c: string | null, readonly flair__Snoozed_At__c: string | null, readonly flair__Unsnooze_At__c: string | null, readonly flair__Is_Archived__c: boolean, readonly flair__Is_Task__c: boolean, readonly flair__Record_Id__c: string | null, readonly flair__Object_Type__c: string | null, readonly flair__Body__c: string | null, readonly flair__Title__c: string | null, readonly CreatedDate: string, readonly flair__Type__c: string, readonly flair__Button_Name__c: string | null, readonly flair__Button_Link__c: string | null };

export type NotificationItemFragment = { readonly __typename?: 'Notification', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Is_Read__c: boolean, readonly flair__Is_Snoozed__c: boolean, readonly flair__Read_At__c: string | null, readonly flair__Snoozed_At__c: string | null, readonly flair__Unsnooze_At__c: string | null, readonly flair__Is_Archived__c: boolean, readonly flair__Is_Task__c: boolean, readonly flair__Record_Id__c: string | null, readonly flair__Object_Type__c: string | null, readonly flair__Body__c: string | null, readonly flair__Title__c: string | null, readonly CreatedDate: string, readonly flair__Type__c: string, readonly flair__Button_Name__c: string | null, readonly flair__Button_Link__c: string | null, readonly renderInfo: { readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | null } | { readonly __typename?: 'AbsenceNotificationRenderInfo', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | { readonly __typename?: 'CandidateEvaluationNotificationRenderInfo', readonly candidateEvaluation: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } } | null } | { readonly __typename?: 'CelebrationNotificationRenderInfo', readonly celebrationEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly celebration: { readonly __typename?: 'Celebration', readonly Id: string, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } } } | null } | { readonly __typename?: 'CommentNotificationRenderInfo', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly Name: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly flair__Related_Object_Name__c: string, readonly CreatedDate: string, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }>, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } | null } | { readonly __typename?: 'SimpleNotificationRenderInfo' } | { readonly __typename?: 'TicketClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketManagerClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketSharedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketSubmittedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo', readonly withdrawal: { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType } | null } | { readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo', readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null } | { readonly __typename?: 'TimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | { readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'WorkflowItemNotificationRenderInfo', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string } | null } };

export type TicketClosedNotificationFieldsFragment = { readonly __typename?: 'TicketClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null };

export type TicketManagerClosedNotificationFieldsFragment = { readonly __typename?: 'TicketManagerClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null };

export type TicketManagerStatusChangedNotificationFieldsFragment = { readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null };

export type TicketSharedNotificationFieldsFragment = { readonly __typename?: 'TicketSharedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null };

export type TicketStatusChangedNotificationFieldsFragment = { readonly __typename?: 'TicketStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null };

export type TicketSubmittedNotificationFieldsFragment = { readonly __typename?: 'TicketSubmittedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null };

export type TimeBalanceWithdrawalNotificationRenderInfoFieldsFragment = { readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo', readonly withdrawal: { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType } | null };

export type TimeEntryChangeRequestNotificationFieldsFragment = { readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo', readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null };

export type TimeEntryNotificationFieldsFragment = { readonly __typename?: 'TimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null };

export type TimeLimitTimeEntryNotificationFieldsFragment = { readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null };

export type WorkflowItemNotificationFieldsFragment = { readonly __typename?: 'WorkflowItemNotificationRenderInfo', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string } | null };

export type CommentNotificationFieldsFragment = { readonly __typename?: 'CommentNotificationRenderInfo', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly Name: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly flair__Related_Object_Name__c: string, readonly CreatedDate: string, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }>, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } | null };

export type MarkAllInboxNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllInboxNotificationsAsReadMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly markAllInboxNotificationsAsRead: { readonly __typename?: 'AllNotificationsActionPayload', readonly recordIds: ReadonlyArray<string> } } };

export type MarkAllTaskNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllTaskNotificationsAsReadMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly markAllTaskNotificationsAsRead: { readonly __typename?: 'AllNotificationsActionPayload', readonly recordIds: ReadonlyArray<string> } } };

export type ArchiveAllInboxNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ArchiveAllInboxNotificationsMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly archiveAllInboxNotifications: { readonly __typename?: 'AllNotificationsActionPayload', readonly recordIds: ReadonlyArray<string> } } };

export type ArchiveNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveNotificationMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly archiveNotification: { readonly __typename?: 'NotificationPayload', readonly recordId: string | null, readonly error: string | null } } };

export type UnarchiveNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UnarchiveNotificationMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly unarchiveNotification: { readonly __typename?: 'NotificationPayload', readonly recordId: string | null, readonly error: string | null } } };

export type SnoozeNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  unsnoozeAt: Scalars['DateTime']['input'];
}>;


export type SnoozeNotificationMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly snoozeNotification: { readonly __typename?: 'NotificationPayload', readonly recordId: string | null, readonly error: string | null } } };

export type UnsnoozeNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UnsnoozeNotificationMutation = { readonly __typename?: 'Mutation', readonly notifications: { readonly __typename?: 'NotificationMutations', readonly unsnoozeNotification: { readonly __typename?: 'NotificationPayload', readonly recordId: string | null, readonly error: string | null } } };

export type NotificationsHomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsHomePageQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly inboxNotifications: { readonly __typename?: 'NotificationPagination', readonly unreadCount: number }, readonly taskNotifications: { readonly __typename?: 'NotificationPagination', readonly unreadCount: number, readonly paginationInfo: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type InboxNotificationsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type InboxNotificationsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly inboxNotifications: { readonly __typename?: 'NotificationPagination', readonly unreadCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Notification', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Is_Read__c: boolean, readonly flair__Is_Snoozed__c: boolean, readonly flair__Read_At__c: string | null, readonly flair__Snoozed_At__c: string | null, readonly flair__Unsnooze_At__c: string | null, readonly flair__Is_Archived__c: boolean, readonly flair__Is_Task__c: boolean, readonly flair__Record_Id__c: string | null, readonly flair__Object_Type__c: string | null, readonly flair__Body__c: string | null, readonly flair__Title__c: string | null, readonly CreatedDate: string, readonly flair__Type__c: string, readonly flair__Button_Name__c: string | null, readonly flair__Button_Link__c: string | null, readonly renderInfo: { readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | null } | { readonly __typename?: 'AbsenceNotificationRenderInfo', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | { readonly __typename?: 'CandidateEvaluationNotificationRenderInfo', readonly candidateEvaluation: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } } | null } | { readonly __typename?: 'CelebrationNotificationRenderInfo', readonly celebrationEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly celebration: { readonly __typename?: 'Celebration', readonly Id: string, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } } } | null } | { readonly __typename?: 'CommentNotificationRenderInfo', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly Name: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly flair__Related_Object_Name__c: string, readonly CreatedDate: string, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }>, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } | null } | { readonly __typename?: 'SimpleNotificationRenderInfo' } | { readonly __typename?: 'TicketClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketManagerClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketSharedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketSubmittedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo', readonly withdrawal: { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType } | null } | { readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo', readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null } | { readonly __typename?: 'TimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | { readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'WorkflowItemNotificationRenderInfo', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string } | null } }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type TaskNotificationsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type TaskNotificationsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly taskNotifications: { readonly __typename?: 'NotificationPagination', readonly unreadCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Notification', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Is_Read__c: boolean, readonly flair__Is_Snoozed__c: boolean, readonly flair__Read_At__c: string | null, readonly flair__Snoozed_At__c: string | null, readonly flair__Unsnooze_At__c: string | null, readonly flair__Is_Archived__c: boolean, readonly flair__Is_Task__c: boolean, readonly flair__Record_Id__c: string | null, readonly flair__Object_Type__c: string | null, readonly flair__Body__c: string | null, readonly flair__Title__c: string | null, readonly CreatedDate: string, readonly flair__Type__c: string, readonly flair__Button_Name__c: string | null, readonly flair__Button_Link__c: string | null, readonly renderInfo: { readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | null } | { readonly __typename?: 'AbsenceNotificationRenderInfo', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | { readonly __typename?: 'CandidateEvaluationNotificationRenderInfo', readonly candidateEvaluation: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } } | null } | { readonly __typename?: 'CelebrationNotificationRenderInfo', readonly celebrationEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly celebration: { readonly __typename?: 'Celebration', readonly Id: string, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } } } | null } | { readonly __typename?: 'CommentNotificationRenderInfo', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly Name: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly flair__Related_Object_Name__c: string, readonly CreatedDate: string, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }>, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } | null } | { readonly __typename?: 'SimpleNotificationRenderInfo' } | { readonly __typename?: 'TicketClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketManagerClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketSharedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketSubmittedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo', readonly withdrawal: { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType } | null } | { readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo', readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null } | { readonly __typename?: 'TimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | { readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'WorkflowItemNotificationRenderInfo', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string } | null } }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type SnoozedNotificationsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type SnoozedNotificationsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly snoozedNotifications: { readonly __typename?: 'NotificationPagination', readonly unreadCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Notification', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Is_Read__c: boolean, readonly flair__Is_Snoozed__c: boolean, readonly flair__Read_At__c: string | null, readonly flair__Snoozed_At__c: string | null, readonly flair__Unsnooze_At__c: string | null, readonly flair__Is_Archived__c: boolean, readonly flair__Is_Task__c: boolean, readonly flair__Record_Id__c: string | null, readonly flair__Object_Type__c: string | null, readonly flair__Body__c: string | null, readonly flair__Title__c: string | null, readonly CreatedDate: string, readonly flair__Type__c: string, readonly flair__Button_Name__c: string | null, readonly flair__Button_Link__c: string | null, readonly renderInfo: { readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | null } | { readonly __typename?: 'AbsenceNotificationRenderInfo', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | { readonly __typename?: 'CandidateEvaluationNotificationRenderInfo', readonly candidateEvaluation: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } } | null } | { readonly __typename?: 'CelebrationNotificationRenderInfo', readonly celebrationEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly celebration: { readonly __typename?: 'Celebration', readonly Id: string, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } } } | null } | { readonly __typename?: 'CommentNotificationRenderInfo', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly Name: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly flair__Related_Object_Name__c: string, readonly CreatedDate: string, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }>, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } | null } | { readonly __typename?: 'SimpleNotificationRenderInfo' } | { readonly __typename?: 'TicketClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketManagerClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketSharedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketSubmittedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo', readonly withdrawal: { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType } | null } | { readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo', readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null } | { readonly __typename?: 'TimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | { readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'WorkflowItemNotificationRenderInfo', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string } | null } }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type SnoozedNotificationsTotalCountQueryVariables = Exact<{ [key: string]: never; }>;


export type SnoozedNotificationsTotalCountQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly snoozedNotifications: { readonly __typename?: 'NotificationPagination', readonly paginationInfo: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type ArchivedNotificationsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type ArchivedNotificationsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly archivedNotifications: { readonly __typename?: 'NotificationPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Notification', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Is_Read__c: boolean, readonly flair__Is_Snoozed__c: boolean, readonly flair__Read_At__c: string | null, readonly flair__Snoozed_At__c: string | null, readonly flair__Unsnooze_At__c: string | null, readonly flair__Is_Archived__c: boolean, readonly flair__Is_Task__c: boolean, readonly flair__Record_Id__c: string | null, readonly flair__Object_Type__c: string | null, readonly flair__Body__c: string | null, readonly flair__Title__c: string | null, readonly CreatedDate: string, readonly flair__Type__c: string, readonly flair__Button_Name__c: string | null, readonly flair__Button_Link__c: string | null, readonly renderInfo: { readonly __typename?: 'AbsenceApprovalRequestNotificationRenderInfo', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | null } | { readonly __typename?: 'AbsenceNotificationRenderInfo', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null } | { readonly __typename?: 'CandidateEvaluationNotificationRenderInfo', readonly candidateEvaluation: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } } | null } | { readonly __typename?: 'CelebrationNotificationRenderInfo', readonly celebrationEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly celebration: { readonly __typename?: 'Celebration', readonly Id: string, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } } } | null } | { readonly __typename?: 'CommentNotificationRenderInfo', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly Name: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly flair__Related_Object_Name__c: string, readonly CreatedDate: string, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }>, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly url: string | null, readonly urlLarge: string | null } | null } | null } | { readonly __typename?: 'SimpleNotificationRenderInfo' } | { readonly __typename?: 'TicketClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketManagerClosedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketManagerStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketSharedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'TicketStatusChangedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TicketSubmittedNotificationRenderInfo', readonly ticket: { readonly __typename?: 'Ticket', readonly Id: string, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly label: string | null } | null } | null } | { readonly __typename?: 'TimeBalanceWithdrawalNotificationRenderInfo', readonly withdrawal: { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType } | null } | { readonly __typename?: 'TimeEntryChangeRequestNotificationRenderInfo', readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null } | { readonly __typename?: 'TimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | { readonly __typename?: 'TimeLimitTimeEntryNotificationRenderInfo', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } | null } | { readonly __typename?: 'WorkflowItemNotificationRenderInfo', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string } | null } }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type CreateReactionMutationVariables = Exact<{
  input: CreateReactionInput;
}>;


export type CreateReactionMutation = { readonly __typename?: 'Mutation', readonly reaction: { readonly __typename?: 'ReactionMutations', readonly createReaction: { readonly __typename?: 'ReactionPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } } | null, readonly related: { readonly __typename?: 'Celebration', readonly Id: string, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | { readonly __typename?: 'Comment', readonly Id: string, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | null } } };

export type DeleteReactionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteReactionMutation = { readonly __typename?: 'Mutation', readonly reaction: { readonly __typename?: 'ReactionMutations', readonly deleteReaction: { readonly __typename?: 'ReactionPayload', readonly recordId: string | null, readonly error: string | null, readonly related: { readonly __typename?: 'Celebration', readonly Id: string, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | { readonly __typename?: 'Comment', readonly Id: string, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | null } } };

export type RequestAbsenceButtonFragment = { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Order__c: number, readonly flair__Without_Balance__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> };

export type RequestAbsenceSidebarQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type RequestAbsenceSidebarQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Employee_Absence_Category__c: string | null }> } };

export type EmployeeAbsenceCategoryByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeeAbsenceCategoryByIdQuery = { readonly __typename?: 'Query', readonly employeeAbsenceCategoryById: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Type__c: AbsenceType, readonly flair__Special_Rules__c: string | null, readonly flair__Order__c: number, readonly flair__Without_Balance__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly accrualPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAccrualPolicy', readonly accrualPolicy: { readonly __typename?: 'AccrualPolicy', readonly flair__Interval__c: AccrualPolicyInterval } }>, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string, readonly flair__Min_Absence_Amount__c: number | null, readonly flair__Max_Absence_Amount__c: number | null, readonly flair__Max_Used_Amount__c: number | null, readonly flair__Max_Used_Amount_Period__c: AbsenceRequestPolicyUsedAmountPeriod | null, readonly flair__Min_Notice_Required__c: number | null, readonly flair__Min_Notice_Period_Unit__c: AbsenceRequestPolicyNoticeRequiredUnit | null, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null, readonly flair__Require_Note__c: boolean | null, readonly flair__Note_Placeholder__c: string | null } }> } | null };

export type CalculateAbsenceWorkingAmountQueryVariables = Exact<{
  input: CalculateAbsenceWorkingAmountInput;
}>;


export type CalculateAbsenceWorkingAmountQuery = { readonly __typename?: 'Query', readonly calculateAbsenceWorkingAmount: { readonly __typename?: 'CalculateAbsenceWorkingAmountResponse', readonly workingAmount: number, readonly hasCredits: boolean, readonly allowances: ReadonlyArray<{ readonly __typename?: 'CalculateAbsenceWorkingAmountAllowanceResponse', readonly id: string, readonly amountLeft: number, readonly withdrawalAmount: number, readonly periodStartDate: string | null, readonly periodEndDate: string | null }> } };

export type ValidateRequestAbsenceMutationVariables = Exact<{
  input: RequestAbsenceInput;
}>;


export type ValidateRequestAbsenceMutation = { readonly __typename?: 'Mutation', readonly absence: { readonly __typename?: 'AbsenceMutations', readonly validateAbsenceRequest: { readonly __typename?: 'ValidateAbsenceRequestResponse', readonly requestedAmount: number | null, readonly allowances: ReadonlyArray<{ readonly __typename?: 'ValidateAbsenceRequestAllowance', readonly id: string, readonly withdrawalAmount: number, readonly isSystem: boolean, readonly periodStartDate: string | null, readonly amountLeft: number }>, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly currentYearSummary: { readonly __typename?: 'AbsenceYearlySummary', readonly employeeAbsenceCategoryId: string, readonly previousPeriod: { readonly __typename?: 'AbsenceYearlySummaryPrevious', readonly startDate: string, readonly endDate: string, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number }> | null }, readonly currentPeriod: { readonly __typename?: 'AbsenceYearlySummaryCurrent', readonly startDate: string, readonly endDate: string, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number }> | null }, readonly nextPeriod: { readonly __typename?: 'AbsenceYearlySummaryNext', readonly startDate: string, readonly endDate: string, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number }> | null } } }, readonly error: { readonly __typename?: 'ValidateAbsenceRequestAboveMaxAmountError', readonly requestedAmount: number, readonly maxAmount: number } | { readonly __typename?: 'ValidateAbsenceRequestAboveMaxUsedAmountError', readonly requestedAmount: number, readonly usedAmount: number, readonly maxUsedAmount: number, readonly maxUsedAmountPeriod: { readonly __typename?: 'ValidateAbsenceRequestAboveMaxUsedAmountPeriod', readonly startDate: string, readonly endDate: string } } | { readonly __typename?: 'ValidateAbsenceRequestBelowMinAmountError', readonly requestedAmount: number, readonly minAmount: number } | { readonly __typename?: 'ValidateAbsenceRequestInsufficientCreditsError', readonly requestedAmount: number } | { readonly __typename?: 'ValidateAbsenceRequestInsufficientNoticePeriodError', readonly requestedAmount: number, readonly noticePeriodAmount: number, readonly noticePeriodUnit: AbsenceRequestPolicyNoticeRequiredUnit } | { readonly __typename?: 'ValidateAbsenceRequestInvalidDaysTimesError' } | { readonly __typename?: 'ValidateAbsenceRequestOverlappingAbsencesError', readonly overlappingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Employee_Absence_Category__c: string | null }> } | { readonly __typename?: 'ValidateAbsenceRequestStartTimeGreaterThanEndTimeError' } | null } } };

export type UpsertAbsenceMutationVariables = Exact<{
  input: UpsertAbsenceInput;
}>;


export type UpsertAbsenceMutation = { readonly __typename?: 'Mutation', readonly absence: { readonly __typename?: 'AbsenceMutations', readonly upsertAbsence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly CreatedDate: string, readonly flair__Days_Times__c: string | null, readonly commentsCount: number, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number }, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Without_Balance__c: boolean } } | null, readonly overlappingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }>, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly absenceDays: ReadonlyArray<{ readonly __typename?: 'AbsenceDay', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Day__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Time__c: string }> } } };

export type RequestAbsence_WithdrawalAllowanceFragment = { readonly __typename?: 'ValidateAbsenceRequestAllowance', readonly id: string, readonly withdrawalAmount: number, readonly isSystem: boolean, readonly periodStartDate: string | null, readonly amountLeft: number };

export type RequestAbsence_YearlySummaryFragment = { readonly __typename?: 'AbsenceYearlySummary', readonly employeeAbsenceCategoryId: string, readonly previousPeriod: { readonly __typename?: 'AbsenceYearlySummaryPrevious', readonly startDate: string, readonly endDate: string, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number }> | null }, readonly currentPeriod: { readonly __typename?: 'AbsenceYearlySummaryCurrent', readonly startDate: string, readonly endDate: string, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number }> | null }, readonly nextPeriod: { readonly __typename?: 'AbsenceYearlySummaryNext', readonly startDate: string, readonly endDate: string, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number }> | null } };

export type RequestAbsence_AllowanceFragment = { readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrued: number, readonly used: number, readonly lost: number, readonly expired: number };

export type EmployeeRequestFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeRequestFormsQuery = { readonly __typename?: 'Query', readonly requestForms: ReadonlyArray<{ readonly __typename?: 'RequestForm', readonly Id: string, readonly Name: string, readonly flair__Information__c: string | null, readonly flair__Data_Change_Object_Name__c: string | null, readonly flair__Employee_Field_Api_Name__c: string | null, readonly flair__Request_Type__c: RequestFormType, readonly flair__Visibility__c: RequestFormVisibility, readonly flair__Mandatory_Reason__c: boolean, readonly flair__Require_Approval__c: boolean, readonly flair__Position_Change_Enabled__c: boolean, readonly flair__Salary_Change_Enabled__c: boolean, readonly objectsFields: ReadonlyArray<{ readonly __typename?: 'RequestFormObjectFields', readonly objectName: string, readonly fields: ReadonlyArray<string> }>, readonly extraFieldInfos: ReadonlyArray<{ readonly __typename?: 'ExtraFieldFormInfo', readonly id: string, readonly fieldApiName: string, readonly required: boolean, readonly formId: string | null, readonly visibilityCondition: string | null, readonly visibleLines: number | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } }> | null, readonly recordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean }> }> };

export type RequestFormsForManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestFormsForManagerQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }> }, readonly requestForms: ReadonlyArray<{ readonly __typename?: 'RequestForm', readonly Id: string, readonly Name: string, readonly flair__Information__c: string | null, readonly flair__Data_Change_Object_Name__c: string | null, readonly flair__Employee_Field_Api_Name__c: string | null, readonly flair__Request_Type__c: RequestFormType, readonly flair__Visibility__c: RequestFormVisibility, readonly flair__Mandatory_Reason__c: boolean, readonly flair__Require_Approval__c: boolean, readonly flair__Position_Change_Enabled__c: boolean, readonly flair__Salary_Change_Enabled__c: boolean, readonly objectsFields: ReadonlyArray<{ readonly __typename?: 'RequestFormObjectFields', readonly objectName: string, readonly fields: ReadonlyArray<string> }>, readonly extraFieldInfos: ReadonlyArray<{ readonly __typename?: 'ExtraFieldFormInfo', readonly id: string, readonly fieldApiName: string, readonly required: boolean, readonly formId: string | null, readonly visibilityCondition: string | null, readonly visibleLines: number | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } }> | null, readonly recordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean }> }> };

export type MyEmployeeDataChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEmployeeDataChangeRequestsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly employeeDataChangeRequests: ReadonlyArray<{ readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Change_Request_Reason__c: string | null, readonly LastModifiedDate: string, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> } };

export type CreateDataChangeRequestMutationVariables = Exact<{
  input: CreateDataChangeRequestInput;
}>;


export type CreateDataChangeRequestMutation = { readonly __typename?: 'Mutation', readonly requestForm: { readonly __typename?: 'RequestFormMutations', readonly createDataChangeRequest: { readonly __typename?: 'CreateDataChangeRequestPayload', readonly recordId: string | null, readonly query: { readonly __typename?: 'Query', readonly employeeDataChangeRequests: ReadonlyArray<{ readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Change_Request_Reason__c: string | null, readonly LastModifiedDate: string, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly employeeDataChangeRequests: ReadonlyArray<{ readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Change_Request_Reason__c: string | null, readonly LastModifiedDate: string, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> } } } } };

export type RequestForm_EmployeeFragment = { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string };

export type ValidateDataChangeRequestMutationVariables = Exact<{
  input: CreateDataChangeRequestInput;
}>;


export type ValidateDataChangeRequestMutation = { readonly __typename?: 'Mutation', readonly requestForm: { readonly __typename?: 'RequestFormMutations', readonly validateCreateDataChangeRequest: { readonly __typename?: 'ValidateDataChangeRequestPayload', readonly isValid: boolean, readonly error: string | null } } };

export type PositionsQueryVariables = Exact<{
  filter: InputMaybe<PositionFilterInput>;
}>;


export type PositionsQuery = { readonly __typename?: 'Query', readonly positions: ReadonlyArray<{ readonly __typename?: 'Position', readonly Id: string, readonly Name: string, readonly flair__Title__c: string, readonly flair__Staffed__c: boolean, readonly flair__Parent_Position__c: string | null, readonly flair__Active__c: boolean, readonly employment: { readonly __typename?: 'Employment', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Active__c: boolean, readonly flair__Main__c: boolean, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } } | null }> };

export type EmployeeSalariesForChangeRequestQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type EmployeeSalariesForChangeRequestQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly salaries: ReadonlyArray<{ readonly __typename?: 'EmployeeSalary', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Salary_Type__c: SalaryType, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Formula_Status__c: string, readonly CurrencyIsoCode: string }> } | null } };

export type EmployeeOrTeamSelectSearchQueryVariables = Exact<{
  searchTerm: InputMaybe<Scalars['String']['input']>;
}>;


export type EmployeeOrTeamSelectSearchQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> };

export type EmployeeOrTeamSelectDefaultQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type EmployeeOrTeamSelectDefaultQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> };

export type EmployeeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeSelectQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> };

export type TeamWithPopupQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type TeamWithPopupQuery = { readonly __typename?: 'Query', readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> }> };

export type TimeBalanceForDayQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
  day: Scalars['LocalDate']['input'];
}>;


export type TimeBalanceForDayQuery = { readonly __typename?: 'Query', readonly timeSheetDay: { readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null } | null };

export type TimeBalanceDetails_TimeBalanceSettingsFragment = { readonly __typename?: 'TimeBalanceSettings', readonly Id: string, readonly flair__Auto_Reset_Mode__c: TimeBalanceAutoResetMode | null, readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode, readonly flair__Daily_Threshold_Minutes__c: number | null, readonly flair__Threshold_Minutes__c: number | null, readonly flair__Maximum_Daily_Working_Minutes__c: number | null, readonly flair__Not_Deduct_Deficit__c: boolean, readonly flair__Negative_Capacity_Minutes__c: number | null, readonly flair__Positive_Capacity_Minutes__c: number | null, readonly flair__Premium_Level_1_Minutes__c: number | null, readonly flair__Premium_Level_1_Multiplier__c: number | null, readonly flair__Premium_Level_2_Minutes__c: number | null, readonly flair__Premium_Level_2_Multiplier__c: number | null, readonly flair__Start_Calculate_After_Minutes__c: number | null, readonly flair__Update_Mode__c: TimeBalanceUpdateMode };

export type TimeSheetAbsenceFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null };

export type TimeSheetCalendarPeriodFragment = { readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean };

export type TimeSheetChartsPopoverFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Target_Hours__c: number, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type TimeSheetDistChartFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Target_Hours__c: number, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Start_Date__c: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type TimeSheetGoalChartFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Target_Hours__c: number, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type TimeSheetOvertimePolicyFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Workload_Model__c: WorkloadModel, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type TimeSheetYearlyChartFragment = { readonly __typename?: 'EmployeeTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel }> };

export type ApproveTimeSheetsMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  timeEntryChangeRequestApproveAction: ApproveTimeSheetAction;
}>;


export type ApproveTimeSheetsMutation = { readonly __typename?: 'Mutation', readonly timeSheet: { readonly __typename?: 'TimeSheetMutations', readonly approveTimeSheets: { readonly __typename?: 'ApproveTimeSheetsPayload', readonly recordIds: ReadonlyArray<string>, readonly records: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours__c: number | null, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly flair__Type__c: WorkloadType, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> }>, readonly error: { readonly __typename?: 'ApproveTimeSheetError', readonly errorCode: ApproveTimeSheetErrorCode, readonly message: string | null } | null } } };

export type TimeSheetTimeEntryChangeRequestsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TimeSheetTimeEntryChangeRequestsQuery = { readonly __typename?: 'Query', readonly timeSheets: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string }> }> };

export type TimeBalancesRefetchQueryVariables = Exact<{
  request: TimeSheetDaysRequestInput;
}>;


export type TimeBalancesRefetchQuery = { readonly __typename?: 'Query', readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }> };

export type TimeSheetDaySubRowTrackedTimeDayFragment = { readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly targetMinutes: number, readonly workedMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> };

export type TimesheetDayChangesFragment = { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } };

export type DateTimeWithOriginFragment = { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null };

export type DurationWithOriginFragment = { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null };

export type TimeSheetDaySubRowsFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly targetMinutes: number, readonly workedMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }> };

export type TimeSheetDaySubRowTimeSheetDayWithTimeBalanceFragment = { readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> };

export type TimeSheetDetailsFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Target_Hours__c: number, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly dayStartDateTime: string, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type TimeSheetDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TimeSheetDetailsQuery = { readonly __typename?: 'Query', readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Target_Hours__c: number, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly dayStartDateTime: string, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> } };

export type TimeSheetDetailsPrefetchQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TimeSheetDetailsPrefetchQuery = { readonly __typename?: 'Query', readonly timeSheets: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__Target_Hours__c: number, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly startOfTrackedTime: string | null, readonly endOfTrackedTime: string | null, readonly targetMinutes: number, readonly trackedMinutes: number, readonly breaksMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly timeEntriesIds: ReadonlyArray<string>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }> }> }, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> }> };

export type TimeSheetPrefetchDataFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__Target_Hours__c: number, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly startOfTrackedTime: string | null, readonly endOfTrackedTime: string | null, readonly targetMinutes: number, readonly trackedMinutes: number, readonly breaksMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly timeEntriesIds: ReadonlyArray<string>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }> }> }, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> };

export type TimeSheetsTable_TimeBalanceWithdrawalFragment = { readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly managerRoles: ReadonlyArray<ManagerRole>, readonly logoUrl: string | null, readonly coverUrl: string | null, readonly Organization: string, readonly hasSlackUser: boolean, readonly calendarToken: string | null, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Position__c: string | null, readonly flair__Can_Change_Own_Time_Entries__c: boolean | null, readonly flair__Employee_Language__c: string | null, readonly flair__Hide_My_Birthday__c: boolean | null, readonly hubAccessRestricted: boolean, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null, readonly urlLarge: string | null } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string }>, readonly courses: ReadonlyArray<{ readonly __typename?: 'EmployeeCourse', readonly Id: string }> }, readonly hub: { readonly __typename?: 'Hub', readonly Id: string, readonly Name: string, readonly flair__Cover_Url__c: string | null, readonly flair__Company_Logo_Url__c: string | null, readonly flair__Inactivity_Timeout__c: number | null } | null, readonly hiringManager: { readonly __typename?: 'HiringManager', readonly Id: string, readonly jobs: ReadonlyArray<{ readonly __typename?: 'Job', readonly Id: string }> }, readonly employeeHubFeatures: { readonly __typename?: 'EmployeeHubFeature', readonly Id: string, readonly flair__IsGlobal__c: boolean, readonly flair__Hide_Absences__c: boolean, readonly flair__Hide_Announcements__c: boolean, readonly flair__Hide_Assessments__c: boolean, readonly flair__Hide_Certificates__c: boolean, readonly flair__Hide_Cheers__c: boolean, readonly flair__Hide_Corporate_Documents__c: boolean, readonly flair__Hide_Directory__c: boolean, readonly flair__Hide_Expenses__c: boolean, readonly flair__Hide_Goals__c: boolean, readonly flair__Hide_Home_Absent_Today__c: boolean, readonly flair__Hide_Home_Birthdays_Card__c: boolean, readonly flair__Hide_Home_New_Hires_Card__c: boolean, readonly flair__Hide_Org_Chart__c: boolean, readonly flair__Hide_Personal_Data__c: boolean, readonly flair__Hide_Personal_Documents__c: boolean, readonly flair__Hide_Private_Notes__c: boolean, readonly flair__Hide_Projects__c: boolean, readonly flair__Hide_Recruiting__c: boolean, readonly flair__Hide_Shift_Planner__c: boolean, readonly flair__Hide_Skills__c: boolean, readonly flair__Hide_Surveys__c: boolean, readonly flair__Hide_Time_Tracking__c: boolean, readonly flair__Hide_Workflows__c: boolean, readonly flair__Hide_HR_HelpDesk__c: boolean, readonly flair__Hide_Inventory__c: boolean, readonly flair__Customise_Dashboard_Main_Slider__c: string | null, readonly flair__Hide_Anniversaries__c: boolean, readonly flair__Hide_Public_Holidays__c: boolean, readonly flair__Hide_Employee_Bank_Details__c: boolean, readonly flair__Hide_Employee_Salaries__c: boolean, readonly flair__Hide_Employee_Workload_Details__c: boolean } | null, readonly organizationInfo: { readonly __typename?: 'OrganizationInfo', readonly features: ReadonlyArray<{ readonly __typename?: 'OrganizationFeature', readonly Id: string }> | null, readonly subscriptionInfo: { readonly __typename?: 'SubscriptionInfo', readonly flairScheduler: boolean } } };

export type IdentifyMutationVariables = Exact<{
  input: IdentifyInput;
}>;


export type IdentifyMutation = { readonly __typename?: 'Mutation', readonly identify: string };

export type EmployeeHubFeatureFragment = { readonly __typename?: 'EmployeeHubFeature', readonly Id: string, readonly flair__IsGlobal__c: boolean, readonly flair__Hide_Absences__c: boolean, readonly flair__Hide_Announcements__c: boolean, readonly flair__Hide_Assessments__c: boolean, readonly flair__Hide_Certificates__c: boolean, readonly flair__Hide_Cheers__c: boolean, readonly flair__Hide_Corporate_Documents__c: boolean, readonly flair__Hide_Directory__c: boolean, readonly flair__Hide_Expenses__c: boolean, readonly flair__Hide_Goals__c: boolean, readonly flair__Hide_Home_Absent_Today__c: boolean, readonly flair__Hide_Home_Birthdays_Card__c: boolean, readonly flair__Hide_Home_New_Hires_Card__c: boolean, readonly flair__Hide_Org_Chart__c: boolean, readonly flair__Hide_Personal_Data__c: boolean, readonly flair__Hide_Personal_Documents__c: boolean, readonly flair__Hide_Private_Notes__c: boolean, readonly flair__Hide_Projects__c: boolean, readonly flair__Hide_Recruiting__c: boolean, readonly flair__Hide_Shift_Planner__c: boolean, readonly flair__Hide_Skills__c: boolean, readonly flair__Hide_Surveys__c: boolean, readonly flair__Hide_Time_Tracking__c: boolean, readonly flair__Hide_Workflows__c: boolean, readonly flair__Hide_HR_HelpDesk__c: boolean, readonly flair__Hide_Inventory__c: boolean, readonly flair__Customise_Dashboard_Main_Slider__c: string | null, readonly flair__Hide_Anniversaries__c: boolean, readonly flair__Hide_Public_Holidays__c: boolean, readonly flair__Hide_Employee_Bank_Details__c: boolean, readonly flair__Hide_Employee_Salaries__c: boolean, readonly flair__Hide_Employee_Workload_Details__c: boolean };

export type CustomerSupportEmployeeTokenQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CustomerSupportEmployeeTokenQuery = { readonly __typename?: 'Query', readonly employeeToken: { readonly __typename?: 'EmployeeTokenResponse', readonly authorizationCode: string | null, readonly error: EmployeeTokenResponseErrorCode | null } | null };

export type OrganizationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationInfoQuery = { readonly __typename?: 'Query', readonly organizationInfo: { readonly __typename?: 'OrganizationInfo', readonly salesforceUserId: string | null, readonly flairHubPermissionSet: boolean } };

export type AbsenceDataFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Category_Restrict_Absence_Deletion__c: boolean | null, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Days_Times__c: string | null, readonly flair__Requires_Approval__c: boolean, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Type__c: AbsenceType }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null } }> } | null };

export type ActiveEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveEmployeesQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> };

export type EmployeeSelectInfoFragment = { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type EmployeeSelectInfoColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type EmployeeWithAvatarFragment = { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type ColleagueWithAvatarFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type EvaluationFragment = { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly flair__Skipped_At__c: string | null, readonly flair__Evaluated__c: boolean, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Funnel_Stage__c: string | null, readonly flair__Final_Score__c: number | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null }, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } };

export type EvaluationCandidateFragment = { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Funnel_Stage__c: string | null, readonly flair__Final_Score__c: number | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null };

export type EvaluationEmployeeFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type FieldInfoFragment = { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> };

export type MyEmployeeDataFragment = { readonly __typename?: 'EmployeeData', readonly employeeId: string, readonly sections: ReadonlyArray<{ readonly __typename?: 'EmployeeDataSection', readonly employeeId: string, readonly label: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }>, readonly relatedLists: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedList', readonly label: string, readonly objectType: string, readonly records: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedListRecord', readonly id: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }> }> };

export type MyEmployeeDataRelatedListFragment = { readonly __typename?: 'EmployeeDataRelatedList', readonly label: string, readonly objectType: string, readonly records: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedListRecord', readonly id: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }> };

export type MyEmployeeDataFieldFragment = { readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } };

export type PaidAbsenceFieldsFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null };

export type CommentItemFragment = { readonly __typename?: 'Comment', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string | null, readonly flair__Related_Id__c: string | null, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly mentions: ReadonlyArray<{ readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> };

type CommentableId_Absence_Fragment = { readonly __typename?: 'Absence', readonly Id: string };

type CommentableId_Announcement_Fragment = { readonly __typename?: 'Announcement', readonly Id: string };

type CommentableId_CandidateEvaluation_Fragment = { readonly __typename?: 'CandidateEvaluation', readonly Id: string };

type CommentableId_Celebration_Fragment = { readonly __typename?: 'Celebration', readonly Id: string };

type CommentableId_EmployeeCertificate_Fragment = { readonly __typename?: 'EmployeeCertificate', readonly Id: string };

type CommentableId_EmployeeDataChangeRequest_Fragment = { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string };

type CommentableId_EmployeeDocument_Fragment = { readonly __typename?: 'EmployeeDocument', readonly Id: string };

type CommentableId_Expense_Fragment = { readonly __typename?: 'Expense', readonly Id: string };

type CommentableId_ExpenseGroup_Fragment = { readonly __typename?: 'ExpenseGroup', readonly Id: string };

type CommentableId_InventoryItem_Fragment = { readonly __typename?: 'InventoryItem', readonly Id: string };

type CommentableId_JobCandidate_Fragment = { readonly __typename?: 'JobCandidate', readonly Id: string };

type CommentableId_Ticket_Fragment = { readonly __typename?: 'Ticket', readonly Id: string };

type CommentableId_TimeSheetDay_Fragment = { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null };

type CommentableId_WorkflowItem_Fragment = { readonly __typename?: 'WorkflowItem', readonly Id: string };

export type CommentableIdFragment = CommentableId_Absence_Fragment | CommentableId_Announcement_Fragment | CommentableId_CandidateEvaluation_Fragment | CommentableId_Celebration_Fragment | CommentableId_EmployeeCertificate_Fragment | CommentableId_EmployeeDataChangeRequest_Fragment | CommentableId_EmployeeDocument_Fragment | CommentableId_Expense_Fragment | CommentableId_ExpenseGroup_Fragment | CommentableId_InventoryItem_Fragment | CommentableId_JobCandidate_Fragment | CommentableId_Ticket_Fragment | CommentableId_TimeSheetDay_Fragment | CommentableId_WorkflowItem_Fragment;

export type ContentDocumentLinkDataFragment = { readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } };

export type FeedbackCycleItemFragment = { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Meeting_Required__c: boolean, readonly flair__With_Peers__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number };

export type LocationHolidayFragment = { readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string };

export type MentionFragment = { readonly __typename?: 'MentionedEmployee', readonly id: string, readonly hasAccess: boolean, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } };

export type PicklistEntryFragment = { readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string };

export type ReactionFragment = { readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } };

export type RequestedAbsenceFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly CreatedDate: string, readonly flair__Days_Times__c: string | null, readonly commentsCount: number, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number }, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Without_Balance__c: boolean } } | null, readonly overlappingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }>, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly absenceDays: ReadonlyArray<{ readonly __typename?: 'AbsenceDay', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Day__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Time__c: string }> };

export type TimeSheetDayIdFragment = { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null };

export type WithLoomVideoIdFragment = { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null };

export type MeCurrentTimeEntryReadCacheFragment = { readonly __typename?: 'Me', readonly Id: string, readonly currentTimeEntry: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null };

export type MeTimeEntryBreakReadCacheFragment = { readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string };

export type UpdateTimeEntryNotesMutationVariables = Exact<{
  input: UpdateTimeEntryNotesInput;
}>;


export type UpdateTimeEntryNotesMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly updateTimeEntryNotes: { readonly __typename?: 'UpdateNotesPayload', readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null } | null, readonly timeEntryChangeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null } | null } } };

export type ApproveTimeEntryChangeRequestMutationVariables = Exact<{
  input: ApproveTimeEntryChangeRequestInput;
}>;


export type ApproveTimeEntryChangeRequestMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly approveTimeEntryChangeRequests: { readonly __typename?: 'ProcessTimeEntryChangeRequestsPayload', readonly recordIds: ReadonlyArray<string>, readonly records: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Status__c: ApprovalStatus, readonly affectedTimeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__Target_Hours__c: number, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly startOfTrackedTime: string | null, readonly endOfTrackedTime: string | null, readonly targetMinutes: number, readonly trackedMinutes: number, readonly breaksMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly timeEntriesIds: ReadonlyArray<string>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }> }> }, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> } | null } | null }> } } };

export type DeleteTimeEntryChangeRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTimeEntryChangeRequestMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly deleteTimeEntryChangeRequest: { readonly __typename?: 'DeleteTimeEntryChangeRequestPayload', readonly recordId: string } } };

export type RejectTimeEntryChangeRequestMutationVariables = Exact<{
  input: RejectTimeEntryChangeRequestInput;
}>;


export type RejectTimeEntryChangeRequestMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly rejectTimeEntryChangeRequests: { readonly __typename?: 'ProcessTimeEntryChangeRequestsPayload', readonly recordIds: ReadonlyArray<string>, readonly records: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Status__c: ApprovalStatus, readonly affectedTimeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly targetMinutes: number, readonly workedMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }> } | null } | null }> } } };

export type SubmitTimeEntryChangeRequestMutationVariables = Exact<{
  input: SubmitTimeEntryChangeRequestInput;
}>;


export type SubmitTimeEntryChangeRequestMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly submitTimeEntryChangeRequest: { readonly __typename?: 'SubmitTimeEntryChangeRequestPayload', readonly record: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly projectTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } }>, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }> } } };

export type TimeBalanceSettingsFragment = { readonly __typename?: 'TimeBalanceSettings', readonly Id: string, readonly flair__Auto_Reset_Mode__c: TimeBalanceAutoResetMode | null, readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode, readonly flair__Daily_Threshold_Minutes__c: number | null, readonly flair__Threshold_Minutes__c: number | null, readonly flair__Maximum_Daily_Working_Minutes__c: number | null, readonly flair__Not_Deduct_Deficit__c: boolean, readonly flair__Negative_Capacity_Minutes__c: number | null, readonly flair__Positive_Capacity_Minutes__c: number | null, readonly flair__Premium_Level_1_Minutes__c: number | null, readonly flair__Premium_Level_1_Multiplier__c: number | null, readonly flair__Premium_Level_2_Minutes__c: number | null, readonly flair__Premium_Level_2_Multiplier__c: number | null, readonly flair__Start_Calculate_After_Minutes__c: number | null, readonly flair__Update_Mode__c: TimeBalanceUpdateMode };

export type TimeLimitSettingsFragment = { readonly __typename?: 'TimeLimitSettings', readonly Id: string, readonly Name: string, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Maximum_Daily_Restriction_Type__c: TimeLimitMaxDailyRestrictionType, readonly flair__Maximum_Daily_Restriction_Action__c: TimeLimitMaxDailyRestrictionAction | null, readonly flair__Maximum_Daily_Restriction_Custom_Minutes__c: number | null, readonly flair__Maximum_Daily_Restriction_Notify_HR__c: boolean, readonly flair__Restrict_Tracking_On_Non_Working_Days__c: boolean };

export type AllTimeFrameworksQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTimeFrameworksQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly timeFrameworks: ReadonlyArray<{ readonly __typename?: 'TimeFramework', readonly Id: string, readonly timeBalanceSettings: { readonly __typename?: 'TimeBalanceSettings', readonly Id: string, readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode } | null }> } };

export type TimeTrackingSettings_AbsenceFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string };

export type WorkloadWeekFragment = { readonly __typename?: 'WorkloadWeek', readonly Id: string, readonly monday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly tuesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly wednesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly thursday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly friday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly saturday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly sunday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null } };

export type WorkloadDayFragment = { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null };

export type TimeFrameworkFragment = { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> };

export type BreakLegislationRuleFragment = { readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number };

export type BreakScheduledFragment = { readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string };

export type TimeTrackingSettings_WorkloadFieldsFragment = { readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType, readonly flair__Type__c: WorkloadType, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly timeBalanceSettings: { readonly __typename?: 'TimeBalanceSettings', readonly Id: string, readonly flair__Auto_Reset_Mode__c: TimeBalanceAutoResetMode | null, readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode, readonly flair__Daily_Threshold_Minutes__c: number | null, readonly flair__Threshold_Minutes__c: number | null, readonly flair__Maximum_Daily_Working_Minutes__c: number | null, readonly flair__Not_Deduct_Deficit__c: boolean, readonly flair__Negative_Capacity_Minutes__c: number | null, readonly flair__Positive_Capacity_Minutes__c: number | null, readonly flair__Premium_Level_1_Minutes__c: number | null, readonly flair__Premium_Level_1_Multiplier__c: number | null, readonly flair__Premium_Level_2_Minutes__c: number | null, readonly flair__Premium_Level_2_Multiplier__c: number | null, readonly flair__Start_Calculate_After_Minutes__c: number | null, readonly flair__Update_Mode__c: TimeBalanceUpdateMode } | null, readonly timeLimitSettings: { readonly __typename?: 'TimeLimitSettings', readonly Id: string, readonly Name: string, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Maximum_Daily_Restriction_Type__c: TimeLimitMaxDailyRestrictionType, readonly flair__Maximum_Daily_Restriction_Action__c: TimeLimitMaxDailyRestrictionAction | null, readonly flair__Maximum_Daily_Restriction_Custom_Minutes__c: number | null, readonly flair__Maximum_Daily_Restriction_Notify_HR__c: boolean, readonly flair__Restrict_Tracking_On_Non_Working_Days__c: boolean } | null, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null, readonly workloadWeeks: ReadonlyArray<{ readonly __typename?: 'WorkloadWeek', readonly Id: string, readonly monday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly tuesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly wednesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly thursday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly friday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly saturday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly sunday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null } }> };

export type TimeTrackingSettingsQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
  today: Scalars['DateTime']['input'];
}>;


export type TimeTrackingSettingsQuery = { readonly __typename?: 'Query', readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType, readonly flair__Type__c: WorkloadType, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly timeBalanceSettings: { readonly __typename?: 'TimeBalanceSettings', readonly Id: string, readonly flair__Auto_Reset_Mode__c: TimeBalanceAutoResetMode | null, readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode, readonly flair__Daily_Threshold_Minutes__c: number | null, readonly flair__Threshold_Minutes__c: number | null, readonly flair__Maximum_Daily_Working_Minutes__c: number | null, readonly flair__Not_Deduct_Deficit__c: boolean, readonly flair__Negative_Capacity_Minutes__c: number | null, readonly flair__Positive_Capacity_Minutes__c: number | null, readonly flair__Premium_Level_1_Minutes__c: number | null, readonly flair__Premium_Level_1_Multiplier__c: number | null, readonly flair__Premium_Level_2_Minutes__c: number | null, readonly flair__Premium_Level_2_Multiplier__c: number | null, readonly flair__Start_Calculate_After_Minutes__c: number | null, readonly flair__Update_Mode__c: TimeBalanceUpdateMode } | null, readonly timeLimitSettings: { readonly __typename?: 'TimeLimitSettings', readonly Id: string, readonly Name: string, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Maximum_Daily_Restriction_Type__c: TimeLimitMaxDailyRestrictionType, readonly flair__Maximum_Daily_Restriction_Action__c: TimeLimitMaxDailyRestrictionAction | null, readonly flair__Maximum_Daily_Restriction_Custom_Minutes__c: number | null, readonly flair__Maximum_Daily_Restriction_Notify_HR__c: boolean, readonly flair__Restrict_Tracking_On_Non_Working_Days__c: boolean } | null, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null, readonly workloadWeeks: ReadonlyArray<{ readonly __typename?: 'WorkloadWeek', readonly Id: string, readonly monday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly tuesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly wednesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly thursday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly friday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly saturday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly sunday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null } }> }> };

export type TimeTrackingSettingsAllDaysQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type TimeTrackingSettingsAllDaysQuery = { readonly __typename?: 'Query', readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType, readonly flair__Type__c: WorkloadType, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly timeBalanceSettings: { readonly __typename?: 'TimeBalanceSettings', readonly Id: string, readonly flair__Auto_Reset_Mode__c: TimeBalanceAutoResetMode | null, readonly flair__Calculation_Mode__c: TimeBalanceCalculationMode, readonly flair__Daily_Threshold_Minutes__c: number | null, readonly flair__Threshold_Minutes__c: number | null, readonly flair__Maximum_Daily_Working_Minutes__c: number | null, readonly flair__Not_Deduct_Deficit__c: boolean, readonly flair__Negative_Capacity_Minutes__c: number | null, readonly flair__Positive_Capacity_Minutes__c: number | null, readonly flair__Premium_Level_1_Minutes__c: number | null, readonly flair__Premium_Level_1_Multiplier__c: number | null, readonly flair__Premium_Level_2_Minutes__c: number | null, readonly flair__Premium_Level_2_Multiplier__c: number | null, readonly flair__Start_Calculate_After_Minutes__c: number | null, readonly flair__Update_Mode__c: TimeBalanceUpdateMode } | null, readonly timeLimitSettings: { readonly __typename?: 'TimeLimitSettings', readonly Id: string, readonly Name: string, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Maximum_Daily_Restriction_Type__c: TimeLimitMaxDailyRestrictionType, readonly flair__Maximum_Daily_Restriction_Action__c: TimeLimitMaxDailyRestrictionAction | null, readonly flair__Maximum_Daily_Restriction_Custom_Minutes__c: number | null, readonly flair__Maximum_Daily_Restriction_Notify_HR__c: boolean, readonly flair__Restrict_Tracking_On_Non_Working_Days__c: boolean } | null, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null, readonly workloadWeeks: ReadonlyArray<{ readonly __typename?: 'WorkloadWeek', readonly Id: string, readonly monday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly tuesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly wednesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly thursday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly friday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly saturday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly sunday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null } }> }>, readonly employeeAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string }> };

export type AbsenceRequestApproveMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AbsenceRequestApproveMutation = { readonly __typename?: 'Mutation', readonly absence: { readonly __typename?: 'AbsenceMutations', readonly approve: { readonly __typename?: 'AbsenceApproveRejectRequestPayload', readonly records: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly CreatedDate: string, readonly LastModifiedDate: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly commentsCount: number, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> } | null }> } } };

export type AbsenceRequestRejectMutationVariables = Exact<{
  inputs: ReadonlyArray<AbsenceRequestRejectInput> | AbsenceRequestRejectInput;
}>;


export type AbsenceRequestRejectMutation = { readonly __typename?: 'Mutation', readonly absence: { readonly __typename?: 'AbsenceMutations', readonly reject: { readonly __typename?: 'AbsenceApproveRejectRequestPayload', readonly records: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly CreatedDate: string, readonly LastModifiedDate: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly commentsCount: number, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> } | null }> } } };

export type AbsencesForManagerFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly CreatedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> };

export type AbsenceRequestFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type AbsenceRequestFilterQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly absencesCategories: ReadonlyArray<{ readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string }> };

export type AbsencesForManagerQueryVariables = Exact<{
  filter: AbsenceRequestFilterInput;
  sort: AbsenceRequestSortInput;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type AbsencesForManagerQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly absencesForManager: { readonly __typename?: 'AbsencePagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly CreatedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type PendingAbsenceRequestToMeQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type PendingAbsenceRequestToMeQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly CreatedDate: string, readonly LastModifiedDate: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly commentsCount: number, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> } | null }> } };

export type EmployeePageAbsenceCalendarQueryVariables = Exact<{
  id: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type EmployeePageAbsenceCalendarQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly Name: string, readonly flair__Amount__c: number, readonly flair__Expired_Amount__c: number, readonly flair__Available_Amount__c: number, readonly flair__Expiration_Date__c: string | null, readonly flair__Accrual_Policy_Period_Start_Date__c: string | null }>, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }>, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Public__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string } | null } }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Type__c: WorkloadType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'Holiday', readonly Id: string, readonly Name: string, readonly startDate: string, readonly endDate: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly flair__Day__c: string }> } | null } };

export type CreateEmployeeCertificateByManagerMutationVariables = Exact<{
  input: CreateEmployeeCertificateInput;
  id: Scalars['String']['input'];
}>;


export type CreateEmployeeCertificateByManagerMutation = { readonly __typename?: 'Mutation', readonly certificates: { readonly __typename?: 'CertificateMutations', readonly createEmployeeCertificate: { readonly __typename?: 'EmployeeCertificatePayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly employeeCertificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }> } | null } } } } };

export type UpdateEmployeeCertificateByManagerMutationVariables = Exact<{
  input: UpdateEmployeeCertificateInput;
  id: Scalars['String']['input'];
}>;


export type UpdateEmployeeCertificateByManagerMutation = { readonly __typename?: 'Mutation', readonly certificates: { readonly __typename?: 'CertificateMutations', readonly updateEmployeeCertificate: { readonly __typename?: 'EmployeeCertificatePayload', readonly error: string | null, readonly record: { readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> } | null, readonly query: { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string } | null } } } } };

export type EmployeePageCertificateQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type EmployeePageCertificateQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly employeeCertificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }> } | null } };

export type DeleteEmployeeCertificateByManagerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type DeleteEmployeeCertificateByManagerMutation = { readonly __typename?: 'Mutation', readonly certificates: { readonly __typename?: 'CertificateMutations', readonly deleteEmployeeCertificate: { readonly __typename?: 'EmployeeCertificatePayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly employeeCertificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }> } | null } } } } };

export type EmployeeHistoryDataFragment = { readonly __typename?: 'EmployeeHistory', readonly Id: string, readonly Name: string, readonly flair__New_Value__c: string | null, readonly flair__Old_Value__c: string | null, readonly CreatedDate: string };

export type EmployeePageHistoryQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type EmployeePageHistoryQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly flair__Start_Date__c: string | null, readonly employeeHistory: ReadonlyArray<{ readonly __typename?: 'EmployeeHistory', readonly Id: string, readonly Name: string, readonly flair__New_Value__c: string | null, readonly flair__Old_Value__c: string | null, readonly CreatedDate: string } | null>, readonly salaries: ReadonlyArray<{ readonly __typename?: 'EmployeeSalary', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Salary_Type__c: SalaryType, readonly flair__Start_Date__c: string, readonly CurrencyIsoCode: string }>, readonly employeeCertificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly CreatedDate: string, readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }>, readonly currentWorkloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Type__c: WorkloadType }>, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } }>, readonly feedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } } }> } | null } };

export type EmployeePageEmployeeNotesQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type EmployeePageEmployeeNotesQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employeeNotes: ReadonlyArray<{ readonly __typename?: 'ManagerEmployeeNote', readonly Id: string, readonly text: string, readonly flair__Polarity__c: ManagerEmployeeNotePolarity, readonly CreatedDate: string }> } };

export type EmployeePageCreateEmployeeNoteMutationVariables = Exact<{
  input: CreateEmployeeNoteInput;
  employeeId: Scalars['String']['input'];
}>;


export type EmployeePageCreateEmployeeNoteMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly createEmployeeNote: { readonly __typename?: 'CreateEmployeeNotesPayload', readonly record: { readonly __typename?: 'ManagerEmployeeNote', readonly Id: string, readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employeeNotes: ReadonlyArray<{ readonly __typename?: 'ManagerEmployeeNote', readonly Id: string, readonly text: string, readonly flair__Polarity__c: ManagerEmployeeNotePolarity, readonly CreatedDate: string }> } } } } };

export type EmployeePageDeleteEmployeeNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeePageDeleteEmployeeNoteMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly deleteEmployeeNote: { readonly __typename?: 'DeleteEmployeeNotesPayload', readonly recordId: string } } };

export type EmployeePagePerformanceReviewQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeePagePerformanceReviewQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly feedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Submitted_At__c: string | null, readonly flair__Progress__c: number, readonly flair__Is_Peer_Reviewer__c: boolean, readonly CreatedDate: string, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Progress__c: number } | null, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Meeting_Required__c: boolean, readonly flair__With_Peers__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly flair__Employee_Feedback_Participant__c: string, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null }, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }>, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string } }> } | null } };

export type EmployeePageControllingQueryVariables = Exact<{
  id: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type EmployeePageControllingQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly timeSheets: ReadonlyArray<{ readonly __typename?: 'EmployeeTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Target_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Time_Entry_Hours__c: number, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours__c: number | null, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly flair__Type__c: WorkloadType, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly workedMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> } }> } | null } };

export type ManagerEmployeeTimesheetFragment = { readonly __typename?: 'EmployeeTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Target_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Time_Entry_Hours__c: number, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours__c: number | null, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly flair__Type__c: WorkloadType, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly workedMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> } };

export type EmployeeTimesheetTrackedTimeFieldsFragment = { readonly __typename?: 'EmployeeTimeSheet', readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly workedMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> } };

export type AdditionalCompensationCard_AdditionalCompensationFragment = { readonly __typename?: 'EmployeeAdditionalCompensation', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Compensation_Type__c: string | null, readonly flair__Recurring_Period_in_Months__c: number, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly CurrencyIsoCode: string };

export type OneTimeCompensationCard_OneTimeCompensationFragment = { readonly __typename?: 'EmployeeOneTimeCompensation', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Compensation_Type__c: string | null, readonly flair__Status__c: string, readonly flair__Compensation_Date__c: string, readonly CurrencyIsoCode: string };

export type EmployeePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  timeSheetsFrom: Scalars['DateTime']['input'];
  timeSheetsTo: Scalars['DateTime']['input'];
}>;


export type EmployeePageQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Start_Date__c: string | null, readonly managerRolesForEmployee: ReadonlyArray<ManagerRole>, readonly data: { readonly __typename?: 'EmployeeData', readonly employeeId: string, readonly sections: ReadonlyArray<{ readonly __typename?: 'EmployeeDataSection', readonly employeeId: string, readonly label: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }>, readonly relatedLists: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedList', readonly label: string, readonly objectType: string, readonly records: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedListRecord', readonly id: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }> }> }, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Compensatory_Time__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly flair__Unlimited__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly Name: string, readonly flair__Amount__c: number, readonly flair__Expired_Amount__c: number, readonly flair__Available_Amount__c: number, readonly flair__Used_Amount__c: number, readonly flair__Expiration_Date__c: string | null, readonly flair__Period_Start_Date__c: string | null, readonly flair__Period_End_Date__c: string | null, readonly flair__Accrual_Policy_Period_Start_Date__c: string | null }>, readonly accrualPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAccrualPolicy', readonly accrualPolicy: { readonly __typename?: 'AccrualPolicy', readonly Id: string, readonly flair__Interval__c: AccrualPolicyInterval } }>, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }>, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } }>, readonly currentWorkloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly Name: string, readonly flair__Hours__c: number | null, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Type__c: WorkloadType }>, readonly salaries: ReadonlyArray<{ readonly __typename?: 'EmployeeSalary', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Salary_Type__c: SalaryType, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly CurrencyIsoCode: string }>, readonly additionalCompensations: ReadonlyArray<{ readonly __typename?: 'EmployeeAdditionalCompensation', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Compensation_Type__c: string | null, readonly flair__Recurring_Period_in_Months__c: number, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly CurrencyIsoCode: string }>, readonly oneTimeCompensations: ReadonlyArray<{ readonly __typename?: 'EmployeeOneTimeCompensation', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Compensation_Type__c: string | null, readonly flair__Status__c: string, readonly flair__Compensation_Date__c: string, readonly CurrencyIsoCode: string }>, readonly timeSheets: ReadonlyArray<{ readonly __typename?: 'EmployeeTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null }>, readonly employeeCertificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly CreatedDate: string, readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }>, readonly employeeHistory: ReadonlyArray<{ readonly __typename?: 'EmployeeHistory', readonly Id: string, readonly Name: string, readonly flair__New_Value__c: string | null, readonly flair__Old_Value__c: string | null, readonly CreatedDate: string } | null>, readonly feedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } } }> } | null } };

export type ManagerExpensesQueryVariables = Exact<{
  expenseFilter: InputMaybe<ExpenseFilterInput>;
  expenseSort: InputMaybe<ReadonlyArray<ExpenseSortInput> | ExpenseSortInput>;
  expensePagination: InputMaybe<PaginationInput>;
  groupFilter: InputMaybe<ExpenseGroupFilterInput>;
}>;


export type ManagerExpensesQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly expenses: { readonly __typename?: 'ExpensePagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CurrencyIsoCode: string, readonly CreatedDate: string, readonly commentsCount: number, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly paginationInfo: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } }, readonly expenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } };

export type ManagerCoursesQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type ManagerCoursesQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employeeCourses: ReadonlyArray<{ readonly __typename?: 'EmployeeCourse', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Course__c: string | null, readonly flair__Complete_Progress__c: number | null, readonly flair__Total_Seconds__c: number | null, readonly flair__Completed_At__c: string | null, readonly flair__Enrolled_At__c: string | null, readonly course: { readonly __typename?: 'Course', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> } };

export type CancelDataChangeRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelDataChangeRequestMutation = { readonly __typename?: 'Mutation', readonly employeeDataChangeRequest: { readonly __typename?: 'EmployeeDataChangeRequestMutations', readonly removeRequest: boolean } };

export type ChangeRequestDetailsFieldsFragment = { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Change_Request_Reason__c: string | null, readonly flair__Object_Action__c: EmployeeDataChangeRequestObjectAction | null, readonly flair__Changes__c: string | null, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly objectChanges: { readonly __typename?: 'ObjectChanges', readonly objectApiName: string, readonly objectLabel: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'ObjectFieldChange', readonly fieldApiName: string, readonly fieldLabel: string, readonly fieldType: FieldType, readonly oldValue: string | null, readonly newValue: string | null, readonly oldDisplayName: string | null, readonly newDisplayName: string | null, readonly isRichTextArea: boolean | null }> } };

export type ObjectChangesFragment = { readonly __typename?: 'ObjectChanges', readonly objectApiName: string, readonly objectLabel: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'ObjectFieldChange', readonly fieldApiName: string, readonly fieldLabel: string, readonly fieldType: FieldType, readonly oldValue: string | null, readonly newValue: string | null, readonly oldDisplayName: string | null, readonly newDisplayName: string | null, readonly isRichTextArea: boolean | null }> };

export type ObjectFieldChangeFragment = { readonly __typename?: 'ObjectFieldChange', readonly fieldApiName: string, readonly fieldLabel: string, readonly fieldType: FieldType, readonly oldValue: string | null, readonly newValue: string | null, readonly oldDisplayName: string | null, readonly newDisplayName: string | null, readonly isRichTextArea: boolean | null };

export type PositionsForChangeRequestQueryVariables = Exact<{ [key: string]: never; }>;


export type PositionsForChangeRequestQuery = { readonly __typename?: 'Query', readonly positions: ReadonlyArray<{ readonly __typename?: 'Position', readonly Id: string, readonly Name: string, readonly flair__Title__c: string, readonly flair__Staffed__c: boolean, readonly flair__Active__c: boolean }> };

export type EmployeeDataChangeRequestFieldsFragment = { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Change_Request_Reason__c: string | null, readonly LastModifiedDate: string, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type EmployeeDataChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeDataChangeRequestsQuery = { readonly __typename?: 'Query', readonly employeeDataChangeRequests: ReadonlyArray<{ readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Change_Request_Reason__c: string | null, readonly LastModifiedDate: string, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> };

export type EmployeeDataChangeRequestByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeeDataChangeRequestByIdQuery = { readonly __typename?: 'Query', readonly employeeDataChangeRequest: { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string | null, readonly flair__Requested_At__c: string | null, readonly flair__Status__c: EmployeeDataChangeRequestStatus, readonly flair__Change_Request_Reason__c: string | null, readonly LastModifiedDate: string, readonly commentsCount: number, readonly flair__Object_Action__c: EmployeeDataChangeRequestObjectAction | null, readonly flair__Changes__c: string | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly objectChanges: { readonly __typename?: 'ObjectChanges', readonly objectApiName: string, readonly objectLabel: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'ObjectFieldChange', readonly fieldApiName: string, readonly fieldLabel: string, readonly fieldType: FieldType, readonly oldValue: string | null, readonly newValue: string | null, readonly oldDisplayName: string | null, readonly newDisplayName: string | null, readonly isRichTextArea: boolean | null }> } } | null };

export type RequestFormFragment = { readonly __typename?: 'RequestForm', readonly Id: string, readonly Name: string, readonly flair__Information__c: string | null, readonly flair__Data_Change_Object_Name__c: string | null, readonly flair__Employee_Field_Api_Name__c: string | null, readonly flair__Request_Type__c: RequestFormType, readonly flair__Visibility__c: RequestFormVisibility, readonly flair__Mandatory_Reason__c: boolean, readonly flair__Require_Approval__c: boolean, readonly flair__Position_Change_Enabled__c: boolean, readonly flair__Salary_Change_Enabled__c: boolean, readonly objectsFields: ReadonlyArray<{ readonly __typename?: 'RequestFormObjectFields', readonly objectName: string, readonly fields: ReadonlyArray<string> }>, readonly extraFieldInfos: ReadonlyArray<{ readonly __typename?: 'ExtraFieldFormInfo', readonly id: string, readonly fieldApiName: string, readonly required: boolean, readonly formId: string | null, readonly visibilityCondition: string | null, readonly visibleLines: number | null, readonly fieldInfo: { readonly __typename?: 'ExtraFieldInfo', readonly label: string, readonly type: FieldType, readonly isRichTextArea: boolean, readonly inlineHelpText: string | null, readonly referenceObjectApiName: string | null, readonly decimalPlaces: number | null, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> | null } }> | null, readonly recordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean }> };

export type EmployeeRecordFieldsQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  fields: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EmployeeRecordFieldsQuery = { readonly __typename?: 'Query', readonly recordFields: ReadonlyArray<{ readonly __typename?: 'ObjectFieldValue', readonly value: string | null, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly objectType: string, readonly name: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> };

export type ObjectFieldValueFragment = { readonly __typename?: 'ObjectFieldValue', readonly value: string | null, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly objectType: string, readonly name: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } };

export type EmployeesQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type EmployeesQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Position__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }> } };

export type ManagerEmployeeReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type ManagerEmployeeReviewsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly performanceReviews: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Submitted_At__c: string | null, readonly flair__Progress__c: number, readonly CreatedDate: string, readonly flair__Is_Peer_Reviewer__c: boolean, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Progress__c: number } | null, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Meeting_Required__c: boolean, readonly flair__With_Peers__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly flair__Employee_Feedback_Participant__c: string, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null }, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }>, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string } }> } };

export type TicketsQueryVariables = Exact<{
  filter: TicketFilterInput;
  sort: InputMaybe<TicketSortInput>;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type TicketsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly tickets: { readonly __typename?: 'TicketPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Ticket', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Status__c: string, readonly flair__Closing_Reason__c: string | null, readonly flair__Details__c: string | null, readonly flair__Priority__c: string | null, readonly flair__Ticket_Number__c: number, readonly flair__Anonymous__c: boolean, readonly flair__Visibility__c: TicketVisibility, readonly flair__Employee__c: string | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type CurrentTimeSheetsQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type CurrentTimeSheetsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly currentTimeSheets: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours__c: number | null, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly flair__Type__c: WorkloadType, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> }> } };

export type TimeSheetDayTimeEntriesQueryVariables = Exact<{
  timeSheetId: Scalars['String']['input'];
}>;


export type TimeSheetDayTimeEntriesQuery = { readonly __typename?: 'Query', readonly costCenters: ReadonlyArray<{ readonly __typename?: 'CostCenter', readonly Id: string, readonly Name: string }>, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Employee__c: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly startOfTrackedTime: string | null, readonly endOfTrackedTime: string | null, readonly targetMinutes: number, readonly trackedMinutes: number, readonly breaksMinutes: number, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }> } };

export type TimeSheetDayTimeEntryFragment = { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> };

export type TimeSheetTimeEntriesDetailsFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Employee__c: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly dayStartDateTime: string, readonly startOfTrackedTime: string | null, readonly endOfTrackedTime: string | null, readonly targetMinutes: number, readonly trackedMinutes: number, readonly breaksMinutes: number, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }> };

export type TimeSheetFiltersQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type TimeSheetFiltersQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } };

export type EmployeeDetailsFragment = { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Start_Date__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null };

export type EmployeeDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeeDetailsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Start_Date__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null } | null } };

export type TimeSheetsTopPanelQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type TimeSheetsTopPanelQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly timeSheetsPagination: { readonly __typename?: 'TimeSheetPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly warnings: ReadonlyArray<{ readonly __typename?: 'TimeSheetWarning', readonly id: string }> }> } } };

export type AllTimeSheetsQueryVariables = Exact<{
  filter: TimeSheetFilterInput;
  sort: InputMaybe<ReadonlyArray<TimeSheetSortInput> | TimeSheetSortInput>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type AllTimeSheetsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly timeSheetsPagination: { readonly __typename?: 'TimeSheetPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Time_Entries_Hours_Diff__c: number, readonly workedHours: number, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly warnings: ReadonlyArray<{ readonly __typename?: 'TimeSheetWarning', readonly id: string, readonly message: string }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type ManagerTimeSheetFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours__c: number | null, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly flair__Type__c: WorkloadType, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type TimeSheetDaySubRowTimeSheetDayFragment = { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> };

export type TimeSheetTableFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Time_Entries_Hours_Diff__c: number, readonly workedHours: number, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly warnings: ReadonlyArray<{ readonly __typename?: 'TimeSheetWarning', readonly id: string, readonly message: string }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> };

export type TimeSheetTableFieldsFragment = { readonly __typename?: 'TimeSheet', readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Time_Entries_Hours_Diff__c: number, readonly workedHours: number };

export type TimesheetTrackedTimeFieldsFragment = { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> };

export type AbsenceApprovalRequestToMeFragment = { readonly __typename?: 'AbsenceApprovalRequestToMe', readonly Id: string, readonly CreatedDate: string, readonly LastModifiedDate: string, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> } };

export type HolidayFragment = { readonly __typename?: 'Holiday', readonly Id: string, readonly Name: string, readonly startDate: string, readonly endDate: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly flair__Day__c: string };

export type AbsencesCalendarQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type AbsencesCalendarQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly Name: string, readonly flair__Amount__c: number, readonly flair__Available_Amount__c: number, readonly flair__Expiration_Date__c: string | null, readonly flair__Accrual_Policy_Period_Start_Date__c: string | null }>, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }>, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Public__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string } | null } }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'MyWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Type__c: WorkloadType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'Holiday', readonly Id: string, readonly Name: string, readonly startDate: string, readonly endDate: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly flair__Day__c: string }> } };

export type ApprovalRequestWithAbsenceFragment = { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly CreatedDate: string, readonly LastModifiedDate: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly commentsCount: number, readonly CreatedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null }, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> } | null };

export type ApproveRejectPayloadFragment = { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver_Comment__c: string | null, readonly LastModifiedDate: string, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null };

export type RequestedAbsenceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RequestedAbsenceQuery = { readonly __typename?: 'Query', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__EmployeeId__c: string, readonly flair__Type__c: AbsenceType, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly CreatedDate: string, readonly flair__Days_Times__c: string | null, readonly commentsCount: number, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null }> | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number }, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Without_Balance__c: boolean } } | null, readonly overlappingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }>, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly absenceDays: ReadonlyArray<{ readonly __typename?: 'AbsenceDay', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Day__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Time__c: string }> } };

export type MyAbsenceFilters_AbsenceRequestFragment = { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null };

export type EmployeeAbsencesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type EmployeeAbsencesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Compensatory_Time__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly flair__Unlimited__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }>, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly CreatedDate: string, readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Category_Restrict_Absence_Deletion__c: boolean | null, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Days_Times__c: string | null, readonly flair__Requires_Approval__c: boolean, readonly commentsCount: number, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Type__c: AbsenceType }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null } }> } | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> }> } };

export type TeamCalendarFiltersQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type TeamCalendarFiltersQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly teamColleagues: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> }> }, readonly absencesCategories: ReadonlyArray<{ readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Public__c: boolean, readonly flair__Archived_Date__c: string | null, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }> };

export type TeamCalendarQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  locations: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  teams: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  departments: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type TeamCalendarQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly teamColleagues: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly absences2: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Id__c: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Amount__c: number, readonly flair__Category_Unlimited__c: boolean, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Public__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string } | null } }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Working_Days__c: ReadonlyArray<WorkingDay>, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Type__c: WorkloadType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'Holiday', readonly Id: string, readonly Name: string, readonly startDate: string, readonly endDate: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly flair__Day__c: string }> }> } };

export type CategoryAccordion_EmployeeAbsenceCategoryFragment = { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Compensatory_Time__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly flair__Unlimited__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> };

export type CategoryAccordion_EmployeeAbsenceCategoryForYearlySummaryFragment = { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Unlimited__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Compensatory_Time__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string } | null }, readonly currentYearSummary: { readonly __typename?: 'AbsenceYearlySummary', readonly employeeAbsenceCategoryId: string, readonly isUnlimited: boolean, readonly hasYearlyBasedAccrualPolicy: boolean, readonly previousPeriod: { readonly __typename?: 'AbsenceYearlySummaryPrevious', readonly startDate: string, readonly endDate: string, readonly accrued: number | null, readonly used: number | null, readonly taken: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly takenAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> }, readonly currentPeriod: { readonly __typename?: 'AbsenceYearlySummaryCurrent', readonly startDate: string, readonly endDate: string, readonly available: number | null, readonly accrued: number | null, readonly taken: number, readonly planned: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly carriedOverFromPrevYear: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryCarriedOver', readonly amount: number, readonly used: number, readonly lost: number, readonly expired: number, readonly expireOn: string | null }>, readonly takenAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }>, readonly plannedAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> }, readonly nextPeriod: { readonly __typename?: 'AbsenceYearlySummaryNext', readonly startDate: string, readonly endDate: string, readonly willAccrue: number | null, readonly planned: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly plannedAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> } } };

export type CategoryAccordion_YearlySummaryFragment = { readonly __typename?: 'AbsenceYearlySummary', readonly employeeAbsenceCategoryId: string, readonly isUnlimited: boolean, readonly hasYearlyBasedAccrualPolicy: boolean, readonly previousPeriod: { readonly __typename?: 'AbsenceYearlySummaryPrevious', readonly startDate: string, readonly endDate: string, readonly accrued: number | null, readonly used: number | null, readonly taken: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly takenAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> }, readonly currentPeriod: { readonly __typename?: 'AbsenceYearlySummaryCurrent', readonly startDate: string, readonly endDate: string, readonly available: number | null, readonly accrued: number | null, readonly taken: number, readonly planned: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly carriedOverFromPrevYear: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryCarriedOver', readonly amount: number, readonly used: number, readonly lost: number, readonly expired: number, readonly expireOn: string | null }>, readonly takenAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }>, readonly plannedAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> }, readonly nextPeriod: { readonly __typename?: 'AbsenceYearlySummaryNext', readonly startDate: string, readonly endDate: string, readonly willAccrue: number | null, readonly planned: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly plannedAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> } };

export type CategoryAccordion_AbsenceFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number };

export type CategoryAccordion_CarriedOverFragment = { readonly __typename?: 'AbsenceYearlySummaryCarriedOver', readonly amount: number, readonly used: number, readonly lost: number, readonly expired: number, readonly expireOn: string | null };

export type CategoryAccordion_AllowanceFragment = { readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string };

export type AbsenceYearlySummaryQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type AbsenceYearlySummaryQuery = { readonly __typename?: 'Query', readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Unlimited__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Compensatory_Time__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string } | null }, readonly currentYearSummary: { readonly __typename?: 'AbsenceYearlySummary', readonly employeeAbsenceCategoryId: string, readonly isUnlimited: boolean, readonly hasYearlyBasedAccrualPolicy: boolean, readonly previousPeriod: { readonly __typename?: 'AbsenceYearlySummaryPrevious', readonly startDate: string, readonly endDate: string, readonly accrued: number | null, readonly used: number | null, readonly taken: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly takenAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> }, readonly currentPeriod: { readonly __typename?: 'AbsenceYearlySummaryCurrent', readonly startDate: string, readonly endDate: string, readonly available: number | null, readonly accrued: number | null, readonly taken: number, readonly planned: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly carriedOverFromPrevYear: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryCarriedOver', readonly amount: number, readonly used: number, readonly lost: number, readonly expired: number, readonly expireOn: string | null }>, readonly takenAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }>, readonly plannedAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> }, readonly nextPeriod: { readonly __typename?: 'AbsenceYearlySummaryNext', readonly startDate: string, readonly endDate: string, readonly willAccrue: number | null, readonly planned: number, readonly allowances: ReadonlyArray<{ readonly __typename?: 'AbsenceYearlySummaryAllowance', readonly absenceAllowanceId: string | null, readonly accrualPolicyId: string | null, readonly accrued: number, readonly title: string }> | null, readonly plannedAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number }> } } }> } | null };

export type AbsenceDayDataFragment = { readonly __typename?: 'AbsenceDay', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Day__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Time__c: string };

export type MyAbsenceDaysQueryVariables = Exact<{
  absenceId: Scalars['String']['input'];
}>;


export type MyAbsenceDaysQuery = { readonly __typename?: 'Query', readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly absenceDays: ReadonlyArray<{ readonly __typename?: 'AbsenceDay', readonly Id: string, readonly flair__Amount__c: number, readonly flair__Day__c: string, readonly flair__Start_Time__c: string, readonly flair__End_Time__c: string }> } };

export type AbsencesByYearFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus };

export type MyAbsencesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type MyAbsencesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Compensatory_Time__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly flair__Unlimited__c: boolean, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }>, readonly absencesCurrentYear: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Working_Amount__c: number, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus }>, readonly upcomingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Category_Restrict_Absence_Deletion__c: boolean | null, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Days_Times__c: string | null, readonly flair__Requires_Approval__c: boolean, readonly commentsCount: number, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver_Comment__c: string | null }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Type__c: AbsenceType }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null } }> } | null }>, readonly absences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly CreatedDate: string, readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Category_Restrict_Absence_Deletion__c: boolean | null, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Days_Times__c: string | null, readonly flair__Requires_Approval__c: boolean, readonly commentsCount: number, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Related_Id__c: string, readonly LastModifiedDate: string, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null }> | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Type__c: AbsenceType }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null } }> } | null }>, readonly ongoingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Category_Restrict_Absence_Deletion__c: boolean | null, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Days_Times__c: string | null, readonly flair__Requires_Approval__c: boolean, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Type__c: AbsenceType }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null } }> } | null }>, readonly pastAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Category_Restrict_Absence_Deletion__c: boolean | null, readonly flair__Category_Time_Tracking_Restricted__c: boolean | null, readonly flair__Employee_Absence_Category__c: string | null, readonly flair__Days_Times__c: string | null, readonly flair__Requires_Approval__c: boolean, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly flair__Type__c: AbsenceType }, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly flair__Document_Upload__c: boolean | null, readonly flair__Min_Amount_For_Document_Upload__c: number | null } }> } | null }> }, readonly myTimeSheets: ReadonlyArray<{ readonly __typename?: 'MyTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null }> };

export type ApproveAbsenceRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveAbsenceRequestMutation = { readonly __typename?: 'Mutation', readonly absence: { readonly __typename?: 'AbsenceMutations', readonly approveAbsenceRequest: { readonly __typename?: 'AbsenceApprovalRequestToMePayload', readonly record: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver_Comment__c: string | null, readonly LastModifiedDate: string, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null } | null } } };

export type RejectAbsenceRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  comment: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectAbsenceRequestMutation = { readonly __typename?: 'Mutation', readonly absence: { readonly __typename?: 'AbsenceMutations', readonly rejectAbsenceRequest: { readonly __typename?: 'AbsenceApprovalRequestToMePayload', readonly record: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver_Comment__c: string | null, readonly LastModifiedDate: string, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null } | null } } };

export type DeleteUpcomingAbsenceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUpcomingAbsenceMutation = { readonly __typename?: 'Mutation', readonly deleteUpcomingAbsence: string };

export type CalendarQueryQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type CalendarQueryQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly flair__Location__c: string | null, readonly activeColleagues: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly shifts: ReadonlyArray<{ readonly __typename?: 'EmployeeShift', readonly Id: string, readonly Name: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Location__c: string, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Open_Shift__c: string | null, readonly flair__Employee_Notes__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'ShiftBreak', readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string }>, readonly shiftLabels: ReadonlyArray<{ readonly __typename?: 'ShiftLabel', readonly Id: string, readonly Name: string, readonly flair__Tag_Name__c: string }> }>, readonly absences2: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Category_Name__c: string, readonly flair__Category_Id__c: string, readonly flair__Type__c: AbsenceType, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string } | null } }>, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Skill__c: string }> }>, readonly invitedColleagues: ReadonlyArray<{ readonly __typename?: 'InvitedColleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly location: { readonly __typename?: 'ExternalLocation', readonly Id: string, readonly Name: string } | null, readonly shifts: ReadonlyArray<{ readonly __typename?: 'EmployeeShift', readonly Id: string, readonly Name: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Location__c: string, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Open_Shift__c: string | null, readonly flair__Employee_Notes__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'ShiftBreak', readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string }>, readonly shiftLabels: ReadonlyArray<{ readonly __typename?: 'ShiftLabel', readonly Id: string, readonly Name: string, readonly flair__Tag_Name__c: string }> }>, readonly absences2: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Category_Name__c: string, readonly flair__Category_Id__c: string, readonly flair__Type__c: AbsenceType, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string } | null } }>, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Skill__c: string }> }>, readonly openShifts: ReadonlyArray<{ readonly __typename?: 'OpenShift', readonly Id: string, readonly Name: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Location__c: string, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Employees_Count__c: number, readonly Breaks: ReadonlyArray<{ readonly __typename?: 'ShiftBreak', readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string }>, readonly AssignmentRequests: ReadonlyArray<{ readonly __typename?: 'OpenShiftAssignmentRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Confirmed_At__c: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly EmployeeShifts: ReadonlyArray<{ readonly __typename?: 'EmployeeShift', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly Skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string }> }> } };

export type CalendarFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarFiltersQuery = { readonly __typename?: 'Query', readonly departments: ReadonlyArray<{ readonly __typename?: 'Department', readonly Id: string, readonly Name: string }>, readonly skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string }> };

export type EmployeeShiftFieldsFragment = { readonly __typename?: 'EmployeeShift', readonly Id: string, readonly Name: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Location__c: string, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Open_Shift__c: string | null, readonly flair__Employee_Notes__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'ShiftBreak', readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string }>, readonly shiftLabels: ReadonlyArray<{ readonly __typename?: 'ShiftLabel', readonly Id: string, readonly Name: string, readonly flair__Tag_Name__c: string }> };

export type ShiftBreakFieldsFragment = { readonly __typename?: 'ShiftBreak', readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string };

export type CreateOpenShiftAssignmentRequestMutationVariables = Exact<{
  input: CreateOpenShiftAssignmentRequestInput;
}>;


export type CreateOpenShiftAssignmentRequestMutation = { readonly __typename?: 'Mutation', readonly createOpenShiftAssignmentRequest: string };

export type DeleteOpenShiftAssignmentRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOpenShiftAssignmentRequestMutation = { readonly __typename?: 'Mutation', readonly deleteOpenShiftAssignmentRequest: string };

export type MyAbsenceRateReportQueryVariables = Exact<{
  filter: AbsenceRateFilter;
}>;


export type MyAbsenceRateReportQuery = { readonly __typename?: 'Query', readonly reports: { readonly __typename?: 'Reports', readonly absenceRate: { readonly __typename?: 'AbsenceRateReportPayload', readonly overallAbsenceRate: number | null, readonly months: ReadonlyArray<{ readonly __typename?: 'AbsenceRateReportMonth', readonly monthDate: string, readonly absenceRate: number }> } | null } };

export type AbsenceRateReportMonthFragmentFragment = { readonly __typename?: 'AbsenceRateReportMonth', readonly monthDate: string, readonly absenceRate: number };

export type AbsenceRateReportPayloadFragmentFragment = { readonly __typename?: 'AbsenceRateReportPayload', readonly overallAbsenceRate: number | null, readonly months: ReadonlyArray<{ readonly __typename?: 'AbsenceRateReportMonth', readonly monthDate: string, readonly absenceRate: number }> };

export type MyEmployeeOvertimeReportQueryVariables = Exact<{
  filter: OvertimeFilter;
}>;


export type MyEmployeeOvertimeReportQuery = { readonly __typename?: 'Query', readonly reports: { readonly __typename?: 'Reports', readonly employeeOvertime: { readonly __typename?: 'OvertimeReportPayload', readonly overallOvertime: number | null, readonly employeeResults: ReadonlyArray<{ readonly __typename?: 'EmployeeOvertimeReport', readonly employeeId: string, readonly employeeName: string, readonly totalOvertime: number }> } | null } };

export type EmployeeOvertimeReportFragmentFragment = { readonly __typename?: 'EmployeeOvertimeReport', readonly employeeId: string, readonly employeeName: string, readonly totalOvertime: number };

export type OvertimeReportPayloadFragmentFragment = { readonly __typename?: 'OvertimeReportPayload', readonly overallOvertime: number | null, readonly employeeResults: ReadonlyArray<{ readonly __typename?: 'EmployeeOvertimeReport', readonly employeeId: string, readonly employeeName: string, readonly totalOvertime: number }> };

export type MyEmployeeTurnoverRateReportQueryVariables = Exact<{
  filter: EmployeeTurnoverRateFilter;
}>;


export type MyEmployeeTurnoverRateReportQuery = { readonly __typename?: 'Query', readonly reports: { readonly __typename?: 'Reports', readonly turnoverRate: { readonly __typename?: 'EmployeeTurnoverRateReportPayload', readonly overallTurnoverRate: number, readonly monthlyResults: ReadonlyArray<{ readonly __typename?: 'EmployeeTurnoverRateReportMonth', readonly monthDate: string, readonly turnoverRate: number }> } | null } };

export type EmployeeTurnoverRateReportMonthFragmentFragment = { readonly __typename?: 'EmployeeTurnoverRateReportMonth', readonly monthDate: string, readonly turnoverRate: number };

export type EmployeeTurnoverRateReportPayloadFragmentFragment = { readonly __typename?: 'EmployeeTurnoverRateReportPayload', readonly overallTurnoverRate: number, readonly monthlyResults: ReadonlyArray<{ readonly __typename?: 'EmployeeTurnoverRateReportMonth', readonly monthDate: string, readonly turnoverRate: number }> };

export type AllApprovalRequestToMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AllApprovalRequestToMeQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly Name: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Action_Datetime__c: string | null, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly relatedRecordObjectName: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Approver__c: string, readonly relatedRecordName: string, readonly CreatedDate: string, readonly flair__Requested_At__c: string, readonly LastModifiedDate: string, readonly recordEmployee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null }> } };

export type ApprovalPathRequestsQueryVariables = Exact<{
  relatedRecordId: Scalars['String']['input'];
}>;


export type ApprovalPathRequestsQuery = { readonly __typename?: 'Query', readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly CreatedDate: string, readonly recordEmployee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> };

export type ApprovalPathColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type ExpenseByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ExpenseByIdQuery = { readonly __typename?: 'Query', readonly expense: { readonly __typename?: 'Expense', readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CurrencyIsoCode: string, readonly CreatedDate: string, readonly commentsCount: number, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> } | null };

export type ApprovalRequestShiftChangeRequestQueryVariables = Exact<{
  shiftChangeRequestId: Scalars['String']['input'];
}>;


export type ApprovalRequestShiftChangeRequestQuery = { readonly __typename?: 'Query', readonly shiftChangeRequest: { readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Change_Reason__c: string | null, readonly flair__Colleague_Responded_At__c: string | null, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string } } | null };

export type PendingApprovalRequestToMeQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingApprovalRequestToMeQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly Name: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Action_Datetime__c: string | null, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly relatedRecordObjectName: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Approver__c: string, readonly relatedRecordName: string, readonly CreatedDate: string, readonly flair__Requested_At__c: string, readonly LastModifiedDate: string, readonly recordEmployee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null }> } };

export type ApprovalRequestByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApprovalRequestByIdQuery = { readonly __typename?: 'Query', readonly approvalRequest: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly Name: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Action_Datetime__c: string | null, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly relatedRecordObjectName: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Approver__c: string, readonly relatedRecordName: string, readonly CreatedDate: string, readonly flair__Requested_At__c: string, readonly LastModifiedDate: string, readonly recordEmployee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null } };

export type ApprovalRequestUpdateStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: ApprovalRequestStatus;
  comment: InputMaybe<Scalars['String']['input']>;
  relatedRecordId: Scalars['String']['input'];
}>;


export type ApprovalRequestUpdateStatusMutation = { readonly __typename?: 'Mutation', readonly approvalRequest: { readonly __typename?: 'ApprovalRequestMutations', readonly updateApprovalRequestStatus: { readonly __typename?: 'UpdateApprovalRequestStatusPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly Name: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Action_Datetime__c: string | null, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly relatedRecordObjectName: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Approver__c: string, readonly relatedRecordName: string, readonly CreatedDate: string, readonly flair__Requested_At__c: string, readonly LastModifiedDate: string, readonly recordEmployee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null } | null, readonly query: { readonly __typename?: 'Query', readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus }> } } } };

export type MyApprovalRequestsTableFieldsFragment = { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly Name: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Action_Datetime__c: string | null, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly relatedRecordObjectName: string, readonly flair__Approver_Comment__c: string | null, readonly flair__Approver__c: string, readonly relatedRecordName: string, readonly CreatedDate: string, readonly flair__Requested_At__c: string, readonly LastModifiedDate: string, readonly recordEmployee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Department__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly approver: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly Name: string, readonly url: string | null } | null } | null, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus } | null };

export type CelebrationFragment = { readonly __typename?: 'Celebration', readonly Id: string, readonly flair__Message__c: string, readonly flair__Predefined_Image__c: string | null, readonly flair__Public__c: boolean, readonly flair__Type__c: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }, readonly recipients: ReadonlyArray<{ readonly __typename?: 'CelebrationRecipient', readonly Id: string, readonly flair__Recipient_Type__c: CelebrationRecipientType, readonly flair__Order__c: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null } | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string } | null }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> };

export type CelebrationColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null };

export type CreateCelebrationMutationVariables = Exact<{
  input: CreateCelebrationInput;
}>;


export type CreateCelebrationMutation = { readonly __typename?: 'Mutation', readonly celebrations: { readonly __typename?: 'CelebrationMutations', readonly createCelebration: { readonly __typename?: 'CelebrationPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Celebration', readonly Id: string, readonly flair__Message__c: string, readonly flair__Predefined_Image__c: string | null, readonly flair__Public__c: boolean, readonly flair__Type__c: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }, readonly recipients: ReadonlyArray<{ readonly __typename?: 'CelebrationRecipient', readonly Id: string, readonly flair__Recipient_Type__c: CelebrationRecipientType, readonly flair__Order__c: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null } | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string } | null }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | null } } };

export type UpdateCelebrationMutationVariables = Exact<{
  input: UpdateCelebrationInput;
}>;


export type UpdateCelebrationMutation = { readonly __typename?: 'Mutation', readonly celebrations: { readonly __typename?: 'CelebrationMutations', readonly updateCelebration: { readonly __typename?: 'CelebrationPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Celebration', readonly Id: string, readonly flair__Message__c: string, readonly flair__Predefined_Image__c: string | null, readonly flair__Public__c: boolean, readonly flair__Type__c: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }, readonly recipients: ReadonlyArray<{ readonly __typename?: 'CelebrationRecipient', readonly Id: string, readonly flair__Recipient_Type__c: CelebrationRecipientType, readonly flair__Order__c: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null } | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string } | null }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | null } } };

export type DeleteCelebrationMutationVariables = Exact<{
  input: DeleteCelebrationInput;
}>;


export type DeleteCelebrationMutation = { readonly __typename?: 'Mutation', readonly celebrations: { readonly __typename?: 'CelebrationMutations', readonly deleteCelebration: { readonly __typename?: 'CelebrationPayload', readonly error: string | null, readonly recordId: string | null } } };

export type MakeCelebrationPublicMutationVariables = Exact<{
  input: MakeCelebrationPublicInput;
}>;


export type MakeCelebrationPublicMutation = { readonly __typename?: 'Mutation', readonly celebrations: { readonly __typename?: 'CelebrationMutations', readonly makeCelebrationPublic: { readonly __typename?: 'CelebrationPayload', readonly error: string | null, readonly recordId: string | null } } };

export type MarkAsReadMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MarkAsReadMutation = { readonly __typename?: 'Mutation', readonly celebrations: { readonly __typename?: 'CelebrationMutations', readonly markAsRead: { readonly __typename?: 'MarkCelebrationAsReadPayload', readonly error: string | null, readonly records: ReadonlyArray<{ readonly __typename?: 'Celebration', readonly Id: string, readonly myEmployeeRecipient: { readonly __typename?: 'CelebrationEmployeeRecipient', readonly flair__Read_Date__c: string | null } | null }> } } };

export type CelebrationsQueryVariables = Exact<{
  filter: CelebrationFilterInput;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type CelebrationsQuery = { readonly __typename?: 'Query', readonly celebrationsPagination: { readonly __typename?: 'CelebrationPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Celebration', readonly Id: string, readonly flair__Message__c: string, readonly flair__Predefined_Image__c: string | null, readonly flair__Public__c: boolean, readonly flair__Type__c: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }, readonly recipients: ReadonlyArray<{ readonly __typename?: 'CelebrationRecipient', readonly Id: string, readonly flair__Recipient_Type__c: CelebrationRecipientType, readonly flair__Order__c: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null } | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string } | null }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } };

export type CertificateDataFragment = { readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> };

export type CertificateFormDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificateFormDataQuery = { readonly __typename?: 'Query', readonly allCertificates: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string }> };

export type CreateEmployeeCertificateMutationVariables = Exact<{
  input: CreateEmployeeCertificateInput;
}>;


export type CreateEmployeeCertificateMutation = { readonly __typename?: 'Mutation', readonly certificates: { readonly __typename?: 'CertificateMutations', readonly createEmployeeCertificate: { readonly __typename?: 'EmployeeCertificatePayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly certificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null }> }, readonly allCertificates: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string }> } } } };

export type UpdateEmployeeCertificateMutationVariables = Exact<{
  input: UpdateEmployeeCertificateInput;
}>;


export type UpdateEmployeeCertificateMutation = { readonly __typename?: 'Mutation', readonly certificates: { readonly __typename?: 'CertificateMutations', readonly updateEmployeeCertificate: { readonly __typename?: 'EmployeeCertificatePayload', readonly error: string | null, readonly record: { readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> } | null, readonly query: { readonly __typename?: 'Query', readonly allCertificates: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string }> } } } };

export type CertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificatesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly certificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string, readonly flair__Certificate_Link__c: string | null, readonly flair__Status__c: string, readonly commentsCount: number, readonly certificate: { readonly __typename?: 'Certificate', readonly Id: string, readonly Name: string } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }> } };

export type DeleteEmployeeCertificateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteEmployeeCertificateMutation = { readonly __typename?: 'Mutation', readonly certificates: { readonly __typename?: 'CertificateMutations', readonly deleteEmployeeCertificate: { readonly __typename?: 'EmployeeCertificatePayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly certificates: ReadonlyArray<{ readonly __typename?: 'EmployeeCertificate', readonly Id: string, readonly Name: string, readonly flair__Issue_Date__c: string | null, readonly flair__Expiration_Date__c: string | null, readonly flair__Planned_Date__c: string | null, readonly flair__Issued_By__c: string | null, readonly flair__Certificate__c: string | null, readonly flair__Employee__c: string }> } } } } };

export type DashboardAbsentTodayQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  filterBy: InputMaybe<EmployeeScopeFilter>;
}>;


export type DashboardAbsentTodayQuery = { readonly __typename?: 'Query', readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Amount__c: number, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } }> };

export type DashboardAbsentToday_ColleagueFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Amount__c: number, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null } };

export type DashboardAnniversariesQueryVariables = Exact<{
  filter: AnniversariesFilter;
}>;


export type DashboardAnniversariesQuery = { readonly __typename?: 'Query', readonly anniversaries: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__Upcoming_Anniversary__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null }> };

export type DashboardAnniversaries_ColleagueFragment = { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__Upcoming_Anniversary__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null };

export type DashboardBirthdayColleaguesQueryVariables = Exact<{
  filter: BirthdaysFilter;
}>;


export type DashboardBirthdayColleaguesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly birthdaysColleagues: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly flair__Birthday_this_year__c: string | null, readonly flair__Upcoming_Birthday__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null }> } };

export type DashboardBirthdayColleagueFieldsFragment = { readonly __typename?: 'Colleague', readonly flair__Birthday_this_year__c: string | null, readonly flair__Upcoming_Birthday__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null };

export type DashboardCompensatoryTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardCompensatoryTimeQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Compensatory_Time__c: boolean, readonly flair__Type__c: AbsenceType }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number } }> } };

export type DashboardEndOfProbationQueryVariables = Exact<{
  filter: ProbationsFilter;
}>;


export type DashboardEndOfProbationQuery = { readonly __typename?: 'Query', readonly probations: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Of_Probation_Period__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null }> };

export type DashboardEndOfProbation_ColleagueFragment = { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Of_Probation_Period__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null };

export type DashboardLastUpdate_ColleagueFragment = { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null };

export type DashboardLastUpdatesQueryVariables = Exact<{
  filter: LastUpdateFilter;
  paginationInfo: LastUpdatePaginationInfo;
}>;


export type DashboardLastUpdatesQuery = { readonly __typename?: 'Query', readonly lastUpdates: { readonly __typename?: 'LastUpdateResponse', readonly offset: { readonly __typename?: 'LastUpdateOffset', readonly announcementOffset: number, readonly celebrationOffset: number, readonly newHiresOffset: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'Announcement', readonly Id: string, readonly Name: string, readonly CreatedDate: string, readonly flair__Published_Date__c: string | null, readonly flair__Announcement_Text__c: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly emojis: ReadonlyArray<{ readonly __typename?: 'AnnouncementEmoji', readonly Id: string, readonly Name: string, readonly flair__Company_Announcement__c: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }> } | { readonly __typename?: 'Celebration', readonly Id: string, readonly flair__Message__c: string, readonly flair__Predefined_Image__c: string | null, readonly flair__Public__c: boolean, readonly flair__Type__c: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly sender: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }, readonly recipients: ReadonlyArray<{ readonly __typename?: 'CelebrationRecipient', readonly Id: string, readonly flair__Recipient_Type__c: CelebrationRecipientType, readonly flair__Order__c: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null } | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string } | null }>, readonly reactions: ReadonlyArray<{ readonly __typename?: 'Reaction', readonly Id: string, readonly flair__Text__c: string, readonly flair__Employee__c: string, readonly flair__Related_Object_Name__c: string, readonly flair__Related_Id__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } | { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null }> } };

export type Dashboard_AbsenceCategoryFragment = { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean, readonly flair__Unlimited__c: boolean, readonly flair__Compensatory_Time__c: boolean, readonly flair__Absence_Categories_Group__c: string | null, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> };

export type ProfileWidgetAbsenceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileWidgetAbsenceCategoriesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean, readonly flair__Unlimited__c: boolean, readonly flair__Compensatory_Time__c: boolean, readonly flair__Absence_Categories_Group__c: string | null, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }> } };

export type DocumentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentCategoriesQuery = { readonly __typename?: 'Query', readonly documentCategories: ReadonlyArray<{ readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }> };

export type DashboardHolidaysQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardHolidaysQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly upcomingHolidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly upcomingCalendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string }> } };

export type DashboardUpcomingAbsencesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type DashboardUpcomingAbsencesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly upcomingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly commentsCount: number }>, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean, readonly flair__Unlimited__c: boolean, readonly flair__Compensatory_Time__c: boolean, readonly flair__Absence_Categories_Group__c: string | null, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }> } };

export type Dashboard_UpcomingAbsencesFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Withdrawal_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly commentsCount: number };

export type DashboardColleagueFieldsFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null };

export type CommentDeepLinkInfoQueryVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type CommentDeepLinkInfoQuery = { readonly __typename?: 'Query', readonly comment: { readonly __typename?: 'Comment', readonly Id: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null } | null };

export type CommentWithDeepLinkDataFragment = { readonly __typename?: 'Comment', readonly Id: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly flair__Manager__c: string | null }, readonly related: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null } | { readonly __typename?: 'Announcement', readonly Id: string } | { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string } | { readonly __typename?: 'Celebration', readonly Id: string } | { readonly __typename?: 'EmployeeCertificate', readonly Id: string } | { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string } | { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string } | { readonly __typename?: 'Expense', readonly Id: string } | { readonly __typename?: 'ExpenseGroup', readonly Id: string } | { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null } | { readonly __typename?: 'JobCandidate', readonly Id: string } | { readonly __typename?: 'Ticket', readonly Id: string } | { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } } | { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string } | null };

export type CommentRelatedWorkflowItemFragment = { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string };

export type CommentRelatedAbsenceFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__EmployeeId__c: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approver__c: string }> | null };

export type CommentRelatedTimeSheetDayFragment = { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Type__c: WorkloadType, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType }> } };

export type CommentRelatedCandidateEvaluationFragment = { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Candidate__c: string };

export type CommentRelatedEmployeeDocumentFragment = { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Employee1__c: string };

export type CommentRelatedInventoryItemFragment = { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Employee__c: string | null };

export type CommentRelatedEmployeeDataChangeRequestFragment = { readonly __typename?: 'EmployeeDataChangeRequest', readonly Id: string };

export type CreateDocumentFolderMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  input: EmployeeDocumentFolderCreateInput;
}>;


export type CreateDocumentFolderMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly createFolder: { readonly __typename?: 'EmployeeDocumentFolderCreatePayload', readonly recordId: string | null, readonly errorCode: NavigatableErrorCode | null, readonly record: { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolder: { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }> } | null } | null } } };

export type PersonalDocumentsFoldersQueryVariables = Exact<{
  folderId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type PersonalDocumentsFoldersQuery = { readonly __typename?: 'Query', readonly navigatable: { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string, readonly fullPath: string, readonly parentFolderId: string | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly parentFolderId: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly fullPath: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }>, readonly parents: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string }> | null } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string, readonly fullPath: string, readonly parentFolderId: string | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly parentFolderId: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly fullPath: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }>, readonly parents: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string }> | null } | null };

export type RenameDocumentMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  input: NavigatableRenameInput;
}>;


export type RenameDocumentMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly rename: { readonly __typename?: 'NavigatableRenamePayload', readonly errorCode: NavigatableErrorCode | null, readonly record: { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string } } } };

export type UploadEmployeeDocumentMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  input: UploadEmployeeDocumentInput;
}>;


export type UploadEmployeeDocumentMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly uploadDocument: { readonly __typename?: 'UploadDocumentPayload', readonly recordId: string, readonly record: { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string } } } };

export type CorporateDocumentsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type CorporateDocumentsFilterQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> };

export type PersonalDocumentsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalDocumentsFilterQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly documentCategories: ReadonlyArray<{ readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }> };

export type ContentDocumentDataFragment = { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string };

export type ContentDocumentLinksDataFragment = { readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } };

export type CorporateDocumentDataFragment = { readonly __typename?: 'CompanyDocument', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Created_By__c: string | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> };

export type CorporateDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type CorporateDocumentsQuery = { readonly __typename?: 'Query', readonly companyDocuments: ReadonlyArray<{ readonly __typename?: 'CompanyDocument', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Created_By__c: string | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> }> };

export type DocumentCategoryDataFragment = { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string };

export type DocumentCreatedByColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

type Navigatable_EmployeeDocument_Fragment = { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> };

type Navigatable_EmployeeDocumentFolder_Fragment = { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> };

export type NavigatableFragment = Navigatable_EmployeeDocument_Fragment | Navigatable_EmployeeDocumentFolder_Fragment;

export type PersonalDocumentFieldsFragment = { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly parentFolderId: string | null, readonly fullPath: string, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> };

export type PersonalDocumentDataFragment = { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly parentFolderId: string | null, readonly fullPath: string, readonly commentsCount: number, readonly canDelete: boolean, readonly parentFolder: { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly parentFolderId: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly fullPath: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> };

export type PersonalDocumentFolderDataFragment = { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly parentFolderId: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly fullPath: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> };

export type PersonalDocumentsQueryVariables = Exact<{
  folderId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type PersonalDocumentsQuery = { readonly __typename?: 'Query', readonly navigatable: { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string, readonly fullPath: string, readonly parentFolderId: string | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }>, readonly parents: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string }> | null } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string, readonly fullPath: string, readonly parentFolderId: string | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }>, readonly parents: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly Name: string }> | null } | null };

export type UpdateDocumentStatusMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  input: NavigatableUpdateStatusInput;
}>;


export type UpdateDocumentStatusMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly updateStatus: { readonly __typename?: 'NavigatableUpdateStatusPayload', readonly record: { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Approval_Status__c: string | null, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus }> } } } };

export type UpdatePersonalDocumentMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  input: EmployeeDocumentUpdateInput;
}>;


export type UpdatePersonalDocumentMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly updateEmployeeDocument: { readonly __typename?: 'EmployeeDocumentUpdatePayload', readonly record: { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly flair__Note__c: string | null, readonly flair__Document_Category__c: string, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string } } } } };

export type UploadPersonalDocumentMutationVariables = Exact<{
  input: UploadEmployeeDocumentInput;
}>;


export type UploadPersonalDocumentMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly uploadEmployeeDocument: string } };

export type DeleteDocumentMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  navigatableIds: ReadonlyArray<NavigatableIdInput> | NavigatableIdInput;
  recursive: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDocumentMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly delete: { readonly __typename?: 'NavigatablesDeletePayload', readonly errorCode: NavigatableErrorCode | null, readonly recordIds: ReadonlyArray<{ readonly __typename?: 'NavigatableIdPayload', readonly id: string }> } } };

export type MoveDocumentsToMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  navigatableIds: ReadonlyArray<NavigatableIdInput> | NavigatableIdInput;
  moveTo: MoveToFolderInput;
}>;


export type MoveDocumentsToMutation = { readonly __typename?: 'Mutation', readonly document: { readonly __typename?: 'DocumentMutations', readonly move: { readonly __typename?: 'NavigatablesMovePayload', readonly errorCode: NavigatableErrorCode | null, readonly sourceFolders: ReadonlyArray<{ readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }> }>, readonly targetFolder: { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee_Document_Folder__c: string | null, readonly flair__Note__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly commentsCount: number, readonly canDelete: boolean, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly approvalRequest: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string, readonly parentFolderId: string | null, readonly fullPath: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Parent_Folder__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly children: ReadonlyArray<{ readonly __typename?: 'EmployeeDocument', readonly Id: string } | { readonly __typename?: 'EmployeeDocumentFolder', readonly Id: string }> }> } } } };

export type CompanyDocumentFragment = { readonly __typename?: 'CompanyDocument', readonly Id: string, readonly Name: string, readonly CreatedDate: string, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> };

export type EmployeeDocumentFragment = { readonly __typename?: 'EmployeeDocument', readonly Id: string, readonly Name: string, readonly flair__Document_Category__c: string, readonly flair__Approval_Status__c: string | null, readonly flair__Self_Uploaded__c: boolean, readonly CreatedDate: string, readonly documentCategory: { readonly __typename?: 'DocumentCategory', readonly Id: string, readonly Name: string }, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> };

export type EditPersonalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EditPersonalDataQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly data: { readonly __typename?: 'EmployeeData', readonly employeeId: string, readonly sections: ReadonlyArray<{ readonly __typename?: 'EmployeeDataSection', readonly employeeId: string, readonly label: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }>, readonly relatedLists: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedList', readonly label: string, readonly objectType: string, readonly records: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedListRecord', readonly id: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }> }> } } };

export type UpdateMyDataMutationVariables = Exact<{
  input: UpdateFieldsInput;
}>;


export type UpdateMyDataMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly updateMyFields: { readonly __typename?: 'UpdateMyEmployeeDataPayload', readonly record: { readonly __typename?: 'EmployeeData', readonly employeeId: string, readonly sections: ReadonlyArray<{ readonly __typename?: 'EmployeeDataSection', readonly employeeId: string, readonly label: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }>, readonly relatedLists: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedList', readonly label: string, readonly objectType: string, readonly records: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedListRecord', readonly id: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }> }> } | null } } };

export type UpdateMyLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type UpdateMyLanguageMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly updateMyLanguage: { readonly __typename?: 'UpdateMyLanguagePayload', readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly flair__Employee_Language__c: string | null } } } } };

export type UpdateMyBirthdayMutationVariables = Exact<{
  hideMyBirthday: Scalars['Boolean']['input'];
}>;


export type UpdateMyBirthdayMutation = { readonly __typename?: 'Mutation', readonly employeeData: { readonly __typename?: 'EmployeeDataMutations', readonly updateMyBirthday: { readonly __typename?: 'UpdateMyBirthdayPayload', readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly flair__Hide_My_Birthday__c: boolean | null } } } } };

export type EmployeeEvaluationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeeEvaluationQuery = { readonly __typename?: 'Query', readonly employeeEvaluationById: { readonly __typename?: 'EmployeeEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Evaluator__c: string, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null, readonly urlLarge: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Employee_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null, readonly workflowItem: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Due_Date__c: string | null, readonly flair__Workflow__c: string } | null } };

export type EmployeeEvaluationFragmentFragment = { readonly __typename?: 'EmployeeEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Evaluator__c: string, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null, readonly urlLarge: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Employee_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null, readonly workflowItem: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Due_Date__c: string | null, readonly flair__Workflow__c: string } | null };

export type SaveEmployeeEvaluationMutationVariables = Exact<{
  input: SaveEmployeeEvaluationInput;
}>;


export type SaveEmployeeEvaluationMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly saveEmployeeEvaluation: { readonly __typename?: 'UpdateEmployeeEvaluationPayload', readonly recordId: string, readonly record: { readonly __typename?: 'EmployeeEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Evaluator__c: string, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null, readonly urlLarge: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Employee_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null, readonly workflowItem: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Due_Date__c: string | null, readonly flair__Workflow__c: string } | null } | null } } };

export type SaveEmployeeEvaluationAnswerMutationVariables = Exact<{
  input: SaveEvaluationAnswerInput;
}>;


export type SaveEmployeeEvaluationAnswerMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly saveEvaluationAnswer: { readonly __typename?: 'SaveEvaluationAnswerPayload', readonly recordId: string } } };

export type DeleteEmployeeEvaluationAnswerMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteEmployeeEvaluationAnswerMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly deleteEvaluationAnswer: ReadonlyArray<{ readonly __typename?: 'DeleteEvaluationAnswerPayload', readonly recordId: string }> | null } };

export type EvaluationTemplateFragmentFragment = { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> };

export type EngagementSurveyEmployeeResponseFragment = { readonly __typename?: 'EngagementSurveyEmployeeResponse', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Submitted_At__c: string | null, readonly flair__Dismissed_At__c: string | null, readonly engagementSurvey: { readonly __typename?: 'EngagementSurvey', readonly Id: string, readonly Name: string, readonly flair__Long_Introduction__c: string | null, readonly flair__Deadline__c: string | null, readonly flair__Is_Anonymous__c: boolean, readonly flair__Is_Compulsory__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly deadlineOver: boolean, readonly sections: ReadonlyArray<{ readonly __typename?: 'EngagementSurveySection', readonly Id: string, readonly Name: string, readonly flair__Engagement_Survey__c: string, readonly questions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestion', readonly Id: string, readonly flair__Question_Text__c: string, readonly flair__Can_comment__c: boolean, readonly flair__Description__c: string | null, readonly flair__Hint__c: string | null, readonly flair__Is_Optional__c: boolean, readonly flair__Order__c: number | null, readonly flair__Type__c: QuestionnaireType, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Section__c: string, readonly options: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionOption', readonly Id: string, readonly Name: string, readonly flair__Order__c: number | null, readonly flair__Required__c: boolean }> }> }> }, readonly questionsAnswers: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionAnswer', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Employee_Response__c: string, readonly flair__Engagement_Survey_Question__c: string, readonly flair__Free_Text__c: string | null, readonly flair__Score__c: number | null, readonly selectedOptions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyAnswerOption', readonly Id: string, readonly flair__Engagement_Survey_Question_Option__c: string, readonly flair__Value__c: number | null }> }> };

export type EngagementSurveyQuestionAnswerFragment = { readonly __typename?: 'EngagementSurveyQuestionAnswer', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Employee_Response__c: string, readonly flair__Engagement_Survey_Question__c: string, readonly flair__Free_Text__c: string | null, readonly flair__Score__c: number | null, readonly selectedOptions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyAnswerOption', readonly Id: string, readonly flair__Engagement_Survey_Question_Option__c: string, readonly flair__Value__c: number | null }> };

export type AnswerEngagementSurveyQuestionMutationVariables = Exact<{
  input: UpdateEngagementSurveyAnswerInput;
}>;


export type AnswerEngagementSurveyQuestionMutation = { readonly __typename?: 'Mutation', readonly engagementSurveys: { readonly __typename?: 'EngagementSurveysMutations', readonly answerEngagementSurveyQuestion: { readonly __typename?: 'EngagementSurveyQuestionAnswerPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'EngagementSurveyQuestionAnswer', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Employee_Response__c: string, readonly flair__Engagement_Survey_Question__c: string, readonly flair__Free_Text__c: string | null, readonly flair__Score__c: number | null, readonly selectedOptions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyAnswerOption', readonly Id: string, readonly flair__Engagement_Survey_Question_Option__c: string, readonly flair__Value__c: number | null }> } | null } } };

export type SubmitEngagementSurveyEmployeeResponseMutationVariables = Exact<{
  input: SubmitEngagementSurveyInput;
}>;


export type SubmitEngagementSurveyEmployeeResponseMutation = { readonly __typename?: 'Mutation', readonly engagementSurveys: { readonly __typename?: 'EngagementSurveysMutations', readonly submitEngagementSurveyEmployeeResponse: { readonly __typename?: 'EngagementSurveyEmployeeResponsePayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'EngagementSurveyEmployeeResponse', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Submitted_At__c: string | null, readonly flair__Dismissed_At__c: string | null, readonly engagementSurvey: { readonly __typename?: 'EngagementSurvey', readonly Id: string, readonly Name: string, readonly flair__Long_Introduction__c: string | null, readonly flair__Deadline__c: string | null, readonly flair__Is_Anonymous__c: boolean, readonly flair__Is_Compulsory__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly deadlineOver: boolean, readonly sections: ReadonlyArray<{ readonly __typename?: 'EngagementSurveySection', readonly Id: string, readonly Name: string, readonly flair__Engagement_Survey__c: string, readonly questions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestion', readonly Id: string, readonly flair__Question_Text__c: string, readonly flair__Can_comment__c: boolean, readonly flair__Description__c: string | null, readonly flair__Hint__c: string | null, readonly flair__Is_Optional__c: boolean, readonly flair__Order__c: number | null, readonly flair__Type__c: QuestionnaireType, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Section__c: string, readonly options: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionOption', readonly Id: string, readonly Name: string, readonly flair__Order__c: number | null, readonly flair__Required__c: boolean }> }> }> }, readonly questionsAnswers: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionAnswer', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Employee_Response__c: string, readonly flair__Engagement_Survey_Question__c: string, readonly flair__Free_Text__c: string | null, readonly flair__Score__c: number | null, readonly selectedOptions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyAnswerOption', readonly Id: string, readonly flair__Engagement_Survey_Question_Option__c: string, readonly flair__Value__c: number | null }> }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly engagementSurveys: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyDto', readonly id: string, readonly name: string, readonly deadline: string | null, readonly state: string, readonly compulsory: boolean, readonly createdOn: string, readonly submittedAt: string | null, readonly dismissedAt: string | null }> } } } } };

export type DismissEngagementSurveyEmployeeResponseMutationVariables = Exact<{
  input: SubmitEngagementSurveyInput;
}>;


export type DismissEngagementSurveyEmployeeResponseMutation = { readonly __typename?: 'Mutation', readonly engagementSurveys: { readonly __typename?: 'EngagementSurveysMutations', readonly dismissEngagementSurveyEmployeeResponse: { readonly __typename?: 'EngagementSurveyEmployeeResponsePayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'EngagementSurveyEmployeeResponse', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Submitted_At__c: string | null, readonly flair__Dismissed_At__c: string | null, readonly engagementSurvey: { readonly __typename?: 'EngagementSurvey', readonly Id: string, readonly Name: string, readonly flair__Long_Introduction__c: string | null, readonly flair__Deadline__c: string | null, readonly flair__Is_Anonymous__c: boolean, readonly flair__Is_Compulsory__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly deadlineOver: boolean, readonly sections: ReadonlyArray<{ readonly __typename?: 'EngagementSurveySection', readonly Id: string, readonly Name: string, readonly flair__Engagement_Survey__c: string, readonly questions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestion', readonly Id: string, readonly flair__Question_Text__c: string, readonly flair__Can_comment__c: boolean, readonly flair__Description__c: string | null, readonly flair__Hint__c: string | null, readonly flair__Is_Optional__c: boolean, readonly flair__Order__c: number | null, readonly flair__Type__c: QuestionnaireType, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Section__c: string, readonly options: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionOption', readonly Id: string, readonly Name: string, readonly flair__Order__c: number | null, readonly flair__Required__c: boolean }> }> }> }, readonly questionsAnswers: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionAnswer', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Employee_Response__c: string, readonly flair__Engagement_Survey_Question__c: string, readonly flair__Free_Text__c: string | null, readonly flair__Score__c: number | null, readonly selectedOptions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyAnswerOption', readonly Id: string, readonly flair__Engagement_Survey_Question_Option__c: string, readonly flair__Value__c: number | null }> }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly engagementSurveys: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyDto', readonly id: string, readonly name: string, readonly deadline: string | null, readonly state: string, readonly compulsory: boolean, readonly createdOn: string, readonly submittedAt: string | null, readonly dismissedAt: string | null }> } } } } };

export type EngagementSurveyEmployeeResponseBySurveyIdQueryVariables = Exact<{
  surveyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type EngagementSurveyEmployeeResponseBySurveyIdQuery = { readonly __typename?: 'Query', readonly engagementSurveyEmployeeResponseBySurveyAndEmployee: { readonly __typename?: 'EngagementSurveyEmployeeResponse', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Submitted_At__c: string | null, readonly flair__Dismissed_At__c: string | null, readonly engagementSurvey: { readonly __typename?: 'EngagementSurvey', readonly Id: string, readonly Name: string, readonly flair__Long_Introduction__c: string | null, readonly flair__Deadline__c: string | null, readonly flair__Is_Anonymous__c: boolean, readonly flair__Is_Compulsory__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly deadlineOver: boolean, readonly sections: ReadonlyArray<{ readonly __typename?: 'EngagementSurveySection', readonly Id: string, readonly Name: string, readonly flair__Engagement_Survey__c: string, readonly questions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestion', readonly Id: string, readonly flair__Question_Text__c: string, readonly flair__Can_comment__c: boolean, readonly flair__Description__c: string | null, readonly flair__Hint__c: string | null, readonly flair__Is_Optional__c: boolean, readonly flair__Order__c: number | null, readonly flair__Type__c: QuestionnaireType, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Section__c: string, readonly options: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionOption', readonly Id: string, readonly Name: string, readonly flair__Order__c: number | null, readonly flair__Required__c: boolean }> }> }> }, readonly questionsAnswers: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyQuestionAnswer', readonly Id: string, readonly flair__Comment__c: string | null, readonly flair__Employee__c: string, readonly flair__Engagement_Survey__c: string, readonly flair__Engagement_Survey_Employee_Response__c: string, readonly flair__Engagement_Survey_Question__c: string, readonly flair__Free_Text__c: string | null, readonly flair__Score__c: number | null, readonly selectedOptions: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyAnswerOption', readonly Id: string, readonly flair__Engagement_Survey_Question_Option__c: string, readonly flair__Value__c: number | null }> }> } | null };

export type EngagementSurveyDtoFragment = { readonly __typename?: 'EngagementSurveyDto', readonly id: string, readonly name: string, readonly deadline: string | null, readonly state: string, readonly compulsory: boolean, readonly createdOn: string, readonly submittedAt: string | null, readonly dismissedAt: string | null };

export type MyEngagementSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEngagementSurveysQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly engagementSurveys: ReadonlyArray<{ readonly __typename?: 'EngagementSurveyDto', readonly id: string, readonly name: string, readonly deadline: string | null, readonly state: string, readonly compulsory: boolean, readonly createdOn: string, readonly submittedAt: string | null, readonly dismissedAt: string | null }> } };

export type ExpenseDataFragment = { readonly __typename?: 'Expense', readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CurrencyIsoCode: string, readonly CreatedDate: string, readonly commentsCount: number, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> };

export type ExpenseGroupApprovalRequestsQueryVariables = Exact<{
  relatedRecordId: Scalars['String']['input'];
}>;


export type ExpenseGroupApprovalRequestsQuery = { readonly __typename?: 'Query', readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> };

export type ExpenseGroupDataFragment = { readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> };

export type ExpenseRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseRulesQuery = { readonly __typename?: 'Query', readonly expenseRules: ReadonlyArray<{ readonly __typename?: 'ExpenseRule', readonly Id: string, readonly Name: string, readonly flair__Amount_Per__c: string | null, readonly flair__Compensation_Amount__c: number | null, readonly flair__Condition_Field__c: string | null, readonly flair__Condition_Operator__c: ExpenseRuleConditionOperator | null, readonly flair__Condition_Value__c: string | null, readonly flair__Percentage_Addition__c: number | null, readonly flair__Valid_For_Record_Types__c: string | null }> | null };

export type ExpenseFormDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseFormDataQuery = { readonly __typename?: 'Query', readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string }>, readonly merchants: ReadonlyArray<{ readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string }>, readonly expenseCategories: ReadonlyArray<{ readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string }>, readonly objectRecordTypes: ReadonlyArray<{ readonly __typename?: 'ObjectRecordType', readonly objectApiName: string, readonly recordTypes: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }> }>, readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus }> }, readonly expenseRules: ReadonlyArray<{ readonly __typename?: 'ExpenseRule', readonly Id: string, readonly Name: string, readonly flair__Amount_Per__c: string | null, readonly flair__Compensation_Amount__c: number | null, readonly flair__Condition_Field__c: string | null, readonly flair__Condition_Operator__c: ExpenseRuleConditionOperator | null, readonly flair__Condition_Value__c: string | null, readonly flair__Percentage_Addition__c: number | null, readonly flair__Valid_For_Record_Types__c: string | null }> | null };

export type CreateDraftExpenseMutationVariables = Exact<{
  input: CreateDraftExpenseInput;
}>;


export type CreateDraftExpenseMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly createDraftExpense: { readonly __typename?: 'ExpensePayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly extraFieldInfoId: string, readonly fieldApiName: string, readonly type: FieldType, readonly jsonValue: string | null, readonly displayValue: string | null, readonly recordId: string, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } } } } };

export type CreateExpenseItemMutationVariables = Exact<{
  input: CreateExpenseItemInput;
}>;


export type CreateExpenseItemMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly createExpenseItem: { readonly __typename?: 'ExpenseItemPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Merchant__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }> } } } } };

export type CreateMerchantMutationVariables = Exact<{
  input: CreateMerchantInput;
}>;


export type CreateMerchantMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly createMerchant: { readonly __typename?: 'MerchantPayload', readonly error: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null } } };

export type DeleteExpenseItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteExpenseItemMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly deleteExpenseItem: { readonly __typename?: 'ExpenseItemPayload', readonly recordId: string | null, readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } } } } };

export type UpdateExpenseMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly updateExpense: { readonly __typename?: 'ExpensePayload', readonly record: { readonly __typename?: 'Expense', readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly CreatedDate: string, readonly commentsCount: number, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly expenseGroup: { readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }> } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } } } } };

export type UpdateExpenseItemMutationVariables = Exact<{
  input: UpdateExpenseItemInput;
}>;


export type UpdateExpenseItemMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly updateExpenseItem: { readonly __typename?: 'ExpenseItemPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Amount__c: number | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly expense: { readonly __typename?: 'Expense', readonly Id: string, readonly flair__Final_Amount__c: number, readonly CurrencyIsoCode: string } | null } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }> } } } } };

export type UploadExpenseFileMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UploadExpenseFileMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly updateExpense: { readonly __typename?: 'ExpensePayload', readonly error: string | null, readonly record: { readonly __typename?: 'Expense', readonly Id: string, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly Title: string, readonly FileExtension: string | null, readonly LatestPublishedVersionId: string } }> } | null } } };

export type ExpenseApprovalRequestsQueryVariables = Exact<{
  relatedRecordId: Scalars['String']['input'];
}>;


export type ExpenseApprovalRequestsQuery = { readonly __typename?: 'Query', readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }> };

export type UpdateExpenseApprovalRequestStatusMutationVariables = Exact<{
  input: UpdateApprovalRequestStatusInput;
  expenseId: Scalars['String']['input'];
}>;


export type UpdateExpenseApprovalRequestStatusMutation = { readonly __typename?: 'Mutation', readonly approvalRequest: { readonly __typename?: 'ApprovalRequestMutations', readonly updateApprovalRequestStatus: { readonly __typename?: 'UpdateApprovalRequestStatusPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus } | null, readonly query: { readonly __typename?: 'Query', readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }>, readonly expense: { readonly __typename?: 'Expense', readonly Id: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Reimbursed__c: boolean } | null } } } };

export type ExpensesQueryVariables = Exact<{
  sort: InputMaybe<ReadonlyArray<ExpenseSortInput> | ExpenseSortInput>;
}>;


export type ExpensesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } };

export type CreateExpenseGroupMutationVariables = Exact<{
  input: CreateExpenseGroupInput;
}>;


export type CreateExpenseGroupMutation = { readonly __typename?: 'Mutation', readonly expenseGroups: { readonly __typename?: 'ExpenseGroupMutations', readonly createExpenseGroup: { readonly __typename?: 'ExpenseGroupPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Type__c: ExpenseGroupType, readonly flair__Status__c: ExpenseStatus, readonly flair__Trip_Location__c: string | null, readonly flair__Employee__c: string } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } } } } };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteExpenseMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly deleteExpense: { readonly __typename?: 'ExpensePayload', readonly recordId: string | null, readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CurrencyIsoCode: string, readonly CreatedDate: string, readonly commentsCount: number, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }> } } } } };

export type DeleteExpenseGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteExpenseGroupMutation = { readonly __typename?: 'Mutation', readonly expenseGroups: { readonly __typename?: 'ExpenseGroupMutations', readonly deleteExpenseGroup: { readonly __typename?: 'ExpenseGroupPayload', readonly recordId: string | null, readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly commentsCount: number, readonly CurrencyIsoCode: string, readonly Id: string, readonly Name: string, readonly flair__Description__c: string, readonly flair__Amount__c: number, readonly flair__Final_Amount__c: number, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly flair__Date_To__c: string | null, readonly flair__Time_From__c: string | null, readonly flair__Time_To__c: string | null, readonly flair__Status__c: ExpenseStatus, readonly flair__Expense_Group__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Is_Draft__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly flair__OCR__c: boolean | null, readonly flair__OCR_Completed_At__c: string | null, readonly CreatedDate: string, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly expenseCategory: { readonly __typename?: 'ExpenseCategory', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }>, readonly expenseItems: ReadonlyArray<{ readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> }> }>, readonly myExpenseGroups: ReadonlyArray<{ readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Type__c: ExpenseGroupType, readonly flair__Employee__c: string, readonly flair__Trip_Location__c: string | null, readonly flair__Reimbursed__c: boolean, readonly flair__Decline_Reason__c: string | null, readonly CurrencyIsoCode: string, readonly isGroup: boolean, readonly CreatedDate: string, readonly totalAmount: number, readonly startDate: string | null, readonly endDate: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string }>, readonly comments: ReadonlyArray<{ readonly __typename?: 'Comment', readonly Id: string }> }> } } } } };

export type ExpenseItemFragment = { readonly __typename?: 'ExpenseItem', readonly Id: string, readonly Name: string | null, readonly flair__Manual_Amount__c: number | null, readonly flair__Amount__c: number | null, readonly flair__Note__c: string | null, readonly flair__Tax__c: string | null, readonly flair__Breakfast_Provided__c: boolean | null, readonly flair__Lunch_Provided__c: boolean | null, readonly flair__Dinner_Provided__c: boolean | null, readonly flair__Address_From__c: string | null, readonly flair__Address_To__c: string | null, readonly flair__Km_Distance__c: number | null, readonly flair__Distance_Sync_In_Progress__c: boolean | null, readonly RecordTypeId: string | null, readonly merchant: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly tax: { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null } | null, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string }, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> };

export type ExpenseRuleFragment = { readonly __typename?: 'ExpenseRule', readonly Id: string, readonly Name: string, readonly flair__Amount_Per__c: string | null, readonly flair__Compensation_Amount__c: number | null, readonly flair__Condition_Field__c: string | null, readonly flair__Condition_Operator__c: ExpenseRuleConditionOperator | null, readonly flair__Condition_Value__c: string | null, readonly flair__Percentage_Addition__c: number | null, readonly flair__Valid_For_Record_Types__c: string | null };

export type ExtraFieldInfoIdFragment = { readonly __typename?: 'ExtraFieldValue', readonly extraFieldInfoId: string, readonly fieldApiName: string, readonly type: FieldType, readonly jsonValue: string | null, readonly displayValue: string | null };

export type RecordTypeBaseFragment = { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string };

export type TaxFragment = { readonly __typename?: 'Tax', readonly Id: string, readonly Name: string | null, readonly flair__Percentage__c: number | null };

export type UpdateExpenseGroupApprovalRequestStatusMutationVariables = Exact<{
  input: UpdateApprovalRequestStatusInput;
  expenseGroupId: Scalars['String']['input'];
}>;


export type UpdateExpenseGroupApprovalRequestStatusMutation = { readonly __typename?: 'Mutation', readonly approvalRequest: { readonly __typename?: 'ApprovalRequestMutations', readonly updateApprovalRequestStatus: { readonly __typename?: 'UpdateApprovalRequestStatusPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus } | null, readonly query: { readonly __typename?: 'Query', readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Approval_Status__c: ApprovalRequestStatus, readonly flair__Approver__c: string }>, readonly expenseGroup: { readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Reimbursed__c: boolean } | null } } } };

export type UpdateExpenseStatusMutationVariables = Exact<{
  input: UpdateExpenseStatusInput;
}>;


export type UpdateExpenseStatusMutation = { readonly __typename?: 'Mutation', readonly expenses: { readonly __typename?: 'ExpenseMutations', readonly updateExpenseStatus: { readonly __typename?: 'ExpensePayload', readonly record: { readonly __typename?: 'Expense', readonly Id: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Decline_Reason__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }> } | null } } };

export type UpdateExpenseGroupStatusMutationVariables = Exact<{
  input: UpdateExpenseGroupStatusInput;
}>;


export type UpdateExpenseGroupStatusMutation = { readonly __typename?: 'Mutation', readonly expenseGroups: { readonly __typename?: 'ExpenseGroupMutations', readonly updateExpenseGroupStatus: { readonly __typename?: 'ExpenseGroupPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'ExpenseGroup', readonly Id: string, readonly Name: string, readonly flair__Type__c: ExpenseGroupType, readonly flair__Status__c: ExpenseStatus, readonly flair__Decline_Reason__c: string | null, readonly flair__Employee__c: string, readonly flair__Reimbursed__c: boolean, readonly expenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string, readonly flair__Status__c: ExpenseStatus, readonly flair__Decline_Reason__c: string | null, readonly flair__Reimbursed__c: boolean }> } | null } } };

export type HomeTodayAbsenceCardAbsenceFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Amount__c: number, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } };

export type HomeTodayAbsencesCardQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filterBy?: InputMaybe<EmployeeScopeFilter>;
}>;


export type HomeTodayAbsencesCardQuery = { readonly __typename?: 'Query', readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Amount__c: number, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } }> };

export type HomeAbsenceCard_AbsenceCategoryFragment = { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean, readonly flair__Unlimited__c: boolean, readonly flair__Compensatory_Time__c: boolean, readonly flair__Absence_Categories_Group__c: string | null, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> };

export type HomeAbsencesCardQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeAbsencesCardQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly absenceCategories: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly flair__Unlimited__c: boolean, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean, readonly flair__Unlimited__c: boolean, readonly flair__Compensatory_Time__c: boolean, readonly flair__Absence_Categories_Group__c: string | null, readonly flair__Without_Balance__c: boolean, readonly flair__Order__c: number, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string, readonly flair__Order__c: number } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number }, readonly absenceRequestPolicies: ReadonlyArray<{ readonly __typename?: 'EmployeeAbsenceRequestPolicy', readonly Id: string, readonly absenceRequestPolicy: { readonly __typename?: 'AbsenceRequestPolicy', readonly Id: string, readonly Name: string } }> }>, readonly absencesCurrentYear: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Working_Amount__c: number, readonly flair__Employee_Absence_Category__c: string | null }>, readonly upcomingAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType }> } };

export type CheckinsSurveysFragment = { readonly __typename?: 'CheckinsSurveyDto', readonly id: string, readonly name: string | null, readonly questionText: string, readonly allowComments: boolean, readonly compulsory: boolean, readonly cycles: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyCycleDto', readonly id: string, readonly startDate: string, readonly endDate: string | null }> };

export type AnswerCheckinsSurveyCycleMutationVariables = Exact<{
  input: AnswerCheckinsSurveyCycleInput;
}>;


export type AnswerCheckinsSurveyCycleMutation = { readonly __typename?: 'Mutation', readonly checkinsSurveys: { readonly __typename?: 'CheckinsSurveyMutations', readonly answerCheckinsSurveyCycle: { readonly __typename?: 'CheckinsSurveyPayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly checkinsSurveys: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyDto', readonly id: string, readonly name: string | null, readonly questionText: string, readonly allowComments: boolean, readonly compulsory: boolean, readonly cycles: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyCycleDto', readonly id: string, readonly startDate: string, readonly endDate: string | null }> }> } } } } };

export type DismissCheckinsSurveyCycleMutationVariables = Exact<{
  input: DismissCheckinsSurveyCycleInput;
}>;


export type DismissCheckinsSurveyCycleMutation = { readonly __typename?: 'Mutation', readonly checkinsSurveys: { readonly __typename?: 'CheckinsSurveyMutations', readonly dismissCheckinsSurveyCycle: { readonly __typename?: 'CheckinsSurveyPayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly checkinsSurveys: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyDto', readonly id: string, readonly name: string | null, readonly questionText: string, readonly allowComments: boolean, readonly compulsory: boolean, readonly cycles: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyCycleDto', readonly id: string, readonly startDate: string, readonly endDate: string | null }> }> } } } } };

export type MyCheckinsSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCheckinsSurveysQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly checkinsSurveys: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyDto', readonly id: string, readonly name: string | null, readonly questionText: string, readonly allowComments: boolean, readonly compulsory: boolean, readonly cycles: ReadonlyArray<{ readonly __typename?: 'CheckinsSurveyCycleDto', readonly id: string, readonly startDate: string, readonly endDate: string | null }> }> } };

export type AbsenceCategoriesFieldsFragment = { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Icon__c: string | null, readonly flair__Unlimited__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Compensatory_Time__c: boolean, readonly flair__Type__c: AbsenceType, readonly group: { readonly __typename?: 'AbsenceCategoriesGroup', readonly Id: string, readonly Name: string } | null }, readonly allowancesSummary: { readonly __typename?: 'AbsenceAllowancesSummary', readonly availableAmount: number, readonly gainedThisYear: number, readonly usedAmount: number } };

export type AbsenceCurrentYearFieldsFragment = { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Working_Amount__c: number, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string, readonly flair__Unlimited__c: boolean, readonly flair__Without_Balance__c: boolean, readonly flair__Icon__c: string | null } };

export type OpenShiftsFieldsFragment = { readonly __typename?: 'OpenShift', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Location__c: string, readonly EmployeeShifts: ReadonlyArray<{ readonly __typename?: 'EmployeeShift', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> };

export type UpdateSliderSettingsMutationVariables = Exact<{
  input: UpdateSliderSettingsInput;
}>;


export type UpdateSliderSettingsMutation = { readonly __typename?: 'Mutation', readonly employeeHubFeatures: { readonly __typename?: 'EmployeeHubFeatureMutations', readonly updateSliderSettings: { readonly __typename?: 'SliderSettingsPayload', readonly query: { readonly __typename?: 'Query', readonly employeeHubFeatures: { readonly __typename?: 'EmployeeHubFeature', readonly Id: string, readonly flair__IsGlobal__c: boolean, readonly flair__Hide_Absences__c: boolean, readonly flair__Hide_Announcements__c: boolean, readonly flair__Hide_Assessments__c: boolean, readonly flair__Hide_Certificates__c: boolean, readonly flair__Hide_Cheers__c: boolean, readonly flair__Hide_Corporate_Documents__c: boolean, readonly flair__Hide_Directory__c: boolean, readonly flair__Hide_Expenses__c: boolean, readonly flair__Hide_Goals__c: boolean, readonly flair__Hide_Home_Absent_Today__c: boolean, readonly flair__Hide_Home_Birthdays_Card__c: boolean, readonly flair__Hide_Home_New_Hires_Card__c: boolean, readonly flair__Hide_Org_Chart__c: boolean, readonly flair__Hide_Personal_Data__c: boolean, readonly flair__Hide_Personal_Documents__c: boolean, readonly flair__Hide_Private_Notes__c: boolean, readonly flair__Hide_Projects__c: boolean, readonly flair__Hide_Recruiting__c: boolean, readonly flair__Hide_Shift_Planner__c: boolean, readonly flair__Hide_Skills__c: boolean, readonly flair__Hide_Surveys__c: boolean, readonly flair__Hide_Time_Tracking__c: boolean, readonly flair__Hide_Workflows__c: boolean, readonly flair__Hide_HR_HelpDesk__c: boolean, readonly flair__Hide_Inventory__c: boolean, readonly flair__Customise_Dashboard_Main_Slider__c: string | null, readonly flair__Hide_Anniversaries__c: boolean, readonly flair__Hide_Public_Holidays__c: boolean, readonly flair__Hide_Employee_Bank_Details__c: boolean, readonly flair__Hide_Employee_Salaries__c: boolean, readonly flair__Hide_Employee_Workload_Details__c: boolean } | null } } } };

export type AnswerEnpsSurveyCycleMutationVariables = Exact<{
  input: AnswerEnpsSurveyCycleInput;
}>;


export type AnswerEnpsSurveyCycleMutation = { readonly __typename?: 'Mutation', readonly enpsSurveys: { readonly __typename?: 'EnpsSurveyMutations', readonly answerEnpsSurveyCycle: { readonly __typename?: 'EnpsSurveyPayload', readonly error: string | null } } };

export type DismissEnpsSurveyCycleMutationVariables = Exact<{
  input: DismissEnpsSurveyCycleInput;
}>;


export type DismissEnpsSurveyCycleMutation = { readonly __typename?: 'Mutation', readonly enpsSurveys: { readonly __typename?: 'EnpsSurveyMutations', readonly dismissEnpsSurveyCycle: { readonly __typename?: 'EnpsSurveyPayload', readonly error: string | null } } };

export type MyEnpsSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEnpsSurveysQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly enpsSurveys: ReadonlyArray<{ readonly __typename?: 'EnpsSurveyDto', readonly id: string, readonly name: string | null, readonly questionText: string, readonly messageBodyText: string, readonly allowComments: boolean, readonly compulsory: boolean, readonly cycles: ReadonlyArray<{ readonly __typename?: 'EnpsSurveyCycleDto', readonly id: string, readonly startDate: string, readonly endDate: string | null }> }> } };

export type HomeNewHiresCardQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeNewHiresCardQuery = { readonly __typename?: 'Query', readonly newHires: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly flair__Start_Date__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null }> };

export type HomePendingApprovalCardQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type HomePendingApprovalCardQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly pendingTimeSheets: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly pendingTimeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Working_Period_In_Hours__c: number, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Working_Period_In_Hours__c: number } | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }>, readonly pendingExpenses: ReadonlyArray<{ readonly __typename?: 'Expense', readonly Id: string, readonly flair__Expense_Date__c: string | null, readonly flair__Date_From__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }> }, readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly approvalRequests: ReadonlyArray<{ readonly __typename?: 'ApprovalRequest', readonly Id: string, readonly flair__Related_Object_Name__c: string, readonly absence: { readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } } | null }> } };

export type HomePerformaceReviewCardQueryVariables = Exact<{
  filter: MyFeedbacksFilter;
}>;


export type HomePerformaceReviewCardQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly feedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null } }>, readonly feedbacksAsReviewer: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null } }> } };

export type CoursesTable_EmployeeCourseFragment = { readonly __typename?: 'EmployeeCourse', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Course__c: string | null, readonly flair__Complete_Progress__c: number | null, readonly flair__Total_Seconds__c: number | null, readonly flair__Completed_At__c: string | null, readonly flair__Enrolled_At__c: string | null, readonly course: { readonly __typename?: 'Course', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type GotoCourseUrlMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GotoCourseUrlMutation = { readonly __typename?: 'Mutation', readonly courses: { readonly __typename?: 'CoursesMutations', readonly gotoCourseUrl: string } };

export type EmployeeCoursesQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type EmployeeCoursesQuery = { readonly __typename?: 'Query', readonly employeeCourses: ReadonlyArray<{ readonly __typename?: 'EmployeeCourse', readonly Id: string, readonly flair__Employee__c: string | null, readonly flair__Course__c: string | null, readonly flair__Complete_Progress__c: number | null, readonly flair__Total_Seconds__c: number | null, readonly flair__Completed_At__c: string | null, readonly flair__Enrolled_At__c: string | null, readonly course: { readonly __typename?: 'Course', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> };

export type InventoryDictionaryDataFragment = { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null };

export type InventoryFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryFilterQuery = { readonly __typename?: 'Query', readonly inventoryCategories: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Name: string }>, readonly locations: ReadonlyArray<{ readonly __typename?: 'Location', readonly Id: string, readonly Name: string }> };

export type InventoryDataFragment = { readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Manufacturer__c: string | null, readonly flair__Model__c: string | null, readonly flair__Type__c: string | null, readonly flair__Support_Video__c: string | null, readonly flair__Support_Instruction__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly supportAdvisor: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type InventoryListQueryVariables = Exact<{
  filter: InventoryItemFilterInput;
  sort: InputMaybe<InventoryItemSortInput>;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type InventoryListQuery = { readonly __typename?: 'Query', readonly inventoryItemsPagination: { readonly __typename?: 'InventoryItemsPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'InventoryItem', readonly Id: string, readonly CurrencyIsoCode: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly flair__Approval_Status__c: string | null, readonly inventory: { readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Manufacturer__c: string | null, readonly flair__Model__c: string | null, readonly flair__Type__c: string | null, readonly flair__Support_Video__c: string | null, readonly flair__Support_Instruction__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly supportAdvisor: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } };

export type InventoryListDataFragment = { readonly __typename?: 'InventoryItem', readonly Id: string, readonly CurrencyIsoCode: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly flair__Approval_Status__c: string | null, readonly inventory: { readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Manufacturer__c: string | null, readonly flair__Model__c: string | null, readonly flair__Type__c: string | null, readonly flair__Support_Video__c: string | null, readonly flair__Support_Instruction__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly supportAdvisor: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null };

export type UpdateInventoryStatusMutationVariables = Exact<{
  input: UpdateInventoryItemStatusInput;
}>;


export type UpdateInventoryStatusMutation = { readonly __typename?: 'Mutation', readonly inventory: { readonly __typename?: 'InventoryMutations', readonly updateInventoryItemStatus: { readonly __typename?: 'UpdateInventoryItemStatusPayload', readonly record: { readonly __typename?: 'InventoryItem', readonly Id: string, readonly flair__Approval_Status__c: string | null } } | null } };

export type InventorySidebarDataFragment = { readonly __typename?: 'InventoryItem', readonly Id: string, readonly Name: string | null, readonly flair__App_Cat_Download_Or_Connect_Link__c: string | null, readonly flair__App_Cat_Editor__c: string | null, readonly flair__App_Cat_Version__c: string | null, readonly flair__Warranty_Information__c: string | null, readonly flair__Warranty_Date__c: string | null, readonly flair__Vehicle_Cat_Serial_Plate_Number__c: string | null, readonly flair__Vehicle_Cat_Model_Year__c: number | null, readonly flair__Vehicle_Cat_Insurance_policy_number__c: string | null, readonly flair__Vehicle_Cat_Insurance_Company_Contact__c: string | null, readonly flair__Vehicle_Cat_Insurance_Company__c: string | null, readonly flair__Vehicle_Cat_Identification_Number_VIN__c: string | null, readonly flair__Vehicle_Cat_Fuel_Type__c: string | null, readonly flair__Uniform_Cat_Type__c: string | null, readonly flair__Uniform_Cat_Size_System__c: string | null, readonly flair__Uniform_Cat_Size__c: string | null, readonly flair__Electronics_Cat_Operating_System__c: string | null, readonly flair__Notes__c: string | null, readonly flair__Net_Purchase_Price__c: number | null, readonly flair__Purchase_Date__c: string | null, readonly flair__Serial_Number__c: string | null, readonly flair__Approval_Status__c: string | null, readonly CurrencyIsoCode: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly inventory: { readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Manufacturer__c: string | null, readonly flair__Model__c: string | null, readonly flair__Type__c: string | null, readonly flair__Support_Video__c: string | null, readonly flair__Support_Instruction__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly supportAdvisor: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly supplier: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly vehicleCatFuelType: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly electronicsCatOperatingSystem: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly uniformCatSizeSystem: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly uniformCatType: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> };

export type InventoryEmployeeDataFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type InventorySidebarQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type InventorySidebarQuery = { readonly __typename?: 'Query', readonly inventoryItemById: { readonly __typename?: 'InventoryItem', readonly Id: string, readonly Name: string | null, readonly flair__App_Cat_Download_Or_Connect_Link__c: string | null, readonly flair__App_Cat_Editor__c: string | null, readonly flair__App_Cat_Version__c: string | null, readonly flair__Warranty_Information__c: string | null, readonly flair__Warranty_Date__c: string | null, readonly flair__Vehicle_Cat_Serial_Plate_Number__c: string | null, readonly flair__Vehicle_Cat_Model_Year__c: number | null, readonly flair__Vehicle_Cat_Insurance_policy_number__c: string | null, readonly flair__Vehicle_Cat_Insurance_Company_Contact__c: string | null, readonly flair__Vehicle_Cat_Insurance_Company__c: string | null, readonly flair__Vehicle_Cat_Identification_Number_VIN__c: string | null, readonly flair__Vehicle_Cat_Fuel_Type__c: string | null, readonly flair__Uniform_Cat_Type__c: string | null, readonly flair__Uniform_Cat_Size_System__c: string | null, readonly flair__Uniform_Cat_Size__c: string | null, readonly flair__Electronics_Cat_Operating_System__c: string | null, readonly flair__Notes__c: string | null, readonly flair__Net_Purchase_Price__c: number | null, readonly flair__Purchase_Date__c: string | null, readonly flair__Serial_Number__c: string | null, readonly flair__Approval_Status__c: string | null, readonly CurrencyIsoCode: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly inventory: { readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Manufacturer__c: string | null, readonly flair__Model__c: string | null, readonly flair__Type__c: string | null, readonly flair__Support_Video__c: string | null, readonly flair__Support_Instruction__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly supportAdvisor: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly supplier: { readonly __typename?: 'Merchant', readonly Id: string, readonly Name: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly vehicleCatFuelType: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly electronicsCatOperatingSystem: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly uniformCatSizeSystem: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly uniformCatType: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly ContentDocumentLinks: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> } | null };

export type SupportAdvisorFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type AddInventoryMutationVariables = Exact<{
  input: AddInventoryInput;
}>;


export type AddInventoryMutation = { readonly __typename?: 'Mutation', readonly inventory: { readonly __typename?: 'InventoryMutations', readonly addInventory: { readonly __typename?: 'AddInventoryPayload', readonly recordId: string } | null } };

export type AddInventoryItemMutationVariables = Exact<{
  input: AddInventoryItemInput;
}>;


export type AddInventoryItemMutation = { readonly __typename?: 'Mutation', readonly inventory: { readonly __typename?: 'InventoryMutations', readonly addInventoryItem: { readonly __typename?: 'AddInventoryItemPayload', readonly record: { readonly __typename?: 'InventoryItem', readonly Id: string, readonly CurrencyIsoCode: string | null, readonly CreatedDate: string, readonly commentsCount: number, readonly flair__Approval_Status__c: string | null, readonly inventory: { readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Manufacturer__c: string | null, readonly flair__Model__c: string | null, readonly flair__Type__c: string | null, readonly flair__Support_Video__c: string | null, readonly flair__Support_Instruction__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null, readonly supportAdvisor: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Company_Email__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null } } | null } };

export type DictionaryItemsByTypeQueryVariables = Exact<{
  type: DictionaryItemType;
}>;


export type DictionaryItemsByTypeQuery = { readonly __typename?: 'Query', readonly dictionaryItemsByType: ReadonlyArray<{ readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null }> };

export type InventoryCategoryOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryCategoryOptionsQuery = { readonly __typename?: 'Query', readonly inventoryCategories: ReadonlyArray<{ readonly __typename?: 'RecordType', readonly Id: string, readonly DeveloperName: string, readonly Name: string }> };

export type InventoryCategoryOptionsFragment = { readonly __typename?: 'RecordType', readonly Id: string, readonly DeveloperName: string, readonly Name: string };

export type InventoryItemLocationListQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryItemLocationListQuery = { readonly __typename?: 'Query', readonly locations: ReadonlyArray<{ readonly __typename?: 'Location', readonly Id: string, readonly Name: string }> };

export type InventoryItemResponsibleListQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryItemResponsibleListQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> };

export type InventoryOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryOptionsQuery = { readonly __typename?: 'Query', readonly inventories: ReadonlyArray<{ readonly __typename?: 'Inventory', readonly Id: string, readonly Name: string, readonly flair__Model__c: string | null, readonly manufacturer: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null } | null }> };

export type TimeEntryChangeRequestTable_TimeEntryChangeRequestFragment = { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly timeEntryBreak: { readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null } | null }>, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } };

export type PendingTimeEntryChangeRequestsQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type PendingTimeEntryChangeRequestsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly pendingTimeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Break_Period_In_Hours__c: number } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly timeEntryBreak: { readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null } | null }>, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }> } };

export type AnnouncementFragment = { readonly __typename?: 'Announcement', readonly Id: string, readonly Name: string, readonly CreatedDate: string, readonly flair__Published_Date__c: string | null, readonly flair__Announcement_Text__c: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly emojis: ReadonlyArray<{ readonly __typename?: 'AnnouncementEmoji', readonly Id: string, readonly Name: string, readonly flair__Company_Announcement__c: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }> };

export type AnnouncementEmployeeFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type AnnouncementEmojiFragment = { readonly __typename?: 'AnnouncementEmoji', readonly Id: string, readonly Name: string, readonly flair__Company_Announcement__c: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } };

export type CreateAnnouncementEmojiMutationVariables = Exact<{
  input: CreateEmojiInput;
}>;


export type CreateAnnouncementEmojiMutation = { readonly __typename?: 'Mutation', readonly announcements: { readonly __typename?: 'AnnouncementMutations', readonly create: { readonly __typename?: 'AnnouncementEmojiPayload', readonly announcement: { readonly __typename?: 'Announcement', readonly Id: string, readonly emojis: ReadonlyArray<{ readonly __typename?: 'AnnouncementEmoji', readonly Id: string, readonly Name: string, readonly flair__Company_Announcement__c: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }> } } } };

export type DeleteAnnouncementEmojiMutationVariables = Exact<{
  input: DeleteEmojiInput;
}>;


export type DeleteAnnouncementEmojiMutation = { readonly __typename?: 'Mutation', readonly announcements: { readonly __typename?: 'AnnouncementMutations', readonly delete: { readonly __typename?: 'AnnouncementEmojiPayload', readonly announcement: { readonly __typename?: 'Announcement', readonly Id: string, readonly emojis: ReadonlyArray<{ readonly __typename?: 'AnnouncementEmoji', readonly Id: string, readonly Name: string, readonly flair__Company_Announcement__c: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }> } } } };

export type AnnouncementQueryVariables = Exact<{ [key: string]: never; }>;


export type AnnouncementQuery = { readonly __typename?: 'Query', readonly announcements: ReadonlyArray<{ readonly __typename?: 'Announcement', readonly Id: string, readonly Name: string, readonly CreatedDate: string, readonly flair__Published_Date__c: string | null, readonly flair__Announcement_Text__c: string | null, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly emojis: ReadonlyArray<{ readonly __typename?: 'AnnouncementEmoji', readonly Id: string, readonly Name: string, readonly flair__Company_Announcement__c: string, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } }> }> };

export type DirectoryFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectoryFiltersQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> }> };

export type DirectoryQueryVariables = Exact<{
  locations: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  teams: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  departments: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DirectoryQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Location__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }>, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType, readonly referenceTo: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> }> };

export type OrgChartQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgChartQuery = { readonly __typename?: 'Query', readonly orgChartEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly flair__Manager__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Company_Phone_Number__c: string | null, readonly manager: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null }> };

export type FetchDocumentTemplateQueryVariables = Exact<{
  feedbackOutcomeId: Scalars['String']['input'];
}>;


export type FetchDocumentTemplateQuery = { readonly __typename?: 'Query', readonly documentTemplates: { readonly __typename?: 'DocumentTemplates', readonly documentTemplatesForPR: ReadonlyArray<{ readonly __typename?: 'DocumentTemplate', readonly Id: string, readonly Name: string }> } };

export type GenerateAndFetchPdfForPerformanceReviewMutationMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
  requesterType: RequesterType;
}>;


export type GenerateAndFetchPdfForPerformanceReviewMutationMutation = { readonly __typename?: 'Mutation', readonly documentTemplate: { readonly __typename?: 'DocumentTemplateMutations', readonly getDownloadLink: string } };

export type TrackDownloadPdfEventMutationVariables = Exact<{
  input: DownloadPdfAnalyticInput;
}>;


export type TrackDownloadPdfEventMutation = { readonly __typename?: 'Mutation', readonly performanceReview: { readonly __typename?: 'PerformanceReviewMutations', readonly trackDownloadPDFEvent: boolean } };

export type ActiveEmployees_PeerReviewersQueryVariables = Exact<{
  searchTerm: InputMaybe<Scalars['String']['input']>;
}>;


export type ActiveEmployees_PeerReviewersQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> };

export type PerformanceEmployeeEvaluationQueryVariables = Exact<{
  feedbackId: Scalars['String']['input'];
}>;


export type PerformanceEmployeeEvaluationQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly objectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Employee_Feedback_Outcome__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null }> }, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__Self_Evaluation__c: boolean, readonly flair__Submitted_At__c: string | null, readonly CreatedDate: string, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number }, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null, readonly openObjectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Finished_Feedback_Outcome__c: string | null, readonly flair__Rate_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly parent: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | null }>, readonly finishedObjectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Finished_Feedback_Outcome__c: string | null, readonly flair__Rate_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly parent: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | null }> }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Request__c: string, readonly flair__Feedback__c: string | null, readonly flair__Note__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility } }>, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__State__c: EmployeeFeedbackState, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }> } | null, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> } };

export type SubmitEmployeeFeedbackMutationVariables = Exact<{
  input: SubmitEmployeeFeedbackInput;
}>;


export type SubmitEmployeeFeedbackMutation = { readonly __typename?: 'Mutation', readonly submitEmployeeFeedback: string };

export type PeerFeedbackFragment = { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } };

export type CreatePeerReviewersMutationVariables = Exact<{
  input: CreatePeerReviewerInput;
}>;


export type CreatePeerReviewersMutation = { readonly __typename?: 'Mutation', readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedbackMutations', readonly createPeerReviewers: { readonly __typename?: 'PeerReviewerPayload', readonly currentFeedbackRequest: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> } | null } } };

export type DeletePeerReviewersMutationVariables = Exact<{
  input: DeletePeerReviewerInput;
}>;


export type DeletePeerReviewersMutation = { readonly __typename?: 'Mutation', readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedbackMutations', readonly deletePeerReviewers: { readonly __typename?: 'PeerReviewerPayload', readonly currentFeedbackRequest: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> } | null } } };

export type PeerReviewerResponseFragment = { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> };

export type UpdateEmployeeMeetingMutationVariables = Exact<{
  input: UpdateEmployeeMeetingInput;
}>;


export type UpdateEmployeeMeetingMutation = { readonly __typename?: 'Mutation', readonly updateEmployeeMeeting: string };

export type ChangeReviewerMutationVariables = Exact<{
  input: ChangeReviewerInput;
}>;


export type ChangeReviewerMutation = { readonly __typename?: 'Mutation', readonly performanceReview: { readonly __typename?: 'PerformanceReviewMutations', readonly changeReviewer: { readonly __typename?: 'ChangeReviewerPayload', readonly recordId: string } } };

export type EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables = Exact<{
  feedbackId: Scalars['String']['input'];
}>;


export type EmployeePerformanceReviewMeetingComparedFeedbackPageQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string }, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__Self_Evaluation__c: boolean, readonly CreatedDate: string, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null }>, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null }, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__State__c: EmployeeFeedbackState, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }> } | null, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }>, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string }, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> } };

export type UpdateEmployeeFeedbackResolutionMutationVariables = Exact<{
  input: UpdateEmployeeFeedbackResolution;
}>;


export type UpdateEmployeeFeedbackResolutionMutation = { readonly __typename?: 'Mutation', readonly updateEmployeeFeedbackResolution: string };

export type FinishEmployeeFeedbackOutcomeMutationVariables = Exact<{
  input: FinishEmployeeFeedbackOutcomeInput;
}>;


export type FinishEmployeeFeedbackOutcomeMutation = { readonly __typename?: 'Mutation', readonly finishEmployeeFeedbackOutcome: string };

export type EmployeePerformanceReviewCompareFeedbackQueryVariables = Exact<{
  feedbackId: Scalars['String']['input'];
}>;


export type EmployeePerformanceReviewCompareFeedbackQuery = { readonly __typename?: 'Query', readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null }, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string } } };

export type PastEmployeeFeedbackDetailsQueryVariables = Exact<{
  feedbackId: Scalars['String']['input'];
}>;


export type PastEmployeeFeedbackDetailsQuery = { readonly __typename?: 'Query', readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__Self_Evaluation__c: boolean, readonly flair__Submitted_At__c: string | null, readonly CreatedDate: string, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly flair__Ended_At__c: string | null, readonly flair__Completed__c: boolean, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }>, readonly objectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Finished_Feedback_Outcome__c: string | null, readonly flair__Rate_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly parent: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | null }>, readonly finishedObjectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Finished_Feedback_Outcome__c: string | null, readonly flair__Rate_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly parent: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | null }>, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } }, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Submitted_At__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }> } | null, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }>, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> } };

export type DeleteEmployeeObjectiveMutationVariables = Exact<{
  input: DeleteEmployeeObjectiveInput;
}>;


export type DeleteEmployeeObjectiveMutation = { readonly __typename?: 'Mutation', readonly deleteEmployeeObjective: string };

export type ObjectiveQueryVariables = Exact<{
  objectiveId: ObjectiveIdInput;
}>;


export type ObjectiveQuery = { readonly __typename?: 'Query', readonly objective: { readonly __typename?: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | { readonly __typename?: 'EmployeeObjective', readonly flair__Responsible__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'EmployeeObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | { readonly __typename?: 'TeamObjective', readonly flair__Team__c: string, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | null };

export type EmployeeObjectiveDetailsFragment = { readonly __typename?: 'EmployeeObjective', readonly flair__Responsible__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'EmployeeObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> };

export type TeamObjectiveDetailsFragment = { readonly __typename?: 'TeamObjective', readonly flair__Team__c: string, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> };

export type CompanyObjectiveDetailsFragment = { readonly __typename?: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> };

type ObjectiveDetails_CompanyObjective_Fragment = { readonly __typename?: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> };

type ObjectiveDetails_EmployeeObjective_Fragment = { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> };

type ObjectiveDetails_TeamObjective_Fragment = { readonly __typename?: 'TeamObjective', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string }>, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> };

export type ObjectiveDetailsFragment = ObjectiveDetails_CompanyObjective_Fragment | ObjectiveDetails_EmployeeObjective_Fragment | ObjectiveDetails_TeamObjective_Fragment;

export type ObjectiveHistoryItemFragment = { readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type ObjectiveReferenceHistoryItemFragment = { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } };

export type ObjectiveReferenceFragment = { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType };

export type CreateEmployeeObjectiveMutationVariables = Exact<{
  input: CreateEmployeeObjectiveInput;
}>;


export type CreateEmployeeObjectiveMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly createEmployeeObjective: { readonly __typename?: 'CreateEmployeeObjectivePayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly flair__Responsible__c: string | null, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Start_Date__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'EmployeeObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | null } } };

export type CloneEmployeeObjectiveMutationVariables = Exact<{
  input: CloneEmployeeObjectiveInput;
}>;


export type CloneEmployeeObjectiveMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly cloneEmployeeObjective: { readonly __typename?: 'CloneEmployeeObjectivePayload', readonly recordIds: ReadonlyArray<string> | null, readonly error: string | null } } };

export type CreateTeamObjectiveMutationVariables = Exact<{
  input: CreateTeamObjectiveInput;
}>;


export type CreateTeamObjectiveMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly createTeamObjective: { readonly __typename?: 'CreateTeamObjectivePayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly flair__Team__c: string, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Start_Date__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | null } } };

export type UpdateObjectiveStatusMutationVariables = Exact<{
  input: UpdateObjectiveStatusInput;
}>;


export type UpdateObjectiveStatusMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly updateObjectiveStatus: { readonly __typename?: 'UpdateObjectivePayload', readonly record: { readonly __typename?: 'CompanyObjective' } | { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Status_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | { readonly __typename?: 'TeamObjective', readonly Id: string, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Status_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | null } } };

export type UpdateEmployeeObjectiveFieldsMutationVariables = Exact<{
  input: UpdateEmployeeObjectiveFieldsInput;
}>;


export type UpdateEmployeeObjectiveFieldsMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly updateEmployeeObjectiveFields: { readonly __typename?: 'UpdateObjectivePayload', readonly record: { readonly __typename?: 'CompanyObjective' } | { readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly flair__Responsible__c: string | null, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Start_Date__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'EmployeeObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | { readonly __typename?: 'TeamObjective' } | null } } };

export type UpdateTeamObjectiveFieldsMutationVariables = Exact<{
  input: UpdateTeamObjectiveFieldsInput;
}>;


export type UpdateTeamObjectiveFieldsMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly updateTeamObjectiveFields: { readonly __typename?: 'UpdateObjectivePayload', readonly record: { readonly __typename?: 'CompanyObjective' } | { readonly __typename?: 'EmployeeObjective' } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly flair__Team__c: string, readonly flair__Status_Reason__c: string | null, readonly flair__Manual_Progress__c: boolean, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Start_Date__c: string | null, readonly flair__Status__c: ObjectiveStatusType, readonly flair__Objective_Time_Period__c: string | null, readonly CreatedDate: string, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly parentObjective: { readonly __typename?: 'CompanyObjective', readonly Id: string } | { readonly __typename?: 'TeamObjective', readonly Id: string } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null, readonly owner: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly allHistoryItems: ReadonlyArray<{ readonly __typename?: 'ObjectiveHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | { readonly __typename?: 'ObjectiveReferenceHistoryItem', readonly id: string, readonly date: string, readonly requestId: string, readonly changeEvent: ObjectiveReferenceChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly reference: { readonly __typename?: 'ObjectiveHistoryItemReference', readonly itemId: string | null, readonly name: string | null, readonly type: ObjectiveReferenceType } }> } | null } } };

export type DeleteObjectiveMutationVariables = Exact<{
  objectiveId: ObjectiveIdInput;
}>;


export type DeleteObjectiveMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly deleteObjective: { readonly __typename?: 'DeleteObjectivePayload', readonly error: string | null } } };

export type UpdateKeyResultMutationVariables = Exact<{
  objective: ObjectiveIdInput;
  input: UpdateObjectiveKeyResultValueInput;
}>;


export type UpdateKeyResultMutation = { readonly __typename?: 'Mutation', readonly objectives: { readonly __typename?: 'ObjectiveMutations', readonly updateKeyResultValue: { readonly __typename?: 'UpdateObjectiveKeyResultPayload', readonly recordId: string, readonly record: { readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Value__c: number, readonly objective: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly allParents: ReadonlyArray<{ readonly __typename?: 'CompanyObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType } | { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType } | { readonly __typename?: 'TeamObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType }>, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> } | { readonly __typename?: 'TeamObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly allParents: ReadonlyArray<{ readonly __typename?: 'CompanyObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType } | { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType } | { readonly __typename?: 'TeamObjective', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Current_Status__c: ObjectiveCurrentStatusType }>, readonly keyResultUpdates: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> } } | null } } };

export type GoalsContextPeriodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsContextPeriodsQuery = { readonly __typename?: 'Query', readonly activeObjectivePeriods: ReadonlyArray<{ readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null }> };

export type GoalsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsFilterQuery = { readonly __typename?: 'Query', readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly objectivePeriods: ReadonlyArray<{ readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null }> };

export type KeyResultFragment = { readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number };

export type ObjectiveTimePeriodFragment = { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null };

export type ObjectiveTimePeriodPhaseFragment = { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType };

export type DevelopmentFrameworkFragment = { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> };

export type ObjectiveCategoryFragment = { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null };

export type TagFragment = { readonly __typename?: 'Tag', readonly Id: string, readonly Name: string };

export type EmployeeObjectiveColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type EmployeeObjectiveEmployeeFragment = { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type TeamFragment = { readonly __typename?: 'Team', readonly Id: string, readonly Name: string };

export type EmployeeObjectiveFragment = { readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null };

export type TeamObjectiveFragment = { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null };

export type CompanyObjectiveFragment = { readonly __typename: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null };

type Objective_CompanyObjective_Fragment = { readonly __typename: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null };

type Objective_EmployeeObjective_Fragment = { readonly __typename: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null };

type Objective_TeamObjective_Fragment = { readonly __typename: 'TeamObjective', readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null };

export type ObjectiveFragment = Objective_CompanyObjective_Fragment | Objective_EmployeeObjective_Fragment | Objective_TeamObjective_Fragment;

export type KeyResultUpdateFragment = { readonly __typename?: 'ObjectiveKeyResultUpdate', readonly Id: string, readonly flair__Objective_Key_Result__c: string, readonly flair__Previous_Value__c: string | null, readonly flair__Value__c: string | null, readonly flair__Comment__c: string | null, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type GoalsEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsEmployeesQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly allColleagues: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> }, readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } };

export type GoalsDetailSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsDetailSelectOptionsQuery = { readonly __typename?: 'Query', readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }>, readonly objectivePeriods: ReadonlyArray<{ readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null }>, readonly activeObjectivePeriods: ReadonlyArray<{ readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null }>, readonly allObjectives: ReadonlyArray<{ readonly __typename?: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Nested_Goals_Allowed__c: boolean } | { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | { readonly __typename?: 'TeamObjective', readonly Id: string, readonly Name: string }> };

export type GoalsFilterSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsFilterSelectOptionsQuery = { readonly __typename?: 'Query', readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly objectivePeriods: ReadonlyArray<{ readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null }> };

export type MyObjectivesQueryVariables = Exact<{
  filter: ObjectiveFilter;
}>;


export type MyObjectivesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly myObjectives: ReadonlyArray<{ readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null }> } };

export type MyColleaguesObjectivesQueryVariables = Exact<{
  filter: ObjectiveFilter;
}>;


export type MyColleaguesObjectivesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly colleaguesObjectives: ReadonlyArray<{ readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null }> } };

export type AllObjectivesQueryVariables = Exact<{
  filter: ObjectiveFilterManager;
}>;


export type AllObjectivesQuery = { readonly __typename?: 'Query', readonly allObjectives: ReadonlyArray<{ readonly __typename: 'CompanyObjective', readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null }> };

export type MyReportsObjectivesQueryVariables = Exact<{
  filter: ObjectiveFilterManager;
}>;


export type MyReportsObjectivesQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employeesObjectives: ReadonlyArray<{ readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null }> } };

export type MyObjectivesFragment = { readonly __typename?: 'Me', readonly Id: string, readonly myObjectives: ReadonlyArray<{ readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null }> };

export type MyColleaguesObjectivesFragment = { readonly __typename?: 'Me', readonly Id: string, readonly colleaguesObjectives: ReadonlyArray<{ readonly __typename: 'EmployeeObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly responsible: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null } | { readonly __typename: 'TeamObjective', readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly flair__RateAt__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Due_Date__c: string | null, readonly flair__Description__c: string | null, readonly flair__Current_Status__c: ObjectiveCurrentStatusType, readonly flair__Expected_Progress__c: number, readonly flair__On_Track__c: boolean, readonly flair__Visibility__c: ObjectiveVisibility, readonly flair__Progress__c: number, readonly flair__Status_Reason__c: string | null, readonly team: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string }, readonly keyResults: ReadonlyArray<{ readonly __typename?: 'ObjectiveKeyResult', readonly Id: string, readonly Name: string, readonly flair__Type__c: ObjectiveKeyResultType, readonly flair__Initial_Value__c: number, readonly flair__Target_Value__c: number, readonly flair__Current_Value__c: number, readonly flair__Progress__c: number }>, readonly rateBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly sharedWith: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly period: { readonly __typename?: 'ObjectiveTimePeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Active__c: boolean, readonly framework: { readonly __typename?: 'DevelopmentFramework', readonly Id: string, readonly Name: string, readonly categories: ReadonlyArray<{ readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null }> } | null, readonly currentPhase: { readonly __typename?: 'ObjectiveTimePeriodPhase', readonly id: string, readonly name: string, readonly createGoals: ObjectivePhaseActionType, readonly updateGoals: ObjectivePhaseActionType, readonly deleteGoals: ObjectivePhaseActionType, readonly updateWeight: ObjectivePhaseActionType, readonly updateProgress: ObjectivePhaseActionType } | null } | null, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly Id: string, readonly Name: string }>, readonly statusChangedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'ObjectiveCategory', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null } | null }> };

export type AcceptEmployeeFeedbackOutcomeObjectivesMutationVariables = Exact<{
  input: AcceptEmployeeFeedbackOutcomeObjectivesInput;
}>;


export type AcceptEmployeeFeedbackOutcomeObjectivesMutation = { readonly __typename?: 'Mutation', readonly acceptEmployeeFeedbackOutcomeObjectives: string };

export type MyPastPerformanceReviewDetailsQueryVariables = Exact<{
  feedbackId: Scalars['String']['input'];
}>;


export type MyPastPerformanceReviewDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly Name: string, readonly feedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__Submitted_At__c: string | null, readonly flair__Self_Evaluation__c: boolean, readonly CreatedDate: string, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly flair__Ended_At__c: string | null, readonly flair__Completed__c: boolean, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null }>, readonly objectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Finished_Feedback_Outcome__c: string | null, readonly flair__Rate_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly parent: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | null }>, readonly finishedObjectives: ReadonlyArray<{ readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Due_Date__c: string | null, readonly flair__Finished_Feedback_Outcome__c: string | null, readonly flair__Rate_Reason__c: string | null, readonly flair__Rate__c: EmployeeObjectiveRateType | null, readonly parent: { readonly __typename?: 'EmployeeObjective', readonly Id: string, readonly Name: string } | null }> }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }>, readonly managerFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null }>, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string } } | null, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }> } } };

export type ReviewsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewsListQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly feedbacksAsReviewer: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Submitted_At__c: string | null, readonly flair__Progress__c: number, readonly CreatedDate: string, readonly flair__Is_Peer_Reviewer__c: boolean, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Progress__c: number } | null, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Meeting_Required__c: boolean, readonly flair__With_Peers__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly flair__Employee_Feedback_Participant__c: string, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string }, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null }, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }>, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string } }> } };

export type SelfPerformanceEvaluationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SelfPerformanceEvaluationQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly feedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly CreatedDate: string, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Introduction_Text__c: string | null, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Signature_required__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly flair__Ended_At__c: string | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Request__c: string, readonly flair__Feedback__c: string | null, readonly flair__Note__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility } }>, readonly managerFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState } | null } } };

export type SubmitSelfPerformanceEvaluationMutationVariables = Exact<{
  input: SubmitEmployeeFeedbackInput;
}>;


export type SubmitSelfPerformanceEvaluationMutation = { readonly __typename?: 'Mutation', readonly submitEmployeeFeedback: string };

export type EmployeeFeedback_PerformanceReviewFragment = { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly flair__Is_Peer_Reviewer__c: boolean, readonly flair__State__c: EmployeeFeedbackState };

export type FeedbackCycleQuestions_PerformanceReviewFragment = { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility };

export type FeedbackCycle_PerformanceReviewFragment = { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number };

export type MyPerformanceReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPerformanceReviewsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly feedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly flair__Submitted_At__c: string | null, readonly flair__Progress__c: number, readonly flair__Feedback_From__c: string, readonly flair__Deadline__c: string | null, readonly CreatedDate: string, readonly flair__Is_Peer_Reviewer__c: boolean, readonly employeeFeedback: { readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__State__c: EmployeeFeedbackState, readonly CreatedDate: string, readonly flair__Progress__c: number } | null, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__Deadline__c: string | null, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Meeting_Required__c: boolean, readonly flair__With_Peers__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Ended_At__c: string | null, readonly flair__Accepted_At__c: string | null, readonly flair__Employee_Feedback_Participant__c: string, readonly reviewer: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly meeting: { readonly __typename?: 'EmployeeMeeting', readonly Id: string, readonly flair__Start_Datetime__c: string | null } | null }, readonly peerFeedbacks: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedback', readonly Id: string, readonly flair__Progress__c: number, readonly flair__Submitted_At__c: string | null, readonly hasFilledAnswers: boolean, readonly reviewer: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackAnswer', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Note__c: string | null, readonly feedbackAnswer: string | null, readonly flair__Feedback__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean } }>, readonly feedbackCycle: { readonly __typename?: 'FeedbackCycle', readonly Id: string, readonly Name: string, readonly flair__State__c: FeedbackCycleState, readonly flair__Manage_Goals__c: boolean, readonly flair__Meeting_Required__c: boolean, readonly flair__Signature_required__c: boolean, readonly flair__See_All_Questions__c: boolean, readonly flair__Timeline_Type__c: FeedbackCycleTimelineTypes, readonly flair__Number_of_Peers__c: number, readonly flair__With_Peers__c: boolean, readonly flair__Without_Reviewer__c: boolean, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'FeedbackQuestion', readonly Id: string, readonly flair__Employee_Feedback_Question_Section__c: string | null, readonly flair__Section_Name__c: string | null, readonly flair__Is_Satisfaction_Section__c: boolean | null, readonly flair__Question__c: string | null, readonly flair__Description__c: string | null, readonly flair__Choices__c: ReadonlyArray<string>, readonly flair__Feedback_Question_Type__c: FeedbackQuestionType, readonly flair__Optional__c: boolean, readonly flair__Optional_Comment__c: boolean, readonly flair__Position__c: number, readonly flair__Required_Choice__c: ReadonlyArray<string>, readonly flair__Hint__c: string | null, readonly flair__Answer_Visibility__c: FeedbackAnswerVisibility, readonly flair__Feedback_Question_Visibility__c: FeedbackQuestionVisibility }> }, readonly outcome: { readonly __typename?: 'EmployeeFeedbackOutcome', readonly Id: string, readonly flair__Accepted_At__c: string | null, readonly resolutions: ReadonlyArray<{ readonly __typename?: 'EmployeeFeedbackResolution', readonly Id: string, readonly flair__Employee_Feedback_Question__c: string, readonly flair__Resolution__c: string | null, readonly question: { readonly __typename?: 'FeedbackQuestion', readonly flair__Question__c: string | null } }> } }>, readonly reviewee: { readonly __typename?: 'EmployeeFeedbackParticipant', readonly Id: string, readonly Name: string } }> } };

export type PersonalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalDataQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly flair__Hide_My_Birthday__c: boolean | null, readonly data: { readonly __typename?: 'EmployeeData', readonly employeeId: string, readonly sections: ReadonlyArray<{ readonly __typename?: 'EmployeeDataSection', readonly employeeId: string, readonly label: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }>, readonly relatedLists: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedList', readonly label: string, readonly objectType: string, readonly records: ReadonlyArray<{ readonly __typename?: 'EmployeeDataRelatedListRecord', readonly id: string, readonly fields: ReadonlyArray<{ readonly __typename?: 'EmployeeDataField', readonly parentId: string, readonly employeeId: string, readonly value: string | null, readonly oldValue: string | null, readonly state: EmployeeDataFieldState, readonly pendingApproval: boolean, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> }> }> } } };

export type ProjectFieldsFragment = { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Description__c: string | null, readonly flair__Billable__c: boolean, readonly flair__Estimation__c: number | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly timeTracked: number };

export type ProjectHistoryItemFragment = { readonly __typename?: 'ProjectHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changeEvent: ChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null } | null };

export type ProjectColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null };

export type ProjectTimesheetFieldsFragment = { readonly __typename?: 'MyTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly projectTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean }>, readonly paidAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null }>, readonly calendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean }> };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutations', readonly updateProject: { readonly __typename?: 'UpdateProjectPayload', readonly record: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Description__c: string | null, readonly flair__Billable__c: boolean, readonly flair__Estimation__c: number | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly timeTracked: number, readonly historyItems: ReadonlyArray<{ readonly __typename?: 'ProjectHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changeEvent: ChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null } | null }> } | null } } };

export type ProjectsTimeSheetFiltersQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type ProjectsTimeSheetFiltersQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }>, readonly pendingTimeSheets: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Project__c: string | null, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string } | null }> }> } };

export type ProjectsTimeSheetDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  projectTimeEntriesFilter: ProjectTimeEntriesFilterInput;
}>;


export type ProjectsTimeSheetDetailsQuery = { readonly __typename?: 'Query', readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly targetMinutes: number, readonly day: string, readonly holidayMinutes: number, readonly absenceMinutes: number, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }>, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Project__c: string | null, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null }> } };

export type ProjectsTimeSheetDetailsFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly targetMinutes: number, readonly day: string, readonly holidayMinutes: number, readonly absenceMinutes: number, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }>, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Project__c: string | null, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null }> };

export type ProjectsTimeSheetDaySubRowTrackedTimeDayFragment = { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly targetMinutes: number, readonly day: string, readonly holidayMinutes: number, readonly absenceMinutes: number, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> };

export type ProjectsTimeSheetDaySubRowTimeSheetDayFragment = { readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null };

export type ProjectsTimeSheetDaySubRowsFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly targetMinutes: number, readonly day: string, readonly holidayMinutes: number, readonly absenceMinutes: number, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }>, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Project__c: string | null, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null }> };

export type ProjectsTimeSheetTableFragment = { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Project_Time_Entries_Minutes__c: number, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }>, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Project__c: string | null, readonly flair__Notes__c: string | null, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null }> };

export type ProjectsTimeSheetTableProjectFragment = { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number };

export type ProjectsTimeSheetTableProjectTimeEntryFragment = { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Project__c: string | null, readonly flair__Notes__c: string | null, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null };

export type ProjectsTimeSheetDetailsPrefetchQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  projectTimeEntriesFilter: ProjectTimeEntriesFilterInput;
}>;


export type ProjectsTimeSheetDetailsPrefetchQuery = { readonly __typename?: 'Query', readonly timeSheets: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly targetMinutes: number, readonly day: string, readonly holidayMinutes: number, readonly absenceMinutes: number, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }>, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Project__c: string | null, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null }> }> };

export type TimeSheetsControllingProjectsQueryVariables = Exact<{
  filter: TimeSheetFilterInput;
  sort: InputMaybe<ReadonlyArray<TimeSheetSortInput> | TimeSheetSortInput>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
  projectTimeEntriesFilter: ProjectTimeEntriesFilterInput;
}>;


export type TimeSheetsControllingProjectsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly timeSheetsPagination: { readonly __typename?: 'TimeSheetPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Project_Time_Entries_Minutes__c: number, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Project_Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null }>, readonly projectsTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Project__c: string | null, readonly flair__Notes__c: string | null, readonly flair__Minutes__c: number | null, readonly flair__Date__c: string, readonly project: { readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly flair__Estimation__c: number | null, readonly flair__Billable__c: boolean, readonly timeTracked: number } | null }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type ProjectsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsOverviewQuery = { readonly __typename?: 'Query', readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Description__c: string | null, readonly flair__Billable__c: boolean, readonly flair__Estimation__c: number | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly timeTracked: number, readonly historyItems: ReadonlyArray<{ readonly __typename?: 'ProjectHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changeEvent: ChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null } | null }> }> };

export type ProjectTimesheetEntryFragment = { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } };

export type SaveProjectTimeEntriesByDaysMutationVariables = Exact<{
  input: SaveProjectTimeEntriesByDaysInput;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type SaveProjectTimeEntriesByDaysMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutations', readonly saveProjectTimeEntriesByDays: { readonly __typename?: 'SaveProjectTimeEntriesPayload', readonly query: { readonly __typename?: 'Query', readonly myTimeSheets: ReadonlyArray<{ readonly __typename?: 'MyTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly projectTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean }>, readonly paidAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null }>, readonly calendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean }> }> } } } };

export type SaveProjectTimeEntriesByProjectsMutationVariables = Exact<{
  input: SaveProjectTimeEntriesByProjectsInput;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type SaveProjectTimeEntriesByProjectsMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutations', readonly saveProjectTimeEntriesByProjects: { readonly __typename?: 'SaveProjectTimeEntriesPayload', readonly query: { readonly __typename?: 'Query', readonly myTimeSheets: ReadonlyArray<{ readonly __typename?: 'MyTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly projectTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean }>, readonly paidAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null }>, readonly calendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean }> }> } } } };

export type ProjectsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type ProjectsQuery = { readonly __typename?: 'Query', readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Description__c: string | null, readonly flair__Billable__c: boolean, readonly flair__Estimation__c: number | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly timeTracked: number, readonly historyItems: ReadonlyArray<{ readonly __typename?: 'ProjectHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changeEvent: ChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null } | null }> }>, readonly costCenters: ReadonlyArray<{ readonly __typename?: 'CostCenter', readonly Id: string, readonly Name: string, readonly flair__Code__c: string }>, readonly myTimeSheets: ReadonlyArray<{ readonly __typename?: 'MyTimeSheet', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Approval_Status__c: TimeSheetStatus, readonly projectTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Notes__c: string | null }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly calendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean }>, readonly paidAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly flair__Time_Entries_Minutes__c: number, readonly commentsCount: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null }> }> };

export type AllReceivedChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllReceivedChangeRequestsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly shiftChangeRequestsToMe: ReadonlyArray<{ readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null }> } };

export type RespondToShiftChangeRequestMutationVariables = Exact<{
  input: RespondToShiftChangeRequestInput;
}>;


export type RespondToShiftChangeRequestMutation = { readonly __typename?: 'Mutation', readonly shiftChangeRequest: { readonly __typename?: 'ShiftChangeRequestMutations', readonly respondToShiftChangeRequest: { readonly __typename?: 'RespondToShiftChangeRequestPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null } | null } } };

export type CancelShiftChangeRequestMutationVariables = Exact<{
  input: CancelShiftChangeRequestInput;
}>;


export type CancelShiftChangeRequestMutation = { readonly __typename?: 'Mutation', readonly shiftChangeRequest: { readonly __typename?: 'ShiftChangeRequestMutations', readonly cancelShiftChangeRequest: { readonly __typename?: 'CancelShiftChangeRequestPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly shiftChangeRequestsFromMe: ReadonlyArray<{ readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null }> } } } } };

export type ShiftChangeRequestFragmentFragment = { readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null };

export type ShiftChangeRequestsByShiftIdQueryVariables = Exact<{
  shiftId: Scalars['String']['input'];
}>;


export type ShiftChangeRequestsByShiftIdQuery = { readonly __typename?: 'Query', readonly schedulerShift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Employee_Notes__c: string | null, readonly flair__Resource_Employee__c: string | null, readonly flair__Allow_Shift_Transfer__c: boolean | null, readonly flair__Min_Days_Before_Shift_Transfer__c: number | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'ShiftBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string }>, readonly shiftLabels: ReadonlyArray<{ readonly __typename?: 'ShiftLabel', readonly Id: string, readonly Name: string, readonly flair__Tag_Name__c: string }>, readonly shiftChangeRequests: ReadonlyArray<{ readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null }> } | null };

export type CreateShiftChangeRequestMutationVariables = Exact<{
  input: CreateShiftChangeRequestInput;
}>;


export type CreateShiftChangeRequestMutation = { readonly __typename?: 'Mutation', readonly shiftChangeRequest: { readonly __typename?: 'ShiftChangeRequestMutations', readonly createShiftChangeRequest: { readonly __typename?: 'CreateShiftChangeRequestPayload', readonly recordId: string | null, readonly record: { readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Pending_Change_Requests_Count__c: number | null, readonly shiftChangeRequests: ReadonlyArray<{ readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null }> } } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly shiftChangeRequestsFromMe: ReadonlyArray<{ readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null }> } } } } };

export type GetShiftChangeRequestSuggestionEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShiftChangeRequestSuggestionEmployeesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly allColleagues: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> } };

export type SchedulerShiftsListQueryVariables = Exact<{
  filter: ShiftFilterInput;
}>;


export type SchedulerShiftsListQuery = { readonly __typename?: 'Query', readonly schedulerShifts: ReadonlyArray<{ readonly __typename?: 'Shift', readonly Id: string, readonly Name: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Total_Break_Period_in_Minutes__c: number | null, readonly flair__Employee_Notes__c: string | null, readonly flair__Linked_Resource_Id__c: string, readonly flair__Linked_Resource_Object__c: string, readonly flair__Linked_Target_Id__c: string, readonly flair__Linked_Target_Object__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null, readonly location: { readonly __typename?: 'Location', readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Name: string } | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'ShiftBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string }>, readonly shiftLabels: ReadonlyArray<{ readonly __typename?: 'ShiftLabel', readonly Id: string, readonly Name: string, readonly flair__Tag_Name__c: string }> }> };

export type AllSentShiftChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSentShiftChangeRequestsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly shiftChangeRequestsFromMe: ReadonlyArray<{ readonly __typename?: 'ShiftChangeRequest', readonly Id: string, readonly flair__Approval_Status__c: ShiftChangeRequestApprovalStatus, readonly flair__Approval_Status_Changed_At__c: string | null, readonly flair__Change_Reason__c: string | null, readonly flair__Request_Type__c: ShiftChangeRequestType, readonly flair__Requested_At__c: string, readonly flair__Colleague_Approval_Status__c: ShiftChangeRequestColleagueApprovalStatus | null, readonly flair__Colleague_Responded_At__c: string | null, readonly flair__Approval_Status_Detailed__c: ShiftChangeRequestDetailedStatus, readonly shift: { readonly __typename?: 'Shift', readonly Id: string, readonly flair__Title__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string, readonly flair__Pending_Change_Requests_Count__c: number | null }, readonly proposedResourceEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null, readonly requestedByEmployee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string } | null }> } };

export type CustomerSupportQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerSupportQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly customerSupport: { readonly __typename?: 'CustomerSupport', readonly supportAccess: boolean } } };

export type UpdateCustomerSupportMutationVariables = Exact<{
  input: CustomerSupportInput;
}>;


export type UpdateCustomerSupportMutation = { readonly __typename?: 'Mutation', readonly updateCustomerSupport: { readonly __typename?: 'UpdateCustomerSupportPayload', readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly customerSupport: { readonly __typename?: 'CustomerSupport', readonly supportAccess: boolean } } } } };

export type EmployeeNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeNotificationSettingsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly notificationSettings: { readonly __typename?: 'EmployeeNotificationSetting', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__ApprovedAbsence_Email__c: boolean, readonly flair__ApprovedAbsence_Slack__c: boolean, readonly flair__ApprovedAbsence_Push__c: boolean, readonly flair__NewAbsenceApprovalRequest_Email__c: boolean, readonly flair__NewAbsenceApprovalRequest_Slack__c: boolean, readonly flair__NewAbsenceApprovalRequest_Push__c: boolean, readonly flair__RejectedAbsence_Email__c: boolean, readonly flair__RejectedAbsence_Slack__c: boolean, readonly flair__RejectedAbsence_Push__c: boolean, readonly flair__OpenShiftRequest_Email__c: boolean, readonly flair__OpenShiftRequest_Push__c: boolean, readonly flair__OpenShiftRequestCreated_Email__c: boolean, readonly flair__OpenShiftRequestCreated_Push__c: boolean, readonly flair__TimeTrackingAutoClockOut_Email__c: boolean, readonly flair__TimeTrackingAutoClockOutManager_Email__c: boolean, readonly flair__OpenShiftsPublished_Email__c: boolean, readonly flair__OpenShiftsPublished_Push__c: boolean, readonly flair__EmployeeShiftsPublished_Email__c: boolean, readonly flair__EmployeeShiftsPublished_Push__c: boolean, readonly flair__TimesheetApproved_Slack__c: boolean, readonly flair__TimesheetPendingWeekly_Slack__c: boolean, readonly flair__TimeEntryAdded_Slack__c: boolean, readonly flair__TimeEntryDeleted_Email__c: boolean, readonly flair__TimeEntryDeleted_Slack__c: boolean, readonly flair__NewTimeEntryChangeRequest_Email__c: boolean, readonly flair__TimeEntryChangesApproved_Email__c: boolean, readonly flair__TimeEntryChangesApproved_Slack__c: boolean, readonly flair__TimeEntryChangesRejected_Slack__c: boolean, readonly flair__EmployeeDataChanges_Email__c: boolean, readonly flair__EmployeeDataChanges_Push__c: boolean, readonly flair__EmployeeFeedbackNotification_Email__c: boolean, readonly flair__EmployeeFeedbackNotification_Push__c: boolean, readonly flair__EmployeeUpload_Email__c: boolean, readonly flair__EmployeeUpload_Push__c: boolean, readonly flair__NewEmployeeDocument_Email__c: boolean, readonly flair__NewEmployeeDocument_Push__c: boolean, readonly flair__InformHiringManager_Email__c: boolean, readonly flair__CandidateEvaluation_Email__c: boolean, readonly flair__CandidateEvaluated_Email__c: boolean, readonly flair__DeletedAbsence_Email__c: boolean, readonly flair__DeletedAbsence_Push__c: boolean, readonly flair__NewAbsence_Email__c: boolean, readonly flair__PfReviewMeetingAttendee_Email__c: boolean, readonly flair__PfReviewMeetingOrganizer_Email__c: boolean, readonly flair__FC_EmployeeReviewSubmitted_Email__c: boolean, readonly flair__FC_ReviewerReviewSubmitted_Email__c: boolean, readonly flair__CelebrationReceived_Email__c: boolean, readonly flair__CelebrationReceived_Slack__c: boolean, readonly flair__PendingWorkflowItems_Email__c: boolean, readonly flair__PendingWorkflowItems_Slack__c: boolean, readonly flair__ExpiringWorkflowItems_Email__c: boolean, readonly flair__ExpiringWorkflowItems_Slack__c: boolean, readonly flair__CommentCreated_Email__c: boolean, readonly flair__CommentCreated_Slack__c: boolean, readonly flair__TicketSubmitted_Email__c: boolean, readonly flair__TicketAssigned_Email__c: boolean, readonly flair__TicketStatusChanged_Email__c: boolean, readonly flair__TicketShared_Email__c: boolean, readonly flair__TicketClosed_Email__c: boolean, readonly flair__TimeBalanceWithdrawalCreated_Email__c: boolean } } };

export type UpdateEmployeeNotificationSettingsMutationVariables = Exact<{
  input: EmployeeNotificationSettingsInput;
}>;


export type UpdateEmployeeNotificationSettingsMutation = { readonly __typename?: 'Mutation', readonly updateEmployeeNotificationSettings: string };

export type SetSlackStatusAutoUpdateMutationVariables = Exact<{
  autoUpdate: Scalars['Boolean']['input'];
}>;


export type SetSlackStatusAutoUpdateMutation = { readonly __typename?: 'Mutation', readonly slack: { readonly __typename?: 'SlackMutations', readonly setSlackStatusAutoUpdate: { readonly __typename?: 'SlackStatusAutoUpdatePayload', readonly query: { readonly __typename?: 'Query', readonly slack: { readonly __typename?: 'SlackInfo', readonly employeeSlackConnection: { readonly __typename?: 'EmployeeSlackConnection', readonly employeeId: string, readonly slackStatusAutoUpdate: boolean } | null } } | null } } };

export type SlackStatusAutoUpdateSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SlackStatusAutoUpdateSettingsQuery = { readonly __typename?: 'Query', readonly slack: { readonly __typename?: 'SlackInfo', readonly orgHasSlackEnabled: boolean, readonly employeeSlackConnection: { readonly __typename?: 'EmployeeSlackConnection', readonly employeeId: string, readonly slackUserId: string, readonly userScopes: ReadonlyArray<string>, readonly slackStatusAutoUpdate: boolean } | null } };

export type SlackStatusAutoUpdateSettings_SlackInfoFragment = { readonly __typename?: 'SlackInfo', readonly orgHasSlackEnabled: boolean, readonly employeeSlackConnection: { readonly __typename?: 'EmployeeSlackConnection', readonly employeeId: string, readonly slackUserId: string, readonly userScopes: ReadonlyArray<string>, readonly slackStatusAutoUpdate: boolean } | null };

export type EmployeeSkillAssociationFragment = { readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } };

export type EmployeeSkillsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmployeeSkillsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employee: { readonly __typename?: 'Employee', readonly Id: string } | null }, readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> }>, readonly skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }> };

export type CreatedByColleagueFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type SkillFragment = { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type SkillNamesFragment = { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string };

export type SkillNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillNamesQuery = { readonly __typename?: 'Query', readonly skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string }> };

export type UpdateSkillTopMutationVariables = Exact<{
  input: UpdateSkillTopInput;
}>;


export type UpdateSkillTopMutation = { readonly __typename?: 'Mutation', readonly employeeSkills: { readonly __typename?: 'EmployeeSkillMutations', readonly updateSkillTop: { readonly __typename?: 'UpdateEmployeeSkillPayload', readonly error: string | null, readonly record: { readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Top__c: boolean } | null } } };

export type UpdateSkillTopResponseFragment = { readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Top__c: boolean };

export type ManagerSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type ManagerSkillsQuery = { readonly __typename?: 'Query', readonly skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Employee__c: string }> }> };

export type ManagerSkillFragment = { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Employee__c: string }> };

export type CreateSkillMutationVariables = Exact<{
  input: CreateSkillInput;
}>;


export type CreateSkillMutation = { readonly __typename?: 'Mutation', readonly skills: { readonly __typename?: 'SkillMutations', readonly createSkill: { readonly __typename?: 'SkillPayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Employee__c: string }> }> } } } };

export type UpdateSkillMutationVariables = Exact<{
  input: UpdateSkillInput;
}>;


export type UpdateSkillMutation = { readonly __typename?: 'Mutation', readonly skills: { readonly __typename?: 'SkillMutations', readonly updateSkill: { readonly __typename?: 'SkillPayload', readonly recordId: string | null, readonly error: string | null, readonly record: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Employee__c: string }> } | null } } };

export type DeleteSkillMutationVariables = Exact<{
  input: DeleteSkillInput;
}>;


export type DeleteSkillMutation = { readonly __typename?: 'Mutation', readonly skills: { readonly __typename?: 'SkillMutations', readonly deleteSkill: { readonly __typename?: 'SkillPayload', readonly error: string | null, readonly query: { readonly __typename?: 'Query', readonly skills: ReadonlyArray<{ readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Employee__c: string }> }> } } } };

export type AddEmployeeSkillMutationVariables = Exact<{
  input: AddSkillToEmployeeInput;
}>;


export type AddEmployeeSkillMutation = { readonly __typename?: 'Mutation', readonly employeeSkills: { readonly __typename?: 'EmployeeSkillMutations', readonly addSkill: { readonly __typename?: 'UpdateEmployeeSkillPayload', readonly error: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } | null, readonly colleague: { readonly __typename?: 'Colleague', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } } } } };

export type RemoveEmployeeSkillMutationVariables = Exact<{
  input: RemoveSkillFromEmployeeInput;
}>;


export type RemoveEmployeeSkillMutation = { readonly __typename?: 'Mutation', readonly employeeSkills: { readonly __typename?: 'EmployeeSkillMutations', readonly removeSkill: { readonly __typename?: 'UpdateEmployeeSkillPayload', readonly error: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } | null, readonly colleague: { readonly __typename?: 'Colleague', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } } } } };

export type UpdateSkillRateMutationVariables = Exact<{
  input: UpdateSkillRateInput;
}>;


export type UpdateSkillRateMutation = { readonly __typename?: 'Mutation', readonly employeeSkills: { readonly __typename?: 'EmployeeSkillMutations', readonly updateSkillRate: { readonly __typename?: 'UpdateEmployeeSkillPayload', readonly error: string | null, readonly record: { readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean } | null } } };

export type UpdateSkillRateResponseFragment = { readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean };

export type ReloadAllEmployeeSkillsPayloadFragment = { readonly __typename?: 'UpdateEmployeeSkillPayload', readonly error: string | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } | null, readonly colleague: { readonly __typename?: 'Colleague', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } | null, readonly query: { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Top__c: boolean, readonly flair__Skill__c: string, readonly flair__Employee__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string, readonly flair__Rateable__c: boolean, readonly CreatedDate: string, readonly createdBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } }> } } };

export type EmployeeSkillsMatrixQueryVariables = Exact<{
  employeeIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EmployeeSkillsMatrixQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Skill__c: string, readonly flair__Employee__c: string }> }> };

export type AllActiveEmployeesMatrixQueryVariables = Exact<{ [key: string]: never; }>;


export type AllActiveEmployeesMatrixQuery = { readonly __typename?: 'Query', readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> };

export type MySubordinatesSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySubordinatesSkillsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Skill__c: string, readonly flair__Employee__c: string }>, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } };

export type EmployeeSkillMatrixFragment = { readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Rate__c: number | null, readonly flair__Skill__c: string, readonly flair__Employee__c: string };

export type EmployeeAuthorizeUrlMutationVariables = Exact<{
  userScopes: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  successRedirectUrl: Scalars['String']['input'];
}>;


export type EmployeeAuthorizeUrlMutation = { readonly __typename?: 'Mutation', readonly slack: { readonly __typename?: 'SlackMutations', readonly employeeAuthorizeUrl: { readonly __typename?: 'SlackInstallationResponse', readonly installationUri: string } } };

export type CreateSlackInstallationMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSlackInstallationMutation = { readonly __typename?: 'Mutation', readonly slack: { readonly __typename?: 'SlackMutations', readonly slackAppAuthorizeUrl: { readonly __typename?: 'SlackInstallationResponse', readonly installationUri: string } } };

export type UpdateSlackUserMutationVariables = Exact<{
  slackUser: Scalars['String']['input'];
}>;


export type UpdateSlackUserMutation = { readonly __typename?: 'Mutation', readonly slack: { readonly __typename?: 'SlackMutations', readonly connectToSlackUser: { readonly __typename?: 'UpdateSlackUserPayload', readonly result: UpdateSlackUserResult } } };

export type CloseTicketMutationVariables = Exact<{
  input: CloseTicketInput;
}>;


export type CloseTicketMutation = { readonly __typename?: 'Mutation', readonly ticket: { readonly __typename?: 'TicketMutations', readonly closeTicket: { readonly __typename?: 'CloseTicketPayload', readonly record: { readonly __typename?: 'Ticket', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Status__c: string, readonly flair__Closing_Reason__c: string | null, readonly flair__Details__c: string | null, readonly flair__Priority__c: string | null, readonly flair__Ticket_Number__c: number, readonly flair__Anonymous__c: boolean, readonly flair__Visibility__c: TicketVisibility, readonly flair__Employee__c: string | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } | null } | null } };

export type TicketFilterQueryVariables = Exact<{
  type: DictionaryItemType;
}>;


export type TicketFilterQuery = { readonly __typename?: 'Query', readonly dictionaryItemsByType: ReadonlyArray<{ readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }>, readonly activeEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> };

export type CreateTicketMutationVariables = Exact<{
  input: CreateTicketInput;
}>;


export type CreateTicketMutation = { readonly __typename?: 'Mutation', readonly ticket: { readonly __typename?: 'TicketMutations', readonly createTicket: { readonly __typename?: 'CreateTicketPayload', readonly record: { readonly __typename?: 'Ticket', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Status__c: string, readonly flair__Closing_Reason__c: string | null, readonly flair__Details__c: string | null, readonly flair__Priority__c: string | null, readonly flair__Ticket_Number__c: number, readonly flair__Anonymous__c: boolean, readonly flair__Visibility__c: TicketVisibility, readonly flair__Employee__c: string | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } } | null } };

export type TicketPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketPolicyQuery = { readonly __typename?: 'Query', readonly ticketPolicy: { readonly __typename?: 'TicketPolicy', readonly Id: string, readonly Name: string, readonly flair__Category_Key__c: string | null, readonly flair__Ticket_Visibility__c: string, readonly flair__Whistleblower_Active__c: boolean } };

export type TicketPolicyDataFragment = { readonly __typename?: 'TicketPolicy', readonly Id: string, readonly Name: string, readonly flair__Category_Key__c: string | null, readonly flair__Ticket_Visibility__c: string, readonly flair__Whistleblower_Active__c: boolean };

export type TicketCategoriesQueryVariables = Exact<{
  type: DictionaryItemType;
}>;


export type TicketCategoriesQuery = { readonly __typename?: 'Query', readonly dictionaryItemsByType: ReadonlyArray<{ readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }> };

export type TicketEmployeeOptionsQueryVariables = Exact<{
  managerReportsType: ManagerReportsType;
}>;


export type TicketEmployeeOptionsQuery = { readonly __typename?: 'Query', readonly manager: { readonly __typename?: 'Manager', readonly Id: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } };

export type ManagerEmployeeDataFragment = { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type TicketSubjectsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TicketSubjectsQuery = { readonly __typename?: 'Query', readonly dictionaryItemsByParent: ReadonlyArray<{ readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }> };

export type TicketEmployeeDataFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type TicketListQueryVariables = Exact<{
  filter: TicketFilterInput;
  sort: InputMaybe<TicketSortInput>;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
  anonymousTicketIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TicketListQuery = { readonly __typename?: 'Query', readonly ticketPagination: { readonly __typename?: 'TicketPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Ticket', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Status__c: string, readonly flair__Closing_Reason__c: string | null, readonly flair__Details__c: string | null, readonly flair__Priority__c: string | null, readonly flair__Ticket_Number__c: number, readonly flair__Anonymous__c: boolean, readonly flair__Visibility__c: TicketVisibility, readonly flair__Employee__c: string | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } };

export type TicketListDataFragment = { readonly __typename?: 'Ticket', readonly Id: string, readonly Name: string, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Status__c: string, readonly flair__Closing_Reason__c: string | null, readonly flair__Details__c: string | null, readonly flair__Priority__c: string | null, readonly flair__Ticket_Number__c: number, readonly flair__Anonymous__c: boolean, readonly flair__Visibility__c: TicketVisibility, readonly flair__Employee__c: string | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type TicketSidebarQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TicketSidebarQuery = { readonly __typename?: 'Query', readonly ticketById: { readonly __typename?: 'Ticket', readonly Id: string, readonly flair__Status__c: string, readonly flair__Ticket_Number__c: number, readonly flair__Closing_Reason__c: string | null, readonly flair__Visibility__c: TicketVisibility, readonly flair__Anonymous__c: boolean, readonly flair__Details__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Employee__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null } };

export type TicketSidebarDataFragment = { readonly __typename?: 'Ticket', readonly Id: string, readonly flair__Status__c: string, readonly flair__Ticket_Number__c: number, readonly flair__Closing_Reason__c: string | null, readonly flair__Visibility__c: TicketVisibility, readonly flair__Anonymous__c: boolean, readonly flair__Details__c: string | null, readonly LastModifiedDate: string, readonly CreatedDate: string, readonly flair__Employee__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly category: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string }, readonly subject: { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string } | null, readonly assignee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null };

export type TicketsDictionaryDataFragment = { readonly __typename?: 'DictionaryItem', readonly Id: string, readonly Name: string, readonly label: string | null, readonly flair__Key__c: string };

export type TimeSheetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TimeSheetQuery = { readonly __typename?: 'Query', readonly costCenters: ReadonlyArray<{ readonly __typename?: 'CostCenter', readonly Id: string, readonly Name: string }>, readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Description__c: string | null, readonly flair__Billable__c: boolean, readonly flair__Estimation__c: number | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly timeTracked: number, readonly historyItems: ReadonlyArray<{ readonly __typename?: 'ProjectHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changeEvent: ChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null } | null }> }>, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Absence_Hours__c: number, readonly flair__Holiday_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Non_Deductible_Absence_Hours__c: number | null, readonly flair__Type__c: WorkloadType, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly previousTimeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string } | null, readonly nextTimeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string } | null, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string | null, readonly flair__Company_Email__c: string | null, readonly flair__Position__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly currentTimeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string } | null }, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Type__c: WorkloadType, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly workloadWeeks: ReadonlyArray<{ readonly __typename?: 'WorkloadWeek', readonly Id: string, readonly monday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly tuesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly wednesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly thursday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly friday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly saturday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly sunday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null } }>, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }>, readonly paidAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly calendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> } } };

export type DeleteTimeEntryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTimeEntryMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly deleteTimeEntry: { readonly __typename?: 'DeleteTimeEntryPayload', readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Target_Hours__c: number, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly dayStartDateTime: string, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> } | null } } };

export type UpdateMyTimeEntryNotesMutationVariables = Exact<{
  input: UpdateMyTimeEntryNotesInput;
}>;


export type UpdateMyTimeEntryNotesMutation = { readonly __typename?: 'Mutation', readonly updateMyTimeEntryNotes: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Notes__c: string | null } };

export type TimeEntryTimeSheetFieldsFragment = { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> };

export type TimeSheetTimeEntriesFragment = { readonly __typename?: 'TimeSheet', readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Target_Hours__c: number, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> };

export type EmployeeTimeSheetsQueryVariables = Exact<{
  filter: EmployeeTimeSheetFilterInput;
  sort: InputMaybe<ReadonlyArray<TimeSheetSortInput> | TimeSheetSortInput>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type EmployeeTimeSheetsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly timeSheetsPagination: { readonly __typename?: 'TimeSheetPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Time_Entries_Hours_Diff__c: number, readonly workedHours: number, readonly employee: { readonly __typename?: 'Employee', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }, readonly warnings: ReadonlyArray<{ readonly __typename?: 'TimeSheetWarning', readonly id: string, readonly message: string }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } };

export type TimeSheetDayProjectTimeEntryFragment = { readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } };

type TimeTrackingError_TimeLimitErrorMaxDailyLimitExceeded_Fragment = { readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string };

type TimeTrackingError_TimeTrackingError_Fragment = { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string };

export type TimeTrackingErrorFragment = TimeTrackingError_TimeLimitErrorMaxDailyLimitExceeded_Fragment | TimeTrackingError_TimeTrackingError_Fragment;

export type TimeTrackingWarningFragment = { readonly __typename?: 'TimeLimitWarningMaxDailyLimit', readonly warningCode: TimeTrackingWarningCode, readonly allowedTimeInMin: number, readonly alreadyTrackedInMin: number, readonly leftToTrackInMin: number, readonly autoClockOut: boolean };

export type CurrentTimeEntryFragment = { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly location: { readonly __typename?: 'MyLocation', readonly Name: string } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> };

export type MyTimeSheetQueryVariables = Exact<{
  employeeId: Scalars['String']['input'];
  day: Scalars['LocalDate']['input'];
}>;


export type MyTimeSheetQuery = { readonly __typename?: 'Query', readonly costCenters: ReadonlyArray<{ readonly __typename?: 'CostCenter', readonly Id: string, readonly Name: string, readonly flair__Code__c: string }>, readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly Id: string, readonly flair__Name__c: string, readonly flair__Description__c: string | null, readonly flair__Billable__c: boolean, readonly flair__Estimation__c: number | null, readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly timeTracked: number, readonly historyItems: ReadonlyArray<{ readonly __typename?: 'ProjectHistoryItem', readonly id: string, readonly fieldApiName: string, readonly oldValue: string | null, readonly newValue: string | null, readonly date: string, readonly requestId: string, readonly changeEvent: ChangeEvent, readonly changedBy: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null } | null }> }>, readonly timeSheetDay: { readonly __typename?: 'TimeSheetDay', readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }>, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly previousTimeSheetStartDay: string, readonly nextTimeSheetStartDay: string, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number }> }, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Hours_Per_Day__c: number | null, readonly flair__Type__c: WorkloadType, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly workloadWeeks: ReadonlyArray<{ readonly __typename?: 'WorkloadWeek', readonly Id: string, readonly monday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly tuesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly wednesday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly thursday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly friday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly saturday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null }, readonly sunday: { readonly __typename?: 'WorkloadDay', readonly startTime: string | null, readonly endTime: string | null, readonly workingMinutes: number, readonly breakMinutes: number | null, readonly breaksScheduled: ReadonlyArray<{ readonly __typename?: 'BreakScheduled', readonly id: string, readonly startTime: string, readonly endTime: string }> | null } }>, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null, readonly flair__Minimal_Break_Length__c: number, readonly flair__Notify_Employee_For_Break_Time__c: boolean, readonly flair__Suggest_Adding_Break__c: boolean, readonly flair__Automatically_Deduct_Unused_Break__c: boolean, readonly flair__Block_Ending_Breaks__c: boolean, readonly flair__Is_Restrict_Future_Entries_Enabled__c: boolean, readonly flair__Track_Geolocation__c: boolean, readonly breakLegislationRules: ReadonlyArray<{ readonly __typename?: 'BreakLegislationRule', readonly Id: string, readonly flair__Work_More_Than_Hour__c: number, readonly flair__Work_More_Than_Minute__c: number, readonly flair__Break__c: number }> } | null }>, readonly paidAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Name__c: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Id__c: string, readonly flair__Amount__c: number, readonly flair__Working_Amount__c: number, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Type__c: AbsenceType, readonly flair__Paid__c: boolean | null, readonly flair__Approval_Status__c: AbsenceApprovalStatus, readonly flair__Category_Unlimited__c: boolean, readonly flair__Comment__c: string | null }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly calendarPeriods: ReadonlyArray<{ readonly __typename?: 'CalendarPeriod', readonly Id: string, readonly Name: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Official__c: boolean }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly commentsCount: number, readonly flair__Time_Entries_Minutes__c: number, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }> } } | null };

export type MyTimeTrackingQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTimeTrackingQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly currentTimeEntry: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly location: { readonly __typename?: 'MyLocation', readonly Name: string } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } };

export type MyTimeTrackingSettingsQueryVariables = Exact<{
  today: Scalars['DateTime']['input'];
}>;


export type MyTimeTrackingSettingsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly workloads: ReadonlyArray<{ readonly __typename?: 'MyWorkload', readonly Id: string, readonly flair__Time_Tracking_Type__c: WorkloadTrackingType, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null }> } };

export type SubmitTimeEntryMutationVariables = Exact<{
  input: SubmitTimeEntryInput;
}>;


export type SubmitTimeEntryMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly submitTimeEntry: { readonly __typename?: 'SubmitTimeEntryPayload', readonly record: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly timeSheet: { readonly __typename?: 'TimeSheet', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string, readonly flair__Type__c: WorkloadType, readonly flair__Target_Hours__c: number, readonly flair__Time_Entry_Hours__c: number, readonly flair__Approval_Status__c: TimeSheetStatus, readonly flair__Current_Compensatory_Time_Level_1__c: number | null, readonly flair__Current_Compensatory_Time_Level_2__c: number | null, readonly flair__Given_Compensatory_Time_Level_1__c: number | null, readonly flair__Given_Compensatory_Time_Level_2__c: number | null, readonly flair__Time_Entries_Hours_Diff__c: number, readonly workedHours: number, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }>, readonly trackedTime: { readonly __typename?: 'TimesheetTrackedTime', readonly timesheetId: string, readonly totalTrackedMinutes: number, readonly totalWorkedMinutes: number, readonly totalDaysTracked: number, readonly days: ReadonlyArray<{ readonly __typename?: 'TimesheetDayTrackedTime', readonly timesheetId: string, readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number, readonly dayStartDateTime: string, readonly timeEntriesIds: ReadonlyArray<string>, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly dayChanges: { readonly __typename?: 'TimesheetDayChanges', readonly changeRequestIds: ReadonlyArray<string>, readonly workedMinutes: number | null, readonly changeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Creation_Time_Entry_Notes__c: string | null }>, readonly trackedTimeStart: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly trackedTimeEnd: { readonly __typename?: 'DateTimeWithOrigin', readonly value: string | null, readonly timeEntryId: string | null, readonly changeRequestId: string | null }, readonly breaksDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null }, readonly trackedDuration: { readonly __typename?: 'DurationWithOrigin', readonly minutes: number | null, readonly timeEntryIds: ReadonlyArray<string>, readonly changeRequestIds: ReadonlyArray<string> | null } } | null, readonly allAbsences: ReadonlyArray<{ readonly __typename?: 'Absence', readonly Id: string, readonly flair__Category_Icon__c: string, readonly flair__Category_Name__c: string, readonly flair__Start_Date__c: string, readonly flair__Start_Time__c: string, readonly flair__Start_Date_Half_Day__c: boolean, readonly flair__End_Date__c: string, readonly flair__End_Time__c: string, readonly flair__End_Date_Half_Day__c: boolean, readonly flair__Comment__c: string | null, readonly flair__Working_Amount__c: number, readonly flair__Type__c: AbsenceType }>, readonly holidays: ReadonlyArray<{ readonly __typename?: 'LocationHoliday', readonly Id: string, readonly Name: string, readonly flair__Day__c: string, readonly flair__Official__c: boolean, readonly flair__Type__c: HolidayType, readonly startDate: string, readonly endDate: string }>, readonly timeEntries: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly Id: string, readonly Name: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> }> }> }, readonly timeSheetDays: ReadonlyArray<{ readonly __typename?: 'TimeSheetDay', readonly timeBalanceAccumulated: number | null, readonly Id: string, readonly flair__Day__c: string, readonly flair__Employee__c: string | null, readonly commentsCount: number, readonly timeBalanceWithdrawals: ReadonlyArray<{ readonly __typename?: 'TimeBalanceWithdrawal', readonly Id: string, readonly flair__Withdrawal_Type__c: TimeBalanceWithdrawalType, readonly flair__Amount__c: number, readonly absenceAllowances: ReadonlyArray<{ readonly __typename?: 'AbsenceAllowance', readonly Id: string, readonly employeeAbsenceCategory: { readonly __typename?: 'EmployeeAbsenceCategory', readonly Id: string, readonly category: { readonly __typename?: 'AbsenceCategory', readonly Id: string, readonly Name: string } } }> | null }>, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly timeSheetDayProjectTimeEntries: ReadonlyArray<{ readonly __typename?: 'TimeSheetDayProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly projectTimeEntry: { readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } } }> }>, readonly timeEntryChangeRequests: ReadonlyArray<{ readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null }>, readonly workloads: ReadonlyArray<{ readonly __typename?: 'EmployeeWorkload', readonly Id: string, readonly flair__Start_Date__c: string, readonly flair__End_Date__c: string | null, readonly flair__Workload_Model__c: WorkloadModel, readonly timeFramework: { readonly __typename?: 'TimeFramework', readonly Id: string, readonly flair__Overtime_Policy__c: string | null } | null }> } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null, readonly projectTimeEntries: ReadonlyArray<{ readonly __typename?: 'ProjectTimeEntry', readonly Id: string, readonly flair__Minutes__c: number | null, readonly flair__Project__c: string | null, readonly flair__Cost_Center__c: string | null, readonly flair__Employee_Timesheet__c: string, readonly flair__Date__c: string, readonly flair__Notes__c: string | null, readonly flair__Time_Entry__c: string | null, readonly extraFields: ReadonlyArray<{ readonly __typename?: 'ExtraFieldValue', readonly recordId: string, readonly fieldApiName: string, readonly jsonValue: string | null, readonly displayValue: string | null, readonly type: FieldType }>, readonly recordType: { readonly __typename?: 'RecordType', readonly Id: string, readonly Name: string, readonly DeveloperName: string, readonly IsDefault: boolean, readonly IsAvailable: boolean, readonly IsMaster: boolean } }>, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }> } } };

export type MyTimeEntryTimeTrackingFragment = { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> };

export type MyTimeEntryBreakFragment = { readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string };

export type TimeSheetTrackedTimeDayFragment = { readonly __typename?: 'TimesheetDayTrackedTime', readonly day: string, readonly trackedMinutes: number, readonly targetMinutes: number, readonly absenceMinutes: number, readonly holidayMinutes: number, readonly workedMinutes: number, readonly overtimeMinutes: number, readonly deficitMinutes: number };

export type MyTimeEntryTimeSheetFieldsFragment = { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Working_Period_In_Hours__c: number, readonly flair__Approval_Status__c: TimeEntryApprovalStatus, readonly flair__Total_Period_In_Hours__c: number, readonly flair__Payroll_Completed__c: boolean, readonly flair__Is_Locked__c: boolean, readonly flair__Total_Break_Period_In_Hours__c: number, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Hours__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> };

export type TimeEntryChangeRequestFieldsFragment = { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null };

export type CreateMyTimeEntryMutationVariables = Exact<{
  input: InputMaybe<StartMyTimeEntryInput>;
}>;


export type CreateMyTimeEntryMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly createMyTimeEntry: { readonly __typename?: 'CreateMyTimeEntryPayload', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly currentTimeEntry: { readonly __typename?: 'MyTimeEntry', readonly timeSheetId: string | null, readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }>, readonly warnings: ReadonlyArray<{ readonly __typename?: 'TimeLimitWarningMaxDailyLimit', readonly warningCode: TimeTrackingWarningCode, readonly allowedTimeInMin: number, readonly alreadyTrackedInMin: number, readonly leftToTrackInMin: number, readonly autoClockOut: boolean }> } } };

export type PauseMyTimeEntryMutationVariables = Exact<{
  input: UpdateMyTimeEntryInput;
}>;


export type PauseMyTimeEntryMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly pauseMyTimeEntry: { readonly __typename?: 'UpdateMyTimeEntryPayload', readonly record: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly changeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }> } } };

export type ResumeMyTimeEntryMutationVariables = Exact<{
  input: UpdateMyTimeEntryInput;
}>;


export type ResumeMyTimeEntryMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly resumeMyTimeEntry: { readonly __typename?: 'UpdateMyTimeEntryPayload', readonly record: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly changeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }> } } };

export type StopMyTimeEntryMutationVariables = Exact<{
  input: StopMyTimeEntryInput;
}>;


export type StopMyTimeEntryMutation = { readonly __typename?: 'Mutation', readonly timeTracking: { readonly __typename?: 'TimeTrackingMutations', readonly stopMyTimeEntry: { readonly __typename?: 'UpdateMyTimeEntryPayload', readonly record: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly changeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null, readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly currentTimeEntry: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly changeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }> } } };

export type MyTimeEntryTimeTrackingWithChangeRequestFragment = { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly changeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> };

export type UpdateMyTimeEntryPayloadFragment = { readonly __typename?: 'UpdateMyTimeEntryPayload', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly currentTimeEntry: { readonly __typename?: 'MyTimeEntry', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Non_compliant__c: boolean, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string, readonly changeRequest: { readonly __typename?: 'TimeEntryChangeRequest', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Time_Entry__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Status__c: ApprovalStatus, readonly flair__Working_Period_In_Hours__c: number, readonly LastModifiedDate: string, readonly flair__Creation_Time_Entry_Notes__c: string | null, readonly flair__Cost_Center__c: string | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'TimeEntryBreakChangeRequest', readonly Id: string, readonly flair__Time_Entry_Break__c: string | null, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly LastModifiedDate: string }>, readonly timeEntry: { readonly __typename?: 'TimeEntry', readonly Id: string, readonly flair__Notes__c: string | null, readonly LastModifiedDate: string } | null } | null, readonly breaks: ReadonlyArray<{ readonly __typename?: 'MyTimeEntryBreak', readonly Id: string, readonly flair__Start_Datetime__c: string, readonly flair__End_Datetime__c: string | null, readonly flair__Total_Break_Period_in_Minutes__c: number, readonly flair__Auto_adjusted_Datetime__c: string | null, readonly LastModifiedDate: string }> } | null } | null, readonly errors2: ReadonlyArray<{ readonly __typename?: 'TimeLimitErrorMaxDailyLimitExceeded', readonly allowedTimeInMin: number, readonly errorCode: TimeTrackingErrorCode, readonly message: string } | { readonly __typename?: 'TimeTrackingError', readonly errorCode: TimeTrackingErrorCode, readonly message: string }> };

export type WorkflowItemsFilterForWorkflowQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;


export type WorkflowItemsFilterForWorkflowQuery = { readonly __typename?: 'Query', readonly workflowItemsFilterOptions: { readonly __typename?: 'WorkflowItemsFilterOptions', readonly responsibleEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }>, readonly responsibleTeams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> } };

export type WorkflowItemsFilterForMeQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowItemsFilterForMeQuery = { readonly __typename?: 'Query', readonly workflowItemsFilterOptions: { readonly __typename?: 'WorkflowItemsFilterOptions', readonly workflowTemplates: ReadonlyArray<{ readonly __typename?: 'WorkflowTemplate', readonly Id: string, readonly Name: string }>, readonly workflowItemTemplates: ReadonlyArray<{ readonly __typename?: 'WorkflowItemTemplate', readonly Id: string, readonly Name: string }>, readonly responsibleEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }>, readonly responsibleTeams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> } };

export type WorkflowItemsFilterQueryVariables = Exact<{
  workflowContext: WorkflowContext;
}>;


export type WorkflowItemsFilterQuery = { readonly __typename?: 'Query', readonly workflowItemsFilterOptions: { readonly __typename?: 'WorkflowItemsFilterOptions', readonly workflowTemplates: ReadonlyArray<{ readonly __typename?: 'WorkflowTemplate', readonly Id: string, readonly Name: string }>, readonly workflowItemTemplates: ReadonlyArray<{ readonly __typename?: 'WorkflowItemTemplate', readonly Id: string, readonly Name: string }>, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }>, readonly responsibleEmployees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }>, readonly responsibleTeams: ReadonlyArray<{ readonly __typename?: 'Team', readonly Id: string, readonly Name: string }> } };

export type WorkflowItemsFilter_WorkflowTemplateFragment = { readonly __typename?: 'WorkflowTemplate', readonly Id: string, readonly Name: string };

export type WorkflowItemsFilter_WorkflowItemTemplateFragment = { readonly __typename?: 'WorkflowItemTemplate', readonly Id: string, readonly Name: string };

export type WorkflowItemsFilter_EmployeeFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string };

export type WorkflowItemsFilter_TeamFragment = { readonly __typename?: 'Team', readonly Id: string, readonly Name: string };

export type WorkflowsFilterForMeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowsFilterForMeOptionsQuery = { readonly __typename?: 'Query', readonly workflowsFilterOptions: { readonly __typename?: 'WorkflowsFilterOptions', readonly workflowTemplates: ReadonlyArray<{ readonly __typename?: 'WorkflowTemplate', readonly Id: string, readonly Name: string }> } };

export type WorkflowsFilterOptionsQueryVariables = Exact<{
  workflowContext: WorkflowContext;
}>;


export type WorkflowsFilterOptionsQuery = { readonly __typename?: 'Query', readonly workflowsFilterOptions: { readonly __typename?: 'WorkflowsFilterOptions', readonly workflowTemplates: ReadonlyArray<{ readonly __typename?: 'WorkflowTemplate', readonly Id: string, readonly Name: string }>, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } };

export type WorkflowFilter_WorkflowTemplateFragment = { readonly __typename?: 'WorkflowTemplate', readonly Id: string, readonly Name: string };

export type WorkflowFilter_EmployeeFragment = { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type UpdateOnboardingFirstOpenDateMutationVariables = Exact<{
  input: UpdateWorkflowFirstOpenedDateInput;
}>;


export type UpdateOnboardingFirstOpenDateMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowFirstOpenedDate: { readonly __typename?: 'UpdateWorkflowFirstOpenedDatePayload', readonly record: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__First_Opened__c: string | null } | null } } };

export type WorkflowDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowDashboardQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly flair__First_Name__c: string | null, readonly flair__Last_Name__c: string | null, readonly onboardingWorkflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Employee__c: string, readonly flair__Complete_Progress__c: number | null, readonly flair__First_Opened__c: string | null, readonly flair__Show_Onboarding_Widget__c: boolean, readonly flair__Status__c: WorkflowStatus } | null, readonly notCompletedWorkflowItems: ReadonlyArray<{ readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Workflow__c: string, readonly flair__Employee__c: string }> } };

export type RefetchWorkflowFieldsFragment = { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> };

export type WorkflowItemUploadedFileFragment = { readonly __typename?: 'ContentDocument', readonly Id: string, readonly Title: string, readonly FileExtension: string | null };

export type WorkflowEmployeeFieldsFragment = { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null };

export type WorkflowItemDataFieldFragment = { readonly __typename?: 'WorkflowItemDataField', readonly value: string | null, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } };

export type WorkflowItemFieldsFragment = { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Type__c: WorkflowItemType, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Due_Date__c: string | null, readonly flair__Data_Fields__c: string | null, readonly flair__Document_Category__c: string | null, readonly flair__File_Format__c: WorkflowItemFileFormat | null, readonly flair__Responsible_Type2__c: WorkflowItemResponsibleType | null, readonly flair__Employee_Evaluation__c: string | null, readonly uploadedFileVisibility: DocumentVisiblity | null, readonly attachments: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly responsible: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly responsibleTeam: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> } | null };

export type UpdateWorkflowItemRegularMutationVariables = Exact<{
  input: UpdateWorkflowItemRegularInput;
}>;


export type UpdateWorkflowItemRegularMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowItemRegular: { readonly __typename?: 'UpdateWorkflowItemPayload', readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> } } | null } } };

export type UpdateWorkflowItemDataRequestMutationVariables = Exact<{
  input: UpdateWorkflowItemDataRequestInput;
}>;


export type UpdateWorkflowItemDataRequestMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowItemDataRequest: { readonly __typename?: 'UpdateWorkflowItemDataRequestPayload', readonly employeeId: string, readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly dataFields: ReadonlyArray<{ readonly __typename?: 'WorkflowItemDataField', readonly value: string | null, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> | null, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> } } | null } } };

export type UpdateWorkflowItemSubTasksMutationVariables = Exact<{
  input: UpdateWorkflowItemSubTasksInput;
}>;


export type UpdateWorkflowItemSubTasksMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowItemSubTasks: { readonly __typename?: 'UpdateWorkflowItemPayload', readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Sub_Tasks_Json__c: string | null, readonly subTasks: ReadonlyArray<{ readonly __typename?: 'WorkflowSubTask', readonly id: string, readonly text: string, readonly checked: boolean }> } | null } } };

export type UpdateWorkflowItemFileRequestMutationVariables = Exact<{
  input: UpdateWorkflowItemFileRequestInput;
}>;


export type UpdateWorkflowItemFileRequestMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowItemFileRequest: { readonly __typename?: 'UpdateWorkflowItemPayload', readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly uploadedFileVisibility: DocumentVisiblity | null, readonly uploadedFile: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly Title: string, readonly FileExtension: string | null } | null, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> } } | null } } };

export type UpdateWorkflowItemVideoRequestMutationVariables = Exact<{
  input: UpdateWorkflowItemVideoRequestInput;
}>;


export type UpdateWorkflowItemVideoRequestMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowItemVideoRequest: { readonly __typename?: 'UpdateWorkflowItemPayload', readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Loom_Video__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> } } | null } } };

export type DeleteWorkflowItemLoomVideoMutationVariables = Exact<{
  input: DeleteWorkflowItemLoomVideoInput;
}>;


export type DeleteWorkflowItemLoomVideoMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly deleteWorkflowItemLoomVideo: { readonly __typename?: 'UpdateWorkflowItemPayload', readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> } } | null } } };

export type WorkflowItemDataRequestQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
  workflowItemId: Scalars['String']['input'];
}>;


export type WorkflowItemDataRequestQuery = { readonly __typename?: 'Query', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly item: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Type__c: WorkflowItemType, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Due_Date__c: string | null, readonly flair__Data_Fields__c: string | null, readonly flair__Document_Category__c: string | null, readonly flair__File_Format__c: WorkflowItemFileFormat | null, readonly flair__Responsible_Type2__c: WorkflowItemResponsibleType | null, readonly flair__Employee_Evaluation__c: string | null, readonly uploadedFileVisibility: DocumentVisiblity | null, readonly dataFields: ReadonlyArray<{ readonly __typename?: 'WorkflowItemDataField', readonly value: string | null, readonly fieldInfo: { readonly __typename?: 'FieldInfo', readonly name: string, readonly objectType: string, readonly locale: string, readonly label: string, readonly recordTypeId: string | null, readonly type: FieldType, readonly picklistValues: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } }> | null, readonly attachments: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly responsible: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly responsibleTeam: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> } | null } | null } };

export type WorkflowItemFileRequestQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
  workflowItemId: Scalars['String']['input'];
}>;


export type WorkflowItemFileRequestQuery = { readonly __typename?: 'Query', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly item: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Description__c: string | null, readonly flair__Type__c: WorkflowItemType, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Due_Date__c: string | null, readonly flair__Data_Fields__c: string | null, readonly flair__Document_Category__c: string | null, readonly flair__File_Format__c: WorkflowItemFileFormat | null, readonly flair__Responsible_Type2__c: WorkflowItemResponsibleType | null, readonly flair__Employee_Evaluation__c: string | null, readonly uploadedFileVisibility: DocumentVisiblity | null, readonly uploadedFile: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly Title: string, readonly FileExtension: string | null } | null, readonly attachments: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly responsible: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly responsibleTeam: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }> } | null } | null } };

export type UpdateWorkflowItemStatusMutationVariables = Exact<{
  input: UpdateWorkflowItemStatusInput;
}>;


export type UpdateWorkflowItemStatusMutation = { readonly __typename?: 'Mutation', readonly workflow: { readonly __typename?: 'WorkflowMutations', readonly updateWorkflowItemStatus: { readonly __typename?: 'UpdateWorkflowItemPayload', readonly record: { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly flair__Status__c: WorkflowItemStatus, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly flair__Complete_Progress__c: number | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Is_Active__c: boolean }> } } | null } } };

export type WorkflowItemSubTasksFragment = { readonly __typename?: 'WorkflowItem', readonly flair__Sub_Tasks_Json__c: string | null, readonly subTasks: ReadonlyArray<{ readonly __typename?: 'WorkflowSubTask', readonly id: string, readonly text: string, readonly checked: boolean }> };

export type WorkflowFragment = { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string, readonly flair__Workflow_Template__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } };

export type WorkflowItemTableFieldsFragment = { readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Responsible__c: string | null, readonly flair__Description__c: string | null, readonly flair__Type__c: WorkflowItemType, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Due_Date__c: string | null, readonly flair__Workflow_Template_Item__c: string | null, readonly flair__Data_Fields__c: string | null, readonly flair__Document_Category__c: string | null, readonly flair__File_Format__c: WorkflowItemFileFormat | null, readonly flair__Responsible_Type2__c: WorkflowItemResponsibleType | null, readonly flair__Employee_Evaluation__c: string | null, readonly flair__Instructions_Loom_Url__c: string | null, readonly flair__Is_Mandatory__c: boolean, readonly flair__Workflow_Step__c: string, readonly canUpdate: boolean, readonly flair__Loom_Video__c: string | null, readonly commentsCount: number, readonly flair__Sub_Tasks_Json__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly signRequestSigner: { readonly __typename?: 'SignRequestSigner', readonly flair__External_Signature_Link__c: string | null, readonly flair__Status__c: SignRequestSignerStatus } | null, readonly attachments: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly responsible: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly responsibleTeam: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } | null, readonly workflowStep: { readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Step_Name__c: string, readonly flair__Order__c: number, readonly flair__Activating_Trigger__c: WorkflowStepActivatingTrigger, readonly flair__Activation_Date__c: string | null, readonly flair__Is_Active__c: boolean }, readonly subTasks: ReadonlyArray<{ readonly __typename?: 'WorkflowSubTask', readonly id: string, readonly text: string, readonly checked: boolean }> };

export type WorkflowItemsForWorkflowQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
  filter: WorkflowItemsFilterInput2;
  sort: InputMaybe<WorkflowsItemsListSortInput>;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type WorkflowItemsForWorkflowQuery = { readonly __typename?: 'Query', readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string, readonly flair__Workflow_Template__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } }, readonly workflowItems: { readonly __typename?: 'WorkflowItemsPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Responsible__c: string | null, readonly flair__Description__c: string | null, readonly flair__Type__c: WorkflowItemType, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Due_Date__c: string | null, readonly flair__Workflow_Template_Item__c: string | null, readonly flair__Data_Fields__c: string | null, readonly flair__Document_Category__c: string | null, readonly flair__File_Format__c: WorkflowItemFileFormat | null, readonly flair__Responsible_Type2__c: WorkflowItemResponsibleType | null, readonly flair__Employee_Evaluation__c: string | null, readonly flair__Instructions_Loom_Url__c: string | null, readonly flair__Is_Mandatory__c: boolean, readonly flair__Workflow_Step__c: string, readonly canUpdate: boolean, readonly flair__Loom_Video__c: string | null, readonly commentsCount: number, readonly flair__Sub_Tasks_Json__c: string | null, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly signRequestSigner: { readonly __typename?: 'SignRequestSigner', readonly flair__External_Signature_Link__c: string | null, readonly flair__Status__c: SignRequestSignerStatus } | null, readonly attachments: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly responsible: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly responsibleTeam: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } | null, readonly workflowStep: { readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Step_Name__c: string, readonly flair__Order__c: number, readonly flair__Activating_Trigger__c: WorkflowStepActivatingTrigger, readonly flair__Activation_Date__c: string | null, readonly flair__Is_Active__c: boolean }, readonly subTasks: ReadonlyArray<{ readonly __typename?: 'WorkflowSubTask', readonly id: string, readonly text: string, readonly checked: boolean }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } };

export type WorkflowsItemsQueryVariables = Exact<{
  workflowContext: WorkflowContext;
  filter: WorkflowItemsFilterInput2;
  sort: InputMaybe<WorkflowsItemsListSortInput>;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type WorkflowsItemsQuery = { readonly __typename?: 'Query', readonly workflowItems: { readonly __typename?: 'WorkflowItemsPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Employee__c: string, readonly flair__Responsible__c: string | null, readonly flair__Description__c: string | null, readonly flair__Type__c: WorkflowItemType, readonly flair__Status__c: WorkflowItemStatus, readonly flair__Due_Date__c: string | null, readonly flair__Workflow_Template_Item__c: string | null, readonly flair__Data_Fields__c: string | null, readonly flair__Document_Category__c: string | null, readonly flair__File_Format__c: WorkflowItemFileFormat | null, readonly flair__Responsible_Type2__c: WorkflowItemResponsibleType | null, readonly flair__Employee_Evaluation__c: string | null, readonly flair__Instructions_Loom_Url__c: string | null, readonly flair__Is_Mandatory__c: boolean, readonly flair__Workflow_Step__c: string, readonly canUpdate: boolean, readonly flair__Loom_Video__c: string | null, readonly commentsCount: number, readonly flair__Sub_Tasks_Json__c: string | null, readonly workflow: { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string, readonly flair__Workflow_Template__c: string | null, readonly employee: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } }, readonly loomVideo: { readonly __typename?: 'LoomVideo', readonly Id: string, readonly Name: string, readonly flair__Loom_Id__c: string, readonly flair__Loom_Public_App_Id__c: string, readonly flair__Shared_Url__c: string, readonly flair__Embed_Url__c: string, readonly flair__Width__c: number, readonly flair__Height__c: number, readonly flair__Created_By__c: string | null, readonly CreatedDate: string } | null, readonly signRequestSigner: { readonly __typename?: 'SignRequestSigner', readonly flair__External_Signature_Link__c: string | null, readonly flair__Status__c: SignRequestSignerStatus } | null, readonly attachments: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }>, readonly responsible: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } | null, readonly responsibleTeam: { readonly __typename?: 'Team', readonly Id: string, readonly Name: string, readonly employees: ReadonlyArray<{ readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null }> } | null, readonly workflowStep: { readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Step_Name__c: string, readonly flair__Order__c: number, readonly flair__Activating_Trigger__c: WorkflowStepActivatingTrigger, readonly flair__Activation_Date__c: string | null, readonly flair__Is_Active__c: boolean }, readonly subTasks: ReadonlyArray<{ readonly __typename?: 'WorkflowSubTask', readonly id: string, readonly text: string, readonly checked: boolean }> }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } };

export type WorkflowTableFieldsFragment = { readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string, readonly flair__Complete_Progress__c: number | null, readonly flair__Closest_Item_Due_Date__c: string | null, readonly flair__Workflow_Template__c: string | null, readonly flair__Type__c: WorkflowType, readonly flair__First_Opened__c: string | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Step_Name__c: string, readonly flair__Order__c: number }>, readonly items: ReadonlyArray<{ readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Status__c: WorkflowItemStatus, readonly CreatedDate: string, readonly flair__Workflow_Step__c: string }>, readonly employee: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } };

export type WorkflowsQueryVariables = Exact<{
  workflowContext: WorkflowContext;
  filter: WorkflowsFilterInput;
  sort: WorkflowListSortInput;
  pagination: PaginationInput;
  skipPaginationInfo: Scalars['Boolean']['input'];
}>;


export type WorkflowsQuery = { readonly __typename?: 'Query', readonly workflows: { readonly __typename?: 'WorkflowPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'Workflow', readonly Id: string, readonly Name: string, readonly flair__Complete_Progress__c: number | null, readonly flair__Closest_Item_Due_Date__c: string | null, readonly flair__Workflow_Template__c: string | null, readonly flair__Type__c: WorkflowType, readonly flair__First_Opened__c: string | null, readonly steps: ReadonlyArray<{ readonly __typename?: 'WorkflowStep', readonly Id: string, readonly flair__Step_Name__c: string, readonly flair__Order__c: number }>, readonly items: ReadonlyArray<{ readonly __typename?: 'WorkflowItem', readonly Id: string, readonly Name: string, readonly flair__Status__c: WorkflowItemStatus, readonly CreatedDate: string, readonly flair__Workflow_Step__c: string }>, readonly employee: { readonly __typename?: 'Colleague', readonly flair__Start_Date__c: string | null, readonly flair__End_Date__c: string | null, readonly Id: string, readonly Name: string, readonly flair__Position__c: string | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } }>, readonly paginationInfo?: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } };

export type JobDetailsQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type JobDetailsQuery = { readonly __typename?: 'Query', readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__Status__c: JobStatus | null, readonly flair__Display_in_Hub__c: boolean | null, readonly flair__Job_Description__c: string | null, readonly flair__Job_Requirements__c: string | null, readonly flair__Responsibilities__c: string | null, readonly flair__Published_At__c: string | null, readonly flair__Type_of_Employment__c: string | null, readonly flair__Time_Commitment__c: string | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null, readonly jobSkills: ReadonlyArray<{ readonly __typename?: 'JobSkillAssociation', readonly Id: string, readonly flair__Skill_Name__c: string | null, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string } }> } | null, readonly me: { readonly __typename?: 'Me', readonly Id: string, readonly employeeSkills: ReadonlyArray<{ readonly __typename?: 'EmployeeSkillAssociation', readonly Id: string, readonly flair__Skill__c: string, readonly skill: { readonly __typename?: 'Skill', readonly Id: string, readonly Name: string } }> } };

export type JobsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsQuery = { readonly __typename?: 'Query', readonly jobs: ReadonlyArray<{ readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__Status__c: JobStatus | null, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }> };

export type CandidateDetail_JobCandidateFragment = { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Job__c: string | null, readonly flair__Cover_Letter__c: string | null, readonly flair__Email__c: string | null, readonly flair__Phone__c: string | null, readonly flair__LinkedIn__c: string | null, readonly flair__Funnel_Stage__c: string | null, readonly flair__Application_Source__c: string | null, readonly flair__How_did_you_hear_about_us__c: string | null, readonly flair__FlairAI_Total_KR_Matching_Score__c: number | null, readonly flair__FlairAI_KR_Matching_Status__c: AiProcessingState, readonly flair__FlairAI_KR_Matching_Info_JSON__c: string | null, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__FlairAI_Key_Requirements_JSON__c: string | null } | null, readonly candidateEvaluations: ReadonlyArray<{ readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Candidate_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null }>, readonly recruitingDocuments: ReadonlyArray<{ readonly __typename?: 'RecruitingDocument', readonly Id: string, readonly Name: string, readonly flair__Title__c: string, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null }> };

export type CandidateEvaluationsFragmentFragment = { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Candidate_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null };

export type CandidateDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CandidateDetailsQuery = { readonly __typename?: 'Query', readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Job__c: string | null, readonly flair__Cover_Letter__c: string | null, readonly flair__Email__c: string | null, readonly flair__Phone__c: string | null, readonly flair__LinkedIn__c: string | null, readonly flair__Funnel_Stage__c: string | null, readonly flair__Application_Source__c: string | null, readonly flair__How_did_you_hear_about_us__c: string | null, readonly flair__FlairAI_Total_KR_Matching_Score__c: number | null, readonly flair__FlairAI_KR_Matching_Status__c: AiProcessingState, readonly flair__FlairAI_KR_Matching_Info_JSON__c: string | null, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__FlairAI_Key_Requirements_JSON__c: string | null } | null, readonly candidateEvaluations: ReadonlyArray<{ readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Candidate_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null }>, readonly recruitingDocuments: ReadonlyArray<{ readonly __typename?: 'RecruitingDocument', readonly Id: string, readonly Name: string, readonly flair__Title__c: string, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null }> } };

export type CreateCandidateEvaluationMutationVariables = Exact<{
  input: CreateCandidateEvaluationInput;
}>;


export type CreateCandidateEvaluationMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly createCandidateEvaluation: { readonly __typename?: 'UpdateCandidateEvaluationPayload', readonly recordId: string, readonly record: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly candidateEvaluations: ReadonlyArray<{ readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Candidate_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null }> } } | null } } };

export type EvaluationTemplatesQueryVariables = Exact<{
  input: AvailableEvaluationTemplatesInput;
}>;


export type EvaluationTemplatesQuery = { readonly __typename?: 'Query', readonly availableEvaluationTemplates: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string }> };

export type EvaluationTemplateFragment = { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string };

export type CandidateListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateListFilterOptionsQuery = { readonly __typename?: 'Query', readonly candidateListFilterOptions: { readonly __typename?: 'CandidateListFilterOptions', readonly stages: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }>, readonly sources: ReadonlyArray<{ readonly __typename?: 'PickListEntry', readonly label: string, readonly value: string }> } };

export type JobCandidatesQueryVariables = Exact<{
  id: Scalars['String']['input'];
  pagination: PaginationInput;
  filter: CandidateFilterInput;
  sort: InputMaybe<SortInput>;
}>;


export type JobCandidatesQuery = { readonly __typename?: 'Query', readonly hiringManager: { readonly __typename?: 'HiringManager', readonly Id: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly candidates: { readonly __typename?: 'JobCandidatesWithPagination', readonly items: ReadonlyArray<{ readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Funnel_Stage__c: string | null, readonly flair__Application_Source__c: string | null, readonly flair__FlairAI_Total_KR_Matching_Score__c: number | null, readonly flair__FlairAI_KR_Matching_Status__c: AiProcessingState, readonly flair__FlairAI_KR_Matching_Info_JSON__c: string | null, readonly CreatedDate: string, readonly commentsCount: number }>, readonly paginationInfo: { readonly __typename?: 'PaginationInfo', readonly totalCount: number } } } | null } };

export type CandidateEvaluationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CandidateEvaluationQuery = { readonly __typename?: 'Query', readonly candidateEvaluationById: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Job__c: string | null, readonly flair__Cover_Letter__c: string | null, readonly flair__Email__c: string | null, readonly flair__Phone__c: string | null, readonly flair__LinkedIn__c: string | null, readonly flair__Funnel_Stage__c: string | null, readonly flair__Application_Source__c: string | null, readonly flair__How_did_you_hear_about_us__c: string | null, readonly flair__FlairAI_Total_KR_Matching_Score__c: number | null, readonly flair__FlairAI_KR_Matching_Status__c: AiProcessingState, readonly flair__FlairAI_KR_Matching_Info_JSON__c: string | null, readonly commentsCount: number, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__FlairAI_Key_Requirements_JSON__c: string | null } | null, readonly candidateEvaluations: ReadonlyArray<{ readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Evaluated__c: boolean, readonly flair__Employee__c: string, readonly LastModifiedDate: string, readonly commentsCount: number, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Candidate_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null }>, readonly recruitingDocuments: ReadonlyArray<{ readonly __typename?: 'RecruitingDocument', readonly Id: string, readonly Name: string, readonly flair__Title__c: string, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null }> }, readonly answers: ReadonlyArray<{ readonly __typename?: 'EvaluationAnswer', readonly Id: string, readonly Name: string, readonly flair__Candidate_Evaluation__c: string | null, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Evaluation_Template_Question__c: string | null, readonly flair__Evaluation_Template_Option__c: string | null, readonly flair__Answer__c: string | null, readonly flair__Score__c: number | null }> | null, readonly evaluationTemplate: { readonly __typename?: 'EvaluationTemplate', readonly Id: string, readonly Name: string, readonly flair__Rating_Min__c: number, readonly flair__Rating_Max__c: number, readonly questions: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateQuestion', readonly Id: string, readonly Name: string, readonly flair__Name__c: string, readonly flair__Question_Type__c: EvaluationTemplateQuestionType, readonly flair__Sequence__c: number, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean, readonly options: ReadonlyArray<{ readonly __typename?: 'EvaluationTemplateOption', readonly Id: string, readonly Name: string, readonly flair__Hint__c: string | null, readonly flair__Required__c: boolean }> }> } | null } };

export type SaveCandidateEvaluationMutationVariables = Exact<{
  input: SaveCandidateEvaluationInput;
}>;


export type SaveCandidateEvaluationMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly saveCandidateEvaluation: { readonly __typename?: 'UpdateCandidateEvaluationPayload', readonly recordId: string, readonly record: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly flair__Skipped_At__c: string | null, readonly flair__Evaluated__c: boolean, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Funnel_Stage__c: string | null, readonly flair__Final_Score__c: number | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null }, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } } | null } } };

export type SaveEvaluationAnswerMutationVariables = Exact<{
  input: SaveEvaluationAnswerInput;
}>;


export type SaveEvaluationAnswerMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly saveEvaluationAnswer: { readonly __typename?: 'SaveEvaluationAnswerPayload', readonly recordId: string } } };

export type DeleteEvaluationAnswerMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteEvaluationAnswerMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly deleteEvaluationAnswer: ReadonlyArray<{ readonly __typename?: 'DeleteEvaluationAnswerPayload', readonly recordId: string }> | null } };

export type CandidateEvaluation_JobCandidateFragment = { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Job__c: string | null, readonly flair__Full_Name__c: string, readonly flair__Cover_Letter__c: string | null, readonly flair__Email__c: string | null, readonly flair__Phone__c: string | null, readonly flair__LinkedIn__c: string | null, readonly flair__Funnel_Stage__c: string | null, readonly flair__Application_Source__c: string | null, readonly flair__How_did_you_hear_about_us__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__FlairAI_Total_KR_Matching_Score__c: number | null, readonly flair__FlairAI_KR_Matching_Status__c: AiProcessingState, readonly flair__FlairAI_KR_Matching_Info_JSON__c: string | null, readonly ContentDocumentLinks__r: ReadonlyArray<{ readonly __typename?: 'ContentDocumentLink', readonly Id: string, readonly ContentDocumentId: string, readonly LinkedEntityId: string, readonly downloadUrl: string, readonly viewUrl: string, readonly ContentDocument: { readonly __typename?: 'ContentDocument', readonly Id: string, readonly CreatedDate: string, readonly FileExtension: string | null, readonly Title: string, readonly FileType: string, readonly ContentSize: number, readonly downloadUrl: string, readonly previewUrl: string } }> | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__FlairAI_Key_Requirements_JSON__c: string | null } | null };

export type JobPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JobPageQuery = { readonly __typename?: 'Query', readonly hiringManager: { readonly __typename?: 'HiringManager', readonly Id: string, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null } };

export type HiringManagerJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type HiringManagerJobsQuery = { readonly __typename?: 'Query', readonly hiringManager: { readonly __typename?: 'HiringManager', readonly Id: string, readonly jobs: ReadonlyArray<{ readonly __typename?: 'Job', readonly Id: string, readonly Name: string, readonly flair__Status__c: JobStatus | null, readonly candidatesCount: number, readonly location: { readonly __typename?: 'Location', readonly Id: string, readonly Name: string } | null, readonly department: { readonly __typename?: 'Department', readonly Id: string, readonly Name: string } | null }> } };

export type EvaluationsQueryVariables = Exact<{
  filter: InputMaybe<EvaluationsFilter>;
}>;


export type EvaluationsQuery = { readonly __typename?: 'Query', readonly evaluations: ReadonlyArray<{ readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly Name: string, readonly flair__Overall_Comment__c: string | null, readonly flair__Final_Score__c: number | null, readonly flair__Employee__c: string, readonly flair__Candidate__c: string, readonly flair__Due_Date__c: string | null, readonly flair__Skipped_At__c: string | null, readonly flair__Evaluated__c: boolean, readonly candidate: { readonly __typename?: 'JobCandidate', readonly Id: string, readonly flair__Full_Name__c: string, readonly flair__Funnel_Stage__c: string | null, readonly flair__Final_Score__c: number | null, readonly job: { readonly __typename?: 'Job', readonly Id: string, readonly Name: string } | null }, readonly employee: { readonly __typename?: 'Colleague', readonly Id: string, readonly Name: string, readonly avatar: { readonly __typename?: 'EmployeeAvatar', readonly Id: string, readonly url: string | null } | null } }> };

export type GetReferrerLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type GetReferrerLinkMutation = { readonly __typename?: 'Mutation', readonly recruiting: { readonly __typename?: 'RecruitingMutations', readonly meReferrerLink: string | null } };

export type SkipEmployeeEvaluationMutationVariables = Exact<{
  evaluationId: Scalars['String']['input'];
}>;


export type SkipEmployeeEvaluationMutation = { readonly __typename?: 'Mutation', readonly evaluation: { readonly __typename?: 'EvaluationMutations', readonly skipEmployeeEvaluation: { readonly __typename?: 'UpdateCandidateEvaluationPayload', readonly recordId: string, readonly record: { readonly __typename?: 'CandidateEvaluation', readonly Id: string, readonly flair__Skipped_At__c: string | null } | null } } };

export const AbsencePopoverOverlappingFragmentDoc = gql`
    fragment AbsencePopoverOverlapping on Absence {
  Id
  flair__Category_Name__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__Type__c
}
    `;
export const AbsencePopoverHolidayFragmentDoc = gql`
    fragment AbsencePopoverHoliday on Holiday {
  Id
  Name
  flair__Type__c
}
    `;
export const CalendarPeriodPopoverFragmentDoc = gql`
    fragment CalendarPeriodPopover on CalendarPeriod {
  Id
  Name
  flair__Start_Date__c
  flair__End_Date__c
}
    `;
export const RecordTypeFragmentDoc = gql`
    fragment RecordType on RecordType {
  Id
  Name
  DeveloperName
  IsDefault
  IsAvailable
  IsMaster
}
    `;
export const AvailableRecordTypeFragmentDoc = gql`
    fragment AvailableRecordType on RecordType {
  Id
  Name
  DeveloperName
  IsDefault
}
    `;
export const ExtraFieldInfoFragmentDoc = gql`
    fragment ExtraFieldInfo on ExtraFieldInfo {
  label
  type
  isRichTextArea
  inlineHelpText
  referenceObjectApiName
  picklistValues {
    label
    value
  }
  decimalPlaces
}
    `;
export const ExtraFieldFormInfoFragmentDoc = gql`
    fragment ExtraFieldFormInfo on ExtraFieldFormInfo {
  id
  fieldApiName
  required
  formId
  visibilityCondition
  fieldInfo {
    ...ExtraFieldInfo
  }
  visibleLines
}
    ${ExtraFieldInfoFragmentDoc}`;
export const ExtraFieldTableInfoFragmentDoc = gql`
    fragment ExtraFieldTableInfo on ExtraFieldTableInfo {
  id
  fieldApiName
  tableId
  customFieldName
  columnTitle
  fieldInfo {
    ...ExtraFieldInfo
  }
}
    ${ExtraFieldInfoFragmentDoc}`;
export const ObjectExtraFieldsFragmentDoc = gql`
    fragment ObjectExtraFields on ObjectExtraFields {
  objectApiName
  recordTypes {
    ...RecordType
  }
  availableRecordTypes {
    ...AvailableRecordType
  }
  form {
    ...ExtraFieldFormInfo
  }
  table {
    ...ExtraFieldTableInfo
  }
}
    ${RecordTypeFragmentDoc}
${AvailableRecordTypeFragmentDoc}
${ExtraFieldFormInfoFragmentDoc}
${ExtraFieldTableInfoFragmentDoc}`;
export const HolidayPopoverFragmentDoc = gql`
    fragment HolidayPopover on Holiday {
  Id
  Name
  flair__Day__c
  flair__Official__c
  flair__Type__c
  startDate
  endDate
}
    `;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on Notification {
  Id
  flair__Employee__c
  flair__Is_Read__c
  flair__Is_Snoozed__c
  flair__Read_At__c
  flair__Snoozed_At__c
  flair__Unsnooze_At__c
  flair__Is_Archived__c
  flair__Is_Task__c
  flair__Record_Id__c
  flair__Object_Type__c
  flair__Body__c
  flair__Title__c
  CreatedDate
  flair__Type__c
  flair__Button_Name__c
  flair__Button_Link__c
}
    `;
export const AbsenceNotificationFieldsFragmentDoc = gql`
    fragment AbsenceNotificationFields on AbsenceNotificationRenderInfo {
  absence {
    Id
    flair__Start_Date__c
    flair__Start_Time__c
    flair__Start_Date_Half_Day__c
    flair__End_Date__c
    flair__End_Time__c
    flair__End_Date_Half_Day__c
    employee {
      Id
      Name
    }
  }
}
    `;
export const AbsenceApprovalRequestNotificationFieldsFragmentDoc = gql`
    fragment AbsenceApprovalRequestNotificationFields on AbsenceApprovalRequestNotificationRenderInfo {
  approvalRequest {
    Id
    flair__Approval_Status__c
    flair__Approver__c
    flair__Approver_Comment__c
    absence {
      Id
      flair__Start_Date__c
      flair__Start_Time__c
      flair__Start_Date_Half_Day__c
      flair__End_Date__c
      flair__End_Time__c
      flair__End_Date_Half_Day__c
      employee {
        Id
        Name
      }
    }
  }
}
    `;
export const CandidateEvaluationNotificationFieldsFragmentDoc = gql`
    fragment CandidateEvaluationNotificationFields on CandidateEvaluationNotificationRenderInfo {
  candidateEvaluation {
    Id
    flair__Employee__c
    flair__Candidate__c
    flair__Due_Date__c
    candidate {
      Id
      flair__Full_Name__c
    }
    candidate {
      Id
      job {
        Id
        Name
      }
    }
  }
}
    `;
export const TimeSheetDayIdFragmentDoc = gql`
    fragment TimeSheetDayId on TimeSheetDay {
  Id
  flair__Day__c
  flair__Employee__c
}
    `;
export const CommentableIdFragmentDoc = gql`
    fragment CommentableId on Commentable {
  Id
  ... on TimeSheetDay {
    ...TimeSheetDayId
  }
}
    ${TimeSheetDayIdFragmentDoc}`;
export const CommentRelatedWorkflowItemFragmentDoc = gql`
    fragment CommentRelatedWorkflowItem on WorkflowItem {
  Id
  flair__Workflow__c
}
    `;
export const CommentRelatedAbsenceFragmentDoc = gql`
    fragment CommentRelatedAbsence on Absence {
  Id
  flair__EmployeeId__c
  approvalRequests {
    Id
    flair__Approver__c
  }
}
    `;
export const CommentRelatedTimeSheetDayFragmentDoc = gql`
    fragment CommentRelatedTimeSheetDay on TimeSheetDay {
  Id
  timeSheet {
    Id
    flair__Start_Date__c
    flair__Type__c
    workloads {
      Id
      flair__Start_Date__c
      flair__End_Date__c
      flair__Time_Tracking_Type__c
    }
  }
}
    `;
export const CommentRelatedCandidateEvaluationFragmentDoc = gql`
    fragment CommentRelatedCandidateEvaluation on CandidateEvaluation {
  Id
  flair__Candidate__c
}
    `;
export const CommentRelatedEmployeeDocumentFragmentDoc = gql`
    fragment CommentRelatedEmployeeDocument on EmployeeDocument {
  Id
  flair__Employee_Document_Folder__c
  flair__Employee1__c
}
    `;
export const CommentRelatedInventoryItemFragmentDoc = gql`
    fragment CommentRelatedInventoryItem on InventoryItem {
  Id
  flair__Employee__c
}
    `;
export const CommentRelatedEmployeeDataChangeRequestFragmentDoc = gql`
    fragment CommentRelatedEmployeeDataChangeRequest on EmployeeDataChangeRequest {
  Id
}
    `;
export const CommentWithDeepLinkDataFragmentDoc = gql`
    fragment CommentWithDeepLinkData on Comment {
  Id
  employee {
    Id
    flair__Manager__c
  }
  related {
    ...CommentableId
    ...CommentRelatedWorkflowItem
    ...CommentRelatedAbsence
    ...CommentRelatedTimeSheetDay
    ...CommentRelatedCandidateEvaluation
    ...CommentRelatedEmployeeDocument
    ...CommentRelatedInventoryItem
    ...CommentRelatedEmployeeDataChangeRequest
  }
}
    ${CommentableIdFragmentDoc}
${CommentRelatedWorkflowItemFragmentDoc}
${CommentRelatedAbsenceFragmentDoc}
${CommentRelatedTimeSheetDayFragmentDoc}
${CommentRelatedCandidateEvaluationFragmentDoc}
${CommentRelatedEmployeeDocumentFragmentDoc}
${CommentRelatedInventoryItemFragmentDoc}
${CommentRelatedEmployeeDataChangeRequestFragmentDoc}`;
export const MentionFragmentDoc = gql`
    fragment Mention on MentionedEmployee {
  id
  hasAccess
  employee {
    Id
    Name
    avatar {
      Id
      url
    }
    flair__Position__c
    flair__Department__c
    flair__Location__c
    flair__Company_Email__c
    flair__Company_Phone_Number__c
    department {
      Id
      Name
    }
    location {
      Id
      Name
    }
    manager {
      Id
      Name
    }
  }
}
    `;
export const CommentNotificationFieldsFragmentDoc = gql`
    fragment CommentNotificationFields on CommentNotificationRenderInfo {
  comment {
    ...CommentWithDeepLinkData
    Id
    Name
    flair__Comment__c
    flair__Employee__c
    flair__Related_Id__c
    flair__Related_Object_Name__c
    CreatedDate
    mentions {
      ...Mention
    }
  }
  employee {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      Name
      flair__Employee__c
      url
      urlLarge
    }
  }
}
    ${CommentWithDeepLinkDataFragmentDoc}
${MentionFragmentDoc}`;
export const CelebrationNotificationFieldsFragmentDoc = gql`
    fragment CelebrationNotificationFields on CelebrationNotificationRenderInfo {
  celebrationEmployeeRecipient {
    celebration {
      Id
      sender {
        Id
        Name
        flair__First_Name__c
        flair__Last_Name__c
        avatar {
          Id
          Name
          flair__Employee__c
          url
          urlLarge
        }
      }
    }
  }
}
    `;
export const TimeEntryNotificationFieldsFragmentDoc = gql`
    fragment TimeEntryNotificationFields on TimeEntryNotificationRenderInfo {
  timeEntry {
    Id
    Name
    flair__Employee__c
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Working_Period_In_Hours__c
    flair__Total_Period_In_Hours__c
    flair__Payroll_Completed__c
    flair__Is_Locked__c
    flair__Total_Break_Period_In_Hours__c
    flair__Non_compliant__c
    flair__Notes__c
    LastModifiedDate
    breaks {
      Id
      flair__Start_Datetime__c
      flair__End_Datetime__c
      flair__Total_Break_Period_in_Hours__c
      flair__Auto_adjusted_Datetime__c
      LastModifiedDate
    }
  }
}
    `;
export const TimeLimitTimeEntryNotificationFieldsFragmentDoc = gql`
    fragment TimeLimitTimeEntryNotificationFields on TimeLimitTimeEntryNotificationRenderInfo {
  timeEntry {
    Id
    flair__Employee__c
    flair__Start_Datetime__c
    flair__End_Datetime__c
    employee {
      Id
      Name
    }
  }
}
    `;
export const TimeEntryChangeRequestNotificationFieldsFragmentDoc = gql`
    fragment TimeEntryChangeRequestNotificationFields on TimeEntryChangeRequestNotificationRenderInfo {
  timeEntryChangeRequest {
    Id
    flair__Employee__c
    flair__Time_Entry__c
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Status__c
    flair__Total_Period_In_Hours__c
    flair__Total_Break_Period_In_Hours__c
    flair__Working_Period_In_Hours__c
    LastModifiedDate
    flair__Creation_Time_Entry_Notes__c
    flair__Cost_Center__c
    employee {
      Id
      Name
    }
    timeEntry {
      Id
      Name
      flair__Employee__c
      flair__Start_Datetime__c
      flair__End_Datetime__c
      flair__Working_Period_In_Hours__c
      flair__Total_Period_In_Hours__c
      flair__Payroll_Completed__c
      flair__Is_Locked__c
      flair__Total_Break_Period_In_Hours__c
      flair__Non_compliant__c
      flair__Notes__c
      LastModifiedDate
      breaks {
        Id
        flair__Start_Datetime__c
        flair__End_Datetime__c
        flair__Total_Break_Period_in_Hours__c
        flair__Auto_adjusted_Datetime__c
        LastModifiedDate
      }
    }
  }
}
    `;
export const WorkflowItemNotificationFieldsFragmentDoc = gql`
    fragment WorkflowItemNotificationFields on WorkflowItemNotificationRenderInfo {
  workflow {
    Id
    Name
  }
}
    `;
export const TicketClosedNotificationFieldsFragmentDoc = gql`
    fragment TicketClosedNotificationFields on TicketClosedNotificationRenderInfo {
  ticket {
    Id
    subject {
      Id
      label
    }
  }
}
    `;
export const TicketSharedNotificationFieldsFragmentDoc = gql`
    fragment TicketSharedNotificationFields on TicketSharedNotificationRenderInfo {
  ticket {
    Id
    subject {
      Id
      label
    }
    employee {
      Id
      Name
    }
  }
}
    `;
export const TicketStatusChangedNotificationFieldsFragmentDoc = gql`
    fragment TicketStatusChangedNotificationFields on TicketStatusChangedNotificationRenderInfo {
  ticket {
    Id
    subject {
      Id
      label
    }
  }
}
    `;
export const TicketSubmittedNotificationFieldsFragmentDoc = gql`
    fragment TicketSubmittedNotificationFields on TicketSubmittedNotificationRenderInfo {
  ticket {
    Id
    subject {
      Id
      label
    }
  }
}
    `;
export const TicketManagerClosedNotificationFieldsFragmentDoc = gql`
    fragment TicketManagerClosedNotificationFields on TicketManagerClosedNotificationRenderInfo {
  ticket {
    Id
    subject {
      Id
      label
    }
    employee {
      Id
      Name
    }
  }
}
    `;
export const TicketManagerStatusChangedNotificationFieldsFragmentDoc = gql`
    fragment TicketManagerStatusChangedNotificationFields on TicketManagerStatusChangedNotificationRenderInfo {
  ticket {
    Id
    subject {
      Id
      label
    }
    employee {
      Id
      Name
    }
  }
}
    `;
export const TimeBalanceWithdrawalNotificationRenderInfoFieldsFragmentDoc = gql`
    fragment TimeBalanceWithdrawalNotificationRenderInfoFields on TimeBalanceWithdrawalNotificationRenderInfo {
  withdrawal {
    Id
    flair__Amount__c
    flair__Withdrawal_Type__c
  }
}
    `;
export const NotificationItemFragmentDoc = gql`
    fragment NotificationItem on Notification {
  ...NotificationFields
  renderInfo {
    ...AbsenceNotificationFields
    ...AbsenceApprovalRequestNotificationFields
    ...CandidateEvaluationNotificationFields
    ...CommentNotificationFields
    ...CelebrationNotificationFields
    ...TimeEntryNotificationFields
    ...TimeLimitTimeEntryNotificationFields
    ...TimeEntryChangeRequestNotificationFields
    ...WorkflowItemNotificationFields
    ...TicketClosedNotificationFields
    ...TicketSharedNotificationFields
    ...TicketStatusChangedNotificationFields
    ...TicketSubmittedNotificationFields
    ...TicketManagerClosedNotificationFields
    ...TicketManagerStatusChangedNotificationFields
    ...TimeBalanceWithdrawalNotificationRenderInfoFields
  }
}
    ${NotificationFieldsFragmentDoc}
${AbsenceNotificationFieldsFragmentDoc}
${AbsenceApprovalRequestNotificationFieldsFragmentDoc}
${CandidateEvaluationNotificationFieldsFragmentDoc}
${CommentNotificationFieldsFragmentDoc}
${CelebrationNotificationFieldsFragmentDoc}
${TimeEntryNotificationFieldsFragmentDoc}
${TimeLimitTimeEntryNotificationFieldsFragmentDoc}
${TimeEntryChangeRequestNotificationFieldsFragmentDoc}
${WorkflowItemNotificationFieldsFragmentDoc}
${TicketClosedNotificationFieldsFragmentDoc}
${TicketSharedNotificationFieldsFragmentDoc}
${TicketStatusChangedNotificationFieldsFragmentDoc}
${TicketSubmittedNotificationFieldsFragmentDoc}
${TicketManagerClosedNotificationFieldsFragmentDoc}
${TicketManagerStatusChangedNotificationFieldsFragmentDoc}
${TimeBalanceWithdrawalNotificationRenderInfoFieldsFragmentDoc}`;
export const RequestAbsence_WithdrawalAllowanceFragmentDoc = gql`
    fragment RequestAbsence_WithdrawalAllowance on ValidateAbsenceRequestAllowance {
  id
  withdrawalAmount
  isSystem
  periodStartDate
  amountLeft
}
    `;
export const RequestAbsence_AllowanceFragmentDoc = gql`
    fragment RequestAbsence_Allowance on AbsenceYearlySummaryAllowance {
  absenceAllowanceId
  accrued
  used
  lost
  expired
}
    `;
export const RequestAbsence_YearlySummaryFragmentDoc = gql`
    fragment RequestAbsence_YearlySummary on AbsenceYearlySummary {
  employeeAbsenceCategoryId
  previousPeriod {
    startDate
    endDate
    allowances {
      ...RequestAbsence_Allowance
    }
  }
  currentPeriod {
    startDate
    endDate
    allowances {
      ...RequestAbsence_Allowance
    }
  }
  nextPeriod {
    startDate
    endDate
    allowances {
      ...RequestAbsence_Allowance
    }
  }
}
    ${RequestAbsence_AllowanceFragmentDoc}`;
export const RequestForm_EmployeeFragmentDoc = gql`
    fragment RequestForm_Employee on Employee {
  Id
  Name
}
    `;
export const TimeBalanceDetails_TimeBalanceSettingsFragmentDoc = gql`
    fragment TimeBalanceDetails_TimeBalanceSettings on TimeBalanceSettings {
  Id
  flair__Auto_Reset_Mode__c
  flair__Calculation_Mode__c
  flair__Daily_Threshold_Minutes__c
  flair__Threshold_Minutes__c
  flair__Maximum_Daily_Working_Minutes__c
  flair__Not_Deduct_Deficit__c
  flair__Negative_Capacity_Minutes__c
  flair__Positive_Capacity_Minutes__c
  flair__Premium_Level_1_Minutes__c
  flair__Premium_Level_1_Multiplier__c
  flair__Premium_Level_2_Minutes__c
  flair__Premium_Level_2_Multiplier__c
  flair__Start_Calculate_After_Minutes__c
  flair__Update_Mode__c
}
    `;
export const AbsencePopoverFragmentDoc = gql`
    fragment AbsencePopover on Absence {
  Id
  flair__Category_Icon__c
  flair__Category_Name__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__Comment__c
  flair__Working_Amount__c
  flair__Type__c
}
    `;
export const TimeSheetAbsenceFragmentDoc = gql`
    fragment TimeSheetAbsence on Absence {
  Id
  ...AbsencePopover
  flair__Category_Name__c
  flair__Category_Icon__c
  flair__Category_Id__c
  flair__Amount__c
  flair__Working_Amount__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__Type__c
  flair__Paid__c
  flair__Approval_Status__c
  flair__Category_Unlimited__c
}
    ${AbsencePopoverFragmentDoc}`;
export const TimeSheetYearlyChartFragmentDoc = gql`
    fragment TimeSheetYearlyChart on EmployeeTimeSheet {
  Id
  flair__Start_Date__c
  flair__Target_Hours__c
  flair__Time_Entry_Hours__c
  flair__Absence_Hours__c
  flair__Holiday_Hours__c
  workloads {
    Id
    flair__Start_Date__c
    flair__End_Date__c
    flair__Workload_Model__c
  }
}
    `;
export const TimesheetTrackedTimeFieldsFragmentDoc = gql`
    fragment TimesheetTrackedTimeFields on TimesheetTrackedTime {
  timesheetId
  totalTrackedMinutes
  totalWorkedMinutes
  totalDaysTracked
  days {
    timesheetId
    day
    trackedMinutes
    targetMinutes
    absenceMinutes
    holidayMinutes
    workedMinutes
    overtimeMinutes
    deficitMinutes
  }
}
    `;
export const TimeSheetGoalChartFragmentDoc = gql`
    fragment TimeSheetGoalChart on TimeSheet {
  Id
  flair__Start_Date__c
  flair__Approval_Status__c
  flair__Target_Hours__c
  flair__Given_Compensatory_Time_Level_1__c
  flair__Given_Compensatory_Time_Level_2__c
  flair__Approval_Status__c
  trackedTime {
    ...TimesheetTrackedTimeFields
  }
  workloads {
    Id
    flair__Start_Date__c
    flair__End_Date__c
    flair__Workload_Model__c
    timeFramework {
      Id
      flair__Overtime_Policy__c
    }
  }
}
    ${TimesheetTrackedTimeFieldsFragmentDoc}`;
export const TimeSheetOvertimePolicyFragmentDoc = gql`
    fragment TimeSheetOvertimePolicy on TimeSheet {
  Id
  flair__Start_Date__c
  workloads {
    Id
    flair__Workload_Model__c
    flair__Start_Date__c
    flair__End_Date__c
    timeFramework {
      Id
      flair__Overtime_Policy__c
    }
  }
}
    `;
export const TimeSheetDistChartFragmentDoc = gql`
    fragment TimeSheetDistChart on TimeSheet {
  Id
  flair__Target_Hours__c
  flair__Absence_Hours__c
  flair__Holiday_Hours__c
  flair__Current_Compensatory_Time_Level_1__c
  flair__Current_Compensatory_Time_Level_2__c
  flair__Given_Compensatory_Time_Level_1__c
  flair__Given_Compensatory_Time_Level_2__c
  flair__Non_Deductible_Absence_Hours__c
  flair__Approval_Status__c
  trackedTime {
    ...TimesheetTrackedTimeFields
  }
  ...TimeSheetOvertimePolicy
  workloads {
    Id
    flair__Workload_Model__c
  }
}
    ${TimesheetTrackedTimeFieldsFragmentDoc}
${TimeSheetOvertimePolicyFragmentDoc}`;
export const TimeSheetChartsPopoverFragmentDoc = gql`
    fragment TimeSheetChartsPopover on TimeSheet {
  Id
  ...TimeSheetGoalChart
  ...TimeSheetDistChart
}
    ${TimeSheetGoalChartFragmentDoc}
${TimeSheetDistChartFragmentDoc}`;
export const DurationWithOriginFragmentDoc = gql`
    fragment DurationWithOrigin on DurationWithOrigin {
  minutes
  timeEntryIds
  changeRequestIds
}
    `;
export const DateTimeWithOriginFragmentDoc = gql`
    fragment DateTimeWithOrigin on DateTimeWithOrigin {
  value
  timeEntryId
  changeRequestId
}
    `;
export const TimesheetDayChangesFragmentDoc = gql`
    fragment TimesheetDayChanges on TimesheetDayChanges {
  changeRequestIds
  trackedTimeStart {
    ...DateTimeWithOrigin
  }
  trackedTimeEnd {
    ...DateTimeWithOrigin
  }
  breaksDuration {
    ...DurationWithOrigin
  }
  trackedDuration {
    ...DurationWithOrigin
  }
  workedMinutes
}
    ${DateTimeWithOriginFragmentDoc}
${DurationWithOriginFragmentDoc}`;
export const LocationHolidayFragmentDoc = gql`
    fragment LocationHoliday on LocationHoliday {
  Id
  Name
  flair__Day__c
  flair__Official__c
  flair__Type__c
  startDate
  endDate
}
    `;
export const TimeEntryTimeSheetFieldsFragmentDoc = gql`
    fragment TimeEntryTimeSheetFields on TimeEntry {
  Id
  Name
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Working_Period_In_Hours__c
  flair__Total_Period_In_Hours__c
  flair__Payroll_Completed__c
  flair__Is_Locked__c
  flair__Non_compliant__c
  flair__Notes__c
  flair__Cost_Center__c
  LastModifiedDate
  breaks {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Total_Break_Period_in_Hours__c
    flair__Auto_adjusted_Datetime__c
    LastModifiedDate
  }
}
    `;
export const TimeSheetDayTimeEntryFragmentDoc = gql`
    fragment TimeSheetDayTimeEntry on TimeEntry {
  ...TimeEntryTimeSheetFields
}
    ${TimeEntryTimeSheetFieldsFragmentDoc}`;
export const TimeSheetDaySubRowTrackedTimeDayFragmentDoc = gql`
    fragment TimeSheetDaySubRowTrackedTimeDay on TimesheetDayTrackedTime {
  timesheetId
  day
  dayStartDateTime
  targetMinutes
  trackedDuration {
    ...DurationWithOrigin
  }
  breaksDuration {
    ...DurationWithOrigin
  }
  trackedTimeStart {
    ...DateTimeWithOrigin
  }
  trackedTimeEnd {
    ...DateTimeWithOrigin
  }
  dayChanges {
    ...TimesheetDayChanges
    changeRequests {
      Id
      flair__Creation_Time_Entry_Notes__c
    }
  }
  workedMinutes
  absenceMinutes
  holidayMinutes
  timeEntriesIds
  allAbsences {
    ...AbsencePopover
  }
  holidays {
    ...LocationHoliday
  }
  timeEntries {
    ...TimeSheetDayTimeEntry
  }
}
    ${DurationWithOriginFragmentDoc}
${DateTimeWithOriginFragmentDoc}
${TimesheetDayChangesFragmentDoc}
${AbsencePopoverFragmentDoc}
${LocationHolidayFragmentDoc}
${TimeSheetDayTimeEntryFragmentDoc}`;
export const LoomVideoFragmentDoc = gql`
    fragment LoomVideo on LoomVideo {
  Id
  Name
  flair__Loom_Id__c
  flair__Loom_Public_App_Id__c
  flair__Shared_Url__c
  flair__Embed_Url__c
  flair__Width__c
  flair__Height__c
  flair__Created_By__c
  CreatedDate
}
    `;
export const ExtraFieldValueShortFragmentDoc = gql`
    fragment ExtraFieldValueShort on ExtraFieldValue {
  fieldApiName
  jsonValue
  displayValue
  type
}
    `;
export const ExtraFieldValueFragmentDoc = gql`
    fragment ExtraFieldValue on ExtraFieldValue {
  ...ExtraFieldValueShort
  recordId
}
    ${ExtraFieldValueShortFragmentDoc}`;
export const ProjectTimesheetEntryFragmentDoc = gql`
    fragment ProjectTimesheetEntry on ProjectTimeEntry {
  Id
  flair__Minutes__c
  flair__Project__c
  flair__Cost_Center__c
  flair__Employee_Timesheet__c
  flair__Date__c
  flair__Notes__c
  flair__Time_Entry__c
  extraFields {
    ...ExtraFieldValue
  }
  recordType {
    ...RecordType
  }
}
    ${ExtraFieldValueFragmentDoc}
${RecordTypeFragmentDoc}`;
export const TimeSheetDayProjectTimeEntryFragmentDoc = gql`
    fragment TimeSheetDayProjectTimeEntry on TimeSheetDayProjectTimeEntry {
  Id
  flair__Minutes__c
  projectTimeEntry {
    ...ProjectTimesheetEntry
  }
}
    ${ProjectTimesheetEntryFragmentDoc}`;
export const TimeSheetDaySubRowTimeSheetDayFragmentDoc = gql`
    fragment TimeSheetDaySubRowTimeSheetDay on TimeSheetDay {
  Id
  flair__Day__c
  flair__Employee__c
  commentsCount
  loomVideo {
    ...LoomVideo
  }
  timeSheetDayProjectTimeEntries {
    ...TimeSheetDayProjectTimeEntry
  }
}
    ${LoomVideoFragmentDoc}
${TimeSheetDayProjectTimeEntryFragmentDoc}`;
export const TimeSheetsTable_TimeBalanceWithdrawalFragmentDoc = gql`
    fragment TimeSheetsTable_TimeBalanceWithdrawal on TimeBalanceWithdrawal {
  Id
  flair__Withdrawal_Type__c
  flair__Amount__c
  absenceAllowances {
    Id
    employeeAbsenceCategory {
      Id
      category {
        Id
        Name
      }
    }
  }
}
    `;
export const TimeSheetDaySubRowTimeSheetDayWithTimeBalanceFragmentDoc = gql`
    fragment TimeSheetDaySubRowTimeSheetDayWithTimeBalance on TimeSheetDay {
  ...TimeSheetDaySubRowTimeSheetDay
  timeBalanceAccumulated
  timeBalanceWithdrawals {
    ...TimeSheetsTable_TimeBalanceWithdrawal
  }
}
    ${TimeSheetDaySubRowTimeSheetDayFragmentDoc}
${TimeSheetsTable_TimeBalanceWithdrawalFragmentDoc}`;
export const TimeEntryChangeRequestFieldsFragmentDoc = gql`
    fragment TimeEntryChangeRequestFields on TimeEntryChangeRequest {
  Id
  flair__Employee__c
  flair__Time_Entry__c
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Status__c
  flair__Working_Period_In_Hours__c
  LastModifiedDate
  flair__Creation_Time_Entry_Notes__c
  flair__Cost_Center__c
  breaks {
    Id
    flair__Time_Entry_Break__c
    flair__Start_Datetime__c
    flair__End_Datetime__c
    LastModifiedDate
  }
  timeEntry {
    Id
    flair__Notes__c
    LastModifiedDate
  }
}
    `;
export const TimeSheetDaySubRowsFragmentDoc = gql`
    fragment TimeSheetDaySubRows on TimeSheet {
  Id
  flair__Employee__c
  trackedTime {
    timesheetId
    days {
      ...TimeSheetDaySubRowTrackedTimeDay
    }
  }
  timeSheetDays {
    ...TimeSheetDaySubRowTimeSheetDayWithTimeBalance
  }
  timeEntryChangeRequests {
    ...TimeEntryChangeRequestFields
  }
}
    ${TimeSheetDaySubRowTrackedTimeDayFragmentDoc}
${TimeSheetDaySubRowTimeSheetDayWithTimeBalanceFragmentDoc}
${TimeEntryChangeRequestFieldsFragmentDoc}`;
export const TimeSheetDetailsFragmentDoc = gql`
    fragment TimeSheetDetails on TimeSheet {
  Id
  ...TimeSheetChartsPopover
  ...TimeSheetDaySubRows
}
    ${TimeSheetChartsPopoverFragmentDoc}
${TimeSheetDaySubRowsFragmentDoc}`;
export const BreakLegislationRuleFragmentDoc = gql`
    fragment BreakLegislationRule on BreakLegislationRule {
  Id
  flair__Work_More_Than_Hour__c
  flair__Work_More_Than_Minute__c
  flair__Break__c
}
    `;
export const TimeFrameworkFragmentDoc = gql`
    fragment TimeFramework on TimeFramework {
  Id
  flair__Minimal_Break_Length__c
  breakLegislationRules {
    ...BreakLegislationRule
  }
  flair__Notify_Employee_For_Break_Time__c
  flair__Suggest_Adding_Break__c
  flair__Automatically_Deduct_Unused_Break__c
  flair__Block_Ending_Breaks__c
  flair__Is_Restrict_Future_Entries_Enabled__c
  flair__Track_Geolocation__c
}
    ${BreakLegislationRuleFragmentDoc}`;
export const TimeSheetWorkloadWithTimeFrameworkFragmentDoc = gql`
    fragment TimeSheetWorkloadWithTimeFramework on EmployeeWorkload {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  timeFramework {
    ...TimeFramework
  }
}
    ${TimeFrameworkFragmentDoc}`;
export const TimeSheetTimeEntriesDetailsFragmentDoc = gql`
    fragment TimeSheetTimeEntriesDetails on TimeSheet {
  Id
  flair__Approval_Status__c
  flair__Employee__c
  trackedTime {
    timesheetId
    days {
      timesheetId
      day
      dayStartDateTime
      startOfTrackedTime
      endOfTrackedTime
      targetMinutes
      trackedMinutes
      breaksMinutes
      timeEntries {
        ...TimeSheetDayTimeEntry
      }
    }
  }
  timeEntryChangeRequests {
    ...TimeEntryChangeRequestFields
  }
  workloads {
    Id
    ...TimeSheetWorkloadWithTimeFramework
  }
}
    ${TimeSheetDayTimeEntryFragmentDoc}
${TimeEntryChangeRequestFieldsFragmentDoc}
${TimeSheetWorkloadWithTimeFrameworkFragmentDoc}`;
export const TimeSheetPrefetchDataFragmentDoc = gql`
    fragment TimeSheetPrefetchData on TimeSheet {
  ...TimeSheetDetails
  ...TimeSheetTimeEntriesDetails
}
    ${TimeSheetDetailsFragmentDoc}
${TimeSheetTimeEntriesDetailsFragmentDoc}`;
export const EmployeeHubFeatureFragmentDoc = gql`
    fragment EmployeeHubFeature on EmployeeHubFeature {
  Id
  flair__IsGlobal__c
  flair__Hide_Absences__c
  flair__Hide_Announcements__c
  flair__Hide_Assessments__c
  flair__Hide_Certificates__c
  flair__Hide_Cheers__c
  flair__Hide_Corporate_Documents__c
  flair__Hide_Directory__c
  flair__Hide_Expenses__c
  flair__Hide_Goals__c
  flair__Hide_Home_Absent_Today__c
  flair__Hide_Home_Birthdays_Card__c
  flair__Hide_Home_New_Hires_Card__c
  flair__Hide_Org_Chart__c
  flair__Hide_Personal_Data__c
  flair__Hide_Personal_Documents__c
  flair__Hide_Private_Notes__c
  flair__Hide_Projects__c
  flair__Hide_Recruiting__c
  flair__Hide_Shift_Planner__c
  flair__Hide_Skills__c
  flair__Hide_Surveys__c
  flair__Hide_Time_Tracking__c
  flair__Hide_Workflows__c
  flair__Hide_HR_HelpDesk__c
  flair__Hide_Inventory__c
  flair__Customise_Dashboard_Main_Slider__c
  flair__Hide_Anniversaries__c
  flair__Hide_Public_Holidays__c
  flair__Hide_Employee_Bank_Details__c
  flair__Hide_Employee_Salaries__c
  flair__Hide_Employee_Workload_Details__c
}
    `;
export const AbsenceDataFragmentDoc = gql`
    fragment AbsenceData on Absence {
  Id
  flair__Approval_Status__c
  flair__Category_Name__c
  flair__Withdrawal_Amount__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__Type__c
  flair__Category_Restrict_Absence_Deletion__c
  flair__Category_Time_Tracking_Restricted__c
  flair__Employee_Absence_Category__c
  flair__Days_Times__c
  flair__Requires_Approval__c
  commentsCount
  loomVideo {
    ...LoomVideo
  }
  category {
    Id
    flair__Type__c
  }
  employeeAbsenceCategory {
    Id
    absenceRequestPolicies {
      Id
      absenceRequestPolicy {
        Id
        flair__Document_Upload__c
        flair__Min_Amount_For_Document_Upload__c
      }
    }
  }
}
    ${LoomVideoFragmentDoc}`;
export const EmployeeWithAvatarFragmentDoc = gql`
    fragment EmployeeWithAvatar on Employee {
  Id
  Name
  flair__First_Name__c
  flair__Last_Name__c
  avatar {
    Id
    url
  }
}
    `;
export const EmployeeSelectInfoFragmentDoc = gql`
    fragment EmployeeSelectInfo on Employee {
  ...EmployeeWithAvatar
}
    ${EmployeeWithAvatarFragmentDoc}`;
export const ColleagueWithAvatarFragmentDoc = gql`
    fragment ColleagueWithAvatar on Colleague {
  Id
  Name
  flair__First_Name__c
  flair__Last_Name__c
  avatar {
    Id
    url
  }
}
    `;
export const EmployeeSelectInfoColleagueFragmentDoc = gql`
    fragment EmployeeSelectInfoColleague on Colleague {
  ...ColleagueWithAvatar
}
    ${ColleagueWithAvatarFragmentDoc}`;
export const EvaluationCandidateFragmentDoc = gql`
    fragment EvaluationCandidate on JobCandidate {
  Id
  flair__Full_Name__c
  flair__Funnel_Stage__c
  flair__Final_Score__c
  job {
    Id
    Name
  }
}
    `;
export const EvaluationEmployeeFragmentDoc = gql`
    fragment EvaluationEmployee on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const EvaluationFragmentDoc = gql`
    fragment Evaluation on CandidateEvaluation {
  Id
  Name
  flair__Overall_Comment__c
  flair__Final_Score__c
  flair__Employee__c
  flair__Candidate__c
  flair__Due_Date__c
  flair__Skipped_At__c
  flair__Evaluated__c
  candidate {
    ...EvaluationCandidate
  }
  employee {
    ...EvaluationEmployee
  }
}
    ${EvaluationCandidateFragmentDoc}
${EvaluationEmployeeFragmentDoc}`;
export const FieldInfoFragmentDoc = gql`
    fragment FieldInfo on FieldInfo {
  name
  objectType
  locale
  label
  recordTypeId
  type
  picklistValues {
    label
    value
  }
}
    `;
export const MyEmployeeDataFieldFragmentDoc = gql`
    fragment MyEmployeeDataField on EmployeeDataField {
  parentId
  employeeId
  fieldInfo {
    ...FieldInfo
  }
  value
  oldValue
  state
  pendingApproval
}
    ${FieldInfoFragmentDoc}`;
export const MyEmployeeDataRelatedListFragmentDoc = gql`
    fragment MyEmployeeDataRelatedList on EmployeeDataRelatedList {
  label
  objectType
  records {
    id
    fields {
      ...MyEmployeeDataField
    }
  }
}
    ${MyEmployeeDataFieldFragmentDoc}`;
export const MyEmployeeDataFragmentDoc = gql`
    fragment MyEmployeeData on EmployeeData {
  employeeId
  sections {
    employeeId
    label
    fields {
      ...MyEmployeeDataField
    }
  }
  relatedLists {
    ...MyEmployeeDataRelatedList
  }
}
    ${MyEmployeeDataFieldFragmentDoc}
${MyEmployeeDataRelatedListFragmentDoc}`;
export const ContentDocumentDataFragmentDoc = gql`
    fragment ContentDocumentData on ContentDocument {
  Id
  FileExtension
  Title
  FileType
  ContentSize
  downloadUrl
  previewUrl
}
    `;
export const ReactionFragmentDoc = gql`
    fragment Reaction on Reaction {
  Id
  flair__Text__c
  flair__Employee__c
  flair__Related_Object_Name__c
  flair__Related_Id__c
  employee {
    Id
    Name
  }
}
    `;
export const CommentItemFragmentDoc = gql`
    fragment CommentItem on Comment {
  Id
  flair__Comment__c
  flair__Employee__c
  flair__Related_Id__c
  CreatedDate
  employee {
    Id
    Name
    flair__Position__c
    avatar {
      Id
      url
    }
  }
  ContentDocumentLinks {
    Id
    ContentDocumentId
    ContentDocument {
      ...ContentDocumentData
    }
  }
  reactions {
    ...Reaction
  }
  mentions {
    ...Mention
  }
}
    ${ContentDocumentDataFragmentDoc}
${ReactionFragmentDoc}
${MentionFragmentDoc}`;
export const FeedbackCycleItemFragmentDoc = gql`
    fragment FeedbackCycleItem on FeedbackCycle {
  Id
  Name
  flair__Deadline__c
  flair__State__c
  flair__Manage_Goals__c
  flair__Timeline_Type__c
  flair__Meeting_Required__c
  flair__With_Peers__c
  flair__Signature_required__c
  flair__Without_Reviewer__c
  flair__Rating_Min__c
  flair__Rating_Max__c
}
    `;
export const PicklistEntryFragmentDoc = gql`
    fragment PicklistEntry on PickListEntry {
  label
  value
}
    `;
export const ContentDocumentLinkDataFragmentDoc = gql`
    fragment ContentDocumentLinkData on ContentDocumentLink {
  Id
  ContentDocumentId
  LinkedEntityId
  downloadUrl
  viewUrl
  ContentDocument {
    Id
    CreatedDate
    ...ContentDocumentData
  }
}
    ${ContentDocumentDataFragmentDoc}`;
export const AbsenceDayDataFragmentDoc = gql`
    fragment AbsenceDayData on AbsenceDay {
  Id
  flair__Amount__c
  flair__Day__c
  flair__Start_Time__c
  flair__End_Time__c
}
    `;
export const RequestedAbsenceFragmentDoc = gql`
    fragment RequestedAbsence on Absence {
  Id
  flair__Category_Name__c
  flair__Working_Amount__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__EmployeeId__c
  flair__Type__c
  flair__Comment__c
  flair__Approval_Status__c
  CreatedDate
  flair__Days_Times__c
  commentsCount
  approvalRequests {
    Id
    flair__Approval_Status__c
    flair__Approver__c
    flair__Approver_Comment__c
  }
  employee {
    Id
    Name
  }
  employeeAbsenceCategory {
    Id
    flair__Unlimited__c
    allowancesSummary {
      availableAmount
      gainedThisYear
    }
    category {
      Id
      flair__Without_Balance__c
    }
  }
  overlappingAbsences {
    Id
    flair__Category_Name__c
    flair__Working_Amount__c
    flair__Start_Date__c
    flair__Start_Time__c
    flair__Start_Date_Half_Day__c
    flair__End_Date__c
    flair__End_Time__c
    flair__End_Date_Half_Day__c
    flair__Type__c
    employee {
      Id
      Name
    }
  }
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
  loomVideo {
    ...LoomVideo
  }
  absenceDays {
    ...AbsenceDayData
  }
}
    ${ContentDocumentLinkDataFragmentDoc}
${LoomVideoFragmentDoc}
${AbsenceDayDataFragmentDoc}`;
export const WithLoomVideoIdFragmentDoc = gql`
    fragment WithLoomVideoId on WithLoomVideo {
  Id
  ... on TimeSheetDay {
    ...TimeSheetDayId
  }
}
    ${TimeSheetDayIdFragmentDoc}`;
export const MeTimeEntryBreakReadCacheFragmentDoc = gql`
    fragment MeTimeEntryBreakReadCache on MyTimeEntryBreak {
  Id
  flair__Start_Datetime__c
  flair__End_Datetime__c
  LastModifiedDate
}
    `;
export const MeCurrentTimeEntryReadCacheFragmentDoc = gql`
    fragment MeCurrentTimeEntryReadCache on Me {
  Id
  currentTimeEntry {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    LastModifiedDate
    breaks {
      ...MeTimeEntryBreakReadCache
    }
  }
}
    ${MeTimeEntryBreakReadCacheFragmentDoc}`;
export const TimeTrackingSettings_AbsenceFragmentDoc = gql`
    fragment TimeTrackingSettings_Absence on Absence {
  Id
  flair__Approval_Status__c
  flair__Category_Time_Tracking_Restricted__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__End_Date__c
  flair__End_Time__c
}
    `;
export const TimeBalanceSettingsFragmentDoc = gql`
    fragment TimeBalanceSettings on TimeBalanceSettings {
  Id
  flair__Auto_Reset_Mode__c
  flair__Calculation_Mode__c
  flair__Daily_Threshold_Minutes__c
  flair__Threshold_Minutes__c
  flair__Maximum_Daily_Working_Minutes__c
  flair__Not_Deduct_Deficit__c
  flair__Negative_Capacity_Minutes__c
  flair__Positive_Capacity_Minutes__c
  flair__Premium_Level_1_Minutes__c
  flair__Premium_Level_1_Multiplier__c
  flair__Premium_Level_2_Minutes__c
  flair__Premium_Level_2_Multiplier__c
  flair__Start_Calculate_After_Minutes__c
  flair__Update_Mode__c
}
    `;
export const TimeLimitSettingsFragmentDoc = gql`
    fragment TimeLimitSettings on TimeLimitSettings {
  Id
  Name
  flair__Is_Restrict_Future_Entries_Enabled__c
  flair__Maximum_Daily_Restriction_Type__c
  flair__Maximum_Daily_Restriction_Action__c
  flair__Maximum_Daily_Restriction_Custom_Minutes__c
  flair__Maximum_Daily_Restriction_Notify_HR__c
  flair__Restrict_Tracking_On_Non_Working_Days__c
}
    `;
export const BreakScheduledFragmentDoc = gql`
    fragment BreakScheduled on BreakScheduled {
  id
  startTime
  endTime
}
    `;
export const WorkloadDayFragmentDoc = gql`
    fragment WorkloadDay on WorkloadDay {
  startTime
  endTime
  workingMinutes
  breakMinutes
  breaksScheduled {
    ...BreakScheduled
  }
}
    ${BreakScheduledFragmentDoc}`;
export const WorkloadWeekFragmentDoc = gql`
    fragment WorkloadWeek on WorkloadWeek {
  Id
  monday {
    ...WorkloadDay
  }
  tuesday {
    ...WorkloadDay
  }
  wednesday {
    ...WorkloadDay
  }
  thursday {
    ...WorkloadDay
  }
  friday {
    ...WorkloadDay
  }
  saturday {
    ...WorkloadDay
  }
  sunday {
    ...WorkloadDay
  }
}
    ${WorkloadDayFragmentDoc}`;
export const TimeTrackingSettings_WorkloadFieldsFragmentDoc = gql`
    fragment TimeTrackingSettings_WorkloadFields on EmployeeWorkload {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  flair__Time_Tracking_Type__c
  flair__Type__c
  flair__Hours_Per_Day__c
  flair__Working_Days__c
  timeFramework {
    ...TimeFramework
    timeBalanceSettings {
      ...TimeBalanceSettings
    }
    timeLimitSettings {
      ...TimeLimitSettings
    }
  }
  workloadWeeks {
    ...WorkloadWeek
  }
}
    ${TimeFrameworkFragmentDoc}
${TimeBalanceSettingsFragmentDoc}
${TimeLimitSettingsFragmentDoc}
${WorkloadWeekFragmentDoc}`;
export const MyAbsenceFilters_AbsenceRequestFragmentDoc = gql`
    fragment MyAbsenceFilters_AbsenceRequest on ApprovalRequest {
  Id
  flair__Approval_Status__c
  flair__Approver__c
  flair__Approver_Comment__c
  flair__Related_Id__c
  LastModifiedDate
  approver {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      Name
      url
    }
  }
}
    `;
export const ExtraFieldsTable_ColleagueFragmentDoc = gql`
    fragment ExtraFieldsTable_Colleague on Colleague {
  ...ColleagueWithAvatar
}
    ${ColleagueWithAvatarFragmentDoc}`;
export const ExtraFieldsTable_ProjectFragmentDoc = gql`
    fragment ExtraFieldsTable_Project on Project {
  Id
  flair__Name__c
}
    `;
export const ExtraFieldsTable_ExtraFieldValueFragmentDoc = gql`
    fragment ExtraFieldsTable_ExtraFieldValue on ExtraFieldValue {
  ...ExtraFieldValue
  referenceTo {
    Id
    ...ExtraFieldsTable_Colleague
    ...ExtraFieldsTable_Project
  }
}
    ${ExtraFieldValueFragmentDoc}
${ExtraFieldsTable_ColleagueFragmentDoc}
${ExtraFieldsTable_ProjectFragmentDoc}`;
export const ExtraFieldsTable_WithExtraFieldsFragmentDoc = gql`
    fragment ExtraFieldsTable_WithExtraFields on WithExtraFields {
  Id
  extraFields {
    ...ExtraFieldsTable_ExtraFieldValue
  }
}
    ${ExtraFieldsTable_ExtraFieldValueFragmentDoc}`;
export const AbsencesForManagerFragmentDoc = gql`
    fragment AbsencesForManager on Absence {
  Id
  flair__Category_Name__c
  flair__Category_Icon__c
  flair__Amount__c
  flair__Working_Amount__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__EmployeeId__c
  flair__Type__c
  flair__Comment__c
  flair__Approval_Status__c
  CreatedDate
  commentsCount
  employee {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      Name
      url
    }
  }
  approvalRequests {
    ...MyAbsenceFilters_AbsenceRequest
  }
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
  loomVideo {
    ...LoomVideo
  }
  ...ExtraFieldsTable_WithExtraFields
}
    ${MyAbsenceFilters_AbsenceRequestFragmentDoc}
${ContentDocumentLinkDataFragmentDoc}
${LoomVideoFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}`;
export const EmployeeHistoryDataFragmentDoc = gql`
    fragment EmployeeHistoryData on EmployeeHistory {
  Id
  Name
  flair__New_Value__c
  flair__Old_Value__c
  CreatedDate
}
    `;
export const EmployeeTimesheetTrackedTimeFieldsFragmentDoc = gql`
    fragment EmployeeTimesheetTrackedTimeFields on EmployeeTimeSheet {
  trackedTime {
    timesheetId
    totalTrackedMinutes
    totalWorkedMinutes
    totalDaysTracked
    days {
      timesheetId
      day
      trackedMinutes
      targetMinutes
      workedMinutes
      absenceMinutes
      holidayMinutes
      overtimeMinutes
      deficitMinutes
    }
  }
}
    `;
export const ManagerEmployeeTimesheetFragmentDoc = gql`
    fragment ManagerEmployeeTimesheet on EmployeeTimeSheet {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  flair__Target_Hours__c
  flair__Approval_Status__c
  flair__Time_Entry_Hours__c
  flair__Absence_Hours__c
  flair__Holiday_Hours__c
  flair__Current_Compensatory_Time_Level_1__c
  flair__Current_Compensatory_Time_Level_2__c
  flair__Given_Compensatory_Time_Level_1__c
  flair__Given_Compensatory_Time_Level_2__c
  flair__Non_Deductible_Absence_Hours__c
  ...EmployeeTimesheetTrackedTimeFields
  timeEntries {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Working_Period_In_Hours__c
  }
  workloads {
    Id
    flair__Hours__c
    flair__Hours_Per_Day__c
    flair__Working_Days__c
    flair__Start_Date__c
    flair__End_Date__c
    flair__Workload_Model__c
    flair__Type__c
    timeFramework {
      Id
      flair__Overtime_Policy__c
    }
  }
}
    ${EmployeeTimesheetTrackedTimeFieldsFragmentDoc}`;
export const AdditionalCompensationCard_AdditionalCompensationFragmentDoc = gql`
    fragment AdditionalCompensationCard_AdditionalCompensation on EmployeeAdditionalCompensation {
  Id
  flair__Amount__c
  flair__Compensation_Type__c
  flair__Recurring_Period_in_Months__c
  flair__Start_Date__c
  flair__End_Date__c
  CurrencyIsoCode
}
    `;
export const OneTimeCompensationCard_OneTimeCompensationFragmentDoc = gql`
    fragment OneTimeCompensationCard_OneTimeCompensation on EmployeeOneTimeCompensation {
  Id
  flair__Amount__c
  flair__Compensation_Type__c
  flair__Status__c
  flair__Compensation_Date__c
  CurrencyIsoCode
}
    `;
export const ObjectFieldChangeFragmentDoc = gql`
    fragment ObjectFieldChange on ObjectFieldChange {
  fieldApiName
  fieldLabel
  fieldType
  oldValue
  newValue
  oldDisplayName
  newDisplayName
  isRichTextArea
}
    `;
export const ObjectChangesFragmentDoc = gql`
    fragment ObjectChanges on ObjectChanges {
  objectApiName
  objectLabel
  fields {
    ...ObjectFieldChange
  }
}
    ${ObjectFieldChangeFragmentDoc}`;
export const ChangeRequestDetailsFieldsFragmentDoc = gql`
    fragment ChangeRequestDetailsFields on EmployeeDataChangeRequest {
  Id
  Name
  flair__Status__c
  flair__Employee__c
  flair__Requested_At__c
  flair__Change_Request_Reason__c
  flair__Object_Action__c
  flair__Changes__c
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
  employee {
    ...ColleagueWithAvatar
  }
  objectChanges {
    ...ObjectChanges
  }
  commentsCount
}
    ${ContentDocumentLinkDataFragmentDoc}
${ColleagueWithAvatarFragmentDoc}
${ObjectChangesFragmentDoc}`;
export const EmployeeDataChangeRequestFieldsFragmentDoc = gql`
    fragment EmployeeDataChangeRequestFields on EmployeeDataChangeRequest {
  Id
  Name
  flair__Employee__c
  flair__Requested_At__c
  flair__Status__c
  flair__Change_Request_Reason__c
  LastModifiedDate
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
  employee {
    ...ColleagueWithAvatar
  }
  commentsCount
}
    ${ContentDocumentLinkDataFragmentDoc}
${ColleagueWithAvatarFragmentDoc}`;
export const RequestFormFragmentDoc = gql`
    fragment RequestForm on RequestForm {
  Id
  Name
  flair__Information__c
  flair__Data_Change_Object_Name__c
  flair__Employee_Field_Api_Name__c
  flair__Request_Type__c
  flair__Visibility__c
  flair__Mandatory_Reason__c
  flair__Require_Approval__c
  flair__Position_Change_Enabled__c
  flair__Salary_Change_Enabled__c
  objectsFields {
    objectName
    fields
  }
  extraFieldInfos {
    ...ExtraFieldFormInfo
  }
  recordTypes {
    ...RecordType
  }
}
    ${ExtraFieldFormInfoFragmentDoc}
${RecordTypeFragmentDoc}`;
export const ObjectFieldValueFragmentDoc = gql`
    fragment ObjectFieldValue on ObjectFieldValue {
  fieldInfo {
    objectType
    name
    locale
    label
    recordTypeId
    type
    picklistValues {
      label
      value
    }
  }
  value
}
    `;
export const EmployeeDetailsFragmentDoc = gql`
    fragment EmployeeDetails on Employee {
  Id
  Name
  location {
    Id
    Name
  }
  department {
    Id
    Name
  }
  flair__Company_Email__c
  flair__Position__c
  flair__Start_Date__c
}
    `;
export const ManagerTimeSheetFragmentDoc = gql`
    fragment ManagerTimeSheet on TimeSheet {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  flair__Type__c
  flair__Target_Hours__c
  flair__Time_Entry_Hours__c
  flair__Current_Compensatory_Time_Level_1__c
  flair__Current_Compensatory_Time_Level_2__c
  flair__Given_Compensatory_Time_Level_1__c
  flair__Given_Compensatory_Time_Level_2__c
  flair__Approval_Status__c
  flair__Non_Deductible_Absence_Hours__c
  trackedTime {
    ...TimesheetTrackedTimeFields
  }
  employee {
    Id
    Name
  }
  timeEntries {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Working_Period_In_Hours__c
  }
  ...TimeSheetOvertimePolicy
  workloads {
    Id
    flair__Hours__c
    flair__Hours_Per_Day__c
    flair__Working_Days__c
    flair__Start_Date__c
    flair__End_Date__c
    flair__Workload_Model__c
    flair__Type__c
  }
}
    ${TimesheetTrackedTimeFieldsFragmentDoc}
${TimeSheetOvertimePolicyFragmentDoc}`;
export const TimeSheetTableFieldsFragmentDoc = gql`
    fragment TimeSheetTableFields on TimeSheet {
  flair__Employee__c
  flair__Start_Date__c
  flair__End_Date__c
  flair__Type__c
  flair__Target_Hours__c
  flair__Time_Entry_Hours__c
  flair__Approval_Status__c
  flair__Current_Compensatory_Time_Level_1__c
  flair__Current_Compensatory_Time_Level_2__c
  flair__Given_Compensatory_Time_Level_1__c
  flair__Given_Compensatory_Time_Level_2__c
  flair__Time_Entries_Hours_Diff__c
  workedHours
}
    `;
export const TimeSheetTableFragmentDoc = gql`
    fragment TimeSheetTable on TimeSheet {
  Id
  ...TimeSheetTableFields
  employee {
    ...EmployeeWithAvatar
  }
  warnings {
    id
    message
  }
  timeSheetDays {
    ...TimeSheetDaySubRowTimeSheetDay
  }
}
    ${TimeSheetTableFieldsFragmentDoc}
${EmployeeWithAvatarFragmentDoc}
${TimeSheetDaySubRowTimeSheetDayFragmentDoc}`;
export const AbsenceApprovalRequestToMeFragmentDoc = gql`
    fragment AbsenceApprovalRequestToMe on AbsenceApprovalRequestToMe {
  Id
  CreatedDate
  LastModifiedDate
  absence {
    Id
    flair__Category_Name__c
    flair__Category_Icon__c
    flair__Amount__c
    flair__Working_Amount__c
    flair__Start_Date__c
    flair__Start_Time__c
    flair__Start_Date_Half_Day__c
    flair__End_Date__c
    flair__End_Time__c
    flair__End_Date_Half_Day__c
    flair__EmployeeId__c
    flair__Type__c
    flair__Comment__c
    flair__Approval_Status__c
    commentsCount
    employee {
      Id
      Name
      flair__First_Name__c
      flair__Last_Name__c
      avatar {
        Id
        Name
        url
      }
    }
    approvalRequests {
      Id
      flair__Approval_Status__c
      flair__Approver__c
      flair__Approver_Comment__c
      LastModifiedDate
      approver {
        Id
        Name
        flair__First_Name__c
        flair__Last_Name__c
        avatar {
          Id
          Name
          url
        }
      }
    }
    ContentDocumentLinks__r {
      ...ContentDocumentLinkData
    }
    loomVideo {
      ...LoomVideo
    }
    ...ExtraFieldsTable_WithExtraFields
  }
}
    ${ContentDocumentLinkDataFragmentDoc}
${LoomVideoFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}`;
export const HolidayFragmentDoc = gql`
    fragment Holiday on Holiday {
  Id
  Name
  startDate
  endDate
  flair__Official__c
  flair__Type__c
  flair__Day__c
}
    `;
export const ApprovalRequestWithAbsenceFragmentDoc = gql`
    fragment ApprovalRequestWithAbsence on ApprovalRequest {
  Id
  CreatedDate
  LastModifiedDate
  flair__Related_Object_Name__c
  flair__Related_Id__c
  flair__Approval_Status__c
  flair__Approver__c
  flair__Approver_Comment__c
  approver {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      Name
      url
    }
  }
  absence {
    Id
    flair__Category_Name__c
    flair__Category_Icon__c
    flair__Amount__c
    flair__Working_Amount__c
    flair__Start_Date__c
    flair__Start_Time__c
    flair__Start_Date_Half_Day__c
    flair__End_Date__c
    flair__End_Time__c
    flair__End_Date_Half_Day__c
    flair__EmployeeId__c
    flair__Type__c
    flair__Comment__c
    flair__Approval_Status__c
    commentsCount
    CreatedDate
    employee {
      Id
      Name
      flair__First_Name__c
      flair__Last_Name__c
      avatar {
        Id
        Name
        url
      }
    }
    approvalRequests {
      Id
      flair__Approval_Status__c
      flair__Approver__c
      flair__Approver_Comment__c
      flair__Related_Id__c
      LastModifiedDate
      approver {
        Id
        Name
        flair__First_Name__c
        flair__Last_Name__c
        avatar {
          Id
          Name
          url
        }
      }
    }
    ContentDocumentLinks__r {
      ...ContentDocumentLinkData
    }
    loomVideo {
      ...LoomVideo
    }
    ...ExtraFieldsTable_WithExtraFields
  }
}
    ${ContentDocumentLinkDataFragmentDoc}
${LoomVideoFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}`;
export const ApproveRejectPayloadFragmentDoc = gql`
    fragment ApproveRejectPayload on ApprovalRequest {
  Id
  flair__Approval_Status__c
  flair__Approver_Comment__c
  LastModifiedDate
  absence {
    Id
    flair__Comment__c
    flair__Approval_Status__c
  }
}
    `;
export const RequestAbsenceButtonFragmentDoc = gql`
    fragment RequestAbsenceButton on EmployeeAbsenceCategory {
  Id
  flair__Unlimited__c
  category {
    Id
    Name
    flair__Icon__c
    flair__Type__c
    flair__Order__c
    flair__Without_Balance__c
    group {
      Id
      Name
      flair__Order__c
    }
  }
  allowancesSummary {
    availableAmount
    gainedThisYear
    usedAmount
  }
  absenceRequestPolicies {
    Id
    absenceRequestPolicy {
      Id
      Name
    }
  }
}
    `;
export const CategoryAccordion_EmployeeAbsenceCategoryFragmentDoc = gql`
    fragment CategoryAccordion_EmployeeAbsenceCategory on EmployeeAbsenceCategory {
  ...RequestAbsenceButton
  Id
  flair__Unlimited__c
  category {
    Id
    Name
    flair__Unlimited__c
    flair__Without_Balance__c
    flair__Icon__c
    flair__Type__c
    flair__Compensatory_Time__c
    group {
      Id
      Name
    }
  }
  allowancesSummary {
    availableAmount
    gainedThisYear
    usedAmount
  }
}
    ${RequestAbsenceButtonFragmentDoc}`;
export const CategoryAccordion_AllowanceFragmentDoc = gql`
    fragment CategoryAccordion_Allowance on AbsenceYearlySummaryAllowance {
  absenceAllowanceId
  accrualPolicyId
  accrued
  title
}
    `;
export const CategoryAccordion_AbsenceFragmentDoc = gql`
    fragment CategoryAccordion_Absence on Absence {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  flair__Working_Amount__c
}
    `;
export const CategoryAccordion_CarriedOverFragmentDoc = gql`
    fragment CategoryAccordion_CarriedOver on AbsenceYearlySummaryCarriedOver {
  amount
  used
  lost
  expired
  expireOn
}
    `;
export const CategoryAccordion_YearlySummaryFragmentDoc = gql`
    fragment CategoryAccordion_YearlySummary on AbsenceYearlySummary {
  employeeAbsenceCategoryId
  isUnlimited
  hasYearlyBasedAccrualPolicy
  previousPeriod {
    startDate
    endDate
    accrued
    allowances {
      ...CategoryAccordion_Allowance
    }
    used
    taken
    takenAbsences {
      ...CategoryAccordion_Absence
    }
  }
  currentPeriod {
    startDate
    endDate
    available
    accrued
    allowances {
      ...CategoryAccordion_Allowance
    }
    taken
    planned
    carriedOverFromPrevYear {
      ...CategoryAccordion_CarriedOver
    }
    takenAbsences {
      ...CategoryAccordion_Absence
    }
    plannedAbsences {
      ...CategoryAccordion_Absence
    }
  }
  nextPeriod {
    startDate
    endDate
    willAccrue
    allowances {
      ...CategoryAccordion_Allowance
    }
    planned
    plannedAbsences {
      ...CategoryAccordion_Absence
    }
  }
}
    ${CategoryAccordion_AllowanceFragmentDoc}
${CategoryAccordion_AbsenceFragmentDoc}
${CategoryAccordion_CarriedOverFragmentDoc}`;
export const CategoryAccordion_EmployeeAbsenceCategoryForYearlySummaryFragmentDoc = gql`
    fragment CategoryAccordion_EmployeeAbsenceCategoryForYearlySummary on EmployeeAbsenceCategory {
  Id
  flair__Unlimited__c
  category {
    Id
    Name
    flair__Unlimited__c
    flair__Without_Balance__c
    flair__Icon__c
    flair__Type__c
    flair__Compensatory_Time__c
    group {
      Id
      Name
    }
  }
  currentYearSummary {
    ...CategoryAccordion_YearlySummary
  }
}
    ${CategoryAccordion_YearlySummaryFragmentDoc}`;
export const AbsencesByYearFragmentDoc = gql`
    fragment AbsencesByYear on Absence {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  flair__Working_Amount__c
  flair__Employee_Absence_Category__c
  flair__Approval_Status__c
}
    `;
export const ShiftBreakFieldsFragmentDoc = gql`
    fragment ShiftBreakFields on ShiftBreak {
  flair__Start_Datetime__c
  flair__End_Datetime__c
}
    `;
export const EmployeeShiftFieldsFragmentDoc = gql`
    fragment EmployeeShiftFields on EmployeeShift {
  Id
  Name
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Location__c
  flair__Total_Break_Period_in_Minutes__c
  flair__Open_Shift__c
  flair__Employee_Notes__c
  location {
    Id
    Name
  }
  breaks {
    ...ShiftBreakFields
  }
  shiftLabels {
    Id
    Name
    flair__Tag_Name__c
  }
}
    ${ShiftBreakFieldsFragmentDoc}`;
export const AbsenceRateReportMonthFragmentFragmentDoc = gql`
    fragment AbsenceRateReportMonthFragment on AbsenceRateReportMonth {
  monthDate
  absenceRate
}
    `;
export const AbsenceRateReportPayloadFragmentFragmentDoc = gql`
    fragment AbsenceRateReportPayloadFragment on AbsenceRateReportPayload {
  overallAbsenceRate
  months {
    ...AbsenceRateReportMonthFragment
  }
}
    ${AbsenceRateReportMonthFragmentFragmentDoc}`;
export const EmployeeOvertimeReportFragmentFragmentDoc = gql`
    fragment EmployeeOvertimeReportFragment on EmployeeOvertimeReport {
  employeeId
  employeeName
  totalOvertime
}
    `;
export const OvertimeReportPayloadFragmentFragmentDoc = gql`
    fragment OvertimeReportPayloadFragment on OvertimeReportPayload {
  overallOvertime
  employeeResults {
    ...EmployeeOvertimeReportFragment
  }
}
    ${EmployeeOvertimeReportFragmentFragmentDoc}`;
export const EmployeeTurnoverRateReportMonthFragmentFragmentDoc = gql`
    fragment EmployeeTurnoverRateReportMonthFragment on EmployeeTurnoverRateReportMonth {
  monthDate
  turnoverRate
}
    `;
export const EmployeeTurnoverRateReportPayloadFragmentFragmentDoc = gql`
    fragment EmployeeTurnoverRateReportPayloadFragment on EmployeeTurnoverRateReportPayload {
  overallTurnoverRate
  monthlyResults {
    ...EmployeeTurnoverRateReportMonthFragment
  }
}
    ${EmployeeTurnoverRateReportMonthFragmentFragmentDoc}`;
export const ApprovalPathColleagueFragmentDoc = gql`
    fragment ApprovalPathColleague on Colleague {
  Id
  Name
  department {
    Id
    Name
  }
  avatar {
    Id
    url
  }
}
    `;
export const MyApprovalRequestsTableFieldsFragmentDoc = gql`
    fragment MyApprovalRequestsTableFields on ApprovalRequest {
  Id
  Name
  flair__Approval_Status__c
  flair__Action_Datetime__c
  flair__Related_Object_Name__c
  flair__Related_Id__c
  relatedRecordObjectName
  flair__Approver_Comment__c
  flair__Approver__c
  relatedRecordName
  CreatedDate
  flair__Requested_At__c
  LastModifiedDate
  recordEmployee {
    Id
    Name
    avatar {
      Id
      url
    }
    flair__Position__c
    flair__Department__c
  }
  approver {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      Name
      url
    }
  }
  absence {
    Id
    flair__Approval_Status__c
  }
}
    `;
export const CelebrationColleagueFragmentDoc = gql`
    fragment CelebrationColleague on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
  department {
    Id
    Name
  }
}
    `;
export const TeamFragmentDoc = gql`
    fragment Team on Team {
  Id
  Name
}
    `;
export const CelebrationFragmentDoc = gql`
    fragment Celebration on Celebration {
  Id
  flair__Message__c
  flair__Predefined_Image__c
  flair__Public__c
  flair__Type__c
  CreatedDate
  commentsCount
  loomVideo {
    ...LoomVideo
  }
  sender {
    ...CelebrationColleague
  }
  recipients {
    Id
    flair__Recipient_Type__c
    flair__Order__c
    employee {
      ...CelebrationColleague
    }
    team {
      ...Team
    }
  }
  reactions {
    ...Reaction
  }
}
    ${LoomVideoFragmentDoc}
${CelebrationColleagueFragmentDoc}
${TeamFragmentDoc}
${ReactionFragmentDoc}`;
export const CertificateDataFragmentDoc = gql`
    fragment CertificateData on EmployeeCertificate {
  Id
  Name
  flair__Issue_Date__c
  flair__Expiration_Date__c
  flair__Planned_Date__c
  flair__Issued_By__c
  flair__Certificate__c
  flair__Employee__c
  flair__Certificate_Link__c
  flair__Status__c
  certificate {
    Id
    Name
  }
  ContentDocumentLinks {
    ...ContentDocumentLinkData
  }
  commentsCount
}
    ${ContentDocumentLinkDataFragmentDoc}`;
export const DashboardColleagueFieldsFragmentDoc = gql`
    fragment DashboardColleagueFields on Colleague {
  Id
  Name
  flair__First_Name__c
  flair__Last_Name__c
  flair__Company_Email__c
  flair__Position__c
  flair__Company_Phone_Number__c
  location {
    Id
    Name
  }
  avatar {
    Id
    url
  }
  department {
    Id
    Name
  }
  manager {
    Id
    Name
  }
}
    `;
export const DashboardAbsentToday_ColleagueFragmentDoc = gql`
    fragment DashboardAbsentToday_Colleague on Absence {
  ...AbsencePopover
  Id
  flair__Approval_Status__c
  flair__Amount__c
  employee {
    ...DashboardColleagueFields
  }
}
    ${AbsencePopoverFragmentDoc}
${DashboardColleagueFieldsFragmentDoc}`;
export const DashboardAnniversaries_ColleagueFragmentDoc = gql`
    fragment DashboardAnniversaries_Colleague on Colleague {
  ...DashboardColleagueFields
  flair__Start_Date__c
  flair__Upcoming_Anniversary__c
}
    ${DashboardColleagueFieldsFragmentDoc}`;
export const DashboardBirthdayColleagueFieldsFragmentDoc = gql`
    fragment DashboardBirthdayColleagueFields on Colleague {
  ...DashboardColleagueFields
  flair__Birthday_this_year__c
  flair__Upcoming_Birthday__c
}
    ${DashboardColleagueFieldsFragmentDoc}`;
export const DashboardEndOfProbation_ColleagueFragmentDoc = gql`
    fragment DashboardEndOfProbation_Colleague on Colleague {
  ...DashboardColleagueFields
  flair__Start_Date__c
  flair__End_Of_Probation_Period__c
}
    ${DashboardColleagueFieldsFragmentDoc}`;
export const DashboardLastUpdate_ColleagueFragmentDoc = gql`
    fragment DashboardLastUpdate_Colleague on Colleague {
  ...DashboardColleagueFields
  flair__Start_Date__c
}
    ${DashboardColleagueFieldsFragmentDoc}`;
export const Dashboard_AbsenceCategoryFragmentDoc = gql`
    fragment Dashboard_AbsenceCategory on EmployeeAbsenceCategory {
  ...RequestAbsenceButton
  Id
  flair__Unlimited__c
  category {
    Id
    Name
    flair__Icon__c
    flair__Type__c
    flair__Paid__c
    flair__Unlimited__c
    flair__Compensatory_Time__c
    flair__Absence_Categories_Group__c
    flair__Without_Balance__c
    group {
      Id
      Name
    }
  }
  allowancesSummary {
    availableAmount
    gainedThisYear
  }
}
    ${RequestAbsenceButtonFragmentDoc}`;
export const Dashboard_UpcomingAbsencesFragmentDoc = gql`
    fragment Dashboard_UpcomingAbsences on Absence {
  Id
  flair__Approval_Status__c
  flair__Category_Name__c
  flair__Category_Icon__c
  flair__Amount__c
  flair__Withdrawal_Amount__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__Type__c
  commentsCount
}
    `;
export const DocumentCreatedByColleagueFragmentDoc = gql`
    fragment DocumentCreatedByColleague on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const ContentDocumentLinksDataFragmentDoc = gql`
    fragment ContentDocumentLinksData on ContentDocumentLink {
  Id
  ContentDocumentId
  LinkedEntityId
  downloadUrl
  viewUrl
  ContentDocument {
    ...ContentDocumentData
  }
}
    ${ContentDocumentDataFragmentDoc}`;
export const CorporateDocumentDataFragmentDoc = gql`
    fragment CorporateDocumentData on CompanyDocument {
  Id
  Name
  LastModifiedDate
  CreatedDate
  flair__Created_By__c
  createdBy {
    ...DocumentCreatedByColleague
  }
  ContentDocumentLinks {
    ...ContentDocumentLinksData
  }
}
    ${DocumentCreatedByColleagueFragmentDoc}
${ContentDocumentLinksDataFragmentDoc}`;
export const CreatedByColleagueFragmentDoc = gql`
    fragment CreatedByColleague on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const PersonalDocumentFolderDataFragmentDoc = gql`
    fragment PersonalDocumentFolderData on EmployeeDocumentFolder {
  Id
  Name
  flair__Employee__c
  flair__Parent_Folder__c
  parentFolderId
  LastModifiedDate
  createdBy {
    ...CreatedByColleague
  }
  CreatedDate
  fullPath
  children {
    Id
  }
}
    ${CreatedByColleagueFragmentDoc}`;
export const DocumentCategoryDataFragmentDoc = gql`
    fragment DocumentCategoryData on DocumentCategory {
  Id
  Name
}
    `;
export const PersonalDocumentFieldsFragmentDoc = gql`
    fragment PersonalDocumentFields on EmployeeDocument {
  Id
  Name
  flair__Employee_Document_Folder__c
  flair__Note__c
  LastModifiedDate
  CreatedDate
  flair__Document_Category__c
  flair__Approval_Status__c
  parentFolderId
  createdBy {
    ...DocumentCreatedByColleague
  }
  ContentDocumentLinks__r {
    ...ContentDocumentLinksData
  }
  documentCategory {
    ...DocumentCategoryData
  }
  fullPath
  commentsCount
  canDelete
  approvalRequest {
    Id
    flair__Approval_Status__c
    flair__Approver__c
  }
}
    ${DocumentCreatedByColleagueFragmentDoc}
${ContentDocumentLinksDataFragmentDoc}
${DocumentCategoryDataFragmentDoc}`;
export const NavigatableFragmentDoc = gql`
    fragment Navigatable on Navigatable {
  Id
  ... on EmployeeDocumentFolder {
    ...PersonalDocumentFolderData
  }
  ... on EmployeeDocument {
    ...PersonalDocumentFields
  }
  parentFolderId
  fullPath
}
    ${PersonalDocumentFolderDataFragmentDoc}
${PersonalDocumentFieldsFragmentDoc}`;
export const PersonalDocumentDataFragmentDoc = gql`
    fragment PersonalDocumentData on EmployeeDocument {
  ...PersonalDocumentFields
  parentFolder {
    ...PersonalDocumentFolderData
  }
}
    ${PersonalDocumentFieldsFragmentDoc}
${PersonalDocumentFolderDataFragmentDoc}`;
export const CompanyDocumentFragmentDoc = gql`
    fragment CompanyDocument on CompanyDocument {
  Id
  Name
  CreatedDate
  ContentDocumentLinks {
    ...ContentDocumentLinkData
  }
}
    ${ContentDocumentLinkDataFragmentDoc}`;
export const EmployeeDocumentFragmentDoc = gql`
    fragment EmployeeDocument on EmployeeDocument {
  Id
  Name
  flair__Document_Category__c
  flair__Approval_Status__c
  flair__Self_Uploaded__c
  CreatedDate
  documentCategory {
    Id
    Name
  }
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
}
    ${ContentDocumentLinkDataFragmentDoc}`;
export const EvaluationTemplateFragmentFragmentDoc = gql`
    fragment EvaluationTemplateFragment on EvaluationTemplate {
  Id
  Name
  flair__Rating_Min__c
  flair__Rating_Max__c
  questions {
    Id
    Name
    flair__Name__c
    flair__Question_Type__c
    flair__Sequence__c
    flair__Hint__c
    flair__Required__c
    options {
      Id
      Name
      flair__Hint__c
      flair__Required__c
    }
  }
}
    `;
export const EmployeeEvaluationFragmentFragmentDoc = gql`
    fragment EmployeeEvaluationFragment on EmployeeEvaluation {
  Id
  Name
  flair__Overall_Comment__c
  flair__Final_Score__c
  flair__Evaluated__c
  flair__Evaluator__c
  flair__Employee__c
  LastModifiedDate
  employee {
    Id
    Name
    flair__Company_Email__c
    flair__Start_Date__c
    flair__End_Date__c
    location {
      Name
    }
    department {
      Id
      Name
    }
    avatar {
      Id
      url
      urlLarge
    }
  }
  answers {
    Id
    Name
    flair__Employee_Evaluation__c
    flair__Question_Type__c
    flair__Evaluation_Template_Question__c
    flair__Evaluation_Template_Option__c
    flair__Answer__c
    flair__Score__c
  }
  evaluationTemplate {
    ...EvaluationTemplateFragment
  }
  workflowItem {
    Id
    flair__Due_Date__c
    flair__Workflow__c
  }
}
    ${EvaluationTemplateFragmentFragmentDoc}`;
export const EngagementSurveyQuestionAnswerFragmentDoc = gql`
    fragment engagementSurveyQuestionAnswer on EngagementSurveyQuestionAnswer {
  Id
  flair__Comment__c
  flair__Employee__c
  flair__Engagement_Survey__c
  flair__Engagement_Survey_Employee_Response__c
  flair__Engagement_Survey_Question__c
  flair__Free_Text__c
  flair__Score__c
  selectedOptions {
    Id
    flair__Engagement_Survey_Question_Option__c
    flair__Value__c
  }
}
    `;
export const EngagementSurveyEmployeeResponseFragmentDoc = gql`
    fragment engagementSurveyEmployeeResponse on EngagementSurveyEmployeeResponse {
  Id
  flair__Employee__c
  flair__Submitted_At__c
  flair__Dismissed_At__c
  engagementSurvey {
    Id
    Name
    flair__Long_Introduction__c
    flair__Deadline__c
    flair__Is_Anonymous__c
    flair__Is_Compulsory__c
    flair__Rating_Min__c
    flair__Rating_Max__c
    deadlineOver
    sections {
      Id
      Name
      flair__Engagement_Survey__c
      questions {
        Id
        flair__Question_Text__c
        flair__Can_comment__c
        flair__Description__c
        flair__Hint__c
        flair__Is_Optional__c
        flair__Order__c
        flair__Type__c
        flair__Engagement_Survey__c
        flair__Engagement_Survey_Section__c
        options {
          Id
          Name
          flair__Order__c
          flair__Required__c
        }
      }
    }
  }
  questionsAnswers {
    ...engagementSurveyQuestionAnswer
  }
}
    ${EngagementSurveyQuestionAnswerFragmentDoc}`;
export const EngagementSurveyDtoFragmentDoc = gql`
    fragment engagementSurveyDto on EngagementSurveyDto {
  id
  name
  deadline
  state
  compulsory
  createdOn
  submittedAt
  dismissedAt
}
    `;
export const RecordTypeBaseFragmentDoc = gql`
    fragment RecordTypeBase on RecordType {
  Id
  Name
  DeveloperName
}
    `;
export const TaxFragmentDoc = gql`
    fragment Tax on Tax {
  Id
  Name
  flair__Percentage__c
}
    `;
export const ExpenseItemFragmentDoc = gql`
    fragment ExpenseItem on ExpenseItem {
  Id
  Name
  flair__Manual_Amount__c
  flair__Amount__c
  flair__Note__c
  flair__Tax__c
  flair__Breakfast_Provided__c
  flair__Lunch_Provided__c
  flair__Dinner_Provided__c
  flair__Address_From__c
  flair__Address_To__c
  flair__Km_Distance__c
  flair__Distance_Sync_In_Progress__c
  RecordTypeId
  merchant {
    Id
    Name
  }
  tax {
    ...Tax
  }
  recordType {
    ...RecordTypeBase
  }
  ContentDocumentLinks {
    ...ContentDocumentLinkData
  }
  extraFields {
    ...ExtraFieldValue
  }
}
    ${TaxFragmentDoc}
${RecordTypeBaseFragmentDoc}
${ContentDocumentLinkDataFragmentDoc}
${ExtraFieldValueFragmentDoc}`;
export const ExpenseDataFragmentDoc = gql`
    fragment ExpenseData on Expense {
  Id
  Name
  flair__Description__c
  flair__Amount__c
  flair__Final_Amount__c
  flair__Expense_Date__c
  flair__Date_From__c
  flair__Date_To__c
  flair__Time_From__c
  flair__Time_To__c
  flair__Status__c
  flair__Expense_Group__c
  flair__Reimbursed__c
  flair__Is_Draft__c
  flair__Decline_Reason__c
  flair__OCR__c
  flair__OCR_Completed_At__c
  CurrencyIsoCode
  CreatedDate
  recordType {
    ...RecordTypeBase
  }
  project {
    Id
    flair__Name__c
  }
  merchant {
    Id
    Name
  }
  expenseCategory {
    Id
    Name
  }
  employee {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      url
    }
  }
  ContentDocumentLinks {
    ...ContentDocumentLinkData
  }
  commentsCount
  extraFields {
    ...ExtraFieldValue
  }
  expenseItems {
    ...ExpenseItem
  }
}
    ${RecordTypeBaseFragmentDoc}
${ContentDocumentLinkDataFragmentDoc}
${ExtraFieldValueFragmentDoc}
${ExpenseItemFragmentDoc}`;
export const ExpenseGroupDataFragmentDoc = gql`
    fragment ExpenseGroupData on ExpenseGroup {
  Id
  Name
  flair__Status__c
  flair__Type__c
  flair__Employee__c
  flair__Trip_Location__c
  flair__Reimbursed__c
  flair__Decline_Reason__c
  CurrencyIsoCode
  isGroup
  CreatedDate
  employee {
    Id
    Name
  }
  expenses {
    Id
  }
  totalAmount
  startDate
  endDate
  commentsCount
  comments {
    Id
  }
}
    `;
export const ExpenseRuleFragmentDoc = gql`
    fragment ExpenseRule on ExpenseRule {
  Id
  Name
  flair__Amount_Per__c
  flair__Compensation_Amount__c
  flair__Condition_Field__c
  flair__Condition_Operator__c
  flair__Condition_Value__c
  flair__Percentage_Addition__c
  flair__Valid_For_Record_Types__c
}
    `;
export const ExtraFieldInfoIdFragmentDoc = gql`
    fragment ExtraFieldInfoId on ExtraFieldValue {
  extraFieldInfoId
  fieldApiName
  type
  jsonValue
  displayValue
}
    `;
export const HomeTodayAbsenceCardAbsenceFragmentDoc = gql`
    fragment HomeTodayAbsenceCardAbsence on Absence {
  ...AbsencePopover
  Id
  flair__Approval_Status__c
  flair__Amount__c
  employee {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    avatar {
      Id
      url
    }
  }
}
    ${AbsencePopoverFragmentDoc}`;
export const HomeAbsenceCard_AbsenceCategoryFragmentDoc = gql`
    fragment HomeAbsenceCard_AbsenceCategory on EmployeeAbsenceCategory {
  ...RequestAbsenceButton
  Id
  flair__Unlimited__c
  category {
    Id
    Name
    flair__Icon__c
    flair__Type__c
    flair__Paid__c
    flair__Unlimited__c
    flair__Compensatory_Time__c
    flair__Absence_Categories_Group__c
    flair__Without_Balance__c
    group {
      Id
      Name
    }
  }
  allowancesSummary {
    availableAmount
    gainedThisYear
    usedAmount
  }
}
    ${RequestAbsenceButtonFragmentDoc}`;
export const CheckinsSurveysFragmentDoc = gql`
    fragment checkinsSurveys on CheckinsSurveyDto {
  id
  name
  questionText
  allowComments
  compulsory
  cycles {
    id
    startDate
    endDate
  }
}
    `;
export const AbsenceCategoriesFieldsFragmentDoc = gql`
    fragment AbsenceCategoriesFields on EmployeeAbsenceCategory {
  Id
  category {
    Id
    Name
    flair__Icon__c
    flair__Unlimited__c
    flair__Without_Balance__c
    flair__Compensatory_Time__c
    flair__Type__c
    group {
      Id
      Name
    }
  }
  allowancesSummary {
    availableAmount
    gainedThisYear
    usedAmount
  }
}
    `;
export const AbsenceCurrentYearFieldsFragmentDoc = gql`
    fragment AbsenceCurrentYearFields on Absence {
  Id
  flair__Start_Date__c
  flair__Working_Amount__c
  category {
    Id
    Name
    flair__Unlimited__c
    flair__Without_Balance__c
    flair__Icon__c
  }
}
    `;
export const OpenShiftsFieldsFragmentDoc = gql`
    fragment OpenShiftsFields on OpenShift {
  Id
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Location__c
  EmployeeShifts {
    Id
    employee {
      Id
      Name
    }
  }
}
    `;
export const EmployeeWithAvatarAndPopup_ColleagueFragmentDoc = gql`
    fragment EmployeeWithAvatarAndPopup_Colleague on Colleague {
  Id
  Name
  flair__Position__c
  department {
    Id
    Name
  }
  avatar {
    Id
    url
  }
}
    `;
export const CoursesTable_EmployeeCourseFragmentDoc = gql`
    fragment CoursesTable_EmployeeCourse on EmployeeCourse {
  Id
  flair__Employee__c
  flair__Course__c
  flair__Complete_Progress__c
  flair__Total_Seconds__c
  flair__Completed_At__c
  flair__Enrolled_At__c
  course {
    Id
    Name
  }
  employee {
    ...EmployeeWithAvatarAndPopup_Colleague
  }
}
    ${EmployeeWithAvatarAndPopup_ColleagueFragmentDoc}`;
export const InventoryDictionaryDataFragmentDoc = gql`
    fragment InventoryDictionaryData on DictionaryItem {
  Id
  Name
  label
}
    `;
export const SupportAdvisorFragmentDoc = gql`
    fragment SupportAdvisor on Colleague {
  Id
  Name
  flair__Company_Email__c
  avatar {
    Id
    url
  }
}
    `;
export const InventoryDataFragmentDoc = gql`
    fragment InventoryData on Inventory {
  Id
  Name
  flair__Manufacturer__c
  flair__Model__c
  flair__Type__c
  manufacturer {
    ...InventoryDictionaryData
  }
  flair__Support_Video__c
  flair__Support_Instruction__c
  supportAdvisor {
    ...SupportAdvisor
  }
}
    ${InventoryDictionaryDataFragmentDoc}
${SupportAdvisorFragmentDoc}`;
export const InventoryListDataFragmentDoc = gql`
    fragment InventoryListData on InventoryItem {
  Id
  inventory {
    ...InventoryData
  }
  location {
    Id
    Name
  }
  CurrencyIsoCode
  CreatedDate
  commentsCount
  flair__Approval_Status__c
}
    ${InventoryDataFragmentDoc}`;
export const InventoryEmployeeDataFragmentDoc = gql`
    fragment InventoryEmployeeData on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const InventorySidebarDataFragmentDoc = gql`
    fragment InventorySidebarData on InventoryItem {
  Id
  Name
  flair__App_Cat_Download_Or_Connect_Link__c
  flair__App_Cat_Editor__c
  flair__App_Cat_Version__c
  flair__Warranty_Information__c
  flair__Warranty_Date__c
  flair__Vehicle_Cat_Serial_Plate_Number__c
  flair__Vehicle_Cat_Model_Year__c
  flair__Vehicle_Cat_Insurance_policy_number__c
  flair__Vehicle_Cat_Insurance_Company_Contact__c
  flair__Vehicle_Cat_Insurance_Company__c
  flair__Vehicle_Cat_Identification_Number_VIN__c
  flair__Vehicle_Cat_Fuel_Type__c
  flair__Uniform_Cat_Type__c
  flair__Uniform_Cat_Size_System__c
  flair__Uniform_Cat_Size__c
  flair__Electronics_Cat_Operating_System__c
  flair__Notes__c
  flair__Net_Purchase_Price__c
  flair__Purchase_Date__c
  flair__Serial_Number__c
  flair__Approval_Status__c
  CurrencyIsoCode
  inventory {
    ...InventoryData
  }
  location {
    Id
    Name
  }
  supplier {
    Id
    Name
  }
  CreatedDate
  commentsCount
  employee {
    ...InventoryEmployeeData
  }
  vehicleCatFuelType {
    ...InventoryDictionaryData
  }
  electronicsCatOperatingSystem {
    ...InventoryDictionaryData
  }
  uniformCatSizeSystem {
    ...InventoryDictionaryData
  }
  uniformCatType {
    ...InventoryDictionaryData
  }
  ContentDocumentLinks {
    ...ContentDocumentLinkData
  }
}
    ${InventoryDataFragmentDoc}
${InventoryEmployeeDataFragmentDoc}
${InventoryDictionaryDataFragmentDoc}
${ContentDocumentLinkDataFragmentDoc}`;
export const InventoryCategoryOptionsFragmentDoc = gql`
    fragment InventoryCategoryOptions on RecordType {
  Id
  DeveloperName
  Name
}
    `;
export const TimeEntryChangeRequestTable_TimeEntryChangeRequestFragmentDoc = gql`
    fragment TimeEntryChangeRequestTable_TimeEntryChangeRequest on TimeEntryChangeRequest {
  Id
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Working_Period_In_Hours__c
  flair__Total_Break_Period_In_Hours__c
  flair__Creation_Time_Entry_Notes__c
  timeEntry {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Working_Period_In_Hours__c
    flair__Total_Break_Period_In_Hours__c
  }
  breaks {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    timeEntryBreak {
      Id
      flair__Start_Datetime__c
      flair__End_Datetime__c
    }
  }
  employee {
    Id
    Name
  }
}
    `;
export const AnnouncementEmployeeFragmentDoc = gql`
    fragment AnnouncementEmployee on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const AnnouncementEmojiFragmentDoc = gql`
    fragment AnnouncementEmoji on AnnouncementEmoji {
  Id
  Name
  flair__Company_Announcement__c
  employee {
    Id
    Name
  }
}
    `;
export const AnnouncementFragmentDoc = gql`
    fragment Announcement on Announcement {
  Id
  Name
  CreatedDate
  flair__Published_Date__c
  flair__Announcement_Text__c
  commentsCount
  employee {
    ...AnnouncementEmployee
  }
  emojis {
    ...AnnouncementEmoji
  }
}
    ${AnnouncementEmployeeFragmentDoc}
${AnnouncementEmojiFragmentDoc}`;
export const FeedbackCycle_PerformanceReviewFragmentDoc = gql`
    fragment FeedbackCycle_PerformanceReview on FeedbackCycle {
  Id
  Name
  flair__State__c
  flair__Manage_Goals__c
  flair__Meeting_Required__c
  flair__Signature_required__c
  flair__See_All_Questions__c
  flair__Timeline_Type__c
  flair__Number_of_Peers__c
  flair__With_Peers__c
  flair__Without_Reviewer__c
  flair__Rating_Min__c
  flair__Rating_Max__c
}
    `;
export const FeedbackCycleQuestions_PerformanceReviewFragmentDoc = gql`
    fragment FeedbackCycleQuestions_PerformanceReview on FeedbackQuestion {
  Id
  flair__Employee_Feedback_Question_Section__c
  flair__Section_Name__c
  flair__Is_Satisfaction_Section__c
  flair__Question__c
  flair__Description__c
  flair__Choices__c
  flair__Feedback_Question_Type__c
  flair__Optional__c
  flair__Optional_Comment__c
  flair__Position__c
  flair__Required_Choice__c
  flair__Hint__c
  flair__Answer_Visibility__c
  flair__Feedback_Question_Visibility__c
}
    `;
export const PeerFeedbackFragmentDoc = gql`
    fragment PeerFeedback on EmployeeFeedback {
  Id
  flair__Progress__c
  flair__Submitted_At__c
  reviewer {
    Id
    Name
    flair__Position__c
    department {
      Id
      Name
    }
    avatar {
      Id
      url
    }
  }
  answers {
    Id
    flair__Employee_Feedback_Question__c
    flair__Note__c
    feedbackAnswer
    flair__Feedback__c
    question {
      Id
      flair__Feedback_Question_Type__c
      flair__Optional__c
    }
  }
  feedbackCycle {
    ...FeedbackCycle_PerformanceReview
    questions {
      ...FeedbackCycleQuestions_PerformanceReview
    }
  }
  outcome {
    Id
    flair__Accepted_At__c
    resolutions {
      Id
      flair__Employee_Feedback_Question__c
      flair__Resolution__c
      question {
        flair__Question__c
      }
    }
  }
  hasFilledAnswers
}
    ${FeedbackCycle_PerformanceReviewFragmentDoc}
${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}`;
export const PeerReviewerResponseFragmentDoc = gql`
    fragment PeerReviewerResponse on EmployeeFeedback {
  Id
  peerFeedbacks {
    ...PeerFeedback
  }
}
    ${PeerFeedbackFragmentDoc}`;
export const EmployeeObjectiveColleagueFragmentDoc = gql`
    fragment EmployeeObjectiveColleague on Colleague {
  Id
  Name
  flair__First_Name__c
  flair__Last_Name__c
  avatar {
    Id
    url
  }
}
    `;
export const ObjectiveHistoryItemFragmentDoc = gql`
    fragment ObjectiveHistoryItem on ObjectiveHistoryItem {
  id
  fieldApiName
  oldValue
  newValue
  date
  requestId
  changedBy {
    ...EmployeeObjectiveColleague
  }
}
    ${EmployeeObjectiveColleagueFragmentDoc}`;
export const ObjectiveReferenceFragmentDoc = gql`
    fragment ObjectiveReference on ObjectiveHistoryItemReference {
  itemId
  name
  type
}
    `;
export const ObjectiveReferenceHistoryItemFragmentDoc = gql`
    fragment ObjectiveReferenceHistoryItem on ObjectiveReferenceHistoryItem {
  id
  date
  requestId
  changedBy {
    ...EmployeeObjectiveColleague
  }
  reference {
    ...ObjectiveReference
  }
  changeEvent
}
    ${EmployeeObjectiveColleagueFragmentDoc}
${ObjectiveReferenceFragmentDoc}`;
export const ObjectiveDetailsFragmentDoc = gql`
    fragment ObjectiveDetails on Objective {
  Id
  Name
  flair__Start_Date__c
  flair__Due_Date__c
  flair__Description__c
  flair__Status__c
  flair__Current_Status__c
  flair__Visibility__c
  flair__Objective_Time_Period__c
  flair__Description__c
  CreatedDate
  sharedWith {
    Id
  }
  tags {
    Id
  }
  category {
    Id
  }
  owner {
    ...EmployeeObjectiveColleague
  }
  createdBy {
    ...EmployeeObjectiveColleague
  }
  allHistoryItems {
    ... on ObjectiveHistoryItem {
      ...ObjectiveHistoryItem
    }
    ... on ObjectiveReferenceHistoryItem {
      ...ObjectiveReferenceHistoryItem
    }
  }
}
    ${EmployeeObjectiveColleagueFragmentDoc}
${ObjectiveHistoryItemFragmentDoc}
${ObjectiveReferenceHistoryItemFragmentDoc}`;
export const KeyResultFragmentDoc = gql`
    fragment KeyResult on ObjectiveKeyResult {
  Id
  Name
  flair__Type__c
  flair__Initial_Value__c
  flair__Target_Value__c
  flair__Current_Value__c
  flair__Progress__c
}
    `;
export const KeyResultUpdateFragmentDoc = gql`
    fragment KeyResultUpdate on ObjectiveKeyResultUpdate {
  Id
  flair__Objective_Key_Result__c
  flair__Previous_Value__c
  flair__Value__c
  flair__Comment__c
  CreatedDate
  createdBy {
    ...EmployeeObjectiveColleague
  }
}
    ${EmployeeObjectiveColleagueFragmentDoc}`;
export const EmployeeObjectiveDetailsFragmentDoc = gql`
    fragment EmployeeObjectiveDetails on EmployeeObjective {
  ...ObjectiveDetails
  flair__Responsible__c
  flair__Rate__c
  flair__Status_Reason__c
  flair__Manual_Progress__c
  keyResults {
    ...KeyResult
  }
  keyResultUpdates {
    ...KeyResultUpdate
  }
  parentObjective {
    Id
  }
}
    ${ObjectiveDetailsFragmentDoc}
${KeyResultFragmentDoc}
${KeyResultUpdateFragmentDoc}`;
export const TeamObjectiveDetailsFragmentDoc = gql`
    fragment TeamObjectiveDetails on TeamObjective {
  ...ObjectiveDetails
  flair__Team__c
  flair__Rate__c
  flair__Status_Reason__c
  flair__Manual_Progress__c
  keyResults {
    ...KeyResult
  }
  keyResultUpdates {
    ...KeyResultUpdate
  }
  parentObjective {
    ... on TeamObjective {
      Id
    }
    ... on CompanyObjective {
      Id
    }
  }
}
    ${ObjectiveDetailsFragmentDoc}
${KeyResultFragmentDoc}
${KeyResultUpdateFragmentDoc}`;
export const CompanyObjectiveDetailsFragmentDoc = gql`
    fragment CompanyObjectiveDetails on CompanyObjective {
  ...ObjectiveDetails
}
    ${ObjectiveDetailsFragmentDoc}`;
export const EmployeeObjectiveEmployeeFragmentDoc = gql`
    fragment EmployeeObjectiveEmployee on Employee {
  Id
  Name
  flair__First_Name__c
  flair__Last_Name__c
  avatar {
    Id
    url
  }
}
    `;
export const ObjectiveCategoryFragmentDoc = gql`
    fragment ObjectiveCategory on ObjectiveCategory {
  Id
  Name
  flair__Description__c
}
    `;
export const DevelopmentFrameworkFragmentDoc = gql`
    fragment DevelopmentFramework on DevelopmentFramework {
  Id
  Name
  categories {
    ...ObjectiveCategory
  }
}
    ${ObjectiveCategoryFragmentDoc}`;
export const ObjectiveTimePeriodPhaseFragmentDoc = gql`
    fragment ObjectiveTimePeriodPhase on ObjectiveTimePeriodPhase {
  id
  name
  createGoals
  updateGoals
  deleteGoals
  updateWeight
  updateProgress
}
    `;
export const ObjectiveTimePeriodFragmentDoc = gql`
    fragment ObjectiveTimePeriod on ObjectiveTimePeriod {
  Id
  Name
  flair__Start_Date__c
  flair__End_Date__c
  flair__Active__c
  framework {
    ...DevelopmentFramework
  }
  currentPhase {
    ...ObjectiveTimePeriodPhase
  }
}
    ${DevelopmentFrameworkFragmentDoc}
${ObjectiveTimePeriodPhaseFragmentDoc}`;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  Id
  Name
}
    `;
export const ObjectiveFragmentDoc = gql`
    fragment Objective on Objective {
  __typename
  Id
  Name
  flair__Due_Date__c
  flair__Description__c
  flair__Current_Status__c
  flair__Expected_Progress__c
  flair__On_Track__c
  flair__Visibility__c
  flair__Progress__c
  flair__Status_Reason__c
  sharedWith {
    ...EmployeeObjectiveColleague
  }
  period {
    ...ObjectiveTimePeriod
  }
  tags {
    ...Tag
  }
  statusChangedBy {
    ...EmployeeObjectiveColleague
  }
  category {
    ...ObjectiveCategory
  }
}
    ${EmployeeObjectiveColleagueFragmentDoc}
${ObjectiveTimePeriodFragmentDoc}
${TagFragmentDoc}
${ObjectiveCategoryFragmentDoc}`;
export const CompanyObjectiveFragmentDoc = gql`
    fragment CompanyObjective on CompanyObjective {
  ...Objective
}
    ${ObjectiveFragmentDoc}`;
export const EmployeeObjectiveFragmentDoc = gql`
    fragment EmployeeObjective on EmployeeObjective {
  ...Objective
  responsible {
    ...EmployeeObjectiveColleague
  }
  keyResults {
    ...KeyResult
  }
  flair__Rate__c
  flair__RateAt__c
  rateBy {
    ...EmployeeObjectiveColleague
  }
}
    ${ObjectiveFragmentDoc}
${EmployeeObjectiveColleagueFragmentDoc}
${KeyResultFragmentDoc}`;
export const TeamObjectiveFragmentDoc = gql`
    fragment TeamObjective on TeamObjective {
  ...Objective
  team {
    Id
    Name
  }
  keyResults {
    ...KeyResult
  }
  flair__Rate__c
  flair__RateAt__c
  rateBy {
    ...EmployeeObjectiveColleague
  }
}
    ${ObjectiveFragmentDoc}
${KeyResultFragmentDoc}
${EmployeeObjectiveColleagueFragmentDoc}`;
export const MyObjectivesFragmentDoc = gql`
    fragment MyObjectives on Me {
  Id
  myObjectives(filter: $filter) {
    ... on EmployeeObjective {
      ...EmployeeObjective
    }
    ... on TeamObjective {
      ...TeamObjective
    }
  }
}
    ${EmployeeObjectiveFragmentDoc}
${TeamObjectiveFragmentDoc}`;
export const MyColleaguesObjectivesFragmentDoc = gql`
    fragment MyColleaguesObjectives on Me {
  Id
  colleaguesObjectives(filter: $filter) {
    ... on EmployeeObjective {
      ...EmployeeObjective
    }
    ... on TeamObjective {
      ...TeamObjective
    }
  }
}
    ${EmployeeObjectiveFragmentDoc}
${TeamObjectiveFragmentDoc}`;
export const EmployeeFeedback_PerformanceReviewFragmentDoc = gql`
    fragment EmployeeFeedback_PerformanceReview on EmployeeFeedback {
  Id
  flair__Progress__c
  flair__Submitted_At__c
  flair__Is_Peer_Reviewer__c
  flair__State__c
}
    `;
export const ProjectFieldsFragmentDoc = gql`
    fragment ProjectFields on Project {
  Id
  flair__Name__c
  flair__Description__c
  flair__Billable__c
  flair__Estimation__c
  flair__Start_Date__c
  flair__End_Date__c
  timeTracked
}
    `;
export const ProjectColleagueFragmentDoc = gql`
    fragment ProjectColleague on Colleague {
  Id
  Name
  flair__First_Name__c
  flair__Last_Name__c
}
    `;
export const ProjectHistoryItemFragmentDoc = gql`
    fragment ProjectHistoryItem on ProjectHistoryItem {
  id
  fieldApiName
  oldValue
  newValue
  date
  requestId
  changeEvent
  changedBy {
    ...ProjectColleague
  }
}
    ${ProjectColleagueFragmentDoc}`;
export const PaidAbsenceFieldsFragmentDoc = gql`
    fragment PaidAbsenceFields on Absence {
  Id
  ...AbsencePopover
  flair__Category_Name__c
  flair__Category_Icon__c
  flair__Category_Id__c
  flair__Amount__c
  flair__Working_Amount__c
  flair__Start_Date__c
  flair__Start_Time__c
  flair__Start_Date_Half_Day__c
  flair__End_Date__c
  flair__End_Time__c
  flair__End_Date_Half_Day__c
  flair__Type__c
  flair__Paid__c
  flair__Approval_Status__c
  flair__Category_Unlimited__c
}
    ${AbsencePopoverFragmentDoc}`;
export const TimeSheetCalendarPeriodFragmentDoc = gql`
    fragment TimeSheetCalendarPeriod on CalendarPeriod {
  Id
  Name
  flair__Start_Date__c
  flair__End_Date__c
  flair__Official__c
}
    `;
export const ProjectTimesheetFieldsFragmentDoc = gql`
    fragment ProjectTimesheetFields on MyTimeSheet {
  Id
  flair__Start_Date__c
  flair__End_Date__c
  flair__Approval_Status__c
  projectTimeEntries {
    ...ProjectTimesheetEntry
  }
  holidays {
    Id
    Name
    flair__Day__c
    flair__Official__c
  }
  paidAbsences {
    ...PaidAbsenceFields
  }
  calendarPeriods {
    ...TimeSheetCalendarPeriod
  }
}
    ${ProjectTimesheetEntryFragmentDoc}
${PaidAbsenceFieldsFragmentDoc}
${TimeSheetCalendarPeriodFragmentDoc}`;
export const ProjectsTimeSheetDaySubRowTrackedTimeDayFragmentDoc = gql`
    fragment ProjectsTimeSheetDaySubRowTrackedTimeDay on TimesheetTrackedTime {
  timesheetId
  days {
    timesheetId
    targetMinutes
    day
    allAbsences {
      ...AbsencePopover
    }
    holidays {
      ...LocationHoliday
    }
    holidayMinutes
    absenceMinutes
    timeEntries {
      ...TimeSheetDayTimeEntry
    }
  }
}
    ${AbsencePopoverFragmentDoc}
${LocationHolidayFragmentDoc}
${TimeSheetDayTimeEntryFragmentDoc}`;
export const ProjectsTimeSheetDaySubRowTimeSheetDayFragmentDoc = gql`
    fragment ProjectsTimeSheetDaySubRowTimeSheetDay on TimeSheetDay {
  ...TimeSheetDayId
  commentsCount
  flair__Project_Time_Entries_Minutes__c
}
    ${TimeSheetDayIdFragmentDoc}`;
export const ProjectsTimeSheetTableProjectFragmentDoc = gql`
    fragment ProjectsTimeSheetTableProject on Project {
  Id
  flair__Name__c
  flair__Start_Date__c
  flair__End_Date__c
  flair__Estimation__c
  flair__Billable__c
  timeTracked
}
    `;
export const ProjectsTimeSheetDaySubRowsFragmentDoc = gql`
    fragment ProjectsTimeSheetDaySubRows on TimeSheet {
  Id
  trackedTime {
    ...ProjectsTimeSheetDaySubRowTrackedTimeDay
  }
  timeSheetDays {
    ...ProjectsTimeSheetDaySubRowTimeSheetDay
  }
  projectsTimeEntries(filter: $projectTimeEntriesFilter) {
    Id
    flair__Minutes__c
    flair__Date__c
    flair__Notes__c
    flair__Project__c
    project {
      ...ProjectsTimeSheetTableProject
    }
  }
}
    ${ProjectsTimeSheetDaySubRowTrackedTimeDayFragmentDoc}
${ProjectsTimeSheetDaySubRowTimeSheetDayFragmentDoc}
${ProjectsTimeSheetTableProjectFragmentDoc}`;
export const ProjectsTimeSheetDetailsFragmentDoc = gql`
    fragment ProjectsTimeSheetDetails on TimeSheet {
  Id
  ...ProjectsTimeSheetDaySubRows
}
    ${ProjectsTimeSheetDaySubRowsFragmentDoc}`;
export const ProjectsTimeSheetTableProjectTimeEntryFragmentDoc = gql`
    fragment ProjectsTimeSheetTableProjectTimeEntry on ProjectTimeEntry {
  Id
  flair__Project__c
  flair__Notes__c
  flair__Minutes__c
  flair__Date__c
  project {
    ...ProjectsTimeSheetTableProject
  }
}
    ${ProjectsTimeSheetTableProjectFragmentDoc}`;
export const ProjectsTimeSheetTableFragmentDoc = gql`
    fragment ProjectsTimeSheetTable on TimeSheet {
  Id
  flair__Employee__c
  flair__Start_Date__c
  flair__End_Date__c
  flair__Type__c
  flair__Target_Hours__c
  flair__Time_Entry_Hours__c
  flair__Approval_Status__c
  flair__Project_Time_Entries_Minutes__c
  employee {
    ...EmployeeWithAvatar
  }
  timeSheetDays {
    ...ProjectsTimeSheetDaySubRowTimeSheetDay
  }
  projectsTimeEntries(filter: $projectTimeEntriesFilter) {
    ...ProjectsTimeSheetTableProjectTimeEntry
  }
}
    ${EmployeeWithAvatarFragmentDoc}
${ProjectsTimeSheetDaySubRowTimeSheetDayFragmentDoc}
${ProjectsTimeSheetTableProjectTimeEntryFragmentDoc}`;
export const ShiftChangeRequestFragmentFragmentDoc = gql`
    fragment ShiftChangeRequestFragment on ShiftChangeRequest {
  Id
  flair__Approval_Status__c
  flair__Approval_Status_Changed_At__c
  flair__Change_Reason__c
  flair__Request_Type__c
  flair__Requested_At__c
  flair__Colleague_Approval_Status__c
  flair__Colleague_Responded_At__c
  flair__Approval_Status_Detailed__c
  shift {
    Id
    flair__Title__c
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Pending_Change_Requests_Count__c
  }
  proposedResourceEmployee {
    Id
    Name
  }
  requestedByEmployee {
    Id
    Name
  }
}
    `;
export const SlackStatusAutoUpdateSettings_SlackInfoFragmentDoc = gql`
    fragment SlackStatusAutoUpdateSettings_SlackInfo on SlackInfo {
  orgHasSlackEnabled
  employeeSlackConnection {
    employeeId
    slackUserId
    userScopes
    slackStatusAutoUpdate
  }
}
    `;
export const SkillNamesFragmentDoc = gql`
    fragment SkillNames on Skill {
  Id
  Name
  flair__Rateable__c
  CreatedDate
}
    `;
export const UpdateSkillTopResponseFragmentDoc = gql`
    fragment UpdateSkillTopResponse on EmployeeSkillAssociation {
  Id
  flair__Top__c
}
    `;
export const ManagerSkillFragmentDoc = gql`
    fragment ManagerSkill on Skill {
  Id
  Name
  flair__Rateable__c
  CreatedDate
  createdBy {
    ...CreatedByColleague
  }
  employeeSkills {
    Id
    flair__Rate__c
    flair__Employee__c
  }
}
    ${CreatedByColleagueFragmentDoc}`;
export const UpdateSkillRateResponseFragmentDoc = gql`
    fragment UpdateSkillRateResponse on EmployeeSkillAssociation {
  Id
  flair__Rate__c
  flair__Top__c
}
    `;
export const SkillFragmentDoc = gql`
    fragment Skill on Skill {
  Id
  Name
  flair__Rateable__c
  CreatedDate
  createdBy {
    ...CreatedByColleague
  }
}
    ${CreatedByColleagueFragmentDoc}`;
export const EmployeeSkillAssociationFragmentDoc = gql`
    fragment EmployeeSkillAssociation on EmployeeSkillAssociation {
  Id
  flair__Rate__c
  flair__Top__c
  flair__Skill__c
  flair__Employee__c
  skill {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;
export const ReloadAllEmployeeSkillsPayloadFragmentDoc = gql`
    fragment ReloadAllEmployeeSkillsPayload on UpdateEmployeeSkillPayload {
  error
  employee {
    Id
    employeeSkills {
      ...EmployeeSkillAssociation
    }
  }
  colleague {
    Id
    employeeSkills {
      ...EmployeeSkillAssociation
    }
  }
  query {
    me {
      Id
      employeeSkills {
        ...EmployeeSkillAssociation
      }
    }
  }
}
    ${EmployeeSkillAssociationFragmentDoc}`;
export const EmployeeSkillMatrixFragmentDoc = gql`
    fragment EmployeeSkillMatrix on EmployeeSkillAssociation {
  Id
  flair__Rate__c
  flair__Skill__c
  flair__Employee__c
}
    `;
export const TicketPolicyDataFragmentDoc = gql`
    fragment TicketPolicyData on TicketPolicy {
  Id
  Name
  flair__Category_Key__c
  flair__Ticket_Visibility__c
  flair__Whistleblower_Active__c
}
    `;
export const ManagerEmployeeDataFragmentDoc = gql`
    fragment ManagerEmployeeData on Employee {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const TicketsDictionaryDataFragmentDoc = gql`
    fragment TicketsDictionaryData on DictionaryItem {
  Id
  Name
  label
  flair__Key__c
}
    `;
export const TicketEmployeeDataFragmentDoc = gql`
    fragment TicketEmployeeData on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const TicketListDataFragmentDoc = gql`
    fragment TicketListData on Ticket {
  Id
  Name
  LastModifiedDate
  CreatedDate
  flair__Status__c
  flair__Closing_Reason__c
  flair__Details__c
  flair__Priority__c
  flair__Ticket_Number__c
  flair__Anonymous__c
  flair__Visibility__c
  flair__Employee__c
  category {
    ...TicketsDictionaryData
  }
  subject {
    ...TicketsDictionaryData
  }
  employee {
    ...TicketEmployeeData
  }
  assignee {
    ...TicketEmployeeData
  }
}
    ${TicketsDictionaryDataFragmentDoc}
${TicketEmployeeDataFragmentDoc}`;
export const TicketSidebarDataFragmentDoc = gql`
    fragment TicketSidebarData on Ticket {
  Id
  flair__Status__c
  flair__Ticket_Number__c
  flair__Closing_Reason__c
  flair__Visibility__c
  flair__Anonymous__c
  flair__Details__c
  LastModifiedDate
  CreatedDate
  flair__Employee__c
  employee {
    ...TicketEmployeeData
  }
  category {
    ...TicketsDictionaryData
  }
  subject {
    ...TicketsDictionaryData
  }
  assignee {
    ...TicketEmployeeData
  }
}
    ${TicketEmployeeDataFragmentDoc}
${TicketsDictionaryDataFragmentDoc}`;
export const TimeSheetTimeEntriesFragmentDoc = gql`
    fragment TimeSheetTimeEntries on TimeSheet {
  flair__Current_Compensatory_Time_Level_1__c
  flair__Current_Compensatory_Time_Level_2__c
  flair__Given_Compensatory_Time_Level_1__c
  flair__Given_Compensatory_Time_Level_2__c
  ...TimeSheetGoalChart
  timeEntries {
    ...TimeEntryTimeSheetFields
  }
}
    ${TimeSheetGoalChartFragmentDoc}
${TimeEntryTimeSheetFieldsFragmentDoc}`;
export const TimeTrackingWarningFragmentDoc = gql`
    fragment TimeTrackingWarning on TimeTrackingWarning {
  ... on TimeLimitWarningMaxDailyLimit {
    warningCode
    allowedTimeInMin
    alreadyTrackedInMin
    leftToTrackInMin
    autoClockOut
  }
}
    `;
export const MyTimeEntryBreakFragmentDoc = gql`
    fragment MyTimeEntryBreak on MyTimeEntryBreak {
  Id
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Total_Break_Period_in_Minutes__c
  flair__Auto_adjusted_Datetime__c
  LastModifiedDate
}
    `;
export const MyTimeEntryTimeTrackingFragmentDoc = gql`
    fragment MyTimeEntryTimeTracking on MyTimeEntry {
  Id
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Non_compliant__c
  flair__Notes__c
  LastModifiedDate
  breaks {
    ...MyTimeEntryBreak
  }
}
    ${MyTimeEntryBreakFragmentDoc}`;
export const CurrentTimeEntryFragmentDoc = gql`
    fragment CurrentTimeEntry on MyTimeEntry {
  ...MyTimeEntryTimeTracking
  location {
    Name
  }
}
    ${MyTimeEntryTimeTrackingFragmentDoc}`;
export const TimeSheetTrackedTimeDayFragmentDoc = gql`
    fragment TimeSheetTrackedTimeDay on TimesheetDayTrackedTime {
  day
  trackedMinutes
  targetMinutes
  absenceMinutes
  holidayMinutes
  workedMinutes
  overtimeMinutes
  deficitMinutes
}
    `;
export const MyTimeEntryTimeSheetFieldsFragmentDoc = gql`
    fragment MyTimeEntryTimeSheetFields on MyTimeEntry {
  Id
  flair__Start_Datetime__c
  flair__End_Datetime__c
  flair__Working_Period_In_Hours__c
  flair__Approval_Status__c
  flair__Total_Period_In_Hours__c
  flair__Payroll_Completed__c
  flair__Is_Locked__c
  flair__Total_Break_Period_In_Hours__c
  flair__Non_compliant__c
  flair__Notes__c
  flair__Cost_Center__c
  LastModifiedDate
  breaks {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Total_Break_Period_in_Hours__c
    flair__Auto_adjusted_Datetime__c
    LastModifiedDate
  }
}
    `;
export const MyTimeEntryTimeTrackingWithChangeRequestFragmentDoc = gql`
    fragment MyTimeEntryTimeTrackingWithChangeRequest on MyTimeEntry {
  ...MyTimeEntryTimeTracking
  changeRequest {
    ...TimeEntryChangeRequestFields
  }
}
    ${MyTimeEntryTimeTrackingFragmentDoc}
${TimeEntryChangeRequestFieldsFragmentDoc}`;
export const TimeTrackingErrorFragmentDoc = gql`
    fragment TimeTrackingError on TimeTrackingErrorBase {
  errorCode
  message
  ... on TimeLimitErrorMaxDailyLimitExceeded {
    allowedTimeInMin
  }
}
    `;
export const UpdateMyTimeEntryPayloadFragmentDoc = gql`
    fragment UpdateMyTimeEntryPayload on UpdateMyTimeEntryPayload {
  me {
    Id
    currentTimeEntry {
      ...MyTimeEntryTimeTrackingWithChangeRequest
    }
  }
  errors2 {
    ...TimeTrackingError
  }
}
    ${MyTimeEntryTimeTrackingWithChangeRequestFragmentDoc}
${TimeTrackingErrorFragmentDoc}`;
export const WorkflowItemsFilter_WorkflowTemplateFragmentDoc = gql`
    fragment WorkflowItemsFilter_WorkflowTemplate on WorkflowTemplate {
  Id
  Name
}
    `;
export const WorkflowItemsFilter_WorkflowItemTemplateFragmentDoc = gql`
    fragment WorkflowItemsFilter_WorkflowItemTemplate on WorkflowItemTemplate {
  Id
  Name
}
    `;
export const WorkflowItemsFilter_EmployeeFragmentDoc = gql`
    fragment WorkflowItemsFilter_Employee on Colleague {
  Id
  Name
}
    `;
export const WorkflowItemsFilter_TeamFragmentDoc = gql`
    fragment WorkflowItemsFilter_Team on Team {
  Id
  Name
}
    `;
export const WorkflowFilter_WorkflowTemplateFragmentDoc = gql`
    fragment WorkflowFilter_WorkflowTemplate on WorkflowTemplate {
  Id
  Name
}
    `;
export const WorkflowFilter_EmployeeFragmentDoc = gql`
    fragment WorkflowFilter_Employee on Colleague {
  Id
  Name
  avatar {
    Id
    url
  }
}
    `;
export const RefetchWorkflowFieldsFragmentDoc = gql`
    fragment RefetchWorkflowFields on Workflow {
  Id
  flair__Complete_Progress__c
  steps {
    Id
    flair__Is_Active__c
  }
}
    `;
export const WorkflowItemUploadedFileFragmentDoc = gql`
    fragment WorkflowItemUploadedFile on ContentDocument {
  Id
  Title
  FileExtension
}
    `;
export const WorkflowItemDataFieldFragmentDoc = gql`
    fragment WorkflowItemDataField on WorkflowItemDataField {
  value
  fieldInfo {
    ...FieldInfo
  }
}
    ${FieldInfoFragmentDoc}`;
export const WorkflowEmployeeFieldsFragmentDoc = gql`
    fragment WorkflowEmployeeFields on Colleague {
  ...EmployeeWithAvatarAndPopup_Colleague
  flair__Start_Date__c
  flair__End_Date__c
}
    ${EmployeeWithAvatarAndPopup_ColleagueFragmentDoc}`;
export const WorkflowItemFieldsFragmentDoc = gql`
    fragment WorkflowItemFields on WorkflowItem {
  Id
  Name
  flair__Description__c
  flair__Type__c
  flair__Status__c
  flair__Due_Date__c
  flair__Data_Fields__c
  flair__Document_Category__c
  flair__File_Format__c
  flair__Responsible_Type2__c
  flair__Employee_Evaluation__c
  attachments {
    ...ContentDocumentLinkData
  }
  responsible {
    ...WorkflowEmployeeFields
  }
  responsibleTeam {
    Id
    Name
    employees {
      Id
      Name
    }
  }
  uploadedFileVisibility
}
    ${ContentDocumentLinkDataFragmentDoc}
${WorkflowEmployeeFieldsFragmentDoc}`;
export const WorkflowFragmentDoc = gql`
    fragment Workflow on Workflow {
  Id
  Name
  flair__Workflow_Template__c
  employee {
    ...WorkflowEmployeeFields
  }
}
    ${WorkflowEmployeeFieldsFragmentDoc}`;
export const WorkflowItemSubTasksFragmentDoc = gql`
    fragment workflowItemSubTasks on WorkflowItem {
  flair__Sub_Tasks_Json__c
  subTasks {
    id
    text
    checked
  }
}
    `;
export const WorkflowItemTableFieldsFragmentDoc = gql`
    fragment WorkflowItemTableFields on WorkflowItem {
  Id
  Name
  flair__Employee__c
  flair__Responsible__c
  flair__Description__c
  flair__Type__c
  flair__Status__c
  flair__Due_Date__c
  flair__Workflow_Template_Item__c
  flair__Data_Fields__c
  flair__Document_Category__c
  flair__File_Format__c
  flair__Responsible_Type2__c
  flair__Employee_Evaluation__c
  flair__Instructions_Loom_Url__c
  flair__Is_Mandatory__c
  flair__Workflow_Step__c
  ...workflowItemSubTasks
  canUpdate
  flair__Loom_Video__c
  loomVideo {
    ...LoomVideo
  }
  signRequestSigner {
    flair__External_Signature_Link__c
    flair__Status__c
  }
  attachments {
    ...ContentDocumentLinkData
  }
  responsible {
    ...WorkflowEmployeeFields
  }
  responsibleTeam {
    Id
    Name
    employees {
      Id
      Name
      avatar {
        Id
        url
      }
    }
  }
  workflowStep {
    Id
    flair__Step_Name__c
    flair__Order__c
    flair__Activating_Trigger__c
    flair__Activation_Date__c
    flair__Is_Active__c
  }
  commentsCount
}
    ${WorkflowItemSubTasksFragmentDoc}
${LoomVideoFragmentDoc}
${ContentDocumentLinkDataFragmentDoc}
${WorkflowEmployeeFieldsFragmentDoc}`;
export const WorkflowTableFieldsFragmentDoc = gql`
    fragment WorkflowTableFields on Workflow {
  Id
  Name
  flair__Complete_Progress__c
  flair__Closest_Item_Due_Date__c
  flair__Workflow_Template__c
  flair__Type__c
  steps {
    Id
    flair__Step_Name__c
    flair__Order__c
  }
  items {
    Id
    Name
    flair__Status__c
    CreatedDate
    flair__Workflow_Step__c
  }
  employee {
    ...WorkflowEmployeeFields
  }
  flair__First_Opened__c
}
    ${WorkflowEmployeeFieldsFragmentDoc}`;
export const CandidateEvaluationsFragmentFragmentDoc = gql`
    fragment CandidateEvaluationsFragment on CandidateEvaluation {
  Id
  Name
  flair__Overall_Comment__c
  flair__Final_Score__c
  flair__Evaluated__c
  flair__Employee__c
  LastModifiedDate
  commentsCount
  employee {
    Id
    Name
  }
  answers {
    Id
    Name
    flair__Candidate_Evaluation__c
    flair__Question_Type__c
    flair__Evaluation_Template_Question__c
    flair__Evaluation_Template_Option__c
    flair__Answer__c
    flair__Score__c
  }
  evaluationTemplate {
    ...EvaluationTemplateFragment
  }
}
    ${EvaluationTemplateFragmentFragmentDoc}`;
export const CandidateDetail_JobCandidateFragmentDoc = gql`
    fragment CandidateDetail_JobCandidate on JobCandidate {
  Id
  flair__Full_Name__c
  flair__Overall_Comment__c
  flair__Final_Score__c
  flair__Job__c
  flair__Cover_Letter__c
  flair__Email__c
  flair__Phone__c
  flair__LinkedIn__c
  flair__Funnel_Stage__c
  flair__Application_Source__c
  flair__How_did_you_hear_about_us__c
  flair__FlairAI_Total_KR_Matching_Score__c
  flair__FlairAI_KR_Matching_Status__c
  flair__FlairAI_KR_Matching_Info_JSON__c
  commentsCount
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
  job {
    Id
    Name
    flair__FlairAI_Key_Requirements_JSON__c
  }
  candidateEvaluations {
    ...CandidateEvaluationsFragment
  }
  recruitingDocuments {
    Id
    Name
    flair__Title__c
    ContentDocumentLinks__r {
      ...ContentDocumentLinkData
    }
  }
}
    ${ContentDocumentLinkDataFragmentDoc}
${CandidateEvaluationsFragmentFragmentDoc}`;
export const EvaluationTemplateFragmentDoc = gql`
    fragment EvaluationTemplate on EvaluationTemplate {
  Id
  Name
}
    `;
export const CandidateEvaluation_JobCandidateFragmentDoc = gql`
    fragment CandidateEvaluation_JobCandidate on JobCandidate {
  Id
  flair__Job__c
  flair__Full_Name__c
  flair__Cover_Letter__c
  flair__Email__c
  flair__Phone__c
  flair__LinkedIn__c
  flair__Funnel_Stage__c
  flair__Application_Source__c
  flair__How_did_you_hear_about_us__c
  flair__Final_Score__c
  flair__FlairAI_Total_KR_Matching_Score__c
  flair__FlairAI_KR_Matching_Status__c
  flair__FlairAI_KR_Matching_Info_JSON__c
  ContentDocumentLinks__r {
    ...ContentDocumentLinkData
  }
  job {
    Id
    Name
    flair__FlairAI_Key_Requirements_JSON__c
  }
}
    ${ContentDocumentLinkDataFragmentDoc}`;
export const SearchEmployeesForMentionDocument = gql`
    query SearchEmployeesForMention($filter: SearchEmployeesForMention!) {
  searchEmployeesForMention(filter: $filter) {
    id
    name
    avatarUrl
    position
    hasAccess
  }
}
    `;

/**
 * __useSearchEmployeesForMentionQuery__
 *
 * To run a query within a React component, call `useSearchEmployeesForMentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmployeesForMentionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmployeesForMentionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchEmployeesForMentionQuery(baseOptions: Apollo.QueryHookOptions<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables> & ({ variables: SearchEmployeesForMentionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables>(SearchEmployeesForMentionDocument, options);
      }
export function useSearchEmployeesForMentionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables>(SearchEmployeesForMentionDocument, options);
        }
export function useSearchEmployeesForMentionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables>(SearchEmployeesForMentionDocument, options);
        }
export type SearchEmployeesForMentionQueryHookResult = ReturnType<typeof useSearchEmployeesForMentionQuery>;
export type SearchEmployeesForMentionLazyQueryHookResult = ReturnType<typeof useSearchEmployeesForMentionLazyQuery>;
export type SearchEmployeesForMentionSuspenseQueryHookResult = ReturnType<typeof useSearchEmployeesForMentionSuspenseQuery>;
export type SearchEmployeesForMentionQueryResult = Apollo.QueryResult<SearchEmployeesForMentionQuery, SearchEmployeesForMentionQueryVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($input: CreateCommentInput!) {
  comment {
    createComment(input: $input) {
      recordId
      record {
        ...CommentItem
      }
      related {
        ...CommentableId
        comments {
          ...CommentItem
        }
        commentsCount
      }
      error
    }
  }
}
    ${CommentItemFragmentDoc}
${CommentableIdFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($id: String!) {
  comment {
    deleteComment(id: $id) {
      recordId
      related {
        ...CommentableId
        commentsCount
        comments {
          ...CommentItem
        }
      }
      error
    }
  }
}
    ${CommentableIdFragmentDoc}
${CommentItemFragmentDoc}`;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($input: UpdateCommentInput!) {
  comment {
    updateComment(input: $input) {
      recordId
      record {
        ...CommentItem
      }
      error
    }
  }
}
    ${CommentItemFragmentDoc}`;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CommentsDocument = gql`
    query comments($commentableId: CommentableIdInput!) {
  commentable(commentableId: $commentableId) {
    ...CommentableId
    comments {
      ...CommentItem
    }
    commentsCount
  }
}
    ${CommentableIdFragmentDoc}
${CommentItemFragmentDoc}`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      commentableId: // value for 'commentableId'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables> & ({ variables: CommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsSuspenseQueryHookResult = ReturnType<typeof useCommentsSuspenseQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const UpdateMyAvatarDocument = gql`
    mutation UpdateMyAvatar($input: UpdateMyAvatarInput) {
  employeeData {
    updateMyAvatar(input: $input) {
      recordId
      query {
        me {
          Id
          avatar {
            Id
            url
            urlLarge
          }
        }
      }
    }
  }
}
    `;
export type UpdateMyAvatarMutationFn = Apollo.MutationFunction<UpdateMyAvatarMutation, UpdateMyAvatarMutationVariables>;

/**
 * __useUpdateMyAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateMyAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyAvatarMutation, { data, loading, error }] = useUpdateMyAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyAvatarMutation, UpdateMyAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyAvatarMutation, UpdateMyAvatarMutationVariables>(UpdateMyAvatarDocument, options);
      }
export type UpdateMyAvatarMutationHookResult = ReturnType<typeof useUpdateMyAvatarMutation>;
export type UpdateMyAvatarMutationResult = Apollo.MutationResult<UpdateMyAvatarMutation>;
export type UpdateMyAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateMyAvatarMutation, UpdateMyAvatarMutationVariables>;
export const RemoveMyAvatarDocument = gql`
    mutation RemoveMyAvatar {
  employeeData {
    removeMyAvatar {
      query {
        me {
          Id
          avatar {
            Id
            url
            urlLarge
          }
        }
      }
    }
  }
}
    `;
export type RemoveMyAvatarMutationFn = Apollo.MutationFunction<RemoveMyAvatarMutation, RemoveMyAvatarMutationVariables>;

/**
 * __useRemoveMyAvatarMutation__
 *
 * To run a mutation, you first call `useRemoveMyAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyAvatarMutation, { data, loading, error }] = useRemoveMyAvatarMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveMyAvatarMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyAvatarMutation, RemoveMyAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyAvatarMutation, RemoveMyAvatarMutationVariables>(RemoveMyAvatarDocument, options);
      }
export type RemoveMyAvatarMutationHookResult = ReturnType<typeof useRemoveMyAvatarMutation>;
export type RemoveMyAvatarMutationResult = Apollo.MutationResult<RemoveMyAvatarMutation>;
export type RemoveMyAvatarMutationOptions = Apollo.BaseMutationOptions<RemoveMyAvatarMutation, RemoveMyAvatarMutationVariables>;
export const EmployeeByTeamSelectDocument = gql`
    query EmployeeByTeamSelect {
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
  manager {
    Id
    employees {
      ...EmployeeSelectInfo
    }
  }
  teams {
    Id
    Name
    employees {
      Id
    }
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}
${EmployeeSelectInfoFragmentDoc}`;

/**
 * __useEmployeeByTeamSelectQuery__
 *
 * To run a query within a React component, call `useEmployeeByTeamSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeByTeamSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeByTeamSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeByTeamSelectQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>(EmployeeByTeamSelectDocument, options);
      }
export function useEmployeeByTeamSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>(EmployeeByTeamSelectDocument, options);
        }
export function useEmployeeByTeamSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>(EmployeeByTeamSelectDocument, options);
        }
export type EmployeeByTeamSelectQueryHookResult = ReturnType<typeof useEmployeeByTeamSelectQuery>;
export type EmployeeByTeamSelectLazyQueryHookResult = ReturnType<typeof useEmployeeByTeamSelectLazyQuery>;
export type EmployeeByTeamSelectSuspenseQueryHookResult = ReturnType<typeof useEmployeeByTeamSelectSuspenseQuery>;
export type EmployeeByTeamSelectQueryResult = Apollo.QueryResult<EmployeeByTeamSelectQuery, EmployeeByTeamSelectQueryVariables>;
export const PeformanceReviewPageDocument = gql`
    query PeformanceReviewPage($employeeId: String!, $feedbackId: String!) {
  manager {
    Id
    employee(id: $employeeId) {
      Id
      Name
      feedback(id: $feedbackId) {
        Id
        feedbackCycle {
          Name
        }
        outcome {
          resolutions {
            Id
            flair__Employee_Feedback_Question__c
            flair__Resolution__c
          }
          objectives {
            Id
            Name
            flair__Description__c
            flair__Due_Date__c
            flair__Rate__c
          }
        }
        employeeFeedback {
          answers {
            Id
            flair__Employee_Feedback_Request__c
            flair__Employee_Feedback_Question__c
            flair__Feedback__c
            flair__Note__c
            question {
              Id
              flair__Employee_Feedback_Question_Section__c
            }
          }
        }
        answers {
          Id
          flair__Employee_Feedback_Request__c
          flair__Employee_Feedback_Question__c
          flair__Feedback__c
          flair__Note__c
          question {
            ...FeedbackCycleQuestions_PerformanceReview
          }
        }
      }
    }
  }
}
    ${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}`;

/**
 * __usePeformanceReviewPageQuery__
 *
 * To run a query within a React component, call `usePeformanceReviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeformanceReviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeformanceReviewPageQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function usePeformanceReviewPageQuery(baseOptions: Apollo.QueryHookOptions<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables> & ({ variables: PeformanceReviewPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables>(PeformanceReviewPageDocument, options);
      }
export function usePeformanceReviewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables>(PeformanceReviewPageDocument, options);
        }
export function usePeformanceReviewPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables>(PeformanceReviewPageDocument, options);
        }
export type PeformanceReviewPageQueryHookResult = ReturnType<typeof usePeformanceReviewPageQuery>;
export type PeformanceReviewPageLazyQueryHookResult = ReturnType<typeof usePeformanceReviewPageLazyQuery>;
export type PeformanceReviewPageSuspenseQueryHookResult = ReturnType<typeof usePeformanceReviewPageSuspenseQuery>;
export type PeformanceReviewPageQueryResult = Apollo.QueryResult<PeformanceReviewPageQuery, PeformanceReviewPageQueryVariables>;
export const UpdateEmployeeFeedbackAnswerDocument = gql`
    mutation UpdateEmployeeFeedbackAnswer($input: UpdateEmployeeFeedbackAnswerInput!) {
  updateEmployeeFeedbackAnswer(input: $input) {
    Id
  }
}
    `;
export type UpdateEmployeeFeedbackAnswerMutationFn = Apollo.MutationFunction<UpdateEmployeeFeedbackAnswerMutation, UpdateEmployeeFeedbackAnswerMutationVariables>;

/**
 * __useUpdateEmployeeFeedbackAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeFeedbackAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeFeedbackAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeFeedbackAnswerMutation, { data, loading, error }] = useUpdateEmployeeFeedbackAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeFeedbackAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeFeedbackAnswerMutation, UpdateEmployeeFeedbackAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeFeedbackAnswerMutation, UpdateEmployeeFeedbackAnswerMutationVariables>(UpdateEmployeeFeedbackAnswerDocument, options);
      }
export type UpdateEmployeeFeedbackAnswerMutationHookResult = ReturnType<typeof useUpdateEmployeeFeedbackAnswerMutation>;
export type UpdateEmployeeFeedbackAnswerMutationResult = Apollo.MutationResult<UpdateEmployeeFeedbackAnswerMutation>;
export type UpdateEmployeeFeedbackAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeFeedbackAnswerMutation, UpdateEmployeeFeedbackAnswerMutationVariables>;
export const UpsertEmployeeObjectiveDocument = gql`
    mutation UpsertEmployeeObjective($input: UpsertEmployeeObjectiveInput!) {
  upsertEmployeeObjective(input: $input)
}
    `;
export type UpsertEmployeeObjectiveMutationFn = Apollo.MutationFunction<UpsertEmployeeObjectiveMutation, UpsertEmployeeObjectiveMutationVariables>;

/**
 * __useUpsertEmployeeObjectiveMutation__
 *
 * To run a mutation, you first call `useUpsertEmployeeObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmployeeObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmployeeObjectiveMutation, { data, loading, error }] = useUpsertEmployeeObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEmployeeObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEmployeeObjectiveMutation, UpsertEmployeeObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEmployeeObjectiveMutation, UpsertEmployeeObjectiveMutationVariables>(UpsertEmployeeObjectiveDocument, options);
      }
export type UpsertEmployeeObjectiveMutationHookResult = ReturnType<typeof useUpsertEmployeeObjectiveMutation>;
export type UpsertEmployeeObjectiveMutationResult = Apollo.MutationResult<UpsertEmployeeObjectiveMutation>;
export type UpsertEmployeeObjectiveMutationOptions = Apollo.BaseMutationOptions<UpsertEmployeeObjectiveMutation, UpsertEmployeeObjectiveMutationVariables>;
export const ExtraFieldLookupOptionsDocument = gql`
    query ExtraFieldLookupOptions($id: String!, $contextParams: [ExtraFieldContextParamInput!]!, $extraFieldsConfigReference: ExtraFieldsConfigReferenceInput) {
  extraFields {
    extraFieldLookupOptions(
      id: $id
      contextParams: $contextParams
      extraFieldsConfigReference: $extraFieldsConfigReference
    ) {
      id
      label
    }
  }
}
    `;

/**
 * __useExtraFieldLookupOptionsQuery__
 *
 * To run a query within a React component, call `useExtraFieldLookupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtraFieldLookupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtraFieldLookupOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contextParams: // value for 'contextParams'
 *      extraFieldsConfigReference: // value for 'extraFieldsConfigReference'
 *   },
 * });
 */
export function useExtraFieldLookupOptionsQuery(baseOptions: Apollo.QueryHookOptions<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables> & ({ variables: ExtraFieldLookupOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables>(ExtraFieldLookupOptionsDocument, options);
      }
export function useExtraFieldLookupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables>(ExtraFieldLookupOptionsDocument, options);
        }
export function useExtraFieldLookupOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables>(ExtraFieldLookupOptionsDocument, options);
        }
export type ExtraFieldLookupOptionsQueryHookResult = ReturnType<typeof useExtraFieldLookupOptionsQuery>;
export type ExtraFieldLookupOptionsLazyQueryHookResult = ReturnType<typeof useExtraFieldLookupOptionsLazyQuery>;
export type ExtraFieldLookupOptionsSuspenseQueryHookResult = ReturnType<typeof useExtraFieldLookupOptionsSuspenseQuery>;
export type ExtraFieldLookupOptionsQueryResult = Apollo.QueryResult<ExtraFieldLookupOptionsQuery, ExtraFieldLookupOptionsQueryVariables>;
export const AllObjectsExtraFieldsDocument = gql`
    query AllObjectsExtraFields($objectApiNames: [String!]!) {
  extraFields {
    objectsExtraFields(objectApiNames: $objectApiNames) {
      ...ObjectExtraFields
    }
  }
}
    ${ObjectExtraFieldsFragmentDoc}`;

/**
 * __useAllObjectsExtraFieldsQuery__
 *
 * To run a query within a React component, call `useAllObjectsExtraFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllObjectsExtraFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllObjectsExtraFieldsQuery({
 *   variables: {
 *      objectApiNames: // value for 'objectApiNames'
 *   },
 * });
 */
export function useAllObjectsExtraFieldsQuery(baseOptions: Apollo.QueryHookOptions<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables> & ({ variables: AllObjectsExtraFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables>(AllObjectsExtraFieldsDocument, options);
      }
export function useAllObjectsExtraFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables>(AllObjectsExtraFieldsDocument, options);
        }
export function useAllObjectsExtraFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables>(AllObjectsExtraFieldsDocument, options);
        }
export type AllObjectsExtraFieldsQueryHookResult = ReturnType<typeof useAllObjectsExtraFieldsQuery>;
export type AllObjectsExtraFieldsLazyQueryHookResult = ReturnType<typeof useAllObjectsExtraFieldsLazyQuery>;
export type AllObjectsExtraFieldsSuspenseQueryHookResult = ReturnType<typeof useAllObjectsExtraFieldsSuspenseQuery>;
export type AllObjectsExtraFieldsQueryResult = Apollo.QueryResult<AllObjectsExtraFieldsQuery, AllObjectsExtraFieldsQueryVariables>;
export const WithExtraFieldsDocument = gql`
    query WithExtraFields($recordId: String!, $objectApiName: String!) {
  extraFields {
    withExtraFields(recordId: $recordId, objectApiName: $objectApiName) {
      Id
      extraFields {
        ...ExtraFieldValue
      }
      recordType {
        ...RecordType
      }
    }
  }
}
    ${ExtraFieldValueFragmentDoc}
${RecordTypeFragmentDoc}`;

/**
 * __useWithExtraFieldsQuery__
 *
 * To run a query within a React component, call `useWithExtraFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithExtraFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithExtraFieldsQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      objectApiName: // value for 'objectApiName'
 *   },
 * });
 */
export function useWithExtraFieldsQuery(baseOptions: Apollo.QueryHookOptions<WithExtraFieldsQuery, WithExtraFieldsQueryVariables> & ({ variables: WithExtraFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WithExtraFieldsQuery, WithExtraFieldsQueryVariables>(WithExtraFieldsDocument, options);
      }
export function useWithExtraFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WithExtraFieldsQuery, WithExtraFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WithExtraFieldsQuery, WithExtraFieldsQueryVariables>(WithExtraFieldsDocument, options);
        }
export function useWithExtraFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WithExtraFieldsQuery, WithExtraFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WithExtraFieldsQuery, WithExtraFieldsQueryVariables>(WithExtraFieldsDocument, options);
        }
export type WithExtraFieldsQueryHookResult = ReturnType<typeof useWithExtraFieldsQuery>;
export type WithExtraFieldsLazyQueryHookResult = ReturnType<typeof useWithExtraFieldsLazyQuery>;
export type WithExtraFieldsSuspenseQueryHookResult = ReturnType<typeof useWithExtraFieldsSuspenseQuery>;
export type WithExtraFieldsQueryResult = Apollo.QueryResult<WithExtraFieldsQuery, WithExtraFieldsQueryVariables>;
export const SendFeedbackDocument = gql`
    mutation SendFeedback($input: SendFeedbackInput!) {
  sendFeedback(input: $input) {
    id
    title
  }
}
    `;
export type SendFeedbackMutationFn = Apollo.MutationFunction<SendFeedbackMutation, SendFeedbackMutationVariables>;

/**
 * __useSendFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackMutation, { data, loading, error }] = useSendFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendFeedbackMutation, SendFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeedbackMutation, SendFeedbackMutationVariables>(SendFeedbackDocument, options);
      }
export type SendFeedbackMutationHookResult = ReturnType<typeof useSendFeedbackMutation>;
export type SendFeedbackMutationResult = Apollo.MutationResult<SendFeedbackMutation>;
export type SendFeedbackMutationOptions = Apollo.BaseMutationOptions<SendFeedbackMutation, SendFeedbackMutationVariables>;
export const AddLoomVideoDocument = gql`
    mutation addLoomVideo($input: LoomVideoInput!) {
  loomVideo {
    createLoomVideo(input: $input) {
      recordId
      record {
        ...LoomVideo
      }
      related {
        ...WithLoomVideoId
        loomVideo {
          ...LoomVideo
        }
      }
    }
  }
}
    ${LoomVideoFragmentDoc}
${WithLoomVideoIdFragmentDoc}`;
export type AddLoomVideoMutationFn = Apollo.MutationFunction<AddLoomVideoMutation, AddLoomVideoMutationVariables>;

/**
 * __useAddLoomVideoMutation__
 *
 * To run a mutation, you first call `useAddLoomVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoomVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoomVideoMutation, { data, loading, error }] = useAddLoomVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLoomVideoMutation(baseOptions?: Apollo.MutationHookOptions<AddLoomVideoMutation, AddLoomVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLoomVideoMutation, AddLoomVideoMutationVariables>(AddLoomVideoDocument, options);
      }
export type AddLoomVideoMutationHookResult = ReturnType<typeof useAddLoomVideoMutation>;
export type AddLoomVideoMutationResult = Apollo.MutationResult<AddLoomVideoMutation>;
export type AddLoomVideoMutationOptions = Apollo.BaseMutationOptions<AddLoomVideoMutation, AddLoomVideoMutationVariables>;
export const RemoveLoomVideoDocument = gql`
    mutation removeLoomVideo($input: DeleteLoomVideoInput!) {
  loomVideo {
    deleteLoomVideo(input: $input) {
      recordId
      related {
        ...WithLoomVideoId
        loomVideo {
          ...LoomVideo
        }
      }
    }
  }
}
    ${WithLoomVideoIdFragmentDoc}
${LoomVideoFragmentDoc}`;
export type RemoveLoomVideoMutationFn = Apollo.MutationFunction<RemoveLoomVideoMutation, RemoveLoomVideoMutationVariables>;

/**
 * __useRemoveLoomVideoMutation__
 *
 * To run a mutation, you first call `useRemoveLoomVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLoomVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLoomVideoMutation, { data, loading, error }] = useRemoveLoomVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLoomVideoMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLoomVideoMutation, RemoveLoomVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLoomVideoMutation, RemoveLoomVideoMutationVariables>(RemoveLoomVideoDocument, options);
      }
export type RemoveLoomVideoMutationHookResult = ReturnType<typeof useRemoveLoomVideoMutation>;
export type RemoveLoomVideoMutationResult = Apollo.MutationResult<RemoveLoomVideoMutation>;
export type RemoveLoomVideoMutationOptions = Apollo.BaseMutationOptions<RemoveLoomVideoMutation, RemoveLoomVideoMutationVariables>;
export const MyAllApprovalRequestsLightDocument = gql`
    query myAllApprovalRequestsLight {
  me {
    Id
    approvalRequests {
      Id
      flair__Approval_Status__c
      flair__Related_Object_Name__c
      absence {
        Id
        flair__Approval_Status__c
      }
    }
  }
}
    `;

/**
 * __useMyAllApprovalRequestsLightQuery__
 *
 * To run a query within a React component, call `useMyAllApprovalRequestsLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAllApprovalRequestsLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAllApprovalRequestsLightQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAllApprovalRequestsLightQuery(baseOptions?: Apollo.QueryHookOptions<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>(MyAllApprovalRequestsLightDocument, options);
      }
export function useMyAllApprovalRequestsLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>(MyAllApprovalRequestsLightDocument, options);
        }
export function useMyAllApprovalRequestsLightSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>(MyAllApprovalRequestsLightDocument, options);
        }
export type MyAllApprovalRequestsLightQueryHookResult = ReturnType<typeof useMyAllApprovalRequestsLightQuery>;
export type MyAllApprovalRequestsLightLazyQueryHookResult = ReturnType<typeof useMyAllApprovalRequestsLightLazyQuery>;
export type MyAllApprovalRequestsLightSuspenseQueryHookResult = ReturnType<typeof useMyAllApprovalRequestsLightSuspenseQuery>;
export type MyAllApprovalRequestsLightQueryResult = Apollo.QueryResult<MyAllApprovalRequestsLightQuery, MyAllApprovalRequestsLightQueryVariables>;
export const MarkAllInboxNotificationsAsReadDocument = gql`
    mutation markAllInboxNotificationsAsRead {
  notifications {
    markAllInboxNotificationsAsRead {
      recordIds
    }
  }
}
    `;
export type MarkAllInboxNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllInboxNotificationsAsReadMutation, MarkAllInboxNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllInboxNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllInboxNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllInboxNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllInboxNotificationsAsReadMutation, { data, loading, error }] = useMarkAllInboxNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllInboxNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllInboxNotificationsAsReadMutation, MarkAllInboxNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllInboxNotificationsAsReadMutation, MarkAllInboxNotificationsAsReadMutationVariables>(MarkAllInboxNotificationsAsReadDocument, options);
      }
export type MarkAllInboxNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllInboxNotificationsAsReadMutation>;
export type MarkAllInboxNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllInboxNotificationsAsReadMutation>;
export type MarkAllInboxNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllInboxNotificationsAsReadMutation, MarkAllInboxNotificationsAsReadMutationVariables>;
export const MarkAllTaskNotificationsAsReadDocument = gql`
    mutation markAllTaskNotificationsAsRead {
  notifications {
    markAllTaskNotificationsAsRead {
      recordIds
    }
  }
}
    `;
export type MarkAllTaskNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllTaskNotificationsAsReadMutation, MarkAllTaskNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllTaskNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllTaskNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllTaskNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllTaskNotificationsAsReadMutation, { data, loading, error }] = useMarkAllTaskNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllTaskNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllTaskNotificationsAsReadMutation, MarkAllTaskNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllTaskNotificationsAsReadMutation, MarkAllTaskNotificationsAsReadMutationVariables>(MarkAllTaskNotificationsAsReadDocument, options);
      }
export type MarkAllTaskNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllTaskNotificationsAsReadMutation>;
export type MarkAllTaskNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllTaskNotificationsAsReadMutation>;
export type MarkAllTaskNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllTaskNotificationsAsReadMutation, MarkAllTaskNotificationsAsReadMutationVariables>;
export const ArchiveAllInboxNotificationsDocument = gql`
    mutation archiveAllInboxNotifications {
  notifications {
    archiveAllInboxNotifications {
      recordIds
    }
  }
}
    `;
export type ArchiveAllInboxNotificationsMutationFn = Apollo.MutationFunction<ArchiveAllInboxNotificationsMutation, ArchiveAllInboxNotificationsMutationVariables>;

/**
 * __useArchiveAllInboxNotificationsMutation__
 *
 * To run a mutation, you first call `useArchiveAllInboxNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAllInboxNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAllInboxNotificationsMutation, { data, loading, error }] = useArchiveAllInboxNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useArchiveAllInboxNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAllInboxNotificationsMutation, ArchiveAllInboxNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAllInboxNotificationsMutation, ArchiveAllInboxNotificationsMutationVariables>(ArchiveAllInboxNotificationsDocument, options);
      }
export type ArchiveAllInboxNotificationsMutationHookResult = ReturnType<typeof useArchiveAllInboxNotificationsMutation>;
export type ArchiveAllInboxNotificationsMutationResult = Apollo.MutationResult<ArchiveAllInboxNotificationsMutation>;
export type ArchiveAllInboxNotificationsMutationOptions = Apollo.BaseMutationOptions<ArchiveAllInboxNotificationsMutation, ArchiveAllInboxNotificationsMutationVariables>;
export const ArchiveNotificationDocument = gql`
    mutation archiveNotification($id: String!) {
  notifications {
    archiveNotification(input: {id: $id}) {
      recordId
      error
    }
  }
}
    `;
export type ArchiveNotificationMutationFn = Apollo.MutationFunction<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;

/**
 * __useArchiveNotificationMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationMutation, { data, loading, error }] = useArchiveNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>(ArchiveNotificationDocument, options);
      }
export type ArchiveNotificationMutationHookResult = ReturnType<typeof useArchiveNotificationMutation>;
export type ArchiveNotificationMutationResult = Apollo.MutationResult<ArchiveNotificationMutation>;
export type ArchiveNotificationMutationOptions = Apollo.BaseMutationOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;
export const UnarchiveNotificationDocument = gql`
    mutation unarchiveNotification($id: String!) {
  notifications {
    unarchiveNotification(input: {id: $id}) {
      recordId
      error
    }
  }
}
    `;
export type UnarchiveNotificationMutationFn = Apollo.MutationFunction<UnarchiveNotificationMutation, UnarchiveNotificationMutationVariables>;

/**
 * __useUnarchiveNotificationMutation__
 *
 * To run a mutation, you first call `useUnarchiveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveNotificationMutation, { data, loading, error }] = useUnarchiveNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveNotificationMutation, UnarchiveNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveNotificationMutation, UnarchiveNotificationMutationVariables>(UnarchiveNotificationDocument, options);
      }
export type UnarchiveNotificationMutationHookResult = ReturnType<typeof useUnarchiveNotificationMutation>;
export type UnarchiveNotificationMutationResult = Apollo.MutationResult<UnarchiveNotificationMutation>;
export type UnarchiveNotificationMutationOptions = Apollo.BaseMutationOptions<UnarchiveNotificationMutation, UnarchiveNotificationMutationVariables>;
export const SnoozeNotificationDocument = gql`
    mutation snoozeNotification($id: String!, $unsnoozeAt: DateTime!) {
  notifications {
    snoozeNotification(input: {id: $id, unsnoozeAt: $unsnoozeAt}) {
      recordId
      error
    }
  }
}
    `;
export type SnoozeNotificationMutationFn = Apollo.MutationFunction<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>;

/**
 * __useSnoozeNotificationMutation__
 *
 * To run a mutation, you first call `useSnoozeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeNotificationMutation, { data, loading, error }] = useSnoozeNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      unsnoozeAt: // value for 'unsnoozeAt'
 *   },
 * });
 */
export function useSnoozeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>(SnoozeNotificationDocument, options);
      }
export type SnoozeNotificationMutationHookResult = ReturnType<typeof useSnoozeNotificationMutation>;
export type SnoozeNotificationMutationResult = Apollo.MutationResult<SnoozeNotificationMutation>;
export type SnoozeNotificationMutationOptions = Apollo.BaseMutationOptions<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>;
export const UnsnoozeNotificationDocument = gql`
    mutation unsnoozeNotification($id: String!) {
  notifications {
    unsnoozeNotification(input: {id: $id}) {
      recordId
      error
    }
  }
}
    `;
export type UnsnoozeNotificationMutationFn = Apollo.MutationFunction<UnsnoozeNotificationMutation, UnsnoozeNotificationMutationVariables>;

/**
 * __useUnsnoozeNotificationMutation__
 *
 * To run a mutation, you first call `useUnsnoozeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsnoozeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsnoozeNotificationMutation, { data, loading, error }] = useUnsnoozeNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsnoozeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UnsnoozeNotificationMutation, UnsnoozeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsnoozeNotificationMutation, UnsnoozeNotificationMutationVariables>(UnsnoozeNotificationDocument, options);
      }
export type UnsnoozeNotificationMutationHookResult = ReturnType<typeof useUnsnoozeNotificationMutation>;
export type UnsnoozeNotificationMutationResult = Apollo.MutationResult<UnsnoozeNotificationMutation>;
export type UnsnoozeNotificationMutationOptions = Apollo.BaseMutationOptions<UnsnoozeNotificationMutation, UnsnoozeNotificationMutationVariables>;
export const NotificationsHomePageDocument = gql`
    query NotificationsHomePage {
  me {
    Id
    inboxNotifications(pagination: {offset: 0, limit: 10}) {
      unreadCount
    }
    taskNotifications(pagination: {offset: 0, limit: 10}) {
      unreadCount
      paginationInfo {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useNotificationsHomePageQuery__
 *
 * To run a query within a React component, call `useNotificationsHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsHomePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsHomePageQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>(NotificationsHomePageDocument, options);
      }
export function useNotificationsHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>(NotificationsHomePageDocument, options);
        }
export function useNotificationsHomePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>(NotificationsHomePageDocument, options);
        }
export type NotificationsHomePageQueryHookResult = ReturnType<typeof useNotificationsHomePageQuery>;
export type NotificationsHomePageLazyQueryHookResult = ReturnType<typeof useNotificationsHomePageLazyQuery>;
export type NotificationsHomePageSuspenseQueryHookResult = ReturnType<typeof useNotificationsHomePageSuspenseQuery>;
export type NotificationsHomePageQueryResult = Apollo.QueryResult<NotificationsHomePageQuery, NotificationsHomePageQueryVariables>;
export const InboxNotificationsDocument = gql`
    query InboxNotifications($offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  me {
    Id
    inboxNotifications(pagination: {offset: $offset, limit: $limit}) {
      items {
        ...NotificationItem
      }
      unreadCount
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${NotificationItemFragmentDoc}`;

/**
 * __useInboxNotificationsQuery__
 *
 * To run a query within a React component, call `useInboxNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useInboxNotificationsQuery(baseOptions: Apollo.QueryHookOptions<InboxNotificationsQuery, InboxNotificationsQueryVariables> & ({ variables: InboxNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxNotificationsQuery, InboxNotificationsQueryVariables>(InboxNotificationsDocument, options);
      }
export function useInboxNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxNotificationsQuery, InboxNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxNotificationsQuery, InboxNotificationsQueryVariables>(InboxNotificationsDocument, options);
        }
export function useInboxNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InboxNotificationsQuery, InboxNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InboxNotificationsQuery, InboxNotificationsQueryVariables>(InboxNotificationsDocument, options);
        }
export type InboxNotificationsQueryHookResult = ReturnType<typeof useInboxNotificationsQuery>;
export type InboxNotificationsLazyQueryHookResult = ReturnType<typeof useInboxNotificationsLazyQuery>;
export type InboxNotificationsSuspenseQueryHookResult = ReturnType<typeof useInboxNotificationsSuspenseQuery>;
export type InboxNotificationsQueryResult = Apollo.QueryResult<InboxNotificationsQuery, InboxNotificationsQueryVariables>;
export const TaskNotificationsDocument = gql`
    query TaskNotifications($offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  me {
    Id
    taskNotifications(pagination: {offset: $offset, limit: $limit}) {
      items {
        ...NotificationItem
      }
      unreadCount
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${NotificationItemFragmentDoc}`;

/**
 * __useTaskNotificationsQuery__
 *
 * To run a query within a React component, call `useTaskNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useTaskNotificationsQuery(baseOptions: Apollo.QueryHookOptions<TaskNotificationsQuery, TaskNotificationsQueryVariables> & ({ variables: TaskNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>(TaskNotificationsDocument, options);
      }
export function useTaskNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskNotificationsQuery, TaskNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>(TaskNotificationsDocument, options);
        }
export function useTaskNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskNotificationsQuery, TaskNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>(TaskNotificationsDocument, options);
        }
export type TaskNotificationsQueryHookResult = ReturnType<typeof useTaskNotificationsQuery>;
export type TaskNotificationsLazyQueryHookResult = ReturnType<typeof useTaskNotificationsLazyQuery>;
export type TaskNotificationsSuspenseQueryHookResult = ReturnType<typeof useTaskNotificationsSuspenseQuery>;
export type TaskNotificationsQueryResult = Apollo.QueryResult<TaskNotificationsQuery, TaskNotificationsQueryVariables>;
export const SnoozedNotificationsDocument = gql`
    query SnoozedNotifications($offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  me {
    Id
    snoozedNotifications(pagination: {offset: $offset, limit: $limit}) {
      items {
        ...NotificationItem
      }
      unreadCount
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${NotificationItemFragmentDoc}`;

/**
 * __useSnoozedNotificationsQuery__
 *
 * To run a query within a React component, call `useSnoozedNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnoozedNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnoozedNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useSnoozedNotificationsQuery(baseOptions: Apollo.QueryHookOptions<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables> & ({ variables: SnoozedNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables>(SnoozedNotificationsDocument, options);
      }
export function useSnoozedNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables>(SnoozedNotificationsDocument, options);
        }
export function useSnoozedNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables>(SnoozedNotificationsDocument, options);
        }
export type SnoozedNotificationsQueryHookResult = ReturnType<typeof useSnoozedNotificationsQuery>;
export type SnoozedNotificationsLazyQueryHookResult = ReturnType<typeof useSnoozedNotificationsLazyQuery>;
export type SnoozedNotificationsSuspenseQueryHookResult = ReturnType<typeof useSnoozedNotificationsSuspenseQuery>;
export type SnoozedNotificationsQueryResult = Apollo.QueryResult<SnoozedNotificationsQuery, SnoozedNotificationsQueryVariables>;
export const SnoozedNotificationsTotalCountDocument = gql`
    query SnoozedNotificationsTotalCount {
  me {
    Id
    snoozedNotifications {
      paginationInfo {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useSnoozedNotificationsTotalCountQuery__
 *
 * To run a query within a React component, call `useSnoozedNotificationsTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnoozedNotificationsTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnoozedNotificationsTotalCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useSnoozedNotificationsTotalCountQuery(baseOptions?: Apollo.QueryHookOptions<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>(SnoozedNotificationsTotalCountDocument, options);
      }
export function useSnoozedNotificationsTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>(SnoozedNotificationsTotalCountDocument, options);
        }
export function useSnoozedNotificationsTotalCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>(SnoozedNotificationsTotalCountDocument, options);
        }
export type SnoozedNotificationsTotalCountQueryHookResult = ReturnType<typeof useSnoozedNotificationsTotalCountQuery>;
export type SnoozedNotificationsTotalCountLazyQueryHookResult = ReturnType<typeof useSnoozedNotificationsTotalCountLazyQuery>;
export type SnoozedNotificationsTotalCountSuspenseQueryHookResult = ReturnType<typeof useSnoozedNotificationsTotalCountSuspenseQuery>;
export type SnoozedNotificationsTotalCountQueryResult = Apollo.QueryResult<SnoozedNotificationsTotalCountQuery, SnoozedNotificationsTotalCountQueryVariables>;
export const ArchivedNotificationsDocument = gql`
    query ArchivedNotifications($offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  me {
    Id
    archivedNotifications(
      filter: {searchText: null}
      pagination: {offset: $offset, limit: $limit}
    ) {
      items {
        ...NotificationItem
      }
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${NotificationItemFragmentDoc}`;

/**
 * __useArchivedNotificationsQuery__
 *
 * To run a query within a React component, call `useArchivedNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useArchivedNotificationsQuery(baseOptions: Apollo.QueryHookOptions<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables> & ({ variables: ArchivedNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables>(ArchivedNotificationsDocument, options);
      }
export function useArchivedNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables>(ArchivedNotificationsDocument, options);
        }
export function useArchivedNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables>(ArchivedNotificationsDocument, options);
        }
export type ArchivedNotificationsQueryHookResult = ReturnType<typeof useArchivedNotificationsQuery>;
export type ArchivedNotificationsLazyQueryHookResult = ReturnType<typeof useArchivedNotificationsLazyQuery>;
export type ArchivedNotificationsSuspenseQueryHookResult = ReturnType<typeof useArchivedNotificationsSuspenseQuery>;
export type ArchivedNotificationsQueryResult = Apollo.QueryResult<ArchivedNotificationsQuery, ArchivedNotificationsQueryVariables>;
export const CreateReactionDocument = gql`
    mutation createReaction($input: CreateReactionInput!) {
  reaction {
    createReaction(input: $input) {
      recordId
      record {
        ...Reaction
      }
      related {
        Id
        reactions {
          ...Reaction
        }
      }
      error
    }
  }
}
    ${ReactionFragmentDoc}`;
export type CreateReactionMutationFn = Apollo.MutationFunction<CreateReactionMutation, CreateReactionMutationVariables>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateReactionMutation, CreateReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReactionMutation, CreateReactionMutationVariables>(CreateReactionDocument, options);
      }
export type CreateReactionMutationHookResult = ReturnType<typeof useCreateReactionMutation>;
export type CreateReactionMutationResult = Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<CreateReactionMutation, CreateReactionMutationVariables>;
export const DeleteReactionDocument = gql`
    mutation deleteReaction($id: String!) {
  reaction {
    deleteReaction(id: $id) {
      recordId
      related {
        Id
        reactions {
          ...Reaction
        }
      }
      error
    }
  }
}
    ${ReactionFragmentDoc}`;
export type DeleteReactionMutationFn = Apollo.MutationFunction<DeleteReactionMutation, DeleteReactionMutationVariables>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReactionMutation, DeleteReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(DeleteReactionDocument, options);
      }
export type DeleteReactionMutationHookResult = ReturnType<typeof useDeleteReactionMutation>;
export type DeleteReactionMutationResult = Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<DeleteReactionMutation, DeleteReactionMutationVariables>;
export const RequestAbsenceSidebarDocument = gql`
    query RequestAbsenceSidebar($from: DateTime!, $to: DateTime!) {
  me {
    Id
    absences(from: $from, to: $to, excludeRejected: true) {
      Id
      flair__Approval_Status__c
      flair__Category_Name__c
      flair__Category_Icon__c
      flair__Amount__c
      flair__Working_Amount__c
      flair__Start_Date__c
      flair__Start_Time__c
      flair__Start_Date_Half_Day__c
      flair__End_Date__c
      flair__End_Time__c
      flair__End_Date_Half_Day__c
      flair__Type__c
      flair__Employee_Absence_Category__c
    }
  }
}
    `;

/**
 * __useRequestAbsenceSidebarQuery__
 *
 * To run a query within a React component, call `useRequestAbsenceSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestAbsenceSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestAbsenceSidebarQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useRequestAbsenceSidebarQuery(baseOptions: Apollo.QueryHookOptions<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables> & ({ variables: RequestAbsenceSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables>(RequestAbsenceSidebarDocument, options);
      }
export function useRequestAbsenceSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables>(RequestAbsenceSidebarDocument, options);
        }
export function useRequestAbsenceSidebarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables>(RequestAbsenceSidebarDocument, options);
        }
export type RequestAbsenceSidebarQueryHookResult = ReturnType<typeof useRequestAbsenceSidebarQuery>;
export type RequestAbsenceSidebarLazyQueryHookResult = ReturnType<typeof useRequestAbsenceSidebarLazyQuery>;
export type RequestAbsenceSidebarSuspenseQueryHookResult = ReturnType<typeof useRequestAbsenceSidebarSuspenseQuery>;
export type RequestAbsenceSidebarQueryResult = Apollo.QueryResult<RequestAbsenceSidebarQuery, RequestAbsenceSidebarQueryVariables>;
export const EmployeeAbsenceCategoryByIdDocument = gql`
    query EmployeeAbsenceCategoryById($id: String!) {
  employeeAbsenceCategoryById(id: $id) {
    Id
    flair__Unlimited__c
    category {
      Id
      Name
      flair__Type__c
      flair__Special_Rules__c
      flair__Order__c
      flair__Without_Balance__c
      group {
        Id
        Name
        flair__Order__c
      }
    }
    accrualPolicies {
      accrualPolicy {
        flair__Interval__c
      }
    }
    absenceRequestPolicies {
      Id
      absenceRequestPolicy {
        Id
        Name
        flair__Min_Absence_Amount__c
        flair__Max_Absence_Amount__c
        flair__Max_Used_Amount__c
        flair__Max_Used_Amount_Period__c
        flair__Min_Notice_Required__c
        flair__Min_Notice_Period_Unit__c
        flair__Document_Upload__c
        flair__Min_Amount_For_Document_Upload__c
        flair__Require_Note__c
        flair__Note_Placeholder__c
      }
    }
  }
}
    `;

/**
 * __useEmployeeAbsenceCategoryByIdQuery__
 *
 * To run a query within a React component, call `useEmployeeAbsenceCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeAbsenceCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeAbsenceCategoryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeAbsenceCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables> & ({ variables: EmployeeAbsenceCategoryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables>(EmployeeAbsenceCategoryByIdDocument, options);
      }
export function useEmployeeAbsenceCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables>(EmployeeAbsenceCategoryByIdDocument, options);
        }
export function useEmployeeAbsenceCategoryByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables>(EmployeeAbsenceCategoryByIdDocument, options);
        }
export type EmployeeAbsenceCategoryByIdQueryHookResult = ReturnType<typeof useEmployeeAbsenceCategoryByIdQuery>;
export type EmployeeAbsenceCategoryByIdLazyQueryHookResult = ReturnType<typeof useEmployeeAbsenceCategoryByIdLazyQuery>;
export type EmployeeAbsenceCategoryByIdSuspenseQueryHookResult = ReturnType<typeof useEmployeeAbsenceCategoryByIdSuspenseQuery>;
export type EmployeeAbsenceCategoryByIdQueryResult = Apollo.QueryResult<EmployeeAbsenceCategoryByIdQuery, EmployeeAbsenceCategoryByIdQueryVariables>;
export const CalculateAbsenceWorkingAmountDocument = gql`
    query CalculateAbsenceWorkingAmount($input: CalculateAbsenceWorkingAmountInput!) {
  calculateAbsenceWorkingAmount(input: $input) {
    workingAmount
    hasCredits
    allowances {
      id
      amountLeft
      withdrawalAmount
      periodStartDate
      periodEndDate
    }
  }
}
    `;

/**
 * __useCalculateAbsenceWorkingAmountQuery__
 *
 * To run a query within a React component, call `useCalculateAbsenceWorkingAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateAbsenceWorkingAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateAbsenceWorkingAmountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateAbsenceWorkingAmountQuery(baseOptions: Apollo.QueryHookOptions<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables> & ({ variables: CalculateAbsenceWorkingAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables>(CalculateAbsenceWorkingAmountDocument, options);
      }
export function useCalculateAbsenceWorkingAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables>(CalculateAbsenceWorkingAmountDocument, options);
        }
export function useCalculateAbsenceWorkingAmountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables>(CalculateAbsenceWorkingAmountDocument, options);
        }
export type CalculateAbsenceWorkingAmountQueryHookResult = ReturnType<typeof useCalculateAbsenceWorkingAmountQuery>;
export type CalculateAbsenceWorkingAmountLazyQueryHookResult = ReturnType<typeof useCalculateAbsenceWorkingAmountLazyQuery>;
export type CalculateAbsenceWorkingAmountSuspenseQueryHookResult = ReturnType<typeof useCalculateAbsenceWorkingAmountSuspenseQuery>;
export type CalculateAbsenceWorkingAmountQueryResult = Apollo.QueryResult<CalculateAbsenceWorkingAmountQuery, CalculateAbsenceWorkingAmountQueryVariables>;
export const ValidateRequestAbsenceDocument = gql`
    mutation ValidateRequestAbsence($input: RequestAbsenceInput!) {
  absence {
    validateAbsenceRequest(input: $input) {
      requestedAmount
      allowances {
        ...RequestAbsence_WithdrawalAllowance
      }
      employeeAbsenceCategory {
        Id
        currentYearSummary {
          ...RequestAbsence_YearlySummary
        }
      }
      error {
        ... on ValidateAbsenceRequestOverlappingAbsencesError {
          overlappingAbsences {
            Id
            flair__Approval_Status__c
            flair__Category_Name__c
            flair__Category_Icon__c
            flair__Amount__c
            flair__Working_Amount__c
            flair__Start_Date__c
            flair__Start_Time__c
            flair__Start_Date_Half_Day__c
            flair__End_Date__c
            flair__End_Time__c
            flair__End_Date_Half_Day__c
            flair__Type__c
            flair__Employee_Absence_Category__c
          }
        }
        ... on ValidateAbsenceRequestInsufficientCreditsError {
          requestedAmount
        }
        ... on ValidateAbsenceRequestBelowMinAmountError {
          requestedAmount
          minAmount
        }
        ... on ValidateAbsenceRequestAboveMaxAmountError {
          requestedAmount
          maxAmount
        }
        ... on ValidateAbsenceRequestInsufficientNoticePeriodError {
          requestedAmount
          noticePeriodAmount
          noticePeriodUnit
        }
        ... on ValidateAbsenceRequestAboveMaxUsedAmountError {
          requestedAmount
          usedAmount
          maxUsedAmount
          maxUsedAmountPeriod {
            startDate
            endDate
          }
        }
      }
    }
  }
}
    ${RequestAbsence_WithdrawalAllowanceFragmentDoc}
${RequestAbsence_YearlySummaryFragmentDoc}`;
export type ValidateRequestAbsenceMutationFn = Apollo.MutationFunction<ValidateRequestAbsenceMutation, ValidateRequestAbsenceMutationVariables>;

/**
 * __useValidateRequestAbsenceMutation__
 *
 * To run a mutation, you first call `useValidateRequestAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateRequestAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateRequestAbsenceMutation, { data, loading, error }] = useValidateRequestAbsenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateRequestAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<ValidateRequestAbsenceMutation, ValidateRequestAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateRequestAbsenceMutation, ValidateRequestAbsenceMutationVariables>(ValidateRequestAbsenceDocument, options);
      }
export type ValidateRequestAbsenceMutationHookResult = ReturnType<typeof useValidateRequestAbsenceMutation>;
export type ValidateRequestAbsenceMutationResult = Apollo.MutationResult<ValidateRequestAbsenceMutation>;
export type ValidateRequestAbsenceMutationOptions = Apollo.BaseMutationOptions<ValidateRequestAbsenceMutation, ValidateRequestAbsenceMutationVariables>;
export const UpsertAbsenceDocument = gql`
    mutation upsertAbsence($input: UpsertAbsenceInput!) {
  absence {
    upsertAbsence(input: $input) {
      ...RequestedAbsence
    }
  }
}
    ${RequestedAbsenceFragmentDoc}`;
export type UpsertAbsenceMutationFn = Apollo.MutationFunction<UpsertAbsenceMutation, UpsertAbsenceMutationVariables>;

/**
 * __useUpsertAbsenceMutation__
 *
 * To run a mutation, you first call `useUpsertAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAbsenceMutation, { data, loading, error }] = useUpsertAbsenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAbsenceMutation, UpsertAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAbsenceMutation, UpsertAbsenceMutationVariables>(UpsertAbsenceDocument, options);
      }
export type UpsertAbsenceMutationHookResult = ReturnType<typeof useUpsertAbsenceMutation>;
export type UpsertAbsenceMutationResult = Apollo.MutationResult<UpsertAbsenceMutation>;
export type UpsertAbsenceMutationOptions = Apollo.BaseMutationOptions<UpsertAbsenceMutation, UpsertAbsenceMutationVariables>;
export const EmployeeRequestFormsDocument = gql`
    query EmployeeRequestForms {
  requestForms(sortBy: "Name") {
    ...RequestForm
  }
}
    ${RequestFormFragmentDoc}`;

/**
 * __useEmployeeRequestFormsQuery__
 *
 * To run a query within a React component, call `useEmployeeRequestFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeRequestFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeRequestFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeRequestFormsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>(EmployeeRequestFormsDocument, options);
      }
export function useEmployeeRequestFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>(EmployeeRequestFormsDocument, options);
        }
export function useEmployeeRequestFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>(EmployeeRequestFormsDocument, options);
        }
export type EmployeeRequestFormsQueryHookResult = ReturnType<typeof useEmployeeRequestFormsQuery>;
export type EmployeeRequestFormsLazyQueryHookResult = ReturnType<typeof useEmployeeRequestFormsLazyQuery>;
export type EmployeeRequestFormsSuspenseQueryHookResult = ReturnType<typeof useEmployeeRequestFormsSuspenseQuery>;
export type EmployeeRequestFormsQueryResult = Apollo.QueryResult<EmployeeRequestFormsQuery, EmployeeRequestFormsQueryVariables>;
export const RequestFormsForManagerDocument = gql`
    query RequestFormsForManager {
  manager {
    Id
    employees(filter: {managerReportsType: ALL}) {
      ...RequestForm_Employee
    }
  }
  requestForms(sortBy: "Name") {
    ...RequestForm
  }
}
    ${RequestForm_EmployeeFragmentDoc}
${RequestFormFragmentDoc}`;

/**
 * __useRequestFormsForManagerQuery__
 *
 * To run a query within a React component, call `useRequestFormsForManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestFormsForManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestFormsForManagerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestFormsForManagerQuery(baseOptions?: Apollo.QueryHookOptions<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>(RequestFormsForManagerDocument, options);
      }
export function useRequestFormsForManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>(RequestFormsForManagerDocument, options);
        }
export function useRequestFormsForManagerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>(RequestFormsForManagerDocument, options);
        }
export type RequestFormsForManagerQueryHookResult = ReturnType<typeof useRequestFormsForManagerQuery>;
export type RequestFormsForManagerLazyQueryHookResult = ReturnType<typeof useRequestFormsForManagerLazyQuery>;
export type RequestFormsForManagerSuspenseQueryHookResult = ReturnType<typeof useRequestFormsForManagerSuspenseQuery>;
export type RequestFormsForManagerQueryResult = Apollo.QueryResult<RequestFormsForManagerQuery, RequestFormsForManagerQueryVariables>;
export const MyEmployeeDataChangeRequestsDocument = gql`
    query MyEmployeeDataChangeRequests {
  me {
    Id
    employeeDataChangeRequests {
      ...EmployeeDataChangeRequestFields
    }
  }
}
    ${EmployeeDataChangeRequestFieldsFragmentDoc}`;

/**
 * __useMyEmployeeDataChangeRequestsQuery__
 *
 * To run a query within a React component, call `useMyEmployeeDataChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEmployeeDataChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEmployeeDataChangeRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEmployeeDataChangeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>(MyEmployeeDataChangeRequestsDocument, options);
      }
export function useMyEmployeeDataChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>(MyEmployeeDataChangeRequestsDocument, options);
        }
export function useMyEmployeeDataChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>(MyEmployeeDataChangeRequestsDocument, options);
        }
export type MyEmployeeDataChangeRequestsQueryHookResult = ReturnType<typeof useMyEmployeeDataChangeRequestsQuery>;
export type MyEmployeeDataChangeRequestsLazyQueryHookResult = ReturnType<typeof useMyEmployeeDataChangeRequestsLazyQuery>;
export type MyEmployeeDataChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useMyEmployeeDataChangeRequestsSuspenseQuery>;
export type MyEmployeeDataChangeRequestsQueryResult = Apollo.QueryResult<MyEmployeeDataChangeRequestsQuery, MyEmployeeDataChangeRequestsQueryVariables>;
export const CreateDataChangeRequestDocument = gql`
    mutation CreateDataChangeRequest($input: CreateDataChangeRequestInput!) {
  requestForm {
    createDataChangeRequest(input: $input) {
      recordId
      query {
        employeeDataChangeRequests {
          ...EmployeeDataChangeRequestFields
        }
        me {
          Id
          employeeDataChangeRequests {
            ...EmployeeDataChangeRequestFields
          }
        }
      }
    }
  }
}
    ${EmployeeDataChangeRequestFieldsFragmentDoc}`;
export type CreateDataChangeRequestMutationFn = Apollo.MutationFunction<CreateDataChangeRequestMutation, CreateDataChangeRequestMutationVariables>;

/**
 * __useCreateDataChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateDataChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataChangeRequestMutation, { data, loading, error }] = useCreateDataChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataChangeRequestMutation, CreateDataChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataChangeRequestMutation, CreateDataChangeRequestMutationVariables>(CreateDataChangeRequestDocument, options);
      }
export type CreateDataChangeRequestMutationHookResult = ReturnType<typeof useCreateDataChangeRequestMutation>;
export type CreateDataChangeRequestMutationResult = Apollo.MutationResult<CreateDataChangeRequestMutation>;
export type CreateDataChangeRequestMutationOptions = Apollo.BaseMutationOptions<CreateDataChangeRequestMutation, CreateDataChangeRequestMutationVariables>;
export const ValidateDataChangeRequestDocument = gql`
    mutation ValidateDataChangeRequest($input: CreateDataChangeRequestInput!) {
  requestForm {
    validateCreateDataChangeRequest(input: $input) {
      isValid
      error
    }
  }
}
    `;
export type ValidateDataChangeRequestMutationFn = Apollo.MutationFunction<ValidateDataChangeRequestMutation, ValidateDataChangeRequestMutationVariables>;

/**
 * __useValidateDataChangeRequestMutation__
 *
 * To run a mutation, you first call `useValidateDataChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDataChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDataChangeRequestMutation, { data, loading, error }] = useValidateDataChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateDataChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDataChangeRequestMutation, ValidateDataChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDataChangeRequestMutation, ValidateDataChangeRequestMutationVariables>(ValidateDataChangeRequestDocument, options);
      }
export type ValidateDataChangeRequestMutationHookResult = ReturnType<typeof useValidateDataChangeRequestMutation>;
export type ValidateDataChangeRequestMutationResult = Apollo.MutationResult<ValidateDataChangeRequestMutation>;
export type ValidateDataChangeRequestMutationOptions = Apollo.BaseMutationOptions<ValidateDataChangeRequestMutation, ValidateDataChangeRequestMutationVariables>;
export const PositionsDocument = gql`
    query Positions($filter: PositionFilterInput) {
  positions(filter: $filter) {
    Id
    Name
    flair__Title__c
    flair__Staffed__c
    flair__Parent_Position__c
    flair__Active__c
    employment {
      Id
      Name
      flair__Employee__c
      flair__Active__c
      flair__Main__c
      employee {
        Id
        Name
      }
    }
  }
}
    `;

/**
 * __usePositionsQuery__
 *
 * To run a query within a React component, call `usePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePositionsQuery(baseOptions?: Apollo.QueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
      }
export function usePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
        }
export function usePositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
        }
export type PositionsQueryHookResult = ReturnType<typeof usePositionsQuery>;
export type PositionsLazyQueryHookResult = ReturnType<typeof usePositionsLazyQuery>;
export type PositionsSuspenseQueryHookResult = ReturnType<typeof usePositionsSuspenseQuery>;
export type PositionsQueryResult = Apollo.QueryResult<PositionsQuery, PositionsQueryVariables>;
export const EmployeeSalariesForChangeRequestDocument = gql`
    query EmployeeSalariesForChangeRequest($employeeId: String!) {
  manager {
    Id
    employee(id: $employeeId) {
      Id
      salaries {
        Id
        flair__Amount__c
        flair__Salary_Type__c
        flair__Start_Date__c
        flair__End_Date__c
        flair__Formula_Status__c
        CurrencyIsoCode
      }
    }
  }
}
    `;

/**
 * __useEmployeeSalariesForChangeRequestQuery__
 *
 * To run a query within a React component, call `useEmployeeSalariesForChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSalariesForChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSalariesForChangeRequestQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeSalariesForChangeRequestQuery(baseOptions: Apollo.QueryHookOptions<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables> & ({ variables: EmployeeSalariesForChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables>(EmployeeSalariesForChangeRequestDocument, options);
      }
export function useEmployeeSalariesForChangeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables>(EmployeeSalariesForChangeRequestDocument, options);
        }
export function useEmployeeSalariesForChangeRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables>(EmployeeSalariesForChangeRequestDocument, options);
        }
export type EmployeeSalariesForChangeRequestQueryHookResult = ReturnType<typeof useEmployeeSalariesForChangeRequestQuery>;
export type EmployeeSalariesForChangeRequestLazyQueryHookResult = ReturnType<typeof useEmployeeSalariesForChangeRequestLazyQuery>;
export type EmployeeSalariesForChangeRequestSuspenseQueryHookResult = ReturnType<typeof useEmployeeSalariesForChangeRequestSuspenseQuery>;
export type EmployeeSalariesForChangeRequestQueryResult = Apollo.QueryResult<EmployeeSalariesForChangeRequestQuery, EmployeeSalariesForChangeRequestQueryVariables>;
export const EmployeeOrTeamSelectSearchDocument = gql`
    query EmployeeOrTeamSelectSearch($searchTerm: String) {
  activeEmployees(filter: {searchTerm: $searchTerm}) {
    ...EmployeeSelectInfoColleague
  }
  teams(filter: {searchTerm: $searchTerm}) {
    ...Team
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}
${TeamFragmentDoc}`;

/**
 * __useEmployeeOrTeamSelectSearchQuery__
 *
 * To run a query within a React component, call `useEmployeeOrTeamSelectSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeOrTeamSelectSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeOrTeamSelectSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useEmployeeOrTeamSelectSearchQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>(EmployeeOrTeamSelectSearchDocument, options);
      }
export function useEmployeeOrTeamSelectSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>(EmployeeOrTeamSelectSearchDocument, options);
        }
export function useEmployeeOrTeamSelectSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>(EmployeeOrTeamSelectSearchDocument, options);
        }
export type EmployeeOrTeamSelectSearchQueryHookResult = ReturnType<typeof useEmployeeOrTeamSelectSearchQuery>;
export type EmployeeOrTeamSelectSearchLazyQueryHookResult = ReturnType<typeof useEmployeeOrTeamSelectSearchLazyQuery>;
export type EmployeeOrTeamSelectSearchSuspenseQueryHookResult = ReturnType<typeof useEmployeeOrTeamSelectSearchSuspenseQuery>;
export type EmployeeOrTeamSelectSearchQueryResult = Apollo.QueryResult<EmployeeOrTeamSelectSearchQuery, EmployeeOrTeamSelectSearchQueryVariables>;
export const EmployeeOrTeamSelectDefaultDocument = gql`
    query EmployeeOrTeamSelectDefault($limit: Int!) {
  activeEmployees(pagination: {offset: 0, limit: $limit}) {
    ...EmployeeSelectInfoColleague
  }
  teams(pagination: {offset: 0, limit: $limit}) {
    ...Team
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}
${TeamFragmentDoc}`;

/**
 * __useEmployeeOrTeamSelectDefaultQuery__
 *
 * To run a query within a React component, call `useEmployeeOrTeamSelectDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeOrTeamSelectDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeOrTeamSelectDefaultQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEmployeeOrTeamSelectDefaultQuery(baseOptions: Apollo.QueryHookOptions<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables> & ({ variables: EmployeeOrTeamSelectDefaultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables>(EmployeeOrTeamSelectDefaultDocument, options);
      }
export function useEmployeeOrTeamSelectDefaultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables>(EmployeeOrTeamSelectDefaultDocument, options);
        }
export function useEmployeeOrTeamSelectDefaultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables>(EmployeeOrTeamSelectDefaultDocument, options);
        }
export type EmployeeOrTeamSelectDefaultQueryHookResult = ReturnType<typeof useEmployeeOrTeamSelectDefaultQuery>;
export type EmployeeOrTeamSelectDefaultLazyQueryHookResult = ReturnType<typeof useEmployeeOrTeamSelectDefaultLazyQuery>;
export type EmployeeOrTeamSelectDefaultSuspenseQueryHookResult = ReturnType<typeof useEmployeeOrTeamSelectDefaultSuspenseQuery>;
export type EmployeeOrTeamSelectDefaultQueryResult = Apollo.QueryResult<EmployeeOrTeamSelectDefaultQuery, EmployeeOrTeamSelectDefaultQueryVariables>;
export const EmployeeSelectDocument = gql`
    query EmployeeSelect {
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __useEmployeeSelectQuery__
 *
 * To run a query within a React component, call `useEmployeeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeSelectQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeSelectQuery, EmployeeSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeSelectQuery, EmployeeSelectQueryVariables>(EmployeeSelectDocument, options);
      }
export function useEmployeeSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeSelectQuery, EmployeeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeSelectQuery, EmployeeSelectQueryVariables>(EmployeeSelectDocument, options);
        }
export function useEmployeeSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeSelectQuery, EmployeeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeSelectQuery, EmployeeSelectQueryVariables>(EmployeeSelectDocument, options);
        }
export type EmployeeSelectQueryHookResult = ReturnType<typeof useEmployeeSelectQuery>;
export type EmployeeSelectLazyQueryHookResult = ReturnType<typeof useEmployeeSelectLazyQuery>;
export type EmployeeSelectSuspenseQueryHookResult = ReturnType<typeof useEmployeeSelectSuspenseQuery>;
export type EmployeeSelectQueryResult = Apollo.QueryResult<EmployeeSelectQuery, EmployeeSelectQueryVariables>;
export const TeamWithPopupDocument = gql`
    query TeamWithPopup($teamId: String!) {
  teams(filter: {teamIds: [$teamId]}) {
    ...Team
    employees {
      ...EmployeeSelectInfoColleague
    }
  }
}
    ${TeamFragmentDoc}
${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __useTeamWithPopupQuery__
 *
 * To run a query within a React component, call `useTeamWithPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamWithPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamWithPopupQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamWithPopupQuery(baseOptions: Apollo.QueryHookOptions<TeamWithPopupQuery, TeamWithPopupQueryVariables> & ({ variables: TeamWithPopupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamWithPopupQuery, TeamWithPopupQueryVariables>(TeamWithPopupDocument, options);
      }
export function useTeamWithPopupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamWithPopupQuery, TeamWithPopupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamWithPopupQuery, TeamWithPopupQueryVariables>(TeamWithPopupDocument, options);
        }
export function useTeamWithPopupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamWithPopupQuery, TeamWithPopupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamWithPopupQuery, TeamWithPopupQueryVariables>(TeamWithPopupDocument, options);
        }
export type TeamWithPopupQueryHookResult = ReturnType<typeof useTeamWithPopupQuery>;
export type TeamWithPopupLazyQueryHookResult = ReturnType<typeof useTeamWithPopupLazyQuery>;
export type TeamWithPopupSuspenseQueryHookResult = ReturnType<typeof useTeamWithPopupSuspenseQuery>;
export type TeamWithPopupQueryResult = Apollo.QueryResult<TeamWithPopupQuery, TeamWithPopupQueryVariables>;
export const TimeBalanceForDayDocument = gql`
    query timeBalanceForDay($employeeId: String!, $day: LocalDate!) {
  timeSheetDay(employeeId: $employeeId, day: $day) {
    ...TimeSheetDayId
    timeBalanceAccumulated
  }
}
    ${TimeSheetDayIdFragmentDoc}`;

/**
 * __useTimeBalanceForDayQuery__
 *
 * To run a query within a React component, call `useTimeBalanceForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeBalanceForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeBalanceForDayQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      day: // value for 'day'
 *   },
 * });
 */
export function useTimeBalanceForDayQuery(baseOptions: Apollo.QueryHookOptions<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables> & ({ variables: TimeBalanceForDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables>(TimeBalanceForDayDocument, options);
      }
export function useTimeBalanceForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables>(TimeBalanceForDayDocument, options);
        }
export function useTimeBalanceForDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables>(TimeBalanceForDayDocument, options);
        }
export type TimeBalanceForDayQueryHookResult = ReturnType<typeof useTimeBalanceForDayQuery>;
export type TimeBalanceForDayLazyQueryHookResult = ReturnType<typeof useTimeBalanceForDayLazyQuery>;
export type TimeBalanceForDaySuspenseQueryHookResult = ReturnType<typeof useTimeBalanceForDaySuspenseQuery>;
export type TimeBalanceForDayQueryResult = Apollo.QueryResult<TimeBalanceForDayQuery, TimeBalanceForDayQueryVariables>;
export const ApproveTimeSheetsDocument = gql`
    mutation ApproveTimeSheets($ids: [String!]!, $timeEntryChangeRequestApproveAction: ApproveTimeSheetAction!) {
  timeSheet {
    approveTimeSheets(
      ids: $ids
      timeEntryChangeRequestApproveAction: $timeEntryChangeRequestApproveAction
    ) {
      recordIds
      records {
        ...ManagerTimeSheet
        timeEntryChangeRequests {
          ...TimeEntryChangeRequestFields
        }
      }
      error {
        errorCode
        message
      }
    }
  }
}
    ${ManagerTimeSheetFragmentDoc}
${TimeEntryChangeRequestFieldsFragmentDoc}`;
export type ApproveTimeSheetsMutationFn = Apollo.MutationFunction<ApproveTimeSheetsMutation, ApproveTimeSheetsMutationVariables>;

/**
 * __useApproveTimeSheetsMutation__
 *
 * To run a mutation, you first call `useApproveTimeSheetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTimeSheetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTimeSheetsMutation, { data, loading, error }] = useApproveTimeSheetsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      timeEntryChangeRequestApproveAction: // value for 'timeEntryChangeRequestApproveAction'
 *   },
 * });
 */
export function useApproveTimeSheetsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTimeSheetsMutation, ApproveTimeSheetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTimeSheetsMutation, ApproveTimeSheetsMutationVariables>(ApproveTimeSheetsDocument, options);
      }
export type ApproveTimeSheetsMutationHookResult = ReturnType<typeof useApproveTimeSheetsMutation>;
export type ApproveTimeSheetsMutationResult = Apollo.MutationResult<ApproveTimeSheetsMutation>;
export type ApproveTimeSheetsMutationOptions = Apollo.BaseMutationOptions<ApproveTimeSheetsMutation, ApproveTimeSheetsMutationVariables>;
export const TimeSheetTimeEntryChangeRequestsDocument = gql`
    query TimeSheetTimeEntryChangeRequests($ids: [String!]!) {
  timeSheets(ids: $ids) {
    Id
    timeEntryChangeRequests {
      Id
    }
  }
}
    `;

/**
 * __useTimeSheetTimeEntryChangeRequestsQuery__
 *
 * To run a query within a React component, call `useTimeSheetTimeEntryChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetTimeEntryChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetTimeEntryChangeRequestsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTimeSheetTimeEntryChangeRequestsQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables> & ({ variables: TimeSheetTimeEntryChangeRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables>(TimeSheetTimeEntryChangeRequestsDocument, options);
      }
export function useTimeSheetTimeEntryChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables>(TimeSheetTimeEntryChangeRequestsDocument, options);
        }
export function useTimeSheetTimeEntryChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables>(TimeSheetTimeEntryChangeRequestsDocument, options);
        }
export type TimeSheetTimeEntryChangeRequestsQueryHookResult = ReturnType<typeof useTimeSheetTimeEntryChangeRequestsQuery>;
export type TimeSheetTimeEntryChangeRequestsLazyQueryHookResult = ReturnType<typeof useTimeSheetTimeEntryChangeRequestsLazyQuery>;
export type TimeSheetTimeEntryChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useTimeSheetTimeEntryChangeRequestsSuspenseQuery>;
export type TimeSheetTimeEntryChangeRequestsQueryResult = Apollo.QueryResult<TimeSheetTimeEntryChangeRequestsQuery, TimeSheetTimeEntryChangeRequestsQueryVariables>;
export const TimeBalancesRefetchDocument = gql`
    query timeBalancesRefetch($request: TimeSheetDaysRequestInput!) {
  timeSheetDays(request: $request) {
    ...TimeSheetDayId
    timeBalanceAccumulated
  }
}
    ${TimeSheetDayIdFragmentDoc}`;

/**
 * __useTimeBalancesRefetchQuery__
 *
 * To run a query within a React component, call `useTimeBalancesRefetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeBalancesRefetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeBalancesRefetchQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useTimeBalancesRefetchQuery(baseOptions: Apollo.QueryHookOptions<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables> & ({ variables: TimeBalancesRefetchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables>(TimeBalancesRefetchDocument, options);
      }
export function useTimeBalancesRefetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables>(TimeBalancesRefetchDocument, options);
        }
export function useTimeBalancesRefetchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables>(TimeBalancesRefetchDocument, options);
        }
export type TimeBalancesRefetchQueryHookResult = ReturnType<typeof useTimeBalancesRefetchQuery>;
export type TimeBalancesRefetchLazyQueryHookResult = ReturnType<typeof useTimeBalancesRefetchLazyQuery>;
export type TimeBalancesRefetchSuspenseQueryHookResult = ReturnType<typeof useTimeBalancesRefetchSuspenseQuery>;
export type TimeBalancesRefetchQueryResult = Apollo.QueryResult<TimeBalancesRefetchQuery, TimeBalancesRefetchQueryVariables>;
export const TimeSheetDetailsDocument = gql`
    query timeSheetDetails($id: String!) {
  timeSheet(id: $id) {
    ...TimeSheetDetails
  }
}
    ${TimeSheetDetailsFragmentDoc}`;

/**
 * __useTimeSheetDetailsQuery__
 *
 * To run a query within a React component, call `useTimeSheetDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeSheetDetailsQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables> & ({ variables: TimeSheetDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables>(TimeSheetDetailsDocument, options);
      }
export function useTimeSheetDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables>(TimeSheetDetailsDocument, options);
        }
export function useTimeSheetDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables>(TimeSheetDetailsDocument, options);
        }
export type TimeSheetDetailsQueryHookResult = ReturnType<typeof useTimeSheetDetailsQuery>;
export type TimeSheetDetailsLazyQueryHookResult = ReturnType<typeof useTimeSheetDetailsLazyQuery>;
export type TimeSheetDetailsSuspenseQueryHookResult = ReturnType<typeof useTimeSheetDetailsSuspenseQuery>;
export type TimeSheetDetailsQueryResult = Apollo.QueryResult<TimeSheetDetailsQuery, TimeSheetDetailsQueryVariables>;
export const TimeSheetDetailsPrefetchDocument = gql`
    query timeSheetDetailsPrefetch($ids: [String!]!) {
  timeSheets(ids: $ids) {
    ...TimeSheetPrefetchData
  }
}
    ${TimeSheetPrefetchDataFragmentDoc}`;

/**
 * __useTimeSheetDetailsPrefetchQuery__
 *
 * To run a query within a React component, call `useTimeSheetDetailsPrefetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetDetailsPrefetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetDetailsPrefetchQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTimeSheetDetailsPrefetchQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables> & ({ variables: TimeSheetDetailsPrefetchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables>(TimeSheetDetailsPrefetchDocument, options);
      }
export function useTimeSheetDetailsPrefetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables>(TimeSheetDetailsPrefetchDocument, options);
        }
export function useTimeSheetDetailsPrefetchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables>(TimeSheetDetailsPrefetchDocument, options);
        }
export type TimeSheetDetailsPrefetchQueryHookResult = ReturnType<typeof useTimeSheetDetailsPrefetchQuery>;
export type TimeSheetDetailsPrefetchLazyQueryHookResult = ReturnType<typeof useTimeSheetDetailsPrefetchLazyQuery>;
export type TimeSheetDetailsPrefetchSuspenseQueryHookResult = ReturnType<typeof useTimeSheetDetailsPrefetchSuspenseQuery>;
export type TimeSheetDetailsPrefetchQueryResult = Apollo.QueryResult<TimeSheetDetailsPrefetchQuery, TimeSheetDetailsPrefetchQueryVariables>;
export const UserInfoDocument = gql`
    query UserInfo {
  me {
    Id
    managerRoles
    logoUrl
    coverUrl
    Organization
    hasSlackUser
    calendarToken
    avatar {
      Id
      url
      urlLarge
    }
    Name
    flair__First_Name__c
    flair__Last_Name__c
    flair__Company_Email__c
    flair__Start_Date__c
    flair__End_Date__c
    flair__Position__c
    flair__Can_Change_Own_Time_Entries__c
    flair__Employee_Language__c
    flair__Hide_My_Birthday__c
    hubAccessRestricted
    location {
      Id
      Name
    }
    department {
      Id
      Name
    }
    manager {
      Id
      Name
    }
    teams {
      Id
    }
    courses {
      Id
    }
  }
  hub {
    Id
    Name
    flair__Cover_Url__c
    flair__Company_Logo_Url__c
    flair__Inactivity_Timeout__c
  }
  hiringManager {
    Id
    jobs {
      Id
    }
  }
  employeeHubFeatures {
    ...EmployeeHubFeature
  }
  organizationInfo {
    features {
      Id
    }
    subscriptionInfo {
      flairScheduler
    }
  }
}
    ${EmployeeHubFeatureFragmentDoc}`;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export function useUserInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoSuspenseQueryHookResult = ReturnType<typeof useUserInfoSuspenseQuery>;
export type UserInfoQueryResult = Apollo.QueryResult<UserInfoQuery, UserInfoQueryVariables>;
export const IdentifyDocument = gql`
    mutation Identify($input: IdentifyInput!) {
  identify(input: $input)
}
    `;
export type IdentifyMutationFn = Apollo.MutationFunction<IdentifyMutation, IdentifyMutationVariables>;

/**
 * __useIdentifyMutation__
 *
 * To run a mutation, you first call `useIdentifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identifyMutation, { data, loading, error }] = useIdentifyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIdentifyMutation(baseOptions?: Apollo.MutationHookOptions<IdentifyMutation, IdentifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdentifyMutation, IdentifyMutationVariables>(IdentifyDocument, options);
      }
export type IdentifyMutationHookResult = ReturnType<typeof useIdentifyMutation>;
export type IdentifyMutationResult = Apollo.MutationResult<IdentifyMutation>;
export type IdentifyMutationOptions = Apollo.BaseMutationOptions<IdentifyMutation, IdentifyMutationVariables>;
export const CustomerSupportEmployeeTokenDocument = gql`
    query customerSupportEmployeeToken($email: String!) {
  employeeToken(email: $email) {
    authorizationCode
    error
  }
}
    `;

/**
 * __useCustomerSupportEmployeeTokenQuery__
 *
 * To run a query within a React component, call `useCustomerSupportEmployeeTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSupportEmployeeTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSupportEmployeeTokenQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCustomerSupportEmployeeTokenQuery(baseOptions: Apollo.QueryHookOptions<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables> & ({ variables: CustomerSupportEmployeeTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables>(CustomerSupportEmployeeTokenDocument, options);
      }
export function useCustomerSupportEmployeeTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables>(CustomerSupportEmployeeTokenDocument, options);
        }
export function useCustomerSupportEmployeeTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables>(CustomerSupportEmployeeTokenDocument, options);
        }
export type CustomerSupportEmployeeTokenQueryHookResult = ReturnType<typeof useCustomerSupportEmployeeTokenQuery>;
export type CustomerSupportEmployeeTokenLazyQueryHookResult = ReturnType<typeof useCustomerSupportEmployeeTokenLazyQuery>;
export type CustomerSupportEmployeeTokenSuspenseQueryHookResult = ReturnType<typeof useCustomerSupportEmployeeTokenSuspenseQuery>;
export type CustomerSupportEmployeeTokenQueryResult = Apollo.QueryResult<CustomerSupportEmployeeTokenQuery, CustomerSupportEmployeeTokenQueryVariables>;
export const OrganizationInfoDocument = gql`
    query OrganizationInfo {
  organizationInfo {
    salesforceUserId
    flairHubPermissionSet
  }
}
    `;

/**
 * __useOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationInfoQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationInfoQuery, OrganizationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationInfoQuery, OrganizationInfoQueryVariables>(OrganizationInfoDocument, options);
      }
export function useOrganizationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationInfoQuery, OrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationInfoQuery, OrganizationInfoQueryVariables>(OrganizationInfoDocument, options);
        }
export function useOrganizationInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationInfoQuery, OrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationInfoQuery, OrganizationInfoQueryVariables>(OrganizationInfoDocument, options);
        }
export type OrganizationInfoQueryHookResult = ReturnType<typeof useOrganizationInfoQuery>;
export type OrganizationInfoLazyQueryHookResult = ReturnType<typeof useOrganizationInfoLazyQuery>;
export type OrganizationInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationInfoSuspenseQuery>;
export type OrganizationInfoQueryResult = Apollo.QueryResult<OrganizationInfoQuery, OrganizationInfoQueryVariables>;
export const ActiveEmployeesDocument = gql`
    query ActiveEmployees {
  activeEmployees {
    Id
    Name
  }
}
    `;

/**
 * __useActiveEmployeesQuery__
 *
 * To run a query within a React component, call `useActiveEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>(ActiveEmployeesDocument, options);
      }
export function useActiveEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>(ActiveEmployeesDocument, options);
        }
export function useActiveEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>(ActiveEmployeesDocument, options);
        }
export type ActiveEmployeesQueryHookResult = ReturnType<typeof useActiveEmployeesQuery>;
export type ActiveEmployeesLazyQueryHookResult = ReturnType<typeof useActiveEmployeesLazyQuery>;
export type ActiveEmployeesSuspenseQueryHookResult = ReturnType<typeof useActiveEmployeesSuspenseQuery>;
export type ActiveEmployeesQueryResult = Apollo.QueryResult<ActiveEmployeesQuery, ActiveEmployeesQueryVariables>;
export const UpdateTimeEntryNotesDocument = gql`
    mutation UpdateTimeEntryNotes($input: UpdateTimeEntryNotesInput!) {
  timeTracking {
    updateTimeEntryNotes(input: $input) {
      timeEntry {
        Id
        flair__Notes__c
      }
      timeEntryChangeRequest {
        Id
        flair__Creation_Time_Entry_Notes__c
      }
    }
  }
}
    `;
export type UpdateTimeEntryNotesMutationFn = Apollo.MutationFunction<UpdateTimeEntryNotesMutation, UpdateTimeEntryNotesMutationVariables>;

/**
 * __useUpdateTimeEntryNotesMutation__
 *
 * To run a mutation, you first call `useUpdateTimeEntryNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeEntryNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeEntryNotesMutation, { data, loading, error }] = useUpdateTimeEntryNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeEntryNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeEntryNotesMutation, UpdateTimeEntryNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeEntryNotesMutation, UpdateTimeEntryNotesMutationVariables>(UpdateTimeEntryNotesDocument, options);
      }
export type UpdateTimeEntryNotesMutationHookResult = ReturnType<typeof useUpdateTimeEntryNotesMutation>;
export type UpdateTimeEntryNotesMutationResult = Apollo.MutationResult<UpdateTimeEntryNotesMutation>;
export type UpdateTimeEntryNotesMutationOptions = Apollo.BaseMutationOptions<UpdateTimeEntryNotesMutation, UpdateTimeEntryNotesMutationVariables>;
export const ApproveTimeEntryChangeRequestDocument = gql`
    mutation ApproveTimeEntryChangeRequest($input: ApproveTimeEntryChangeRequestInput!) {
  timeTracking {
    approveTimeEntryChangeRequests(input: $input) {
      recordIds
      records {
        Id
        flair__Status__c
        affectedTimeEntry {
          Id
          timeSheet {
            Id
            ...TimeSheetTimeEntries
            ...TimeSheetTimeEntriesDetails
            ...TimeSheetDaySubRows
          }
        }
      }
    }
  }
}
    ${TimeSheetTimeEntriesFragmentDoc}
${TimeSheetTimeEntriesDetailsFragmentDoc}
${TimeSheetDaySubRowsFragmentDoc}`;
export type ApproveTimeEntryChangeRequestMutationFn = Apollo.MutationFunction<ApproveTimeEntryChangeRequestMutation, ApproveTimeEntryChangeRequestMutationVariables>;

/**
 * __useApproveTimeEntryChangeRequestMutation__
 *
 * To run a mutation, you first call `useApproveTimeEntryChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTimeEntryChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTimeEntryChangeRequestMutation, { data, loading, error }] = useApproveTimeEntryChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveTimeEntryChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTimeEntryChangeRequestMutation, ApproveTimeEntryChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTimeEntryChangeRequestMutation, ApproveTimeEntryChangeRequestMutationVariables>(ApproveTimeEntryChangeRequestDocument, options);
      }
export type ApproveTimeEntryChangeRequestMutationHookResult = ReturnType<typeof useApproveTimeEntryChangeRequestMutation>;
export type ApproveTimeEntryChangeRequestMutationResult = Apollo.MutationResult<ApproveTimeEntryChangeRequestMutation>;
export type ApproveTimeEntryChangeRequestMutationOptions = Apollo.BaseMutationOptions<ApproveTimeEntryChangeRequestMutation, ApproveTimeEntryChangeRequestMutationVariables>;
export const DeleteTimeEntryChangeRequestDocument = gql`
    mutation DeleteTimeEntryChangeRequest($id: String!) {
  timeTracking {
    deleteTimeEntryChangeRequest(id: $id) {
      recordId
    }
  }
}
    `;
export type DeleteTimeEntryChangeRequestMutationFn = Apollo.MutationFunction<DeleteTimeEntryChangeRequestMutation, DeleteTimeEntryChangeRequestMutationVariables>;

/**
 * __useDeleteTimeEntryChangeRequestMutation__
 *
 * To run a mutation, you first call `useDeleteTimeEntryChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeEntryChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeEntryChangeRequestMutation, { data, loading, error }] = useDeleteTimeEntryChangeRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeEntryChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeEntryChangeRequestMutation, DeleteTimeEntryChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeEntryChangeRequestMutation, DeleteTimeEntryChangeRequestMutationVariables>(DeleteTimeEntryChangeRequestDocument, options);
      }
export type DeleteTimeEntryChangeRequestMutationHookResult = ReturnType<typeof useDeleteTimeEntryChangeRequestMutation>;
export type DeleteTimeEntryChangeRequestMutationResult = Apollo.MutationResult<DeleteTimeEntryChangeRequestMutation>;
export type DeleteTimeEntryChangeRequestMutationOptions = Apollo.BaseMutationOptions<DeleteTimeEntryChangeRequestMutation, DeleteTimeEntryChangeRequestMutationVariables>;
export const RejectTimeEntryChangeRequestDocument = gql`
    mutation RejectTimeEntryChangeRequest($input: RejectTimeEntryChangeRequestInput!) {
  timeTracking {
    rejectTimeEntryChangeRequests(input: $input) {
      recordIds
      records {
        Id
        flair__Status__c
        affectedTimeEntry {
          Id
          timeSheet {
            Id
            ...TimeSheetDaySubRows
          }
        }
      }
    }
  }
}
    ${TimeSheetDaySubRowsFragmentDoc}`;
export type RejectTimeEntryChangeRequestMutationFn = Apollo.MutationFunction<RejectTimeEntryChangeRequestMutation, RejectTimeEntryChangeRequestMutationVariables>;

/**
 * __useRejectTimeEntryChangeRequestMutation__
 *
 * To run a mutation, you first call `useRejectTimeEntryChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTimeEntryChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTimeEntryChangeRequestMutation, { data, loading, error }] = useRejectTimeEntryChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectTimeEntryChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectTimeEntryChangeRequestMutation, RejectTimeEntryChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTimeEntryChangeRequestMutation, RejectTimeEntryChangeRequestMutationVariables>(RejectTimeEntryChangeRequestDocument, options);
      }
export type RejectTimeEntryChangeRequestMutationHookResult = ReturnType<typeof useRejectTimeEntryChangeRequestMutation>;
export type RejectTimeEntryChangeRequestMutationResult = Apollo.MutationResult<RejectTimeEntryChangeRequestMutation>;
export type RejectTimeEntryChangeRequestMutationOptions = Apollo.BaseMutationOptions<RejectTimeEntryChangeRequestMutation, RejectTimeEntryChangeRequestMutationVariables>;
export const SubmitTimeEntryChangeRequestDocument = gql`
    mutation SubmitTimeEntryChangeRequest($input: SubmitTimeEntryChangeRequestInput!) {
  timeTracking {
    submitTimeEntryChangeRequest(input: $input) {
      record {
        ...TimeEntryChangeRequestFields
      }
      projectTimeEntries {
        ...ProjectTimesheetEntry
      }
      errors2 {
        ...TimeTrackingError
      }
    }
  }
}
    ${TimeEntryChangeRequestFieldsFragmentDoc}
${ProjectTimesheetEntryFragmentDoc}
${TimeTrackingErrorFragmentDoc}`;
export type SubmitTimeEntryChangeRequestMutationFn = Apollo.MutationFunction<SubmitTimeEntryChangeRequestMutation, SubmitTimeEntryChangeRequestMutationVariables>;

/**
 * __useSubmitTimeEntryChangeRequestMutation__
 *
 * To run a mutation, you first call `useSubmitTimeEntryChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTimeEntryChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTimeEntryChangeRequestMutation, { data, loading, error }] = useSubmitTimeEntryChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTimeEntryChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTimeEntryChangeRequestMutation, SubmitTimeEntryChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTimeEntryChangeRequestMutation, SubmitTimeEntryChangeRequestMutationVariables>(SubmitTimeEntryChangeRequestDocument, options);
      }
export type SubmitTimeEntryChangeRequestMutationHookResult = ReturnType<typeof useSubmitTimeEntryChangeRequestMutation>;
export type SubmitTimeEntryChangeRequestMutationResult = Apollo.MutationResult<SubmitTimeEntryChangeRequestMutation>;
export type SubmitTimeEntryChangeRequestMutationOptions = Apollo.BaseMutationOptions<SubmitTimeEntryChangeRequestMutation, SubmitTimeEntryChangeRequestMutationVariables>;
export const AllTimeFrameworksDocument = gql`
    query AllTimeFrameworks {
  manager {
    Id
    timeFrameworks {
      Id
      timeBalanceSettings {
        Id
        flair__Calculation_Mode__c
      }
    }
  }
}
    `;

/**
 * __useAllTimeFrameworksQuery__
 *
 * To run a query within a React component, call `useAllTimeFrameworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTimeFrameworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTimeFrameworksQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTimeFrameworksQuery(baseOptions?: Apollo.QueryHookOptions<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>(AllTimeFrameworksDocument, options);
      }
export function useAllTimeFrameworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>(AllTimeFrameworksDocument, options);
        }
export function useAllTimeFrameworksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>(AllTimeFrameworksDocument, options);
        }
export type AllTimeFrameworksQueryHookResult = ReturnType<typeof useAllTimeFrameworksQuery>;
export type AllTimeFrameworksLazyQueryHookResult = ReturnType<typeof useAllTimeFrameworksLazyQuery>;
export type AllTimeFrameworksSuspenseQueryHookResult = ReturnType<typeof useAllTimeFrameworksSuspenseQuery>;
export type AllTimeFrameworksQueryResult = Apollo.QueryResult<AllTimeFrameworksQuery, AllTimeFrameworksQueryVariables>;
export const TimeTrackingSettingsDocument = gql`
    query TimeTrackingSettings($employeeId: String!, $today: DateTime!) {
  workloads(employeeId: $employeeId, from: $today, to: $today) {
    ...TimeTrackingSettings_WorkloadFields
  }
}
    ${TimeTrackingSettings_WorkloadFieldsFragmentDoc}`;

/**
 * __useTimeTrackingSettingsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingSettingsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      today: // value for 'today'
 *   },
 * });
 */
export function useTimeTrackingSettingsQuery(baseOptions: Apollo.QueryHookOptions<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables> & ({ variables: TimeTrackingSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables>(TimeTrackingSettingsDocument, options);
      }
export function useTimeTrackingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables>(TimeTrackingSettingsDocument, options);
        }
export function useTimeTrackingSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables>(TimeTrackingSettingsDocument, options);
        }
export type TimeTrackingSettingsQueryHookResult = ReturnType<typeof useTimeTrackingSettingsQuery>;
export type TimeTrackingSettingsLazyQueryHookResult = ReturnType<typeof useTimeTrackingSettingsLazyQuery>;
export type TimeTrackingSettingsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingSettingsSuspenseQuery>;
export type TimeTrackingSettingsQueryResult = Apollo.QueryResult<TimeTrackingSettingsQuery, TimeTrackingSettingsQueryVariables>;
export const TimeTrackingSettingsAllDaysDocument = gql`
    query TimeTrackingSettingsAllDays($employeeId: String!) {
  workloads(employeeId: $employeeId) {
    ...TimeTrackingSettings_WorkloadFields
  }
  employeeAbsences(
    employeeId: $employeeId
    filter: {onlyWithTimeTrackingRestrictedCategory: true}
  ) {
    ...TimeTrackingSettings_Absence
  }
}
    ${TimeTrackingSettings_WorkloadFieldsFragmentDoc}
${TimeTrackingSettings_AbsenceFragmentDoc}`;

/**
 * __useTimeTrackingSettingsAllDaysQuery__
 *
 * To run a query within a React component, call `useTimeTrackingSettingsAllDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingSettingsAllDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingSettingsAllDaysQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useTimeTrackingSettingsAllDaysQuery(baseOptions: Apollo.QueryHookOptions<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables> & ({ variables: TimeTrackingSettingsAllDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables>(TimeTrackingSettingsAllDaysDocument, options);
      }
export function useTimeTrackingSettingsAllDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables>(TimeTrackingSettingsAllDaysDocument, options);
        }
export function useTimeTrackingSettingsAllDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables>(TimeTrackingSettingsAllDaysDocument, options);
        }
export type TimeTrackingSettingsAllDaysQueryHookResult = ReturnType<typeof useTimeTrackingSettingsAllDaysQuery>;
export type TimeTrackingSettingsAllDaysLazyQueryHookResult = ReturnType<typeof useTimeTrackingSettingsAllDaysLazyQuery>;
export type TimeTrackingSettingsAllDaysSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingSettingsAllDaysSuspenseQuery>;
export type TimeTrackingSettingsAllDaysQueryResult = Apollo.QueryResult<TimeTrackingSettingsAllDaysQuery, TimeTrackingSettingsAllDaysQueryVariables>;
export const AbsenceRequestApproveDocument = gql`
    mutation AbsenceRequestApprove($ids: [String!]!) {
  absence {
    approve(ids: $ids) {
      records {
        ...ApprovalRequestWithAbsence
      }
    }
  }
}
    ${ApprovalRequestWithAbsenceFragmentDoc}`;
export type AbsenceRequestApproveMutationFn = Apollo.MutationFunction<AbsenceRequestApproveMutation, AbsenceRequestApproveMutationVariables>;

/**
 * __useAbsenceRequestApproveMutation__
 *
 * To run a mutation, you first call `useAbsenceRequestApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbsenceRequestApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [absenceRequestApproveMutation, { data, loading, error }] = useAbsenceRequestApproveMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAbsenceRequestApproveMutation(baseOptions?: Apollo.MutationHookOptions<AbsenceRequestApproveMutation, AbsenceRequestApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbsenceRequestApproveMutation, AbsenceRequestApproveMutationVariables>(AbsenceRequestApproveDocument, options);
      }
export type AbsenceRequestApproveMutationHookResult = ReturnType<typeof useAbsenceRequestApproveMutation>;
export type AbsenceRequestApproveMutationResult = Apollo.MutationResult<AbsenceRequestApproveMutation>;
export type AbsenceRequestApproveMutationOptions = Apollo.BaseMutationOptions<AbsenceRequestApproveMutation, AbsenceRequestApproveMutationVariables>;
export const AbsenceRequestRejectDocument = gql`
    mutation AbsenceRequestReject($inputs: [AbsenceRequestRejectInput!]!) {
  absence {
    reject(inputs: $inputs) {
      records {
        ...ApprovalRequestWithAbsence
      }
    }
  }
}
    ${ApprovalRequestWithAbsenceFragmentDoc}`;
export type AbsenceRequestRejectMutationFn = Apollo.MutationFunction<AbsenceRequestRejectMutation, AbsenceRequestRejectMutationVariables>;

/**
 * __useAbsenceRequestRejectMutation__
 *
 * To run a mutation, you first call `useAbsenceRequestRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbsenceRequestRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [absenceRequestRejectMutation, { data, loading, error }] = useAbsenceRequestRejectMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAbsenceRequestRejectMutation(baseOptions?: Apollo.MutationHookOptions<AbsenceRequestRejectMutation, AbsenceRequestRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbsenceRequestRejectMutation, AbsenceRequestRejectMutationVariables>(AbsenceRequestRejectDocument, options);
      }
export type AbsenceRequestRejectMutationHookResult = ReturnType<typeof useAbsenceRequestRejectMutation>;
export type AbsenceRequestRejectMutationResult = Apollo.MutationResult<AbsenceRequestRejectMutation>;
export type AbsenceRequestRejectMutationOptions = Apollo.BaseMutationOptions<AbsenceRequestRejectMutation, AbsenceRequestRejectMutationVariables>;
export const AbsenceRequestFilterDocument = gql`
    query AbsenceRequestFilter {
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
  absencesCategories {
    Id
    Name
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __useAbsenceRequestFilterQuery__
 *
 * To run a query within a React component, call `useAbsenceRequestFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsenceRequestFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsenceRequestFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useAbsenceRequestFilterQuery(baseOptions?: Apollo.QueryHookOptions<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>(AbsenceRequestFilterDocument, options);
      }
export function useAbsenceRequestFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>(AbsenceRequestFilterDocument, options);
        }
export function useAbsenceRequestFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>(AbsenceRequestFilterDocument, options);
        }
export type AbsenceRequestFilterQueryHookResult = ReturnType<typeof useAbsenceRequestFilterQuery>;
export type AbsenceRequestFilterLazyQueryHookResult = ReturnType<typeof useAbsenceRequestFilterLazyQuery>;
export type AbsenceRequestFilterSuspenseQueryHookResult = ReturnType<typeof useAbsenceRequestFilterSuspenseQuery>;
export type AbsenceRequestFilterQueryResult = Apollo.QueryResult<AbsenceRequestFilterQuery, AbsenceRequestFilterQueryVariables>;
export const AbsencesForManagerDocument = gql`
    query AbsencesForManager($filter: AbsenceRequestFilterInput!, $sort: AbsenceRequestSortInput!, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!) {
  manager {
    Id
    absencesForManager(filter: $filter, sort: $sort, pagination: $pagination) {
      items {
        ...AbsencesForManager
      }
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${AbsencesForManagerFragmentDoc}`;

/**
 * __useAbsencesForManagerQuery__
 *
 * To run a query within a React component, call `useAbsencesForManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesForManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesForManagerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useAbsencesForManagerQuery(baseOptions: Apollo.QueryHookOptions<AbsencesForManagerQuery, AbsencesForManagerQueryVariables> & ({ variables: AbsencesForManagerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbsencesForManagerQuery, AbsencesForManagerQueryVariables>(AbsencesForManagerDocument, options);
      }
export function useAbsencesForManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbsencesForManagerQuery, AbsencesForManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbsencesForManagerQuery, AbsencesForManagerQueryVariables>(AbsencesForManagerDocument, options);
        }
export function useAbsencesForManagerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AbsencesForManagerQuery, AbsencesForManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AbsencesForManagerQuery, AbsencesForManagerQueryVariables>(AbsencesForManagerDocument, options);
        }
export type AbsencesForManagerQueryHookResult = ReturnType<typeof useAbsencesForManagerQuery>;
export type AbsencesForManagerLazyQueryHookResult = ReturnType<typeof useAbsencesForManagerLazyQuery>;
export type AbsencesForManagerSuspenseQueryHookResult = ReturnType<typeof useAbsencesForManagerSuspenseQuery>;
export type AbsencesForManagerQueryResult = Apollo.QueryResult<AbsencesForManagerQuery, AbsencesForManagerQueryVariables>;
export const PendingAbsenceRequestToMeDocument = gql`
    query PendingAbsenceRequestToMe($managerReportsType: ManagerReportsType!) {
  me {
    Id
    approvalRequests(
      filter: {managerReportsType: $managerReportsType, statuses: [PENDING], relatedObjectName: "flair__Absence__c"}
    ) {
      ...ApprovalRequestWithAbsence
    }
  }
}
    ${ApprovalRequestWithAbsenceFragmentDoc}`;

/**
 * __usePendingAbsenceRequestToMeQuery__
 *
 * To run a query within a React component, call `usePendingAbsenceRequestToMeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingAbsenceRequestToMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingAbsenceRequestToMeQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function usePendingAbsenceRequestToMeQuery(baseOptions: Apollo.QueryHookOptions<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables> & ({ variables: PendingAbsenceRequestToMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables>(PendingAbsenceRequestToMeDocument, options);
      }
export function usePendingAbsenceRequestToMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables>(PendingAbsenceRequestToMeDocument, options);
        }
export function usePendingAbsenceRequestToMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables>(PendingAbsenceRequestToMeDocument, options);
        }
export type PendingAbsenceRequestToMeQueryHookResult = ReturnType<typeof usePendingAbsenceRequestToMeQuery>;
export type PendingAbsenceRequestToMeLazyQueryHookResult = ReturnType<typeof usePendingAbsenceRequestToMeLazyQuery>;
export type PendingAbsenceRequestToMeSuspenseQueryHookResult = ReturnType<typeof usePendingAbsenceRequestToMeSuspenseQuery>;
export type PendingAbsenceRequestToMeQueryResult = Apollo.QueryResult<PendingAbsenceRequestToMeQuery, PendingAbsenceRequestToMeQueryVariables>;
export const EmployeePageAbsenceCalendarDocument = gql`
    query EmployeePageAbsenceCalendar($id: String!, $from: DateTime!, $to: DateTime!) {
  manager {
    Id
    employee(id: $id) {
      Id
      absenceCategories {
        ...RequestAbsenceButton
        Id
        flair__Unlimited__c
        category {
          Id
          Name
          flair__Icon__c
          flair__Type__c
          flair__Without_Balance__c
          group {
            Id
            Name
          }
        }
        allowances {
          Id
          Name
          flair__Amount__c
          flair__Expired_Amount__c
          flair__Available_Amount__c
          flair__Expiration_Date__c
          flair__Accrual_Policy_Period_Start_Date__c
        }
      }
      absences(from: $from, to: $to) {
        Id
        ...AbsencePopover
        flair__Approval_Status__c
        flair__Category_Name__c
        flair__Category_Icon__c
        flair__Category_Id__c
        flair__Amount__c
        flair__Working_Amount__c
        flair__Start_Date__c
        flair__Start_Time__c
        flair__Start_Date_Half_Day__c
        flair__End_Date__c
        flair__End_Time__c
        flair__End_Date_Half_Day__c
        flair__Type__c
        flair__Employee_Absence_Category__c
        flair__Category_Unlimited__c
        category {
          Id
          flair__Public__c
          group {
            Id
          }
        }
      }
      workloads(from: $from, to: $to) {
        Id
        flair__Start_Date__c
        flair__End_Date__c
        flair__Working_Days__c
        flair__Hours_Per_Day__c
        flair__Type__c
      }
      holidays(from: $from, to: $to) {
        ...Holiday
      }
    }
  }
}
    ${RequestAbsenceButtonFragmentDoc}
${AbsencePopoverFragmentDoc}
${HolidayFragmentDoc}`;

/**
 * __useEmployeePageAbsenceCalendarQuery__
 *
 * To run a query within a React component, call `useEmployeePageAbsenceCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageAbsenceCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageAbsenceCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEmployeePageAbsenceCalendarQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables> & ({ variables: EmployeePageAbsenceCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables>(EmployeePageAbsenceCalendarDocument, options);
      }
export function useEmployeePageAbsenceCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables>(EmployeePageAbsenceCalendarDocument, options);
        }
export function useEmployeePageAbsenceCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables>(EmployeePageAbsenceCalendarDocument, options);
        }
export type EmployeePageAbsenceCalendarQueryHookResult = ReturnType<typeof useEmployeePageAbsenceCalendarQuery>;
export type EmployeePageAbsenceCalendarLazyQueryHookResult = ReturnType<typeof useEmployeePageAbsenceCalendarLazyQuery>;
export type EmployeePageAbsenceCalendarSuspenseQueryHookResult = ReturnType<typeof useEmployeePageAbsenceCalendarSuspenseQuery>;
export type EmployeePageAbsenceCalendarQueryResult = Apollo.QueryResult<EmployeePageAbsenceCalendarQuery, EmployeePageAbsenceCalendarQueryVariables>;
export const CreateEmployeeCertificateByManagerDocument = gql`
    mutation createEmployeeCertificateByManager($input: CreateEmployeeCertificateInput!, $id: String!) {
  certificates {
    createEmployeeCertificate(input: $input) {
      query {
        manager {
          Id
          employee(id: $id) {
            Id
            employeeCertificates {
              ...CertificateData
            }
          }
        }
      }
      error
    }
  }
}
    ${CertificateDataFragmentDoc}`;
export type CreateEmployeeCertificateByManagerMutationFn = Apollo.MutationFunction<CreateEmployeeCertificateByManagerMutation, CreateEmployeeCertificateByManagerMutationVariables>;

/**
 * __useCreateEmployeeCertificateByManagerMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeCertificateByManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeCertificateByManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeCertificateByManagerMutation, { data, loading, error }] = useCreateEmployeeCertificateByManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateEmployeeCertificateByManagerMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeCertificateByManagerMutation, CreateEmployeeCertificateByManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeCertificateByManagerMutation, CreateEmployeeCertificateByManagerMutationVariables>(CreateEmployeeCertificateByManagerDocument, options);
      }
export type CreateEmployeeCertificateByManagerMutationHookResult = ReturnType<typeof useCreateEmployeeCertificateByManagerMutation>;
export type CreateEmployeeCertificateByManagerMutationResult = Apollo.MutationResult<CreateEmployeeCertificateByManagerMutation>;
export type CreateEmployeeCertificateByManagerMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeCertificateByManagerMutation, CreateEmployeeCertificateByManagerMutationVariables>;
export const UpdateEmployeeCertificateByManagerDocument = gql`
    mutation updateEmployeeCertificateByManager($input: UpdateEmployeeCertificateInput!, $id: String!) {
  certificates {
    updateEmployeeCertificate(input: $input) {
      record {
        ...CertificateData
      }
      query {
        manager {
          Id
          employee(id: $id) {
            Id
          }
        }
      }
      error
    }
  }
}
    ${CertificateDataFragmentDoc}`;
export type UpdateEmployeeCertificateByManagerMutationFn = Apollo.MutationFunction<UpdateEmployeeCertificateByManagerMutation, UpdateEmployeeCertificateByManagerMutationVariables>;

/**
 * __useUpdateEmployeeCertificateByManagerMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeCertificateByManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeCertificateByManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeCertificateByManagerMutation, { data, loading, error }] = useUpdateEmployeeCertificateByManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateEmployeeCertificateByManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeCertificateByManagerMutation, UpdateEmployeeCertificateByManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeCertificateByManagerMutation, UpdateEmployeeCertificateByManagerMutationVariables>(UpdateEmployeeCertificateByManagerDocument, options);
      }
export type UpdateEmployeeCertificateByManagerMutationHookResult = ReturnType<typeof useUpdateEmployeeCertificateByManagerMutation>;
export type UpdateEmployeeCertificateByManagerMutationResult = Apollo.MutationResult<UpdateEmployeeCertificateByManagerMutation>;
export type UpdateEmployeeCertificateByManagerMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeCertificateByManagerMutation, UpdateEmployeeCertificateByManagerMutationVariables>;
export const EmployeePageCertificateDocument = gql`
    query EmployeePageCertificate($employeeId: String!) {
  manager {
    Id
    employee(id: $employeeId) {
      Id
      employeeCertificates {
        ...CertificateData
      }
    }
  }
}
    ${CertificateDataFragmentDoc}`;

/**
 * __useEmployeePageCertificateQuery__
 *
 * To run a query within a React component, call `useEmployeePageCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageCertificateQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeePageCertificateQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables> & ({ variables: EmployeePageCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables>(EmployeePageCertificateDocument, options);
      }
export function useEmployeePageCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables>(EmployeePageCertificateDocument, options);
        }
export function useEmployeePageCertificateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables>(EmployeePageCertificateDocument, options);
        }
export type EmployeePageCertificateQueryHookResult = ReturnType<typeof useEmployeePageCertificateQuery>;
export type EmployeePageCertificateLazyQueryHookResult = ReturnType<typeof useEmployeePageCertificateLazyQuery>;
export type EmployeePageCertificateSuspenseQueryHookResult = ReturnType<typeof useEmployeePageCertificateSuspenseQuery>;
export type EmployeePageCertificateQueryResult = Apollo.QueryResult<EmployeePageCertificateQuery, EmployeePageCertificateQueryVariables>;
export const DeleteEmployeeCertificateByManagerDocument = gql`
    mutation deleteEmployeeCertificateByManager($id: String!, $employeeId: String!) {
  certificates {
    deleteEmployeeCertificate(id: $id) {
      query {
        manager {
          Id
          employee(id: $employeeId) {
            Id
            employeeCertificates {
              ...CertificateData
            }
          }
        }
      }
      error
    }
  }
}
    ${CertificateDataFragmentDoc}`;
export type DeleteEmployeeCertificateByManagerMutationFn = Apollo.MutationFunction<DeleteEmployeeCertificateByManagerMutation, DeleteEmployeeCertificateByManagerMutationVariables>;

/**
 * __useDeleteEmployeeCertificateByManagerMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeCertificateByManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeCertificateByManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeCertificateByManagerMutation, { data, loading, error }] = useDeleteEmployeeCertificateByManagerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteEmployeeCertificateByManagerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeCertificateByManagerMutation, DeleteEmployeeCertificateByManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeCertificateByManagerMutation, DeleteEmployeeCertificateByManagerMutationVariables>(DeleteEmployeeCertificateByManagerDocument, options);
      }
export type DeleteEmployeeCertificateByManagerMutationHookResult = ReturnType<typeof useDeleteEmployeeCertificateByManagerMutation>;
export type DeleteEmployeeCertificateByManagerMutationResult = Apollo.MutationResult<DeleteEmployeeCertificateByManagerMutation>;
export type DeleteEmployeeCertificateByManagerMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeCertificateByManagerMutation, DeleteEmployeeCertificateByManagerMutationVariables>;
export const EmployeePageHistoryDocument = gql`
    query EmployeePageHistory($employeeId: String!, $from: DateTime!, $to: DateTime!) {
  manager {
    Id
    employee(id: $employeeId) {
      Id
      flair__Start_Date__c
      employeeHistory {
        ...EmployeeHistoryData
      }
      salaries {
        Id
        flair__Amount__c
        flair__Salary_Type__c
        flair__Start_Date__c
        CurrencyIsoCode
      }
      employeeCertificates {
        ...CertificateData
        CreatedDate
      }
      currentWorkloads {
        Id
        Name
        flair__Start_Date__c
        flair__End_Date__c
        flair__Type__c
      }
      absences(from: $from, to: $to) {
        Id
        flair__Start_Date__c
        flair__End_Date__c
        flair__Working_Amount__c
        flair__Employee_Absence_Category__c
        flair__Approval_Status__c
        category {
          Id
          Name
        }
      }
      feedbacks {
        Id
        flair__State__c
        feedbackCycle {
          Id
          Name
        }
        outcome {
          Id
          flair__Ended_At__c
          flair__Accepted_At__c
          reviewer {
            Id
            Name
          }
        }
      }
    }
  }
}
    ${EmployeeHistoryDataFragmentDoc}
${CertificateDataFragmentDoc}`;

/**
 * __useEmployeePageHistoryQuery__
 *
 * To run a query within a React component, call `useEmployeePageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageHistoryQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEmployeePageHistoryQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables> & ({ variables: EmployeePageHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables>(EmployeePageHistoryDocument, options);
      }
export function useEmployeePageHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables>(EmployeePageHistoryDocument, options);
        }
export function useEmployeePageHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables>(EmployeePageHistoryDocument, options);
        }
export type EmployeePageHistoryQueryHookResult = ReturnType<typeof useEmployeePageHistoryQuery>;
export type EmployeePageHistoryLazyQueryHookResult = ReturnType<typeof useEmployeePageHistoryLazyQuery>;
export type EmployeePageHistorySuspenseQueryHookResult = ReturnType<typeof useEmployeePageHistorySuspenseQuery>;
export type EmployeePageHistoryQueryResult = Apollo.QueryResult<EmployeePageHistoryQuery, EmployeePageHistoryQueryVariables>;
export const EmployeePageEmployeeNotesDocument = gql`
    query EmployeePageEmployeeNotes($employeeId: String!) {
  manager {
    Id
    employeeNotes(employeeId: $employeeId) {
      Id
      text
      flair__Polarity__c
      CreatedDate
    }
  }
}
    `;

/**
 * __useEmployeePageEmployeeNotesQuery__
 *
 * To run a query within a React component, call `useEmployeePageEmployeeNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageEmployeeNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageEmployeeNotesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeePageEmployeeNotesQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables> & ({ variables: EmployeePageEmployeeNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables>(EmployeePageEmployeeNotesDocument, options);
      }
export function useEmployeePageEmployeeNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables>(EmployeePageEmployeeNotesDocument, options);
        }
export function useEmployeePageEmployeeNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables>(EmployeePageEmployeeNotesDocument, options);
        }
export type EmployeePageEmployeeNotesQueryHookResult = ReturnType<typeof useEmployeePageEmployeeNotesQuery>;
export type EmployeePageEmployeeNotesLazyQueryHookResult = ReturnType<typeof useEmployeePageEmployeeNotesLazyQuery>;
export type EmployeePageEmployeeNotesSuspenseQueryHookResult = ReturnType<typeof useEmployeePageEmployeeNotesSuspenseQuery>;
export type EmployeePageEmployeeNotesQueryResult = Apollo.QueryResult<EmployeePageEmployeeNotesQuery, EmployeePageEmployeeNotesQueryVariables>;
export const EmployeePageCreateEmployeeNoteDocument = gql`
    mutation EmployeePageCreateEmployeeNote($input: CreateEmployeeNoteInput!, $employeeId: String!) {
  employeeData {
    createEmployeeNote(input: $input) {
      record {
        Id
        manager {
          Id
          employeeNotes(employeeId: $employeeId) {
            Id
            text
            flair__Polarity__c
            CreatedDate
          }
        }
      }
    }
  }
}
    `;
export type EmployeePageCreateEmployeeNoteMutationFn = Apollo.MutationFunction<EmployeePageCreateEmployeeNoteMutation, EmployeePageCreateEmployeeNoteMutationVariables>;

/**
 * __useEmployeePageCreateEmployeeNoteMutation__
 *
 * To run a mutation, you first call `useEmployeePageCreateEmployeeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageCreateEmployeeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeePageCreateEmployeeNoteMutation, { data, loading, error }] = useEmployeePageCreateEmployeeNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeePageCreateEmployeeNoteMutation(baseOptions?: Apollo.MutationHookOptions<EmployeePageCreateEmployeeNoteMutation, EmployeePageCreateEmployeeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeePageCreateEmployeeNoteMutation, EmployeePageCreateEmployeeNoteMutationVariables>(EmployeePageCreateEmployeeNoteDocument, options);
      }
export type EmployeePageCreateEmployeeNoteMutationHookResult = ReturnType<typeof useEmployeePageCreateEmployeeNoteMutation>;
export type EmployeePageCreateEmployeeNoteMutationResult = Apollo.MutationResult<EmployeePageCreateEmployeeNoteMutation>;
export type EmployeePageCreateEmployeeNoteMutationOptions = Apollo.BaseMutationOptions<EmployeePageCreateEmployeeNoteMutation, EmployeePageCreateEmployeeNoteMutationVariables>;
export const EmployeePageDeleteEmployeeNoteDocument = gql`
    mutation EmployeePageDeleteEmployeeNote($id: String!) {
  employeeData {
    deleteEmployeeNote(id: $id) {
      recordId
    }
  }
}
    `;
export type EmployeePageDeleteEmployeeNoteMutationFn = Apollo.MutationFunction<EmployeePageDeleteEmployeeNoteMutation, EmployeePageDeleteEmployeeNoteMutationVariables>;

/**
 * __useEmployeePageDeleteEmployeeNoteMutation__
 *
 * To run a mutation, you first call `useEmployeePageDeleteEmployeeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageDeleteEmployeeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeePageDeleteEmployeeNoteMutation, { data, loading, error }] = useEmployeePageDeleteEmployeeNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeePageDeleteEmployeeNoteMutation(baseOptions?: Apollo.MutationHookOptions<EmployeePageDeleteEmployeeNoteMutation, EmployeePageDeleteEmployeeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeePageDeleteEmployeeNoteMutation, EmployeePageDeleteEmployeeNoteMutationVariables>(EmployeePageDeleteEmployeeNoteDocument, options);
      }
export type EmployeePageDeleteEmployeeNoteMutationHookResult = ReturnType<typeof useEmployeePageDeleteEmployeeNoteMutation>;
export type EmployeePageDeleteEmployeeNoteMutationResult = Apollo.MutationResult<EmployeePageDeleteEmployeeNoteMutation>;
export type EmployeePageDeleteEmployeeNoteMutationOptions = Apollo.BaseMutationOptions<EmployeePageDeleteEmployeeNoteMutation, EmployeePageDeleteEmployeeNoteMutationVariables>;
export const EmployeePagePerformanceReviewDocument = gql`
    query EmployeePagePerformanceReview($id: String!) {
  manager {
    Id
    employee(id: $id) {
      Id
      feedbacks {
        Id
        flair__Feedback_From__c
        flair__Deadline__c
        flair__State__c
        flair__Submitted_At__c
        flair__Progress__c
        flair__Is_Peer_Reviewer__c
        CreatedDate
        employeeFeedback {
          Id
          flair__State__c
          flair__Progress__c
        }
        feedbackCycle {
          ...FeedbackCycleItem
        }
        outcome {
          Id
          flair__Ended_At__c
          flair__Accepted_At__c
          flair__Employee_Feedback_Participant__c
          reviewer {
            Id
            Name
          }
          meeting {
            Id
            flair__Start_Datetime__c
          }
        }
        peerFeedbacks {
          ...PeerFeedback
        }
        reviewee {
          Id
          Name
        }
      }
    }
  }
}
    ${FeedbackCycleItemFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __useEmployeePagePerformanceReviewQuery__
 *
 * To run a query within a React component, call `useEmployeePagePerformanceReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePagePerformanceReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePagePerformanceReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeePagePerformanceReviewQuery(baseOptions: Apollo.QueryHookOptions<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables> & ({ variables: EmployeePagePerformanceReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables>(EmployeePagePerformanceReviewDocument, options);
      }
export function useEmployeePagePerformanceReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables>(EmployeePagePerformanceReviewDocument, options);
        }
export function useEmployeePagePerformanceReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables>(EmployeePagePerformanceReviewDocument, options);
        }
export type EmployeePagePerformanceReviewQueryHookResult = ReturnType<typeof useEmployeePagePerformanceReviewQuery>;
export type EmployeePagePerformanceReviewLazyQueryHookResult = ReturnType<typeof useEmployeePagePerformanceReviewLazyQuery>;
export type EmployeePagePerformanceReviewSuspenseQueryHookResult = ReturnType<typeof useEmployeePagePerformanceReviewSuspenseQuery>;
export type EmployeePagePerformanceReviewQueryResult = Apollo.QueryResult<EmployeePagePerformanceReviewQuery, EmployeePagePerformanceReviewQueryVariables>;
export const EmployeePageControllingDocument = gql`
    query EmployeePageControlling($id: String!, $from: DateTime!, $to: DateTime!) {
  manager {
    Id
    employee(id: $id) {
      Id
      timeSheets(from: $from, to: $to) {
        ...ManagerEmployeeTimesheet
      }
    }
  }
}
    ${ManagerEmployeeTimesheetFragmentDoc}`;

/**
 * __useEmployeePageControllingQuery__
 *
 * To run a query within a React component, call `useEmployeePageControllingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageControllingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageControllingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEmployeePageControllingQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageControllingQuery, EmployeePageControllingQueryVariables> & ({ variables: EmployeePageControllingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageControllingQuery, EmployeePageControllingQueryVariables>(EmployeePageControllingDocument, options);
      }
export function useEmployeePageControllingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageControllingQuery, EmployeePageControllingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageControllingQuery, EmployeePageControllingQueryVariables>(EmployeePageControllingDocument, options);
        }
export function useEmployeePageControllingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePageControllingQuery, EmployeePageControllingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePageControllingQuery, EmployeePageControllingQueryVariables>(EmployeePageControllingDocument, options);
        }
export type EmployeePageControllingQueryHookResult = ReturnType<typeof useEmployeePageControllingQuery>;
export type EmployeePageControllingLazyQueryHookResult = ReturnType<typeof useEmployeePageControllingLazyQuery>;
export type EmployeePageControllingSuspenseQueryHookResult = ReturnType<typeof useEmployeePageControllingSuspenseQuery>;
export type EmployeePageControllingQueryResult = Apollo.QueryResult<EmployeePageControllingQuery, EmployeePageControllingQueryVariables>;
export const EmployeePageDocument = gql`
    query EmployeePage($id: String!, $from: DateTime!, $to: DateTime!, $timeSheetsFrom: DateTime!, $timeSheetsTo: DateTime!) {
  manager {
    Id
    employee(id: $id) {
      Id
      Name
      flair__Position__c
      flair__Start_Date__c
      managerRolesForEmployee
      data {
        ...MyEmployeeData
      }
      absenceCategories {
        ...RequestAbsenceButton
        ...CategoryAccordion_EmployeeAbsenceCategory
        Id
        flair__Unlimited__c
        category {
          Id
          Name
          flair__Icon__c
          flair__Type__c
          flair__Compensatory_Time__c
          flair__Without_Balance__c
          group {
            Id
            Name
          }
        }
        allowances {
          Id
          Name
          flair__Amount__c
          flair__Expired_Amount__c
          flair__Available_Amount__c
          flair__Used_Amount__c
          flair__Expiration_Date__c
          flair__Period_Start_Date__c
          flair__Period_End_Date__c
          flair__Accrual_Policy_Period_Start_Date__c
        }
        accrualPolicies {
          accrualPolicy {
            Id
            flair__Interval__c
          }
        }
      }
      absences(from: $from, to: $to) {
        Id
        flair__Start_Date__c
        flair__End_Date__c
        flair__Working_Amount__c
        flair__Employee_Absence_Category__c
        flair__Approval_Status__c
        category {
          Id
          Name
        }
      }
      currentWorkloads {
        Id
        Name
        flair__Hours__c
        flair__Hours_Per_Day__c
        flair__Working_Days__c
        flair__Start_Date__c
        flair__End_Date__c
        flair__Type__c
      }
      salaries {
        Id
        flair__Amount__c
        flair__Salary_Type__c
        flair__Start_Date__c
        flair__End_Date__c
        CurrencyIsoCode
      }
      additionalCompensations {
        ...AdditionalCompensationCard_AdditionalCompensation
      }
      oneTimeCompensations {
        ...OneTimeCompensationCard_OneTimeCompensation
      }
      timeSheets(from: $timeSheetsFrom, to: $timeSheetsTo) {
        Id
        flair__Start_Date__c
        flair__Given_Compensatory_Time_Level_1__c
        flair__Given_Compensatory_Time_Level_2__c
      }
      employeeCertificates {
        ...CertificateData
        CreatedDate
      }
      employeeHistory {
        ...EmployeeHistoryData
      }
      feedbacks {
        Id
        flair__State__c
        feedbackCycle {
          Id
          Name
        }
        outcome {
          Id
          flair__Ended_At__c
          flair__Accepted_At__c
          reviewer {
            Id
            Name
          }
        }
      }
    }
  }
}
    ${MyEmployeeDataFragmentDoc}
${RequestAbsenceButtonFragmentDoc}
${CategoryAccordion_EmployeeAbsenceCategoryFragmentDoc}
${AdditionalCompensationCard_AdditionalCompensationFragmentDoc}
${OneTimeCompensationCard_OneTimeCompensationFragmentDoc}
${CertificateDataFragmentDoc}
${EmployeeHistoryDataFragmentDoc}`;

/**
 * __useEmployeePageQuery__
 *
 * To run a query within a React component, call `useEmployeePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeSheetsFrom: // value for 'timeSheetsFrom'
 *      timeSheetsTo: // value for 'timeSheetsTo'
 *   },
 * });
 */
export function useEmployeePageQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageQuery, EmployeePageQueryVariables> & ({ variables: EmployeePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageQuery, EmployeePageQueryVariables>(EmployeePageDocument, options);
      }
export function useEmployeePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageQuery, EmployeePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageQuery, EmployeePageQueryVariables>(EmployeePageDocument, options);
        }
export function useEmployeePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePageQuery, EmployeePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePageQuery, EmployeePageQueryVariables>(EmployeePageDocument, options);
        }
export type EmployeePageQueryHookResult = ReturnType<typeof useEmployeePageQuery>;
export type EmployeePageLazyQueryHookResult = ReturnType<typeof useEmployeePageLazyQuery>;
export type EmployeePageSuspenseQueryHookResult = ReturnType<typeof useEmployeePageSuspenseQuery>;
export type EmployeePageQueryResult = Apollo.QueryResult<EmployeePageQuery, EmployeePageQueryVariables>;
export const ManagerExpensesDocument = gql`
    query ManagerExpenses($expenseFilter: ExpenseFilterInput, $expenseSort: [ExpenseSortInput!], $expensePagination: PaginationInput, $groupFilter: ExpenseGroupFilterInput) {
  manager {
    Id
    expenses(
      filter: $expenseFilter
      sort: $expenseSort
      pagination: $expensePagination
    ) {
      items {
        ...ExpenseData
        ...ExtraFieldsTable_WithExtraFields
      }
      paginationInfo {
        totalCount
      }
    }
    expenseGroups(filter: $groupFilter) {
      ...ExpenseGroupData
    }
  }
}
    ${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;

/**
 * __useManagerExpensesQuery__
 *
 * To run a query within a React component, call `useManagerExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerExpensesQuery({
 *   variables: {
 *      expenseFilter: // value for 'expenseFilter'
 *      expenseSort: // value for 'expenseSort'
 *      expensePagination: // value for 'expensePagination'
 *      groupFilter: // value for 'groupFilter'
 *   },
 * });
 */
export function useManagerExpensesQuery(baseOptions?: Apollo.QueryHookOptions<ManagerExpensesQuery, ManagerExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerExpensesQuery, ManagerExpensesQueryVariables>(ManagerExpensesDocument, options);
      }
export function useManagerExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerExpensesQuery, ManagerExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerExpensesQuery, ManagerExpensesQueryVariables>(ManagerExpensesDocument, options);
        }
export function useManagerExpensesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerExpensesQuery, ManagerExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerExpensesQuery, ManagerExpensesQueryVariables>(ManagerExpensesDocument, options);
        }
export type ManagerExpensesQueryHookResult = ReturnType<typeof useManagerExpensesQuery>;
export type ManagerExpensesLazyQueryHookResult = ReturnType<typeof useManagerExpensesLazyQuery>;
export type ManagerExpensesSuspenseQueryHookResult = ReturnType<typeof useManagerExpensesSuspenseQuery>;
export type ManagerExpensesQueryResult = Apollo.QueryResult<ManagerExpensesQuery, ManagerExpensesQueryVariables>;
export const ManagerCoursesDocument = gql`
    query ManagerCourses($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    employeeCourses(filter: {managerReportsType: $managerReportsType}) {
      ...CoursesTable_EmployeeCourse
    }
  }
}
    ${CoursesTable_EmployeeCourseFragmentDoc}`;

/**
 * __useManagerCoursesQuery__
 *
 * To run a query within a React component, call `useManagerCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerCoursesQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useManagerCoursesQuery(baseOptions: Apollo.QueryHookOptions<ManagerCoursesQuery, ManagerCoursesQueryVariables> & ({ variables: ManagerCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerCoursesQuery, ManagerCoursesQueryVariables>(ManagerCoursesDocument, options);
      }
export function useManagerCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerCoursesQuery, ManagerCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerCoursesQuery, ManagerCoursesQueryVariables>(ManagerCoursesDocument, options);
        }
export function useManagerCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerCoursesQuery, ManagerCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerCoursesQuery, ManagerCoursesQueryVariables>(ManagerCoursesDocument, options);
        }
export type ManagerCoursesQueryHookResult = ReturnType<typeof useManagerCoursesQuery>;
export type ManagerCoursesLazyQueryHookResult = ReturnType<typeof useManagerCoursesLazyQuery>;
export type ManagerCoursesSuspenseQueryHookResult = ReturnType<typeof useManagerCoursesSuspenseQuery>;
export type ManagerCoursesQueryResult = Apollo.QueryResult<ManagerCoursesQuery, ManagerCoursesQueryVariables>;
export const CancelDataChangeRequestDocument = gql`
    mutation CancelDataChangeRequest($id: String!) {
  employeeDataChangeRequest {
    removeRequest(id: $id)
  }
}
    `;
export type CancelDataChangeRequestMutationFn = Apollo.MutationFunction<CancelDataChangeRequestMutation, CancelDataChangeRequestMutationVariables>;

/**
 * __useCancelDataChangeRequestMutation__
 *
 * To run a mutation, you first call `useCancelDataChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDataChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDataChangeRequestMutation, { data, loading, error }] = useCancelDataChangeRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelDataChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelDataChangeRequestMutation, CancelDataChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDataChangeRequestMutation, CancelDataChangeRequestMutationVariables>(CancelDataChangeRequestDocument, options);
      }
export type CancelDataChangeRequestMutationHookResult = ReturnType<typeof useCancelDataChangeRequestMutation>;
export type CancelDataChangeRequestMutationResult = Apollo.MutationResult<CancelDataChangeRequestMutation>;
export type CancelDataChangeRequestMutationOptions = Apollo.BaseMutationOptions<CancelDataChangeRequestMutation, CancelDataChangeRequestMutationVariables>;
export const PositionsForChangeRequestDocument = gql`
    query PositionsForChangeRequest {
  positions(filter: {activeOnly: false}) {
    Id
    Name
    flair__Title__c
    flair__Staffed__c
    flair__Active__c
  }
}
    `;

/**
 * __usePositionsForChangeRequestQuery__
 *
 * To run a query within a React component, call `usePositionsForChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionsForChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionsForChangeRequestQuery({
 *   variables: {
 *   },
 * });
 */
export function usePositionsForChangeRequestQuery(baseOptions?: Apollo.QueryHookOptions<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>(PositionsForChangeRequestDocument, options);
      }
export function usePositionsForChangeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>(PositionsForChangeRequestDocument, options);
        }
export function usePositionsForChangeRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>(PositionsForChangeRequestDocument, options);
        }
export type PositionsForChangeRequestQueryHookResult = ReturnType<typeof usePositionsForChangeRequestQuery>;
export type PositionsForChangeRequestLazyQueryHookResult = ReturnType<typeof usePositionsForChangeRequestLazyQuery>;
export type PositionsForChangeRequestSuspenseQueryHookResult = ReturnType<typeof usePositionsForChangeRequestSuspenseQuery>;
export type PositionsForChangeRequestQueryResult = Apollo.QueryResult<PositionsForChangeRequestQuery, PositionsForChangeRequestQueryVariables>;
export const EmployeeDataChangeRequestsDocument = gql`
    query EmployeeDataChangeRequests {
  employeeDataChangeRequests {
    ...EmployeeDataChangeRequestFields
  }
}
    ${EmployeeDataChangeRequestFieldsFragmentDoc}`;

/**
 * __useEmployeeDataChangeRequestsQuery__
 *
 * To run a query within a React component, call `useEmployeeDataChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDataChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDataChangeRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeDataChangeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>(EmployeeDataChangeRequestsDocument, options);
      }
export function useEmployeeDataChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>(EmployeeDataChangeRequestsDocument, options);
        }
export function useEmployeeDataChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>(EmployeeDataChangeRequestsDocument, options);
        }
export type EmployeeDataChangeRequestsQueryHookResult = ReturnType<typeof useEmployeeDataChangeRequestsQuery>;
export type EmployeeDataChangeRequestsLazyQueryHookResult = ReturnType<typeof useEmployeeDataChangeRequestsLazyQuery>;
export type EmployeeDataChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useEmployeeDataChangeRequestsSuspenseQuery>;
export type EmployeeDataChangeRequestsQueryResult = Apollo.QueryResult<EmployeeDataChangeRequestsQuery, EmployeeDataChangeRequestsQueryVariables>;
export const EmployeeDataChangeRequestByIdDocument = gql`
    query EmployeeDataChangeRequestById($id: String!) {
  employeeDataChangeRequest(id: $id) {
    ...EmployeeDataChangeRequestFields
    ...ChangeRequestDetailsFields
  }
}
    ${EmployeeDataChangeRequestFieldsFragmentDoc}
${ChangeRequestDetailsFieldsFragmentDoc}`;

/**
 * __useEmployeeDataChangeRequestByIdQuery__
 *
 * To run a query within a React component, call `useEmployeeDataChangeRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDataChangeRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDataChangeRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDataChangeRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables> & ({ variables: EmployeeDataChangeRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables>(EmployeeDataChangeRequestByIdDocument, options);
      }
export function useEmployeeDataChangeRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables>(EmployeeDataChangeRequestByIdDocument, options);
        }
export function useEmployeeDataChangeRequestByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables>(EmployeeDataChangeRequestByIdDocument, options);
        }
export type EmployeeDataChangeRequestByIdQueryHookResult = ReturnType<typeof useEmployeeDataChangeRequestByIdQuery>;
export type EmployeeDataChangeRequestByIdLazyQueryHookResult = ReturnType<typeof useEmployeeDataChangeRequestByIdLazyQuery>;
export type EmployeeDataChangeRequestByIdSuspenseQueryHookResult = ReturnType<typeof useEmployeeDataChangeRequestByIdSuspenseQuery>;
export type EmployeeDataChangeRequestByIdQueryResult = Apollo.QueryResult<EmployeeDataChangeRequestByIdQuery, EmployeeDataChangeRequestByIdQueryVariables>;
export const EmployeeRecordFieldsDocument = gql`
    query EmployeeRecordFields($employeeId: String!, $recordType: String!, $fields: [String!]!) {
  recordFields(recordId: $employeeId, recordType: $recordType, fields: $fields) {
    ...ObjectFieldValue
  }
}
    ${ObjectFieldValueFragmentDoc}`;

/**
 * __useEmployeeRecordFieldsQuery__
 *
 * To run a query within a React component, call `useEmployeeRecordFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeRecordFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeRecordFieldsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      recordType: // value for 'recordType'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useEmployeeRecordFieldsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables> & ({ variables: EmployeeRecordFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables>(EmployeeRecordFieldsDocument, options);
      }
export function useEmployeeRecordFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables>(EmployeeRecordFieldsDocument, options);
        }
export function useEmployeeRecordFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables>(EmployeeRecordFieldsDocument, options);
        }
export type EmployeeRecordFieldsQueryHookResult = ReturnType<typeof useEmployeeRecordFieldsQuery>;
export type EmployeeRecordFieldsLazyQueryHookResult = ReturnType<typeof useEmployeeRecordFieldsLazyQuery>;
export type EmployeeRecordFieldsSuspenseQueryHookResult = ReturnType<typeof useEmployeeRecordFieldsSuspenseQuery>;
export type EmployeeRecordFieldsQueryResult = Apollo.QueryResult<EmployeeRecordFieldsQuery, EmployeeRecordFieldsQueryVariables>;
export const EmployeesDocument = gql`
    query Employees($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    employees(filter: {managerReportsType: $managerReportsType}) {
      Id
      Name
      flair__Start_Date__c
      flair__Position__c
      location {
        Id
        Name
      }
      department {
        Id
        Name
      }
    }
  }
}
    `;

/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions: Apollo.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables> & ({ variables: EmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
      }
export function useEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesSuspenseQueryHookResult = ReturnType<typeof useEmployeesSuspenseQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;
export const ManagerEmployeeReviewsDocument = gql`
    query ManagerEmployeeReviews {
  manager {
    Id
    performanceReviews {
      Id
      flair__Feedback_From__c
      flair__Deadline__c
      flair__State__c
      flair__Submitted_At__c
      flair__Progress__c
      CreatedDate
      flair__Is_Peer_Reviewer__c
      employeeFeedback {
        Id
        flair__State__c
        flair__Progress__c
      }
      feedbackCycle {
        ...FeedbackCycleItem
      }
      outcome {
        Id
        flair__Ended_At__c
        flair__Accepted_At__c
        flair__Employee_Feedback_Participant__c
        reviewer {
          Id
          Name
        }
        meeting {
          Id
          flair__Start_Datetime__c
        }
      }
      peerFeedbacks {
        ...PeerFeedback
      }
      reviewee {
        Id
        Name
      }
    }
  }
}
    ${FeedbackCycleItemFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __useManagerEmployeeReviewsQuery__
 *
 * To run a query within a React component, call `useManagerEmployeeReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerEmployeeReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerEmployeeReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagerEmployeeReviewsQuery(baseOptions?: Apollo.QueryHookOptions<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>(ManagerEmployeeReviewsDocument, options);
      }
export function useManagerEmployeeReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>(ManagerEmployeeReviewsDocument, options);
        }
export function useManagerEmployeeReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>(ManagerEmployeeReviewsDocument, options);
        }
export type ManagerEmployeeReviewsQueryHookResult = ReturnType<typeof useManagerEmployeeReviewsQuery>;
export type ManagerEmployeeReviewsLazyQueryHookResult = ReturnType<typeof useManagerEmployeeReviewsLazyQuery>;
export type ManagerEmployeeReviewsSuspenseQueryHookResult = ReturnType<typeof useManagerEmployeeReviewsSuspenseQuery>;
export type ManagerEmployeeReviewsQueryResult = Apollo.QueryResult<ManagerEmployeeReviewsQuery, ManagerEmployeeReviewsQueryVariables>;
export const TicketsDocument = gql`
    query Tickets($filter: TicketFilterInput!, $sort: TicketSortInput, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!, $employeeId: String!) {
  manager {
    Id
    tickets(
      employeeId: $employeeId
      filter: $filter
      pagination: $pagination
      sort: $sort
    ) {
      items {
        ...TicketListData
      }
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${TicketListDataFragmentDoc}`;

/**
 * __useTicketsQuery__
 *
 * To run a query within a React component, call `useTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useTicketsQuery(baseOptions: Apollo.QueryHookOptions<TicketsQuery, TicketsQueryVariables> & ({ variables: TicketsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
      }
export function useTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketsQuery, TicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
        }
export function useTicketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketsQuery, TicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
        }
export type TicketsQueryHookResult = ReturnType<typeof useTicketsQuery>;
export type TicketsLazyQueryHookResult = ReturnType<typeof useTicketsLazyQuery>;
export type TicketsSuspenseQueryHookResult = ReturnType<typeof useTicketsSuspenseQuery>;
export type TicketsQueryResult = Apollo.QueryResult<TicketsQuery, TicketsQueryVariables>;
export const CurrentTimeSheetsDocument = gql`
    query CurrentTimeSheets($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    currentTimeSheets(filter: {managerReportsType: $managerReportsType}) {
      ...ManagerTimeSheet
    }
  }
}
    ${ManagerTimeSheetFragmentDoc}`;

/**
 * __useCurrentTimeSheetsQuery__
 *
 * To run a query within a React component, call `useCurrentTimeSheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTimeSheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTimeSheetsQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useCurrentTimeSheetsQuery(baseOptions: Apollo.QueryHookOptions<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables> & ({ variables: CurrentTimeSheetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables>(CurrentTimeSheetsDocument, options);
      }
export function useCurrentTimeSheetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables>(CurrentTimeSheetsDocument, options);
        }
export function useCurrentTimeSheetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables>(CurrentTimeSheetsDocument, options);
        }
export type CurrentTimeSheetsQueryHookResult = ReturnType<typeof useCurrentTimeSheetsQuery>;
export type CurrentTimeSheetsLazyQueryHookResult = ReturnType<typeof useCurrentTimeSheetsLazyQuery>;
export type CurrentTimeSheetsSuspenseQueryHookResult = ReturnType<typeof useCurrentTimeSheetsSuspenseQuery>;
export type CurrentTimeSheetsQueryResult = Apollo.QueryResult<CurrentTimeSheetsQuery, CurrentTimeSheetsQueryVariables>;
export const TimeSheetDayTimeEntriesDocument = gql`
    query timeSheetDayTimeEntries($timeSheetId: String!) {
  costCenters {
    Id
    Name
  }
  timeSheet(id: $timeSheetId) {
    Id
    ...TimeSheetTimeEntriesDetails
  }
}
    ${TimeSheetTimeEntriesDetailsFragmentDoc}`;

/**
 * __useTimeSheetDayTimeEntriesQuery__
 *
 * To run a query within a React component, call `useTimeSheetDayTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetDayTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetDayTimeEntriesQuery({
 *   variables: {
 *      timeSheetId: // value for 'timeSheetId'
 *   },
 * });
 */
export function useTimeSheetDayTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables> & ({ variables: TimeSheetDayTimeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables>(TimeSheetDayTimeEntriesDocument, options);
      }
export function useTimeSheetDayTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables>(TimeSheetDayTimeEntriesDocument, options);
        }
export function useTimeSheetDayTimeEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables>(TimeSheetDayTimeEntriesDocument, options);
        }
export type TimeSheetDayTimeEntriesQueryHookResult = ReturnType<typeof useTimeSheetDayTimeEntriesQuery>;
export type TimeSheetDayTimeEntriesLazyQueryHookResult = ReturnType<typeof useTimeSheetDayTimeEntriesLazyQuery>;
export type TimeSheetDayTimeEntriesSuspenseQueryHookResult = ReturnType<typeof useTimeSheetDayTimeEntriesSuspenseQuery>;
export type TimeSheetDayTimeEntriesQueryResult = Apollo.QueryResult<TimeSheetDayTimeEntriesQuery, TimeSheetDayTimeEntriesQueryVariables>;
export const TimeSheetFiltersDocument = gql`
    query TimeSheetFilters($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    employees(filter: {managerReportsType: $managerReportsType}) {
      ...EmployeeSelectInfo
    }
  }
}
    ${EmployeeSelectInfoFragmentDoc}`;

/**
 * __useTimeSheetFiltersQuery__
 *
 * To run a query within a React component, call `useTimeSheetFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetFiltersQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useTimeSheetFiltersQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables> & ({ variables: TimeSheetFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables>(TimeSheetFiltersDocument, options);
      }
export function useTimeSheetFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables>(TimeSheetFiltersDocument, options);
        }
export function useTimeSheetFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables>(TimeSheetFiltersDocument, options);
        }
export type TimeSheetFiltersQueryHookResult = ReturnType<typeof useTimeSheetFiltersQuery>;
export type TimeSheetFiltersLazyQueryHookResult = ReturnType<typeof useTimeSheetFiltersLazyQuery>;
export type TimeSheetFiltersSuspenseQueryHookResult = ReturnType<typeof useTimeSheetFiltersSuspenseQuery>;
export type TimeSheetFiltersQueryResult = Apollo.QueryResult<TimeSheetFiltersQuery, TimeSheetFiltersQueryVariables>;
export const EmployeeDetailsDocument = gql`
    query EmployeeDetails($id: String!) {
  manager {
    Id
    employee(id: $id) {
      ...EmployeeDetails
    }
  }
}
    ${EmployeeDetailsFragmentDoc}`;

/**
 * __useEmployeeDetailsQuery__
 *
 * To run a query within a React component, call `useEmployeeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDetailsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables> & ({ variables: EmployeeDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>(EmployeeDetailsDocument, options);
      }
export function useEmployeeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>(EmployeeDetailsDocument, options);
        }
export function useEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>(EmployeeDetailsDocument, options);
        }
export type EmployeeDetailsQueryHookResult = ReturnType<typeof useEmployeeDetailsQuery>;
export type EmployeeDetailsLazyQueryHookResult = ReturnType<typeof useEmployeeDetailsLazyQuery>;
export type EmployeeDetailsSuspenseQueryHookResult = ReturnType<typeof useEmployeeDetailsSuspenseQuery>;
export type EmployeeDetailsQueryResult = Apollo.QueryResult<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>;
export const TimeSheetsTopPanelDocument = gql`
    query TimeSheetsTopPanel($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    timeSheetsPagination(
      filter: {managerReportsType: $managerReportsType, status: PENDING}
      pagination: {offset: 0, limit: 4000}
    ) {
      items {
        Id
        flair__Approval_Status__c
        warnings {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useTimeSheetsTopPanelQuery__
 *
 * To run a query within a React component, call `useTimeSheetsTopPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetsTopPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetsTopPanelQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useTimeSheetsTopPanelQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables> & ({ variables: TimeSheetsTopPanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables>(TimeSheetsTopPanelDocument, options);
      }
export function useTimeSheetsTopPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables>(TimeSheetsTopPanelDocument, options);
        }
export function useTimeSheetsTopPanelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables>(TimeSheetsTopPanelDocument, options);
        }
export type TimeSheetsTopPanelQueryHookResult = ReturnType<typeof useTimeSheetsTopPanelQuery>;
export type TimeSheetsTopPanelLazyQueryHookResult = ReturnType<typeof useTimeSheetsTopPanelLazyQuery>;
export type TimeSheetsTopPanelSuspenseQueryHookResult = ReturnType<typeof useTimeSheetsTopPanelSuspenseQuery>;
export type TimeSheetsTopPanelQueryResult = Apollo.QueryResult<TimeSheetsTopPanelQuery, TimeSheetsTopPanelQueryVariables>;
export const AllTimeSheetsDocument = gql`
    query AllTimeSheets($filter: TimeSheetFilterInput!, $sort: [TimeSheetSortInput!], $offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  manager {
    Id
    timeSheetsPagination(
      filter: $filter
      sort: $sort
      pagination: {offset: $offset, limit: $limit}
    ) {
      items {
        ...TimeSheetTable
      }
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${TimeSheetTableFragmentDoc}`;

/**
 * __useAllTimeSheetsQuery__
 *
 * To run a query within a React component, call `useAllTimeSheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTimeSheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTimeSheetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useAllTimeSheetsQuery(baseOptions: Apollo.QueryHookOptions<AllTimeSheetsQuery, AllTimeSheetsQueryVariables> & ({ variables: AllTimeSheetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTimeSheetsQuery, AllTimeSheetsQueryVariables>(AllTimeSheetsDocument, options);
      }
export function useAllTimeSheetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTimeSheetsQuery, AllTimeSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTimeSheetsQuery, AllTimeSheetsQueryVariables>(AllTimeSheetsDocument, options);
        }
export function useAllTimeSheetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllTimeSheetsQuery, AllTimeSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTimeSheetsQuery, AllTimeSheetsQueryVariables>(AllTimeSheetsDocument, options);
        }
export type AllTimeSheetsQueryHookResult = ReturnType<typeof useAllTimeSheetsQuery>;
export type AllTimeSheetsLazyQueryHookResult = ReturnType<typeof useAllTimeSheetsLazyQuery>;
export type AllTimeSheetsSuspenseQueryHookResult = ReturnType<typeof useAllTimeSheetsSuspenseQuery>;
export type AllTimeSheetsQueryResult = Apollo.QueryResult<AllTimeSheetsQuery, AllTimeSheetsQueryVariables>;
export const AbsencesCalendarDocument = gql`
    query AbsencesCalendar($from: DateTime!, $to: DateTime!) {
  me {
    Id
    absenceCategories {
      ...RequestAbsenceButton
      Id
      flair__Unlimited__c
      category {
        Id
        Name
        flair__Icon__c
        flair__Type__c
        group {
          Id
          Name
        }
      }
      allowances {
        Id
        Name
        flair__Amount__c
        flair__Available_Amount__c
        flair__Expiration_Date__c
        flair__Accrual_Policy_Period_Start_Date__c
      }
    }
    absences(from: $from, to: $to, excludeRejected: true) {
      Id
      ...AbsencePopover
      flair__Approval_Status__c
      flair__Category_Name__c
      flair__Category_Icon__c
      flair__Category_Id__c
      flair__Amount__c
      flair__Working_Amount__c
      flair__Start_Date__c
      flair__Start_Time__c
      flair__Start_Date_Half_Day__c
      flair__End_Date__c
      flair__End_Time__c
      flair__End_Date_Half_Day__c
      flair__Type__c
      flair__Employee_Absence_Category__c
      flair__Category_Unlimited__c
      category {
        Id
        flair__Public__c
        group {
          Id
        }
      }
    }
    workloads(from: $from, to: $to) {
      Id
      flair__Start_Date__c
      flair__End_Date__c
      flair__Working_Days__c
      flair__Hours_Per_Day__c
      flair__Type__c
    }
    holidays(from: $from, to: $to) {
      ...Holiday
    }
  }
}
    ${RequestAbsenceButtonFragmentDoc}
${AbsencePopoverFragmentDoc}
${HolidayFragmentDoc}`;

/**
 * __useAbsencesCalendarQuery__
 *
 * To run a query within a React component, call `useAbsencesCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesCalendarQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAbsencesCalendarQuery(baseOptions: Apollo.QueryHookOptions<AbsencesCalendarQuery, AbsencesCalendarQueryVariables> & ({ variables: AbsencesCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbsencesCalendarQuery, AbsencesCalendarQueryVariables>(AbsencesCalendarDocument, options);
      }
export function useAbsencesCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbsencesCalendarQuery, AbsencesCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbsencesCalendarQuery, AbsencesCalendarQueryVariables>(AbsencesCalendarDocument, options);
        }
export function useAbsencesCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AbsencesCalendarQuery, AbsencesCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AbsencesCalendarQuery, AbsencesCalendarQueryVariables>(AbsencesCalendarDocument, options);
        }
export type AbsencesCalendarQueryHookResult = ReturnType<typeof useAbsencesCalendarQuery>;
export type AbsencesCalendarLazyQueryHookResult = ReturnType<typeof useAbsencesCalendarLazyQuery>;
export type AbsencesCalendarSuspenseQueryHookResult = ReturnType<typeof useAbsencesCalendarSuspenseQuery>;
export type AbsencesCalendarQueryResult = Apollo.QueryResult<AbsencesCalendarQuery, AbsencesCalendarQueryVariables>;
export const RequestedAbsenceDocument = gql`
    query RequestedAbsence($id: String!) {
  absence(id: $id) {
    ...RequestedAbsence
  }
}
    ${RequestedAbsenceFragmentDoc}`;

/**
 * __useRequestedAbsenceQuery__
 *
 * To run a query within a React component, call `useRequestedAbsenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestedAbsenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestedAbsenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestedAbsenceQuery(baseOptions: Apollo.QueryHookOptions<RequestedAbsenceQuery, RequestedAbsenceQueryVariables> & ({ variables: RequestedAbsenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestedAbsenceQuery, RequestedAbsenceQueryVariables>(RequestedAbsenceDocument, options);
      }
export function useRequestedAbsenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestedAbsenceQuery, RequestedAbsenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestedAbsenceQuery, RequestedAbsenceQueryVariables>(RequestedAbsenceDocument, options);
        }
export function useRequestedAbsenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestedAbsenceQuery, RequestedAbsenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestedAbsenceQuery, RequestedAbsenceQueryVariables>(RequestedAbsenceDocument, options);
        }
export type RequestedAbsenceQueryHookResult = ReturnType<typeof useRequestedAbsenceQuery>;
export type RequestedAbsenceLazyQueryHookResult = ReturnType<typeof useRequestedAbsenceLazyQuery>;
export type RequestedAbsenceSuspenseQueryHookResult = ReturnType<typeof useRequestedAbsenceSuspenseQuery>;
export type RequestedAbsenceQueryResult = Apollo.QueryResult<RequestedAbsenceQuery, RequestedAbsenceQueryVariables>;
export const EmployeeAbsencesDocument = gql`
    query EmployeeAbsences($from: DateTime!, $to: DateTime!) {
  me {
    Id
    absenceCategories {
      ...RequestAbsenceButton
      ...CategoryAccordion_EmployeeAbsenceCategory
    }
    absences(from: $from, to: $to, excludeRejected: false) {
      ...AbsenceData
      ...ExtraFieldsTable_WithExtraFields
      flair__Category_Icon__c
      flair__Amount__c
      CreatedDate
      approvalRequests {
        ...MyAbsenceFilters_AbsenceRequest
      }
    }
  }
}
    ${RequestAbsenceButtonFragmentDoc}
${CategoryAccordion_EmployeeAbsenceCategoryFragmentDoc}
${AbsenceDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${MyAbsenceFilters_AbsenceRequestFragmentDoc}`;

/**
 * __useEmployeeAbsencesQuery__
 *
 * To run a query within a React component, call `useEmployeeAbsencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeAbsencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeAbsencesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEmployeeAbsencesQuery(baseOptions: Apollo.QueryHookOptions<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables> & ({ variables: EmployeeAbsencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables>(EmployeeAbsencesDocument, options);
      }
export function useEmployeeAbsencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables>(EmployeeAbsencesDocument, options);
        }
export function useEmployeeAbsencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables>(EmployeeAbsencesDocument, options);
        }
export type EmployeeAbsencesQueryHookResult = ReturnType<typeof useEmployeeAbsencesQuery>;
export type EmployeeAbsencesLazyQueryHookResult = ReturnType<typeof useEmployeeAbsencesLazyQuery>;
export type EmployeeAbsencesSuspenseQueryHookResult = ReturnType<typeof useEmployeeAbsencesSuspenseQuery>;
export type EmployeeAbsencesQueryResult = Apollo.QueryResult<EmployeeAbsencesQuery, EmployeeAbsencesQueryVariables>;
export const TeamCalendarFiltersDocument = gql`
    query TeamCalendarFilters($from: DateTime!, $to: DateTime!) {
  me {
    Id
    teamColleagues(from: $from, to: $to) {
      Id
      location {
        Id
        Name
      }
      department {
        Id
        Name
      }
      teams {
        Id
        Name
      }
    }
  }
  absencesCategories {
    Id
    Name
    flair__Public__c
    flair__Archived_Date__c
    flair__Order__c
    group {
      Id
      Name
      flair__Order__c
    }
  }
}
    `;

/**
 * __useTeamCalendarFiltersQuery__
 *
 * To run a query within a React component, call `useTeamCalendarFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamCalendarFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamCalendarFiltersQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTeamCalendarFiltersQuery(baseOptions: Apollo.QueryHookOptions<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables> & ({ variables: TeamCalendarFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables>(TeamCalendarFiltersDocument, options);
      }
export function useTeamCalendarFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables>(TeamCalendarFiltersDocument, options);
        }
export function useTeamCalendarFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables>(TeamCalendarFiltersDocument, options);
        }
export type TeamCalendarFiltersQueryHookResult = ReturnType<typeof useTeamCalendarFiltersQuery>;
export type TeamCalendarFiltersLazyQueryHookResult = ReturnType<typeof useTeamCalendarFiltersLazyQuery>;
export type TeamCalendarFiltersSuspenseQueryHookResult = ReturnType<typeof useTeamCalendarFiltersSuspenseQuery>;
export type TeamCalendarFiltersQueryResult = Apollo.QueryResult<TeamCalendarFiltersQuery, TeamCalendarFiltersQueryVariables>;
export const TeamCalendarDocument = gql`
    query TeamCalendar($from: DateTime!, $to: DateTime!, $locations: [String!], $teams: [String!], $departments: [String!]) {
  me {
    Id
    teamColleagues(
      from: $from
      to: $to
      locations: $locations
      teams: $teams
      departments: $departments
    ) {
      Id
      Name
      avatar {
        Id
        url
      }
      absences2(from: $from, to: $to) {
        Id
        ...AbsencePopover
        flair__Category_Id__c
        flair__Approval_Status__c
        flair__Amount__c
        flair__Category_Unlimited__c
        category {
          Id
          flair__Public__c
          group {
            Id
          }
        }
      }
      workloads(from: $from, to: $to) {
        Id
        flair__Start_Date__c
        flair__End_Date__c
        flair__Working_Days__c
        flair__Hours_Per_Day__c
        flair__Type__c
      }
      holidays(from: $from, to: $to) {
        ...Holiday
      }
    }
  }
}
    ${AbsencePopoverFragmentDoc}
${HolidayFragmentDoc}`;

/**
 * __useTeamCalendarQuery__
 *
 * To run a query within a React component, call `useTeamCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamCalendarQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      locations: // value for 'locations'
 *      teams: // value for 'teams'
 *      departments: // value for 'departments'
 *   },
 * });
 */
export function useTeamCalendarQuery(baseOptions: Apollo.QueryHookOptions<TeamCalendarQuery, TeamCalendarQueryVariables> & ({ variables: TeamCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamCalendarQuery, TeamCalendarQueryVariables>(TeamCalendarDocument, options);
      }
export function useTeamCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamCalendarQuery, TeamCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamCalendarQuery, TeamCalendarQueryVariables>(TeamCalendarDocument, options);
        }
export function useTeamCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamCalendarQuery, TeamCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamCalendarQuery, TeamCalendarQueryVariables>(TeamCalendarDocument, options);
        }
export type TeamCalendarQueryHookResult = ReturnType<typeof useTeamCalendarQuery>;
export type TeamCalendarLazyQueryHookResult = ReturnType<typeof useTeamCalendarLazyQuery>;
export type TeamCalendarSuspenseQueryHookResult = ReturnType<typeof useTeamCalendarSuspenseQuery>;
export type TeamCalendarQueryResult = Apollo.QueryResult<TeamCalendarQuery, TeamCalendarQueryVariables>;
export const AbsenceYearlySummaryDocument = gql`
    query AbsenceYearlySummary($employeeId: String!) {
  employee(id: $employeeId) {
    Id
    absenceCategories {
      ...CategoryAccordion_EmployeeAbsenceCategoryForYearlySummary
    }
  }
}
    ${CategoryAccordion_EmployeeAbsenceCategoryForYearlySummaryFragmentDoc}`;

/**
 * __useAbsenceYearlySummaryQuery__
 *
 * To run a query within a React component, call `useAbsenceYearlySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsenceYearlySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsenceYearlySummaryQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useAbsenceYearlySummaryQuery(baseOptions: Apollo.QueryHookOptions<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables> & ({ variables: AbsenceYearlySummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables>(AbsenceYearlySummaryDocument, options);
      }
export function useAbsenceYearlySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables>(AbsenceYearlySummaryDocument, options);
        }
export function useAbsenceYearlySummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables>(AbsenceYearlySummaryDocument, options);
        }
export type AbsenceYearlySummaryQueryHookResult = ReturnType<typeof useAbsenceYearlySummaryQuery>;
export type AbsenceYearlySummaryLazyQueryHookResult = ReturnType<typeof useAbsenceYearlySummaryLazyQuery>;
export type AbsenceYearlySummarySuspenseQueryHookResult = ReturnType<typeof useAbsenceYearlySummarySuspenseQuery>;
export type AbsenceYearlySummaryQueryResult = Apollo.QueryResult<AbsenceYearlySummaryQuery, AbsenceYearlySummaryQueryVariables>;
export const MyAbsenceDaysDocument = gql`
    query MyAbsenceDays($absenceId: String!) {
  absence(id: $absenceId) {
    Id
    absenceDays {
      ...AbsenceDayData
    }
  }
}
    ${AbsenceDayDataFragmentDoc}`;

/**
 * __useMyAbsenceDaysQuery__
 *
 * To run a query within a React component, call `useMyAbsenceDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAbsenceDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAbsenceDaysQuery({
 *   variables: {
 *      absenceId: // value for 'absenceId'
 *   },
 * });
 */
export function useMyAbsenceDaysQuery(baseOptions: Apollo.QueryHookOptions<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables> & ({ variables: MyAbsenceDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables>(MyAbsenceDaysDocument, options);
      }
export function useMyAbsenceDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables>(MyAbsenceDaysDocument, options);
        }
export function useMyAbsenceDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables>(MyAbsenceDaysDocument, options);
        }
export type MyAbsenceDaysQueryHookResult = ReturnType<typeof useMyAbsenceDaysQuery>;
export type MyAbsenceDaysLazyQueryHookResult = ReturnType<typeof useMyAbsenceDaysLazyQuery>;
export type MyAbsenceDaysSuspenseQueryHookResult = ReturnType<typeof useMyAbsenceDaysSuspenseQuery>;
export type MyAbsenceDaysQueryResult = Apollo.QueryResult<MyAbsenceDaysQuery, MyAbsenceDaysQueryVariables>;
export const MyAbsencesDocument = gql`
    query MyAbsences($from: DateTime!, $to: DateTime!) {
  me {
    Id
    absenceCategories {
      ...CategoryAccordion_EmployeeAbsenceCategory
    }
    absencesCurrentYear {
      ...AbsencesByYear
    }
    upcomingAbsences {
      ...AbsenceData
      flair__Category_Icon__c
      flair__Amount__c
      approvalRequests {
        Id
        flair__Approval_Status__c
        flair__Approver_Comment__c
      }
    }
    absences(from: $from, to: $to, excludeRejected: false) {
      ...AbsenceData
      flair__Category_Icon__c
      flair__Amount__c
      CreatedDate
      approvalRequests {
        ...MyAbsenceFilters_AbsenceRequest
      }
    }
    ongoingAbsences {
      ...AbsenceData
    }
    pastAbsences {
      ...AbsenceData
    }
  }
  myTimeSheets(from: $from, to: $to) {
    Id
    flair__Start_Date__c
    flair__Given_Compensatory_Time_Level_1__c
    flair__Given_Compensatory_Time_Level_2__c
  }
}
    ${CategoryAccordion_EmployeeAbsenceCategoryFragmentDoc}
${AbsencesByYearFragmentDoc}
${AbsenceDataFragmentDoc}
${MyAbsenceFilters_AbsenceRequestFragmentDoc}`;

/**
 * __useMyAbsencesQuery__
 *
 * To run a query within a React component, call `useMyAbsencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAbsencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAbsencesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMyAbsencesQuery(baseOptions: Apollo.QueryHookOptions<MyAbsencesQuery, MyAbsencesQueryVariables> & ({ variables: MyAbsencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAbsencesQuery, MyAbsencesQueryVariables>(MyAbsencesDocument, options);
      }
export function useMyAbsencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAbsencesQuery, MyAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAbsencesQuery, MyAbsencesQueryVariables>(MyAbsencesDocument, options);
        }
export function useMyAbsencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAbsencesQuery, MyAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAbsencesQuery, MyAbsencesQueryVariables>(MyAbsencesDocument, options);
        }
export type MyAbsencesQueryHookResult = ReturnType<typeof useMyAbsencesQuery>;
export type MyAbsencesLazyQueryHookResult = ReturnType<typeof useMyAbsencesLazyQuery>;
export type MyAbsencesSuspenseQueryHookResult = ReturnType<typeof useMyAbsencesSuspenseQuery>;
export type MyAbsencesQueryResult = Apollo.QueryResult<MyAbsencesQuery, MyAbsencesQueryVariables>;
export const ApproveAbsenceRequestDocument = gql`
    mutation ApproveAbsenceRequest($id: String!) {
  absence {
    approveAbsenceRequest(id: $id) {
      record {
        ...ApproveRejectPayload
      }
    }
  }
}
    ${ApproveRejectPayloadFragmentDoc}`;
export type ApproveAbsenceRequestMutationFn = Apollo.MutationFunction<ApproveAbsenceRequestMutation, ApproveAbsenceRequestMutationVariables>;

/**
 * __useApproveAbsenceRequestMutation__
 *
 * To run a mutation, you first call `useApproveAbsenceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAbsenceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAbsenceRequestMutation, { data, loading, error }] = useApproveAbsenceRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveAbsenceRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAbsenceRequestMutation, ApproveAbsenceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAbsenceRequestMutation, ApproveAbsenceRequestMutationVariables>(ApproveAbsenceRequestDocument, options);
      }
export type ApproveAbsenceRequestMutationHookResult = ReturnType<typeof useApproveAbsenceRequestMutation>;
export type ApproveAbsenceRequestMutationResult = Apollo.MutationResult<ApproveAbsenceRequestMutation>;
export type ApproveAbsenceRequestMutationOptions = Apollo.BaseMutationOptions<ApproveAbsenceRequestMutation, ApproveAbsenceRequestMutationVariables>;
export const RejectAbsenceRequestDocument = gql`
    mutation RejectAbsenceRequest($id: String!, $comment: String) {
  absence {
    rejectAbsenceRequest(id: $id, comment: $comment) {
      record {
        ...ApproveRejectPayload
      }
    }
  }
}
    ${ApproveRejectPayloadFragmentDoc}`;
export type RejectAbsenceRequestMutationFn = Apollo.MutationFunction<RejectAbsenceRequestMutation, RejectAbsenceRequestMutationVariables>;

/**
 * __useRejectAbsenceRequestMutation__
 *
 * To run a mutation, you first call `useRejectAbsenceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAbsenceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAbsenceRequestMutation, { data, loading, error }] = useRejectAbsenceRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRejectAbsenceRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectAbsenceRequestMutation, RejectAbsenceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAbsenceRequestMutation, RejectAbsenceRequestMutationVariables>(RejectAbsenceRequestDocument, options);
      }
export type RejectAbsenceRequestMutationHookResult = ReturnType<typeof useRejectAbsenceRequestMutation>;
export type RejectAbsenceRequestMutationResult = Apollo.MutationResult<RejectAbsenceRequestMutation>;
export type RejectAbsenceRequestMutationOptions = Apollo.BaseMutationOptions<RejectAbsenceRequestMutation, RejectAbsenceRequestMutationVariables>;
export const DeleteUpcomingAbsenceDocument = gql`
    mutation DeleteUpcomingAbsence($id: String!) {
  deleteUpcomingAbsence(id: $id)
}
    `;
export type DeleteUpcomingAbsenceMutationFn = Apollo.MutationFunction<DeleteUpcomingAbsenceMutation, DeleteUpcomingAbsenceMutationVariables>;

/**
 * __useDeleteUpcomingAbsenceMutation__
 *
 * To run a mutation, you first call `useDeleteUpcomingAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUpcomingAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUpcomingAbsenceMutation, { data, loading, error }] = useDeleteUpcomingAbsenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUpcomingAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUpcomingAbsenceMutation, DeleteUpcomingAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUpcomingAbsenceMutation, DeleteUpcomingAbsenceMutationVariables>(DeleteUpcomingAbsenceDocument, options);
      }
export type DeleteUpcomingAbsenceMutationHookResult = ReturnType<typeof useDeleteUpcomingAbsenceMutation>;
export type DeleteUpcomingAbsenceMutationResult = Apollo.MutationResult<DeleteUpcomingAbsenceMutation>;
export type DeleteUpcomingAbsenceMutationOptions = Apollo.BaseMutationOptions<DeleteUpcomingAbsenceMutation, DeleteUpcomingAbsenceMutationVariables>;
export const CalendarQueryDocument = gql`
    query CalendarQuery($from: DateTime!, $to: DateTime!) {
  me {
    Id
    flair__Location__c
    activeColleagues(from: $from, to: $to) {
      Id
      Name
      flair__Position__c
      flair__Department__c
      shifts(from: $from, to: $to) {
        ...EmployeeShiftFields
      }
      absences2(from: $from, to: $to) {
        Id
        flair__Start_Date__c
        flair__Start_Time__c
        flair__Start_Date_Half_Day__c
        flair__End_Date__c
        flair__End_Time__c
        flair__End_Date_Half_Day__c
        flair__Category_Name__c
        flair__Category_Id__c
        flair__Type__c
        category {
          Id
          group {
            Id
          }
        }
      }
      employeeSkills {
        Id
        flair__Skill__c
      }
    }
    invitedColleagues(from: $from, to: $to) {
      Id
      Name
      flair__Position__c
      flair__Department__c
      location {
        Id
        Name
      }
      shifts(from: $from, to: $to) {
        ...EmployeeShiftFields
      }
      absences2(from: $from, to: $to) {
        Id
        flair__Start_Date__c
        flair__Start_Time__c
        flair__Start_Date_Half_Day__c
        flair__End_Date__c
        flair__End_Time__c
        flair__End_Date_Half_Day__c
        flair__Category_Name__c
        flair__Category_Id__c
        flair__Type__c
        category {
          Id
          group {
            Id
          }
        }
      }
      employeeSkills {
        Id
        flair__Skill__c
      }
    }
    openShifts(from: $from, to: $to) {
      Id
      Name
      flair__Start_Datetime__c
      flair__End_Datetime__c
      flair__Location__c
      flair__Total_Break_Period_in_Minutes__c
      flair__Employees_Count__c
      Breaks {
        ...ShiftBreakFields
      }
      AssignmentRequests {
        Id
        flair__Employee__c
        flair__Confirmed_At__c
        employee {
          Id
          Name
        }
      }
      EmployeeShifts {
        Id
        employee {
          Id
          Name
        }
      }
      Skills {
        Id
        Name
      }
    }
  }
}
    ${EmployeeShiftFieldsFragmentDoc}
${ShiftBreakFieldsFragmentDoc}`;

/**
 * __useCalendarQueryQuery__
 *
 * To run a query within a React component, call `useCalendarQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarQueryQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCalendarQueryQuery(baseOptions: Apollo.QueryHookOptions<CalendarQueryQuery, CalendarQueryQueryVariables> & ({ variables: CalendarQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarQueryQuery, CalendarQueryQueryVariables>(CalendarQueryDocument, options);
      }
export function useCalendarQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarQueryQuery, CalendarQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarQueryQuery, CalendarQueryQueryVariables>(CalendarQueryDocument, options);
        }
export function useCalendarQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarQueryQuery, CalendarQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarQueryQuery, CalendarQueryQueryVariables>(CalendarQueryDocument, options);
        }
export type CalendarQueryQueryHookResult = ReturnType<typeof useCalendarQueryQuery>;
export type CalendarQueryLazyQueryHookResult = ReturnType<typeof useCalendarQueryLazyQuery>;
export type CalendarQuerySuspenseQueryHookResult = ReturnType<typeof useCalendarQuerySuspenseQuery>;
export type CalendarQueryQueryResult = Apollo.QueryResult<CalendarQueryQuery, CalendarQueryQueryVariables>;
export const CalendarFiltersDocument = gql`
    query CalendarFilters {
  departments {
    Id
    Name
  }
  skills {
    Id
    Name
  }
}
    `;

/**
 * __useCalendarFiltersQuery__
 *
 * To run a query within a React component, call `useCalendarFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarFiltersQuery(baseOptions?: Apollo.QueryHookOptions<CalendarFiltersQuery, CalendarFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarFiltersQuery, CalendarFiltersQueryVariables>(CalendarFiltersDocument, options);
      }
export function useCalendarFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarFiltersQuery, CalendarFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarFiltersQuery, CalendarFiltersQueryVariables>(CalendarFiltersDocument, options);
        }
export function useCalendarFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarFiltersQuery, CalendarFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarFiltersQuery, CalendarFiltersQueryVariables>(CalendarFiltersDocument, options);
        }
export type CalendarFiltersQueryHookResult = ReturnType<typeof useCalendarFiltersQuery>;
export type CalendarFiltersLazyQueryHookResult = ReturnType<typeof useCalendarFiltersLazyQuery>;
export type CalendarFiltersSuspenseQueryHookResult = ReturnType<typeof useCalendarFiltersSuspenseQuery>;
export type CalendarFiltersQueryResult = Apollo.QueryResult<CalendarFiltersQuery, CalendarFiltersQueryVariables>;
export const CreateOpenShiftAssignmentRequestDocument = gql`
    mutation CreateOpenShiftAssignmentRequest($input: CreateOpenShiftAssignmentRequestInput!) {
  createOpenShiftAssignmentRequest(input: $input)
}
    `;
export type CreateOpenShiftAssignmentRequestMutationFn = Apollo.MutationFunction<CreateOpenShiftAssignmentRequestMutation, CreateOpenShiftAssignmentRequestMutationVariables>;

/**
 * __useCreateOpenShiftAssignmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateOpenShiftAssignmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenShiftAssignmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenShiftAssignmentRequestMutation, { data, loading, error }] = useCreateOpenShiftAssignmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpenShiftAssignmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpenShiftAssignmentRequestMutation, CreateOpenShiftAssignmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpenShiftAssignmentRequestMutation, CreateOpenShiftAssignmentRequestMutationVariables>(CreateOpenShiftAssignmentRequestDocument, options);
      }
export type CreateOpenShiftAssignmentRequestMutationHookResult = ReturnType<typeof useCreateOpenShiftAssignmentRequestMutation>;
export type CreateOpenShiftAssignmentRequestMutationResult = Apollo.MutationResult<CreateOpenShiftAssignmentRequestMutation>;
export type CreateOpenShiftAssignmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateOpenShiftAssignmentRequestMutation, CreateOpenShiftAssignmentRequestMutationVariables>;
export const DeleteOpenShiftAssignmentRequestDocument = gql`
    mutation DeleteOpenShiftAssignmentRequest($id: String!) {
  deleteOpenShiftAssignmentRequest(id: $id)
}
    `;
export type DeleteOpenShiftAssignmentRequestMutationFn = Apollo.MutationFunction<DeleteOpenShiftAssignmentRequestMutation, DeleteOpenShiftAssignmentRequestMutationVariables>;

/**
 * __useDeleteOpenShiftAssignmentRequestMutation__
 *
 * To run a mutation, you first call `useDeleteOpenShiftAssignmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpenShiftAssignmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpenShiftAssignmentRequestMutation, { data, loading, error }] = useDeleteOpenShiftAssignmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOpenShiftAssignmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpenShiftAssignmentRequestMutation, DeleteOpenShiftAssignmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpenShiftAssignmentRequestMutation, DeleteOpenShiftAssignmentRequestMutationVariables>(DeleteOpenShiftAssignmentRequestDocument, options);
      }
export type DeleteOpenShiftAssignmentRequestMutationHookResult = ReturnType<typeof useDeleteOpenShiftAssignmentRequestMutation>;
export type DeleteOpenShiftAssignmentRequestMutationResult = Apollo.MutationResult<DeleteOpenShiftAssignmentRequestMutation>;
export type DeleteOpenShiftAssignmentRequestMutationOptions = Apollo.BaseMutationOptions<DeleteOpenShiftAssignmentRequestMutation, DeleteOpenShiftAssignmentRequestMutationVariables>;
export const MyAbsenceRateReportDocument = gql`
    query MyAbsenceRateReport($filter: AbsenceRateFilter!) {
  reports {
    absenceRate(filter: $filter) {
      ...AbsenceRateReportPayloadFragment
    }
  }
}
    ${AbsenceRateReportPayloadFragmentFragmentDoc}`;

/**
 * __useMyAbsenceRateReportQuery__
 *
 * To run a query within a React component, call `useMyAbsenceRateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAbsenceRateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAbsenceRateReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyAbsenceRateReportQuery(baseOptions: Apollo.QueryHookOptions<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables> & ({ variables: MyAbsenceRateReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables>(MyAbsenceRateReportDocument, options);
      }
export function useMyAbsenceRateReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables>(MyAbsenceRateReportDocument, options);
        }
export function useMyAbsenceRateReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables>(MyAbsenceRateReportDocument, options);
        }
export type MyAbsenceRateReportQueryHookResult = ReturnType<typeof useMyAbsenceRateReportQuery>;
export type MyAbsenceRateReportLazyQueryHookResult = ReturnType<typeof useMyAbsenceRateReportLazyQuery>;
export type MyAbsenceRateReportSuspenseQueryHookResult = ReturnType<typeof useMyAbsenceRateReportSuspenseQuery>;
export type MyAbsenceRateReportQueryResult = Apollo.QueryResult<MyAbsenceRateReportQuery, MyAbsenceRateReportQueryVariables>;
export const MyEmployeeOvertimeReportDocument = gql`
    query MyEmployeeOvertimeReport($filter: OvertimeFilter!) {
  reports {
    employeeOvertime(filter: $filter) {
      ...OvertimeReportPayloadFragment
    }
  }
}
    ${OvertimeReportPayloadFragmentFragmentDoc}`;

/**
 * __useMyEmployeeOvertimeReportQuery__
 *
 * To run a query within a React component, call `useMyEmployeeOvertimeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEmployeeOvertimeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEmployeeOvertimeReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyEmployeeOvertimeReportQuery(baseOptions: Apollo.QueryHookOptions<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables> & ({ variables: MyEmployeeOvertimeReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables>(MyEmployeeOvertimeReportDocument, options);
      }
export function useMyEmployeeOvertimeReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables>(MyEmployeeOvertimeReportDocument, options);
        }
export function useMyEmployeeOvertimeReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables>(MyEmployeeOvertimeReportDocument, options);
        }
export type MyEmployeeOvertimeReportQueryHookResult = ReturnType<typeof useMyEmployeeOvertimeReportQuery>;
export type MyEmployeeOvertimeReportLazyQueryHookResult = ReturnType<typeof useMyEmployeeOvertimeReportLazyQuery>;
export type MyEmployeeOvertimeReportSuspenseQueryHookResult = ReturnType<typeof useMyEmployeeOvertimeReportSuspenseQuery>;
export type MyEmployeeOvertimeReportQueryResult = Apollo.QueryResult<MyEmployeeOvertimeReportQuery, MyEmployeeOvertimeReportQueryVariables>;
export const MyEmployeeTurnoverRateReportDocument = gql`
    query MyEmployeeTurnoverRateReport($filter: EmployeeTurnoverRateFilter!) {
  reports {
    turnoverRate(filter: $filter) {
      ...EmployeeTurnoverRateReportPayloadFragment
    }
  }
}
    ${EmployeeTurnoverRateReportPayloadFragmentFragmentDoc}`;

/**
 * __useMyEmployeeTurnoverRateReportQuery__
 *
 * To run a query within a React component, call `useMyEmployeeTurnoverRateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEmployeeTurnoverRateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEmployeeTurnoverRateReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyEmployeeTurnoverRateReportQuery(baseOptions: Apollo.QueryHookOptions<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables> & ({ variables: MyEmployeeTurnoverRateReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables>(MyEmployeeTurnoverRateReportDocument, options);
      }
export function useMyEmployeeTurnoverRateReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables>(MyEmployeeTurnoverRateReportDocument, options);
        }
export function useMyEmployeeTurnoverRateReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables>(MyEmployeeTurnoverRateReportDocument, options);
        }
export type MyEmployeeTurnoverRateReportQueryHookResult = ReturnType<typeof useMyEmployeeTurnoverRateReportQuery>;
export type MyEmployeeTurnoverRateReportLazyQueryHookResult = ReturnType<typeof useMyEmployeeTurnoverRateReportLazyQuery>;
export type MyEmployeeTurnoverRateReportSuspenseQueryHookResult = ReturnType<typeof useMyEmployeeTurnoverRateReportSuspenseQuery>;
export type MyEmployeeTurnoverRateReportQueryResult = Apollo.QueryResult<MyEmployeeTurnoverRateReportQuery, MyEmployeeTurnoverRateReportQueryVariables>;
export const AllApprovalRequestToMeDocument = gql`
    query AllApprovalRequestToMe {
  me {
    Id
    approvalRequests {
      ...MyApprovalRequestsTableFields
    }
  }
}
    ${MyApprovalRequestsTableFieldsFragmentDoc}`;

/**
 * __useAllApprovalRequestToMeQuery__
 *
 * To run a query within a React component, call `useAllApprovalRequestToMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllApprovalRequestToMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllApprovalRequestToMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllApprovalRequestToMeQuery(baseOptions?: Apollo.QueryHookOptions<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>(AllApprovalRequestToMeDocument, options);
      }
export function useAllApprovalRequestToMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>(AllApprovalRequestToMeDocument, options);
        }
export function useAllApprovalRequestToMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>(AllApprovalRequestToMeDocument, options);
        }
export type AllApprovalRequestToMeQueryHookResult = ReturnType<typeof useAllApprovalRequestToMeQuery>;
export type AllApprovalRequestToMeLazyQueryHookResult = ReturnType<typeof useAllApprovalRequestToMeLazyQuery>;
export type AllApprovalRequestToMeSuspenseQueryHookResult = ReturnType<typeof useAllApprovalRequestToMeSuspenseQuery>;
export type AllApprovalRequestToMeQueryResult = Apollo.QueryResult<AllApprovalRequestToMeQuery, AllApprovalRequestToMeQueryVariables>;
export const ApprovalPathRequestsDocument = gql`
    query ApprovalPathRequests($relatedRecordId: String!) {
  approvalRequests(relatedRecordId: $relatedRecordId) {
    Id
    flair__Approval_Status__c
    CreatedDate
    recordEmployee {
      ...ApprovalPathColleague
    }
    approver {
      ...ApprovalPathColleague
    }
  }
}
    ${ApprovalPathColleagueFragmentDoc}`;

/**
 * __useApprovalPathRequestsQuery__
 *
 * To run a query within a React component, call `useApprovalPathRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalPathRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalPathRequestsQuery({
 *   variables: {
 *      relatedRecordId: // value for 'relatedRecordId'
 *   },
 * });
 */
export function useApprovalPathRequestsQuery(baseOptions: Apollo.QueryHookOptions<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables> & ({ variables: ApprovalPathRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables>(ApprovalPathRequestsDocument, options);
      }
export function useApprovalPathRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables>(ApprovalPathRequestsDocument, options);
        }
export function useApprovalPathRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables>(ApprovalPathRequestsDocument, options);
        }
export type ApprovalPathRequestsQueryHookResult = ReturnType<typeof useApprovalPathRequestsQuery>;
export type ApprovalPathRequestsLazyQueryHookResult = ReturnType<typeof useApprovalPathRequestsLazyQuery>;
export type ApprovalPathRequestsSuspenseQueryHookResult = ReturnType<typeof useApprovalPathRequestsSuspenseQuery>;
export type ApprovalPathRequestsQueryResult = Apollo.QueryResult<ApprovalPathRequestsQuery, ApprovalPathRequestsQueryVariables>;
export const ExpenseByIdDocument = gql`
    query ExpenseById($id: String!) {
  expense(id: $id) {
    ...ExpenseData
  }
}
    ${ExpenseDataFragmentDoc}`;

/**
 * __useExpenseByIdQuery__
 *
 * To run a query within a React component, call `useExpenseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpenseByIdQuery(baseOptions: Apollo.QueryHookOptions<ExpenseByIdQuery, ExpenseByIdQueryVariables> & ({ variables: ExpenseByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseByIdQuery, ExpenseByIdQueryVariables>(ExpenseByIdDocument, options);
      }
export function useExpenseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseByIdQuery, ExpenseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseByIdQuery, ExpenseByIdQueryVariables>(ExpenseByIdDocument, options);
        }
export function useExpenseByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpenseByIdQuery, ExpenseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpenseByIdQuery, ExpenseByIdQueryVariables>(ExpenseByIdDocument, options);
        }
export type ExpenseByIdQueryHookResult = ReturnType<typeof useExpenseByIdQuery>;
export type ExpenseByIdLazyQueryHookResult = ReturnType<typeof useExpenseByIdLazyQuery>;
export type ExpenseByIdSuspenseQueryHookResult = ReturnType<typeof useExpenseByIdSuspenseQuery>;
export type ExpenseByIdQueryResult = Apollo.QueryResult<ExpenseByIdQuery, ExpenseByIdQueryVariables>;
export const ApprovalRequestShiftChangeRequestDocument = gql`
    query ApprovalRequestShiftChangeRequest($shiftChangeRequestId: String!) {
  shiftChangeRequest(id: $shiftChangeRequestId) {
    Id
    proposedResourceEmployee {
      Id
      Name
    }
    flair__Change_Reason__c
    flair__Colleague_Responded_At__c
    shift {
      Id
      flair__Title__c
      flair__Start_Datetime__c
      flair__End_Datetime__c
    }
  }
}
    `;

/**
 * __useApprovalRequestShiftChangeRequestQuery__
 *
 * To run a query within a React component, call `useApprovalRequestShiftChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalRequestShiftChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalRequestShiftChangeRequestQuery({
 *   variables: {
 *      shiftChangeRequestId: // value for 'shiftChangeRequestId'
 *   },
 * });
 */
export function useApprovalRequestShiftChangeRequestQuery(baseOptions: Apollo.QueryHookOptions<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables> & ({ variables: ApprovalRequestShiftChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables>(ApprovalRequestShiftChangeRequestDocument, options);
      }
export function useApprovalRequestShiftChangeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables>(ApprovalRequestShiftChangeRequestDocument, options);
        }
export function useApprovalRequestShiftChangeRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables>(ApprovalRequestShiftChangeRequestDocument, options);
        }
export type ApprovalRequestShiftChangeRequestQueryHookResult = ReturnType<typeof useApprovalRequestShiftChangeRequestQuery>;
export type ApprovalRequestShiftChangeRequestLazyQueryHookResult = ReturnType<typeof useApprovalRequestShiftChangeRequestLazyQuery>;
export type ApprovalRequestShiftChangeRequestSuspenseQueryHookResult = ReturnType<typeof useApprovalRequestShiftChangeRequestSuspenseQuery>;
export type ApprovalRequestShiftChangeRequestQueryResult = Apollo.QueryResult<ApprovalRequestShiftChangeRequestQuery, ApprovalRequestShiftChangeRequestQueryVariables>;
export const PendingApprovalRequestToMeDocument = gql`
    query PendingApprovalRequestToMe {
  me {
    Id
    approvalRequests(filter: {statuses: [PENDING]}) {
      ...MyApprovalRequestsTableFields
    }
  }
}
    ${MyApprovalRequestsTableFieldsFragmentDoc}`;

/**
 * __usePendingApprovalRequestToMeQuery__
 *
 * To run a query within a React component, call `usePendingApprovalRequestToMeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingApprovalRequestToMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingApprovalRequestToMeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingApprovalRequestToMeQuery(baseOptions?: Apollo.QueryHookOptions<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>(PendingApprovalRequestToMeDocument, options);
      }
export function usePendingApprovalRequestToMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>(PendingApprovalRequestToMeDocument, options);
        }
export function usePendingApprovalRequestToMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>(PendingApprovalRequestToMeDocument, options);
        }
export type PendingApprovalRequestToMeQueryHookResult = ReturnType<typeof usePendingApprovalRequestToMeQuery>;
export type PendingApprovalRequestToMeLazyQueryHookResult = ReturnType<typeof usePendingApprovalRequestToMeLazyQuery>;
export type PendingApprovalRequestToMeSuspenseQueryHookResult = ReturnType<typeof usePendingApprovalRequestToMeSuspenseQuery>;
export type PendingApprovalRequestToMeQueryResult = Apollo.QueryResult<PendingApprovalRequestToMeQuery, PendingApprovalRequestToMeQueryVariables>;
export const ApprovalRequestByIdDocument = gql`
    query ApprovalRequestById($id: String!) {
  approvalRequest(id: $id) {
    ...MyApprovalRequestsTableFields
  }
}
    ${MyApprovalRequestsTableFieldsFragmentDoc}`;

/**
 * __useApprovalRequestByIdQuery__
 *
 * To run a query within a React component, call `useApprovalRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables> & ({ variables: ApprovalRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables>(ApprovalRequestByIdDocument, options);
      }
export function useApprovalRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables>(ApprovalRequestByIdDocument, options);
        }
export function useApprovalRequestByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables>(ApprovalRequestByIdDocument, options);
        }
export type ApprovalRequestByIdQueryHookResult = ReturnType<typeof useApprovalRequestByIdQuery>;
export type ApprovalRequestByIdLazyQueryHookResult = ReturnType<typeof useApprovalRequestByIdLazyQuery>;
export type ApprovalRequestByIdSuspenseQueryHookResult = ReturnType<typeof useApprovalRequestByIdSuspenseQuery>;
export type ApprovalRequestByIdQueryResult = Apollo.QueryResult<ApprovalRequestByIdQuery, ApprovalRequestByIdQueryVariables>;
export const ApprovalRequestUpdateStatusDocument = gql`
    mutation ApprovalRequestUpdateStatus($id: String!, $status: ApprovalRequestStatus!, $comment: String, $relatedRecordId: String!) {
  approvalRequest {
    updateApprovalRequestStatus(
      input: {id: $id, status: $status, comment: $comment}
    ) {
      recordId
      record {
        ...MyApprovalRequestsTableFields
      }
      query {
        approvalRequests(relatedRecordId: $relatedRecordId) {
          Id
          flair__Approval_Status__c
        }
      }
    }
  }
}
    ${MyApprovalRequestsTableFieldsFragmentDoc}`;
export type ApprovalRequestUpdateStatusMutationFn = Apollo.MutationFunction<ApprovalRequestUpdateStatusMutation, ApprovalRequestUpdateStatusMutationVariables>;

/**
 * __useApprovalRequestUpdateStatusMutation__
 *
 * To run a mutation, you first call `useApprovalRequestUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalRequestUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalRequestUpdateStatusMutation, { data, loading, error }] = useApprovalRequestUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *      relatedRecordId: // value for 'relatedRecordId'
 *   },
 * });
 */
export function useApprovalRequestUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ApprovalRequestUpdateStatusMutation, ApprovalRequestUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovalRequestUpdateStatusMutation, ApprovalRequestUpdateStatusMutationVariables>(ApprovalRequestUpdateStatusDocument, options);
      }
export type ApprovalRequestUpdateStatusMutationHookResult = ReturnType<typeof useApprovalRequestUpdateStatusMutation>;
export type ApprovalRequestUpdateStatusMutationResult = Apollo.MutationResult<ApprovalRequestUpdateStatusMutation>;
export type ApprovalRequestUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ApprovalRequestUpdateStatusMutation, ApprovalRequestUpdateStatusMutationVariables>;
export const CreateCelebrationDocument = gql`
    mutation createCelebration($input: CreateCelebrationInput!) {
  celebrations {
    createCelebration(input: $input) {
      recordId
      error
      record {
        ...Celebration
      }
    }
  }
}
    ${CelebrationFragmentDoc}`;
export type CreateCelebrationMutationFn = Apollo.MutationFunction<CreateCelebrationMutation, CreateCelebrationMutationVariables>;

/**
 * __useCreateCelebrationMutation__
 *
 * To run a mutation, you first call `useCreateCelebrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCelebrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCelebrationMutation, { data, loading, error }] = useCreateCelebrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCelebrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCelebrationMutation, CreateCelebrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCelebrationMutation, CreateCelebrationMutationVariables>(CreateCelebrationDocument, options);
      }
export type CreateCelebrationMutationHookResult = ReturnType<typeof useCreateCelebrationMutation>;
export type CreateCelebrationMutationResult = Apollo.MutationResult<CreateCelebrationMutation>;
export type CreateCelebrationMutationOptions = Apollo.BaseMutationOptions<CreateCelebrationMutation, CreateCelebrationMutationVariables>;
export const UpdateCelebrationDocument = gql`
    mutation updateCelebration($input: UpdateCelebrationInput!) {
  celebrations {
    updateCelebration(input: $input) {
      recordId
      error
      record {
        ...Celebration
      }
    }
  }
}
    ${CelebrationFragmentDoc}`;
export type UpdateCelebrationMutationFn = Apollo.MutationFunction<UpdateCelebrationMutation, UpdateCelebrationMutationVariables>;

/**
 * __useUpdateCelebrationMutation__
 *
 * To run a mutation, you first call `useUpdateCelebrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCelebrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCelebrationMutation, { data, loading, error }] = useUpdateCelebrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCelebrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCelebrationMutation, UpdateCelebrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCelebrationMutation, UpdateCelebrationMutationVariables>(UpdateCelebrationDocument, options);
      }
export type UpdateCelebrationMutationHookResult = ReturnType<typeof useUpdateCelebrationMutation>;
export type UpdateCelebrationMutationResult = Apollo.MutationResult<UpdateCelebrationMutation>;
export type UpdateCelebrationMutationOptions = Apollo.BaseMutationOptions<UpdateCelebrationMutation, UpdateCelebrationMutationVariables>;
export const DeleteCelebrationDocument = gql`
    mutation deleteCelebration($input: DeleteCelebrationInput!) {
  celebrations {
    deleteCelebration(input: $input) {
      error
      recordId
    }
  }
}
    `;
export type DeleteCelebrationMutationFn = Apollo.MutationFunction<DeleteCelebrationMutation, DeleteCelebrationMutationVariables>;

/**
 * __useDeleteCelebrationMutation__
 *
 * To run a mutation, you first call `useDeleteCelebrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCelebrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCelebrationMutation, { data, loading, error }] = useDeleteCelebrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCelebrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCelebrationMutation, DeleteCelebrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCelebrationMutation, DeleteCelebrationMutationVariables>(DeleteCelebrationDocument, options);
      }
export type DeleteCelebrationMutationHookResult = ReturnType<typeof useDeleteCelebrationMutation>;
export type DeleteCelebrationMutationResult = Apollo.MutationResult<DeleteCelebrationMutation>;
export type DeleteCelebrationMutationOptions = Apollo.BaseMutationOptions<DeleteCelebrationMutation, DeleteCelebrationMutationVariables>;
export const MakeCelebrationPublicDocument = gql`
    mutation makeCelebrationPublic($input: MakeCelebrationPublicInput!) {
  celebrations {
    makeCelebrationPublic(input: $input) {
      error
      recordId
    }
  }
}
    `;
export type MakeCelebrationPublicMutationFn = Apollo.MutationFunction<MakeCelebrationPublicMutation, MakeCelebrationPublicMutationVariables>;

/**
 * __useMakeCelebrationPublicMutation__
 *
 * To run a mutation, you first call `useMakeCelebrationPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCelebrationPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCelebrationPublicMutation, { data, loading, error }] = useMakeCelebrationPublicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeCelebrationPublicMutation(baseOptions?: Apollo.MutationHookOptions<MakeCelebrationPublicMutation, MakeCelebrationPublicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeCelebrationPublicMutation, MakeCelebrationPublicMutationVariables>(MakeCelebrationPublicDocument, options);
      }
export type MakeCelebrationPublicMutationHookResult = ReturnType<typeof useMakeCelebrationPublicMutation>;
export type MakeCelebrationPublicMutationResult = Apollo.MutationResult<MakeCelebrationPublicMutation>;
export type MakeCelebrationPublicMutationOptions = Apollo.BaseMutationOptions<MakeCelebrationPublicMutation, MakeCelebrationPublicMutationVariables>;
export const MarkAsReadDocument = gql`
    mutation markAsRead($ids: [String!]!) {
  celebrations {
    markAsRead(input: {ids: $ids}) {
      error
      records {
        Id
        myEmployeeRecipient {
          flair__Read_Date__c
        }
      }
    }
  }
}
    `;
export type MarkAsReadMutationFn = Apollo.MutationFunction<MarkAsReadMutation, MarkAsReadMutationVariables>;

/**
 * __useMarkAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsReadMutation, { data, loading, error }] = useMarkAsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsReadMutation, MarkAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsReadMutation, MarkAsReadMutationVariables>(MarkAsReadDocument, options);
      }
export type MarkAsReadMutationHookResult = ReturnType<typeof useMarkAsReadMutation>;
export type MarkAsReadMutationResult = Apollo.MutationResult<MarkAsReadMutation>;
export type MarkAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAsReadMutation, MarkAsReadMutationVariables>;
export const CelebrationsDocument = gql`
    query Celebrations($filter: CelebrationFilterInput!, $offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  celebrationsPagination(
    filter: $filter
    pagination: {offset: $offset, limit: $limit}
  ) {
    items {
      ...Celebration
    }
    paginationInfo @skip(if: $skipPaginationInfo) {
      totalCount
    }
  }
}
    ${CelebrationFragmentDoc}`;

/**
 * __useCelebrationsQuery__
 *
 * To run a query within a React component, call `useCelebrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCelebrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCelebrationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useCelebrationsQuery(baseOptions: Apollo.QueryHookOptions<CelebrationsQuery, CelebrationsQueryVariables> & ({ variables: CelebrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CelebrationsQuery, CelebrationsQueryVariables>(CelebrationsDocument, options);
      }
export function useCelebrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CelebrationsQuery, CelebrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CelebrationsQuery, CelebrationsQueryVariables>(CelebrationsDocument, options);
        }
export function useCelebrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CelebrationsQuery, CelebrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CelebrationsQuery, CelebrationsQueryVariables>(CelebrationsDocument, options);
        }
export type CelebrationsQueryHookResult = ReturnType<typeof useCelebrationsQuery>;
export type CelebrationsLazyQueryHookResult = ReturnType<typeof useCelebrationsLazyQuery>;
export type CelebrationsSuspenseQueryHookResult = ReturnType<typeof useCelebrationsSuspenseQuery>;
export type CelebrationsQueryResult = Apollo.QueryResult<CelebrationsQuery, CelebrationsQueryVariables>;
export const CertificateFormDataDocument = gql`
    query CertificateFormData {
  allCertificates {
    Id
    Name
  }
}
    `;

/**
 * __useCertificateFormDataQuery__
 *
 * To run a query within a React component, call `useCertificateFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateFormDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCertificateFormDataQuery(baseOptions?: Apollo.QueryHookOptions<CertificateFormDataQuery, CertificateFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CertificateFormDataQuery, CertificateFormDataQueryVariables>(CertificateFormDataDocument, options);
      }
export function useCertificateFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CertificateFormDataQuery, CertificateFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CertificateFormDataQuery, CertificateFormDataQueryVariables>(CertificateFormDataDocument, options);
        }
export function useCertificateFormDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CertificateFormDataQuery, CertificateFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CertificateFormDataQuery, CertificateFormDataQueryVariables>(CertificateFormDataDocument, options);
        }
export type CertificateFormDataQueryHookResult = ReturnType<typeof useCertificateFormDataQuery>;
export type CertificateFormDataLazyQueryHookResult = ReturnType<typeof useCertificateFormDataLazyQuery>;
export type CertificateFormDataSuspenseQueryHookResult = ReturnType<typeof useCertificateFormDataSuspenseQuery>;
export type CertificateFormDataQueryResult = Apollo.QueryResult<CertificateFormDataQuery, CertificateFormDataQueryVariables>;
export const CreateEmployeeCertificateDocument = gql`
    mutation createEmployeeCertificate($input: CreateEmployeeCertificateInput!) {
  certificates {
    createEmployeeCertificate(input: $input) {
      query {
        me {
          Id
          certificates {
            Id
            Name
            flair__Issue_Date__c
            flair__Expiration_Date__c
            flair__Planned_Date__c
            flair__Issued_By__c
            flair__Certificate__c
            flair__Employee__c
            certificate {
              Id
              Name
            }
          }
        }
        allCertificates {
          Id
          Name
        }
      }
      error
    }
  }
}
    `;
export type CreateEmployeeCertificateMutationFn = Apollo.MutationFunction<CreateEmployeeCertificateMutation, CreateEmployeeCertificateMutationVariables>;

/**
 * __useCreateEmployeeCertificateMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeCertificateMutation, { data, loading, error }] = useCreateEmployeeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeCertificateMutation, CreateEmployeeCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeCertificateMutation, CreateEmployeeCertificateMutationVariables>(CreateEmployeeCertificateDocument, options);
      }
export type CreateEmployeeCertificateMutationHookResult = ReturnType<typeof useCreateEmployeeCertificateMutation>;
export type CreateEmployeeCertificateMutationResult = Apollo.MutationResult<CreateEmployeeCertificateMutation>;
export type CreateEmployeeCertificateMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeCertificateMutation, CreateEmployeeCertificateMutationVariables>;
export const UpdateEmployeeCertificateDocument = gql`
    mutation UpdateEmployeeCertificate($input: UpdateEmployeeCertificateInput!) {
  certificates {
    updateEmployeeCertificate(input: $input) {
      record {
        ...CertificateData
      }
      query {
        allCertificates {
          Id
          Name
        }
      }
      error
    }
  }
}
    ${CertificateDataFragmentDoc}`;
export type UpdateEmployeeCertificateMutationFn = Apollo.MutationFunction<UpdateEmployeeCertificateMutation, UpdateEmployeeCertificateMutationVariables>;

/**
 * __useUpdateEmployeeCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeCertificateMutation, { data, loading, error }] = useUpdateEmployeeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeCertificateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeCertificateMutation, UpdateEmployeeCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeCertificateMutation, UpdateEmployeeCertificateMutationVariables>(UpdateEmployeeCertificateDocument, options);
      }
export type UpdateEmployeeCertificateMutationHookResult = ReturnType<typeof useUpdateEmployeeCertificateMutation>;
export type UpdateEmployeeCertificateMutationResult = Apollo.MutationResult<UpdateEmployeeCertificateMutation>;
export type UpdateEmployeeCertificateMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeCertificateMutation, UpdateEmployeeCertificateMutationVariables>;
export const CertificatesDocument = gql`
    query Certificates {
  me {
    Id
    certificates {
      ...CertificateData
    }
  }
}
    ${CertificateDataFragmentDoc}`;

/**
 * __useCertificatesQuery__
 *
 * To run a query within a React component, call `useCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCertificatesQuery(baseOptions?: Apollo.QueryHookOptions<CertificatesQuery, CertificatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CertificatesQuery, CertificatesQueryVariables>(CertificatesDocument, options);
      }
export function useCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CertificatesQuery, CertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CertificatesQuery, CertificatesQueryVariables>(CertificatesDocument, options);
        }
export function useCertificatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CertificatesQuery, CertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CertificatesQuery, CertificatesQueryVariables>(CertificatesDocument, options);
        }
export type CertificatesQueryHookResult = ReturnType<typeof useCertificatesQuery>;
export type CertificatesLazyQueryHookResult = ReturnType<typeof useCertificatesLazyQuery>;
export type CertificatesSuspenseQueryHookResult = ReturnType<typeof useCertificatesSuspenseQuery>;
export type CertificatesQueryResult = Apollo.QueryResult<CertificatesQuery, CertificatesQueryVariables>;
export const DeleteEmployeeCertificateDocument = gql`
    mutation deleteEmployeeCertificate($id: String!) {
  certificates {
    deleteEmployeeCertificate(id: $id) {
      query {
        me {
          Id
          certificates {
            Id
            Name
            flair__Issue_Date__c
            flair__Expiration_Date__c
            flair__Planned_Date__c
            flair__Issued_By__c
            flair__Certificate__c
            flair__Employee__c
          }
        }
      }
      error
    }
  }
}
    `;
export type DeleteEmployeeCertificateMutationFn = Apollo.MutationFunction<DeleteEmployeeCertificateMutation, DeleteEmployeeCertificateMutationVariables>;

/**
 * __useDeleteEmployeeCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeCertificateMutation, { data, loading, error }] = useDeleteEmployeeCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeCertificateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeCertificateMutation, DeleteEmployeeCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeCertificateMutation, DeleteEmployeeCertificateMutationVariables>(DeleteEmployeeCertificateDocument, options);
      }
export type DeleteEmployeeCertificateMutationHookResult = ReturnType<typeof useDeleteEmployeeCertificateMutation>;
export type DeleteEmployeeCertificateMutationResult = Apollo.MutationResult<DeleteEmployeeCertificateMutation>;
export type DeleteEmployeeCertificateMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeCertificateMutation, DeleteEmployeeCertificateMutationVariables>;
export const DashboardAbsentTodayDocument = gql`
    query DashboardAbsentToday($from: DateTime!, $to: DateTime!, $limit: Int, $filterBy: EmployeeScopeFilter) {
  allAbsences(from: $from, to: $to, filterBy: $filterBy, limit: $limit) {
    ...DashboardAbsentToday_Colleague
  }
}
    ${DashboardAbsentToday_ColleagueFragmentDoc}`;

/**
 * __useDashboardAbsentTodayQuery__
 *
 * To run a query within a React component, call `useDashboardAbsentTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAbsentTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAbsentTodayQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *      filterBy: // value for 'filterBy'
 *   },
 * });
 */
export function useDashboardAbsentTodayQuery(baseOptions: Apollo.QueryHookOptions<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables> & ({ variables: DashboardAbsentTodayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables>(DashboardAbsentTodayDocument, options);
      }
export function useDashboardAbsentTodayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables>(DashboardAbsentTodayDocument, options);
        }
export function useDashboardAbsentTodaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables>(DashboardAbsentTodayDocument, options);
        }
export type DashboardAbsentTodayQueryHookResult = ReturnType<typeof useDashboardAbsentTodayQuery>;
export type DashboardAbsentTodayLazyQueryHookResult = ReturnType<typeof useDashboardAbsentTodayLazyQuery>;
export type DashboardAbsentTodaySuspenseQueryHookResult = ReturnType<typeof useDashboardAbsentTodaySuspenseQuery>;
export type DashboardAbsentTodayQueryResult = Apollo.QueryResult<DashboardAbsentTodayQuery, DashboardAbsentTodayQueryVariables>;
export const DashboardAnniversariesDocument = gql`
    query DashboardAnniversaries($filter: AnniversariesFilter!) {
  anniversaries(filter: $filter) {
    ...DashboardAnniversaries_Colleague
  }
}
    ${DashboardAnniversaries_ColleagueFragmentDoc}`;

/**
 * __useDashboardAnniversariesQuery__
 *
 * To run a query within a React component, call `useDashboardAnniversariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAnniversariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAnniversariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardAnniversariesQuery(baseOptions: Apollo.QueryHookOptions<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables> & ({ variables: DashboardAnniversariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables>(DashboardAnniversariesDocument, options);
      }
export function useDashboardAnniversariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables>(DashboardAnniversariesDocument, options);
        }
export function useDashboardAnniversariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables>(DashboardAnniversariesDocument, options);
        }
export type DashboardAnniversariesQueryHookResult = ReturnType<typeof useDashboardAnniversariesQuery>;
export type DashboardAnniversariesLazyQueryHookResult = ReturnType<typeof useDashboardAnniversariesLazyQuery>;
export type DashboardAnniversariesSuspenseQueryHookResult = ReturnType<typeof useDashboardAnniversariesSuspenseQuery>;
export type DashboardAnniversariesQueryResult = Apollo.QueryResult<DashboardAnniversariesQuery, DashboardAnniversariesQueryVariables>;
export const DashboardBirthdayColleaguesDocument = gql`
    query DashboardBirthdayColleagues($filter: BirthdaysFilter!) {
  me {
    Id
    birthdaysColleagues(filter: $filter) {
      ...DashboardBirthdayColleagueFields
    }
  }
}
    ${DashboardBirthdayColleagueFieldsFragmentDoc}`;

/**
 * __useDashboardBirthdayColleaguesQuery__
 *
 * To run a query within a React component, call `useDashboardBirthdayColleaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardBirthdayColleaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardBirthdayColleaguesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardBirthdayColleaguesQuery(baseOptions: Apollo.QueryHookOptions<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables> & ({ variables: DashboardBirthdayColleaguesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables>(DashboardBirthdayColleaguesDocument, options);
      }
export function useDashboardBirthdayColleaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables>(DashboardBirthdayColleaguesDocument, options);
        }
export function useDashboardBirthdayColleaguesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables>(DashboardBirthdayColleaguesDocument, options);
        }
export type DashboardBirthdayColleaguesQueryHookResult = ReturnType<typeof useDashboardBirthdayColleaguesQuery>;
export type DashboardBirthdayColleaguesLazyQueryHookResult = ReturnType<typeof useDashboardBirthdayColleaguesLazyQuery>;
export type DashboardBirthdayColleaguesSuspenseQueryHookResult = ReturnType<typeof useDashboardBirthdayColleaguesSuspenseQuery>;
export type DashboardBirthdayColleaguesQueryResult = Apollo.QueryResult<DashboardBirthdayColleaguesQuery, DashboardBirthdayColleaguesQueryVariables>;
export const DashboardCompensatoryTimeDocument = gql`
    query DashboardCompensatoryTime {
  me {
    Id
    absenceCategories {
      Id
      category {
        Id
        Name
        flair__Compensatory_Time__c
        flair__Type__c
      }
      allowancesSummary {
        availableAmount
      }
    }
  }
}
    `;

/**
 * __useDashboardCompensatoryTimeQuery__
 *
 * To run a query within a React component, call `useDashboardCompensatoryTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCompensatoryTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCompensatoryTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardCompensatoryTimeQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>(DashboardCompensatoryTimeDocument, options);
      }
export function useDashboardCompensatoryTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>(DashboardCompensatoryTimeDocument, options);
        }
export function useDashboardCompensatoryTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>(DashboardCompensatoryTimeDocument, options);
        }
export type DashboardCompensatoryTimeQueryHookResult = ReturnType<typeof useDashboardCompensatoryTimeQuery>;
export type DashboardCompensatoryTimeLazyQueryHookResult = ReturnType<typeof useDashboardCompensatoryTimeLazyQuery>;
export type DashboardCompensatoryTimeSuspenseQueryHookResult = ReturnType<typeof useDashboardCompensatoryTimeSuspenseQuery>;
export type DashboardCompensatoryTimeQueryResult = Apollo.QueryResult<DashboardCompensatoryTimeQuery, DashboardCompensatoryTimeQueryVariables>;
export const DashboardEndOfProbationDocument = gql`
    query DashboardEndOfProbation($filter: ProbationsFilter!) {
  probations(filter: $filter) {
    ...DashboardEndOfProbation_Colleague
  }
}
    ${DashboardEndOfProbation_ColleagueFragmentDoc}`;

/**
 * __useDashboardEndOfProbationQuery__
 *
 * To run a query within a React component, call `useDashboardEndOfProbationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardEndOfProbationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardEndOfProbationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardEndOfProbationQuery(baseOptions: Apollo.QueryHookOptions<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables> & ({ variables: DashboardEndOfProbationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables>(DashboardEndOfProbationDocument, options);
      }
export function useDashboardEndOfProbationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables>(DashboardEndOfProbationDocument, options);
        }
export function useDashboardEndOfProbationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables>(DashboardEndOfProbationDocument, options);
        }
export type DashboardEndOfProbationQueryHookResult = ReturnType<typeof useDashboardEndOfProbationQuery>;
export type DashboardEndOfProbationLazyQueryHookResult = ReturnType<typeof useDashboardEndOfProbationLazyQuery>;
export type DashboardEndOfProbationSuspenseQueryHookResult = ReturnType<typeof useDashboardEndOfProbationSuspenseQuery>;
export type DashboardEndOfProbationQueryResult = Apollo.QueryResult<DashboardEndOfProbationQuery, DashboardEndOfProbationQueryVariables>;
export const DashboardLastUpdatesDocument = gql`
    query DashboardLastUpdates($filter: LastUpdateFilter!, $paginationInfo: LastUpdatePaginationInfo!) {
  lastUpdates(filter: $filter, paginationInfo: $paginationInfo) {
    offset {
      announcementOffset
      celebrationOffset
      newHiresOffset
    }
    data {
      ...Announcement
      ...Celebration
      ...DashboardLastUpdate_Colleague
    }
  }
}
    ${AnnouncementFragmentDoc}
${CelebrationFragmentDoc}
${DashboardLastUpdate_ColleagueFragmentDoc}`;

/**
 * __useDashboardLastUpdatesQuery__
 *
 * To run a query within a React component, call `useDashboardLastUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardLastUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardLastUpdatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paginationInfo: // value for 'paginationInfo'
 *   },
 * });
 */
export function useDashboardLastUpdatesQuery(baseOptions: Apollo.QueryHookOptions<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables> & ({ variables: DashboardLastUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables>(DashboardLastUpdatesDocument, options);
      }
export function useDashboardLastUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables>(DashboardLastUpdatesDocument, options);
        }
export function useDashboardLastUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables>(DashboardLastUpdatesDocument, options);
        }
export type DashboardLastUpdatesQueryHookResult = ReturnType<typeof useDashboardLastUpdatesQuery>;
export type DashboardLastUpdatesLazyQueryHookResult = ReturnType<typeof useDashboardLastUpdatesLazyQuery>;
export type DashboardLastUpdatesSuspenseQueryHookResult = ReturnType<typeof useDashboardLastUpdatesSuspenseQuery>;
export type DashboardLastUpdatesQueryResult = Apollo.QueryResult<DashboardLastUpdatesQuery, DashboardLastUpdatesQueryVariables>;
export const ProfileWidgetAbsenceCategoriesDocument = gql`
    query ProfileWidgetAbsenceCategories {
  me {
    Id
    absenceCategories {
      ...Dashboard_AbsenceCategory
    }
  }
}
    ${Dashboard_AbsenceCategoryFragmentDoc}`;

/**
 * __useProfileWidgetAbsenceCategoriesQuery__
 *
 * To run a query within a React component, call `useProfileWidgetAbsenceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileWidgetAbsenceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileWidgetAbsenceCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileWidgetAbsenceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>(ProfileWidgetAbsenceCategoriesDocument, options);
      }
export function useProfileWidgetAbsenceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>(ProfileWidgetAbsenceCategoriesDocument, options);
        }
export function useProfileWidgetAbsenceCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>(ProfileWidgetAbsenceCategoriesDocument, options);
        }
export type ProfileWidgetAbsenceCategoriesQueryHookResult = ReturnType<typeof useProfileWidgetAbsenceCategoriesQuery>;
export type ProfileWidgetAbsenceCategoriesLazyQueryHookResult = ReturnType<typeof useProfileWidgetAbsenceCategoriesLazyQuery>;
export type ProfileWidgetAbsenceCategoriesSuspenseQueryHookResult = ReturnType<typeof useProfileWidgetAbsenceCategoriesSuspenseQuery>;
export type ProfileWidgetAbsenceCategoriesQueryResult = Apollo.QueryResult<ProfileWidgetAbsenceCategoriesQuery, ProfileWidgetAbsenceCategoriesQueryVariables>;
export const DocumentCategoriesDocument = gql`
    query DocumentCategories {
  documentCategories {
    Id
    Name
  }
}
    `;

/**
 * __useDocumentCategoriesQuery__
 *
 * To run a query within a React component, call `useDocumentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>(DocumentCategoriesDocument, options);
      }
export function useDocumentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>(DocumentCategoriesDocument, options);
        }
export function useDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>(DocumentCategoriesDocument, options);
        }
export type DocumentCategoriesQueryHookResult = ReturnType<typeof useDocumentCategoriesQuery>;
export type DocumentCategoriesLazyQueryHookResult = ReturnType<typeof useDocumentCategoriesLazyQuery>;
export type DocumentCategoriesSuspenseQueryHookResult = ReturnType<typeof useDocumentCategoriesSuspenseQuery>;
export type DocumentCategoriesQueryResult = Apollo.QueryResult<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>;
export const DashboardHolidaysDocument = gql`
    query DashboardHolidays {
  me {
    Id
    upcomingHolidays {
      ...LocationHoliday
    }
    upcomingCalendarPeriods {
      Id
      Name
      flair__Start_Date__c
    }
  }
}
    ${LocationHolidayFragmentDoc}`;

/**
 * __useDashboardHolidaysQuery__
 *
 * To run a query within a React component, call `useDashboardHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardHolidaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardHolidaysQuery(baseOptions?: Apollo.QueryHookOptions<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>(DashboardHolidaysDocument, options);
      }
export function useDashboardHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>(DashboardHolidaysDocument, options);
        }
export function useDashboardHolidaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>(DashboardHolidaysDocument, options);
        }
export type DashboardHolidaysQueryHookResult = ReturnType<typeof useDashboardHolidaysQuery>;
export type DashboardHolidaysLazyQueryHookResult = ReturnType<typeof useDashboardHolidaysLazyQuery>;
export type DashboardHolidaysSuspenseQueryHookResult = ReturnType<typeof useDashboardHolidaysSuspenseQuery>;
export type DashboardHolidaysQueryResult = Apollo.QueryResult<DashboardHolidaysQuery, DashboardHolidaysQueryVariables>;
export const DashboardUpcomingAbsencesDocument = gql`
    query DashboardUpcomingAbsences($limit: Int!) {
  me {
    Id
    upcomingAbsences(limit: $limit) {
      ...Dashboard_UpcomingAbsences
    }
    absenceCategories {
      ...Dashboard_AbsenceCategory
    }
  }
}
    ${Dashboard_UpcomingAbsencesFragmentDoc}
${Dashboard_AbsenceCategoryFragmentDoc}`;

/**
 * __useDashboardUpcomingAbsencesQuery__
 *
 * To run a query within a React component, call `useDashboardUpcomingAbsencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUpcomingAbsencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUpcomingAbsencesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDashboardUpcomingAbsencesQuery(baseOptions: Apollo.QueryHookOptions<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables> & ({ variables: DashboardUpcomingAbsencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables>(DashboardUpcomingAbsencesDocument, options);
      }
export function useDashboardUpcomingAbsencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables>(DashboardUpcomingAbsencesDocument, options);
        }
export function useDashboardUpcomingAbsencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables>(DashboardUpcomingAbsencesDocument, options);
        }
export type DashboardUpcomingAbsencesQueryHookResult = ReturnType<typeof useDashboardUpcomingAbsencesQuery>;
export type DashboardUpcomingAbsencesLazyQueryHookResult = ReturnType<typeof useDashboardUpcomingAbsencesLazyQuery>;
export type DashboardUpcomingAbsencesSuspenseQueryHookResult = ReturnType<typeof useDashboardUpcomingAbsencesSuspenseQuery>;
export type DashboardUpcomingAbsencesQueryResult = Apollo.QueryResult<DashboardUpcomingAbsencesQuery, DashboardUpcomingAbsencesQueryVariables>;
export const CommentDeepLinkInfoDocument = gql`
    query commentDeepLinkInfo($commentId: String!) {
  comment(commentId: $commentId) {
    ...CommentWithDeepLinkData
  }
}
    ${CommentWithDeepLinkDataFragmentDoc}`;

/**
 * __useCommentDeepLinkInfoQuery__
 *
 * To run a query within a React component, call `useCommentDeepLinkInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentDeepLinkInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentDeepLinkInfoQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useCommentDeepLinkInfoQuery(baseOptions: Apollo.QueryHookOptions<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables> & ({ variables: CommentDeepLinkInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables>(CommentDeepLinkInfoDocument, options);
      }
export function useCommentDeepLinkInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables>(CommentDeepLinkInfoDocument, options);
        }
export function useCommentDeepLinkInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables>(CommentDeepLinkInfoDocument, options);
        }
export type CommentDeepLinkInfoQueryHookResult = ReturnType<typeof useCommentDeepLinkInfoQuery>;
export type CommentDeepLinkInfoLazyQueryHookResult = ReturnType<typeof useCommentDeepLinkInfoLazyQuery>;
export type CommentDeepLinkInfoSuspenseQueryHookResult = ReturnType<typeof useCommentDeepLinkInfoSuspenseQuery>;
export type CommentDeepLinkInfoQueryResult = Apollo.QueryResult<CommentDeepLinkInfoQuery, CommentDeepLinkInfoQueryVariables>;
export const CreateDocumentFolderDocument = gql`
    mutation createDocumentFolder($employeeId: String!, $input: EmployeeDocumentFolderCreateInput!) {
  document {
    createFolder(employeeId: $employeeId, input: $input) {
      recordId
      record {
        Id
        parentFolder {
          Id
          children {
            ...Navigatable
          }
        }
      }
      errorCode
    }
  }
}
    ${NavigatableFragmentDoc}`;
export type CreateDocumentFolderMutationFn = Apollo.MutationFunction<CreateDocumentFolderMutation, CreateDocumentFolderMutationVariables>;

/**
 * __useCreateDocumentFolderMutation__
 *
 * To run a mutation, you first call `useCreateDocumentFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentFolderMutation, { data, loading, error }] = useCreateDocumentFolderMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentFolderMutation, CreateDocumentFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentFolderMutation, CreateDocumentFolderMutationVariables>(CreateDocumentFolderDocument, options);
      }
export type CreateDocumentFolderMutationHookResult = ReturnType<typeof useCreateDocumentFolderMutation>;
export type CreateDocumentFolderMutationResult = Apollo.MutationResult<CreateDocumentFolderMutation>;
export type CreateDocumentFolderMutationOptions = Apollo.BaseMutationOptions<CreateDocumentFolderMutation, CreateDocumentFolderMutationVariables>;
export const PersonalDocumentsFoldersDocument = gql`
    query PersonalDocumentsFolders($folderId: String!, $employeeId: String!) {
  navigatable(
    navigatableId: {id: $folderId, type: EMPLOYEE_DOCUMENT_FOLDER}
    employeeId: $employeeId
  ) {
    Id
    children {
      Id
      ... on EmployeeDocumentFolder {
        ...PersonalDocumentFolderData
      }
    }
    parents {
      Id
      Name
    }
    Name
    fullPath
    parentFolderId
  }
}
    ${PersonalDocumentFolderDataFragmentDoc}`;

/**
 * __usePersonalDocumentsFoldersQuery__
 *
 * To run a query within a React component, call `usePersonalDocumentsFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalDocumentsFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalDocumentsFoldersQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function usePersonalDocumentsFoldersQuery(baseOptions: Apollo.QueryHookOptions<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables> & ({ variables: PersonalDocumentsFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables>(PersonalDocumentsFoldersDocument, options);
      }
export function usePersonalDocumentsFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables>(PersonalDocumentsFoldersDocument, options);
        }
export function usePersonalDocumentsFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables>(PersonalDocumentsFoldersDocument, options);
        }
export type PersonalDocumentsFoldersQueryHookResult = ReturnType<typeof usePersonalDocumentsFoldersQuery>;
export type PersonalDocumentsFoldersLazyQueryHookResult = ReturnType<typeof usePersonalDocumentsFoldersLazyQuery>;
export type PersonalDocumentsFoldersSuspenseQueryHookResult = ReturnType<typeof usePersonalDocumentsFoldersSuspenseQuery>;
export type PersonalDocumentsFoldersQueryResult = Apollo.QueryResult<PersonalDocumentsFoldersQuery, PersonalDocumentsFoldersQueryVariables>;
export const RenameDocumentDocument = gql`
    mutation renameDocument($employeeId: String!, $input: NavigatableRenameInput!) {
  document {
    rename(employeeId: $employeeId, input: $input) {
      record {
        Id
        Name
      }
      errorCode
    }
  }
}
    `;
export type RenameDocumentMutationFn = Apollo.MutationFunction<RenameDocumentMutation, RenameDocumentMutationVariables>;

/**
 * __useRenameDocumentMutation__
 *
 * To run a mutation, you first call `useRenameDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameDocumentMutation, { data, loading, error }] = useRenameDocumentMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RenameDocumentMutation, RenameDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameDocumentMutation, RenameDocumentMutationVariables>(RenameDocumentDocument, options);
      }
export type RenameDocumentMutationHookResult = ReturnType<typeof useRenameDocumentMutation>;
export type RenameDocumentMutationResult = Apollo.MutationResult<RenameDocumentMutation>;
export type RenameDocumentMutationOptions = Apollo.BaseMutationOptions<RenameDocumentMutation, RenameDocumentMutationVariables>;
export const UploadEmployeeDocumentDocument = gql`
    mutation UploadEmployeeDocument($employeeId: String!, $input: UploadEmployeeDocumentInput!) {
  document {
    uploadDocument(employeeId: $employeeId, input: $input) {
      recordId
      record {
        Id
        Name
      }
    }
  }
}
    `;
export type UploadEmployeeDocumentMutationFn = Apollo.MutationFunction<UploadEmployeeDocumentMutation, UploadEmployeeDocumentMutationVariables>;

/**
 * __useUploadEmployeeDocumentMutation__
 *
 * To run a mutation, you first call `useUploadEmployeeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEmployeeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEmployeeDocumentMutation, { data, loading, error }] = useUploadEmployeeDocumentMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEmployeeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadEmployeeDocumentMutation, UploadEmployeeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEmployeeDocumentMutation, UploadEmployeeDocumentMutationVariables>(UploadEmployeeDocumentDocument, options);
      }
export type UploadEmployeeDocumentMutationHookResult = ReturnType<typeof useUploadEmployeeDocumentMutation>;
export type UploadEmployeeDocumentMutationResult = Apollo.MutationResult<UploadEmployeeDocumentMutation>;
export type UploadEmployeeDocumentMutationOptions = Apollo.BaseMutationOptions<UploadEmployeeDocumentMutation, UploadEmployeeDocumentMutationVariables>;
export const CorporateDocumentsFilterDocument = gql`
    query CorporateDocumentsFilter {
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __useCorporateDocumentsFilterQuery__
 *
 * To run a query within a React component, call `useCorporateDocumentsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporateDocumentsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorporateDocumentsFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useCorporateDocumentsFilterQuery(baseOptions?: Apollo.QueryHookOptions<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>(CorporateDocumentsFilterDocument, options);
      }
export function useCorporateDocumentsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>(CorporateDocumentsFilterDocument, options);
        }
export function useCorporateDocumentsFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>(CorporateDocumentsFilterDocument, options);
        }
export type CorporateDocumentsFilterQueryHookResult = ReturnType<typeof useCorporateDocumentsFilterQuery>;
export type CorporateDocumentsFilterLazyQueryHookResult = ReturnType<typeof useCorporateDocumentsFilterLazyQuery>;
export type CorporateDocumentsFilterSuspenseQueryHookResult = ReturnType<typeof useCorporateDocumentsFilterSuspenseQuery>;
export type CorporateDocumentsFilterQueryResult = Apollo.QueryResult<CorporateDocumentsFilterQuery, CorporateDocumentsFilterQueryVariables>;
export const PersonalDocumentsFilterDocument = gql`
    query PersonalDocumentsFilter {
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
  documentCategories {
    Id
    Name
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __usePersonalDocumentsFilterQuery__
 *
 * To run a query within a React component, call `usePersonalDocumentsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalDocumentsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalDocumentsFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalDocumentsFilterQuery(baseOptions?: Apollo.QueryHookOptions<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>(PersonalDocumentsFilterDocument, options);
      }
export function usePersonalDocumentsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>(PersonalDocumentsFilterDocument, options);
        }
export function usePersonalDocumentsFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>(PersonalDocumentsFilterDocument, options);
        }
export type PersonalDocumentsFilterQueryHookResult = ReturnType<typeof usePersonalDocumentsFilterQuery>;
export type PersonalDocumentsFilterLazyQueryHookResult = ReturnType<typeof usePersonalDocumentsFilterLazyQuery>;
export type PersonalDocumentsFilterSuspenseQueryHookResult = ReturnType<typeof usePersonalDocumentsFilterSuspenseQuery>;
export type PersonalDocumentsFilterQueryResult = Apollo.QueryResult<PersonalDocumentsFilterQuery, PersonalDocumentsFilterQueryVariables>;
export const CorporateDocumentsDocument = gql`
    query CorporateDocuments {
  companyDocuments {
    ...CorporateDocumentData
  }
}
    ${CorporateDocumentDataFragmentDoc}`;

/**
 * __useCorporateDocumentsQuery__
 *
 * To run a query within a React component, call `useCorporateDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporateDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorporateDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCorporateDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>(CorporateDocumentsDocument, options);
      }
export function useCorporateDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>(CorporateDocumentsDocument, options);
        }
export function useCorporateDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>(CorporateDocumentsDocument, options);
        }
export type CorporateDocumentsQueryHookResult = ReturnType<typeof useCorporateDocumentsQuery>;
export type CorporateDocumentsLazyQueryHookResult = ReturnType<typeof useCorporateDocumentsLazyQuery>;
export type CorporateDocumentsSuspenseQueryHookResult = ReturnType<typeof useCorporateDocumentsSuspenseQuery>;
export type CorporateDocumentsQueryResult = Apollo.QueryResult<CorporateDocumentsQuery, CorporateDocumentsQueryVariables>;
export const PersonalDocumentsDocument = gql`
    query PersonalDocuments($folderId: String!, $employeeId: String!) {
  navigatable(
    navigatableId: {id: $folderId, type: EMPLOYEE_DOCUMENT_FOLDER}
    employeeId: $employeeId
  ) {
    Id
    children {
      ...Navigatable
    }
    parents {
      Id
      Name
    }
    Name
    fullPath
    parentFolderId
  }
}
    ${NavigatableFragmentDoc}`;

/**
 * __usePersonalDocumentsQuery__
 *
 * To run a query within a React component, call `usePersonalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalDocumentsQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function usePersonalDocumentsQuery(baseOptions: Apollo.QueryHookOptions<PersonalDocumentsQuery, PersonalDocumentsQueryVariables> & ({ variables: PersonalDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalDocumentsQuery, PersonalDocumentsQueryVariables>(PersonalDocumentsDocument, options);
      }
export function usePersonalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalDocumentsQuery, PersonalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalDocumentsQuery, PersonalDocumentsQueryVariables>(PersonalDocumentsDocument, options);
        }
export function usePersonalDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalDocumentsQuery, PersonalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalDocumentsQuery, PersonalDocumentsQueryVariables>(PersonalDocumentsDocument, options);
        }
export type PersonalDocumentsQueryHookResult = ReturnType<typeof usePersonalDocumentsQuery>;
export type PersonalDocumentsLazyQueryHookResult = ReturnType<typeof usePersonalDocumentsLazyQuery>;
export type PersonalDocumentsSuspenseQueryHookResult = ReturnType<typeof usePersonalDocumentsSuspenseQuery>;
export type PersonalDocumentsQueryResult = Apollo.QueryResult<PersonalDocumentsQuery, PersonalDocumentsQueryVariables>;
export const UpdateDocumentStatusDocument = gql`
    mutation updateDocumentStatus($employeeId: String!, $input: NavigatableUpdateStatusInput!) {
  document {
    updateStatus(employeeId: $employeeId, input: $input) {
      record {
        Id
        flair__Approval_Status__c
        approvalRequest {
          Id
          flair__Approval_Status__c
        }
      }
    }
  }
}
    `;
export type UpdateDocumentStatusMutationFn = Apollo.MutationFunction<UpdateDocumentStatusMutation, UpdateDocumentStatusMutationVariables>;

/**
 * __useUpdateDocumentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentStatusMutation, { data, loading, error }] = useUpdateDocumentStatusMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentStatusMutation, UpdateDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentStatusMutation, UpdateDocumentStatusMutationVariables>(UpdateDocumentStatusDocument, options);
      }
export type UpdateDocumentStatusMutationHookResult = ReturnType<typeof useUpdateDocumentStatusMutation>;
export type UpdateDocumentStatusMutationResult = Apollo.MutationResult<UpdateDocumentStatusMutation>;
export type UpdateDocumentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentStatusMutation, UpdateDocumentStatusMutationVariables>;
export const UpdatePersonalDocumentDocument = gql`
    mutation updatePersonalDocument($employeeId: String!, $input: EmployeeDocumentUpdateInput!) {
  document {
    updateEmployeeDocument(employeeId: $employeeId, input: $input) {
      record {
        Id
        flair__Note__c
        flair__Document_Category__c
        documentCategory {
          ...DocumentCategoryData
        }
      }
    }
  }
}
    ${DocumentCategoryDataFragmentDoc}`;
export type UpdatePersonalDocumentMutationFn = Apollo.MutationFunction<UpdatePersonalDocumentMutation, UpdatePersonalDocumentMutationVariables>;

/**
 * __useUpdatePersonalDocumentMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalDocumentMutation, { data, loading, error }] = useUpdatePersonalDocumentMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalDocumentMutation, UpdatePersonalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalDocumentMutation, UpdatePersonalDocumentMutationVariables>(UpdatePersonalDocumentDocument, options);
      }
export type UpdatePersonalDocumentMutationHookResult = ReturnType<typeof useUpdatePersonalDocumentMutation>;
export type UpdatePersonalDocumentMutationResult = Apollo.MutationResult<UpdatePersonalDocumentMutation>;
export type UpdatePersonalDocumentMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalDocumentMutation, UpdatePersonalDocumentMutationVariables>;
export const UploadPersonalDocumentDocument = gql`
    mutation uploadPersonalDocument($input: UploadEmployeeDocumentInput!) {
  document {
    uploadEmployeeDocument(input: $input)
  }
}
    `;
export type UploadPersonalDocumentMutationFn = Apollo.MutationFunction<UploadPersonalDocumentMutation, UploadPersonalDocumentMutationVariables>;

/**
 * __useUploadPersonalDocumentMutation__
 *
 * To run a mutation, you first call `useUploadPersonalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPersonalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPersonalDocumentMutation, { data, loading, error }] = useUploadPersonalDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadPersonalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadPersonalDocumentMutation, UploadPersonalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPersonalDocumentMutation, UploadPersonalDocumentMutationVariables>(UploadPersonalDocumentDocument, options);
      }
export type UploadPersonalDocumentMutationHookResult = ReturnType<typeof useUploadPersonalDocumentMutation>;
export type UploadPersonalDocumentMutationResult = Apollo.MutationResult<UploadPersonalDocumentMutation>;
export type UploadPersonalDocumentMutationOptions = Apollo.BaseMutationOptions<UploadPersonalDocumentMutation, UploadPersonalDocumentMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($employeeId: String!, $navigatableIds: [NavigatableIdInput!]!, $recursive: Boolean) {
  document {
    delete(
      employeeId: $employeeId
      navigatableIds: $navigatableIds
      recursive: $recursive
    ) {
      recordIds {
        id
      }
      errorCode
    }
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      navigatableIds: // value for 'navigatableIds'
 *      recursive: // value for 'recursive'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const MoveDocumentsToDocument = gql`
    mutation moveDocumentsTo($employeeId: String!, $navigatableIds: [NavigatableIdInput!]!, $moveTo: MoveToFolderInput!) {
  document {
    move(employeeId: $employeeId, navigatableIds: $navigatableIds, moveTo: $moveTo) {
      errorCode
      sourceFolders {
        Id
        children {
          ...Navigatable
        }
      }
      targetFolder {
        Id
        children {
          ...Navigatable
        }
      }
    }
  }
}
    ${NavigatableFragmentDoc}`;
export type MoveDocumentsToMutationFn = Apollo.MutationFunction<MoveDocumentsToMutation, MoveDocumentsToMutationVariables>;

/**
 * __useMoveDocumentsToMutation__
 *
 * To run a mutation, you first call `useMoveDocumentsToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveDocumentsToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveDocumentsToMutation, { data, loading, error }] = useMoveDocumentsToMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      navigatableIds: // value for 'navigatableIds'
 *      moveTo: // value for 'moveTo'
 *   },
 * });
 */
export function useMoveDocumentsToMutation(baseOptions?: Apollo.MutationHookOptions<MoveDocumentsToMutation, MoveDocumentsToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveDocumentsToMutation, MoveDocumentsToMutationVariables>(MoveDocumentsToDocument, options);
      }
export type MoveDocumentsToMutationHookResult = ReturnType<typeof useMoveDocumentsToMutation>;
export type MoveDocumentsToMutationResult = Apollo.MutationResult<MoveDocumentsToMutation>;
export type MoveDocumentsToMutationOptions = Apollo.BaseMutationOptions<MoveDocumentsToMutation, MoveDocumentsToMutationVariables>;
export const EditPersonalDataDocument = gql`
    query EditPersonalData {
  me {
    Id
    data {
      ...MyEmployeeData
    }
  }
}
    ${MyEmployeeDataFragmentDoc}`;

/**
 * __useEditPersonalDataQuery__
 *
 * To run a query within a React component, call `useEditPersonalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditPersonalDataQuery(baseOptions?: Apollo.QueryHookOptions<EditPersonalDataQuery, EditPersonalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditPersonalDataQuery, EditPersonalDataQueryVariables>(EditPersonalDataDocument, options);
      }
export function useEditPersonalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditPersonalDataQuery, EditPersonalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditPersonalDataQuery, EditPersonalDataQueryVariables>(EditPersonalDataDocument, options);
        }
export function useEditPersonalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditPersonalDataQuery, EditPersonalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditPersonalDataQuery, EditPersonalDataQueryVariables>(EditPersonalDataDocument, options);
        }
export type EditPersonalDataQueryHookResult = ReturnType<typeof useEditPersonalDataQuery>;
export type EditPersonalDataLazyQueryHookResult = ReturnType<typeof useEditPersonalDataLazyQuery>;
export type EditPersonalDataSuspenseQueryHookResult = ReturnType<typeof useEditPersonalDataSuspenseQuery>;
export type EditPersonalDataQueryResult = Apollo.QueryResult<EditPersonalDataQuery, EditPersonalDataQueryVariables>;
export const UpdateMyDataDocument = gql`
    mutation UpdateMyData($input: UpdateFieldsInput!) {
  employeeData {
    updateMyFields(input: $input) {
      record {
        ...MyEmployeeData
      }
    }
  }
}
    ${MyEmployeeDataFragmentDoc}`;
export type UpdateMyDataMutationFn = Apollo.MutationFunction<UpdateMyDataMutation, UpdateMyDataMutationVariables>;

/**
 * __useUpdateMyDataMutation__
 *
 * To run a mutation, you first call `useUpdateMyDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyDataMutation, { data, loading, error }] = useUpdateMyDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyDataMutation, UpdateMyDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyDataMutation, UpdateMyDataMutationVariables>(UpdateMyDataDocument, options);
      }
export type UpdateMyDataMutationHookResult = ReturnType<typeof useUpdateMyDataMutation>;
export type UpdateMyDataMutationResult = Apollo.MutationResult<UpdateMyDataMutation>;
export type UpdateMyDataMutationOptions = Apollo.BaseMutationOptions<UpdateMyDataMutation, UpdateMyDataMutationVariables>;
export const UpdateMyLanguageDocument = gql`
    mutation UpdateMyLanguage($language: String!) {
  employeeData {
    updateMyLanguage(language: $language) {
      query {
        me {
          Id
          flair__Employee_Language__c
        }
      }
    }
  }
}
    `;
export type UpdateMyLanguageMutationFn = Apollo.MutationFunction<UpdateMyLanguageMutation, UpdateMyLanguageMutationVariables>;

/**
 * __useUpdateMyLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateMyLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyLanguageMutation, { data, loading, error }] = useUpdateMyLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateMyLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyLanguageMutation, UpdateMyLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyLanguageMutation, UpdateMyLanguageMutationVariables>(UpdateMyLanguageDocument, options);
      }
export type UpdateMyLanguageMutationHookResult = ReturnType<typeof useUpdateMyLanguageMutation>;
export type UpdateMyLanguageMutationResult = Apollo.MutationResult<UpdateMyLanguageMutation>;
export type UpdateMyLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateMyLanguageMutation, UpdateMyLanguageMutationVariables>;
export const UpdateMyBirthdayDocument = gql`
    mutation UpdateMyBirthday($hideMyBirthday: Boolean!) {
  employeeData {
    updateMyBirthday(hideMyBirthday: $hideMyBirthday) {
      query {
        me {
          Id
          flair__Hide_My_Birthday__c
        }
      }
    }
  }
}
    `;
export type UpdateMyBirthdayMutationFn = Apollo.MutationFunction<UpdateMyBirthdayMutation, UpdateMyBirthdayMutationVariables>;

/**
 * __useUpdateMyBirthdayMutation__
 *
 * To run a mutation, you first call `useUpdateMyBirthdayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyBirthdayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyBirthdayMutation, { data, loading, error }] = useUpdateMyBirthdayMutation({
 *   variables: {
 *      hideMyBirthday: // value for 'hideMyBirthday'
 *   },
 * });
 */
export function useUpdateMyBirthdayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyBirthdayMutation, UpdateMyBirthdayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyBirthdayMutation, UpdateMyBirthdayMutationVariables>(UpdateMyBirthdayDocument, options);
      }
export type UpdateMyBirthdayMutationHookResult = ReturnType<typeof useUpdateMyBirthdayMutation>;
export type UpdateMyBirthdayMutationResult = Apollo.MutationResult<UpdateMyBirthdayMutation>;
export type UpdateMyBirthdayMutationOptions = Apollo.BaseMutationOptions<UpdateMyBirthdayMutation, UpdateMyBirthdayMutationVariables>;
export const EmployeeEvaluationDocument = gql`
    query EmployeeEvaluation($id: String!) {
  employeeEvaluationById(id: $id) {
    ...EmployeeEvaluationFragment
  }
}
    ${EmployeeEvaluationFragmentFragmentDoc}`;

/**
 * __useEmployeeEvaluationQuery__
 *
 * To run a query within a React component, call `useEmployeeEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeEvaluationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeEvaluationQuery(baseOptions: Apollo.QueryHookOptions<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables> & ({ variables: EmployeeEvaluationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables>(EmployeeEvaluationDocument, options);
      }
export function useEmployeeEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables>(EmployeeEvaluationDocument, options);
        }
export function useEmployeeEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables>(EmployeeEvaluationDocument, options);
        }
export type EmployeeEvaluationQueryHookResult = ReturnType<typeof useEmployeeEvaluationQuery>;
export type EmployeeEvaluationLazyQueryHookResult = ReturnType<typeof useEmployeeEvaluationLazyQuery>;
export type EmployeeEvaluationSuspenseQueryHookResult = ReturnType<typeof useEmployeeEvaluationSuspenseQuery>;
export type EmployeeEvaluationQueryResult = Apollo.QueryResult<EmployeeEvaluationQuery, EmployeeEvaluationQueryVariables>;
export const SaveEmployeeEvaluationDocument = gql`
    mutation SaveEmployeeEvaluation($input: SaveEmployeeEvaluationInput!) {
  evaluation {
    saveEmployeeEvaluation(input: $input) {
      recordId
      record {
        ...EmployeeEvaluationFragment
      }
    }
  }
}
    ${EmployeeEvaluationFragmentFragmentDoc}`;
export type SaveEmployeeEvaluationMutationFn = Apollo.MutationFunction<SaveEmployeeEvaluationMutation, SaveEmployeeEvaluationMutationVariables>;

/**
 * __useSaveEmployeeEvaluationMutation__
 *
 * To run a mutation, you first call `useSaveEmployeeEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmployeeEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmployeeEvaluationMutation, { data, loading, error }] = useSaveEmployeeEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEmployeeEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmployeeEvaluationMutation, SaveEmployeeEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmployeeEvaluationMutation, SaveEmployeeEvaluationMutationVariables>(SaveEmployeeEvaluationDocument, options);
      }
export type SaveEmployeeEvaluationMutationHookResult = ReturnType<typeof useSaveEmployeeEvaluationMutation>;
export type SaveEmployeeEvaluationMutationResult = Apollo.MutationResult<SaveEmployeeEvaluationMutation>;
export type SaveEmployeeEvaluationMutationOptions = Apollo.BaseMutationOptions<SaveEmployeeEvaluationMutation, SaveEmployeeEvaluationMutationVariables>;
export const SaveEmployeeEvaluationAnswerDocument = gql`
    mutation SaveEmployeeEvaluationAnswer($input: SaveEvaluationAnswerInput!) {
  evaluation {
    saveEvaluationAnswer(input: $input) {
      recordId
    }
  }
}
    `;
export type SaveEmployeeEvaluationAnswerMutationFn = Apollo.MutationFunction<SaveEmployeeEvaluationAnswerMutation, SaveEmployeeEvaluationAnswerMutationVariables>;

/**
 * __useSaveEmployeeEvaluationAnswerMutation__
 *
 * To run a mutation, you first call `useSaveEmployeeEvaluationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmployeeEvaluationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmployeeEvaluationAnswerMutation, { data, loading, error }] = useSaveEmployeeEvaluationAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEmployeeEvaluationAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmployeeEvaluationAnswerMutation, SaveEmployeeEvaluationAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmployeeEvaluationAnswerMutation, SaveEmployeeEvaluationAnswerMutationVariables>(SaveEmployeeEvaluationAnswerDocument, options);
      }
export type SaveEmployeeEvaluationAnswerMutationHookResult = ReturnType<typeof useSaveEmployeeEvaluationAnswerMutation>;
export type SaveEmployeeEvaluationAnswerMutationResult = Apollo.MutationResult<SaveEmployeeEvaluationAnswerMutation>;
export type SaveEmployeeEvaluationAnswerMutationOptions = Apollo.BaseMutationOptions<SaveEmployeeEvaluationAnswerMutation, SaveEmployeeEvaluationAnswerMutationVariables>;
export const DeleteEmployeeEvaluationAnswerDocument = gql`
    mutation DeleteEmployeeEvaluationAnswer($ids: [String!]!) {
  evaluation {
    deleteEvaluationAnswer(ids: $ids) {
      recordId
    }
  }
}
    `;
export type DeleteEmployeeEvaluationAnswerMutationFn = Apollo.MutationFunction<DeleteEmployeeEvaluationAnswerMutation, DeleteEmployeeEvaluationAnswerMutationVariables>;

/**
 * __useDeleteEmployeeEvaluationAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeEvaluationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeEvaluationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeEvaluationAnswerMutation, { data, loading, error }] = useDeleteEmployeeEvaluationAnswerMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteEmployeeEvaluationAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeEvaluationAnswerMutation, DeleteEmployeeEvaluationAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeEvaluationAnswerMutation, DeleteEmployeeEvaluationAnswerMutationVariables>(DeleteEmployeeEvaluationAnswerDocument, options);
      }
export type DeleteEmployeeEvaluationAnswerMutationHookResult = ReturnType<typeof useDeleteEmployeeEvaluationAnswerMutation>;
export type DeleteEmployeeEvaluationAnswerMutationResult = Apollo.MutationResult<DeleteEmployeeEvaluationAnswerMutation>;
export type DeleteEmployeeEvaluationAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeEvaluationAnswerMutation, DeleteEmployeeEvaluationAnswerMutationVariables>;
export const AnswerEngagementSurveyQuestionDocument = gql`
    mutation AnswerEngagementSurveyQuestion($input: UpdateEngagementSurveyAnswerInput!) {
  engagementSurveys {
    answerEngagementSurveyQuestion(input: $input) {
      recordId
      record {
        ...engagementSurveyQuestionAnswer
      }
    }
  }
}
    ${EngagementSurveyQuestionAnswerFragmentDoc}`;
export type AnswerEngagementSurveyQuestionMutationFn = Apollo.MutationFunction<AnswerEngagementSurveyQuestionMutation, AnswerEngagementSurveyQuestionMutationVariables>;

/**
 * __useAnswerEngagementSurveyQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerEngagementSurveyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerEngagementSurveyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerEngagementSurveyQuestionMutation, { data, loading, error }] = useAnswerEngagementSurveyQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerEngagementSurveyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerEngagementSurveyQuestionMutation, AnswerEngagementSurveyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerEngagementSurveyQuestionMutation, AnswerEngagementSurveyQuestionMutationVariables>(AnswerEngagementSurveyQuestionDocument, options);
      }
export type AnswerEngagementSurveyQuestionMutationHookResult = ReturnType<typeof useAnswerEngagementSurveyQuestionMutation>;
export type AnswerEngagementSurveyQuestionMutationResult = Apollo.MutationResult<AnswerEngagementSurveyQuestionMutation>;
export type AnswerEngagementSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerEngagementSurveyQuestionMutation, AnswerEngagementSurveyQuestionMutationVariables>;
export const SubmitEngagementSurveyEmployeeResponseDocument = gql`
    mutation SubmitEngagementSurveyEmployeeResponse($input: SubmitEngagementSurveyInput!) {
  engagementSurveys {
    submitEngagementSurveyEmployeeResponse(input: $input) {
      recordId
      record {
        ...engagementSurveyEmployeeResponse
      }
      query {
        me {
          Id
          engagementSurveys {
            ...engagementSurveyDto
          }
        }
      }
    }
  }
}
    ${EngagementSurveyEmployeeResponseFragmentDoc}
${EngagementSurveyDtoFragmentDoc}`;
export type SubmitEngagementSurveyEmployeeResponseMutationFn = Apollo.MutationFunction<SubmitEngagementSurveyEmployeeResponseMutation, SubmitEngagementSurveyEmployeeResponseMutationVariables>;

/**
 * __useSubmitEngagementSurveyEmployeeResponseMutation__
 *
 * To run a mutation, you first call `useSubmitEngagementSurveyEmployeeResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEngagementSurveyEmployeeResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEngagementSurveyEmployeeResponseMutation, { data, loading, error }] = useSubmitEngagementSurveyEmployeeResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEngagementSurveyEmployeeResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEngagementSurveyEmployeeResponseMutation, SubmitEngagementSurveyEmployeeResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEngagementSurveyEmployeeResponseMutation, SubmitEngagementSurveyEmployeeResponseMutationVariables>(SubmitEngagementSurveyEmployeeResponseDocument, options);
      }
export type SubmitEngagementSurveyEmployeeResponseMutationHookResult = ReturnType<typeof useSubmitEngagementSurveyEmployeeResponseMutation>;
export type SubmitEngagementSurveyEmployeeResponseMutationResult = Apollo.MutationResult<SubmitEngagementSurveyEmployeeResponseMutation>;
export type SubmitEngagementSurveyEmployeeResponseMutationOptions = Apollo.BaseMutationOptions<SubmitEngagementSurveyEmployeeResponseMutation, SubmitEngagementSurveyEmployeeResponseMutationVariables>;
export const DismissEngagementSurveyEmployeeResponseDocument = gql`
    mutation DismissEngagementSurveyEmployeeResponse($input: SubmitEngagementSurveyInput!) {
  engagementSurveys {
    dismissEngagementSurveyEmployeeResponse(input: $input) {
      recordId
      record {
        ...engagementSurveyEmployeeResponse
      }
      query {
        me {
          Id
          engagementSurveys {
            ...engagementSurveyDto
          }
        }
      }
    }
  }
}
    ${EngagementSurveyEmployeeResponseFragmentDoc}
${EngagementSurveyDtoFragmentDoc}`;
export type DismissEngagementSurveyEmployeeResponseMutationFn = Apollo.MutationFunction<DismissEngagementSurveyEmployeeResponseMutation, DismissEngagementSurveyEmployeeResponseMutationVariables>;

/**
 * __useDismissEngagementSurveyEmployeeResponseMutation__
 *
 * To run a mutation, you first call `useDismissEngagementSurveyEmployeeResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissEngagementSurveyEmployeeResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissEngagementSurveyEmployeeResponseMutation, { data, loading, error }] = useDismissEngagementSurveyEmployeeResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissEngagementSurveyEmployeeResponseMutation(baseOptions?: Apollo.MutationHookOptions<DismissEngagementSurveyEmployeeResponseMutation, DismissEngagementSurveyEmployeeResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissEngagementSurveyEmployeeResponseMutation, DismissEngagementSurveyEmployeeResponseMutationVariables>(DismissEngagementSurveyEmployeeResponseDocument, options);
      }
export type DismissEngagementSurveyEmployeeResponseMutationHookResult = ReturnType<typeof useDismissEngagementSurveyEmployeeResponseMutation>;
export type DismissEngagementSurveyEmployeeResponseMutationResult = Apollo.MutationResult<DismissEngagementSurveyEmployeeResponseMutation>;
export type DismissEngagementSurveyEmployeeResponseMutationOptions = Apollo.BaseMutationOptions<DismissEngagementSurveyEmployeeResponseMutation, DismissEngagementSurveyEmployeeResponseMutationVariables>;
export const EngagementSurveyEmployeeResponseBySurveyIdDocument = gql`
    query EngagementSurveyEmployeeResponseBySurveyId($surveyId: String!, $employeeId: String!) {
  engagementSurveyEmployeeResponseBySurveyAndEmployee(
    surveyId: $surveyId
    employeeId: $employeeId
  ) {
    ...engagementSurveyEmployeeResponse
  }
}
    ${EngagementSurveyEmployeeResponseFragmentDoc}`;

/**
 * __useEngagementSurveyEmployeeResponseBySurveyIdQuery__
 *
 * To run a query within a React component, call `useEngagementSurveyEmployeeResponseBySurveyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementSurveyEmployeeResponseBySurveyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementSurveyEmployeeResponseBySurveyIdQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEngagementSurveyEmployeeResponseBySurveyIdQuery(baseOptions: Apollo.QueryHookOptions<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables> & ({ variables: EngagementSurveyEmployeeResponseBySurveyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables>(EngagementSurveyEmployeeResponseBySurveyIdDocument, options);
      }
export function useEngagementSurveyEmployeeResponseBySurveyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables>(EngagementSurveyEmployeeResponseBySurveyIdDocument, options);
        }
export function useEngagementSurveyEmployeeResponseBySurveyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables>(EngagementSurveyEmployeeResponseBySurveyIdDocument, options);
        }
export type EngagementSurveyEmployeeResponseBySurveyIdQueryHookResult = ReturnType<typeof useEngagementSurveyEmployeeResponseBySurveyIdQuery>;
export type EngagementSurveyEmployeeResponseBySurveyIdLazyQueryHookResult = ReturnType<typeof useEngagementSurveyEmployeeResponseBySurveyIdLazyQuery>;
export type EngagementSurveyEmployeeResponseBySurveyIdSuspenseQueryHookResult = ReturnType<typeof useEngagementSurveyEmployeeResponseBySurveyIdSuspenseQuery>;
export type EngagementSurveyEmployeeResponseBySurveyIdQueryResult = Apollo.QueryResult<EngagementSurveyEmployeeResponseBySurveyIdQuery, EngagementSurveyEmployeeResponseBySurveyIdQueryVariables>;
export const MyEngagementSurveysDocument = gql`
    query MyEngagementSurveys {
  me {
    Id
    engagementSurveys {
      ...engagementSurveyDto
    }
  }
}
    ${EngagementSurveyDtoFragmentDoc}`;

/**
 * __useMyEngagementSurveysQuery__
 *
 * To run a query within a React component, call `useMyEngagementSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEngagementSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEngagementSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEngagementSurveysQuery(baseOptions?: Apollo.QueryHookOptions<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>(MyEngagementSurveysDocument, options);
      }
export function useMyEngagementSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>(MyEngagementSurveysDocument, options);
        }
export function useMyEngagementSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>(MyEngagementSurveysDocument, options);
        }
export type MyEngagementSurveysQueryHookResult = ReturnType<typeof useMyEngagementSurveysQuery>;
export type MyEngagementSurveysLazyQueryHookResult = ReturnType<typeof useMyEngagementSurveysLazyQuery>;
export type MyEngagementSurveysSuspenseQueryHookResult = ReturnType<typeof useMyEngagementSurveysSuspenseQuery>;
export type MyEngagementSurveysQueryResult = Apollo.QueryResult<MyEngagementSurveysQuery, MyEngagementSurveysQueryVariables>;
export const ExpenseGroupApprovalRequestsDocument = gql`
    query ExpenseGroupApprovalRequests($relatedRecordId: String!) {
  approvalRequests(relatedRecordId: $relatedRecordId) {
    Id
    flair__Approval_Status__c
    flair__Approver__c
  }
}
    `;

/**
 * __useExpenseGroupApprovalRequestsQuery__
 *
 * To run a query within a React component, call `useExpenseGroupApprovalRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseGroupApprovalRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseGroupApprovalRequestsQuery({
 *   variables: {
 *      relatedRecordId: // value for 'relatedRecordId'
 *   },
 * });
 */
export function useExpenseGroupApprovalRequestsQuery(baseOptions: Apollo.QueryHookOptions<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables> & ({ variables: ExpenseGroupApprovalRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables>(ExpenseGroupApprovalRequestsDocument, options);
      }
export function useExpenseGroupApprovalRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables>(ExpenseGroupApprovalRequestsDocument, options);
        }
export function useExpenseGroupApprovalRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables>(ExpenseGroupApprovalRequestsDocument, options);
        }
export type ExpenseGroupApprovalRequestsQueryHookResult = ReturnType<typeof useExpenseGroupApprovalRequestsQuery>;
export type ExpenseGroupApprovalRequestsLazyQueryHookResult = ReturnType<typeof useExpenseGroupApprovalRequestsLazyQuery>;
export type ExpenseGroupApprovalRequestsSuspenseQueryHookResult = ReturnType<typeof useExpenseGroupApprovalRequestsSuspenseQuery>;
export type ExpenseGroupApprovalRequestsQueryResult = Apollo.QueryResult<ExpenseGroupApprovalRequestsQuery, ExpenseGroupApprovalRequestsQueryVariables>;
export const ExpenseRulesDocument = gql`
    query ExpenseRules {
  expenseRules {
    ...ExpenseRule
  }
}
    ${ExpenseRuleFragmentDoc}`;

/**
 * __useExpenseRulesQuery__
 *
 * To run a query within a React component, call `useExpenseRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseRulesQuery(baseOptions?: Apollo.QueryHookOptions<ExpenseRulesQuery, ExpenseRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseRulesQuery, ExpenseRulesQueryVariables>(ExpenseRulesDocument, options);
      }
export function useExpenseRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseRulesQuery, ExpenseRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseRulesQuery, ExpenseRulesQueryVariables>(ExpenseRulesDocument, options);
        }
export function useExpenseRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpenseRulesQuery, ExpenseRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpenseRulesQuery, ExpenseRulesQueryVariables>(ExpenseRulesDocument, options);
        }
export type ExpenseRulesQueryHookResult = ReturnType<typeof useExpenseRulesQuery>;
export type ExpenseRulesLazyQueryHookResult = ReturnType<typeof useExpenseRulesLazyQuery>;
export type ExpenseRulesSuspenseQueryHookResult = ReturnType<typeof useExpenseRulesSuspenseQuery>;
export type ExpenseRulesQueryResult = Apollo.QueryResult<ExpenseRulesQuery, ExpenseRulesQueryVariables>;
export const ExpenseFormDataDocument = gql`
    query ExpenseFormData {
  projects {
    Id
    flair__Name__c
  }
  merchants {
    Id
    Name
  }
  expenseCategories {
    Id
    Name
  }
  objectRecordTypes(
    objectApiNames: ["flair__Expense__c", "flair__Expense_Item__c"]
  ) {
    objectApiName
    recordTypes {
      ...RecordTypeBase
    }
  }
  me {
    Id
    myExpenses {
      ...ExpenseData
      ...ExtraFieldsTable_WithExtraFields
      commentsCount
      CurrencyIsoCode
    }
    myExpenseGroups {
      Id
      Name
      flair__Status__c
    }
  }
  expenseRules {
    ...ExpenseRule
  }
}
    ${RecordTypeBaseFragmentDoc}
${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseRuleFragmentDoc}`;

/**
 * __useExpenseFormDataQuery__
 *
 * To run a query within a React component, call `useExpenseFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseFormDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseFormDataQuery(baseOptions?: Apollo.QueryHookOptions<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>(ExpenseFormDataDocument, options);
      }
export function useExpenseFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>(ExpenseFormDataDocument, options);
        }
export function useExpenseFormDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>(ExpenseFormDataDocument, options);
        }
export type ExpenseFormDataQueryHookResult = ReturnType<typeof useExpenseFormDataQuery>;
export type ExpenseFormDataLazyQueryHookResult = ReturnType<typeof useExpenseFormDataLazyQuery>;
export type ExpenseFormDataSuspenseQueryHookResult = ReturnType<typeof useExpenseFormDataSuspenseQuery>;
export type ExpenseFormDataQueryResult = Apollo.QueryResult<ExpenseFormDataQuery, ExpenseFormDataQueryVariables>;
export const CreateDraftExpenseDocument = gql`
    mutation CreateDraftExpense($input: CreateDraftExpenseInput!) {
  expenses {
    createDraftExpense(input: $input) {
      recordId
      record {
        ...ExpenseData
        ...ExtraFieldsTable_WithExtraFields
        commentsCount
        CurrencyIsoCode
        extraFields {
          ...ExtraFieldInfoId
        }
      }
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
          myExpenseGroups {
            ...ExpenseGroupData
          }
        }
      }
      error
    }
  }
}
    ${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExtraFieldInfoIdFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;
export type CreateDraftExpenseMutationFn = Apollo.MutationFunction<CreateDraftExpenseMutation, CreateDraftExpenseMutationVariables>;

/**
 * __useCreateDraftExpenseMutation__
 *
 * To run a mutation, you first call `useCreateDraftExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftExpenseMutation, { data, loading, error }] = useCreateDraftExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDraftExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftExpenseMutation, CreateDraftExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftExpenseMutation, CreateDraftExpenseMutationVariables>(CreateDraftExpenseDocument, options);
      }
export type CreateDraftExpenseMutationHookResult = ReturnType<typeof useCreateDraftExpenseMutation>;
export type CreateDraftExpenseMutationResult = Apollo.MutationResult<CreateDraftExpenseMutation>;
export type CreateDraftExpenseMutationOptions = Apollo.BaseMutationOptions<CreateDraftExpenseMutation, CreateDraftExpenseMutationVariables>;
export const CreateExpenseItemDocument = gql`
    mutation CreateExpenseItem($input: CreateExpenseItemInput!) {
  expenses {
    createExpenseItem(input: $input) {
      recordId
      record {
        Id
        Name
        flair__Manual_Amount__c
        flair__Amount__c
        flair__Note__c
        flair__Merchant__c
        flair__Tax__c
        flair__Address_From__c
        flair__Address_To__c
        flair__Km_Distance__c
        flair__Distance_Sync_In_Progress__c
        merchant {
          Id
          Name
        }
        tax {
          ...Tax
        }
        recordType {
          ...RecordTypeBase
        }
        extraFields {
          ...ExtraFieldValue
        }
      }
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
        }
      }
      error
    }
  }
}
    ${TaxFragmentDoc}
${RecordTypeBaseFragmentDoc}
${ExtraFieldValueFragmentDoc}
${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}`;
export type CreateExpenseItemMutationFn = Apollo.MutationFunction<CreateExpenseItemMutation, CreateExpenseItemMutationVariables>;

/**
 * __useCreateExpenseItemMutation__
 *
 * To run a mutation, you first call `useCreateExpenseItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseItemMutation, { data, loading, error }] = useCreateExpenseItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpenseItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpenseItemMutation, CreateExpenseItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpenseItemMutation, CreateExpenseItemMutationVariables>(CreateExpenseItemDocument, options);
      }
export type CreateExpenseItemMutationHookResult = ReturnType<typeof useCreateExpenseItemMutation>;
export type CreateExpenseItemMutationResult = Apollo.MutationResult<CreateExpenseItemMutation>;
export type CreateExpenseItemMutationOptions = Apollo.BaseMutationOptions<CreateExpenseItemMutation, CreateExpenseItemMutationVariables>;
export const CreateMerchantDocument = gql`
    mutation CreateMerchant($input: CreateMerchantInput!) {
  expenses {
    createMerchant(input: $input) {
      merchant {
        Id
        Name
      }
      error
    }
  }
}
    `;
export type CreateMerchantMutationFn = Apollo.MutationFunction<CreateMerchantMutation, CreateMerchantMutationVariables>;

/**
 * __useCreateMerchantMutation__
 *
 * To run a mutation, you first call `useCreateMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMerchantMutation, { data, loading, error }] = useCreateMerchantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMerchantMutation(baseOptions?: Apollo.MutationHookOptions<CreateMerchantMutation, CreateMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMerchantMutation, CreateMerchantMutationVariables>(CreateMerchantDocument, options);
      }
export type CreateMerchantMutationHookResult = ReturnType<typeof useCreateMerchantMutation>;
export type CreateMerchantMutationResult = Apollo.MutationResult<CreateMerchantMutation>;
export type CreateMerchantMutationOptions = Apollo.BaseMutationOptions<CreateMerchantMutation, CreateMerchantMutationVariables>;
export const DeleteExpenseItemDocument = gql`
    mutation DeleteExpenseItem($id: String!) {
  expenses {
    deleteExpenseItem(id: $id) {
      recordId
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
          myExpenseGroups {
            ...ExpenseGroupData
          }
        }
      }
      error
    }
  }
}
    ${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;
export type DeleteExpenseItemMutationFn = Apollo.MutationFunction<DeleteExpenseItemMutation, DeleteExpenseItemMutationVariables>;

/**
 * __useDeleteExpenseItemMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpenseItemMutation, { data, loading, error }] = useDeleteExpenseItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpenseItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpenseItemMutation, DeleteExpenseItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpenseItemMutation, DeleteExpenseItemMutationVariables>(DeleteExpenseItemDocument, options);
      }
export type DeleteExpenseItemMutationHookResult = ReturnType<typeof useDeleteExpenseItemMutation>;
export type DeleteExpenseItemMutationResult = Apollo.MutationResult<DeleteExpenseItemMutation>;
export type DeleteExpenseItemMutationOptions = Apollo.BaseMutationOptions<DeleteExpenseItemMutation, DeleteExpenseItemMutationVariables>;
export const UpdateExpenseDocument = gql`
    mutation updateExpense($input: UpdateExpenseInput!) {
  expenses {
    updateExpense(input: $input) {
      record {
        Id
        Name
        flair__Description__c
        flair__Amount__c
        flair__Final_Amount__c
        flair__Expense_Date__c
        flair__Date_From__c
        flair__Date_To__c
        flair__Time_From__c
        flair__Time_To__c
        flair__Status__c
        flair__Expense_Group__c
        flair__Reimbursed__c
        flair__Is_Draft__c
        flair__Decline_Reason__c
        CurrencyIsoCode
        CreatedDate
        project {
          Id
          flair__Name__c
        }
        expenseCategory {
          Id
          Name
        }
        merchant {
          Id
          Name
        }
        employee {
          Id
          Name
          flair__First_Name__c
          flair__Last_Name__c
          avatar {
            Id
            url
          }
        }
        expenseGroup {
          Id
          expenses {
            Id
          }
        }
        ContentDocumentLinks {
          ...ContentDocumentLinkData
        }
        commentsCount
        expenseItems {
          ...ExpenseItem
        }
        recordType {
          ...RecordTypeBase
        }
        extraFields {
          ...ExtraFieldValue
        }
      }
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
          myExpenseGroups {
            ...ExpenseGroupData
          }
        }
      }
    }
  }
}
    ${ContentDocumentLinkDataFragmentDoc}
${ExpenseItemFragmentDoc}
${RecordTypeBaseFragmentDoc}
${ExtraFieldValueFragmentDoc}
${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;
export type UpdateExpenseMutationFn = Apollo.MutationFunction<UpdateExpenseMutation, UpdateExpenseMutationVariables>;

/**
 * __useUpdateExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseMutation, { data, loading, error }] = useUpdateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseMutation, UpdateExpenseMutationVariables>(UpdateExpenseDocument, options);
      }
export type UpdateExpenseMutationHookResult = ReturnType<typeof useUpdateExpenseMutation>;
export type UpdateExpenseMutationResult = Apollo.MutationResult<UpdateExpenseMutation>;
export type UpdateExpenseMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>;
export const UpdateExpenseItemDocument = gql`
    mutation updateExpenseItem($input: UpdateExpenseItemInput!) {
  expenses {
    updateExpenseItem(input: $input) {
      recordId
      record {
        Id
        Name
        flair__Breakfast_Provided__c
        flair__Lunch_Provided__c
        flair__Dinner_Provided__c
        flair__Amount__c
        flair__Manual_Amount__c
        flair__Note__c
        flair__Tax__c
        flair__Address_From__c
        flair__Address_To__c
        flair__Km_Distance__c
        flair__Distance_Sync_In_Progress__c
        tax {
          ...Tax
        }
        recordType {
          ...RecordTypeBase
        }
        extraFields {
          ...ExtraFieldValue
        }
        expense {
          Id
          flair__Final_Amount__c
          CurrencyIsoCode
        }
      }
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
        }
      }
      error
    }
  }
}
    ${TaxFragmentDoc}
${RecordTypeBaseFragmentDoc}
${ExtraFieldValueFragmentDoc}
${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}`;
export type UpdateExpenseItemMutationFn = Apollo.MutationFunction<UpdateExpenseItemMutation, UpdateExpenseItemMutationVariables>;

/**
 * __useUpdateExpenseItemMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseItemMutation, { data, loading, error }] = useUpdateExpenseItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseItemMutation, UpdateExpenseItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseItemMutation, UpdateExpenseItemMutationVariables>(UpdateExpenseItemDocument, options);
      }
export type UpdateExpenseItemMutationHookResult = ReturnType<typeof useUpdateExpenseItemMutation>;
export type UpdateExpenseItemMutationResult = Apollo.MutationResult<UpdateExpenseItemMutation>;
export type UpdateExpenseItemMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseItemMutation, UpdateExpenseItemMutationVariables>;
export const UploadExpenseFileDocument = gql`
    mutation UploadExpenseFile($input: UpdateExpenseInput!) {
  expenses {
    updateExpense(input: $input) {
      record {
        Id
        ContentDocumentLinks {
          Id
          ContentDocument {
            Id
            Title
            FileExtension
            LatestPublishedVersionId
          }
        }
      }
      error
    }
  }
}
    `;
export type UploadExpenseFileMutationFn = Apollo.MutationFunction<UploadExpenseFileMutation, UploadExpenseFileMutationVariables>;

/**
 * __useUploadExpenseFileMutation__
 *
 * To run a mutation, you first call `useUploadExpenseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadExpenseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadExpenseFileMutation, { data, loading, error }] = useUploadExpenseFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadExpenseFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadExpenseFileMutation, UploadExpenseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadExpenseFileMutation, UploadExpenseFileMutationVariables>(UploadExpenseFileDocument, options);
      }
export type UploadExpenseFileMutationHookResult = ReturnType<typeof useUploadExpenseFileMutation>;
export type UploadExpenseFileMutationResult = Apollo.MutationResult<UploadExpenseFileMutation>;
export type UploadExpenseFileMutationOptions = Apollo.BaseMutationOptions<UploadExpenseFileMutation, UploadExpenseFileMutationVariables>;
export const ExpenseApprovalRequestsDocument = gql`
    query ExpenseApprovalRequests($relatedRecordId: String!) {
  approvalRequests(relatedRecordId: $relatedRecordId) {
    Id
    flair__Approval_Status__c
    flair__Approver__c
  }
}
    `;

/**
 * __useExpenseApprovalRequestsQuery__
 *
 * To run a query within a React component, call `useExpenseApprovalRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseApprovalRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseApprovalRequestsQuery({
 *   variables: {
 *      relatedRecordId: // value for 'relatedRecordId'
 *   },
 * });
 */
export function useExpenseApprovalRequestsQuery(baseOptions: Apollo.QueryHookOptions<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables> & ({ variables: ExpenseApprovalRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables>(ExpenseApprovalRequestsDocument, options);
      }
export function useExpenseApprovalRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables>(ExpenseApprovalRequestsDocument, options);
        }
export function useExpenseApprovalRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables>(ExpenseApprovalRequestsDocument, options);
        }
export type ExpenseApprovalRequestsQueryHookResult = ReturnType<typeof useExpenseApprovalRequestsQuery>;
export type ExpenseApprovalRequestsLazyQueryHookResult = ReturnType<typeof useExpenseApprovalRequestsLazyQuery>;
export type ExpenseApprovalRequestsSuspenseQueryHookResult = ReturnType<typeof useExpenseApprovalRequestsSuspenseQuery>;
export type ExpenseApprovalRequestsQueryResult = Apollo.QueryResult<ExpenseApprovalRequestsQuery, ExpenseApprovalRequestsQueryVariables>;
export const UpdateExpenseApprovalRequestStatusDocument = gql`
    mutation UpdateExpenseApprovalRequestStatus($input: UpdateApprovalRequestStatusInput!, $expenseId: String!) {
  approvalRequest {
    updateApprovalRequestStatus(input: $input) {
      recordId
      record {
        Id
        flair__Approval_Status__c
      }
      query {
        approvalRequests(relatedRecordId: $expenseId) {
          Id
          flair__Approval_Status__c
          flair__Approver__c
        }
        expense(id: $expenseId) {
          Id
          flair__Status__c
          flair__Reimbursed__c
        }
      }
    }
  }
}
    `;
export type UpdateExpenseApprovalRequestStatusMutationFn = Apollo.MutationFunction<UpdateExpenseApprovalRequestStatusMutation, UpdateExpenseApprovalRequestStatusMutationVariables>;

/**
 * __useUpdateExpenseApprovalRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseApprovalRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseApprovalRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseApprovalRequestStatusMutation, { data, loading, error }] = useUpdateExpenseApprovalRequestStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *      expenseId: // value for 'expenseId'
 *   },
 * });
 */
export function useUpdateExpenseApprovalRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseApprovalRequestStatusMutation, UpdateExpenseApprovalRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseApprovalRequestStatusMutation, UpdateExpenseApprovalRequestStatusMutationVariables>(UpdateExpenseApprovalRequestStatusDocument, options);
      }
export type UpdateExpenseApprovalRequestStatusMutationHookResult = ReturnType<typeof useUpdateExpenseApprovalRequestStatusMutation>;
export type UpdateExpenseApprovalRequestStatusMutationResult = Apollo.MutationResult<UpdateExpenseApprovalRequestStatusMutation>;
export type UpdateExpenseApprovalRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseApprovalRequestStatusMutation, UpdateExpenseApprovalRequestStatusMutationVariables>;
export const ExpensesDocument = gql`
    query Expenses($sort: [ExpenseSortInput!]) {
  me {
    Id
    myExpenses(sort: $sort) {
      ...ExpenseData
      ...ExtraFieldsTable_WithExtraFields
      commentsCount
      CurrencyIsoCode
    }
    myExpenseGroups {
      ...ExpenseGroupData
    }
  }
}
    ${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;

/**
 * __useExpensesQuery__
 *
 * To run a query within a React component, call `useExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExpensesQuery(baseOptions?: Apollo.QueryHookOptions<ExpensesQuery, ExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, options);
      }
export function useExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesQuery, ExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, options);
        }
export function useExpensesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpensesQuery, ExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, options);
        }
export type ExpensesQueryHookResult = ReturnType<typeof useExpensesQuery>;
export type ExpensesLazyQueryHookResult = ReturnType<typeof useExpensesLazyQuery>;
export type ExpensesSuspenseQueryHookResult = ReturnType<typeof useExpensesSuspenseQuery>;
export type ExpensesQueryResult = Apollo.QueryResult<ExpensesQuery, ExpensesQueryVariables>;
export const CreateExpenseGroupDocument = gql`
    mutation createExpenseGroup($input: CreateExpenseGroupInput!) {
  expenseGroups {
    createExpenseGroup(input: $input) {
      recordId
      record {
        Id
        Name
        flair__Type__c
        flair__Status__c
        flair__Trip_Location__c
        flair__Employee__c
      }
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
          myExpenseGroups {
            ...ExpenseGroupData
          }
        }
      }
      error
    }
  }
}
    ${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;
export type CreateExpenseGroupMutationFn = Apollo.MutationFunction<CreateExpenseGroupMutation, CreateExpenseGroupMutationVariables>;

/**
 * __useCreateExpenseGroupMutation__
 *
 * To run a mutation, you first call `useCreateExpenseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseGroupMutation, { data, loading, error }] = useCreateExpenseGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpenseGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpenseGroupMutation, CreateExpenseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpenseGroupMutation, CreateExpenseGroupMutationVariables>(CreateExpenseGroupDocument, options);
      }
export type CreateExpenseGroupMutationHookResult = ReturnType<typeof useCreateExpenseGroupMutation>;
export type CreateExpenseGroupMutationResult = Apollo.MutationResult<CreateExpenseGroupMutation>;
export type CreateExpenseGroupMutationOptions = Apollo.BaseMutationOptions<CreateExpenseGroupMutation, CreateExpenseGroupMutationVariables>;
export const DeleteExpenseDocument = gql`
    mutation deleteExpense($id: String!) {
  expenses {
    deleteExpense(id: $id) {
      recordId
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
          }
        }
      }
      error
    }
  }
}
    ${ExpenseDataFragmentDoc}`;
export type DeleteExpenseMutationFn = Apollo.MutationFunction<DeleteExpenseMutation, DeleteExpenseMutationVariables>;

/**
 * __useDeleteExpenseMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpenseMutation, { data, loading, error }] = useDeleteExpenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpenseMutation, DeleteExpenseMutationVariables>(DeleteExpenseDocument, options);
      }
export type DeleteExpenseMutationHookResult = ReturnType<typeof useDeleteExpenseMutation>;
export type DeleteExpenseMutationResult = Apollo.MutationResult<DeleteExpenseMutation>;
export type DeleteExpenseMutationOptions = Apollo.BaseMutationOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>;
export const DeleteExpenseGroupDocument = gql`
    mutation deleteExpenseGroup($id: String!) {
  expenseGroups {
    deleteExpenseGroup(id: $id) {
      recordId
      query {
        me {
          Id
          myExpenses {
            ...ExpenseData
            ...ExtraFieldsTable_WithExtraFields
            commentsCount
            CurrencyIsoCode
          }
          myExpenseGroups {
            ...ExpenseGroupData
          }
        }
      }
      error
    }
  }
}
    ${ExpenseDataFragmentDoc}
${ExtraFieldsTable_WithExtraFieldsFragmentDoc}
${ExpenseGroupDataFragmentDoc}`;
export type DeleteExpenseGroupMutationFn = Apollo.MutationFunction<DeleteExpenseGroupMutation, DeleteExpenseGroupMutationVariables>;

/**
 * __useDeleteExpenseGroupMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpenseGroupMutation, { data, loading, error }] = useDeleteExpenseGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpenseGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpenseGroupMutation, DeleteExpenseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpenseGroupMutation, DeleteExpenseGroupMutationVariables>(DeleteExpenseGroupDocument, options);
      }
export type DeleteExpenseGroupMutationHookResult = ReturnType<typeof useDeleteExpenseGroupMutation>;
export type DeleteExpenseGroupMutationResult = Apollo.MutationResult<DeleteExpenseGroupMutation>;
export type DeleteExpenseGroupMutationOptions = Apollo.BaseMutationOptions<DeleteExpenseGroupMutation, DeleteExpenseGroupMutationVariables>;
export const UpdateExpenseGroupApprovalRequestStatusDocument = gql`
    mutation UpdateExpenseGroupApprovalRequestStatus($input: UpdateApprovalRequestStatusInput!, $expenseGroupId: String!) {
  approvalRequest {
    updateApprovalRequestStatus(input: $input) {
      recordId
      record {
        Id
        flair__Approval_Status__c
      }
      query {
        approvalRequests(relatedRecordId: $expenseGroupId) {
          Id
          flair__Approval_Status__c
          flair__Approver__c
        }
        expenseGroup(id: $expenseGroupId) {
          Id
          flair__Status__c
          flair__Reimbursed__c
        }
      }
    }
  }
}
    `;
export type UpdateExpenseGroupApprovalRequestStatusMutationFn = Apollo.MutationFunction<UpdateExpenseGroupApprovalRequestStatusMutation, UpdateExpenseGroupApprovalRequestStatusMutationVariables>;

/**
 * __useUpdateExpenseGroupApprovalRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseGroupApprovalRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseGroupApprovalRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseGroupApprovalRequestStatusMutation, { data, loading, error }] = useUpdateExpenseGroupApprovalRequestStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *      expenseGroupId: // value for 'expenseGroupId'
 *   },
 * });
 */
export function useUpdateExpenseGroupApprovalRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseGroupApprovalRequestStatusMutation, UpdateExpenseGroupApprovalRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseGroupApprovalRequestStatusMutation, UpdateExpenseGroupApprovalRequestStatusMutationVariables>(UpdateExpenseGroupApprovalRequestStatusDocument, options);
      }
export type UpdateExpenseGroupApprovalRequestStatusMutationHookResult = ReturnType<typeof useUpdateExpenseGroupApprovalRequestStatusMutation>;
export type UpdateExpenseGroupApprovalRequestStatusMutationResult = Apollo.MutationResult<UpdateExpenseGroupApprovalRequestStatusMutation>;
export type UpdateExpenseGroupApprovalRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseGroupApprovalRequestStatusMutation, UpdateExpenseGroupApprovalRequestStatusMutationVariables>;
export const UpdateExpenseStatusDocument = gql`
    mutation updateExpenseStatus($input: UpdateExpenseStatusInput!) {
  expenses {
    updateExpenseStatus(input: $input) {
      record {
        Id
        flair__Status__c
        flair__Decline_Reason__c
        extraFields {
          ...ExtraFieldValue
        }
      }
    }
  }
}
    ${ExtraFieldValueFragmentDoc}`;
export type UpdateExpenseStatusMutationFn = Apollo.MutationFunction<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>;

/**
 * __useUpdateExpenseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseStatusMutation, { data, loading, error }] = useUpdateExpenseStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>(UpdateExpenseStatusDocument, options);
      }
export type UpdateExpenseStatusMutationHookResult = ReturnType<typeof useUpdateExpenseStatusMutation>;
export type UpdateExpenseStatusMutationResult = Apollo.MutationResult<UpdateExpenseStatusMutation>;
export type UpdateExpenseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>;
export const UpdateExpenseGroupStatusDocument = gql`
    mutation updateExpenseGroupStatus($input: UpdateExpenseGroupStatusInput!) {
  expenseGroups {
    updateExpenseGroupStatus(input: $input) {
      recordId
      record {
        Id
        Name
        flair__Type__c
        flair__Status__c
        flair__Decline_Reason__c
        flair__Employee__c
        flair__Reimbursed__c
        expenses {
          Id
          flair__Status__c
          flair__Decline_Reason__c
          flair__Reimbursed__c
        }
      }
      error
    }
  }
}
    `;
export type UpdateExpenseGroupStatusMutationFn = Apollo.MutationFunction<UpdateExpenseGroupStatusMutation, UpdateExpenseGroupStatusMutationVariables>;

/**
 * __useUpdateExpenseGroupStatusMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseGroupStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseGroupStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseGroupStatusMutation, { data, loading, error }] = useUpdateExpenseGroupStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseGroupStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseGroupStatusMutation, UpdateExpenseGroupStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseGroupStatusMutation, UpdateExpenseGroupStatusMutationVariables>(UpdateExpenseGroupStatusDocument, options);
      }
export type UpdateExpenseGroupStatusMutationHookResult = ReturnType<typeof useUpdateExpenseGroupStatusMutation>;
export type UpdateExpenseGroupStatusMutationResult = Apollo.MutationResult<UpdateExpenseGroupStatusMutation>;
export type UpdateExpenseGroupStatusMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseGroupStatusMutation, UpdateExpenseGroupStatusMutationVariables>;
export const HomeTodayAbsencesCardDocument = gql`
    query HomeTodayAbsencesCard($from: DateTime!, $to: DateTime!, $filterBy: EmployeeScopeFilter = null) {
  allAbsences(from: $from, to: $to, filterBy: $filterBy) {
    ...HomeTodayAbsenceCardAbsence
  }
}
    ${HomeTodayAbsenceCardAbsenceFragmentDoc}`;

/**
 * __useHomeTodayAbsencesCardQuery__
 *
 * To run a query within a React component, call `useHomeTodayAbsencesCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeTodayAbsencesCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeTodayAbsencesCardQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filterBy: // value for 'filterBy'
 *   },
 * });
 */
export function useHomeTodayAbsencesCardQuery(baseOptions: Apollo.QueryHookOptions<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables> & ({ variables: HomeTodayAbsencesCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables>(HomeTodayAbsencesCardDocument, options);
      }
export function useHomeTodayAbsencesCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables>(HomeTodayAbsencesCardDocument, options);
        }
export function useHomeTodayAbsencesCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables>(HomeTodayAbsencesCardDocument, options);
        }
export type HomeTodayAbsencesCardQueryHookResult = ReturnType<typeof useHomeTodayAbsencesCardQuery>;
export type HomeTodayAbsencesCardLazyQueryHookResult = ReturnType<typeof useHomeTodayAbsencesCardLazyQuery>;
export type HomeTodayAbsencesCardSuspenseQueryHookResult = ReturnType<typeof useHomeTodayAbsencesCardSuspenseQuery>;
export type HomeTodayAbsencesCardQueryResult = Apollo.QueryResult<HomeTodayAbsencesCardQuery, HomeTodayAbsencesCardQueryVariables>;
export const HomeAbsencesCardDocument = gql`
    query HomeAbsencesCard {
  me {
    Id
    absenceCategories {
      ...HomeAbsenceCard_AbsenceCategory
    }
    absencesCurrentYear {
      Id
      flair__Working_Amount__c
      flair__Employee_Absence_Category__c
    }
    upcomingAbsences {
      Id
      flair__Approval_Status__c
      flair__Category_Name__c
      flair__Category_Icon__c
      flair__Amount__c
      flair__Working_Amount__c
      flair__Start_Date__c
      flair__Start_Time__c
      flair__Start_Date_Half_Day__c
      flair__End_Date__c
      flair__End_Time__c
      flair__End_Date_Half_Day__c
      flair__Type__c
    }
  }
}
    ${HomeAbsenceCard_AbsenceCategoryFragmentDoc}`;

/**
 * __useHomeAbsencesCardQuery__
 *
 * To run a query within a React component, call `useHomeAbsencesCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAbsencesCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAbsencesCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeAbsencesCardQuery(baseOptions?: Apollo.QueryHookOptions<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>(HomeAbsencesCardDocument, options);
      }
export function useHomeAbsencesCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>(HomeAbsencesCardDocument, options);
        }
export function useHomeAbsencesCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>(HomeAbsencesCardDocument, options);
        }
export type HomeAbsencesCardQueryHookResult = ReturnType<typeof useHomeAbsencesCardQuery>;
export type HomeAbsencesCardLazyQueryHookResult = ReturnType<typeof useHomeAbsencesCardLazyQuery>;
export type HomeAbsencesCardSuspenseQueryHookResult = ReturnType<typeof useHomeAbsencesCardSuspenseQuery>;
export type HomeAbsencesCardQueryResult = Apollo.QueryResult<HomeAbsencesCardQuery, HomeAbsencesCardQueryVariables>;
export const AnswerCheckinsSurveyCycleDocument = gql`
    mutation AnswerCheckinsSurveyCycle($input: AnswerCheckinsSurveyCycleInput!) {
  checkinsSurveys {
    answerCheckinsSurveyCycle(input: $input) {
      error
      query {
        me {
          Id
          checkinsSurveys {
            ...checkinsSurveys
          }
        }
      }
    }
  }
}
    ${CheckinsSurveysFragmentDoc}`;
export type AnswerCheckinsSurveyCycleMutationFn = Apollo.MutationFunction<AnswerCheckinsSurveyCycleMutation, AnswerCheckinsSurveyCycleMutationVariables>;

/**
 * __useAnswerCheckinsSurveyCycleMutation__
 *
 * To run a mutation, you first call `useAnswerCheckinsSurveyCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerCheckinsSurveyCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerCheckinsSurveyCycleMutation, { data, loading, error }] = useAnswerCheckinsSurveyCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerCheckinsSurveyCycleMutation(baseOptions?: Apollo.MutationHookOptions<AnswerCheckinsSurveyCycleMutation, AnswerCheckinsSurveyCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerCheckinsSurveyCycleMutation, AnswerCheckinsSurveyCycleMutationVariables>(AnswerCheckinsSurveyCycleDocument, options);
      }
export type AnswerCheckinsSurveyCycleMutationHookResult = ReturnType<typeof useAnswerCheckinsSurveyCycleMutation>;
export type AnswerCheckinsSurveyCycleMutationResult = Apollo.MutationResult<AnswerCheckinsSurveyCycleMutation>;
export type AnswerCheckinsSurveyCycleMutationOptions = Apollo.BaseMutationOptions<AnswerCheckinsSurveyCycleMutation, AnswerCheckinsSurveyCycleMutationVariables>;
export const DismissCheckinsSurveyCycleDocument = gql`
    mutation DismissCheckinsSurveyCycle($input: DismissCheckinsSurveyCycleInput!) {
  checkinsSurveys {
    dismissCheckinsSurveyCycle(input: $input) {
      error
      query {
        me {
          Id
          checkinsSurveys {
            ...checkinsSurveys
          }
        }
      }
    }
  }
}
    ${CheckinsSurveysFragmentDoc}`;
export type DismissCheckinsSurveyCycleMutationFn = Apollo.MutationFunction<DismissCheckinsSurveyCycleMutation, DismissCheckinsSurveyCycleMutationVariables>;

/**
 * __useDismissCheckinsSurveyCycleMutation__
 *
 * To run a mutation, you first call `useDismissCheckinsSurveyCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissCheckinsSurveyCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissCheckinsSurveyCycleMutation, { data, loading, error }] = useDismissCheckinsSurveyCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissCheckinsSurveyCycleMutation(baseOptions?: Apollo.MutationHookOptions<DismissCheckinsSurveyCycleMutation, DismissCheckinsSurveyCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissCheckinsSurveyCycleMutation, DismissCheckinsSurveyCycleMutationVariables>(DismissCheckinsSurveyCycleDocument, options);
      }
export type DismissCheckinsSurveyCycleMutationHookResult = ReturnType<typeof useDismissCheckinsSurveyCycleMutation>;
export type DismissCheckinsSurveyCycleMutationResult = Apollo.MutationResult<DismissCheckinsSurveyCycleMutation>;
export type DismissCheckinsSurveyCycleMutationOptions = Apollo.BaseMutationOptions<DismissCheckinsSurveyCycleMutation, DismissCheckinsSurveyCycleMutationVariables>;
export const MyCheckinsSurveysDocument = gql`
    query MyCheckinsSurveys {
  me {
    Id
    checkinsSurveys {
      ...checkinsSurveys
    }
  }
}
    ${CheckinsSurveysFragmentDoc}`;

/**
 * __useMyCheckinsSurveysQuery__
 *
 * To run a query within a React component, call `useMyCheckinsSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCheckinsSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCheckinsSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCheckinsSurveysQuery(baseOptions?: Apollo.QueryHookOptions<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>(MyCheckinsSurveysDocument, options);
      }
export function useMyCheckinsSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>(MyCheckinsSurveysDocument, options);
        }
export function useMyCheckinsSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>(MyCheckinsSurveysDocument, options);
        }
export type MyCheckinsSurveysQueryHookResult = ReturnType<typeof useMyCheckinsSurveysQuery>;
export type MyCheckinsSurveysLazyQueryHookResult = ReturnType<typeof useMyCheckinsSurveysLazyQuery>;
export type MyCheckinsSurveysSuspenseQueryHookResult = ReturnType<typeof useMyCheckinsSurveysSuspenseQuery>;
export type MyCheckinsSurveysQueryResult = Apollo.QueryResult<MyCheckinsSurveysQuery, MyCheckinsSurveysQueryVariables>;
export const UpdateSliderSettingsDocument = gql`
    mutation updateSliderSettings($input: UpdateSliderSettingsInput!) {
  employeeHubFeatures {
    updateSliderSettings(input: $input) {
      query {
        employeeHubFeatures {
          ...EmployeeHubFeature
        }
      }
    }
  }
}
    ${EmployeeHubFeatureFragmentDoc}`;
export type UpdateSliderSettingsMutationFn = Apollo.MutationFunction<UpdateSliderSettingsMutation, UpdateSliderSettingsMutationVariables>;

/**
 * __useUpdateSliderSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSliderSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSliderSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSliderSettingsMutation, { data, loading, error }] = useUpdateSliderSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSliderSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSliderSettingsMutation, UpdateSliderSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSliderSettingsMutation, UpdateSliderSettingsMutationVariables>(UpdateSliderSettingsDocument, options);
      }
export type UpdateSliderSettingsMutationHookResult = ReturnType<typeof useUpdateSliderSettingsMutation>;
export type UpdateSliderSettingsMutationResult = Apollo.MutationResult<UpdateSliderSettingsMutation>;
export type UpdateSliderSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSliderSettingsMutation, UpdateSliderSettingsMutationVariables>;
export const AnswerEnpsSurveyCycleDocument = gql`
    mutation AnswerEnpsSurveyCycle($input: AnswerEnpsSurveyCycleInput!) {
  enpsSurveys {
    answerEnpsSurveyCycle(input: $input) {
      error
    }
  }
}
    `;
export type AnswerEnpsSurveyCycleMutationFn = Apollo.MutationFunction<AnswerEnpsSurveyCycleMutation, AnswerEnpsSurveyCycleMutationVariables>;

/**
 * __useAnswerEnpsSurveyCycleMutation__
 *
 * To run a mutation, you first call `useAnswerEnpsSurveyCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerEnpsSurveyCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerEnpsSurveyCycleMutation, { data, loading, error }] = useAnswerEnpsSurveyCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerEnpsSurveyCycleMutation(baseOptions?: Apollo.MutationHookOptions<AnswerEnpsSurveyCycleMutation, AnswerEnpsSurveyCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerEnpsSurveyCycleMutation, AnswerEnpsSurveyCycleMutationVariables>(AnswerEnpsSurveyCycleDocument, options);
      }
export type AnswerEnpsSurveyCycleMutationHookResult = ReturnType<typeof useAnswerEnpsSurveyCycleMutation>;
export type AnswerEnpsSurveyCycleMutationResult = Apollo.MutationResult<AnswerEnpsSurveyCycleMutation>;
export type AnswerEnpsSurveyCycleMutationOptions = Apollo.BaseMutationOptions<AnswerEnpsSurveyCycleMutation, AnswerEnpsSurveyCycleMutationVariables>;
export const DismissEnpsSurveyCycleDocument = gql`
    mutation DismissEnpsSurveyCycle($input: DismissEnpsSurveyCycleInput!) {
  enpsSurveys {
    dismissEnpsSurveyCycle(input: $input) {
      error
    }
  }
}
    `;
export type DismissEnpsSurveyCycleMutationFn = Apollo.MutationFunction<DismissEnpsSurveyCycleMutation, DismissEnpsSurveyCycleMutationVariables>;

/**
 * __useDismissEnpsSurveyCycleMutation__
 *
 * To run a mutation, you first call `useDismissEnpsSurveyCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissEnpsSurveyCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissEnpsSurveyCycleMutation, { data, loading, error }] = useDismissEnpsSurveyCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissEnpsSurveyCycleMutation(baseOptions?: Apollo.MutationHookOptions<DismissEnpsSurveyCycleMutation, DismissEnpsSurveyCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissEnpsSurveyCycleMutation, DismissEnpsSurveyCycleMutationVariables>(DismissEnpsSurveyCycleDocument, options);
      }
export type DismissEnpsSurveyCycleMutationHookResult = ReturnType<typeof useDismissEnpsSurveyCycleMutation>;
export type DismissEnpsSurveyCycleMutationResult = Apollo.MutationResult<DismissEnpsSurveyCycleMutation>;
export type DismissEnpsSurveyCycleMutationOptions = Apollo.BaseMutationOptions<DismissEnpsSurveyCycleMutation, DismissEnpsSurveyCycleMutationVariables>;
export const MyEnpsSurveysDocument = gql`
    query MyEnpsSurveys {
  me {
    Id
    enpsSurveys {
      id
      name
      questionText
      messageBodyText
      allowComments
      compulsory
      cycles {
        id
        startDate
        endDate
      }
    }
  }
}
    `;

/**
 * __useMyEnpsSurveysQuery__
 *
 * To run a query within a React component, call `useMyEnpsSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEnpsSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEnpsSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEnpsSurveysQuery(baseOptions?: Apollo.QueryHookOptions<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>(MyEnpsSurveysDocument, options);
      }
export function useMyEnpsSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>(MyEnpsSurveysDocument, options);
        }
export function useMyEnpsSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>(MyEnpsSurveysDocument, options);
        }
export type MyEnpsSurveysQueryHookResult = ReturnType<typeof useMyEnpsSurveysQuery>;
export type MyEnpsSurveysLazyQueryHookResult = ReturnType<typeof useMyEnpsSurveysLazyQuery>;
export type MyEnpsSurveysSuspenseQueryHookResult = ReturnType<typeof useMyEnpsSurveysSuspenseQuery>;
export type MyEnpsSurveysQueryResult = Apollo.QueryResult<MyEnpsSurveysQuery, MyEnpsSurveysQueryVariables>;
export const HomeNewHiresCardDocument = gql`
    query HomeNewHiresCard {
  newHires {
    Id
    Name
    flair__First_Name__c
    flair__Last_Name__c
    flair__Start_Date__c
    avatar {
      Id
      url
    }
    department {
      Id
      Name
    }
    location {
      Id
      Name
    }
  }
}
    `;

/**
 * __useHomeNewHiresCardQuery__
 *
 * To run a query within a React component, call `useHomeNewHiresCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeNewHiresCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeNewHiresCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeNewHiresCardQuery(baseOptions?: Apollo.QueryHookOptions<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>(HomeNewHiresCardDocument, options);
      }
export function useHomeNewHiresCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>(HomeNewHiresCardDocument, options);
        }
export function useHomeNewHiresCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>(HomeNewHiresCardDocument, options);
        }
export type HomeNewHiresCardQueryHookResult = ReturnType<typeof useHomeNewHiresCardQuery>;
export type HomeNewHiresCardLazyQueryHookResult = ReturnType<typeof useHomeNewHiresCardLazyQuery>;
export type HomeNewHiresCardSuspenseQueryHookResult = ReturnType<typeof useHomeNewHiresCardSuspenseQuery>;
export type HomeNewHiresCardQueryResult = Apollo.QueryResult<HomeNewHiresCardQuery, HomeNewHiresCardQueryVariables>;
export const HomePendingApprovalCardDocument = gql`
    query HomePendingApprovalCard($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    pendingTimeSheets(filter: {managerReportsType: $managerReportsType}) {
      Id
      flair__Start_Date__c
      employee {
        Id
        Name
      }
    }
    pendingTimeEntryChangeRequests(
      filter: {managerReportsType: $managerReportsType}
    ) {
      Id
      flair__Working_Period_In_Hours__c
      timeEntry {
        Id
        flair__Working_Period_In_Hours__c
      }
      employee {
        Id
        Name
      }
    }
    pendingExpenses(filter: {managerReportsType: $managerReportsType}) {
      Id
      flair__Expense_Date__c
      flair__Date_From__c
      employee {
        Id
        Name
      }
    }
  }
  me {
    Id
    approvalRequests(
      filter: {managerReportsType: $managerReportsType, statuses: [PENDING], relatedObjectName: "flair__Absence__c"}
    ) {
      Id
      flair__Related_Object_Name__c
      absence {
        Id
        flair__Category_Name__c
        flair__Category_Icon__c
        flair__Start_Date__c
        flair__Start_Time__c
        flair__Start_Date_Half_Day__c
        flair__End_Date__c
        flair__End_Time__c
        flair__End_Date_Half_Day__c
        flair__Type__c
        loomVideo {
          ...LoomVideo
        }
        employee {
          Id
          Name
        }
      }
    }
  }
}
    ${LoomVideoFragmentDoc}`;

/**
 * __useHomePendingApprovalCardQuery__
 *
 * To run a query within a React component, call `useHomePendingApprovalCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePendingApprovalCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePendingApprovalCardQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useHomePendingApprovalCardQuery(baseOptions: Apollo.QueryHookOptions<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables> & ({ variables: HomePendingApprovalCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables>(HomePendingApprovalCardDocument, options);
      }
export function useHomePendingApprovalCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables>(HomePendingApprovalCardDocument, options);
        }
export function useHomePendingApprovalCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables>(HomePendingApprovalCardDocument, options);
        }
export type HomePendingApprovalCardQueryHookResult = ReturnType<typeof useHomePendingApprovalCardQuery>;
export type HomePendingApprovalCardLazyQueryHookResult = ReturnType<typeof useHomePendingApprovalCardLazyQuery>;
export type HomePendingApprovalCardSuspenseQueryHookResult = ReturnType<typeof useHomePendingApprovalCardSuspenseQuery>;
export type HomePendingApprovalCardQueryResult = Apollo.QueryResult<HomePendingApprovalCardQuery, HomePendingApprovalCardQueryVariables>;
export const HomePerformaceReviewCardDocument = gql`
    query HomePerformaceReviewCard($filter: MyFeedbacksFilter!) {
  me {
    Id
    feedbacks(filter: $filter) {
      Id
      flair__State__c
      feedbackCycle {
        Id
        Name
        flair__Timeline_Type__c
      }
      outcome {
        Id
        flair__Ended_At__c
        flair__Accepted_At__c
        meeting {
          Id
          flair__Start_Datetime__c
        }
      }
    }
    feedbacksAsReviewer {
      Id
      flair__State__c
      feedbackCycle {
        Id
        Name
        flair__Timeline_Type__c
      }
      outcome {
        Id
        flair__Ended_At__c
        flair__Accepted_At__c
        meeting {
          Id
          flair__Start_Datetime__c
        }
      }
    }
  }
}
    `;

/**
 * __useHomePerformaceReviewCardQuery__
 *
 * To run a query within a React component, call `useHomePerformaceReviewCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePerformaceReviewCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePerformaceReviewCardQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHomePerformaceReviewCardQuery(baseOptions: Apollo.QueryHookOptions<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables> & ({ variables: HomePerformaceReviewCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables>(HomePerformaceReviewCardDocument, options);
      }
export function useHomePerformaceReviewCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables>(HomePerformaceReviewCardDocument, options);
        }
export function useHomePerformaceReviewCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables>(HomePerformaceReviewCardDocument, options);
        }
export type HomePerformaceReviewCardQueryHookResult = ReturnType<typeof useHomePerformaceReviewCardQuery>;
export type HomePerformaceReviewCardLazyQueryHookResult = ReturnType<typeof useHomePerformaceReviewCardLazyQuery>;
export type HomePerformaceReviewCardSuspenseQueryHookResult = ReturnType<typeof useHomePerformaceReviewCardSuspenseQuery>;
export type HomePerformaceReviewCardQueryResult = Apollo.QueryResult<HomePerformaceReviewCardQuery, HomePerformaceReviewCardQueryVariables>;
export const GotoCourseUrlDocument = gql`
    mutation gotoCourseUrl($id: String!) {
  courses {
    gotoCourseUrl(employeeCourseId: $id)
  }
}
    `;
export type GotoCourseUrlMutationFn = Apollo.MutationFunction<GotoCourseUrlMutation, GotoCourseUrlMutationVariables>;

/**
 * __useGotoCourseUrlMutation__
 *
 * To run a mutation, you first call `useGotoCourseUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGotoCourseUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gotoCourseUrlMutation, { data, loading, error }] = useGotoCourseUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGotoCourseUrlMutation(baseOptions?: Apollo.MutationHookOptions<GotoCourseUrlMutation, GotoCourseUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GotoCourseUrlMutation, GotoCourseUrlMutationVariables>(GotoCourseUrlDocument, options);
      }
export type GotoCourseUrlMutationHookResult = ReturnType<typeof useGotoCourseUrlMutation>;
export type GotoCourseUrlMutationResult = Apollo.MutationResult<GotoCourseUrlMutation>;
export type GotoCourseUrlMutationOptions = Apollo.BaseMutationOptions<GotoCourseUrlMutation, GotoCourseUrlMutationVariables>;
export const EmployeeCoursesDocument = gql`
    query EmployeeCourses($employeeId: String!) {
  employeeCourses(employeeId: $employeeId) {
    ...CoursesTable_EmployeeCourse
  }
}
    ${CoursesTable_EmployeeCourseFragmentDoc}`;

/**
 * __useEmployeeCoursesQuery__
 *
 * To run a query within a React component, call `useEmployeeCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeCoursesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeCoursesQuery(baseOptions: Apollo.QueryHookOptions<EmployeeCoursesQuery, EmployeeCoursesQueryVariables> & ({ variables: EmployeeCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeCoursesQuery, EmployeeCoursesQueryVariables>(EmployeeCoursesDocument, options);
      }
export function useEmployeeCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeCoursesQuery, EmployeeCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeCoursesQuery, EmployeeCoursesQueryVariables>(EmployeeCoursesDocument, options);
        }
export function useEmployeeCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeCoursesQuery, EmployeeCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeCoursesQuery, EmployeeCoursesQueryVariables>(EmployeeCoursesDocument, options);
        }
export type EmployeeCoursesQueryHookResult = ReturnType<typeof useEmployeeCoursesQuery>;
export type EmployeeCoursesLazyQueryHookResult = ReturnType<typeof useEmployeeCoursesLazyQuery>;
export type EmployeeCoursesSuspenseQueryHookResult = ReturnType<typeof useEmployeeCoursesSuspenseQuery>;
export type EmployeeCoursesQueryResult = Apollo.QueryResult<EmployeeCoursesQuery, EmployeeCoursesQueryVariables>;
export const InventoryFilterDocument = gql`
    query InventoryFilter {
  inventoryCategories {
    Name
  }
  locations {
    Id
    Name
  }
}
    `;

/**
 * __useInventoryFilterQuery__
 *
 * To run a query within a React component, call `useInventoryFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryFilterQuery(baseOptions?: Apollo.QueryHookOptions<InventoryFilterQuery, InventoryFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryFilterQuery, InventoryFilterQueryVariables>(InventoryFilterDocument, options);
      }
export function useInventoryFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryFilterQuery, InventoryFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryFilterQuery, InventoryFilterQueryVariables>(InventoryFilterDocument, options);
        }
export function useInventoryFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryFilterQuery, InventoryFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryFilterQuery, InventoryFilterQueryVariables>(InventoryFilterDocument, options);
        }
export type InventoryFilterQueryHookResult = ReturnType<typeof useInventoryFilterQuery>;
export type InventoryFilterLazyQueryHookResult = ReturnType<typeof useInventoryFilterLazyQuery>;
export type InventoryFilterSuspenseQueryHookResult = ReturnType<typeof useInventoryFilterSuspenseQuery>;
export type InventoryFilterQueryResult = Apollo.QueryResult<InventoryFilterQuery, InventoryFilterQueryVariables>;
export const InventoryListDocument = gql`
    query InventoryList($filter: InventoryItemFilterInput!, $sort: InventoryItemSortInput, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!, $employeeId: String!) {
  inventoryItemsPagination(
    employeeId: $employeeId
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    items {
      ...InventoryListData
    }
    paginationInfo @skip(if: $skipPaginationInfo) {
      totalCount
    }
  }
}
    ${InventoryListDataFragmentDoc}`;

/**
 * __useInventoryListQuery__
 *
 * To run a query within a React component, call `useInventoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useInventoryListQuery(baseOptions: Apollo.QueryHookOptions<InventoryListQuery, InventoryListQueryVariables> & ({ variables: InventoryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryListQuery, InventoryListQueryVariables>(InventoryListDocument, options);
      }
export function useInventoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryListQuery, InventoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryListQuery, InventoryListQueryVariables>(InventoryListDocument, options);
        }
export function useInventoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryListQuery, InventoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryListQuery, InventoryListQueryVariables>(InventoryListDocument, options);
        }
export type InventoryListQueryHookResult = ReturnType<typeof useInventoryListQuery>;
export type InventoryListLazyQueryHookResult = ReturnType<typeof useInventoryListLazyQuery>;
export type InventoryListSuspenseQueryHookResult = ReturnType<typeof useInventoryListSuspenseQuery>;
export type InventoryListQueryResult = Apollo.QueryResult<InventoryListQuery, InventoryListQueryVariables>;
export const UpdateInventoryStatusDocument = gql`
    mutation UpdateInventoryStatus($input: UpdateInventoryItemStatusInput!) {
  inventory {
    updateInventoryItemStatus(input: $input) {
      record {
        Id
        flair__Approval_Status__c
      }
    }
  }
}
    `;
export type UpdateInventoryStatusMutationFn = Apollo.MutationFunction<UpdateInventoryStatusMutation, UpdateInventoryStatusMutationVariables>;

/**
 * __useUpdateInventoryStatusMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryStatusMutation, { data, loading, error }] = useUpdateInventoryStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryStatusMutation, UpdateInventoryStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryStatusMutation, UpdateInventoryStatusMutationVariables>(UpdateInventoryStatusDocument, options);
      }
export type UpdateInventoryStatusMutationHookResult = ReturnType<typeof useUpdateInventoryStatusMutation>;
export type UpdateInventoryStatusMutationResult = Apollo.MutationResult<UpdateInventoryStatusMutation>;
export type UpdateInventoryStatusMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryStatusMutation, UpdateInventoryStatusMutationVariables>;
export const InventorySidebarDocument = gql`
    query InventorySidebar($id: String!) {
  inventoryItemById(id: $id) {
    ...InventorySidebarData
  }
}
    ${InventorySidebarDataFragmentDoc}`;

/**
 * __useInventorySidebarQuery__
 *
 * To run a query within a React component, call `useInventorySidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventorySidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventorySidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventorySidebarQuery(baseOptions: Apollo.QueryHookOptions<InventorySidebarQuery, InventorySidebarQueryVariables> & ({ variables: InventorySidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventorySidebarQuery, InventorySidebarQueryVariables>(InventorySidebarDocument, options);
      }
export function useInventorySidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventorySidebarQuery, InventorySidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventorySidebarQuery, InventorySidebarQueryVariables>(InventorySidebarDocument, options);
        }
export function useInventorySidebarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventorySidebarQuery, InventorySidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventorySidebarQuery, InventorySidebarQueryVariables>(InventorySidebarDocument, options);
        }
export type InventorySidebarQueryHookResult = ReturnType<typeof useInventorySidebarQuery>;
export type InventorySidebarLazyQueryHookResult = ReturnType<typeof useInventorySidebarLazyQuery>;
export type InventorySidebarSuspenseQueryHookResult = ReturnType<typeof useInventorySidebarSuspenseQuery>;
export type InventorySidebarQueryResult = Apollo.QueryResult<InventorySidebarQuery, InventorySidebarQueryVariables>;
export const AddInventoryDocument = gql`
    mutation AddInventory($input: AddInventoryInput!) {
  inventory {
    addInventory(input: $input) {
      recordId
    }
  }
}
    `;
export type AddInventoryMutationFn = Apollo.MutationFunction<AddInventoryMutation, AddInventoryMutationVariables>;

/**
 * __useAddInventoryMutation__
 *
 * To run a mutation, you first call `useAddInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInventoryMutation, { data, loading, error }] = useAddInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInventoryMutation(baseOptions?: Apollo.MutationHookOptions<AddInventoryMutation, AddInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInventoryMutation, AddInventoryMutationVariables>(AddInventoryDocument, options);
      }
export type AddInventoryMutationHookResult = ReturnType<typeof useAddInventoryMutation>;
export type AddInventoryMutationResult = Apollo.MutationResult<AddInventoryMutation>;
export type AddInventoryMutationOptions = Apollo.BaseMutationOptions<AddInventoryMutation, AddInventoryMutationVariables>;
export const AddInventoryItemDocument = gql`
    mutation AddInventoryItem($input: AddInventoryItemInput!) {
  inventory {
    addInventoryItem(input: $input) {
      record {
        ...InventoryListData
      }
    }
  }
}
    ${InventoryListDataFragmentDoc}`;
export type AddInventoryItemMutationFn = Apollo.MutationFunction<AddInventoryItemMutation, AddInventoryItemMutationVariables>;

/**
 * __useAddInventoryItemMutation__
 *
 * To run a mutation, you first call `useAddInventoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInventoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInventoryItemMutation, { data, loading, error }] = useAddInventoryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInventoryItemMutation(baseOptions?: Apollo.MutationHookOptions<AddInventoryItemMutation, AddInventoryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInventoryItemMutation, AddInventoryItemMutationVariables>(AddInventoryItemDocument, options);
      }
export type AddInventoryItemMutationHookResult = ReturnType<typeof useAddInventoryItemMutation>;
export type AddInventoryItemMutationResult = Apollo.MutationResult<AddInventoryItemMutation>;
export type AddInventoryItemMutationOptions = Apollo.BaseMutationOptions<AddInventoryItemMutation, AddInventoryItemMutationVariables>;
export const DictionaryItemsByTypeDocument = gql`
    query DictionaryItemsByType($type: DictionaryItemType!) {
  dictionaryItemsByType(type: $type) {
    ...InventoryDictionaryData
  }
}
    ${InventoryDictionaryDataFragmentDoc}`;

/**
 * __useDictionaryItemsByTypeQuery__
 *
 * To run a query within a React component, call `useDictionaryItemsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDictionaryItemsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDictionaryItemsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDictionaryItemsByTypeQuery(baseOptions: Apollo.QueryHookOptions<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables> & ({ variables: DictionaryItemsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables>(DictionaryItemsByTypeDocument, options);
      }
export function useDictionaryItemsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables>(DictionaryItemsByTypeDocument, options);
        }
export function useDictionaryItemsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables>(DictionaryItemsByTypeDocument, options);
        }
export type DictionaryItemsByTypeQueryHookResult = ReturnType<typeof useDictionaryItemsByTypeQuery>;
export type DictionaryItemsByTypeLazyQueryHookResult = ReturnType<typeof useDictionaryItemsByTypeLazyQuery>;
export type DictionaryItemsByTypeSuspenseQueryHookResult = ReturnType<typeof useDictionaryItemsByTypeSuspenseQuery>;
export type DictionaryItemsByTypeQueryResult = Apollo.QueryResult<DictionaryItemsByTypeQuery, DictionaryItemsByTypeQueryVariables>;
export const InventoryCategoryOptionsDocument = gql`
    query InventoryCategoryOptions {
  inventoryCategories {
    ...InventoryCategoryOptions
  }
}
    ${InventoryCategoryOptionsFragmentDoc}`;

/**
 * __useInventoryCategoryOptionsQuery__
 *
 * To run a query within a React component, call `useInventoryCategoryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryCategoryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryCategoryOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryCategoryOptionsQuery(baseOptions?: Apollo.QueryHookOptions<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>(InventoryCategoryOptionsDocument, options);
      }
export function useInventoryCategoryOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>(InventoryCategoryOptionsDocument, options);
        }
export function useInventoryCategoryOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>(InventoryCategoryOptionsDocument, options);
        }
export type InventoryCategoryOptionsQueryHookResult = ReturnType<typeof useInventoryCategoryOptionsQuery>;
export type InventoryCategoryOptionsLazyQueryHookResult = ReturnType<typeof useInventoryCategoryOptionsLazyQuery>;
export type InventoryCategoryOptionsSuspenseQueryHookResult = ReturnType<typeof useInventoryCategoryOptionsSuspenseQuery>;
export type InventoryCategoryOptionsQueryResult = Apollo.QueryResult<InventoryCategoryOptionsQuery, InventoryCategoryOptionsQueryVariables>;
export const InventoryItemLocationListDocument = gql`
    query InventoryItemLocationList {
  locations {
    Id
    Name
  }
}
    `;

/**
 * __useInventoryItemLocationListQuery__
 *
 * To run a query within a React component, call `useInventoryItemLocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemLocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemLocationListQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryItemLocationListQuery(baseOptions?: Apollo.QueryHookOptions<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>(InventoryItemLocationListDocument, options);
      }
export function useInventoryItemLocationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>(InventoryItemLocationListDocument, options);
        }
export function useInventoryItemLocationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>(InventoryItemLocationListDocument, options);
        }
export type InventoryItemLocationListQueryHookResult = ReturnType<typeof useInventoryItemLocationListQuery>;
export type InventoryItemLocationListLazyQueryHookResult = ReturnType<typeof useInventoryItemLocationListLazyQuery>;
export type InventoryItemLocationListSuspenseQueryHookResult = ReturnType<typeof useInventoryItemLocationListSuspenseQuery>;
export type InventoryItemLocationListQueryResult = Apollo.QueryResult<InventoryItemLocationListQuery, InventoryItemLocationListQueryVariables>;
export const InventoryItemResponsibleListDocument = gql`
    query InventoryItemResponsibleList {
  activeEmployees {
    Id
    Name
  }
}
    `;

/**
 * __useInventoryItemResponsibleListQuery__
 *
 * To run a query within a React component, call `useInventoryItemResponsibleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemResponsibleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemResponsibleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryItemResponsibleListQuery(baseOptions?: Apollo.QueryHookOptions<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>(InventoryItemResponsibleListDocument, options);
      }
export function useInventoryItemResponsibleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>(InventoryItemResponsibleListDocument, options);
        }
export function useInventoryItemResponsibleListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>(InventoryItemResponsibleListDocument, options);
        }
export type InventoryItemResponsibleListQueryHookResult = ReturnType<typeof useInventoryItemResponsibleListQuery>;
export type InventoryItemResponsibleListLazyQueryHookResult = ReturnType<typeof useInventoryItemResponsibleListLazyQuery>;
export type InventoryItemResponsibleListSuspenseQueryHookResult = ReturnType<typeof useInventoryItemResponsibleListSuspenseQuery>;
export type InventoryItemResponsibleListQueryResult = Apollo.QueryResult<InventoryItemResponsibleListQuery, InventoryItemResponsibleListQueryVariables>;
export const InventoryOptionsDocument = gql`
    query InventoryOptions {
  inventories {
    Id
    Name
    flair__Model__c
    manufacturer {
      ...InventoryDictionaryData
    }
  }
}
    ${InventoryDictionaryDataFragmentDoc}`;

/**
 * __useInventoryOptionsQuery__
 *
 * To run a query within a React component, call `useInventoryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryOptionsQuery(baseOptions?: Apollo.QueryHookOptions<InventoryOptionsQuery, InventoryOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryOptionsQuery, InventoryOptionsQueryVariables>(InventoryOptionsDocument, options);
      }
export function useInventoryOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryOptionsQuery, InventoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryOptionsQuery, InventoryOptionsQueryVariables>(InventoryOptionsDocument, options);
        }
export function useInventoryOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryOptionsQuery, InventoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryOptionsQuery, InventoryOptionsQueryVariables>(InventoryOptionsDocument, options);
        }
export type InventoryOptionsQueryHookResult = ReturnType<typeof useInventoryOptionsQuery>;
export type InventoryOptionsLazyQueryHookResult = ReturnType<typeof useInventoryOptionsLazyQuery>;
export type InventoryOptionsSuspenseQueryHookResult = ReturnType<typeof useInventoryOptionsSuspenseQuery>;
export type InventoryOptionsQueryResult = Apollo.QueryResult<InventoryOptionsQuery, InventoryOptionsQueryVariables>;
export const PendingTimeEntryChangeRequestsDocument = gql`
    query PendingTimeEntryChangeRequests($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    pendingTimeEntryChangeRequests(
      filter: {managerReportsType: $managerReportsType}
    ) {
      ...TimeEntryChangeRequestTable_TimeEntryChangeRequest
    }
  }
}
    ${TimeEntryChangeRequestTable_TimeEntryChangeRequestFragmentDoc}`;

/**
 * __usePendingTimeEntryChangeRequestsQuery__
 *
 * To run a query within a React component, call `usePendingTimeEntryChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingTimeEntryChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingTimeEntryChangeRequestsQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function usePendingTimeEntryChangeRequestsQuery(baseOptions: Apollo.QueryHookOptions<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables> & ({ variables: PendingTimeEntryChangeRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables>(PendingTimeEntryChangeRequestsDocument, options);
      }
export function usePendingTimeEntryChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables>(PendingTimeEntryChangeRequestsDocument, options);
        }
export function usePendingTimeEntryChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables>(PendingTimeEntryChangeRequestsDocument, options);
        }
export type PendingTimeEntryChangeRequestsQueryHookResult = ReturnType<typeof usePendingTimeEntryChangeRequestsQuery>;
export type PendingTimeEntryChangeRequestsLazyQueryHookResult = ReturnType<typeof usePendingTimeEntryChangeRequestsLazyQuery>;
export type PendingTimeEntryChangeRequestsSuspenseQueryHookResult = ReturnType<typeof usePendingTimeEntryChangeRequestsSuspenseQuery>;
export type PendingTimeEntryChangeRequestsQueryResult = Apollo.QueryResult<PendingTimeEntryChangeRequestsQuery, PendingTimeEntryChangeRequestsQueryVariables>;
export const CreateAnnouncementEmojiDocument = gql`
    mutation CreateAnnouncementEmoji($input: CreateEmojiInput!) {
  announcements {
    create(input: $input) {
      announcement {
        Id
        emojis {
          ...AnnouncementEmoji
        }
      }
    }
  }
}
    ${AnnouncementEmojiFragmentDoc}`;
export type CreateAnnouncementEmojiMutationFn = Apollo.MutationFunction<CreateAnnouncementEmojiMutation, CreateAnnouncementEmojiMutationVariables>;

/**
 * __useCreateAnnouncementEmojiMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementEmojiMutation, { data, loading, error }] = useCreateAnnouncementEmojiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementEmojiMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnouncementEmojiMutation, CreateAnnouncementEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnouncementEmojiMutation, CreateAnnouncementEmojiMutationVariables>(CreateAnnouncementEmojiDocument, options);
      }
export type CreateAnnouncementEmojiMutationHookResult = ReturnType<typeof useCreateAnnouncementEmojiMutation>;
export type CreateAnnouncementEmojiMutationResult = Apollo.MutationResult<CreateAnnouncementEmojiMutation>;
export type CreateAnnouncementEmojiMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementEmojiMutation, CreateAnnouncementEmojiMutationVariables>;
export const DeleteAnnouncementEmojiDocument = gql`
    mutation DeleteAnnouncementEmoji($input: DeleteEmojiInput!) {
  announcements {
    delete(input: $input) {
      announcement {
        Id
        emojis {
          ...AnnouncementEmoji
        }
      }
    }
  }
}
    ${AnnouncementEmojiFragmentDoc}`;
export type DeleteAnnouncementEmojiMutationFn = Apollo.MutationFunction<DeleteAnnouncementEmojiMutation, DeleteAnnouncementEmojiMutationVariables>;

/**
 * __useDeleteAnnouncementEmojiMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementEmojiMutation, { data, loading, error }] = useDeleteAnnouncementEmojiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnnouncementEmojiMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnouncementEmojiMutation, DeleteAnnouncementEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnouncementEmojiMutation, DeleteAnnouncementEmojiMutationVariables>(DeleteAnnouncementEmojiDocument, options);
      }
export type DeleteAnnouncementEmojiMutationHookResult = ReturnType<typeof useDeleteAnnouncementEmojiMutation>;
export type DeleteAnnouncementEmojiMutationResult = Apollo.MutationResult<DeleteAnnouncementEmojiMutation>;
export type DeleteAnnouncementEmojiMutationOptions = Apollo.BaseMutationOptions<DeleteAnnouncementEmojiMutation, DeleteAnnouncementEmojiMutationVariables>;
export const AnnouncementDocument = gql`
    query Announcement {
  announcements {
    ...Announcement
  }
}
    ${AnnouncementFragmentDoc}`;

/**
 * __useAnnouncementQuery__
 *
 * To run a query within a React component, call `useAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnnouncementQuery(baseOptions?: Apollo.QueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument, options);
      }
export function useAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument, options);
        }
export function useAnnouncementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument, options);
        }
export type AnnouncementQueryHookResult = ReturnType<typeof useAnnouncementQuery>;
export type AnnouncementLazyQueryHookResult = ReturnType<typeof useAnnouncementLazyQuery>;
export type AnnouncementSuspenseQueryHookResult = ReturnType<typeof useAnnouncementSuspenseQuery>;
export type AnnouncementQueryResult = Apollo.QueryResult<AnnouncementQuery, AnnouncementQueryVariables>;
export const DirectoryFiltersDocument = gql`
    query DirectoryFilters {
  activeEmployees {
    Id
    location {
      Id
      Name
    }
    department {
      Id
      Name
    }
    teams {
      Id
      Name
    }
  }
}
    `;

/**
 * __useDirectoryFiltersQuery__
 *
 * To run a query within a React component, call `useDirectoryFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDirectoryFiltersQuery(baseOptions?: Apollo.QueryHookOptions<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>(DirectoryFiltersDocument, options);
      }
export function useDirectoryFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>(DirectoryFiltersDocument, options);
        }
export function useDirectoryFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>(DirectoryFiltersDocument, options);
        }
export type DirectoryFiltersQueryHookResult = ReturnType<typeof useDirectoryFiltersQuery>;
export type DirectoryFiltersLazyQueryHookResult = ReturnType<typeof useDirectoryFiltersLazyQuery>;
export type DirectoryFiltersSuspenseQueryHookResult = ReturnType<typeof useDirectoryFiltersSuspenseQuery>;
export type DirectoryFiltersQueryResult = Apollo.QueryResult<DirectoryFiltersQuery, DirectoryFiltersQueryVariables>;
export const DirectoryDocument = gql`
    query Directory($locations: [String!], $teams: [String!], $departments: [String!]) {
  activeEmployees(
    filter: {locations: $locations, teams: $teams, departments: $departments}
  ) {
    Id
    Name
    flair__Position__c
    flair__Company_Email__c
    flair__Location__c
    flair__Company_Phone_Number__c
    manager {
      Id
      Name
    }
    department {
      Id
      Name
    }
    avatar {
      Id
      url
    }
    location {
      Id
      Name
    }
    teams {
      Id
      Name
    }
    ...ExtraFieldsTable_WithExtraFields
  }
}
    ${ExtraFieldsTable_WithExtraFieldsFragmentDoc}`;

/**
 * __useDirectoryQuery__
 *
 * To run a query within a React component, call `useDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      teams: // value for 'teams'
 *      departments: // value for 'departments'
 *   },
 * });
 */
export function useDirectoryQuery(baseOptions?: Apollo.QueryHookOptions<DirectoryQuery, DirectoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryQuery, DirectoryQueryVariables>(DirectoryDocument, options);
      }
export function useDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryQuery, DirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryQuery, DirectoryQueryVariables>(DirectoryDocument, options);
        }
export function useDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryQuery, DirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryQuery, DirectoryQueryVariables>(DirectoryDocument, options);
        }
export type DirectoryQueryHookResult = ReturnType<typeof useDirectoryQuery>;
export type DirectoryLazyQueryHookResult = ReturnType<typeof useDirectoryLazyQuery>;
export type DirectorySuspenseQueryHookResult = ReturnType<typeof useDirectorySuspenseQuery>;
export type DirectoryQueryResult = Apollo.QueryResult<DirectoryQuery, DirectoryQueryVariables>;
export const OrgChartDocument = gql`
    query OrgChart {
  orgChartEmployees {
    Id
    Name
    flair__Position__c
    flair__Manager__c
    flair__Company_Email__c
    flair__Company_Phone_Number__c
    manager {
      Id
      Name
    }
    department {
      Id
      Name
    }
    avatar {
      Id
      url
    }
    location {
      Id
      Name
    }
  }
}
    `;

/**
 * __useOrgChartQuery__
 *
 * To run a query within a React component, call `useOrgChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgChartQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgChartQuery(baseOptions?: Apollo.QueryHookOptions<OrgChartQuery, OrgChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgChartQuery, OrgChartQueryVariables>(OrgChartDocument, options);
      }
export function useOrgChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgChartQuery, OrgChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgChartQuery, OrgChartQueryVariables>(OrgChartDocument, options);
        }
export function useOrgChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgChartQuery, OrgChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgChartQuery, OrgChartQueryVariables>(OrgChartDocument, options);
        }
export type OrgChartQueryHookResult = ReturnType<typeof useOrgChartQuery>;
export type OrgChartLazyQueryHookResult = ReturnType<typeof useOrgChartLazyQuery>;
export type OrgChartSuspenseQueryHookResult = ReturnType<typeof useOrgChartSuspenseQuery>;
export type OrgChartQueryResult = Apollo.QueryResult<OrgChartQuery, OrgChartQueryVariables>;
export const FetchDocumentTemplateDocument = gql`
    query FetchDocumentTemplate($feedbackOutcomeId: String!) {
  documentTemplates {
    documentTemplatesForPR(feedbackOutcomeId: $feedbackOutcomeId) {
      Id
      Name
    }
  }
}
    `;

/**
 * __useFetchDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useFetchDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDocumentTemplateQuery({
 *   variables: {
 *      feedbackOutcomeId: // value for 'feedbackOutcomeId'
 *   },
 * });
 */
export function useFetchDocumentTemplateQuery(baseOptions: Apollo.QueryHookOptions<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables> & ({ variables: FetchDocumentTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables>(FetchDocumentTemplateDocument, options);
      }
export function useFetchDocumentTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables>(FetchDocumentTemplateDocument, options);
        }
export function useFetchDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables>(FetchDocumentTemplateDocument, options);
        }
export type FetchDocumentTemplateQueryHookResult = ReturnType<typeof useFetchDocumentTemplateQuery>;
export type FetchDocumentTemplateLazyQueryHookResult = ReturnType<typeof useFetchDocumentTemplateLazyQuery>;
export type FetchDocumentTemplateSuspenseQueryHookResult = ReturnType<typeof useFetchDocumentTemplateSuspenseQuery>;
export type FetchDocumentTemplateQueryResult = Apollo.QueryResult<FetchDocumentTemplateQuery, FetchDocumentTemplateQueryVariables>;
export const GenerateAndFetchPdfForPerformanceReviewMutationDocument = gql`
    mutation GenerateAndFetchPdfForPerformanceReviewMutation($templateId: String!, $recordId: String!, $requesterType: RequesterType!) {
  documentTemplate {
    getDownloadLink(
      templateId: $templateId
      recordId: $recordId
      requesterType: $requesterType
    )
  }
}
    `;
export type GenerateAndFetchPdfForPerformanceReviewMutationMutationFn = Apollo.MutationFunction<GenerateAndFetchPdfForPerformanceReviewMutationMutation, GenerateAndFetchPdfForPerformanceReviewMutationMutationVariables>;

/**
 * __useGenerateAndFetchPdfForPerformanceReviewMutationMutation__
 *
 * To run a mutation, you first call `useGenerateAndFetchPdfForPerformanceReviewMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAndFetchPdfForPerformanceReviewMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAndFetchPdfForPerformanceReviewMutationMutation, { data, loading, error }] = useGenerateAndFetchPdfForPerformanceReviewMutationMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      recordId: // value for 'recordId'
 *      requesterType: // value for 'requesterType'
 *   },
 * });
 */
export function useGenerateAndFetchPdfForPerformanceReviewMutationMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAndFetchPdfForPerformanceReviewMutationMutation, GenerateAndFetchPdfForPerformanceReviewMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAndFetchPdfForPerformanceReviewMutationMutation, GenerateAndFetchPdfForPerformanceReviewMutationMutationVariables>(GenerateAndFetchPdfForPerformanceReviewMutationDocument, options);
      }
export type GenerateAndFetchPdfForPerformanceReviewMutationMutationHookResult = ReturnType<typeof useGenerateAndFetchPdfForPerformanceReviewMutationMutation>;
export type GenerateAndFetchPdfForPerformanceReviewMutationMutationResult = Apollo.MutationResult<GenerateAndFetchPdfForPerformanceReviewMutationMutation>;
export type GenerateAndFetchPdfForPerformanceReviewMutationMutationOptions = Apollo.BaseMutationOptions<GenerateAndFetchPdfForPerformanceReviewMutationMutation, GenerateAndFetchPdfForPerformanceReviewMutationMutationVariables>;
export const TrackDownloadPdfEventDocument = gql`
    mutation TrackDownloadPDFEvent($input: DownloadPDFAnalyticInput!) {
  performanceReview {
    trackDownloadPDFEvent(input: $input)
  }
}
    `;
export type TrackDownloadPdfEventMutationFn = Apollo.MutationFunction<TrackDownloadPdfEventMutation, TrackDownloadPdfEventMutationVariables>;

/**
 * __useTrackDownloadPdfEventMutation__
 *
 * To run a mutation, you first call `useTrackDownloadPdfEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackDownloadPdfEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackDownloadPdfEventMutation, { data, loading, error }] = useTrackDownloadPdfEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackDownloadPdfEventMutation(baseOptions?: Apollo.MutationHookOptions<TrackDownloadPdfEventMutation, TrackDownloadPdfEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackDownloadPdfEventMutation, TrackDownloadPdfEventMutationVariables>(TrackDownloadPdfEventDocument, options);
      }
export type TrackDownloadPdfEventMutationHookResult = ReturnType<typeof useTrackDownloadPdfEventMutation>;
export type TrackDownloadPdfEventMutationResult = Apollo.MutationResult<TrackDownloadPdfEventMutation>;
export type TrackDownloadPdfEventMutationOptions = Apollo.BaseMutationOptions<TrackDownloadPdfEventMutation, TrackDownloadPdfEventMutationVariables>;
export const ActiveEmployees_PeerReviewersDocument = gql`
    query ActiveEmployees_PeerReviewers($searchTerm: String) {
  activeEmployees(
    filter: {searchTerm: $searchTerm}
    pagination: {offset: 0, limit: 10}
  ) {
    Id
    Name
  }
}
    `;

/**
 * __useActiveEmployees_PeerReviewersQuery__
 *
 * To run a query within a React component, call `useActiveEmployees_PeerReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveEmployees_PeerReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveEmployees_PeerReviewersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useActiveEmployees_PeerReviewersQuery(baseOptions?: Apollo.QueryHookOptions<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>(ActiveEmployees_PeerReviewersDocument, options);
      }
export function useActiveEmployees_PeerReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>(ActiveEmployees_PeerReviewersDocument, options);
        }
export function useActiveEmployees_PeerReviewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>(ActiveEmployees_PeerReviewersDocument, options);
        }
export type ActiveEmployees_PeerReviewersQueryHookResult = ReturnType<typeof useActiveEmployees_PeerReviewersQuery>;
export type ActiveEmployees_PeerReviewersLazyQueryHookResult = ReturnType<typeof useActiveEmployees_PeerReviewersLazyQuery>;
export type ActiveEmployees_PeerReviewersSuspenseQueryHookResult = ReturnType<typeof useActiveEmployees_PeerReviewersSuspenseQuery>;
export type ActiveEmployees_PeerReviewersQueryResult = Apollo.QueryResult<ActiveEmployees_PeerReviewersQuery, ActiveEmployees_PeerReviewersQueryVariables>;
export const PerformanceEmployeeEvaluationDocument = gql`
    query PerformanceEmployeeEvaluation($feedbackId: String!) {
  me {
    Id
    objectives {
      Id
      Name
      flair__Employee_Feedback_Outcome__c
      flair__Rate__c
    }
  }
  employeeFeedback(feedbackId: $feedbackId) {
    Id
    flair__State__c
    flair__Feedback_From__c
    flair__Deadline__c
    flair__Is_Peer_Reviewer__c
    flair__Self_Evaluation__c
    flair__Submitted_At__c
    CreatedDate
    feedbackCycle {
      ...FeedbackCycle_PerformanceReview
    }
    reviewee {
      Id
      Name
    }
    outcome {
      Id
      flair__Ended_At__c
      meeting {
        Id
        flair__Start_Datetime__c
      }
      openObjectives {
        Id
        Name
        flair__Description__c
        flair__Due_Date__c
        flair__Finished_Feedback_Outcome__c
        flair__Rate_Reason__c
        flair__Rate__c
        parent {
          Id
          Name
        }
      }
      finishedObjectives {
        Id
        Name
        flair__Description__c
        flair__Due_Date__c
        flair__Finished_Feedback_Outcome__c
        flair__Rate_Reason__c
        flair__Rate__c
        parent {
          Id
          Name
        }
      }
    }
    answers {
      Id
      flair__Employee_Feedback_Request__c
      flair__Feedback__c
      flair__Note__c
      question {
        ...FeedbackCycleQuestions_PerformanceReview
      }
    }
    employeeFeedback {
      ...EmployeeFeedback_PerformanceReview
      reviewee {
        Id
        Name
      }
      answers {
        Id
        flair__Employee_Feedback_Question__c
        flair__Note__c
        feedbackAnswer
      }
    }
    peerFeedbacks {
      ...PeerFeedback
    }
  }
}
    ${FeedbackCycle_PerformanceReviewFragmentDoc}
${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}
${EmployeeFeedback_PerformanceReviewFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __usePerformanceEmployeeEvaluationQuery__
 *
 * To run a query within a React component, call `usePerformanceEmployeeEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceEmployeeEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceEmployeeEvaluationQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function usePerformanceEmployeeEvaluationQuery(baseOptions: Apollo.QueryHookOptions<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables> & ({ variables: PerformanceEmployeeEvaluationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables>(PerformanceEmployeeEvaluationDocument, options);
      }
export function usePerformanceEmployeeEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables>(PerformanceEmployeeEvaluationDocument, options);
        }
export function usePerformanceEmployeeEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables>(PerformanceEmployeeEvaluationDocument, options);
        }
export type PerformanceEmployeeEvaluationQueryHookResult = ReturnType<typeof usePerformanceEmployeeEvaluationQuery>;
export type PerformanceEmployeeEvaluationLazyQueryHookResult = ReturnType<typeof usePerformanceEmployeeEvaluationLazyQuery>;
export type PerformanceEmployeeEvaluationSuspenseQueryHookResult = ReturnType<typeof usePerformanceEmployeeEvaluationSuspenseQuery>;
export type PerformanceEmployeeEvaluationQueryResult = Apollo.QueryResult<PerformanceEmployeeEvaluationQuery, PerformanceEmployeeEvaluationQueryVariables>;
export const SubmitEmployeeFeedbackDocument = gql`
    mutation SubmitEmployeeFeedback($input: SubmitEmployeeFeedbackInput!) {
  submitEmployeeFeedback(input: $input)
}
    `;
export type SubmitEmployeeFeedbackMutationFn = Apollo.MutationFunction<SubmitEmployeeFeedbackMutation, SubmitEmployeeFeedbackMutationVariables>;

/**
 * __useSubmitEmployeeFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitEmployeeFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEmployeeFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEmployeeFeedbackMutation, { data, loading, error }] = useSubmitEmployeeFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEmployeeFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEmployeeFeedbackMutation, SubmitEmployeeFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEmployeeFeedbackMutation, SubmitEmployeeFeedbackMutationVariables>(SubmitEmployeeFeedbackDocument, options);
      }
export type SubmitEmployeeFeedbackMutationHookResult = ReturnType<typeof useSubmitEmployeeFeedbackMutation>;
export type SubmitEmployeeFeedbackMutationResult = Apollo.MutationResult<SubmitEmployeeFeedbackMutation>;
export type SubmitEmployeeFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitEmployeeFeedbackMutation, SubmitEmployeeFeedbackMutationVariables>;
export const CreatePeerReviewersDocument = gql`
    mutation CreatePeerReviewers($input: CreatePeerReviewerInput!) {
  employeeFeedback {
    createPeerReviewers(input: $input) {
      currentFeedbackRequest {
        ...PeerReviewerResponse
      }
    }
  }
}
    ${PeerReviewerResponseFragmentDoc}`;
export type CreatePeerReviewersMutationFn = Apollo.MutationFunction<CreatePeerReviewersMutation, CreatePeerReviewersMutationVariables>;

/**
 * __useCreatePeerReviewersMutation__
 *
 * To run a mutation, you first call `useCreatePeerReviewersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePeerReviewersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPeerReviewersMutation, { data, loading, error }] = useCreatePeerReviewersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePeerReviewersMutation(baseOptions?: Apollo.MutationHookOptions<CreatePeerReviewersMutation, CreatePeerReviewersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePeerReviewersMutation, CreatePeerReviewersMutationVariables>(CreatePeerReviewersDocument, options);
      }
export type CreatePeerReviewersMutationHookResult = ReturnType<typeof useCreatePeerReviewersMutation>;
export type CreatePeerReviewersMutationResult = Apollo.MutationResult<CreatePeerReviewersMutation>;
export type CreatePeerReviewersMutationOptions = Apollo.BaseMutationOptions<CreatePeerReviewersMutation, CreatePeerReviewersMutationVariables>;
export const DeletePeerReviewersDocument = gql`
    mutation DeletePeerReviewers($input: DeletePeerReviewerInput!) {
  employeeFeedback {
    deletePeerReviewers(input: $input) {
      currentFeedbackRequest {
        ...PeerReviewerResponse
      }
    }
  }
}
    ${PeerReviewerResponseFragmentDoc}`;
export type DeletePeerReviewersMutationFn = Apollo.MutationFunction<DeletePeerReviewersMutation, DeletePeerReviewersMutationVariables>;

/**
 * __useDeletePeerReviewersMutation__
 *
 * To run a mutation, you first call `useDeletePeerReviewersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePeerReviewersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePeerReviewersMutation, { data, loading, error }] = useDeletePeerReviewersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePeerReviewersMutation(baseOptions?: Apollo.MutationHookOptions<DeletePeerReviewersMutation, DeletePeerReviewersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePeerReviewersMutation, DeletePeerReviewersMutationVariables>(DeletePeerReviewersDocument, options);
      }
export type DeletePeerReviewersMutationHookResult = ReturnType<typeof useDeletePeerReviewersMutation>;
export type DeletePeerReviewersMutationResult = Apollo.MutationResult<DeletePeerReviewersMutation>;
export type DeletePeerReviewersMutationOptions = Apollo.BaseMutationOptions<DeletePeerReviewersMutation, DeletePeerReviewersMutationVariables>;
export const UpdateEmployeeMeetingDocument = gql`
    mutation UpdateEmployeeMeeting($input: UpdateEmployeeMeetingInput!) {
  updateEmployeeMeeting(input: $input)
}
    `;
export type UpdateEmployeeMeetingMutationFn = Apollo.MutationFunction<UpdateEmployeeMeetingMutation, UpdateEmployeeMeetingMutationVariables>;

/**
 * __useUpdateEmployeeMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMeetingMutation, { data, loading, error }] = useUpdateEmployeeMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMeetingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMeetingMutation, UpdateEmployeeMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMeetingMutation, UpdateEmployeeMeetingMutationVariables>(UpdateEmployeeMeetingDocument, options);
      }
export type UpdateEmployeeMeetingMutationHookResult = ReturnType<typeof useUpdateEmployeeMeetingMutation>;
export type UpdateEmployeeMeetingMutationResult = Apollo.MutationResult<UpdateEmployeeMeetingMutation>;
export type UpdateEmployeeMeetingMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMeetingMutation, UpdateEmployeeMeetingMutationVariables>;
export const ChangeReviewerDocument = gql`
    mutation ChangeReviewer($input: ChangeReviewerInput!) {
  performanceReview {
    changeReviewer(input: $input) {
      recordId
    }
  }
}
    `;
export type ChangeReviewerMutationFn = Apollo.MutationFunction<ChangeReviewerMutation, ChangeReviewerMutationVariables>;

/**
 * __useChangeReviewerMutation__
 *
 * To run a mutation, you first call `useChangeReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeReviewerMutation, { data, loading, error }] = useChangeReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeReviewerMutation(baseOptions?: Apollo.MutationHookOptions<ChangeReviewerMutation, ChangeReviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeReviewerMutation, ChangeReviewerMutationVariables>(ChangeReviewerDocument, options);
      }
export type ChangeReviewerMutationHookResult = ReturnType<typeof useChangeReviewerMutation>;
export type ChangeReviewerMutationResult = Apollo.MutationResult<ChangeReviewerMutation>;
export type ChangeReviewerMutationOptions = Apollo.BaseMutationOptions<ChangeReviewerMutation, ChangeReviewerMutationVariables>;
export const EmployeePerformanceReviewMeetingComparedFeedbackPageDocument = gql`
    query EmployeePerformanceReviewMeetingComparedFeedbackPage($feedbackId: String!) {
  me {
    Id
  }
  employeeFeedback(feedbackId: $feedbackId) {
    Id
    flair__State__c
    flair__Feedback_From__c
    flair__Deadline__c
    flair__Is_Peer_Reviewer__c
    flair__Self_Evaluation__c
    CreatedDate
    feedbackCycle {
      ...FeedbackCycle_PerformanceReview
      questions {
        ...FeedbackCycleQuestions_PerformanceReview
      }
    }
    reviewee {
      Id
      Name
    }
    outcome {
      Id
      flair__Ended_At__c
      resolutions {
        Id
        flair__Employee_Feedback_Question__c
        flair__Resolution__c
      }
      meeting {
        Id
        flair__Start_Datetime__c
      }
    }
    employeeFeedback {
      ...EmployeeFeedback_PerformanceReview
      answers {
        Id
        flair__Employee_Feedback_Question__c
        flair__Note__c
        feedbackAnswer
      }
    }
    answers {
      Id
      flair__Employee_Feedback_Question__c
      flair__Note__c
      feedbackAnswer
    }
    reviewer {
      Id
      Name
    }
    peerFeedbacks {
      ...PeerFeedback
    }
  }
}
    ${FeedbackCycle_PerformanceReviewFragmentDoc}
${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}
${EmployeeFeedback_PerformanceReviewFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __useEmployeePerformanceReviewMeetingComparedFeedbackPageQuery__
 *
 * To run a query within a React component, call `useEmployeePerformanceReviewMeetingComparedFeedbackPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePerformanceReviewMeetingComparedFeedbackPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePerformanceReviewMeetingComparedFeedbackPageQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useEmployeePerformanceReviewMeetingComparedFeedbackPageQuery(baseOptions: Apollo.QueryHookOptions<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables> & ({ variables: EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables>(EmployeePerformanceReviewMeetingComparedFeedbackPageDocument, options);
      }
export function useEmployeePerformanceReviewMeetingComparedFeedbackPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables>(EmployeePerformanceReviewMeetingComparedFeedbackPageDocument, options);
        }
export function useEmployeePerformanceReviewMeetingComparedFeedbackPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables>(EmployeePerformanceReviewMeetingComparedFeedbackPageDocument, options);
        }
export type EmployeePerformanceReviewMeetingComparedFeedbackPageQueryHookResult = ReturnType<typeof useEmployeePerformanceReviewMeetingComparedFeedbackPageQuery>;
export type EmployeePerformanceReviewMeetingComparedFeedbackPageLazyQueryHookResult = ReturnType<typeof useEmployeePerformanceReviewMeetingComparedFeedbackPageLazyQuery>;
export type EmployeePerformanceReviewMeetingComparedFeedbackPageSuspenseQueryHookResult = ReturnType<typeof useEmployeePerformanceReviewMeetingComparedFeedbackPageSuspenseQuery>;
export type EmployeePerformanceReviewMeetingComparedFeedbackPageQueryResult = Apollo.QueryResult<EmployeePerformanceReviewMeetingComparedFeedbackPageQuery, EmployeePerformanceReviewMeetingComparedFeedbackPageQueryVariables>;
export const UpdateEmployeeFeedbackResolutionDocument = gql`
    mutation UpdateEmployeeFeedbackResolution($input: UpdateEmployeeFeedbackResolution!) {
  updateEmployeeFeedbackResolution(input: $input)
}
    `;
export type UpdateEmployeeFeedbackResolutionMutationFn = Apollo.MutationFunction<UpdateEmployeeFeedbackResolutionMutation, UpdateEmployeeFeedbackResolutionMutationVariables>;

/**
 * __useUpdateEmployeeFeedbackResolutionMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeFeedbackResolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeFeedbackResolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeFeedbackResolutionMutation, { data, loading, error }] = useUpdateEmployeeFeedbackResolutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeFeedbackResolutionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeFeedbackResolutionMutation, UpdateEmployeeFeedbackResolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeFeedbackResolutionMutation, UpdateEmployeeFeedbackResolutionMutationVariables>(UpdateEmployeeFeedbackResolutionDocument, options);
      }
export type UpdateEmployeeFeedbackResolutionMutationHookResult = ReturnType<typeof useUpdateEmployeeFeedbackResolutionMutation>;
export type UpdateEmployeeFeedbackResolutionMutationResult = Apollo.MutationResult<UpdateEmployeeFeedbackResolutionMutation>;
export type UpdateEmployeeFeedbackResolutionMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeFeedbackResolutionMutation, UpdateEmployeeFeedbackResolutionMutationVariables>;
export const FinishEmployeeFeedbackOutcomeDocument = gql`
    mutation FinishEmployeeFeedbackOutcome($input: FinishEmployeeFeedbackOutcomeInput!) {
  finishEmployeeFeedbackOutcome(input: $input)
}
    `;
export type FinishEmployeeFeedbackOutcomeMutationFn = Apollo.MutationFunction<FinishEmployeeFeedbackOutcomeMutation, FinishEmployeeFeedbackOutcomeMutationVariables>;

/**
 * __useFinishEmployeeFeedbackOutcomeMutation__
 *
 * To run a mutation, you first call `useFinishEmployeeFeedbackOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishEmployeeFeedbackOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishEmployeeFeedbackOutcomeMutation, { data, loading, error }] = useFinishEmployeeFeedbackOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishEmployeeFeedbackOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<FinishEmployeeFeedbackOutcomeMutation, FinishEmployeeFeedbackOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishEmployeeFeedbackOutcomeMutation, FinishEmployeeFeedbackOutcomeMutationVariables>(FinishEmployeeFeedbackOutcomeDocument, options);
      }
export type FinishEmployeeFeedbackOutcomeMutationHookResult = ReturnType<typeof useFinishEmployeeFeedbackOutcomeMutation>;
export type FinishEmployeeFeedbackOutcomeMutationResult = Apollo.MutationResult<FinishEmployeeFeedbackOutcomeMutation>;
export type FinishEmployeeFeedbackOutcomeMutationOptions = Apollo.BaseMutationOptions<FinishEmployeeFeedbackOutcomeMutation, FinishEmployeeFeedbackOutcomeMutationVariables>;
export const EmployeePerformanceReviewCompareFeedbackDocument = gql`
    query EmployeePerformanceReviewCompareFeedback($feedbackId: String!) {
  employeeFeedback(feedbackId: $feedbackId) {
    Id
    flair__State__c
    flair__Feedback_From__c
    flair__Deadline__c
    feedbackCycle {
      Id
      Name
      flair__Timeline_Type__c
    }
    outcome {
      Id
      flair__Ended_At__c
    }
    reviewee {
      Id
      Name
    }
  }
}
    `;

/**
 * __useEmployeePerformanceReviewCompareFeedbackQuery__
 *
 * To run a query within a React component, call `useEmployeePerformanceReviewCompareFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePerformanceReviewCompareFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePerformanceReviewCompareFeedbackQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useEmployeePerformanceReviewCompareFeedbackQuery(baseOptions: Apollo.QueryHookOptions<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables> & ({ variables: EmployeePerformanceReviewCompareFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables>(EmployeePerformanceReviewCompareFeedbackDocument, options);
      }
export function useEmployeePerformanceReviewCompareFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables>(EmployeePerformanceReviewCompareFeedbackDocument, options);
        }
export function useEmployeePerformanceReviewCompareFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables>(EmployeePerformanceReviewCompareFeedbackDocument, options);
        }
export type EmployeePerformanceReviewCompareFeedbackQueryHookResult = ReturnType<typeof useEmployeePerformanceReviewCompareFeedbackQuery>;
export type EmployeePerformanceReviewCompareFeedbackLazyQueryHookResult = ReturnType<typeof useEmployeePerformanceReviewCompareFeedbackLazyQuery>;
export type EmployeePerformanceReviewCompareFeedbackSuspenseQueryHookResult = ReturnType<typeof useEmployeePerformanceReviewCompareFeedbackSuspenseQuery>;
export type EmployeePerformanceReviewCompareFeedbackQueryResult = Apollo.QueryResult<EmployeePerformanceReviewCompareFeedbackQuery, EmployeePerformanceReviewCompareFeedbackQueryVariables>;
export const PastEmployeeFeedbackDetailsDocument = gql`
    query PastEmployeeFeedbackDetails($feedbackId: String!) {
  employeeFeedback(feedbackId: $feedbackId) {
    Id
    flair__State__c
    flair__Feedback_From__c
    flair__Deadline__c
    flair__Is_Peer_Reviewer__c
    flair__Self_Evaluation__c
    flair__Submitted_At__c
    CreatedDate
    feedbackCycle {
      ...FeedbackCycle_PerformanceReview
      questions {
        ...FeedbackCycleQuestions_PerformanceReview
      }
    }
    reviewee {
      Id
      Name
    }
    outcome {
      Id
      flair__Accepted_At__c
      flair__Ended_At__c
      flair__Completed__c
      resolutions {
        Id
        flair__Employee_Feedback_Question__c
        flair__Resolution__c
        question {
          flair__Question__c
        }
      }
      objectives {
        Id
        Name
        flair__Description__c
        flair__Due_Date__c
        flair__Finished_Feedback_Outcome__c
        flair__Rate_Reason__c
        flair__Rate__c
        parent {
          Id
          Name
        }
      }
      finishedObjectives {
        Id
        Name
        flair__Description__c
        flair__Due_Date__c
        flair__Finished_Feedback_Outcome__c
        flair__Rate_Reason__c
        flair__Rate__c
        parent {
          Id
          Name
        }
      }
      reviewer {
        Id
        Name
      }
    }
    employeeFeedback {
      Id
      flair__Submitted_At__c
      flair__Is_Peer_Reviewer__c
      answers {
        Id
        flair__Employee_Feedback_Question__c
        flair__Note__c
        feedbackAnswer
      }
    }
    answers {
      Id
      flair__Employee_Feedback_Question__c
      flair__Note__c
      feedbackAnswer
    }
    peerFeedbacks {
      ...PeerFeedback
    }
  }
}
    ${FeedbackCycle_PerformanceReviewFragmentDoc}
${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __usePastEmployeeFeedbackDetailsQuery__
 *
 * To run a query within a React component, call `usePastEmployeeFeedbackDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastEmployeeFeedbackDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastEmployeeFeedbackDetailsQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function usePastEmployeeFeedbackDetailsQuery(baseOptions: Apollo.QueryHookOptions<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables> & ({ variables: PastEmployeeFeedbackDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables>(PastEmployeeFeedbackDetailsDocument, options);
      }
export function usePastEmployeeFeedbackDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables>(PastEmployeeFeedbackDetailsDocument, options);
        }
export function usePastEmployeeFeedbackDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables>(PastEmployeeFeedbackDetailsDocument, options);
        }
export type PastEmployeeFeedbackDetailsQueryHookResult = ReturnType<typeof usePastEmployeeFeedbackDetailsQuery>;
export type PastEmployeeFeedbackDetailsLazyQueryHookResult = ReturnType<typeof usePastEmployeeFeedbackDetailsLazyQuery>;
export type PastEmployeeFeedbackDetailsSuspenseQueryHookResult = ReturnType<typeof usePastEmployeeFeedbackDetailsSuspenseQuery>;
export type PastEmployeeFeedbackDetailsQueryResult = Apollo.QueryResult<PastEmployeeFeedbackDetailsQuery, PastEmployeeFeedbackDetailsQueryVariables>;
export const DeleteEmployeeObjectiveDocument = gql`
    mutation DeleteEmployeeObjective($input: DeleteEmployeeObjectiveInput!) {
  deleteEmployeeObjective(input: $input)
}
    `;
export type DeleteEmployeeObjectiveMutationFn = Apollo.MutationFunction<DeleteEmployeeObjectiveMutation, DeleteEmployeeObjectiveMutationVariables>;

/**
 * __useDeleteEmployeeObjectiveMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeObjectiveMutation, { data, loading, error }] = useDeleteEmployeeObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmployeeObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeObjectiveMutation, DeleteEmployeeObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeObjectiveMutation, DeleteEmployeeObjectiveMutationVariables>(DeleteEmployeeObjectiveDocument, options);
      }
export type DeleteEmployeeObjectiveMutationHookResult = ReturnType<typeof useDeleteEmployeeObjectiveMutation>;
export type DeleteEmployeeObjectiveMutationResult = Apollo.MutationResult<DeleteEmployeeObjectiveMutation>;
export type DeleteEmployeeObjectiveMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeObjectiveMutation, DeleteEmployeeObjectiveMutationVariables>;
export const ObjectiveDocument = gql`
    query Objective($objectiveId: ObjectiveIdInput!) {
  objective(objectiveId: $objectiveId) {
    ... on EmployeeObjective {
      ...EmployeeObjectiveDetails
    }
    ... on TeamObjective {
      ...TeamObjectiveDetails
    }
    ... on CompanyObjective {
      ...CompanyObjectiveDetails
    }
  }
}
    ${EmployeeObjectiveDetailsFragmentDoc}
${TeamObjectiveDetailsFragmentDoc}
${CompanyObjectiveDetailsFragmentDoc}`;

/**
 * __useObjectiveQuery__
 *
 * To run a query within a React component, call `useObjectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectiveQuery({
 *   variables: {
 *      objectiveId: // value for 'objectiveId'
 *   },
 * });
 */
export function useObjectiveQuery(baseOptions: Apollo.QueryHookOptions<ObjectiveQuery, ObjectiveQueryVariables> & ({ variables: ObjectiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectiveQuery, ObjectiveQueryVariables>(ObjectiveDocument, options);
      }
export function useObjectiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectiveQuery, ObjectiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectiveQuery, ObjectiveQueryVariables>(ObjectiveDocument, options);
        }
export function useObjectiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ObjectiveQuery, ObjectiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ObjectiveQuery, ObjectiveQueryVariables>(ObjectiveDocument, options);
        }
export type ObjectiveQueryHookResult = ReturnType<typeof useObjectiveQuery>;
export type ObjectiveLazyQueryHookResult = ReturnType<typeof useObjectiveLazyQuery>;
export type ObjectiveSuspenseQueryHookResult = ReturnType<typeof useObjectiveSuspenseQuery>;
export type ObjectiveQueryResult = Apollo.QueryResult<ObjectiveQuery, ObjectiveQueryVariables>;
export const CreateEmployeeObjectiveDocument = gql`
    mutation createEmployeeObjective($input: CreateEmployeeObjectiveInput!) {
  objectives {
    createEmployeeObjective(input: $input) {
      recordId
      error
      record {
        ...EmployeeObjective
        ...EmployeeObjectiveDetails
      }
    }
  }
}
    ${EmployeeObjectiveFragmentDoc}
${EmployeeObjectiveDetailsFragmentDoc}`;
export type CreateEmployeeObjectiveMutationFn = Apollo.MutationFunction<CreateEmployeeObjectiveMutation, CreateEmployeeObjectiveMutationVariables>;

/**
 * __useCreateEmployeeObjectiveMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeObjectiveMutation, { data, loading, error }] = useCreateEmployeeObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeObjectiveMutation, CreateEmployeeObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeObjectiveMutation, CreateEmployeeObjectiveMutationVariables>(CreateEmployeeObjectiveDocument, options);
      }
export type CreateEmployeeObjectiveMutationHookResult = ReturnType<typeof useCreateEmployeeObjectiveMutation>;
export type CreateEmployeeObjectiveMutationResult = Apollo.MutationResult<CreateEmployeeObjectiveMutation>;
export type CreateEmployeeObjectiveMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeObjectiveMutation, CreateEmployeeObjectiveMutationVariables>;
export const CloneEmployeeObjectiveDocument = gql`
    mutation cloneEmployeeObjective($input: CloneEmployeeObjectiveInput!) {
  objectives {
    cloneEmployeeObjective(input: $input) {
      recordIds
      error
    }
  }
}
    `;
export type CloneEmployeeObjectiveMutationFn = Apollo.MutationFunction<CloneEmployeeObjectiveMutation, CloneEmployeeObjectiveMutationVariables>;

/**
 * __useCloneEmployeeObjectiveMutation__
 *
 * To run a mutation, you first call `useCloneEmployeeObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneEmployeeObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneEmployeeObjectiveMutation, { data, loading, error }] = useCloneEmployeeObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneEmployeeObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<CloneEmployeeObjectiveMutation, CloneEmployeeObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneEmployeeObjectiveMutation, CloneEmployeeObjectiveMutationVariables>(CloneEmployeeObjectiveDocument, options);
      }
export type CloneEmployeeObjectiveMutationHookResult = ReturnType<typeof useCloneEmployeeObjectiveMutation>;
export type CloneEmployeeObjectiveMutationResult = Apollo.MutationResult<CloneEmployeeObjectiveMutation>;
export type CloneEmployeeObjectiveMutationOptions = Apollo.BaseMutationOptions<CloneEmployeeObjectiveMutation, CloneEmployeeObjectiveMutationVariables>;
export const CreateTeamObjectiveDocument = gql`
    mutation createTeamObjective($input: CreateTeamObjectiveInput!) {
  objectives {
    createTeamObjective(input: $input) {
      recordId
      error
      record {
        ...TeamObjective
        ...TeamObjectiveDetails
      }
    }
  }
}
    ${TeamObjectiveFragmentDoc}
${TeamObjectiveDetailsFragmentDoc}`;
export type CreateTeamObjectiveMutationFn = Apollo.MutationFunction<CreateTeamObjectiveMutation, CreateTeamObjectiveMutationVariables>;

/**
 * __useCreateTeamObjectiveMutation__
 *
 * To run a mutation, you first call `useCreateTeamObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamObjectiveMutation, { data, loading, error }] = useCreateTeamObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamObjectiveMutation, CreateTeamObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamObjectiveMutation, CreateTeamObjectiveMutationVariables>(CreateTeamObjectiveDocument, options);
      }
export type CreateTeamObjectiveMutationHookResult = ReturnType<typeof useCreateTeamObjectiveMutation>;
export type CreateTeamObjectiveMutationResult = Apollo.MutationResult<CreateTeamObjectiveMutation>;
export type CreateTeamObjectiveMutationOptions = Apollo.BaseMutationOptions<CreateTeamObjectiveMutation, CreateTeamObjectiveMutationVariables>;
export const UpdateObjectiveStatusDocument = gql`
    mutation updateObjectiveStatus($input: UpdateObjectiveStatusInput!) {
  objectives {
    updateObjectiveStatus(input: $input) {
      record {
        ... on EmployeeObjective {
          Id
          flair__Current_Status__c
          flair__Status__c
          flair__Current_Status__c
          flair__Status_Reason__c
          flair__Rate__c
          flair__RateAt__c
          rateBy {
            ...EmployeeObjectiveColleague
          }
          allHistoryItems {
            ... on ObjectiveHistoryItem {
              ...ObjectiveHistoryItem
            }
            ... on ObjectiveReferenceHistoryItem {
              ...ObjectiveReferenceHistoryItem
            }
          }
        }
        ... on TeamObjective {
          Id
          flair__Current_Status__c
          flair__Status__c
          flair__Current_Status__c
          flair__Status_Reason__c
          flair__Rate__c
          flair__RateAt__c
          rateBy {
            ...EmployeeObjectiveColleague
          }
          allHistoryItems {
            ... on ObjectiveHistoryItem {
              ...ObjectiveHistoryItem
            }
            ... on ObjectiveReferenceHistoryItem {
              ...ObjectiveReferenceHistoryItem
            }
          }
        }
      }
    }
  }
}
    ${EmployeeObjectiveColleagueFragmentDoc}
${ObjectiveHistoryItemFragmentDoc}
${ObjectiveReferenceHistoryItemFragmentDoc}`;
export type UpdateObjectiveStatusMutationFn = Apollo.MutationFunction<UpdateObjectiveStatusMutation, UpdateObjectiveStatusMutationVariables>;

/**
 * __useUpdateObjectiveStatusMutation__
 *
 * To run a mutation, you first call `useUpdateObjectiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectiveStatusMutation, { data, loading, error }] = useUpdateObjectiveStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateObjectiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectiveStatusMutation, UpdateObjectiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectiveStatusMutation, UpdateObjectiveStatusMutationVariables>(UpdateObjectiveStatusDocument, options);
      }
export type UpdateObjectiveStatusMutationHookResult = ReturnType<typeof useUpdateObjectiveStatusMutation>;
export type UpdateObjectiveStatusMutationResult = Apollo.MutationResult<UpdateObjectiveStatusMutation>;
export type UpdateObjectiveStatusMutationOptions = Apollo.BaseMutationOptions<UpdateObjectiveStatusMutation, UpdateObjectiveStatusMutationVariables>;
export const UpdateEmployeeObjectiveFieldsDocument = gql`
    mutation updateEmployeeObjectiveFields($input: UpdateEmployeeObjectiveFieldsInput!) {
  objectives {
    updateEmployeeObjectiveFields(input: $input) {
      record {
        ... on EmployeeObjective {
          ...EmployeeObjective
          ...EmployeeObjectiveDetails
        }
      }
    }
  }
}
    ${EmployeeObjectiveFragmentDoc}
${EmployeeObjectiveDetailsFragmentDoc}`;
export type UpdateEmployeeObjectiveFieldsMutationFn = Apollo.MutationFunction<UpdateEmployeeObjectiveFieldsMutation, UpdateEmployeeObjectiveFieldsMutationVariables>;

/**
 * __useUpdateEmployeeObjectiveFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeObjectiveFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeObjectiveFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeObjectiveFieldsMutation, { data, loading, error }] = useUpdateEmployeeObjectiveFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeObjectiveFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeObjectiveFieldsMutation, UpdateEmployeeObjectiveFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeObjectiveFieldsMutation, UpdateEmployeeObjectiveFieldsMutationVariables>(UpdateEmployeeObjectiveFieldsDocument, options);
      }
export type UpdateEmployeeObjectiveFieldsMutationHookResult = ReturnType<typeof useUpdateEmployeeObjectiveFieldsMutation>;
export type UpdateEmployeeObjectiveFieldsMutationResult = Apollo.MutationResult<UpdateEmployeeObjectiveFieldsMutation>;
export type UpdateEmployeeObjectiveFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeObjectiveFieldsMutation, UpdateEmployeeObjectiveFieldsMutationVariables>;
export const UpdateTeamObjectiveFieldsDocument = gql`
    mutation updateTeamObjectiveFields($input: UpdateTeamObjectiveFieldsInput!) {
  objectives {
    updateTeamObjectiveFields(input: $input) {
      record {
        ... on TeamObjective {
          ...TeamObjective
          ...TeamObjectiveDetails
        }
      }
    }
  }
}
    ${TeamObjectiveFragmentDoc}
${TeamObjectiveDetailsFragmentDoc}`;
export type UpdateTeamObjectiveFieldsMutationFn = Apollo.MutationFunction<UpdateTeamObjectiveFieldsMutation, UpdateTeamObjectiveFieldsMutationVariables>;

/**
 * __useUpdateTeamObjectiveFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamObjectiveFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamObjectiveFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamObjectiveFieldsMutation, { data, loading, error }] = useUpdateTeamObjectiveFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamObjectiveFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamObjectiveFieldsMutation, UpdateTeamObjectiveFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamObjectiveFieldsMutation, UpdateTeamObjectiveFieldsMutationVariables>(UpdateTeamObjectiveFieldsDocument, options);
      }
export type UpdateTeamObjectiveFieldsMutationHookResult = ReturnType<typeof useUpdateTeamObjectiveFieldsMutation>;
export type UpdateTeamObjectiveFieldsMutationResult = Apollo.MutationResult<UpdateTeamObjectiveFieldsMutation>;
export type UpdateTeamObjectiveFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateTeamObjectiveFieldsMutation, UpdateTeamObjectiveFieldsMutationVariables>;
export const DeleteObjectiveDocument = gql`
    mutation deleteObjective($objectiveId: ObjectiveIdInput!) {
  objectives {
    deleteObjective(objectiveId: $objectiveId) {
      error
    }
  }
}
    `;
export type DeleteObjectiveMutationFn = Apollo.MutationFunction<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>;

/**
 * __useDeleteObjectiveMutation__
 *
 * To run a mutation, you first call `useDeleteObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteObjectiveMutation, { data, loading, error }] = useDeleteObjectiveMutation({
 *   variables: {
 *      objectiveId: // value for 'objectiveId'
 *   },
 * });
 */
export function useDeleteObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>(DeleteObjectiveDocument, options);
      }
export type DeleteObjectiveMutationHookResult = ReturnType<typeof useDeleteObjectiveMutation>;
export type DeleteObjectiveMutationResult = Apollo.MutationResult<DeleteObjectiveMutation>;
export type DeleteObjectiveMutationOptions = Apollo.BaseMutationOptions<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>;
export const UpdateKeyResultDocument = gql`
    mutation UpdateKeyResult($objective: ObjectiveIdInput!, $input: UpdateObjectiveKeyResultValueInput!) {
  objectives {
    updateKeyResultValue(objective: $objective, input: $input) {
      recordId
      record {
        Id
        flair__Progress__c
        flair__Current_Value__c
        objective {
          ... on Objective {
            Id
            flair__Progress__c
            flair__Current_Status__c
            allParents {
              ... on Objective {
                Id
                flair__Progress__c
                flair__Current_Status__c
              }
            }
          }
          ... on EmployeeObjective {
            keyResultUpdates {
              ...KeyResultUpdate
            }
          }
          ... on TeamObjective {
            keyResultUpdates {
              ...KeyResultUpdate
            }
          }
        }
      }
    }
  }
}
    ${KeyResultUpdateFragmentDoc}`;
export type UpdateKeyResultMutationFn = Apollo.MutationFunction<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>;

/**
 * __useUpdateKeyResultMutation__
 *
 * To run a mutation, you first call `useUpdateKeyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyResultMutation, { data, loading, error }] = useUpdateKeyResultMutation({
 *   variables: {
 *      objective: // value for 'objective'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>(UpdateKeyResultDocument, options);
      }
export type UpdateKeyResultMutationHookResult = ReturnType<typeof useUpdateKeyResultMutation>;
export type UpdateKeyResultMutationResult = Apollo.MutationResult<UpdateKeyResultMutation>;
export type UpdateKeyResultMutationOptions = Apollo.BaseMutationOptions<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>;
export const GoalsContextPeriodsDocument = gql`
    query GoalsContextPeriods {
  activeObjectivePeriods {
    ...ObjectiveTimePeriod
  }
}
    ${ObjectiveTimePeriodFragmentDoc}`;

/**
 * __useGoalsContextPeriodsQuery__
 *
 * To run a query within a React component, call `useGoalsContextPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsContextPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsContextPeriodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoalsContextPeriodsQuery(baseOptions?: Apollo.QueryHookOptions<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>(GoalsContextPeriodsDocument, options);
      }
export function useGoalsContextPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>(GoalsContextPeriodsDocument, options);
        }
export function useGoalsContextPeriodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>(GoalsContextPeriodsDocument, options);
        }
export type GoalsContextPeriodsQueryHookResult = ReturnType<typeof useGoalsContextPeriodsQuery>;
export type GoalsContextPeriodsLazyQueryHookResult = ReturnType<typeof useGoalsContextPeriodsLazyQuery>;
export type GoalsContextPeriodsSuspenseQueryHookResult = ReturnType<typeof useGoalsContextPeriodsSuspenseQuery>;
export type GoalsContextPeriodsQueryResult = Apollo.QueryResult<GoalsContextPeriodsQuery, GoalsContextPeriodsQueryVariables>;
export const GoalsFilterDocument = gql`
    query GoalsFilter {
  tags {
    ...Tag
  }
  objectivePeriods {
    ...ObjectiveTimePeriod
  }
}
    ${TagFragmentDoc}
${ObjectiveTimePeriodFragmentDoc}`;

/**
 * __useGoalsFilterQuery__
 *
 * To run a query within a React component, call `useGoalsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoalsFilterQuery(baseOptions?: Apollo.QueryHookOptions<GoalsFilterQuery, GoalsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsFilterQuery, GoalsFilterQueryVariables>(GoalsFilterDocument, options);
      }
export function useGoalsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsFilterQuery, GoalsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsFilterQuery, GoalsFilterQueryVariables>(GoalsFilterDocument, options);
        }
export function useGoalsFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalsFilterQuery, GoalsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalsFilterQuery, GoalsFilterQueryVariables>(GoalsFilterDocument, options);
        }
export type GoalsFilterQueryHookResult = ReturnType<typeof useGoalsFilterQuery>;
export type GoalsFilterLazyQueryHookResult = ReturnType<typeof useGoalsFilterLazyQuery>;
export type GoalsFilterSuspenseQueryHookResult = ReturnType<typeof useGoalsFilterSuspenseQuery>;
export type GoalsFilterQueryResult = Apollo.QueryResult<GoalsFilterQuery, GoalsFilterQueryVariables>;
export const GoalsEmployeesDocument = gql`
    query GoalsEmployees {
  activeEmployees {
    ...EmployeeObjectiveColleague
  }
  me {
    Id
    allColleagues {
      ...EmployeeObjectiveColleague
    }
  }
  manager {
    Id
    employees {
      ...EmployeeObjectiveEmployee
    }
  }
}
    ${EmployeeObjectiveColleagueFragmentDoc}
${EmployeeObjectiveEmployeeFragmentDoc}`;

/**
 * __useGoalsEmployeesQuery__
 *
 * To run a query within a React component, call `useGoalsEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoalsEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>(GoalsEmployeesDocument, options);
      }
export function useGoalsEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>(GoalsEmployeesDocument, options);
        }
export function useGoalsEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>(GoalsEmployeesDocument, options);
        }
export type GoalsEmployeesQueryHookResult = ReturnType<typeof useGoalsEmployeesQuery>;
export type GoalsEmployeesLazyQueryHookResult = ReturnType<typeof useGoalsEmployeesLazyQuery>;
export type GoalsEmployeesSuspenseQueryHookResult = ReturnType<typeof useGoalsEmployeesSuspenseQuery>;
export type GoalsEmployeesQueryResult = Apollo.QueryResult<GoalsEmployeesQuery, GoalsEmployeesQueryVariables>;
export const GoalsDetailSelectOptionsDocument = gql`
    query GoalsDetailSelectOptions {
  tags {
    ...Tag
  }
  teams {
    ...Team
  }
  objectivePeriods {
    ...ObjectiveTimePeriod
  }
  activeObjectivePeriods {
    ...ObjectiveTimePeriod
  }
  allObjectives {
    ... on Objective {
      Id
      Name
    }
    ... on CompanyObjective {
      Id
      flair__Nested_Goals_Allowed__c
    }
  }
}
    ${TagFragmentDoc}
${TeamFragmentDoc}
${ObjectiveTimePeriodFragmentDoc}`;

/**
 * __useGoalsDetailSelectOptionsQuery__
 *
 * To run a query within a React component, call `useGoalsDetailSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsDetailSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsDetailSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoalsDetailSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>(GoalsDetailSelectOptionsDocument, options);
      }
export function useGoalsDetailSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>(GoalsDetailSelectOptionsDocument, options);
        }
export function useGoalsDetailSelectOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>(GoalsDetailSelectOptionsDocument, options);
        }
export type GoalsDetailSelectOptionsQueryHookResult = ReturnType<typeof useGoalsDetailSelectOptionsQuery>;
export type GoalsDetailSelectOptionsLazyQueryHookResult = ReturnType<typeof useGoalsDetailSelectOptionsLazyQuery>;
export type GoalsDetailSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useGoalsDetailSelectOptionsSuspenseQuery>;
export type GoalsDetailSelectOptionsQueryResult = Apollo.QueryResult<GoalsDetailSelectOptionsQuery, GoalsDetailSelectOptionsQueryVariables>;
export const GoalsFilterSelectOptionsDocument = gql`
    query GoalsFilterSelectOptions {
  tags {
    ...Tag
  }
  objectivePeriods {
    ...ObjectiveTimePeriod
  }
}
    ${TagFragmentDoc}
${ObjectiveTimePeriodFragmentDoc}`;

/**
 * __useGoalsFilterSelectOptionsQuery__
 *
 * To run a query within a React component, call `useGoalsFilterSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsFilterSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsFilterSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoalsFilterSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>(GoalsFilterSelectOptionsDocument, options);
      }
export function useGoalsFilterSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>(GoalsFilterSelectOptionsDocument, options);
        }
export function useGoalsFilterSelectOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>(GoalsFilterSelectOptionsDocument, options);
        }
export type GoalsFilterSelectOptionsQueryHookResult = ReturnType<typeof useGoalsFilterSelectOptionsQuery>;
export type GoalsFilterSelectOptionsLazyQueryHookResult = ReturnType<typeof useGoalsFilterSelectOptionsLazyQuery>;
export type GoalsFilterSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useGoalsFilterSelectOptionsSuspenseQuery>;
export type GoalsFilterSelectOptionsQueryResult = Apollo.QueryResult<GoalsFilterSelectOptionsQuery, GoalsFilterSelectOptionsQueryVariables>;
export const MyObjectivesDocument = gql`
    query MyObjectives($filter: ObjectiveFilter!) {
  me {
    ...MyObjectives
  }
}
    ${MyObjectivesFragmentDoc}`;

/**
 * __useMyObjectivesQuery__
 *
 * To run a query within a React component, call `useMyObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyObjectivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyObjectivesQuery(baseOptions: Apollo.QueryHookOptions<MyObjectivesQuery, MyObjectivesQueryVariables> & ({ variables: MyObjectivesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyObjectivesQuery, MyObjectivesQueryVariables>(MyObjectivesDocument, options);
      }
export function useMyObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyObjectivesQuery, MyObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyObjectivesQuery, MyObjectivesQueryVariables>(MyObjectivesDocument, options);
        }
export function useMyObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyObjectivesQuery, MyObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyObjectivesQuery, MyObjectivesQueryVariables>(MyObjectivesDocument, options);
        }
export type MyObjectivesQueryHookResult = ReturnType<typeof useMyObjectivesQuery>;
export type MyObjectivesLazyQueryHookResult = ReturnType<typeof useMyObjectivesLazyQuery>;
export type MyObjectivesSuspenseQueryHookResult = ReturnType<typeof useMyObjectivesSuspenseQuery>;
export type MyObjectivesQueryResult = Apollo.QueryResult<MyObjectivesQuery, MyObjectivesQueryVariables>;
export const MyColleaguesObjectivesDocument = gql`
    query MyColleaguesObjectives($filter: ObjectiveFilter!) {
  me {
    ...MyColleaguesObjectives
  }
}
    ${MyColleaguesObjectivesFragmentDoc}`;

/**
 * __useMyColleaguesObjectivesQuery__
 *
 * To run a query within a React component, call `useMyColleaguesObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyColleaguesObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyColleaguesObjectivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyColleaguesObjectivesQuery(baseOptions: Apollo.QueryHookOptions<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables> & ({ variables: MyColleaguesObjectivesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables>(MyColleaguesObjectivesDocument, options);
      }
export function useMyColleaguesObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables>(MyColleaguesObjectivesDocument, options);
        }
export function useMyColleaguesObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables>(MyColleaguesObjectivesDocument, options);
        }
export type MyColleaguesObjectivesQueryHookResult = ReturnType<typeof useMyColleaguesObjectivesQuery>;
export type MyColleaguesObjectivesLazyQueryHookResult = ReturnType<typeof useMyColleaguesObjectivesLazyQuery>;
export type MyColleaguesObjectivesSuspenseQueryHookResult = ReturnType<typeof useMyColleaguesObjectivesSuspenseQuery>;
export type MyColleaguesObjectivesQueryResult = Apollo.QueryResult<MyColleaguesObjectivesQuery, MyColleaguesObjectivesQueryVariables>;
export const AllObjectivesDocument = gql`
    query AllObjectives($filter: ObjectiveFilterManager!) {
  allObjectives(filter: $filter) {
    ... on EmployeeObjective {
      ...EmployeeObjective
    }
    ... on TeamObjective {
      ...TeamObjective
    }
    ... on CompanyObjective {
      ...CompanyObjective
    }
  }
}
    ${EmployeeObjectiveFragmentDoc}
${TeamObjectiveFragmentDoc}
${CompanyObjectiveFragmentDoc}`;

/**
 * __useAllObjectivesQuery__
 *
 * To run a query within a React component, call `useAllObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllObjectivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllObjectivesQuery(baseOptions: Apollo.QueryHookOptions<AllObjectivesQuery, AllObjectivesQueryVariables> & ({ variables: AllObjectivesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllObjectivesQuery, AllObjectivesQueryVariables>(AllObjectivesDocument, options);
      }
export function useAllObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllObjectivesQuery, AllObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllObjectivesQuery, AllObjectivesQueryVariables>(AllObjectivesDocument, options);
        }
export function useAllObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllObjectivesQuery, AllObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllObjectivesQuery, AllObjectivesQueryVariables>(AllObjectivesDocument, options);
        }
export type AllObjectivesQueryHookResult = ReturnType<typeof useAllObjectivesQuery>;
export type AllObjectivesLazyQueryHookResult = ReturnType<typeof useAllObjectivesLazyQuery>;
export type AllObjectivesSuspenseQueryHookResult = ReturnType<typeof useAllObjectivesSuspenseQuery>;
export type AllObjectivesQueryResult = Apollo.QueryResult<AllObjectivesQuery, AllObjectivesQueryVariables>;
export const MyReportsObjectivesDocument = gql`
    query MyReportsObjectives($filter: ObjectiveFilterManager!) {
  manager {
    Id
    employeesObjectives(filter: $filter) {
      ... on EmployeeObjective {
        ...EmployeeObjective
      }
      ... on TeamObjective {
        ...TeamObjective
      }
    }
  }
}
    ${EmployeeObjectiveFragmentDoc}
${TeamObjectiveFragmentDoc}`;

/**
 * __useMyReportsObjectivesQuery__
 *
 * To run a query within a React component, call `useMyReportsObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReportsObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReportsObjectivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyReportsObjectivesQuery(baseOptions: Apollo.QueryHookOptions<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables> & ({ variables: MyReportsObjectivesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables>(MyReportsObjectivesDocument, options);
      }
export function useMyReportsObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables>(MyReportsObjectivesDocument, options);
        }
export function useMyReportsObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables>(MyReportsObjectivesDocument, options);
        }
export type MyReportsObjectivesQueryHookResult = ReturnType<typeof useMyReportsObjectivesQuery>;
export type MyReportsObjectivesLazyQueryHookResult = ReturnType<typeof useMyReportsObjectivesLazyQuery>;
export type MyReportsObjectivesSuspenseQueryHookResult = ReturnType<typeof useMyReportsObjectivesSuspenseQuery>;
export type MyReportsObjectivesQueryResult = Apollo.QueryResult<MyReportsObjectivesQuery, MyReportsObjectivesQueryVariables>;
export const AcceptEmployeeFeedbackOutcomeObjectivesDocument = gql`
    mutation AcceptEmployeeFeedbackOutcomeObjectives($input: AcceptEmployeeFeedbackOutcomeObjectivesInput!) {
  acceptEmployeeFeedbackOutcomeObjectives(input: $input)
}
    `;
export type AcceptEmployeeFeedbackOutcomeObjectivesMutationFn = Apollo.MutationFunction<AcceptEmployeeFeedbackOutcomeObjectivesMutation, AcceptEmployeeFeedbackOutcomeObjectivesMutationVariables>;

/**
 * __useAcceptEmployeeFeedbackOutcomeObjectivesMutation__
 *
 * To run a mutation, you first call `useAcceptEmployeeFeedbackOutcomeObjectivesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptEmployeeFeedbackOutcomeObjectivesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptEmployeeFeedbackOutcomeObjectivesMutation, { data, loading, error }] = useAcceptEmployeeFeedbackOutcomeObjectivesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptEmployeeFeedbackOutcomeObjectivesMutation(baseOptions?: Apollo.MutationHookOptions<AcceptEmployeeFeedbackOutcomeObjectivesMutation, AcceptEmployeeFeedbackOutcomeObjectivesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptEmployeeFeedbackOutcomeObjectivesMutation, AcceptEmployeeFeedbackOutcomeObjectivesMutationVariables>(AcceptEmployeeFeedbackOutcomeObjectivesDocument, options);
      }
export type AcceptEmployeeFeedbackOutcomeObjectivesMutationHookResult = ReturnType<typeof useAcceptEmployeeFeedbackOutcomeObjectivesMutation>;
export type AcceptEmployeeFeedbackOutcomeObjectivesMutationResult = Apollo.MutationResult<AcceptEmployeeFeedbackOutcomeObjectivesMutation>;
export type AcceptEmployeeFeedbackOutcomeObjectivesMutationOptions = Apollo.BaseMutationOptions<AcceptEmployeeFeedbackOutcomeObjectivesMutation, AcceptEmployeeFeedbackOutcomeObjectivesMutationVariables>;
export const MyPastPerformanceReviewDetailsDocument = gql`
    query MyPastPerformanceReviewDetails($feedbackId: String!) {
  me {
    Id
    Name
    feedback(id: $feedbackId) {
      Id
      flair__State__c
      flair__Feedback_From__c
      flair__Deadline__c
      flair__Is_Peer_Reviewer__c
      flair__Submitted_At__c
      flair__Self_Evaluation__c
      CreatedDate
      feedbackCycle {
        ...FeedbackCycle_PerformanceReview
        questions {
          ...FeedbackCycleQuestions_PerformanceReview
        }
      }
      reviewee {
        Id
        Name
      }
      outcome {
        Id
        flair__Accepted_At__c
        flair__Ended_At__c
        flair__Completed__c
        resolutions {
          Id
          flair__Employee_Feedback_Question__c
          flair__Resolution__c
        }
        objectives {
          Id
          Name
          flair__Description__c
          flair__Due_Date__c
          flair__Finished_Feedback_Outcome__c
          flair__Rate_Reason__c
          flair__Rate__c
          parent {
            Id
            Name
          }
        }
        finishedObjectives {
          Id
          Name
          flair__Description__c
          flair__Due_Date__c
          flair__Finished_Feedback_Outcome__c
          flair__Rate_Reason__c
          flair__Rate__c
          parent {
            Id
            Name
          }
        }
      }
      answers {
        Id
        flair__Employee_Feedback_Question__c
        flair__Note__c
        feedbackAnswer
      }
      managerFeedback {
        Id
        answers {
          Id
          flair__Employee_Feedback_Question__c
          flair__Note__c
          feedbackAnswer
        }
        reviewer {
          Id
          Name
        }
      }
      peerFeedbacks {
        ...PeerFeedback
      }
    }
  }
}
    ${FeedbackCycle_PerformanceReviewFragmentDoc}
${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __useMyPastPerformanceReviewDetailsQuery__
 *
 * To run a query within a React component, call `useMyPastPerformanceReviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPastPerformanceReviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPastPerformanceReviewDetailsQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useMyPastPerformanceReviewDetailsQuery(baseOptions: Apollo.QueryHookOptions<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables> & ({ variables: MyPastPerformanceReviewDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables>(MyPastPerformanceReviewDetailsDocument, options);
      }
export function useMyPastPerformanceReviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables>(MyPastPerformanceReviewDetailsDocument, options);
        }
export function useMyPastPerformanceReviewDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables>(MyPastPerformanceReviewDetailsDocument, options);
        }
export type MyPastPerformanceReviewDetailsQueryHookResult = ReturnType<typeof useMyPastPerformanceReviewDetailsQuery>;
export type MyPastPerformanceReviewDetailsLazyQueryHookResult = ReturnType<typeof useMyPastPerformanceReviewDetailsLazyQuery>;
export type MyPastPerformanceReviewDetailsSuspenseQueryHookResult = ReturnType<typeof useMyPastPerformanceReviewDetailsSuspenseQuery>;
export type MyPastPerformanceReviewDetailsQueryResult = Apollo.QueryResult<MyPastPerformanceReviewDetailsQuery, MyPastPerformanceReviewDetailsQueryVariables>;
export const ReviewsListDocument = gql`
    query ReviewsList {
  me {
    Id
    feedbacksAsReviewer {
      Id
      flair__Feedback_From__c
      flair__Deadline__c
      flair__State__c
      flair__Submitted_At__c
      flair__Progress__c
      CreatedDate
      flair__Is_Peer_Reviewer__c
      employeeFeedback {
        Id
        flair__State__c
        flair__Progress__c
      }
      feedbackCycle {
        ...FeedbackCycleItem
      }
      outcome {
        Id
        flair__Ended_At__c
        flair__Accepted_At__c
        flair__Employee_Feedback_Participant__c
        reviewer {
          Id
          Name
        }
        meeting {
          Id
          flair__Start_Datetime__c
        }
      }
      peerFeedbacks {
        ...PeerFeedback
      }
      reviewee {
        Id
        Name
      }
    }
  }
}
    ${FeedbackCycleItemFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __useReviewsListQuery__
 *
 * To run a query within a React component, call `useReviewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewsListQuery(baseOptions?: Apollo.QueryHookOptions<ReviewsListQuery, ReviewsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsListQuery, ReviewsListQueryVariables>(ReviewsListDocument, options);
      }
export function useReviewsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsListQuery, ReviewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsListQuery, ReviewsListQueryVariables>(ReviewsListDocument, options);
        }
export function useReviewsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewsListQuery, ReviewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewsListQuery, ReviewsListQueryVariables>(ReviewsListDocument, options);
        }
export type ReviewsListQueryHookResult = ReturnType<typeof useReviewsListQuery>;
export type ReviewsListLazyQueryHookResult = ReturnType<typeof useReviewsListLazyQuery>;
export type ReviewsListSuspenseQueryHookResult = ReturnType<typeof useReviewsListSuspenseQuery>;
export type ReviewsListQueryResult = Apollo.QueryResult<ReviewsListQuery, ReviewsListQueryVariables>;
export const SelfPerformanceEvaluationDocument = gql`
    query SelfPerformanceEvaluation($id: String!) {
  me {
    Id
    feedback(id: $id) {
      Id
      flair__State__c
      CreatedDate
      feedbackCycle {
        Id
        Name
        flair__Introduction_Text__c
        flair__State__c
        flair__Manage_Goals__c
        flair__Meeting_Required__c
        flair__Timeline_Type__c
        flair__Signature_required__c
        flair__Rating_Min__c
        flair__Rating_Max__c
      }
      outcome {
        Id
        flair__Accepted_At__c
        flair__Ended_At__c
      }
      answers {
        Id
        flair__Employee_Feedback_Request__c
        flair__Feedback__c
        flair__Note__c
        question {
          ...FeedbackCycleQuestions_PerformanceReview
        }
      }
      managerFeedback {
        Id
        flair__State__c
      }
    }
  }
}
    ${FeedbackCycleQuestions_PerformanceReviewFragmentDoc}`;

/**
 * __useSelfPerformanceEvaluationQuery__
 *
 * To run a query within a React component, call `useSelfPerformanceEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfPerformanceEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfPerformanceEvaluationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelfPerformanceEvaluationQuery(baseOptions: Apollo.QueryHookOptions<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables> & ({ variables: SelfPerformanceEvaluationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables>(SelfPerformanceEvaluationDocument, options);
      }
export function useSelfPerformanceEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables>(SelfPerformanceEvaluationDocument, options);
        }
export function useSelfPerformanceEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables>(SelfPerformanceEvaluationDocument, options);
        }
export type SelfPerformanceEvaluationQueryHookResult = ReturnType<typeof useSelfPerformanceEvaluationQuery>;
export type SelfPerformanceEvaluationLazyQueryHookResult = ReturnType<typeof useSelfPerformanceEvaluationLazyQuery>;
export type SelfPerformanceEvaluationSuspenseQueryHookResult = ReturnType<typeof useSelfPerformanceEvaluationSuspenseQuery>;
export type SelfPerformanceEvaluationQueryResult = Apollo.QueryResult<SelfPerformanceEvaluationQuery, SelfPerformanceEvaluationQueryVariables>;
export const SubmitSelfPerformanceEvaluationDocument = gql`
    mutation SubmitSelfPerformanceEvaluation($input: SubmitEmployeeFeedbackInput!) {
  submitEmployeeFeedback(input: $input)
}
    `;
export type SubmitSelfPerformanceEvaluationMutationFn = Apollo.MutationFunction<SubmitSelfPerformanceEvaluationMutation, SubmitSelfPerformanceEvaluationMutationVariables>;

/**
 * __useSubmitSelfPerformanceEvaluationMutation__
 *
 * To run a mutation, you first call `useSubmitSelfPerformanceEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSelfPerformanceEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSelfPerformanceEvaluationMutation, { data, loading, error }] = useSubmitSelfPerformanceEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSelfPerformanceEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSelfPerformanceEvaluationMutation, SubmitSelfPerformanceEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSelfPerformanceEvaluationMutation, SubmitSelfPerformanceEvaluationMutationVariables>(SubmitSelfPerformanceEvaluationDocument, options);
      }
export type SubmitSelfPerformanceEvaluationMutationHookResult = ReturnType<typeof useSubmitSelfPerformanceEvaluationMutation>;
export type SubmitSelfPerformanceEvaluationMutationResult = Apollo.MutationResult<SubmitSelfPerformanceEvaluationMutation>;
export type SubmitSelfPerformanceEvaluationMutationOptions = Apollo.BaseMutationOptions<SubmitSelfPerformanceEvaluationMutation, SubmitSelfPerformanceEvaluationMutationVariables>;
export const MyPerformanceReviewsDocument = gql`
    query MyPerformanceReviews {
  me {
    Id
    feedbacks {
      Id
      flair__State__c
      flair__Submitted_At__c
      flair__Progress__c
      flair__Feedback_From__c
      flair__Deadline__c
      CreatedDate
      flair__Is_Peer_Reviewer__c
      employeeFeedback {
        Id
        flair__State__c
        CreatedDate
        flair__Progress__c
      }
      feedbackCycle {
        ...FeedbackCycleItem
      }
      outcome {
        Id
        flair__Ended_At__c
        flair__Accepted_At__c
        flair__Employee_Feedback_Participant__c
        reviewer {
          Id
          Name
          flair__First_Name__c
          flair__Last_Name__c
          avatar {
            Id
            url
          }
        }
        meeting {
          Id
          flair__Start_Datetime__c
        }
      }
      peerFeedbacks {
        ...PeerFeedback
      }
      reviewee {
        Id
        Name
      }
    }
  }
}
    ${FeedbackCycleItemFragmentDoc}
${PeerFeedbackFragmentDoc}`;

/**
 * __useMyPerformanceReviewsQuery__
 *
 * To run a query within a React component, call `useMyPerformanceReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPerformanceReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPerformanceReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPerformanceReviewsQuery(baseOptions?: Apollo.QueryHookOptions<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>(MyPerformanceReviewsDocument, options);
      }
export function useMyPerformanceReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>(MyPerformanceReviewsDocument, options);
        }
export function useMyPerformanceReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>(MyPerformanceReviewsDocument, options);
        }
export type MyPerformanceReviewsQueryHookResult = ReturnType<typeof useMyPerformanceReviewsQuery>;
export type MyPerformanceReviewsLazyQueryHookResult = ReturnType<typeof useMyPerformanceReviewsLazyQuery>;
export type MyPerformanceReviewsSuspenseQueryHookResult = ReturnType<typeof useMyPerformanceReviewsSuspenseQuery>;
export type MyPerformanceReviewsQueryResult = Apollo.QueryResult<MyPerformanceReviewsQuery, MyPerformanceReviewsQueryVariables>;
export const PersonalDataDocument = gql`
    query PersonalData {
  me {
    Id
    flair__Hide_My_Birthday__c
    data {
      ...MyEmployeeData
    }
  }
}
    ${MyEmployeeDataFragmentDoc}`;

/**
 * __usePersonalDataQuery__
 *
 * To run a query within a React component, call `usePersonalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalDataQuery(baseOptions?: Apollo.QueryHookOptions<PersonalDataQuery, PersonalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalDataQuery, PersonalDataQueryVariables>(PersonalDataDocument, options);
      }
export function usePersonalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalDataQuery, PersonalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalDataQuery, PersonalDataQueryVariables>(PersonalDataDocument, options);
        }
export function usePersonalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalDataQuery, PersonalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalDataQuery, PersonalDataQueryVariables>(PersonalDataDocument, options);
        }
export type PersonalDataQueryHookResult = ReturnType<typeof usePersonalDataQuery>;
export type PersonalDataLazyQueryHookResult = ReturnType<typeof usePersonalDataLazyQuery>;
export type PersonalDataSuspenseQueryHookResult = ReturnType<typeof usePersonalDataSuspenseQuery>;
export type PersonalDataQueryResult = Apollo.QueryResult<PersonalDataQuery, PersonalDataQueryVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($input: UpdateProjectInput!) {
  project {
    updateProject(input: $input) {
      record {
        ...ProjectFields
        historyItems {
          ...ProjectHistoryItem
        }
      }
    }
  }
}
    ${ProjectFieldsFragmentDoc}
${ProjectHistoryItemFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const ProjectsTimeSheetFiltersDocument = gql`
    query ProjectsTimeSheetFilters($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    employees(filter: {managerReportsType: $managerReportsType}) {
      ...EmployeeSelectInfo
    }
    pendingTimeSheets {
      Id
      projectsTimeEntries {
        Id
        flair__Project__c
        project {
          Id
          flair__Name__c
        }
      }
    }
  }
}
    ${EmployeeSelectInfoFragmentDoc}`;

/**
 * __useProjectsTimeSheetFiltersQuery__
 *
 * To run a query within a React component, call `useProjectsTimeSheetFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsTimeSheetFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsTimeSheetFiltersQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useProjectsTimeSheetFiltersQuery(baseOptions: Apollo.QueryHookOptions<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables> & ({ variables: ProjectsTimeSheetFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables>(ProjectsTimeSheetFiltersDocument, options);
      }
export function useProjectsTimeSheetFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables>(ProjectsTimeSheetFiltersDocument, options);
        }
export function useProjectsTimeSheetFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables>(ProjectsTimeSheetFiltersDocument, options);
        }
export type ProjectsTimeSheetFiltersQueryHookResult = ReturnType<typeof useProjectsTimeSheetFiltersQuery>;
export type ProjectsTimeSheetFiltersLazyQueryHookResult = ReturnType<typeof useProjectsTimeSheetFiltersLazyQuery>;
export type ProjectsTimeSheetFiltersSuspenseQueryHookResult = ReturnType<typeof useProjectsTimeSheetFiltersSuspenseQuery>;
export type ProjectsTimeSheetFiltersQueryResult = Apollo.QueryResult<ProjectsTimeSheetFiltersQuery, ProjectsTimeSheetFiltersQueryVariables>;
export const ProjectsTimeSheetDetailsDocument = gql`
    query projectsTimeSheetDetails($id: String!, $projectTimeEntriesFilter: ProjectTimeEntriesFilterInput!) {
  timeSheet(id: $id) {
    ...ProjectsTimeSheetDetails
  }
}
    ${ProjectsTimeSheetDetailsFragmentDoc}`;

/**
 * __useProjectsTimeSheetDetailsQuery__
 *
 * To run a query within a React component, call `useProjectsTimeSheetDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsTimeSheetDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsTimeSheetDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectTimeEntriesFilter: // value for 'projectTimeEntriesFilter'
 *   },
 * });
 */
export function useProjectsTimeSheetDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables> & ({ variables: ProjectsTimeSheetDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables>(ProjectsTimeSheetDetailsDocument, options);
      }
export function useProjectsTimeSheetDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables>(ProjectsTimeSheetDetailsDocument, options);
        }
export function useProjectsTimeSheetDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables>(ProjectsTimeSheetDetailsDocument, options);
        }
export type ProjectsTimeSheetDetailsQueryHookResult = ReturnType<typeof useProjectsTimeSheetDetailsQuery>;
export type ProjectsTimeSheetDetailsLazyQueryHookResult = ReturnType<typeof useProjectsTimeSheetDetailsLazyQuery>;
export type ProjectsTimeSheetDetailsSuspenseQueryHookResult = ReturnType<typeof useProjectsTimeSheetDetailsSuspenseQuery>;
export type ProjectsTimeSheetDetailsQueryResult = Apollo.QueryResult<ProjectsTimeSheetDetailsQuery, ProjectsTimeSheetDetailsQueryVariables>;
export const ProjectsTimeSheetDetailsPrefetchDocument = gql`
    query projectsTimeSheetDetailsPrefetch($ids: [String!]!, $projectTimeEntriesFilter: ProjectTimeEntriesFilterInput!) {
  timeSheets(ids: $ids) {
    ...ProjectsTimeSheetDetails
  }
}
    ${ProjectsTimeSheetDetailsFragmentDoc}`;

/**
 * __useProjectsTimeSheetDetailsPrefetchQuery__
 *
 * To run a query within a React component, call `useProjectsTimeSheetDetailsPrefetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsTimeSheetDetailsPrefetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsTimeSheetDetailsPrefetchQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      projectTimeEntriesFilter: // value for 'projectTimeEntriesFilter'
 *   },
 * });
 */
export function useProjectsTimeSheetDetailsPrefetchQuery(baseOptions: Apollo.QueryHookOptions<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables> & ({ variables: ProjectsTimeSheetDetailsPrefetchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables>(ProjectsTimeSheetDetailsPrefetchDocument, options);
      }
export function useProjectsTimeSheetDetailsPrefetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables>(ProjectsTimeSheetDetailsPrefetchDocument, options);
        }
export function useProjectsTimeSheetDetailsPrefetchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables>(ProjectsTimeSheetDetailsPrefetchDocument, options);
        }
export type ProjectsTimeSheetDetailsPrefetchQueryHookResult = ReturnType<typeof useProjectsTimeSheetDetailsPrefetchQuery>;
export type ProjectsTimeSheetDetailsPrefetchLazyQueryHookResult = ReturnType<typeof useProjectsTimeSheetDetailsPrefetchLazyQuery>;
export type ProjectsTimeSheetDetailsPrefetchSuspenseQueryHookResult = ReturnType<typeof useProjectsTimeSheetDetailsPrefetchSuspenseQuery>;
export type ProjectsTimeSheetDetailsPrefetchQueryResult = Apollo.QueryResult<ProjectsTimeSheetDetailsPrefetchQuery, ProjectsTimeSheetDetailsPrefetchQueryVariables>;
export const TimeSheetsControllingProjectsDocument = gql`
    query TimeSheetsControllingProjects($filter: TimeSheetFilterInput!, $sort: [TimeSheetSortInput!], $offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!, $projectTimeEntriesFilter: ProjectTimeEntriesFilterInput!) {
  manager {
    Id
    timeSheetsPagination(
      filter: $filter
      sort: $sort
      pagination: {offset: $offset, limit: $limit}
    ) {
      items {
        ...ProjectsTimeSheetTable
      }
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${ProjectsTimeSheetTableFragmentDoc}`;

/**
 * __useTimeSheetsControllingProjectsQuery__
 *
 * To run a query within a React component, call `useTimeSheetsControllingProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetsControllingProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetsControllingProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *      projectTimeEntriesFilter: // value for 'projectTimeEntriesFilter'
 *   },
 * });
 */
export function useTimeSheetsControllingProjectsQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables> & ({ variables: TimeSheetsControllingProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables>(TimeSheetsControllingProjectsDocument, options);
      }
export function useTimeSheetsControllingProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables>(TimeSheetsControllingProjectsDocument, options);
        }
export function useTimeSheetsControllingProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables>(TimeSheetsControllingProjectsDocument, options);
        }
export type TimeSheetsControllingProjectsQueryHookResult = ReturnType<typeof useTimeSheetsControllingProjectsQuery>;
export type TimeSheetsControllingProjectsLazyQueryHookResult = ReturnType<typeof useTimeSheetsControllingProjectsLazyQuery>;
export type TimeSheetsControllingProjectsSuspenseQueryHookResult = ReturnType<typeof useTimeSheetsControllingProjectsSuspenseQuery>;
export type TimeSheetsControllingProjectsQueryResult = Apollo.QueryResult<TimeSheetsControllingProjectsQuery, TimeSheetsControllingProjectsQueryVariables>;
export const ProjectsOverviewDocument = gql`
    query ProjectsOverview {
  projects {
    ...ProjectFields
    historyItems {
      ...ProjectHistoryItem
    }
  }
}
    ${ProjectFieldsFragmentDoc}
${ProjectHistoryItemFragmentDoc}`;

/**
 * __useProjectsOverviewQuery__
 *
 * To run a query within a React component, call `useProjectsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>(ProjectsOverviewDocument, options);
      }
export function useProjectsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>(ProjectsOverviewDocument, options);
        }
export function useProjectsOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>(ProjectsOverviewDocument, options);
        }
export type ProjectsOverviewQueryHookResult = ReturnType<typeof useProjectsOverviewQuery>;
export type ProjectsOverviewLazyQueryHookResult = ReturnType<typeof useProjectsOverviewLazyQuery>;
export type ProjectsOverviewSuspenseQueryHookResult = ReturnType<typeof useProjectsOverviewSuspenseQuery>;
export type ProjectsOverviewQueryResult = Apollo.QueryResult<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>;
export const SaveProjectTimeEntriesByDaysDocument = gql`
    mutation saveProjectTimeEntriesByDays($input: SaveProjectTimeEntriesByDaysInput!, $from: DateTime!, $to: DateTime!) {
  project {
    saveProjectTimeEntriesByDays(input: $input) {
      query {
        myTimeSheets(from: $from, to: $to) {
          ...ProjectTimesheetFields
        }
      }
    }
  }
}
    ${ProjectTimesheetFieldsFragmentDoc}`;
export type SaveProjectTimeEntriesByDaysMutationFn = Apollo.MutationFunction<SaveProjectTimeEntriesByDaysMutation, SaveProjectTimeEntriesByDaysMutationVariables>;

/**
 * __useSaveProjectTimeEntriesByDaysMutation__
 *
 * To run a mutation, you first call `useSaveProjectTimeEntriesByDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectTimeEntriesByDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectTimeEntriesByDaysMutation, { data, loading, error }] = useSaveProjectTimeEntriesByDaysMutation({
 *   variables: {
 *      input: // value for 'input'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSaveProjectTimeEntriesByDaysMutation(baseOptions?: Apollo.MutationHookOptions<SaveProjectTimeEntriesByDaysMutation, SaveProjectTimeEntriesByDaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProjectTimeEntriesByDaysMutation, SaveProjectTimeEntriesByDaysMutationVariables>(SaveProjectTimeEntriesByDaysDocument, options);
      }
export type SaveProjectTimeEntriesByDaysMutationHookResult = ReturnType<typeof useSaveProjectTimeEntriesByDaysMutation>;
export type SaveProjectTimeEntriesByDaysMutationResult = Apollo.MutationResult<SaveProjectTimeEntriesByDaysMutation>;
export type SaveProjectTimeEntriesByDaysMutationOptions = Apollo.BaseMutationOptions<SaveProjectTimeEntriesByDaysMutation, SaveProjectTimeEntriesByDaysMutationVariables>;
export const SaveProjectTimeEntriesByProjectsDocument = gql`
    mutation saveProjectTimeEntriesByProjects($input: SaveProjectTimeEntriesByProjectsInput!, $from: DateTime!, $to: DateTime!) {
  project {
    saveProjectTimeEntriesByProjects(input: $input) {
      query {
        myTimeSheets(from: $from, to: $to) {
          ...ProjectTimesheetFields
        }
      }
    }
  }
}
    ${ProjectTimesheetFieldsFragmentDoc}`;
export type SaveProjectTimeEntriesByProjectsMutationFn = Apollo.MutationFunction<SaveProjectTimeEntriesByProjectsMutation, SaveProjectTimeEntriesByProjectsMutationVariables>;

/**
 * __useSaveProjectTimeEntriesByProjectsMutation__
 *
 * To run a mutation, you first call `useSaveProjectTimeEntriesByProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectTimeEntriesByProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectTimeEntriesByProjectsMutation, { data, loading, error }] = useSaveProjectTimeEntriesByProjectsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSaveProjectTimeEntriesByProjectsMutation(baseOptions?: Apollo.MutationHookOptions<SaveProjectTimeEntriesByProjectsMutation, SaveProjectTimeEntriesByProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProjectTimeEntriesByProjectsMutation, SaveProjectTimeEntriesByProjectsMutationVariables>(SaveProjectTimeEntriesByProjectsDocument, options);
      }
export type SaveProjectTimeEntriesByProjectsMutationHookResult = ReturnType<typeof useSaveProjectTimeEntriesByProjectsMutation>;
export type SaveProjectTimeEntriesByProjectsMutationResult = Apollo.MutationResult<SaveProjectTimeEntriesByProjectsMutation>;
export type SaveProjectTimeEntriesByProjectsMutationOptions = Apollo.BaseMutationOptions<SaveProjectTimeEntriesByProjectsMutation, SaveProjectTimeEntriesByProjectsMutationVariables>;
export const ProjectsDocument = gql`
    query Projects($from: DateTime!, $to: DateTime!) {
  projects {
    ...ProjectFields
    historyItems {
      ...ProjectHistoryItem
    }
  }
  costCenters {
    Id
    Name
    flair__Code__c
  }
  myTimeSheets(from: $from, to: $to) {
    Id
    flair__Start_Date__c
    flair__End_Date__c
    flair__Type__c
    flair__Approval_Status__c
    projectTimeEntries {
      ...ProjectTimesheetEntry
    }
    timeEntries {
      Id
      flair__Start_Datetime__c
      flair__End_Datetime__c
      flair__Total_Break_Period_In_Hours__c
      flair__Total_Period_In_Hours__c
      flair__Working_Period_In_Hours__c
      flair__Notes__c
    }
    holidays {
      ...LocationHoliday
    }
    calendarPeriods {
      ...TimeSheetCalendarPeriod
    }
    paidAbsences {
      ...PaidAbsenceFields
    }
    timeSheetDays {
      ...TimeSheetDayId
      flair__Time_Entries_Minutes__c
      commentsCount
      loomVideo {
        ...LoomVideo
      }
    }
  }
}
    ${ProjectFieldsFragmentDoc}
${ProjectHistoryItemFragmentDoc}
${ProjectTimesheetEntryFragmentDoc}
${LocationHolidayFragmentDoc}
${TimeSheetCalendarPeriodFragmentDoc}
${PaidAbsenceFieldsFragmentDoc}
${TimeSheetDayIdFragmentDoc}
${LoomVideoFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables> & ({ variables: ProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const AllReceivedChangeRequestsDocument = gql`
    query AllReceivedChangeRequests {
  me {
    Id
    shiftChangeRequestsToMe {
      ...ShiftChangeRequestFragment
    }
  }
}
    ${ShiftChangeRequestFragmentFragmentDoc}`;

/**
 * __useAllReceivedChangeRequestsQuery__
 *
 * To run a query within a React component, call `useAllReceivedChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReceivedChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReceivedChangeRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReceivedChangeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>(AllReceivedChangeRequestsDocument, options);
      }
export function useAllReceivedChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>(AllReceivedChangeRequestsDocument, options);
        }
export function useAllReceivedChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>(AllReceivedChangeRequestsDocument, options);
        }
export type AllReceivedChangeRequestsQueryHookResult = ReturnType<typeof useAllReceivedChangeRequestsQuery>;
export type AllReceivedChangeRequestsLazyQueryHookResult = ReturnType<typeof useAllReceivedChangeRequestsLazyQuery>;
export type AllReceivedChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useAllReceivedChangeRequestsSuspenseQuery>;
export type AllReceivedChangeRequestsQueryResult = Apollo.QueryResult<AllReceivedChangeRequestsQuery, AllReceivedChangeRequestsQueryVariables>;
export const RespondToShiftChangeRequestDocument = gql`
    mutation RespondToShiftChangeRequest($input: RespondToShiftChangeRequestInput!) {
  shiftChangeRequest {
    respondToShiftChangeRequest(input: $input) {
      recordId
      record {
        ...ShiftChangeRequestFragment
      }
    }
  }
}
    ${ShiftChangeRequestFragmentFragmentDoc}`;
export type RespondToShiftChangeRequestMutationFn = Apollo.MutationFunction<RespondToShiftChangeRequestMutation, RespondToShiftChangeRequestMutationVariables>;

/**
 * __useRespondToShiftChangeRequestMutation__
 *
 * To run a mutation, you first call `useRespondToShiftChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToShiftChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToShiftChangeRequestMutation, { data, loading, error }] = useRespondToShiftChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToShiftChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<RespondToShiftChangeRequestMutation, RespondToShiftChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToShiftChangeRequestMutation, RespondToShiftChangeRequestMutationVariables>(RespondToShiftChangeRequestDocument, options);
      }
export type RespondToShiftChangeRequestMutationHookResult = ReturnType<typeof useRespondToShiftChangeRequestMutation>;
export type RespondToShiftChangeRequestMutationResult = Apollo.MutationResult<RespondToShiftChangeRequestMutation>;
export type RespondToShiftChangeRequestMutationOptions = Apollo.BaseMutationOptions<RespondToShiftChangeRequestMutation, RespondToShiftChangeRequestMutationVariables>;
export const CancelShiftChangeRequestDocument = gql`
    mutation CancelShiftChangeRequest($input: CancelShiftChangeRequestInput!) {
  shiftChangeRequest {
    cancelShiftChangeRequest(input: $input) {
      recordId
      record {
        ...ShiftChangeRequestFragment
      }
      query {
        me {
          Id
          shiftChangeRequestsFromMe {
            ...ShiftChangeRequestFragment
          }
        }
      }
    }
  }
}
    ${ShiftChangeRequestFragmentFragmentDoc}`;
export type CancelShiftChangeRequestMutationFn = Apollo.MutationFunction<CancelShiftChangeRequestMutation, CancelShiftChangeRequestMutationVariables>;

/**
 * __useCancelShiftChangeRequestMutation__
 *
 * To run a mutation, you first call `useCancelShiftChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelShiftChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelShiftChangeRequestMutation, { data, loading, error }] = useCancelShiftChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelShiftChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelShiftChangeRequestMutation, CancelShiftChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelShiftChangeRequestMutation, CancelShiftChangeRequestMutationVariables>(CancelShiftChangeRequestDocument, options);
      }
export type CancelShiftChangeRequestMutationHookResult = ReturnType<typeof useCancelShiftChangeRequestMutation>;
export type CancelShiftChangeRequestMutationResult = Apollo.MutationResult<CancelShiftChangeRequestMutation>;
export type CancelShiftChangeRequestMutationOptions = Apollo.BaseMutationOptions<CancelShiftChangeRequestMutation, CancelShiftChangeRequestMutationVariables>;
export const ShiftChangeRequestsByShiftIdDocument = gql`
    query ShiftChangeRequestsByShiftId($shiftId: String!) {
  schedulerShift(id: $shiftId) {
    Id
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Employee_Notes__c
    flair__Resource_Employee__c
    flair__Allow_Shift_Transfer__c
    flair__Min_Days_Before_Shift_Transfer__c
    breaks {
      Id
      flair__Start_Datetime__c
      flair__End_Datetime__c
    }
    shiftLabels {
      Id
      Name
      flair__Tag_Name__c
    }
    shiftChangeRequests {
      ...ShiftChangeRequestFragment
    }
  }
}
    ${ShiftChangeRequestFragmentFragmentDoc}`;

/**
 * __useShiftChangeRequestsByShiftIdQuery__
 *
 * To run a query within a React component, call `useShiftChangeRequestsByShiftIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftChangeRequestsByShiftIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftChangeRequestsByShiftIdQuery({
 *   variables: {
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useShiftChangeRequestsByShiftIdQuery(baseOptions: Apollo.QueryHookOptions<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables> & ({ variables: ShiftChangeRequestsByShiftIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables>(ShiftChangeRequestsByShiftIdDocument, options);
      }
export function useShiftChangeRequestsByShiftIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables>(ShiftChangeRequestsByShiftIdDocument, options);
        }
export function useShiftChangeRequestsByShiftIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables>(ShiftChangeRequestsByShiftIdDocument, options);
        }
export type ShiftChangeRequestsByShiftIdQueryHookResult = ReturnType<typeof useShiftChangeRequestsByShiftIdQuery>;
export type ShiftChangeRequestsByShiftIdLazyQueryHookResult = ReturnType<typeof useShiftChangeRequestsByShiftIdLazyQuery>;
export type ShiftChangeRequestsByShiftIdSuspenseQueryHookResult = ReturnType<typeof useShiftChangeRequestsByShiftIdSuspenseQuery>;
export type ShiftChangeRequestsByShiftIdQueryResult = Apollo.QueryResult<ShiftChangeRequestsByShiftIdQuery, ShiftChangeRequestsByShiftIdQueryVariables>;
export const CreateShiftChangeRequestDocument = gql`
    mutation CreateShiftChangeRequest($input: CreateShiftChangeRequestInput!) {
  shiftChangeRequest {
    createShiftChangeRequest(input: $input) {
      recordId
      record {
        Id
        shift {
          Id
          flair__Pending_Change_Requests_Count__c
          shiftChangeRequests {
            ...ShiftChangeRequestFragment
          }
        }
      }
      query {
        me {
          Id
          shiftChangeRequestsFromMe {
            ...ShiftChangeRequestFragment
          }
        }
      }
    }
  }
}
    ${ShiftChangeRequestFragmentFragmentDoc}`;
export type CreateShiftChangeRequestMutationFn = Apollo.MutationFunction<CreateShiftChangeRequestMutation, CreateShiftChangeRequestMutationVariables>;

/**
 * __useCreateShiftChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateShiftChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShiftChangeRequestMutation, { data, loading, error }] = useCreateShiftChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShiftChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateShiftChangeRequestMutation, CreateShiftChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShiftChangeRequestMutation, CreateShiftChangeRequestMutationVariables>(CreateShiftChangeRequestDocument, options);
      }
export type CreateShiftChangeRequestMutationHookResult = ReturnType<typeof useCreateShiftChangeRequestMutation>;
export type CreateShiftChangeRequestMutationResult = Apollo.MutationResult<CreateShiftChangeRequestMutation>;
export type CreateShiftChangeRequestMutationOptions = Apollo.BaseMutationOptions<CreateShiftChangeRequestMutation, CreateShiftChangeRequestMutationVariables>;
export const GetShiftChangeRequestSuggestionEmployeesDocument = gql`
    query GetShiftChangeRequestSuggestionEmployees {
  me {
    Id
    allColleagues {
      Id
      Name
    }
  }
}
    `;

/**
 * __useGetShiftChangeRequestSuggestionEmployeesQuery__
 *
 * To run a query within a React component, call `useGetShiftChangeRequestSuggestionEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftChangeRequestSuggestionEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftChangeRequestSuggestionEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShiftChangeRequestSuggestionEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>(GetShiftChangeRequestSuggestionEmployeesDocument, options);
      }
export function useGetShiftChangeRequestSuggestionEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>(GetShiftChangeRequestSuggestionEmployeesDocument, options);
        }
export function useGetShiftChangeRequestSuggestionEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>(GetShiftChangeRequestSuggestionEmployeesDocument, options);
        }
export type GetShiftChangeRequestSuggestionEmployeesQueryHookResult = ReturnType<typeof useGetShiftChangeRequestSuggestionEmployeesQuery>;
export type GetShiftChangeRequestSuggestionEmployeesLazyQueryHookResult = ReturnType<typeof useGetShiftChangeRequestSuggestionEmployeesLazyQuery>;
export type GetShiftChangeRequestSuggestionEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetShiftChangeRequestSuggestionEmployeesSuspenseQuery>;
export type GetShiftChangeRequestSuggestionEmployeesQueryResult = Apollo.QueryResult<GetShiftChangeRequestSuggestionEmployeesQuery, GetShiftChangeRequestSuggestionEmployeesQueryVariables>;
export const SchedulerShiftsListDocument = gql`
    query SchedulerShiftsList($filter: ShiftFilterInput!) {
  schedulerShifts(filter: $filter) {
    Id
    Name
    flair__Title__c
    flair__Start_Datetime__c
    flair__End_Datetime__c
    flair__Total_Break_Period_in_Minutes__c
    flair__Employee_Notes__c
    flair__Linked_Resource_Id__c
    flair__Linked_Resource_Object__c
    flair__Linked_Target_Id__c
    flair__Linked_Target_Object__c
    flair__Pending_Change_Requests_Count__c
    location {
      Name
    }
    department {
      Name
    }
    employee {
      Id
      Name
    }
    breaks {
      Id
      flair__Start_Datetime__c
      flair__End_Datetime__c
    }
    shiftLabels {
      Id
      Name
      flair__Tag_Name__c
    }
  }
}
    `;

/**
 * __useSchedulerShiftsListQuery__
 *
 * To run a query within a React component, call `useSchedulerShiftsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerShiftsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerShiftsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSchedulerShiftsListQuery(baseOptions: Apollo.QueryHookOptions<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables> & ({ variables: SchedulerShiftsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables>(SchedulerShiftsListDocument, options);
      }
export function useSchedulerShiftsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables>(SchedulerShiftsListDocument, options);
        }
export function useSchedulerShiftsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables>(SchedulerShiftsListDocument, options);
        }
export type SchedulerShiftsListQueryHookResult = ReturnType<typeof useSchedulerShiftsListQuery>;
export type SchedulerShiftsListLazyQueryHookResult = ReturnType<typeof useSchedulerShiftsListLazyQuery>;
export type SchedulerShiftsListSuspenseQueryHookResult = ReturnType<typeof useSchedulerShiftsListSuspenseQuery>;
export type SchedulerShiftsListQueryResult = Apollo.QueryResult<SchedulerShiftsListQuery, SchedulerShiftsListQueryVariables>;
export const AllSentShiftChangeRequestsDocument = gql`
    query AllSentShiftChangeRequests {
  me {
    Id
    shiftChangeRequestsFromMe {
      ...ShiftChangeRequestFragment
    }
  }
}
    ${ShiftChangeRequestFragmentFragmentDoc}`;

/**
 * __useAllSentShiftChangeRequestsQuery__
 *
 * To run a query within a React component, call `useAllSentShiftChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSentShiftChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSentShiftChangeRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSentShiftChangeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>(AllSentShiftChangeRequestsDocument, options);
      }
export function useAllSentShiftChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>(AllSentShiftChangeRequestsDocument, options);
        }
export function useAllSentShiftChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>(AllSentShiftChangeRequestsDocument, options);
        }
export type AllSentShiftChangeRequestsQueryHookResult = ReturnType<typeof useAllSentShiftChangeRequestsQuery>;
export type AllSentShiftChangeRequestsLazyQueryHookResult = ReturnType<typeof useAllSentShiftChangeRequestsLazyQuery>;
export type AllSentShiftChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useAllSentShiftChangeRequestsSuspenseQuery>;
export type AllSentShiftChangeRequestsQueryResult = Apollo.QueryResult<AllSentShiftChangeRequestsQuery, AllSentShiftChangeRequestsQueryVariables>;
export const CustomerSupportDocument = gql`
    query CustomerSupport {
  me {
    Id
    customerSupport {
      supportAccess
    }
  }
}
    `;

/**
 * __useCustomerSupportQuery__
 *
 * To run a query within a React component, call `useCustomerSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSupportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSupportQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerSupportQuery(baseOptions?: Apollo.QueryHookOptions<CustomerSupportQuery, CustomerSupportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSupportQuery, CustomerSupportQueryVariables>(CustomerSupportDocument, options);
      }
export function useCustomerSupportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSupportQuery, CustomerSupportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSupportQuery, CustomerSupportQueryVariables>(CustomerSupportDocument, options);
        }
export function useCustomerSupportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerSupportQuery, CustomerSupportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerSupportQuery, CustomerSupportQueryVariables>(CustomerSupportDocument, options);
        }
export type CustomerSupportQueryHookResult = ReturnType<typeof useCustomerSupportQuery>;
export type CustomerSupportLazyQueryHookResult = ReturnType<typeof useCustomerSupportLazyQuery>;
export type CustomerSupportSuspenseQueryHookResult = ReturnType<typeof useCustomerSupportSuspenseQuery>;
export type CustomerSupportQueryResult = Apollo.QueryResult<CustomerSupportQuery, CustomerSupportQueryVariables>;
export const UpdateCustomerSupportDocument = gql`
    mutation UpdateCustomerSupport($input: CustomerSupportInput!) {
  updateCustomerSupport(input: $input) {
    query {
      me {
        Id
        customerSupport {
          supportAccess
        }
      }
    }
  }
}
    `;
export type UpdateCustomerSupportMutationFn = Apollo.MutationFunction<UpdateCustomerSupportMutation, UpdateCustomerSupportMutationVariables>;

/**
 * __useUpdateCustomerSupportMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSupportMutation, { data, loading, error }] = useUpdateCustomerSupportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerSupportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerSupportMutation, UpdateCustomerSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerSupportMutation, UpdateCustomerSupportMutationVariables>(UpdateCustomerSupportDocument, options);
      }
export type UpdateCustomerSupportMutationHookResult = ReturnType<typeof useUpdateCustomerSupportMutation>;
export type UpdateCustomerSupportMutationResult = Apollo.MutationResult<UpdateCustomerSupportMutation>;
export type UpdateCustomerSupportMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerSupportMutation, UpdateCustomerSupportMutationVariables>;
export const EmployeeNotificationSettingsDocument = gql`
    query EmployeeNotificationSettings {
  me {
    Id
    notificationSettings {
      Id
      Name
      flair__Employee__c
      flair__ApprovedAbsence_Email__c
      flair__ApprovedAbsence_Slack__c
      flair__ApprovedAbsence_Push__c
      flair__NewAbsenceApprovalRequest_Email__c
      flair__NewAbsenceApprovalRequest_Slack__c
      flair__NewAbsenceApprovalRequest_Push__c
      flair__RejectedAbsence_Email__c
      flair__RejectedAbsence_Slack__c
      flair__RejectedAbsence_Push__c
      flair__OpenShiftRequest_Email__c
      flair__OpenShiftRequest_Push__c
      flair__OpenShiftRequestCreated_Email__c
      flair__OpenShiftRequestCreated_Push__c
      flair__TimeTrackingAutoClockOut_Email__c
      flair__TimeTrackingAutoClockOutManager_Email__c
      flair__OpenShiftsPublished_Email__c
      flair__OpenShiftsPublished_Push__c
      flair__EmployeeShiftsPublished_Email__c
      flair__EmployeeShiftsPublished_Push__c
      flair__TimesheetApproved_Slack__c
      flair__TimesheetPendingWeekly_Slack__c
      flair__TimeEntryAdded_Slack__c
      flair__TimeEntryDeleted_Email__c
      flair__TimeEntryDeleted_Slack__c
      flair__NewTimeEntryChangeRequest_Email__c
      flair__TimeEntryChangesApproved_Email__c
      flair__TimeEntryChangesApproved_Slack__c
      flair__TimeEntryChangesRejected_Slack__c
      flair__EmployeeDataChanges_Email__c
      flair__EmployeeDataChanges_Push__c
      flair__EmployeeFeedbackNotification_Email__c
      flair__EmployeeFeedbackNotification_Push__c
      flair__EmployeeUpload_Email__c
      flair__EmployeeUpload_Push__c
      flair__NewEmployeeDocument_Email__c
      flair__NewEmployeeDocument_Push__c
      flair__InformHiringManager_Email__c
      flair__CandidateEvaluation_Email__c
      flair__CandidateEvaluated_Email__c
      flair__DeletedAbsence_Email__c
      flair__DeletedAbsence_Push__c
      flair__NewAbsence_Email__c
      flair__PfReviewMeetingAttendee_Email__c
      flair__PfReviewMeetingOrganizer_Email__c
      flair__FC_EmployeeReviewSubmitted_Email__c
      flair__FC_ReviewerReviewSubmitted_Email__c
      flair__CelebrationReceived_Email__c
      flair__CelebrationReceived_Slack__c
      flair__PendingWorkflowItems_Email__c
      flair__PendingWorkflowItems_Slack__c
      flair__ExpiringWorkflowItems_Email__c
      flair__ExpiringWorkflowItems_Slack__c
      flair__CommentCreated_Email__c
      flair__CommentCreated_Slack__c
      flair__TicketSubmitted_Email__c
      flair__TicketAssigned_Email__c
      flair__TicketStatusChanged_Email__c
      flair__TicketShared_Email__c
      flair__TicketClosed_Email__c
      flair__TimeBalanceWithdrawalCreated_Email__c
    }
  }
}
    `;

/**
 * __useEmployeeNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useEmployeeNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>(EmployeeNotificationSettingsDocument, options);
      }
export function useEmployeeNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>(EmployeeNotificationSettingsDocument, options);
        }
export function useEmployeeNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>(EmployeeNotificationSettingsDocument, options);
        }
export type EmployeeNotificationSettingsQueryHookResult = ReturnType<typeof useEmployeeNotificationSettingsQuery>;
export type EmployeeNotificationSettingsLazyQueryHookResult = ReturnType<typeof useEmployeeNotificationSettingsLazyQuery>;
export type EmployeeNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useEmployeeNotificationSettingsSuspenseQuery>;
export type EmployeeNotificationSettingsQueryResult = Apollo.QueryResult<EmployeeNotificationSettingsQuery, EmployeeNotificationSettingsQueryVariables>;
export const UpdateEmployeeNotificationSettingsDocument = gql`
    mutation UpdateEmployeeNotificationSettings($input: EmployeeNotificationSettingsInput!) {
  updateEmployeeNotificationSettings(input: $input)
}
    `;
export type UpdateEmployeeNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateEmployeeNotificationSettingsMutation, UpdateEmployeeNotificationSettingsMutationVariables>;

/**
 * __useUpdateEmployeeNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeNotificationSettingsMutation, { data, loading, error }] = useUpdateEmployeeNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeNotificationSettingsMutation, UpdateEmployeeNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeNotificationSettingsMutation, UpdateEmployeeNotificationSettingsMutationVariables>(UpdateEmployeeNotificationSettingsDocument, options);
      }
export type UpdateEmployeeNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateEmployeeNotificationSettingsMutation>;
export type UpdateEmployeeNotificationSettingsMutationResult = Apollo.MutationResult<UpdateEmployeeNotificationSettingsMutation>;
export type UpdateEmployeeNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeNotificationSettingsMutation, UpdateEmployeeNotificationSettingsMutationVariables>;
export const SetSlackStatusAutoUpdateDocument = gql`
    mutation setSlackStatusAutoUpdate($autoUpdate: Boolean!) {
  slack {
    setSlackStatusAutoUpdate(input: {slackStatusAutoUpdate: $autoUpdate}) {
      query {
        slack {
          employeeSlackConnection {
            employeeId
            slackStatusAutoUpdate
          }
        }
      }
    }
  }
}
    `;
export type SetSlackStatusAutoUpdateMutationFn = Apollo.MutationFunction<SetSlackStatusAutoUpdateMutation, SetSlackStatusAutoUpdateMutationVariables>;

/**
 * __useSetSlackStatusAutoUpdateMutation__
 *
 * To run a mutation, you first call `useSetSlackStatusAutoUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSlackStatusAutoUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSlackStatusAutoUpdateMutation, { data, loading, error }] = useSetSlackStatusAutoUpdateMutation({
 *   variables: {
 *      autoUpdate: // value for 'autoUpdate'
 *   },
 * });
 */
export function useSetSlackStatusAutoUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SetSlackStatusAutoUpdateMutation, SetSlackStatusAutoUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSlackStatusAutoUpdateMutation, SetSlackStatusAutoUpdateMutationVariables>(SetSlackStatusAutoUpdateDocument, options);
      }
export type SetSlackStatusAutoUpdateMutationHookResult = ReturnType<typeof useSetSlackStatusAutoUpdateMutation>;
export type SetSlackStatusAutoUpdateMutationResult = Apollo.MutationResult<SetSlackStatusAutoUpdateMutation>;
export type SetSlackStatusAutoUpdateMutationOptions = Apollo.BaseMutationOptions<SetSlackStatusAutoUpdateMutation, SetSlackStatusAutoUpdateMutationVariables>;
export const SlackStatusAutoUpdateSettingsDocument = gql`
    query slackStatusAutoUpdateSettings {
  slack {
    ...SlackStatusAutoUpdateSettings_SlackInfo
  }
}
    ${SlackStatusAutoUpdateSettings_SlackInfoFragmentDoc}`;

/**
 * __useSlackStatusAutoUpdateSettingsQuery__
 *
 * To run a query within a React component, call `useSlackStatusAutoUpdateSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackStatusAutoUpdateSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackStatusAutoUpdateSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSlackStatusAutoUpdateSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>(SlackStatusAutoUpdateSettingsDocument, options);
      }
export function useSlackStatusAutoUpdateSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>(SlackStatusAutoUpdateSettingsDocument, options);
        }
export function useSlackStatusAutoUpdateSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>(SlackStatusAutoUpdateSettingsDocument, options);
        }
export type SlackStatusAutoUpdateSettingsQueryHookResult = ReturnType<typeof useSlackStatusAutoUpdateSettingsQuery>;
export type SlackStatusAutoUpdateSettingsLazyQueryHookResult = ReturnType<typeof useSlackStatusAutoUpdateSettingsLazyQuery>;
export type SlackStatusAutoUpdateSettingsSuspenseQueryHookResult = ReturnType<typeof useSlackStatusAutoUpdateSettingsSuspenseQuery>;
export type SlackStatusAutoUpdateSettingsQueryResult = Apollo.QueryResult<SlackStatusAutoUpdateSettingsQuery, SlackStatusAutoUpdateSettingsQueryVariables>;
export const EmployeeSkillsDocument = gql`
    query EmployeeSkills($id: String!) {
  manager {
    Id
    employee(id: $id) {
      Id
    }
  }
  activeEmployees(filter: {employeeIds: [$id]}) {
    Id
    employeeSkills {
      ...EmployeeSkillAssociation
    }
  }
  skills {
    ...Skill
  }
}
    ${EmployeeSkillAssociationFragmentDoc}
${SkillFragmentDoc}`;

/**
 * __useEmployeeSkillsQuery__
 *
 * To run a query within a React component, call `useEmployeeSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSkillsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeSkillsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeSkillsQuery, EmployeeSkillsQueryVariables> & ({ variables: EmployeeSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeSkillsQuery, EmployeeSkillsQueryVariables>(EmployeeSkillsDocument, options);
      }
export function useEmployeeSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeSkillsQuery, EmployeeSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeSkillsQuery, EmployeeSkillsQueryVariables>(EmployeeSkillsDocument, options);
        }
export function useEmployeeSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeSkillsQuery, EmployeeSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeSkillsQuery, EmployeeSkillsQueryVariables>(EmployeeSkillsDocument, options);
        }
export type EmployeeSkillsQueryHookResult = ReturnType<typeof useEmployeeSkillsQuery>;
export type EmployeeSkillsLazyQueryHookResult = ReturnType<typeof useEmployeeSkillsLazyQuery>;
export type EmployeeSkillsSuspenseQueryHookResult = ReturnType<typeof useEmployeeSkillsSuspenseQuery>;
export type EmployeeSkillsQueryResult = Apollo.QueryResult<EmployeeSkillsQuery, EmployeeSkillsQueryVariables>;
export const SkillNamesDocument = gql`
    query SkillNames {
  skills {
    ...SkillNames
  }
}
    ${SkillNamesFragmentDoc}`;

/**
 * __useSkillNamesQuery__
 *
 * To run a query within a React component, call `useSkillNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillNamesQuery(baseOptions?: Apollo.QueryHookOptions<SkillNamesQuery, SkillNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillNamesQuery, SkillNamesQueryVariables>(SkillNamesDocument, options);
      }
export function useSkillNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillNamesQuery, SkillNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillNamesQuery, SkillNamesQueryVariables>(SkillNamesDocument, options);
        }
export function useSkillNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillNamesQuery, SkillNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillNamesQuery, SkillNamesQueryVariables>(SkillNamesDocument, options);
        }
export type SkillNamesQueryHookResult = ReturnType<typeof useSkillNamesQuery>;
export type SkillNamesLazyQueryHookResult = ReturnType<typeof useSkillNamesLazyQuery>;
export type SkillNamesSuspenseQueryHookResult = ReturnType<typeof useSkillNamesSuspenseQuery>;
export type SkillNamesQueryResult = Apollo.QueryResult<SkillNamesQuery, SkillNamesQueryVariables>;
export const UpdateSkillTopDocument = gql`
    mutation updateSkillTop($input: UpdateSkillTopInput!) {
  employeeSkills {
    updateSkillTop(input: $input) {
      error
      record {
        ...UpdateSkillTopResponse
      }
    }
  }
}
    ${UpdateSkillTopResponseFragmentDoc}`;
export type UpdateSkillTopMutationFn = Apollo.MutationFunction<UpdateSkillTopMutation, UpdateSkillTopMutationVariables>;

/**
 * __useUpdateSkillTopMutation__
 *
 * To run a mutation, you first call `useUpdateSkillTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkillTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkillTopMutation, { data, loading, error }] = useUpdateSkillTopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSkillTopMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkillTopMutation, UpdateSkillTopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkillTopMutation, UpdateSkillTopMutationVariables>(UpdateSkillTopDocument, options);
      }
export type UpdateSkillTopMutationHookResult = ReturnType<typeof useUpdateSkillTopMutation>;
export type UpdateSkillTopMutationResult = Apollo.MutationResult<UpdateSkillTopMutation>;
export type UpdateSkillTopMutationOptions = Apollo.BaseMutationOptions<UpdateSkillTopMutation, UpdateSkillTopMutationVariables>;
export const ManagerSkillsDocument = gql`
    query ManagerSkills {
  skills {
    ...ManagerSkill
  }
}
    ${ManagerSkillFragmentDoc}`;

/**
 * __useManagerSkillsQuery__
 *
 * To run a query within a React component, call `useManagerSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagerSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ManagerSkillsQuery, ManagerSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerSkillsQuery, ManagerSkillsQueryVariables>(ManagerSkillsDocument, options);
      }
export function useManagerSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerSkillsQuery, ManagerSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerSkillsQuery, ManagerSkillsQueryVariables>(ManagerSkillsDocument, options);
        }
export function useManagerSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerSkillsQuery, ManagerSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerSkillsQuery, ManagerSkillsQueryVariables>(ManagerSkillsDocument, options);
        }
export type ManagerSkillsQueryHookResult = ReturnType<typeof useManagerSkillsQuery>;
export type ManagerSkillsLazyQueryHookResult = ReturnType<typeof useManagerSkillsLazyQuery>;
export type ManagerSkillsSuspenseQueryHookResult = ReturnType<typeof useManagerSkillsSuspenseQuery>;
export type ManagerSkillsQueryResult = Apollo.QueryResult<ManagerSkillsQuery, ManagerSkillsQueryVariables>;
export const CreateSkillDocument = gql`
    mutation CreateSkill($input: CreateSkillInput!) {
  skills {
    createSkill(input: $input) {
      query {
        skills {
          ...ManagerSkill
        }
      }
      error
    }
  }
}
    ${ManagerSkillFragmentDoc}`;
export type CreateSkillMutationFn = Apollo.MutationFunction<CreateSkillMutation, CreateSkillMutationVariables>;

/**
 * __useCreateSkillMutation__
 *
 * To run a mutation, you first call `useCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillMutation, { data, loading, error }] = useCreateSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSkillMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkillMutation, CreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkillMutation, CreateSkillMutationVariables>(CreateSkillDocument, options);
      }
export type CreateSkillMutationHookResult = ReturnType<typeof useCreateSkillMutation>;
export type CreateSkillMutationResult = Apollo.MutationResult<CreateSkillMutation>;
export type CreateSkillMutationOptions = Apollo.BaseMutationOptions<CreateSkillMutation, CreateSkillMutationVariables>;
export const UpdateSkillDocument = gql`
    mutation updateSkill($input: UpdateSkillInput!) {
  skills {
    updateSkill(input: $input) {
      recordId
      record {
        ...ManagerSkill
      }
      error
    }
  }
}
    ${ManagerSkillFragmentDoc}`;
export type UpdateSkillMutationFn = Apollo.MutationFunction<UpdateSkillMutation, UpdateSkillMutationVariables>;

/**
 * __useUpdateSkillMutation__
 *
 * To run a mutation, you first call `useUpdateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkillMutation, { data, loading, error }] = useUpdateSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSkillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkillMutation, UpdateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkillMutation, UpdateSkillMutationVariables>(UpdateSkillDocument, options);
      }
export type UpdateSkillMutationHookResult = ReturnType<typeof useUpdateSkillMutation>;
export type UpdateSkillMutationResult = Apollo.MutationResult<UpdateSkillMutation>;
export type UpdateSkillMutationOptions = Apollo.BaseMutationOptions<UpdateSkillMutation, UpdateSkillMutationVariables>;
export const DeleteSkillDocument = gql`
    mutation DeleteSkill($input: DeleteSkillInput!) {
  skills {
    deleteSkill(input: $input) {
      query {
        skills {
          ...ManagerSkill
        }
      }
      error
    }
  }
}
    ${ManagerSkillFragmentDoc}`;
export type DeleteSkillMutationFn = Apollo.MutationFunction<DeleteSkillMutation, DeleteSkillMutationVariables>;

/**
 * __useDeleteSkillMutation__
 *
 * To run a mutation, you first call `useDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillMutation, { data, loading, error }] = useDeleteSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSkillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillMutation, DeleteSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillMutation, DeleteSkillMutationVariables>(DeleteSkillDocument, options);
      }
export type DeleteSkillMutationHookResult = ReturnType<typeof useDeleteSkillMutation>;
export type DeleteSkillMutationResult = Apollo.MutationResult<DeleteSkillMutation>;
export type DeleteSkillMutationOptions = Apollo.BaseMutationOptions<DeleteSkillMutation, DeleteSkillMutationVariables>;
export const AddEmployeeSkillDocument = gql`
    mutation addEmployeeSkill($input: AddSkillToEmployeeInput!) {
  employeeSkills {
    addSkill(input: $input) {
      ...ReloadAllEmployeeSkillsPayload
    }
  }
}
    ${ReloadAllEmployeeSkillsPayloadFragmentDoc}`;
export type AddEmployeeSkillMutationFn = Apollo.MutationFunction<AddEmployeeSkillMutation, AddEmployeeSkillMutationVariables>;

/**
 * __useAddEmployeeSkillMutation__
 *
 * To run a mutation, you first call `useAddEmployeeSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeeSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeeSkillMutation, { data, loading, error }] = useAddEmployeeSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEmployeeSkillMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeeSkillMutation, AddEmployeeSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeeSkillMutation, AddEmployeeSkillMutationVariables>(AddEmployeeSkillDocument, options);
      }
export type AddEmployeeSkillMutationHookResult = ReturnType<typeof useAddEmployeeSkillMutation>;
export type AddEmployeeSkillMutationResult = Apollo.MutationResult<AddEmployeeSkillMutation>;
export type AddEmployeeSkillMutationOptions = Apollo.BaseMutationOptions<AddEmployeeSkillMutation, AddEmployeeSkillMutationVariables>;
export const RemoveEmployeeSkillDocument = gql`
    mutation removeEmployeeSkill($input: RemoveSkillFromEmployeeInput!) {
  employeeSkills {
    removeSkill(input: $input) {
      ...ReloadAllEmployeeSkillsPayload
    }
  }
}
    ${ReloadAllEmployeeSkillsPayloadFragmentDoc}`;
export type RemoveEmployeeSkillMutationFn = Apollo.MutationFunction<RemoveEmployeeSkillMutation, RemoveEmployeeSkillMutationVariables>;

/**
 * __useRemoveEmployeeSkillMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeeSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeeSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeeSkillMutation, { data, loading, error }] = useRemoveEmployeeSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveEmployeeSkillMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeeSkillMutation, RemoveEmployeeSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeeSkillMutation, RemoveEmployeeSkillMutationVariables>(RemoveEmployeeSkillDocument, options);
      }
export type RemoveEmployeeSkillMutationHookResult = ReturnType<typeof useRemoveEmployeeSkillMutation>;
export type RemoveEmployeeSkillMutationResult = Apollo.MutationResult<RemoveEmployeeSkillMutation>;
export type RemoveEmployeeSkillMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeeSkillMutation, RemoveEmployeeSkillMutationVariables>;
export const UpdateSkillRateDocument = gql`
    mutation updateSkillRate($input: UpdateSkillRateInput!) {
  employeeSkills {
    updateSkillRate(input: $input) {
      error
      record {
        ...UpdateSkillRateResponse
      }
    }
  }
}
    ${UpdateSkillRateResponseFragmentDoc}`;
export type UpdateSkillRateMutationFn = Apollo.MutationFunction<UpdateSkillRateMutation, UpdateSkillRateMutationVariables>;

/**
 * __useUpdateSkillRateMutation__
 *
 * To run a mutation, you first call `useUpdateSkillRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkillRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkillRateMutation, { data, loading, error }] = useUpdateSkillRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSkillRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkillRateMutation, UpdateSkillRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkillRateMutation, UpdateSkillRateMutationVariables>(UpdateSkillRateDocument, options);
      }
export type UpdateSkillRateMutationHookResult = ReturnType<typeof useUpdateSkillRateMutation>;
export type UpdateSkillRateMutationResult = Apollo.MutationResult<UpdateSkillRateMutation>;
export type UpdateSkillRateMutationOptions = Apollo.BaseMutationOptions<UpdateSkillRateMutation, UpdateSkillRateMutationVariables>;
export const EmployeeSkillsMatrixDocument = gql`
    query EmployeeSkillsMatrix($employeeIds: [String!]!) {
  activeEmployees(filter: {employeeIds: $employeeIds}) {
    Id
    employeeSkills {
      ...EmployeeSkillMatrix
    }
  }
}
    ${EmployeeSkillMatrixFragmentDoc}`;

/**
 * __useEmployeeSkillsMatrixQuery__
 *
 * To run a query within a React component, call `useEmployeeSkillsMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSkillsMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSkillsMatrixQuery({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useEmployeeSkillsMatrixQuery(baseOptions: Apollo.QueryHookOptions<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables> & ({ variables: EmployeeSkillsMatrixQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables>(EmployeeSkillsMatrixDocument, options);
      }
export function useEmployeeSkillsMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables>(EmployeeSkillsMatrixDocument, options);
        }
export function useEmployeeSkillsMatrixSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables>(EmployeeSkillsMatrixDocument, options);
        }
export type EmployeeSkillsMatrixQueryHookResult = ReturnType<typeof useEmployeeSkillsMatrixQuery>;
export type EmployeeSkillsMatrixLazyQueryHookResult = ReturnType<typeof useEmployeeSkillsMatrixLazyQuery>;
export type EmployeeSkillsMatrixSuspenseQueryHookResult = ReturnType<typeof useEmployeeSkillsMatrixSuspenseQuery>;
export type EmployeeSkillsMatrixQueryResult = Apollo.QueryResult<EmployeeSkillsMatrixQuery, EmployeeSkillsMatrixQueryVariables>;
export const AllActiveEmployeesMatrixDocument = gql`
    query AllActiveEmployeesMatrix {
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
}
    ${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __useAllActiveEmployeesMatrixQuery__
 *
 * To run a query within a React component, call `useAllActiveEmployeesMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActiveEmployeesMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActiveEmployeesMatrixQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllActiveEmployeesMatrixQuery(baseOptions?: Apollo.QueryHookOptions<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>(AllActiveEmployeesMatrixDocument, options);
      }
export function useAllActiveEmployeesMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>(AllActiveEmployeesMatrixDocument, options);
        }
export function useAllActiveEmployeesMatrixSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>(AllActiveEmployeesMatrixDocument, options);
        }
export type AllActiveEmployeesMatrixQueryHookResult = ReturnType<typeof useAllActiveEmployeesMatrixQuery>;
export type AllActiveEmployeesMatrixLazyQueryHookResult = ReturnType<typeof useAllActiveEmployeesMatrixLazyQuery>;
export type AllActiveEmployeesMatrixSuspenseQueryHookResult = ReturnType<typeof useAllActiveEmployeesMatrixSuspenseQuery>;
export type AllActiveEmployeesMatrixQueryResult = Apollo.QueryResult<AllActiveEmployeesMatrixQuery, AllActiveEmployeesMatrixQueryVariables>;
export const MySubordinatesSkillsDocument = gql`
    query MySubordinatesSkills {
  manager {
    Id
    employees {
      ...EmployeeSelectInfo
      employeeSkills {
        ...EmployeeSkillMatrix
      }
    }
  }
}
    ${EmployeeSelectInfoFragmentDoc}
${EmployeeSkillMatrixFragmentDoc}`;

/**
 * __useMySubordinatesSkillsQuery__
 *
 * To run a query within a React component, call `useMySubordinatesSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubordinatesSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubordinatesSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySubordinatesSkillsQuery(baseOptions?: Apollo.QueryHookOptions<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>(MySubordinatesSkillsDocument, options);
      }
export function useMySubordinatesSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>(MySubordinatesSkillsDocument, options);
        }
export function useMySubordinatesSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>(MySubordinatesSkillsDocument, options);
        }
export type MySubordinatesSkillsQueryHookResult = ReturnType<typeof useMySubordinatesSkillsQuery>;
export type MySubordinatesSkillsLazyQueryHookResult = ReturnType<typeof useMySubordinatesSkillsLazyQuery>;
export type MySubordinatesSkillsSuspenseQueryHookResult = ReturnType<typeof useMySubordinatesSkillsSuspenseQuery>;
export type MySubordinatesSkillsQueryResult = Apollo.QueryResult<MySubordinatesSkillsQuery, MySubordinatesSkillsQueryVariables>;
export const EmployeeAuthorizeUrlDocument = gql`
    mutation EmployeeAuthorizeUrl($userScopes: [String!]!, $successRedirectUrl: String!) {
  slack {
    employeeAuthorizeUrl(
      userScopes: $userScopes
      successRedirectUrl: $successRedirectUrl
    ) {
      installationUri
    }
  }
}
    `;
export type EmployeeAuthorizeUrlMutationFn = Apollo.MutationFunction<EmployeeAuthorizeUrlMutation, EmployeeAuthorizeUrlMutationVariables>;

/**
 * __useEmployeeAuthorizeUrlMutation__
 *
 * To run a mutation, you first call `useEmployeeAuthorizeUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeAuthorizeUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeAuthorizeUrlMutation, { data, loading, error }] = useEmployeeAuthorizeUrlMutation({
 *   variables: {
 *      userScopes: // value for 'userScopes'
 *      successRedirectUrl: // value for 'successRedirectUrl'
 *   },
 * });
 */
export function useEmployeeAuthorizeUrlMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeAuthorizeUrlMutation, EmployeeAuthorizeUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeAuthorizeUrlMutation, EmployeeAuthorizeUrlMutationVariables>(EmployeeAuthorizeUrlDocument, options);
      }
export type EmployeeAuthorizeUrlMutationHookResult = ReturnType<typeof useEmployeeAuthorizeUrlMutation>;
export type EmployeeAuthorizeUrlMutationResult = Apollo.MutationResult<EmployeeAuthorizeUrlMutation>;
export type EmployeeAuthorizeUrlMutationOptions = Apollo.BaseMutationOptions<EmployeeAuthorizeUrlMutation, EmployeeAuthorizeUrlMutationVariables>;
export const CreateSlackInstallationDocument = gql`
    mutation CreateSlackInstallation {
  slack {
    slackAppAuthorizeUrl {
      installationUri
    }
  }
}
    `;
export type CreateSlackInstallationMutationFn = Apollo.MutationFunction<CreateSlackInstallationMutation, CreateSlackInstallationMutationVariables>;

/**
 * __useCreateSlackInstallationMutation__
 *
 * To run a mutation, you first call `useCreateSlackInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackInstallationMutation, { data, loading, error }] = useCreateSlackInstallationMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSlackInstallationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlackInstallationMutation, CreateSlackInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlackInstallationMutation, CreateSlackInstallationMutationVariables>(CreateSlackInstallationDocument, options);
      }
export type CreateSlackInstallationMutationHookResult = ReturnType<typeof useCreateSlackInstallationMutation>;
export type CreateSlackInstallationMutationResult = Apollo.MutationResult<CreateSlackInstallationMutation>;
export type CreateSlackInstallationMutationOptions = Apollo.BaseMutationOptions<CreateSlackInstallationMutation, CreateSlackInstallationMutationVariables>;
export const UpdateSlackUserDocument = gql`
    mutation UpdateSlackUser($slackUser: String!) {
  slack {
    connectToSlackUser(input: {slackUser: $slackUser}) {
      result
    }
  }
}
    `;
export type UpdateSlackUserMutationFn = Apollo.MutationFunction<UpdateSlackUserMutation, UpdateSlackUserMutationVariables>;

/**
 * __useUpdateSlackUserMutation__
 *
 * To run a mutation, you first call `useUpdateSlackUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlackUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlackUserMutation, { data, loading, error }] = useUpdateSlackUserMutation({
 *   variables: {
 *      slackUser: // value for 'slackUser'
 *   },
 * });
 */
export function useUpdateSlackUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlackUserMutation, UpdateSlackUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlackUserMutation, UpdateSlackUserMutationVariables>(UpdateSlackUserDocument, options);
      }
export type UpdateSlackUserMutationHookResult = ReturnType<typeof useUpdateSlackUserMutation>;
export type UpdateSlackUserMutationResult = Apollo.MutationResult<UpdateSlackUserMutation>;
export type UpdateSlackUserMutationOptions = Apollo.BaseMutationOptions<UpdateSlackUserMutation, UpdateSlackUserMutationVariables>;
export const CloseTicketDocument = gql`
    mutation closeTicket($input: CloseTicketInput!) {
  ticket {
    closeTicket(input: $input) {
      record {
        Id
        ... on Ticket {
          ...TicketListData
        }
      }
    }
  }
}
    ${TicketListDataFragmentDoc}`;
export type CloseTicketMutationFn = Apollo.MutationFunction<CloseTicketMutation, CloseTicketMutationVariables>;

/**
 * __useCloseTicketMutation__
 *
 * To run a mutation, you first call `useCloseTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeTicketMutation, { data, loading, error }] = useCloseTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseTicketMutation(baseOptions?: Apollo.MutationHookOptions<CloseTicketMutation, CloseTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseTicketMutation, CloseTicketMutationVariables>(CloseTicketDocument, options);
      }
export type CloseTicketMutationHookResult = ReturnType<typeof useCloseTicketMutation>;
export type CloseTicketMutationResult = Apollo.MutationResult<CloseTicketMutation>;
export type CloseTicketMutationOptions = Apollo.BaseMutationOptions<CloseTicketMutation, CloseTicketMutationVariables>;
export const TicketFilterDocument = gql`
    query TicketFilter($type: DictionaryItemType!) {
  dictionaryItemsByType(type: $type) {
    ...TicketsDictionaryData
  }
  activeEmployees {
    ...EmployeeSelectInfoColleague
  }
}
    ${TicketsDictionaryDataFragmentDoc}
${EmployeeSelectInfoColleagueFragmentDoc}`;

/**
 * __useTicketFilterQuery__
 *
 * To run a query within a React component, call `useTicketFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketFilterQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTicketFilterQuery(baseOptions: Apollo.QueryHookOptions<TicketFilterQuery, TicketFilterQueryVariables> & ({ variables: TicketFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketFilterQuery, TicketFilterQueryVariables>(TicketFilterDocument, options);
      }
export function useTicketFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketFilterQuery, TicketFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketFilterQuery, TicketFilterQueryVariables>(TicketFilterDocument, options);
        }
export function useTicketFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketFilterQuery, TicketFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketFilterQuery, TicketFilterQueryVariables>(TicketFilterDocument, options);
        }
export type TicketFilterQueryHookResult = ReturnType<typeof useTicketFilterQuery>;
export type TicketFilterLazyQueryHookResult = ReturnType<typeof useTicketFilterLazyQuery>;
export type TicketFilterSuspenseQueryHookResult = ReturnType<typeof useTicketFilterSuspenseQuery>;
export type TicketFilterQueryResult = Apollo.QueryResult<TicketFilterQuery, TicketFilterQueryVariables>;
export const CreateTicketDocument = gql`
    mutation createTicket($input: CreateTicketInput!) {
  ticket {
    createTicket(input: $input) {
      record {
        Id
        ... on Ticket {
          ...TicketListData
        }
      }
    }
  }
}
    ${TicketListDataFragmentDoc}`;
export type CreateTicketMutationFn = Apollo.MutationFunction<CreateTicketMutation, CreateTicketMutationVariables>;

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTicketMutation, CreateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTicketMutation, CreateTicketMutationVariables>(CreateTicketDocument, options);
      }
export type CreateTicketMutationHookResult = ReturnType<typeof useCreateTicketMutation>;
export type CreateTicketMutationResult = Apollo.MutationResult<CreateTicketMutation>;
export type CreateTicketMutationOptions = Apollo.BaseMutationOptions<CreateTicketMutation, CreateTicketMutationVariables>;
export const TicketPolicyDocument = gql`
    query TicketPolicy {
  ticketPolicy {
    ...TicketPolicyData
  }
}
    ${TicketPolicyDataFragmentDoc}`;

/**
 * __useTicketPolicyQuery__
 *
 * To run a query within a React component, call `useTicketPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTicketPolicyQuery(baseOptions?: Apollo.QueryHookOptions<TicketPolicyQuery, TicketPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketPolicyQuery, TicketPolicyQueryVariables>(TicketPolicyDocument, options);
      }
export function useTicketPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketPolicyQuery, TicketPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketPolicyQuery, TicketPolicyQueryVariables>(TicketPolicyDocument, options);
        }
export function useTicketPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketPolicyQuery, TicketPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketPolicyQuery, TicketPolicyQueryVariables>(TicketPolicyDocument, options);
        }
export type TicketPolicyQueryHookResult = ReturnType<typeof useTicketPolicyQuery>;
export type TicketPolicyLazyQueryHookResult = ReturnType<typeof useTicketPolicyLazyQuery>;
export type TicketPolicySuspenseQueryHookResult = ReturnType<typeof useTicketPolicySuspenseQuery>;
export type TicketPolicyQueryResult = Apollo.QueryResult<TicketPolicyQuery, TicketPolicyQueryVariables>;
export const TicketCategoriesDocument = gql`
    query TicketCategories($type: DictionaryItemType!) {
  dictionaryItemsByType(type: $type) {
    ...TicketsDictionaryData
  }
}
    ${TicketsDictionaryDataFragmentDoc}`;

/**
 * __useTicketCategoriesQuery__
 *
 * To run a query within a React component, call `useTicketCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketCategoriesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTicketCategoriesQuery(baseOptions: Apollo.QueryHookOptions<TicketCategoriesQuery, TicketCategoriesQueryVariables> & ({ variables: TicketCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketCategoriesQuery, TicketCategoriesQueryVariables>(TicketCategoriesDocument, options);
      }
export function useTicketCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketCategoriesQuery, TicketCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketCategoriesQuery, TicketCategoriesQueryVariables>(TicketCategoriesDocument, options);
        }
export function useTicketCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketCategoriesQuery, TicketCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketCategoriesQuery, TicketCategoriesQueryVariables>(TicketCategoriesDocument, options);
        }
export type TicketCategoriesQueryHookResult = ReturnType<typeof useTicketCategoriesQuery>;
export type TicketCategoriesLazyQueryHookResult = ReturnType<typeof useTicketCategoriesLazyQuery>;
export type TicketCategoriesSuspenseQueryHookResult = ReturnType<typeof useTicketCategoriesSuspenseQuery>;
export type TicketCategoriesQueryResult = Apollo.QueryResult<TicketCategoriesQuery, TicketCategoriesQueryVariables>;
export const TicketEmployeeOptionsDocument = gql`
    query TicketEmployeeOptions($managerReportsType: ManagerReportsType!) {
  manager {
    Id
    employees(filter: {managerReportsType: $managerReportsType}) {
      ...ManagerEmployeeData
    }
  }
}
    ${ManagerEmployeeDataFragmentDoc}`;

/**
 * __useTicketEmployeeOptionsQuery__
 *
 * To run a query within a React component, call `useTicketEmployeeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketEmployeeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketEmployeeOptionsQuery({
 *   variables: {
 *      managerReportsType: // value for 'managerReportsType'
 *   },
 * });
 */
export function useTicketEmployeeOptionsQuery(baseOptions: Apollo.QueryHookOptions<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables> & ({ variables: TicketEmployeeOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables>(TicketEmployeeOptionsDocument, options);
      }
export function useTicketEmployeeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables>(TicketEmployeeOptionsDocument, options);
        }
export function useTicketEmployeeOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables>(TicketEmployeeOptionsDocument, options);
        }
export type TicketEmployeeOptionsQueryHookResult = ReturnType<typeof useTicketEmployeeOptionsQuery>;
export type TicketEmployeeOptionsLazyQueryHookResult = ReturnType<typeof useTicketEmployeeOptionsLazyQuery>;
export type TicketEmployeeOptionsSuspenseQueryHookResult = ReturnType<typeof useTicketEmployeeOptionsSuspenseQuery>;
export type TicketEmployeeOptionsQueryResult = Apollo.QueryResult<TicketEmployeeOptionsQuery, TicketEmployeeOptionsQueryVariables>;
export const TicketSubjectsDocument = gql`
    query TicketSubjects($id: String!) {
  dictionaryItemsByParent(id: $id) {
    ...TicketsDictionaryData
  }
}
    ${TicketsDictionaryDataFragmentDoc}`;

/**
 * __useTicketSubjectsQuery__
 *
 * To run a query within a React component, call `useTicketSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketSubjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTicketSubjectsQuery(baseOptions: Apollo.QueryHookOptions<TicketSubjectsQuery, TicketSubjectsQueryVariables> & ({ variables: TicketSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketSubjectsQuery, TicketSubjectsQueryVariables>(TicketSubjectsDocument, options);
      }
export function useTicketSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketSubjectsQuery, TicketSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketSubjectsQuery, TicketSubjectsQueryVariables>(TicketSubjectsDocument, options);
        }
export function useTicketSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketSubjectsQuery, TicketSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketSubjectsQuery, TicketSubjectsQueryVariables>(TicketSubjectsDocument, options);
        }
export type TicketSubjectsQueryHookResult = ReturnType<typeof useTicketSubjectsQuery>;
export type TicketSubjectsLazyQueryHookResult = ReturnType<typeof useTicketSubjectsLazyQuery>;
export type TicketSubjectsSuspenseQueryHookResult = ReturnType<typeof useTicketSubjectsSuspenseQuery>;
export type TicketSubjectsQueryResult = Apollo.QueryResult<TicketSubjectsQuery, TicketSubjectsQueryVariables>;
export const TicketListDocument = gql`
    query TicketList($filter: TicketFilterInput!, $sort: TicketSortInput, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!, $anonymousTicketIds: [String!]!) {
  ticketPagination(
    anonymousTicketIds: $anonymousTicketIds
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    items {
      ...TicketListData
    }
    paginationInfo @skip(if: $skipPaginationInfo) {
      totalCount
    }
  }
}
    ${TicketListDataFragmentDoc}`;

/**
 * __useTicketListQuery__
 *
 * To run a query within a React component, call `useTicketListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *      anonymousTicketIds: // value for 'anonymousTicketIds'
 *   },
 * });
 */
export function useTicketListQuery(baseOptions: Apollo.QueryHookOptions<TicketListQuery, TicketListQueryVariables> & ({ variables: TicketListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketListQuery, TicketListQueryVariables>(TicketListDocument, options);
      }
export function useTicketListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketListQuery, TicketListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketListQuery, TicketListQueryVariables>(TicketListDocument, options);
        }
export function useTicketListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketListQuery, TicketListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketListQuery, TicketListQueryVariables>(TicketListDocument, options);
        }
export type TicketListQueryHookResult = ReturnType<typeof useTicketListQuery>;
export type TicketListLazyQueryHookResult = ReturnType<typeof useTicketListLazyQuery>;
export type TicketListSuspenseQueryHookResult = ReturnType<typeof useTicketListSuspenseQuery>;
export type TicketListQueryResult = Apollo.QueryResult<TicketListQuery, TicketListQueryVariables>;
export const TicketSidebarDocument = gql`
    query TicketSidebar($id: String!) {
  ticketById(id: $id) {
    ...TicketSidebarData
  }
}
    ${TicketSidebarDataFragmentDoc}`;

/**
 * __useTicketSidebarQuery__
 *
 * To run a query within a React component, call `useTicketSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTicketSidebarQuery(baseOptions: Apollo.QueryHookOptions<TicketSidebarQuery, TicketSidebarQueryVariables> & ({ variables: TicketSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketSidebarQuery, TicketSidebarQueryVariables>(TicketSidebarDocument, options);
      }
export function useTicketSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketSidebarQuery, TicketSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketSidebarQuery, TicketSidebarQueryVariables>(TicketSidebarDocument, options);
        }
export function useTicketSidebarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketSidebarQuery, TicketSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketSidebarQuery, TicketSidebarQueryVariables>(TicketSidebarDocument, options);
        }
export type TicketSidebarQueryHookResult = ReturnType<typeof useTicketSidebarQuery>;
export type TicketSidebarLazyQueryHookResult = ReturnType<typeof useTicketSidebarLazyQuery>;
export type TicketSidebarSuspenseQueryHookResult = ReturnType<typeof useTicketSidebarSuspenseQuery>;
export type TicketSidebarQueryResult = Apollo.QueryResult<TicketSidebarQuery, TicketSidebarQueryVariables>;
export const TimeSheetDocument = gql`
    query TimeSheet($id: String!) {
  costCenters {
    Id
    Name
  }
  projects {
    ...ProjectFields
    historyItems {
      ...ProjectHistoryItem
    }
  }
  timeSheet(id: $id) {
    Id
    flair__Employee__c
    flair__Start_Date__c
    flair__End_Date__c
    flair__Target_Hours__c
    flair__Time_Entry_Hours__c
    flair__Absence_Hours__c
    flair__Holiday_Hours__c
    flair__Approval_Status__c
    flair__Non_Deductible_Absence_Hours__c
    flair__Type__c
    ...TimeSheetTimeEntries
    previousTimeSheet {
      Id
    }
    nextTimeSheet {
      Id
    }
    employee {
      Id
      Name
      flair__Start_Date__c
      flair__Company_Email__c
      flair__Position__c
      location {
        Id
        Name
      }
      department {
        Id
        Name
      }
      currentTimeSheet {
        Id
      }
    }
    workloads {
      Id
      ...TimeSheetWorkloadWithTimeFramework
      flair__Hours_Per_Day__c
      flair__Type__c
      workloadWeeks {
        ...WorkloadWeek
      }
    }
    paidAbsences {
      Id
      ...AbsencePopover
      flair__Category_Name__c
      flair__Category_Icon__c
      flair__Category_Id__c
      flair__Amount__c
      flair__Working_Amount__c
      flair__Start_Date__c
      flair__Start_Time__c
      flair__Start_Date_Half_Day__c
      flair__End_Date__c
      flair__End_Time__c
      flair__End_Date_Half_Day__c
      flair__Type__c
      flair__Paid__c
      flair__Approval_Status__c
      flair__Category_Unlimited__c
    }
    holidays {
      ...LocationHoliday
    }
    calendarPeriods {
      ...TimeSheetCalendarPeriod
    }
    timeEntryChangeRequests {
      ...TimeEntryChangeRequestFields
    }
    timeSheetDays {
      ...TimeSheetDayId
      commentsCount
      flair__Time_Entries_Minutes__c
      loomVideo {
        ...LoomVideo
      }
      timeSheetDayProjectTimeEntries {
        ...TimeSheetDayProjectTimeEntry
      }
    }
  }
}
    ${ProjectFieldsFragmentDoc}
${ProjectHistoryItemFragmentDoc}
${TimeSheetTimeEntriesFragmentDoc}
${TimeSheetWorkloadWithTimeFrameworkFragmentDoc}
${WorkloadWeekFragmentDoc}
${AbsencePopoverFragmentDoc}
${LocationHolidayFragmentDoc}
${TimeSheetCalendarPeriodFragmentDoc}
${TimeEntryChangeRequestFieldsFragmentDoc}
${TimeSheetDayIdFragmentDoc}
${LoomVideoFragmentDoc}
${TimeSheetDayProjectTimeEntryFragmentDoc}`;

/**
 * __useTimeSheetQuery__
 *
 * To run a query within a React component, call `useTimeSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSheetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeSheetQuery(baseOptions: Apollo.QueryHookOptions<TimeSheetQuery, TimeSheetQueryVariables> & ({ variables: TimeSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSheetQuery, TimeSheetQueryVariables>(TimeSheetDocument, options);
      }
export function useTimeSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSheetQuery, TimeSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSheetQuery, TimeSheetQueryVariables>(TimeSheetDocument, options);
        }
export function useTimeSheetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeSheetQuery, TimeSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeSheetQuery, TimeSheetQueryVariables>(TimeSheetDocument, options);
        }
export type TimeSheetQueryHookResult = ReturnType<typeof useTimeSheetQuery>;
export type TimeSheetLazyQueryHookResult = ReturnType<typeof useTimeSheetLazyQuery>;
export type TimeSheetSuspenseQueryHookResult = ReturnType<typeof useTimeSheetSuspenseQuery>;
export type TimeSheetQueryResult = Apollo.QueryResult<TimeSheetQuery, TimeSheetQueryVariables>;
export const DeleteTimeEntryDocument = gql`
    mutation DeleteTimeEntry($id: String!) {
  timeTracking {
    deleteTimeEntry(id: $id) {
      timeSheet {
        Id
        ...TimeSheetTimeEntries
        ...TimeSheetDaySubRows
      }
    }
  }
}
    ${TimeSheetTimeEntriesFragmentDoc}
${TimeSheetDaySubRowsFragmentDoc}`;
export type DeleteTimeEntryMutationFn = Apollo.MutationFunction<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>;

/**
 * __useDeleteTimeEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeEntryMutation, { data, loading, error }] = useDeleteTimeEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>(DeleteTimeEntryDocument, options);
      }
export type DeleteTimeEntryMutationHookResult = ReturnType<typeof useDeleteTimeEntryMutation>;
export type DeleteTimeEntryMutationResult = Apollo.MutationResult<DeleteTimeEntryMutation>;
export type DeleteTimeEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>;
export const UpdateMyTimeEntryNotesDocument = gql`
    mutation UpdateMyTimeEntryNotes($input: UpdateMyTimeEntryNotesInput!) {
  updateMyTimeEntryNotes(input: $input) {
    Id
    flair__Notes__c
  }
}
    `;
export type UpdateMyTimeEntryNotesMutationFn = Apollo.MutationFunction<UpdateMyTimeEntryNotesMutation, UpdateMyTimeEntryNotesMutationVariables>;

/**
 * __useUpdateMyTimeEntryNotesMutation__
 *
 * To run a mutation, you first call `useUpdateMyTimeEntryNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyTimeEntryNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyTimeEntryNotesMutation, { data, loading, error }] = useUpdateMyTimeEntryNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyTimeEntryNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyTimeEntryNotesMutation, UpdateMyTimeEntryNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyTimeEntryNotesMutation, UpdateMyTimeEntryNotesMutationVariables>(UpdateMyTimeEntryNotesDocument, options);
      }
export type UpdateMyTimeEntryNotesMutationHookResult = ReturnType<typeof useUpdateMyTimeEntryNotesMutation>;
export type UpdateMyTimeEntryNotesMutationResult = Apollo.MutationResult<UpdateMyTimeEntryNotesMutation>;
export type UpdateMyTimeEntryNotesMutationOptions = Apollo.BaseMutationOptions<UpdateMyTimeEntryNotesMutation, UpdateMyTimeEntryNotesMutationVariables>;
export const EmployeeTimeSheetsDocument = gql`
    query EmployeeTimeSheets($filter: EmployeeTimeSheetFilterInput!, $sort: [TimeSheetSortInput!], $offset: Int!, $limit: Int!, $skipPaginationInfo: Boolean!) {
  me {
    Id
    timeSheetsPagination(
      filter: $filter
      sort: $sort
      pagination: {offset: $offset, limit: $limit}
    ) {
      items {
        ...TimeSheetTable
      }
      paginationInfo @skip(if: $skipPaginationInfo) {
        totalCount
      }
    }
  }
}
    ${TimeSheetTableFragmentDoc}`;

/**
 * __useEmployeeTimeSheetsQuery__
 *
 * To run a query within a React component, call `useEmployeeTimeSheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeTimeSheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeTimeSheetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useEmployeeTimeSheetsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables> & ({ variables: EmployeeTimeSheetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables>(EmployeeTimeSheetsDocument, options);
      }
export function useEmployeeTimeSheetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables>(EmployeeTimeSheetsDocument, options);
        }
export function useEmployeeTimeSheetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables>(EmployeeTimeSheetsDocument, options);
        }
export type EmployeeTimeSheetsQueryHookResult = ReturnType<typeof useEmployeeTimeSheetsQuery>;
export type EmployeeTimeSheetsLazyQueryHookResult = ReturnType<typeof useEmployeeTimeSheetsLazyQuery>;
export type EmployeeTimeSheetsSuspenseQueryHookResult = ReturnType<typeof useEmployeeTimeSheetsSuspenseQuery>;
export type EmployeeTimeSheetsQueryResult = Apollo.QueryResult<EmployeeTimeSheetsQuery, EmployeeTimeSheetsQueryVariables>;
export const MyTimeSheetDocument = gql`
    query MyTimeSheet($employeeId: String!, $day: LocalDate!) {
  costCenters {
    Id
    Name
    flair__Code__c
  }
  projects {
    ...ProjectFields
    historyItems {
      ...ProjectHistoryItem
    }
  }
  timeSheetDay(employeeId: $employeeId, day: $day) {
    ...TimeSheetDayId
    timeSheetDayProjectTimeEntries {
      ...TimeSheetDayProjectTimeEntry
    }
    timeSheet {
      ...TimeSheetGoalChart
      Id
      flair__Employee__c
      flair__Start_Date__c
      flair__End_Date__c
      flair__Type__c
      flair__Target_Hours__c
      flair__Approval_Status__c
      flair__Current_Compensatory_Time_Level_1__c
      flair__Current_Compensatory_Time_Level_2__c
      flair__Given_Compensatory_Time_Level_1__c
      flair__Given_Compensatory_Time_Level_2__c
      previousTimeSheetStartDay
      nextTimeSheetStartDay
      trackedTime {
        ...TimesheetTrackedTimeFields
      }
      timeEntries {
        ...TimeEntryTimeSheetFields
      }
      workloads {
        Id
        flair__Start_Date__c
        flair__End_Date__c
        flair__Hours_Per_Day__c
        flair__Type__c
        timeFramework {
          ...TimeFramework
        }
        workloadWeeks {
          ...WorkloadWeek
        }
      }
      paidAbsences {
        ...TimeSheetAbsence
      }
      holidays {
        ...LocationHoliday
      }
      calendarPeriods {
        ...TimeSheetCalendarPeriod
      }
      timeEntryChangeRequests {
        ...TimeEntryChangeRequestFields
      }
      timeSheetDays {
        ...TimeSheetDayId
        commentsCount
        flair__Time_Entries_Minutes__c
        loomVideo {
          ...LoomVideo
        }
        timeSheetDayProjectTimeEntries {
          ...TimeSheetDayProjectTimeEntry
        }
      }
    }
  }
}
    ${ProjectFieldsFragmentDoc}
${ProjectHistoryItemFragmentDoc}
${TimeSheetDayIdFragmentDoc}
${TimeSheetDayProjectTimeEntryFragmentDoc}
${TimeSheetGoalChartFragmentDoc}
${TimesheetTrackedTimeFieldsFragmentDoc}
${TimeEntryTimeSheetFieldsFragmentDoc}
${TimeFrameworkFragmentDoc}
${WorkloadWeekFragmentDoc}
${TimeSheetAbsenceFragmentDoc}
${LocationHolidayFragmentDoc}
${TimeSheetCalendarPeriodFragmentDoc}
${TimeEntryChangeRequestFieldsFragmentDoc}
${LoomVideoFragmentDoc}`;

/**
 * __useMyTimeSheetQuery__
 *
 * To run a query within a React component, call `useMyTimeSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTimeSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTimeSheetQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      day: // value for 'day'
 *   },
 * });
 */
export function useMyTimeSheetQuery(baseOptions: Apollo.QueryHookOptions<MyTimeSheetQuery, MyTimeSheetQueryVariables> & ({ variables: MyTimeSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTimeSheetQuery, MyTimeSheetQueryVariables>(MyTimeSheetDocument, options);
      }
export function useMyTimeSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTimeSheetQuery, MyTimeSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTimeSheetQuery, MyTimeSheetQueryVariables>(MyTimeSheetDocument, options);
        }
export function useMyTimeSheetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTimeSheetQuery, MyTimeSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTimeSheetQuery, MyTimeSheetQueryVariables>(MyTimeSheetDocument, options);
        }
export type MyTimeSheetQueryHookResult = ReturnType<typeof useMyTimeSheetQuery>;
export type MyTimeSheetLazyQueryHookResult = ReturnType<typeof useMyTimeSheetLazyQuery>;
export type MyTimeSheetSuspenseQueryHookResult = ReturnType<typeof useMyTimeSheetSuspenseQuery>;
export type MyTimeSheetQueryResult = Apollo.QueryResult<MyTimeSheetQuery, MyTimeSheetQueryVariables>;
export const MyTimeTrackingDocument = gql`
    query MyTimeTracking {
  me {
    Id
    currentTimeEntry {
      ...CurrentTimeEntry
    }
  }
}
    ${CurrentTimeEntryFragmentDoc}`;

/**
 * __useMyTimeTrackingQuery__
 *
 * To run a query within a React component, call `useMyTimeTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTimeTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTimeTrackingQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTimeTrackingQuery(baseOptions?: Apollo.QueryHookOptions<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>(MyTimeTrackingDocument, options);
      }
export function useMyTimeTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>(MyTimeTrackingDocument, options);
        }
export function useMyTimeTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>(MyTimeTrackingDocument, options);
        }
export type MyTimeTrackingQueryHookResult = ReturnType<typeof useMyTimeTrackingQuery>;
export type MyTimeTrackingLazyQueryHookResult = ReturnType<typeof useMyTimeTrackingLazyQuery>;
export type MyTimeTrackingSuspenseQueryHookResult = ReturnType<typeof useMyTimeTrackingSuspenseQuery>;
export type MyTimeTrackingQueryResult = Apollo.QueryResult<MyTimeTrackingQuery, MyTimeTrackingQueryVariables>;
export const MyTimeTrackingSettingsDocument = gql`
    query MyTimeTrackingSettings($today: DateTime!) {
  me {
    Id
    workloads(from: $today, to: $today) {
      Id
      flair__Time_Tracking_Type__c
      flair__Start_Date__c
      flair__End_Date__c
    }
  }
}
    `;

/**
 * __useMyTimeTrackingSettingsQuery__
 *
 * To run a query within a React component, call `useMyTimeTrackingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTimeTrackingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTimeTrackingSettingsQuery({
 *   variables: {
 *      today: // value for 'today'
 *   },
 * });
 */
export function useMyTimeTrackingSettingsQuery(baseOptions: Apollo.QueryHookOptions<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables> & ({ variables: MyTimeTrackingSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables>(MyTimeTrackingSettingsDocument, options);
      }
export function useMyTimeTrackingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables>(MyTimeTrackingSettingsDocument, options);
        }
export function useMyTimeTrackingSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables>(MyTimeTrackingSettingsDocument, options);
        }
export type MyTimeTrackingSettingsQueryHookResult = ReturnType<typeof useMyTimeTrackingSettingsQuery>;
export type MyTimeTrackingSettingsLazyQueryHookResult = ReturnType<typeof useMyTimeTrackingSettingsLazyQuery>;
export type MyTimeTrackingSettingsSuspenseQueryHookResult = ReturnType<typeof useMyTimeTrackingSettingsSuspenseQuery>;
export type MyTimeTrackingSettingsQueryResult = Apollo.QueryResult<MyTimeTrackingSettingsQuery, MyTimeTrackingSettingsQueryVariables>;
export const SubmitTimeEntryDocument = gql`
    mutation SubmitTimeEntry($input: SubmitTimeEntryInput!) {
  timeTracking {
    submitTimeEntry(input: $input) {
      record {
        Id
        ...TimeEntryTimeSheetFields
        timeSheet {
          Id
          ...TimeSheetTableFields
          ...TimeSheetTimeEntries
          ...TimeSheetDaySubRows
        }
      }
      projectTimeEntries {
        ...ProjectTimesheetEntry
      }
      errors2 {
        ...TimeTrackingError
      }
    }
  }
}
    ${TimeEntryTimeSheetFieldsFragmentDoc}
${TimeSheetTableFieldsFragmentDoc}
${TimeSheetTimeEntriesFragmentDoc}
${TimeSheetDaySubRowsFragmentDoc}
${ProjectTimesheetEntryFragmentDoc}
${TimeTrackingErrorFragmentDoc}`;
export type SubmitTimeEntryMutationFn = Apollo.MutationFunction<SubmitTimeEntryMutation, SubmitTimeEntryMutationVariables>;

/**
 * __useSubmitTimeEntryMutation__
 *
 * To run a mutation, you first call `useSubmitTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTimeEntryMutation, { data, loading, error }] = useSubmitTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTimeEntryMutation, SubmitTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTimeEntryMutation, SubmitTimeEntryMutationVariables>(SubmitTimeEntryDocument, options);
      }
export type SubmitTimeEntryMutationHookResult = ReturnType<typeof useSubmitTimeEntryMutation>;
export type SubmitTimeEntryMutationResult = Apollo.MutationResult<SubmitTimeEntryMutation>;
export type SubmitTimeEntryMutationOptions = Apollo.BaseMutationOptions<SubmitTimeEntryMutation, SubmitTimeEntryMutationVariables>;
export const CreateMyTimeEntryDocument = gql`
    mutation CreateMyTimeEntry($input: StartMyTimeEntryInput) {
  timeTracking {
    createMyTimeEntry(input: $input) {
      me {
        Id
        currentTimeEntry {
          ...MyTimeEntryTimeTracking
          timeSheetId
        }
      }
      errors2 {
        ...TimeTrackingError
      }
      warnings {
        ...TimeTrackingWarning
      }
    }
  }
}
    ${MyTimeEntryTimeTrackingFragmentDoc}
${TimeTrackingErrorFragmentDoc}
${TimeTrackingWarningFragmentDoc}`;
export type CreateMyTimeEntryMutationFn = Apollo.MutationFunction<CreateMyTimeEntryMutation, CreateMyTimeEntryMutationVariables>;

/**
 * __useCreateMyTimeEntryMutation__
 *
 * To run a mutation, you first call `useCreateMyTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyTimeEntryMutation, { data, loading, error }] = useCreateMyTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyTimeEntryMutation, CreateMyTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyTimeEntryMutation, CreateMyTimeEntryMutationVariables>(CreateMyTimeEntryDocument, options);
      }
export type CreateMyTimeEntryMutationHookResult = ReturnType<typeof useCreateMyTimeEntryMutation>;
export type CreateMyTimeEntryMutationResult = Apollo.MutationResult<CreateMyTimeEntryMutation>;
export type CreateMyTimeEntryMutationOptions = Apollo.BaseMutationOptions<CreateMyTimeEntryMutation, CreateMyTimeEntryMutationVariables>;
export const PauseMyTimeEntryDocument = gql`
    mutation PauseMyTimeEntry($input: UpdateMyTimeEntryInput!) {
  timeTracking {
    pauseMyTimeEntry(input: $input) {
      record {
        ...MyTimeEntryTimeTrackingWithChangeRequest
      }
      errors2 {
        ...TimeTrackingError
      }
    }
  }
}
    ${MyTimeEntryTimeTrackingWithChangeRequestFragmentDoc}
${TimeTrackingErrorFragmentDoc}`;
export type PauseMyTimeEntryMutationFn = Apollo.MutationFunction<PauseMyTimeEntryMutation, PauseMyTimeEntryMutationVariables>;

/**
 * __usePauseMyTimeEntryMutation__
 *
 * To run a mutation, you first call `usePauseMyTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseMyTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseMyTimeEntryMutation, { data, loading, error }] = usePauseMyTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseMyTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<PauseMyTimeEntryMutation, PauseMyTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseMyTimeEntryMutation, PauseMyTimeEntryMutationVariables>(PauseMyTimeEntryDocument, options);
      }
export type PauseMyTimeEntryMutationHookResult = ReturnType<typeof usePauseMyTimeEntryMutation>;
export type PauseMyTimeEntryMutationResult = Apollo.MutationResult<PauseMyTimeEntryMutation>;
export type PauseMyTimeEntryMutationOptions = Apollo.BaseMutationOptions<PauseMyTimeEntryMutation, PauseMyTimeEntryMutationVariables>;
export const ResumeMyTimeEntryDocument = gql`
    mutation ResumeMyTimeEntry($input: UpdateMyTimeEntryInput!) {
  timeTracking {
    resumeMyTimeEntry(input: $input) {
      record {
        ...MyTimeEntryTimeTrackingWithChangeRequest
      }
      errors2 {
        ...TimeTrackingError
      }
    }
  }
}
    ${MyTimeEntryTimeTrackingWithChangeRequestFragmentDoc}
${TimeTrackingErrorFragmentDoc}`;
export type ResumeMyTimeEntryMutationFn = Apollo.MutationFunction<ResumeMyTimeEntryMutation, ResumeMyTimeEntryMutationVariables>;

/**
 * __useResumeMyTimeEntryMutation__
 *
 * To run a mutation, you first call `useResumeMyTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeMyTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeMyTimeEntryMutation, { data, loading, error }] = useResumeMyTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeMyTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<ResumeMyTimeEntryMutation, ResumeMyTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeMyTimeEntryMutation, ResumeMyTimeEntryMutationVariables>(ResumeMyTimeEntryDocument, options);
      }
export type ResumeMyTimeEntryMutationHookResult = ReturnType<typeof useResumeMyTimeEntryMutation>;
export type ResumeMyTimeEntryMutationResult = Apollo.MutationResult<ResumeMyTimeEntryMutation>;
export type ResumeMyTimeEntryMutationOptions = Apollo.BaseMutationOptions<ResumeMyTimeEntryMutation, ResumeMyTimeEntryMutationVariables>;
export const StopMyTimeEntryDocument = gql`
    mutation StopMyTimeEntry($input: StopMyTimeEntryInput!) {
  timeTracking {
    stopMyTimeEntry(input: $input) {
      ...UpdateMyTimeEntryPayload
      record {
        ...MyTimeEntryTimeTrackingWithChangeRequest
      }
    }
  }
}
    ${UpdateMyTimeEntryPayloadFragmentDoc}
${MyTimeEntryTimeTrackingWithChangeRequestFragmentDoc}`;
export type StopMyTimeEntryMutationFn = Apollo.MutationFunction<StopMyTimeEntryMutation, StopMyTimeEntryMutationVariables>;

/**
 * __useStopMyTimeEntryMutation__
 *
 * To run a mutation, you first call `useStopMyTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopMyTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopMyTimeEntryMutation, { data, loading, error }] = useStopMyTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopMyTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<StopMyTimeEntryMutation, StopMyTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopMyTimeEntryMutation, StopMyTimeEntryMutationVariables>(StopMyTimeEntryDocument, options);
      }
export type StopMyTimeEntryMutationHookResult = ReturnType<typeof useStopMyTimeEntryMutation>;
export type StopMyTimeEntryMutationResult = Apollo.MutationResult<StopMyTimeEntryMutation>;
export type StopMyTimeEntryMutationOptions = Apollo.BaseMutationOptions<StopMyTimeEntryMutation, StopMyTimeEntryMutationVariables>;
export const WorkflowItemsFilterForWorkflowDocument = gql`
    query WorkflowItemsFilterForWorkflow($workflowId: String!) {
  workflowItemsFilterOptions(workflowContext: ALL, workflowId: $workflowId) {
    responsibleEmployees {
      ...WorkflowItemsFilter_Employee
    }
    responsibleTeams {
      ...WorkflowItemsFilter_Team
    }
  }
}
    ${WorkflowItemsFilter_EmployeeFragmentDoc}
${WorkflowItemsFilter_TeamFragmentDoc}`;

/**
 * __useWorkflowItemsFilterForWorkflowQuery__
 *
 * To run a query within a React component, call `useWorkflowItemsFilterForWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowItemsFilterForWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowItemsFilterForWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useWorkflowItemsFilterForWorkflowQuery(baseOptions: Apollo.QueryHookOptions<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables> & ({ variables: WorkflowItemsFilterForWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables>(WorkflowItemsFilterForWorkflowDocument, options);
      }
export function useWorkflowItemsFilterForWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables>(WorkflowItemsFilterForWorkflowDocument, options);
        }
export function useWorkflowItemsFilterForWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables>(WorkflowItemsFilterForWorkflowDocument, options);
        }
export type WorkflowItemsFilterForWorkflowQueryHookResult = ReturnType<typeof useWorkflowItemsFilterForWorkflowQuery>;
export type WorkflowItemsFilterForWorkflowLazyQueryHookResult = ReturnType<typeof useWorkflowItemsFilterForWorkflowLazyQuery>;
export type WorkflowItemsFilterForWorkflowSuspenseQueryHookResult = ReturnType<typeof useWorkflowItemsFilterForWorkflowSuspenseQuery>;
export type WorkflowItemsFilterForWorkflowQueryResult = Apollo.QueryResult<WorkflowItemsFilterForWorkflowQuery, WorkflowItemsFilterForWorkflowQueryVariables>;
export const WorkflowItemsFilterForMeDocument = gql`
    query WorkflowItemsFilterForMe {
  workflowItemsFilterOptions(workflowContext: MY) {
    workflowTemplates {
      ...WorkflowItemsFilter_WorkflowTemplate
    }
    workflowItemTemplates {
      ...WorkflowItemsFilter_WorkflowItemTemplate
    }
    responsibleEmployees {
      ...WorkflowItemsFilter_Employee
    }
    responsibleTeams {
      ...WorkflowItemsFilter_Team
    }
  }
}
    ${WorkflowItemsFilter_WorkflowTemplateFragmentDoc}
${WorkflowItemsFilter_WorkflowItemTemplateFragmentDoc}
${WorkflowItemsFilter_EmployeeFragmentDoc}
${WorkflowItemsFilter_TeamFragmentDoc}`;

/**
 * __useWorkflowItemsFilterForMeQuery__
 *
 * To run a query within a React component, call `useWorkflowItemsFilterForMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowItemsFilterForMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowItemsFilterForMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowItemsFilterForMeQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>(WorkflowItemsFilterForMeDocument, options);
      }
export function useWorkflowItemsFilterForMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>(WorkflowItemsFilterForMeDocument, options);
        }
export function useWorkflowItemsFilterForMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>(WorkflowItemsFilterForMeDocument, options);
        }
export type WorkflowItemsFilterForMeQueryHookResult = ReturnType<typeof useWorkflowItemsFilterForMeQuery>;
export type WorkflowItemsFilterForMeLazyQueryHookResult = ReturnType<typeof useWorkflowItemsFilterForMeLazyQuery>;
export type WorkflowItemsFilterForMeSuspenseQueryHookResult = ReturnType<typeof useWorkflowItemsFilterForMeSuspenseQuery>;
export type WorkflowItemsFilterForMeQueryResult = Apollo.QueryResult<WorkflowItemsFilterForMeQuery, WorkflowItemsFilterForMeQueryVariables>;
export const WorkflowItemsFilterDocument = gql`
    query WorkflowItemsFilter($workflowContext: WorkflowContext!) {
  workflowItemsFilterOptions(workflowContext: $workflowContext) {
    workflowTemplates {
      ...WorkflowItemsFilter_WorkflowTemplate
    }
    workflowItemTemplates {
      ...WorkflowItemsFilter_WorkflowItemTemplate
    }
    employees {
      ...WorkflowItemsFilter_Employee
    }
    responsibleEmployees {
      ...WorkflowItemsFilter_Employee
    }
    responsibleTeams {
      ...WorkflowItemsFilter_Team
    }
  }
}
    ${WorkflowItemsFilter_WorkflowTemplateFragmentDoc}
${WorkflowItemsFilter_WorkflowItemTemplateFragmentDoc}
${WorkflowItemsFilter_EmployeeFragmentDoc}
${WorkflowItemsFilter_TeamFragmentDoc}`;

/**
 * __useWorkflowItemsFilterQuery__
 *
 * To run a query within a React component, call `useWorkflowItemsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowItemsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowItemsFilterQuery({
 *   variables: {
 *      workflowContext: // value for 'workflowContext'
 *   },
 * });
 */
export function useWorkflowItemsFilterQuery(baseOptions: Apollo.QueryHookOptions<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables> & ({ variables: WorkflowItemsFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables>(WorkflowItemsFilterDocument, options);
      }
export function useWorkflowItemsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables>(WorkflowItemsFilterDocument, options);
        }
export function useWorkflowItemsFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables>(WorkflowItemsFilterDocument, options);
        }
export type WorkflowItemsFilterQueryHookResult = ReturnType<typeof useWorkflowItemsFilterQuery>;
export type WorkflowItemsFilterLazyQueryHookResult = ReturnType<typeof useWorkflowItemsFilterLazyQuery>;
export type WorkflowItemsFilterSuspenseQueryHookResult = ReturnType<typeof useWorkflowItemsFilterSuspenseQuery>;
export type WorkflowItemsFilterQueryResult = Apollo.QueryResult<WorkflowItemsFilterQuery, WorkflowItemsFilterQueryVariables>;
export const WorkflowsFilterForMeOptionsDocument = gql`
    query WorkflowsFilterForMeOptions {
  workflowsFilterOptions(workflowContext: MY) {
    workflowTemplates {
      ...WorkflowFilter_WorkflowTemplate
    }
  }
}
    ${WorkflowFilter_WorkflowTemplateFragmentDoc}`;

/**
 * __useWorkflowsFilterForMeOptionsQuery__
 *
 * To run a query within a React component, call `useWorkflowsFilterForMeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsFilterForMeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsFilterForMeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowsFilterForMeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>(WorkflowsFilterForMeOptionsDocument, options);
      }
export function useWorkflowsFilterForMeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>(WorkflowsFilterForMeOptionsDocument, options);
        }
export function useWorkflowsFilterForMeOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>(WorkflowsFilterForMeOptionsDocument, options);
        }
export type WorkflowsFilterForMeOptionsQueryHookResult = ReturnType<typeof useWorkflowsFilterForMeOptionsQuery>;
export type WorkflowsFilterForMeOptionsLazyQueryHookResult = ReturnType<typeof useWorkflowsFilterForMeOptionsLazyQuery>;
export type WorkflowsFilterForMeOptionsSuspenseQueryHookResult = ReturnType<typeof useWorkflowsFilterForMeOptionsSuspenseQuery>;
export type WorkflowsFilterForMeOptionsQueryResult = Apollo.QueryResult<WorkflowsFilterForMeOptionsQuery, WorkflowsFilterForMeOptionsQueryVariables>;
export const WorkflowsFilterOptionsDocument = gql`
    query WorkflowsFilterOptions($workflowContext: WorkflowContext!) {
  workflowsFilterOptions(workflowContext: $workflowContext) {
    workflowTemplates {
      ...WorkflowFilter_WorkflowTemplate
    }
    employees {
      ...WorkflowFilter_Employee
    }
  }
}
    ${WorkflowFilter_WorkflowTemplateFragmentDoc}
${WorkflowFilter_EmployeeFragmentDoc}`;

/**
 * __useWorkflowsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useWorkflowsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsFilterOptionsQuery({
 *   variables: {
 *      workflowContext: // value for 'workflowContext'
 *   },
 * });
 */
export function useWorkflowsFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables> & ({ variables: WorkflowsFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables>(WorkflowsFilterOptionsDocument, options);
      }
export function useWorkflowsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables>(WorkflowsFilterOptionsDocument, options);
        }
export function useWorkflowsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables>(WorkflowsFilterOptionsDocument, options);
        }
export type WorkflowsFilterOptionsQueryHookResult = ReturnType<typeof useWorkflowsFilterOptionsQuery>;
export type WorkflowsFilterOptionsLazyQueryHookResult = ReturnType<typeof useWorkflowsFilterOptionsLazyQuery>;
export type WorkflowsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useWorkflowsFilterOptionsSuspenseQuery>;
export type WorkflowsFilterOptionsQueryResult = Apollo.QueryResult<WorkflowsFilterOptionsQuery, WorkflowsFilterOptionsQueryVariables>;
export const UpdateOnboardingFirstOpenDateDocument = gql`
    mutation updateOnboardingFirstOpenDate($input: UpdateWorkflowFirstOpenedDateInput!) {
  workflow {
    updateWorkflowFirstOpenedDate(input: $input) {
      record {
        Id
        flair__First_Opened__c
      }
    }
  }
}
    `;
export type UpdateOnboardingFirstOpenDateMutationFn = Apollo.MutationFunction<UpdateOnboardingFirstOpenDateMutation, UpdateOnboardingFirstOpenDateMutationVariables>;

/**
 * __useUpdateOnboardingFirstOpenDateMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingFirstOpenDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingFirstOpenDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingFirstOpenDateMutation, { data, loading, error }] = useUpdateOnboardingFirstOpenDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOnboardingFirstOpenDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnboardingFirstOpenDateMutation, UpdateOnboardingFirstOpenDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnboardingFirstOpenDateMutation, UpdateOnboardingFirstOpenDateMutationVariables>(UpdateOnboardingFirstOpenDateDocument, options);
      }
export type UpdateOnboardingFirstOpenDateMutationHookResult = ReturnType<typeof useUpdateOnboardingFirstOpenDateMutation>;
export type UpdateOnboardingFirstOpenDateMutationResult = Apollo.MutationResult<UpdateOnboardingFirstOpenDateMutation>;
export type UpdateOnboardingFirstOpenDateMutationOptions = Apollo.BaseMutationOptions<UpdateOnboardingFirstOpenDateMutation, UpdateOnboardingFirstOpenDateMutationVariables>;
export const WorkflowDashboardDocument = gql`
    query WorkflowDashboard {
  me {
    Id
    flair__First_Name__c
    flair__Last_Name__c
    onboardingWorkflow {
      Id
      flair__Employee__c
      flair__Complete_Progress__c
      flair__First_Opened__c
      flair__Show_Onboarding_Widget__c
      flair__Status__c
    }
    notCompletedWorkflowItems {
      Id
      flair__Workflow__c
      flair__Employee__c
    }
  }
}
    `;

/**
 * __useWorkflowDashboardQuery__
 *
 * To run a query within a React component, call `useWorkflowDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowDashboardQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>(WorkflowDashboardDocument, options);
      }
export function useWorkflowDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>(WorkflowDashboardDocument, options);
        }
export function useWorkflowDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>(WorkflowDashboardDocument, options);
        }
export type WorkflowDashboardQueryHookResult = ReturnType<typeof useWorkflowDashboardQuery>;
export type WorkflowDashboardLazyQueryHookResult = ReturnType<typeof useWorkflowDashboardLazyQuery>;
export type WorkflowDashboardSuspenseQueryHookResult = ReturnType<typeof useWorkflowDashboardSuspenseQuery>;
export type WorkflowDashboardQueryResult = Apollo.QueryResult<WorkflowDashboardQuery, WorkflowDashboardQueryVariables>;
export const UpdateWorkflowItemRegularDocument = gql`
    mutation updateWorkflowItemRegular($input: UpdateWorkflowItemRegularInput!) {
  workflow {
    updateWorkflowItemRegular(input: $input) {
      record {
        Id
        flair__Status__c
        workflow {
          ...RefetchWorkflowFields
        }
      }
    }
  }
}
    ${RefetchWorkflowFieldsFragmentDoc}`;
export type UpdateWorkflowItemRegularMutationFn = Apollo.MutationFunction<UpdateWorkflowItemRegularMutation, UpdateWorkflowItemRegularMutationVariables>;

/**
 * __useUpdateWorkflowItemRegularMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowItemRegularMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowItemRegularMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowItemRegularMutation, { data, loading, error }] = useUpdateWorkflowItemRegularMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowItemRegularMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowItemRegularMutation, UpdateWorkflowItemRegularMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowItemRegularMutation, UpdateWorkflowItemRegularMutationVariables>(UpdateWorkflowItemRegularDocument, options);
      }
export type UpdateWorkflowItemRegularMutationHookResult = ReturnType<typeof useUpdateWorkflowItemRegularMutation>;
export type UpdateWorkflowItemRegularMutationResult = Apollo.MutationResult<UpdateWorkflowItemRegularMutation>;
export type UpdateWorkflowItemRegularMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowItemRegularMutation, UpdateWorkflowItemRegularMutationVariables>;
export const UpdateWorkflowItemDataRequestDocument = gql`
    mutation updateWorkflowItemDataRequest($input: UpdateWorkflowItemDataRequestInput!) {
  workflow {
    updateWorkflowItemDataRequest(input: $input) {
      employeeId
      record {
        Id
        flair__Status__c
        dataFields {
          ...WorkflowItemDataField
        }
        workflow {
          ...RefetchWorkflowFields
        }
      }
    }
  }
}
    ${WorkflowItemDataFieldFragmentDoc}
${RefetchWorkflowFieldsFragmentDoc}`;
export type UpdateWorkflowItemDataRequestMutationFn = Apollo.MutationFunction<UpdateWorkflowItemDataRequestMutation, UpdateWorkflowItemDataRequestMutationVariables>;

/**
 * __useUpdateWorkflowItemDataRequestMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowItemDataRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowItemDataRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowItemDataRequestMutation, { data, loading, error }] = useUpdateWorkflowItemDataRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowItemDataRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowItemDataRequestMutation, UpdateWorkflowItemDataRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowItemDataRequestMutation, UpdateWorkflowItemDataRequestMutationVariables>(UpdateWorkflowItemDataRequestDocument, options);
      }
export type UpdateWorkflowItemDataRequestMutationHookResult = ReturnType<typeof useUpdateWorkflowItemDataRequestMutation>;
export type UpdateWorkflowItemDataRequestMutationResult = Apollo.MutationResult<UpdateWorkflowItemDataRequestMutation>;
export type UpdateWorkflowItemDataRequestMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowItemDataRequestMutation, UpdateWorkflowItemDataRequestMutationVariables>;
export const UpdateWorkflowItemSubTasksDocument = gql`
    mutation updateWorkflowItemSubTasks($input: UpdateWorkflowItemSubTasksInput!) {
  workflow {
    updateWorkflowItemSubTasks(input: $input) {
      record {
        Id
        flair__Status__c
        ...workflowItemSubTasks
      }
    }
  }
}
    ${WorkflowItemSubTasksFragmentDoc}`;
export type UpdateWorkflowItemSubTasksMutationFn = Apollo.MutationFunction<UpdateWorkflowItemSubTasksMutation, UpdateWorkflowItemSubTasksMutationVariables>;

/**
 * __useUpdateWorkflowItemSubTasksMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowItemSubTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowItemSubTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowItemSubTasksMutation, { data, loading, error }] = useUpdateWorkflowItemSubTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowItemSubTasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowItemSubTasksMutation, UpdateWorkflowItemSubTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowItemSubTasksMutation, UpdateWorkflowItemSubTasksMutationVariables>(UpdateWorkflowItemSubTasksDocument, options);
      }
export type UpdateWorkflowItemSubTasksMutationHookResult = ReturnType<typeof useUpdateWorkflowItemSubTasksMutation>;
export type UpdateWorkflowItemSubTasksMutationResult = Apollo.MutationResult<UpdateWorkflowItemSubTasksMutation>;
export type UpdateWorkflowItemSubTasksMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowItemSubTasksMutation, UpdateWorkflowItemSubTasksMutationVariables>;
export const UpdateWorkflowItemFileRequestDocument = gql`
    mutation updateWorkflowItemFileRequest($input: UpdateWorkflowItemFileRequestInput!) {
  workflow {
    updateWorkflowItemFileRequest(input: $input) {
      record {
        Id
        flair__Status__c
        uploadedFile {
          ...WorkflowItemUploadedFile
        }
        uploadedFileVisibility
        workflow {
          ...RefetchWorkflowFields
        }
      }
    }
  }
}
    ${WorkflowItemUploadedFileFragmentDoc}
${RefetchWorkflowFieldsFragmentDoc}`;
export type UpdateWorkflowItemFileRequestMutationFn = Apollo.MutationFunction<UpdateWorkflowItemFileRequestMutation, UpdateWorkflowItemFileRequestMutationVariables>;

/**
 * __useUpdateWorkflowItemFileRequestMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowItemFileRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowItemFileRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowItemFileRequestMutation, { data, loading, error }] = useUpdateWorkflowItemFileRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowItemFileRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowItemFileRequestMutation, UpdateWorkflowItemFileRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowItemFileRequestMutation, UpdateWorkflowItemFileRequestMutationVariables>(UpdateWorkflowItemFileRequestDocument, options);
      }
export type UpdateWorkflowItemFileRequestMutationHookResult = ReturnType<typeof useUpdateWorkflowItemFileRequestMutation>;
export type UpdateWorkflowItemFileRequestMutationResult = Apollo.MutationResult<UpdateWorkflowItemFileRequestMutation>;
export type UpdateWorkflowItemFileRequestMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowItemFileRequestMutation, UpdateWorkflowItemFileRequestMutationVariables>;
export const UpdateWorkflowItemVideoRequestDocument = gql`
    mutation updateWorkflowItemVideoRequest($input: UpdateWorkflowItemVideoRequestInput!) {
  workflow {
    updateWorkflowItemVideoRequest(input: $input) {
      record {
        Id
        flair__Status__c
        flair__Loom_Video__c
        loomVideo {
          ...LoomVideo
        }
        workflow {
          ...RefetchWorkflowFields
        }
      }
    }
  }
}
    ${LoomVideoFragmentDoc}
${RefetchWorkflowFieldsFragmentDoc}`;
export type UpdateWorkflowItemVideoRequestMutationFn = Apollo.MutationFunction<UpdateWorkflowItemVideoRequestMutation, UpdateWorkflowItemVideoRequestMutationVariables>;

/**
 * __useUpdateWorkflowItemVideoRequestMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowItemVideoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowItemVideoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowItemVideoRequestMutation, { data, loading, error }] = useUpdateWorkflowItemVideoRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowItemVideoRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowItemVideoRequestMutation, UpdateWorkflowItemVideoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowItemVideoRequestMutation, UpdateWorkflowItemVideoRequestMutationVariables>(UpdateWorkflowItemVideoRequestDocument, options);
      }
export type UpdateWorkflowItemVideoRequestMutationHookResult = ReturnType<typeof useUpdateWorkflowItemVideoRequestMutation>;
export type UpdateWorkflowItemVideoRequestMutationResult = Apollo.MutationResult<UpdateWorkflowItemVideoRequestMutation>;
export type UpdateWorkflowItemVideoRequestMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowItemVideoRequestMutation, UpdateWorkflowItemVideoRequestMutationVariables>;
export const DeleteWorkflowItemLoomVideoDocument = gql`
    mutation deleteWorkflowItemLoomVideo($input: DeleteWorkflowItemLoomVideoInput!) {
  workflow {
    deleteWorkflowItemLoomVideo(input: $input) {
      record {
        Id
        flair__Status__c
        loomVideo {
          ...LoomVideo
        }
        workflow {
          ...RefetchWorkflowFields
        }
      }
    }
  }
}
    ${LoomVideoFragmentDoc}
${RefetchWorkflowFieldsFragmentDoc}`;
export type DeleteWorkflowItemLoomVideoMutationFn = Apollo.MutationFunction<DeleteWorkflowItemLoomVideoMutation, DeleteWorkflowItemLoomVideoMutationVariables>;

/**
 * __useDeleteWorkflowItemLoomVideoMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowItemLoomVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowItemLoomVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowItemLoomVideoMutation, { data, loading, error }] = useDeleteWorkflowItemLoomVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkflowItemLoomVideoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowItemLoomVideoMutation, DeleteWorkflowItemLoomVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowItemLoomVideoMutation, DeleteWorkflowItemLoomVideoMutationVariables>(DeleteWorkflowItemLoomVideoDocument, options);
      }
export type DeleteWorkflowItemLoomVideoMutationHookResult = ReturnType<typeof useDeleteWorkflowItemLoomVideoMutation>;
export type DeleteWorkflowItemLoomVideoMutationResult = Apollo.MutationResult<DeleteWorkflowItemLoomVideoMutation>;
export type DeleteWorkflowItemLoomVideoMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowItemLoomVideoMutation, DeleteWorkflowItemLoomVideoMutationVariables>;
export const WorkflowItemDataRequestDocument = gql`
    query WorkflowItemDataRequest($workflowId: String!, $workflowItemId: String!) {
  workflow(workflowId: $workflowId) {
    Id
    item(id: $workflowItemId) {
      ...WorkflowItemFields
      dataFields {
        ...WorkflowItemDataField
      }
    }
  }
}
    ${WorkflowItemFieldsFragmentDoc}
${WorkflowItemDataFieldFragmentDoc}`;

/**
 * __useWorkflowItemDataRequestQuery__
 *
 * To run a query within a React component, call `useWorkflowItemDataRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowItemDataRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowItemDataRequestQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      workflowItemId: // value for 'workflowItemId'
 *   },
 * });
 */
export function useWorkflowItemDataRequestQuery(baseOptions: Apollo.QueryHookOptions<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables> & ({ variables: WorkflowItemDataRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables>(WorkflowItemDataRequestDocument, options);
      }
export function useWorkflowItemDataRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables>(WorkflowItemDataRequestDocument, options);
        }
export function useWorkflowItemDataRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables>(WorkflowItemDataRequestDocument, options);
        }
export type WorkflowItemDataRequestQueryHookResult = ReturnType<typeof useWorkflowItemDataRequestQuery>;
export type WorkflowItemDataRequestLazyQueryHookResult = ReturnType<typeof useWorkflowItemDataRequestLazyQuery>;
export type WorkflowItemDataRequestSuspenseQueryHookResult = ReturnType<typeof useWorkflowItemDataRequestSuspenseQuery>;
export type WorkflowItemDataRequestQueryResult = Apollo.QueryResult<WorkflowItemDataRequestQuery, WorkflowItemDataRequestQueryVariables>;
export const WorkflowItemFileRequestDocument = gql`
    query WorkflowItemFileRequest($workflowId: String!, $workflowItemId: String!) {
  workflow(workflowId: $workflowId) {
    Id
    item(id: $workflowItemId) {
      ...WorkflowItemFields
      uploadedFile {
        ...WorkflowItemUploadedFile
      }
    }
  }
}
    ${WorkflowItemFieldsFragmentDoc}
${WorkflowItemUploadedFileFragmentDoc}`;

/**
 * __useWorkflowItemFileRequestQuery__
 *
 * To run a query within a React component, call `useWorkflowItemFileRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowItemFileRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowItemFileRequestQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      workflowItemId: // value for 'workflowItemId'
 *   },
 * });
 */
export function useWorkflowItemFileRequestQuery(baseOptions: Apollo.QueryHookOptions<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables> & ({ variables: WorkflowItemFileRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables>(WorkflowItemFileRequestDocument, options);
      }
export function useWorkflowItemFileRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables>(WorkflowItemFileRequestDocument, options);
        }
export function useWorkflowItemFileRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables>(WorkflowItemFileRequestDocument, options);
        }
export type WorkflowItemFileRequestQueryHookResult = ReturnType<typeof useWorkflowItemFileRequestQuery>;
export type WorkflowItemFileRequestLazyQueryHookResult = ReturnType<typeof useWorkflowItemFileRequestLazyQuery>;
export type WorkflowItemFileRequestSuspenseQueryHookResult = ReturnType<typeof useWorkflowItemFileRequestSuspenseQuery>;
export type WorkflowItemFileRequestQueryResult = Apollo.QueryResult<WorkflowItemFileRequestQuery, WorkflowItemFileRequestQueryVariables>;
export const UpdateWorkflowItemStatusDocument = gql`
    mutation updateWorkflowItemStatus($input: UpdateWorkflowItemStatusInput!) {
  workflow {
    updateWorkflowItemStatus(input: $input) {
      record {
        Id
        flair__Status__c
        workflow {
          Id
          flair__Complete_Progress__c
          steps {
            Id
            flair__Is_Active__c
          }
        }
      }
    }
  }
}
    `;
export type UpdateWorkflowItemStatusMutationFn = Apollo.MutationFunction<UpdateWorkflowItemStatusMutation, UpdateWorkflowItemStatusMutationVariables>;

/**
 * __useUpdateWorkflowItemStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowItemStatusMutation, { data, loading, error }] = useUpdateWorkflowItemStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowItemStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowItemStatusMutation, UpdateWorkflowItemStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowItemStatusMutation, UpdateWorkflowItemStatusMutationVariables>(UpdateWorkflowItemStatusDocument, options);
      }
export type UpdateWorkflowItemStatusMutationHookResult = ReturnType<typeof useUpdateWorkflowItemStatusMutation>;
export type UpdateWorkflowItemStatusMutationResult = Apollo.MutationResult<UpdateWorkflowItemStatusMutation>;
export type UpdateWorkflowItemStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowItemStatusMutation, UpdateWorkflowItemStatusMutationVariables>;
export const WorkflowItemsForWorkflowDocument = gql`
    query WorkflowItemsForWorkflow($workflowId: String!, $filter: WorkflowItemsFilterInput2!, $sort: WorkflowsItemsListSortInput, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!) {
  workflow(workflowId: $workflowId) {
    ...Workflow
  }
  workflowItems(
    workflowContext: ALL
    filter: $filter
    sort: $sort
    pagination: $pagination
  ) {
    items {
      ...WorkflowItemTableFields
    }
    paginationInfo @skip(if: $skipPaginationInfo) {
      totalCount
    }
  }
}
    ${WorkflowFragmentDoc}
${WorkflowItemTableFieldsFragmentDoc}`;

/**
 * __useWorkflowItemsForWorkflowQuery__
 *
 * To run a query within a React component, call `useWorkflowItemsForWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowItemsForWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowItemsForWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useWorkflowItemsForWorkflowQuery(baseOptions: Apollo.QueryHookOptions<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables> & ({ variables: WorkflowItemsForWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables>(WorkflowItemsForWorkflowDocument, options);
      }
export function useWorkflowItemsForWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables>(WorkflowItemsForWorkflowDocument, options);
        }
export function useWorkflowItemsForWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables>(WorkflowItemsForWorkflowDocument, options);
        }
export type WorkflowItemsForWorkflowQueryHookResult = ReturnType<typeof useWorkflowItemsForWorkflowQuery>;
export type WorkflowItemsForWorkflowLazyQueryHookResult = ReturnType<typeof useWorkflowItemsForWorkflowLazyQuery>;
export type WorkflowItemsForWorkflowSuspenseQueryHookResult = ReturnType<typeof useWorkflowItemsForWorkflowSuspenseQuery>;
export type WorkflowItemsForWorkflowQueryResult = Apollo.QueryResult<WorkflowItemsForWorkflowQuery, WorkflowItemsForWorkflowQueryVariables>;
export const WorkflowsItemsDocument = gql`
    query WorkflowsItems($workflowContext: WorkflowContext!, $filter: WorkflowItemsFilterInput2!, $sort: WorkflowsItemsListSortInput, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!) {
  workflowItems(
    workflowContext: $workflowContext
    filter: $filter
    sort: $sort
    pagination: $pagination
  ) {
    items {
      ...WorkflowItemTableFields
      workflow {
        ...Workflow
      }
    }
    paginationInfo @skip(if: $skipPaginationInfo) {
      totalCount
    }
  }
}
    ${WorkflowItemTableFieldsFragmentDoc}
${WorkflowFragmentDoc}`;

/**
 * __useWorkflowsItemsQuery__
 *
 * To run a query within a React component, call `useWorkflowsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsItemsQuery({
 *   variables: {
 *      workflowContext: // value for 'workflowContext'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useWorkflowsItemsQuery(baseOptions: Apollo.QueryHookOptions<WorkflowsItemsQuery, WorkflowsItemsQueryVariables> & ({ variables: WorkflowsItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowsItemsQuery, WorkflowsItemsQueryVariables>(WorkflowsItemsDocument, options);
      }
export function useWorkflowsItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowsItemsQuery, WorkflowsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowsItemsQuery, WorkflowsItemsQueryVariables>(WorkflowsItemsDocument, options);
        }
export function useWorkflowsItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowsItemsQuery, WorkflowsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowsItemsQuery, WorkflowsItemsQueryVariables>(WorkflowsItemsDocument, options);
        }
export type WorkflowsItemsQueryHookResult = ReturnType<typeof useWorkflowsItemsQuery>;
export type WorkflowsItemsLazyQueryHookResult = ReturnType<typeof useWorkflowsItemsLazyQuery>;
export type WorkflowsItemsSuspenseQueryHookResult = ReturnType<typeof useWorkflowsItemsSuspenseQuery>;
export type WorkflowsItemsQueryResult = Apollo.QueryResult<WorkflowsItemsQuery, WorkflowsItemsQueryVariables>;
export const WorkflowsDocument = gql`
    query Workflows($workflowContext: WorkflowContext!, $filter: WorkflowsFilterInput!, $sort: WorkflowListSortInput!, $pagination: PaginationInput!, $skipPaginationInfo: Boolean!) {
  workflows(
    workflowContext: $workflowContext
    filter: $filter
    sort: $sort
    pagination: $pagination
  ) {
    items {
      ...WorkflowTableFields
    }
    paginationInfo @skip(if: $skipPaginationInfo) {
      totalCount
    }
  }
}
    ${WorkflowTableFieldsFragmentDoc}`;

/**
 * __useWorkflowsQuery__
 *
 * To run a query within a React component, call `useWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsQuery({
 *   variables: {
 *      workflowContext: // value for 'workflowContext'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      skipPaginationInfo: // value for 'skipPaginationInfo'
 *   },
 * });
 */
export function useWorkflowsQuery(baseOptions: Apollo.QueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables> & ({ variables: WorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options);
      }
export function useWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options);
        }
export function useWorkflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options);
        }
export type WorkflowsQueryHookResult = ReturnType<typeof useWorkflowsQuery>;
export type WorkflowsLazyQueryHookResult = ReturnType<typeof useWorkflowsLazyQuery>;
export type WorkflowsSuspenseQueryHookResult = ReturnType<typeof useWorkflowsSuspenseQuery>;
export type WorkflowsQueryResult = Apollo.QueryResult<WorkflowsQuery, WorkflowsQueryVariables>;
export const JobDetailsDocument = gql`
    query JobDetails($jobId: String!) {
  job(id: $jobId) {
    Id
    Name
    flair__Status__c
    flair__Display_in_Hub__c
    flair__Job_Description__c
    flair__Job_Requirements__c
    flair__Responsibilities__c
    flair__Published_At__c
    flair__Type_of_Employment__c
    flair__Time_Commitment__c
    location {
      Id
      Name
    }
    department {
      Id
      Name
    }
    jobSkills {
      Id
      flair__Skill_Name__c
      skill {
        Id
        Name
      }
    }
  }
  me {
    Id
    employeeSkills {
      Id
      flair__Skill__c
      skill {
        Id
        Name
      }
    }
  }
}
    `;

/**
 * __useJobDetailsQuery__
 *
 * To run a query within a React component, call `useJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobDetailsQuery(baseOptions: Apollo.QueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables> & ({ variables: JobDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
      }
export function useJobDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
        }
export function useJobDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
        }
export type JobDetailsQueryHookResult = ReturnType<typeof useJobDetailsQuery>;
export type JobDetailsLazyQueryHookResult = ReturnType<typeof useJobDetailsLazyQuery>;
export type JobDetailsSuspenseQueryHookResult = ReturnType<typeof useJobDetailsSuspenseQuery>;
export type JobDetailsQueryResult = Apollo.QueryResult<JobDetailsQuery, JobDetailsQueryVariables>;
export const JobsDocument = gql`
    query Jobs {
  jobs {
    Id
    Name
    flair__Status__c
    location {
      Id
      Name
    }
    department {
      Id
      Name
    }
  }
}
    `;

/**
 * __useJobsQuery__
 *
 * To run a query within a React component, call `useJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobsQuery(baseOptions?: Apollo.QueryHookOptions<JobsQuery, JobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
      }
export function useJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export function useJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export type JobsQueryHookResult = ReturnType<typeof useJobsQuery>;
export type JobsLazyQueryHookResult = ReturnType<typeof useJobsLazyQuery>;
export type JobsSuspenseQueryHookResult = ReturnType<typeof useJobsSuspenseQuery>;
export type JobsQueryResult = Apollo.QueryResult<JobsQuery, JobsQueryVariables>;
export const CandidateDetailsDocument = gql`
    query CandidateDetails($id: String!) {
  candidate(id: $id) {
    ...CandidateDetail_JobCandidate
  }
}
    ${CandidateDetail_JobCandidateFragmentDoc}`;

/**
 * __useCandidateDetailsQuery__
 *
 * To run a query within a React component, call `useCandidateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateDetailsQuery(baseOptions: Apollo.QueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables> & ({ variables: CandidateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateDetailsQuery, CandidateDetailsQueryVariables>(CandidateDetailsDocument, options);
      }
export function useCandidateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateDetailsQuery, CandidateDetailsQueryVariables>(CandidateDetailsDocument, options);
        }
export function useCandidateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateDetailsQuery, CandidateDetailsQueryVariables>(CandidateDetailsDocument, options);
        }
export type CandidateDetailsQueryHookResult = ReturnType<typeof useCandidateDetailsQuery>;
export type CandidateDetailsLazyQueryHookResult = ReturnType<typeof useCandidateDetailsLazyQuery>;
export type CandidateDetailsSuspenseQueryHookResult = ReturnType<typeof useCandidateDetailsSuspenseQuery>;
export type CandidateDetailsQueryResult = Apollo.QueryResult<CandidateDetailsQuery, CandidateDetailsQueryVariables>;
export const CreateCandidateEvaluationDocument = gql`
    mutation CreateCandidateEvaluation($input: CreateCandidateEvaluationInput!) {
  evaluation {
    createCandidateEvaluation(input: $input) {
      recordId
      record {
        Id
        candidate {
          Id
          candidateEvaluations {
            ...CandidateEvaluationsFragment
          }
        }
      }
    }
  }
}
    ${CandidateEvaluationsFragmentFragmentDoc}`;
export type CreateCandidateEvaluationMutationFn = Apollo.MutationFunction<CreateCandidateEvaluationMutation, CreateCandidateEvaluationMutationVariables>;

/**
 * __useCreateCandidateEvaluationMutation__
 *
 * To run a mutation, you first call `useCreateCandidateEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateEvaluationMutation, { data, loading, error }] = useCreateCandidateEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateEvaluationMutation, CreateCandidateEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateEvaluationMutation, CreateCandidateEvaluationMutationVariables>(CreateCandidateEvaluationDocument, options);
      }
export type CreateCandidateEvaluationMutationHookResult = ReturnType<typeof useCreateCandidateEvaluationMutation>;
export type CreateCandidateEvaluationMutationResult = Apollo.MutationResult<CreateCandidateEvaluationMutation>;
export type CreateCandidateEvaluationMutationOptions = Apollo.BaseMutationOptions<CreateCandidateEvaluationMutation, CreateCandidateEvaluationMutationVariables>;
export const EvaluationTemplatesDocument = gql`
    query EvaluationTemplates($input: AvailableEvaluationTemplatesInput!) {
  availableEvaluationTemplates(input: $input) {
    ...EvaluationTemplate
  }
}
    ${EvaluationTemplateFragmentDoc}`;

/**
 * __useEvaluationTemplatesQuery__
 *
 * To run a query within a React component, call `useEvaluationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvaluationTemplatesQuery(baseOptions: Apollo.QueryHookOptions<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables> & ({ variables: EvaluationTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables>(EvaluationTemplatesDocument, options);
      }
export function useEvaluationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables>(EvaluationTemplatesDocument, options);
        }
export function useEvaluationTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables>(EvaluationTemplatesDocument, options);
        }
export type EvaluationTemplatesQueryHookResult = ReturnType<typeof useEvaluationTemplatesQuery>;
export type EvaluationTemplatesLazyQueryHookResult = ReturnType<typeof useEvaluationTemplatesLazyQuery>;
export type EvaluationTemplatesSuspenseQueryHookResult = ReturnType<typeof useEvaluationTemplatesSuspenseQuery>;
export type EvaluationTemplatesQueryResult = Apollo.QueryResult<EvaluationTemplatesQuery, EvaluationTemplatesQueryVariables>;
export const CandidateListFilterOptionsDocument = gql`
    query CandidateListFilterOptions {
  candidateListFilterOptions {
    stages {
      ...PicklistEntry
    }
    sources {
      ...PicklistEntry
    }
  }
}
    ${PicklistEntryFragmentDoc}`;

/**
 * __useCandidateListFilterOptionsQuery__
 *
 * To run a query within a React component, call `useCandidateListFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateListFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateListFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCandidateListFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>(CandidateListFilterOptionsDocument, options);
      }
export function useCandidateListFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>(CandidateListFilterOptionsDocument, options);
        }
export function useCandidateListFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>(CandidateListFilterOptionsDocument, options);
        }
export type CandidateListFilterOptionsQueryHookResult = ReturnType<typeof useCandidateListFilterOptionsQuery>;
export type CandidateListFilterOptionsLazyQueryHookResult = ReturnType<typeof useCandidateListFilterOptionsLazyQuery>;
export type CandidateListFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useCandidateListFilterOptionsSuspenseQuery>;
export type CandidateListFilterOptionsQueryResult = Apollo.QueryResult<CandidateListFilterOptionsQuery, CandidateListFilterOptionsQueryVariables>;
export const JobCandidatesDocument = gql`
    query JobCandidates($id: String!, $pagination: PaginationInput!, $filter: CandidateFilterInput!, $sort: SortInput) {
  hiringManager {
    Id
    job(id: $id) {
      Id
      Name
      candidates(pagination: $pagination, filter: $filter, sort: $sort) {
        items {
          Id
          flair__Full_Name__c
          flair__Overall_Comment__c
          flair__Final_Score__c
          flair__Funnel_Stage__c
          flair__Application_Source__c
          flair__FlairAI_Total_KR_Matching_Score__c
          flair__FlairAI_KR_Matching_Status__c
          flair__FlairAI_KR_Matching_Info_JSON__c
          CreatedDate
          commentsCount
        }
        paginationInfo {
          totalCount
        }
      }
    }
  }
}
    `;

/**
 * __useJobCandidatesQuery__
 *
 * To run a query within a React component, call `useJobCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobCandidatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useJobCandidatesQuery(baseOptions: Apollo.QueryHookOptions<JobCandidatesQuery, JobCandidatesQueryVariables> & ({ variables: JobCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobCandidatesQuery, JobCandidatesQueryVariables>(JobCandidatesDocument, options);
      }
export function useJobCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobCandidatesQuery, JobCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobCandidatesQuery, JobCandidatesQueryVariables>(JobCandidatesDocument, options);
        }
export function useJobCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobCandidatesQuery, JobCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobCandidatesQuery, JobCandidatesQueryVariables>(JobCandidatesDocument, options);
        }
export type JobCandidatesQueryHookResult = ReturnType<typeof useJobCandidatesQuery>;
export type JobCandidatesLazyQueryHookResult = ReturnType<typeof useJobCandidatesLazyQuery>;
export type JobCandidatesSuspenseQueryHookResult = ReturnType<typeof useJobCandidatesSuspenseQuery>;
export type JobCandidatesQueryResult = Apollo.QueryResult<JobCandidatesQuery, JobCandidatesQueryVariables>;
export const CandidateEvaluationDocument = gql`
    query CandidateEvaluation($id: String!) {
  candidateEvaluationById(id: $id) {
    Id
    Name
    flair__Overall_Comment__c
    flair__Final_Score__c
    flair__Evaluated__c
    flair__Employee__c
    LastModifiedDate
    candidate {
      Id
      ...CandidateDetail_JobCandidate
      ...CandidateEvaluation_JobCandidate
    }
    answers {
      Id
      Name
      flair__Candidate_Evaluation__c
      flair__Question_Type__c
      flair__Evaluation_Template_Question__c
      flair__Evaluation_Template_Option__c
      flair__Answer__c
      flair__Score__c
    }
    evaluationTemplate {
      ...EvaluationTemplateFragment
    }
  }
}
    ${CandidateDetail_JobCandidateFragmentDoc}
${CandidateEvaluation_JobCandidateFragmentDoc}
${EvaluationTemplateFragmentFragmentDoc}`;

/**
 * __useCandidateEvaluationQuery__
 *
 * To run a query within a React component, call `useCandidateEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateEvaluationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateEvaluationQuery(baseOptions: Apollo.QueryHookOptions<CandidateEvaluationQuery, CandidateEvaluationQueryVariables> & ({ variables: CandidateEvaluationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateEvaluationQuery, CandidateEvaluationQueryVariables>(CandidateEvaluationDocument, options);
      }
export function useCandidateEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateEvaluationQuery, CandidateEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateEvaluationQuery, CandidateEvaluationQueryVariables>(CandidateEvaluationDocument, options);
        }
export function useCandidateEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateEvaluationQuery, CandidateEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateEvaluationQuery, CandidateEvaluationQueryVariables>(CandidateEvaluationDocument, options);
        }
export type CandidateEvaluationQueryHookResult = ReturnType<typeof useCandidateEvaluationQuery>;
export type CandidateEvaluationLazyQueryHookResult = ReturnType<typeof useCandidateEvaluationLazyQuery>;
export type CandidateEvaluationSuspenseQueryHookResult = ReturnType<typeof useCandidateEvaluationSuspenseQuery>;
export type CandidateEvaluationQueryResult = Apollo.QueryResult<CandidateEvaluationQuery, CandidateEvaluationQueryVariables>;
export const SaveCandidateEvaluationDocument = gql`
    mutation SaveCandidateEvaluation($input: SaveCandidateEvaluationInput!) {
  evaluation {
    saveCandidateEvaluation(input: $input) {
      recordId
      record {
        ...Evaluation
      }
    }
  }
}
    ${EvaluationFragmentDoc}`;
export type SaveCandidateEvaluationMutationFn = Apollo.MutationFunction<SaveCandidateEvaluationMutation, SaveCandidateEvaluationMutationVariables>;

/**
 * __useSaveCandidateEvaluationMutation__
 *
 * To run a mutation, you first call `useSaveCandidateEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCandidateEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCandidateEvaluationMutation, { data, loading, error }] = useSaveCandidateEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCandidateEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<SaveCandidateEvaluationMutation, SaveCandidateEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCandidateEvaluationMutation, SaveCandidateEvaluationMutationVariables>(SaveCandidateEvaluationDocument, options);
      }
export type SaveCandidateEvaluationMutationHookResult = ReturnType<typeof useSaveCandidateEvaluationMutation>;
export type SaveCandidateEvaluationMutationResult = Apollo.MutationResult<SaveCandidateEvaluationMutation>;
export type SaveCandidateEvaluationMutationOptions = Apollo.BaseMutationOptions<SaveCandidateEvaluationMutation, SaveCandidateEvaluationMutationVariables>;
export const SaveEvaluationAnswerDocument = gql`
    mutation SaveEvaluationAnswer($input: SaveEvaluationAnswerInput!) {
  evaluation {
    saveEvaluationAnswer(input: $input) {
      recordId
    }
  }
}
    `;
export type SaveEvaluationAnswerMutationFn = Apollo.MutationFunction<SaveEvaluationAnswerMutation, SaveEvaluationAnswerMutationVariables>;

/**
 * __useSaveEvaluationAnswerMutation__
 *
 * To run a mutation, you first call `useSaveEvaluationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEvaluationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEvaluationAnswerMutation, { data, loading, error }] = useSaveEvaluationAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEvaluationAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SaveEvaluationAnswerMutation, SaveEvaluationAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEvaluationAnswerMutation, SaveEvaluationAnswerMutationVariables>(SaveEvaluationAnswerDocument, options);
      }
export type SaveEvaluationAnswerMutationHookResult = ReturnType<typeof useSaveEvaluationAnswerMutation>;
export type SaveEvaluationAnswerMutationResult = Apollo.MutationResult<SaveEvaluationAnswerMutation>;
export type SaveEvaluationAnswerMutationOptions = Apollo.BaseMutationOptions<SaveEvaluationAnswerMutation, SaveEvaluationAnswerMutationVariables>;
export const DeleteEvaluationAnswerDocument = gql`
    mutation DeleteEvaluationAnswer($ids: [String!]!) {
  evaluation {
    deleteEvaluationAnswer(ids: $ids) {
      recordId
    }
  }
}
    `;
export type DeleteEvaluationAnswerMutationFn = Apollo.MutationFunction<DeleteEvaluationAnswerMutation, DeleteEvaluationAnswerMutationVariables>;

/**
 * __useDeleteEvaluationAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteEvaluationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEvaluationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEvaluationAnswerMutation, { data, loading, error }] = useDeleteEvaluationAnswerMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteEvaluationAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEvaluationAnswerMutation, DeleteEvaluationAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEvaluationAnswerMutation, DeleteEvaluationAnswerMutationVariables>(DeleteEvaluationAnswerDocument, options);
      }
export type DeleteEvaluationAnswerMutationHookResult = ReturnType<typeof useDeleteEvaluationAnswerMutation>;
export type DeleteEvaluationAnswerMutationResult = Apollo.MutationResult<DeleteEvaluationAnswerMutation>;
export type DeleteEvaluationAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteEvaluationAnswerMutation, DeleteEvaluationAnswerMutationVariables>;
export const JobPageDocument = gql`
    query JobPage($id: String!) {
  hiringManager {
    Id
    job(id: $id) {
      Id
      Name
    }
  }
}
    `;

/**
 * __useJobPageQuery__
 *
 * To run a query within a React component, call `useJobPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobPageQuery(baseOptions: Apollo.QueryHookOptions<JobPageQuery, JobPageQueryVariables> & ({ variables: JobPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPageQuery, JobPageQueryVariables>(JobPageDocument, options);
      }
export function useJobPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPageQuery, JobPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPageQuery, JobPageQueryVariables>(JobPageDocument, options);
        }
export function useJobPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPageQuery, JobPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPageQuery, JobPageQueryVariables>(JobPageDocument, options);
        }
export type JobPageQueryHookResult = ReturnType<typeof useJobPageQuery>;
export type JobPageLazyQueryHookResult = ReturnType<typeof useJobPageLazyQuery>;
export type JobPageSuspenseQueryHookResult = ReturnType<typeof useJobPageSuspenseQuery>;
export type JobPageQueryResult = Apollo.QueryResult<JobPageQuery, JobPageQueryVariables>;
export const HiringManagerJobsDocument = gql`
    query HiringManagerJobs {
  hiringManager {
    Id
    jobs {
      Id
      Name
      flair__Status__c
      location {
        Id
        Name
      }
      department {
        Id
        Name
      }
      candidatesCount
    }
  }
}
    `;

/**
 * __useHiringManagerJobsQuery__
 *
 * To run a query within a React component, call `useHiringManagerJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiringManagerJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiringManagerJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHiringManagerJobsQuery(baseOptions?: Apollo.QueryHookOptions<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>(HiringManagerJobsDocument, options);
      }
export function useHiringManagerJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>(HiringManagerJobsDocument, options);
        }
export function useHiringManagerJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>(HiringManagerJobsDocument, options);
        }
export type HiringManagerJobsQueryHookResult = ReturnType<typeof useHiringManagerJobsQuery>;
export type HiringManagerJobsLazyQueryHookResult = ReturnType<typeof useHiringManagerJobsLazyQuery>;
export type HiringManagerJobsSuspenseQueryHookResult = ReturnType<typeof useHiringManagerJobsSuspenseQuery>;
export type HiringManagerJobsQueryResult = Apollo.QueryResult<HiringManagerJobsQuery, HiringManagerJobsQueryVariables>;
export const EvaluationsDocument = gql`
    query Evaluations($filter: EvaluationsFilter) {
  evaluations(filter: $filter) {
    ...Evaluation
  }
}
    ${EvaluationFragmentDoc}`;

/**
 * __useEvaluationsQuery__
 *
 * To run a query within a React component, call `useEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEvaluationsQuery(baseOptions?: Apollo.QueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
      }
export function useEvaluationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
        }
export function useEvaluationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
        }
export type EvaluationsQueryHookResult = ReturnType<typeof useEvaluationsQuery>;
export type EvaluationsLazyQueryHookResult = ReturnType<typeof useEvaluationsLazyQuery>;
export type EvaluationsSuspenseQueryHookResult = ReturnType<typeof useEvaluationsSuspenseQuery>;
export type EvaluationsQueryResult = Apollo.QueryResult<EvaluationsQuery, EvaluationsQueryVariables>;
export const GetReferrerLinkDocument = gql`
    mutation GetReferrerLink {
  recruiting {
    meReferrerLink
  }
}
    `;
export type GetReferrerLinkMutationFn = Apollo.MutationFunction<GetReferrerLinkMutation, GetReferrerLinkMutationVariables>;

/**
 * __useGetReferrerLinkMutation__
 *
 * To run a mutation, you first call `useGetReferrerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReferrerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReferrerLinkMutation, { data, loading, error }] = useGetReferrerLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetReferrerLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetReferrerLinkMutation, GetReferrerLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReferrerLinkMutation, GetReferrerLinkMutationVariables>(GetReferrerLinkDocument, options);
      }
export type GetReferrerLinkMutationHookResult = ReturnType<typeof useGetReferrerLinkMutation>;
export type GetReferrerLinkMutationResult = Apollo.MutationResult<GetReferrerLinkMutation>;
export type GetReferrerLinkMutationOptions = Apollo.BaseMutationOptions<GetReferrerLinkMutation, GetReferrerLinkMutationVariables>;
export const SkipEmployeeEvaluationDocument = gql`
    mutation SkipEmployeeEvaluation($evaluationId: String!) {
  evaluation {
    skipEmployeeEvaluation(evaluationId: $evaluationId) {
      recordId
      record {
        Id
        flair__Skipped_At__c
      }
    }
  }
}
    `;
export type SkipEmployeeEvaluationMutationFn = Apollo.MutationFunction<SkipEmployeeEvaluationMutation, SkipEmployeeEvaluationMutationVariables>;

/**
 * __useSkipEmployeeEvaluationMutation__
 *
 * To run a mutation, you first call `useSkipEmployeeEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipEmployeeEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipEmployeeEvaluationMutation, { data, loading, error }] = useSkipEmployeeEvaluationMutation({
 *   variables: {
 *      evaluationId: // value for 'evaluationId'
 *   },
 * });
 */
export function useSkipEmployeeEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<SkipEmployeeEvaluationMutation, SkipEmployeeEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipEmployeeEvaluationMutation, SkipEmployeeEvaluationMutationVariables>(SkipEmployeeEvaluationDocument, options);
      }
export type SkipEmployeeEvaluationMutationHookResult = ReturnType<typeof useSkipEmployeeEvaluationMutation>;
export type SkipEmployeeEvaluationMutationResult = Apollo.MutationResult<SkipEmployeeEvaluationMutation>;
export type SkipEmployeeEvaluationMutationOptions = Apollo.BaseMutationOptions<SkipEmployeeEvaluationMutation, SkipEmployeeEvaluationMutationVariables>;